webpackJsonp([23],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    computed: {
        scoreTypeList: function scoreTypeList() {
            var projectId = this.$store.state.user.projectId + '';
            if (projectId === '2') {
                return this.selectMap.WB_SCORE_TYPE;
            }
            return (this.selectMap.WB_SCORE_TYPE || []).filter(function (st) {
                return !['11', '12', '13'].includes(st.value);
            });
        },
        selectMap: function selectMap() {
            return this.$store.state.baseData.selectMap;
        },
        salaryMap: function salaryMap() {
            return this.$store.state.salary.selectMap;
        }
    },
    methods: {
        ajaxGetSelectMap: function ajaxGetSelectMap(key) {
            return this.$axios.get('/share/getBasicData.api?BASE_DATA_KEY=' + key);
        },
        getSelectMapText: function getSelectMapText(selectMapName, value) {
            var separator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

            var text = '',
                list = selectMapName instanceof Array ? selectMapName : this.selectMap[selectMapName],
                curValue = '',
                resultTxt = [];
            if (!(value instanceof Array)) {
                value = [value];
            }
            curValue = value.shift();
            while (typeof curValue !== 'undefined' && list) {
                for (var index = 0; index < list.length; index++) {
                    var item = list[index];
                    if (item.value === String(curValue)) {
                        resultTxt.push(item.text);
                        list = item.list;
                        break;
                    }
                }
                curValue = value.shift();
            }
            return resultTxt.length === 1 ? resultTxt[0] : resultTxt.join(separator);
        },
        getSalaryMap: function getSalaryMap(selectMapName) {
            console.log('getSalary');
            return selectMapName instanceof Array ? selectMapName : this.salaryMap[selectMapName];
        }
    }
});

/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dateFormat; });


function dateFormat(date) {
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'yyyy-MM-dd';

    if (!date) {
        return '';
    }

    var dateReplace = typeof date === 'string' ? date.replace(/-/g, '/') : date;

    if (!(date instanceof Date)) {
        date = new Date(dateReplace);
    }

    if (String(date) === 'Invalid Date') {
        return '';
    }

    var map = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds(),
        'q+': Math.floor((date.getMonth() + 3) / 3),
        'S': date.getMilliseconds() };

    if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }

    for (var key in map) {
        if (new RegExp('(' + key + ')').test(format)) {
            format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? map[key] : ('00' + map[key]).substr(('' + map[key]).length));
        }
    }

    return format;
}



/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/searchPanel/searchBar.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ var searchBar_defaultExport = ({
    name: 'searchBar',
    props: {
        placeholder: {
            type: String,
            'default': '请输入内容'
        },
        value: {
            type: String,
            'default': ''
        },
        ajaxSearch: {
            type: Boolean,
            'default': true
        },
        enterKey: Function,
        config: {
            type: Object,
            'default': function _default() {
                return {
                    url: '/resume/list.api',
                    keyName: 'name'
                };
            }
        }
    },
    data: function data() {
        return {
            url: '/hunter/searchWord.api',
            keyword: this.value,
            isPass: true,
            timeout: null
        };
    },

    watch: {
        keyword: function keyword(value) {
            this.$emit('input', value);
        }
    },
    methods: {
        querySearch: function querySearch(keyword, callback) {
            var _this = this;

            if (this.isPass) {
                this.isPass = false;
                this.timeout = setTimeout(function () {
                    _this.getRequestFn(callback);
                }, this.timeout ? 500 : 0);
            }
        },
        getRequestFn: function getRequestFn(callback) {
            var _this2 = this;

            var data = {},
                CancelToken = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.CancelToken;
            if (this.getRequest) {
                this.source.cancel('取消未返回的请求');
            }
            this.source = CancelToken.source();
            data[this.config.keyName] = this.keyword;
            this.getRequest = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.config.url, {
                params: data,
                cancelToken: this.source.token,
                'X-loadingOff': true
            }).then(function (res) {
                var list = [];

                _this2.isPass = true;
                res.result.list.forEach(function (item, index) {
                    list.push({ value: typeof item === 'string' ? item : item[_this2.config.keyName] });
                });
                callback(list);
            }).catch(function () {
                var list = [];
                _this2.isPass = true;
                callback(list);
            });
        },
        handleSelect: function handleSelect(item) {
            this.$emit('select', item.value);
        },
        iconClickHandler: function iconClickHandler() {
            this.keyword = '';
        },
        enterKeyFn: function enterKeyFn() {
            this.$emit('enter-key', this.keyword);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48148d24"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/searchPanel/searchBar.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.ajaxSearch) ? _c('div', [_c('el-autocomplete', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "size": "medium",
      "fetch-suggestions": _vm.querySearch,
      "placeholder": _vm.placeholder,
      "trigger-on-focus": true
    },
    on: {
      "select": _vm.handleSelect
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        return _vm.enterKeyFn($event)
      }
    },
    model: {
      value: (_vm.keyword),
      callback: function($$v) {
        _vm.keyword = $$v
      },
      expression: "keyword"
    }
  }, [_c('i', {
    class: _vm.keyword ? 'circle-close' : '',
    attrs: {
      "slot": "suffix"
    },
    on: {
      "click": _vm.iconClickHandler
    },
    slot: "suffix"
  })])], 1) : _c('div', [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "size": "medium",
      "placeholder": _vm.placeholder
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        return _vm.enterKeyFn($event)
      }
    },
    model: {
      value: (_vm.keyword),
      callback: function($$v) {
        _vm.keyword = $$v
      },
      expression: "keyword"
    }
  }, [_c('i', {
    class: _vm.keyword ? 'circle-close' : '',
    attrs: {
      "slot": "suffix"
    },
    on: {
      "click": _vm.iconClickHandler
    },
    slot: "suffix"
  })])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var searchPanel_searchBar_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/components/searchPanel/searchBar.vue
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  searchBar_defaultExport,
  searchPanel_searchBar_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_searchPanel_searchBar_defaultExport = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/filterPanel/filterPanel.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ var filterPanel_defaultExport = ({
    data: function data() {
        return {
            params: {}
        };
    },

    methods: {
        getParams: function getParams() {
            var _this = this;

            this.params = {};
            this.$children.forEach(function (child, index) {
                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this.params, child.getSelected());
            });
            return this.params;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-611bbe96"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/filterPanel/filterPanel.vue
var filterPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filter-panel"
  }, [_vm._t("default")], 2)
}
var filterPanel_staticRenderFns = []
var filterPanel_esExports = { render: filterPanel_render, staticRenderFns: filterPanel_staticRenderFns }
/* harmony default export */ var filterPanel_filterPanel_defaultExport = (filterPanel_esExports);
// CONCATENATED MODULE: ./src/components/filterPanel/filterPanel.vue
function injectStyle (ssrContext) {
  __webpack_require__(753)
}
var filterPanel_normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var filterPanel___vue_styles__ = injectStyle
/* scopeId */
var filterPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var filterPanel___vue_module_identifier__ = null
var filterPanel_Component = filterPanel_normalizeComponent(
  filterPanel_defaultExport,
  filterPanel_filterPanel_defaultExport,
  filterPanel___vue_styles__,
  filterPanel___vue_scopeId__,
  filterPanel___vue_module_identifier__
)

/* harmony default export */ var components_filterPanel_filterPanel_defaultExport = (filterPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/filterPanel/filterPanelItem.vue
/* harmony import */ var filterPanelItem___WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(13);
/* harmony import */ var filterPanelItem___WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(filterPanelItem___WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_underscore__);





/* harmony default export */ var filterPanelItem_defaultExport = ({
    data: function data() {
        var activeClassName = 'active';
        return {
            dateValue: '',
            value: '',
            selectValue: [],
            selectLoading: false,
            selectOptions: [],
            dateFirstTime: false,
            activeClass: activeClassName,
            allClassChecked: activeClassName,
            pickerOptions: {
                shortcuts: []
            }
        };
    },
    mounted: function mounted() {
        var _this = this;

        if (this.mode === 'date') {
            this.data.forEach(function (item, index) {
                var pickerHandler = function () {
                    var timer = item.id * 24 * 3600 * 1000;
                    return function (picker) {
                        var end = new Date();
                        var start = new Date();
                        start.setTime(start.getTime() - timer);
                        picker.$emit('pick', [start, end]);
                    };
                }(item);

                _this.pickerOptions.shortcuts.push({
                    text: item.text,
                    onClick: pickerHandler
                });
            });
            if (this.initValue) {
                this.dateFirstTime = !!this.initValue.length;
            }
        }
        this.value = this.initValue || '';
        this.setSelected();
    },

    props: {
        valueName: { type: String, default: 'value' },

        labelName: { type: String, default: 'text' },

        label: String,
        name: String,

        mode: { type: String, default: 'multi' },

        hasAll: { type: Boolean, default: true },

        data: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        visible: { type: Boolean, default: true },
        initValue: [String, Array]
    },
    watch: {
        data: {
            handler: function handler() {
                this.setSelected();
            },
            deep: true
        },
        initValue: {
            handler: function handler(newValue) {
                this.setSelected(newValue);
            },
            deep: true
        }
    },
    methods: {
        active: function active(item) {
            var isChecked = item._selectedClass === this.activeClass;
            if (this.mode === 'single') {
                this.data.forEach(function (item) {
                    item._selectedClass = '';
                });
            }
            this.allClassChecked = '';
            item._selectedClass = isChecked ? '' : this.activeClass;
            this.$parent.$emit('params-change', this.name);
        },
        dateChange: function dateChange() {
            if (!this.dateFirstTime) {
                this.$parent.$emit('params-change');
            } else {
                this.dateFirstTime = false;
            }
        },
        checkedAll: function checkedAll() {
            this.data.forEach(function (item) {
                item._selectedClass = '';
            });
            this.allClassChecked = this.activeClass;
            this.$parent.$emit('params-change', this.name);
        },
        getSelected: function getSelected() {
            var _this2 = this;

            var params = {},
                values = [];
            if (this.mode === 'single' || this.mode === 'multi') {
                this.data.forEach(function (item, index) {
                    item = _this2.data[index];
                    if (item._selectedClass === _this2.activeClass) {
                        values.push(item[_this2.valueName]);
                    }
                });
            } else if (this.mode === 'date') {
                this.dateValue = this.dateValue || [];
                values = values.concat([this.formateDate(this.dateValue[0]), this.formateDate(this.dateValue[1])]);
            } else if (this.mode === 'select') {
                values = values.concat(this.selectValue);
            }
            params[this.name] = values.join(',');
            this.value = values.join(',');
            return params;
        },
        setSelected: function setSelected(value) {
            var _this3 = this;

            if (value) {
                this.value = value;
            }
            if (this.mode === 'date') {
                this.dateValue = this.value;
            } else if (this.mode === 'select') {
                this.selectValue = __WEBPACK_IMPORTED_MODULE_1_underscore___default.a.pluck(this.data, 'id');
                this.setSelectDefaultValue(this.data);
            } else {
                var activeClass = this.activeClass;
                this.data.forEach(function (item) {
                    item._selectedClass = '';
                });
                if (this.value === '' || this.value === null) {
                    if (this.hasAll === true) {
                        this.allClassChecked = activeClass;
                    }
                } else {
                    var valueName = this.valueName;
                    this.allClassChecked = '';
                    this.value.split(',').forEach(function (item) {
                        _this3.data.forEach(function (orgData) {
                            if (String(orgData[valueName]) === String(item)) {
                                orgData._selectedClass = activeClass;
                            }
                        });
                    });
                }
                this.$forceUpdate();
            }
        },
        formateDate: function formateDate(date) {
            if (date) {
                var m = date.getMonth() + 1,
                    d = date.getDate();
                return [date.getFullYear(), m < 10 ? '0' + m : m, d < 10 ? '0' + d : d].join('-');
            } else {
                return '';
            }
        },
        remoteMethod: function remoteMethod(query) {
            var _this4 = this;

            if (query !== '') {
                this.selectLoading = true;

                filterPanelItem___WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/system/position/list.api', { params: { name: query }, 'X-loadingOff': true }).then(function (res) {
                    _this4.selectLoading = false;
                    _this4.selectOptions = res.result.list.map(function (item) {
                        return {
                            value: item.id,
                            label: item.name
                        };
                    });
                }).catch(function () {
                    _this4.selectLoading = false;
                    _this4.selectOptions = [];
                });
            } else {
                this.selectOptions = [];
            }
        },
        selectChange: function selectChange(boolean) {
            if (!boolean) {
                this.$parent.$emit('params-change');
            }
        },
        setSelectDefaultValue: function setSelectDefaultValue(list) {
            var _this5 = this;

            if (Object.prototype.toString.call(list) === '[object Array]' && list.length > 0) {
                list.forEach(function (item) {
                    _this5.$refs.select.$data.cachedOptions.push({ value: item.id, currentLabel: item.name });
                });
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0385e7e8"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/filterPanel/filterPanelItem.vue
var filterPanelItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dl', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }]
  }, [_c('dt', [_vm._v(_vm._s(_vm.label) + "：")]), _vm._v(" "), (_vm.mode == 'single' || _vm.mode == 'multi') ? _c('dd', [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasAll),
      expression: "hasAll"
    }],
    class: _vm.allClassChecked,
    attrs: {
      "type": "text",
      "size": "small"
    },
    on: {
      "click": _vm.checkedAll
    }
  }, [_vm._v("全部\n        ")]), _vm._v(" "), _vm._l((_vm.data), function(item, index) {
    return _c('span', [_c('el-button', {
      key: index,
      class: item._selectedClass,
      attrs: {
        "type": "text",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.active(item)
        }
      }
    }, [_vm._v(_vm._s(item[_vm.labelName]))]), _vm._v(" "), (index != 0 && index % 8 == 0) ? _c('br') : _vm._e()], 1)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.mode == 'date') ? _c('dd', [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "align": "left",
      "size": "medium",
      "placeholder": "选择日期范围"
    },
    on: {
      "change": _vm.dateChange
    },
    model: {
      value: (_vm.dateValue),
      callback: function($$v) {
        _vm.dateValue = $$v
      },
      expression: "dateValue"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.mode === 'select') ? _c('dd', [_c('el-select', {
    ref: "select",
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "size": "medium",
      "multiple": "",
      "filterable": "",
      "remote": "",
      "placeholder": "请输入关键词",
      "remote-method": _vm.remoteMethod,
      "loading": _vm.selectLoading
    },
    on: {
      "visible-change": _vm.selectChange,
      "remove-tag": function($event) {
        return _vm.selectChange(false)
      }
    },
    model: {
      value: (_vm.selectValue),
      callback: function($$v) {
        _vm.selectValue = $$v
      },
      expression: "selectValue"
    }
  }, _vm._l((_vm.selectOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1) : _vm._e()])
}
var filterPanelItem_staticRenderFns = []
var filterPanelItem_esExports = { render: filterPanelItem_render, staticRenderFns: filterPanelItem_staticRenderFns }
/* harmony default export */ var filterPanel_filterPanelItem_defaultExport = (filterPanelItem_esExports);
// CONCATENATED MODULE: ./src/components/filterPanel/filterPanelItem.vue
var filterPanelItem_normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var filterPanelItem___vue_styles__ = null
/* scopeId */
var filterPanelItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var filterPanelItem___vue_module_identifier__ = null
var filterPanelItem_Component = filterPanelItem_normalizeComponent(
  filterPanelItem_defaultExport,
  filterPanel_filterPanelItem_defaultExport,
  filterPanelItem___vue_styles__,
  filterPanelItem___vue_scopeId__,
  filterPanelItem___vue_module_identifier__
)

/* harmony default export */ var components_filterPanel_filterPanelItem_defaultExport = (filterPanelItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/queryListExtend.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_views_common_empty__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_underscore__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_underscore__);









/* harmony default export */ var queryListExtend_defaultExport = ({
    data: function data() {
        return {
            fetchUrl: '/hunter/listHeadCompany.api',
            lists: [],
            timeout: null,
            filterConf: [],
            searchData: {
                pageIndex: null,
                pageSize: null
            },
            keyword: this.$route.query.searchWord || '',
            firstRendered: false,
            partialLoading: false,
            pagination: {},
            cancels: [],
            httpKey: 0
        };
    },

    watch: {
        '$route': 'fetchData',
        'searchData': {
            handler: function handler(newVal) {
                this.$router.push({ query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, newVal) });
            },
            deep: true
        }
    },
    computed: {
        filterKeyArr: function filterKeyArr() {
            return this.filterConf.map(function (item) {
                return item.filter;
            });
        },
        filterNameArr: function filterNameArr() {
            return this.filterConf.map(function (item) {
                return item.name;
            });
        },
        fetchUrlExtend: function fetchUrlExtend() {
            return this.filterKeyArr.length ? this.fetchUrl + '?BASE_DATA_KEY=' + this.filterKeyArr.join(',') : this.fetchUrl;
        }
    },
    methods: {
        fetchData: function fetchData() {
            var _this = this;

            var routeQuery = this.$route.query;
            var that = this;

            if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(routeQuery).length) {
                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.searchData).forEach(function (attr) {
                    _this.searchData[attr] = _this.searchData[attr] || null;
                });
            }
            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.searchData, routeQuery);

            this.partialLoading = true;

            if (!this.resetSearchDateBeforeFetch()) {
                return false;
            }
            var CancelToken = this.$axios.CancelToken;
            that.httpKey++;
            var nowHttpKey = that.httpKey;
            this.$axios.get(this.fetchUrlExtend, {
                cancelToken: new CancelToken(function executor(c) {
                    that.cancels.push({ cancel: c, httpKey: that.httpKey });
                }),
                'X-loadingOff': this.firstRendered,
                params: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.searchData, this.extendParamsBeforeFetch()),
                timeout: this.timeout || this.$axios.defaults.timeout
            }).then(function (res) {
                that.cancels.map(function (cv) {
                    if (that.httpKey !== cv.httpKey) {
                        cv.cancel();
                    }
                });
                if (nowHttpKey === that.httpKey) {
                    _this.lists = res.result.list;
                    _this.pagination = res.page || _this.pagination;

                    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this.pagination).forEach(function (attr) {
                        _this.pagination[attr] = parseInt(_this.pagination[attr], 10);
                    });

                    _this.filterKeyArr.forEach(function (key, index) {
                        if (typeof routeQuery[_this.filterNameArr[index]] !== 'undefined') {
                            _this.filterConf[index].value = routeQuery[_this.filterNameArr[index]];
                        }

                        if (key && res.result[key]) {
                            _this.filterConf[index].data = res.result[key];
                        }
                    });
                    _this.firstTimeProcess();
                    _this.fetchCallback(res);
                }
            }).catch(function (err) {
                if (that.$axios.isCancel(err)) {
                    console.log('Request canceled', err.message);
                } else {
                    _this.lists = [];
                    _this.firstTimeProcess();
                    console.error(err);
                }
            });
        },
        resetSearchDateBeforeFetch: function resetSearchDateBeforeFetch() {
            return true;
        },
        extendParamsBeforeFetch: function extendParamsBeforeFetch() {
            return {};
        },
        fetchCallback: function fetchCallback(res) {},
        firstTimeProcess: function firstTimeProcess() {
            if (!this.firstRendered) {
                this.firstRendered = true;
            }

            this.partialLoading = false;
        },

        pageSizeChange: function pageSizeChange(val) {
            this.searchData.pageSize = val;
        },
        pageIndexChange: function pageIndexChange(val) {
            this.searchData.pageIndex = val;
        },
        searchKeyword: function searchKeyword(value) {
            this.searchData.searchWord = typeof value === 'string' ? value : this.$refs.searchKeyword.$refs.input.value;
            this.searchData.pageSize = null;
            this.searchData.pageIndex = null;
        },
        checkSearchWord: function checkSearchWord() {
            this.searchInputIcon = this.$refs.searchKeyword.$refs.input.value.length ? 'circle-close' : '';
        },
        clearSearchWord: function clearSearchWord() {
            var _this2 = this;

            this.searchInputIcon = '';
            this.$nextTick(function () {
                _this2.$refs.searchKeyword.$refs.input.value = '';
            });
        },
        getParams: function getParams(middleWare) {
            var params = this.$refs.condition.getParams();
            params = this.dateParamProcess(params);
            if (typeof middleWare === 'function') {
                middleWare(params);
            }
            this.searchData.pageIndex = 1;
            this.searchData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.searchData, params);
        },
        dateParamProcess: function dateParamProcess(params) {
            if (__WEBPACK_IMPORTED_MODULE_3_underscore___default.a.has(this.searchData, 'startDate') && __WEBPACK_IMPORTED_MODULE_3_underscore___default.a.has(params, 'date')) {
                var dateArr = params.date && params.date.split(',') || ['', ''];
                params = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_3_underscore___default.a.omit(params, 'date'), { startDate: dateArr[0], endDate: dateArr[1] });
            }
            return params;
        },
        extendSearchDataFromFilterConf: function extendSearchDataFromFilterConf() {
            var _this3 = this;

            this.filterNameArr.forEach(function (key, index) {
                _this3.searchData[key] = _this3.filterConf[index].value || null;
            });
        },
        removeRecordById: function removeRecordById(id) {
            this.lists = __WEBPACK_IMPORTED_MODULE_3_underscore___default.a.reject(this.lists, function (item) {
                return item.id === id;
            });
        }
    },
    created: function created() {
        var self = this;
        window.refreshList = function () {
            self.fetchData();
        };
        this.extendSearchDataFromFilterConf();
        this.fetchData();
    },

    components: {
        EmptyTip: __WEBPACK_IMPORTED_MODULE_2_views_common_empty__["a" /* default */],
        SearchBar: components_searchPanel_searchBar_defaultExport,
        FilterPanel: components_filterPanel_filterPanel_defaultExport,
        FilterPanelItem: components_filterPanel_filterPanelItem_defaultExport
    }
});
// CONCATENATED MODULE: ./src/components/queryListExtend.vue
var queryListExtend_normalizeComponent = __webpack_require__(1)
/* script */

/* template */
var __vue_template__ = null
/* styles */
var queryListExtend___vue_styles__ = null
/* scopeId */
var queryListExtend___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var queryListExtend___vue_module_identifier__ = null
var queryListExtend_Component = queryListExtend_normalizeComponent(
  queryListExtend_defaultExport,
  __vue_template__,
  queryListExtend___vue_styles__,
  queryListExtend___vue_scopeId__,
  queryListExtend___vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (queryListExtend_Component.exports);


/***/ }),
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    methods: {
        resetForm: function resetForm(formName) {
            this.$refs[formName] && this.$refs[formName].resetFields();
        },
        submitForm: function submitForm(formName, boolean) {
            var _this = this;

            this.$refs[formName].validate(function (valid) {
                if (valid) {
                    _this.saveForm(boolean);
                } else {
                    console.log('Not Valid');
                }
            });
        },
        saveForm: function saveForm(boolean) {}
    }
});

/***/ }),
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/operation/exportCustomDialog.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_qs__);





/* harmony default export */ var exportCustomDialog_defaultExport = ({
    data: function data() {
        return {
            showDialog: false,
            checkAll: false,
            exportAll: false,
            exportList: [],
            templateList: [],
            exportSelected: '',
            templateSelected: '',
            curExportList: [],
            curSelectedList: [],
            exportItemsIds: [],
            curSelectedItemIds: []
        };
    },

    props: {
        paramsCallBack: {
            type: Function,
            default: function _default() {
                return function () {
                    return {};
                };
            }
        },
        validCallBack: {
            type: Function,
            default: function _default() {
                return function () {
                    return true;
                };
            }
        },
        showChoosedButton: {
            type: Boolean,
            default: true
        }
    },
    watch: {
        exportSelected: function exportSelected() {
            var _this = this;

            var arr = [];
            if (this.exportSelected !== '') {
                var data = this.exportList.filter(function (item) {
                    return item.value === _this.exportSelected;
                });
                if (data && data.length) {
                    arr = data[0].list;
                }
                this.exportItemsIds = [];
                this.checkAll = false;
            }
            this.curExportList = arr;
        },
        templateSelected: function templateSelected() {
            var _this2 = this;

            var arr = [];
            if (this.templateSelected !== '') {
                var data = this.templateList.filter(function (item) {
                    return item.text === _this2.templateSelected;
                });
                if (data && data.length) {
                    arr = data[0].list;
                }
            }
            this.curSelectedList = arr;
        }
    },
    methods: {
        handleCheckedItemChange: function handleCheckedItemChange(value) {
            var checkedCount = value.length;
            this.checkAll = checkedCount === this.curExportList.length;
        },
        handleCheckAllChange: function handleCheckAllChange(event) {
            this.exportItemsIds = event ? this.curExportList.map(function (item) {
                return item.value;
            }) : [];
        },
        show: function show(exportAll) {
            if (!exportAll && !this.validCallBack()) {
                return;
            }
            this.exportSelected = '';
            this.templateSelected = '';
            this.exportAll = exportAll;
            this.exportItemsIds = [];
            this.curSelectedItemIds = [];
            this.showDialog = true;
            this.getInitData();
        },
        getInitData: function getInitData() {
            var _this3 = this;

            return this.$axios.get('/system/export/list.api').then(function (res) {
                _this3.exportList = res.result.exportList;
                _this3.templateList = res.result.templateList;
            });
        },
        getExportTitle: function getExportTitle() {
            return '\u81EA\u5B9A\u4E49\u5BFC\u51FA' + (this.exportAll ? '（导出全部结果）' : '');
        },
        addToRight: function addToRight() {
            var _this4 = this;

            if (this.exportItemsIds.length === 0) {
                this.$message({
                    message: '请勾选字段',
                    type: 'warning'
                });
                return false;
            }
            this.exportItemsIds.forEach(function (name) {
                var data = _this4.curExportList.filter(function (item) {
                    return item.value === name;
                });
                if (data && !_this4.curSelectedList.some(function (item) {
                    return item.value === name;
                })) {
                    _this4.curSelectedList.push(data[0]);
                }
            });
            this.$message('字段添加成功');
        },
        addSingleToRight: function addSingleToRight(data) {
            if (data && !this.curSelectedList.some(function (item) {
                return item.value === data.value;
            })) {
                this.curSelectedList.push(data);
            }
        },
        removeSelectedItem: function removeSelectedItem(item) {
            var _this5 = this;

            var selectedIds = [];
            if (item) {
                selectedIds = [item.value];
            } else {
                if (this.curSelectedItemIds.length === 0) {
                    this.$message({
                        message: '请勾选字段',
                        type: 'warning'
                    });
                    return false;
                }
                __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(selectedIds, this.curSelectedItemIds);
            }
            selectedIds.forEach(function (value) {
                var curSelectedListIndex = _this5.curSelectedList.map(function (item) {
                    return item.value;
                }).indexOf(value);
                var curSelectedItemIdsIndex = _this5.curSelectedItemIds.indexOf(value);
                curSelectedListIndex > -1 && _this5.curSelectedList.splice(curSelectedListIndex, 1);
                curSelectedItemIdsIndex > -1 && _this5.curSelectedItemIds.splice(curSelectedItemIdsIndex, 1);
            });
        },
        saveTemplate: function saveTemplate() {
            if (this.curSelectedList.length === 0) {
                this.$message({
                    message: '请先选择字段',
                    type: 'warning'
                });
                return false;
            }
            this.getNameInput(this.templateSelected);
        },
        getNameInput: function getNameInput() {
            var _this6 = this;

            var curName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

            this.$prompt('请输入模板名称', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputValue: curName,
                inputPattern: /^[\S]{1,20}$/,
                inputErrorMessage: '不能为空，不能空字符开头，长度不能超过20'
            }).then(function (_ref) {
                var value = _ref.value;

                _this6.$axios.post('/system/export/template.api', {
                    type: curName ? 2 : 1,
                    name: value,
                    propertyCodes: _this6.curSelectedList.map(function (item, index) {
                        return [index + 1, item.value, item.text].join(',');
                    }).join(';')
                }).then(function (res) {
                    _this6.getInitData();
                    _this6.$message({
                        message: '保存成功',
                        type: 'success'
                    });
                }).catch(function () {});
            }).catch(function () {});
        },
        removeTemplate: function removeTemplate() {
            var _this7 = this;

            if (this.templateSelected !== '') {
                this.$confirm('是否删除“' + this.templateSelected + '”?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    _this7.$axios.post('/system/export/template.api', {
                        type: 3,
                        name: _this7.templateSelected
                    }).then(function (res) {
                        _this7.getInitData();
                        _this7.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                        _this7.templateSelected = '';
                    });
                }).catch(function () {});
            } else {
                this.$message({
                    message: '请选择模板',
                    type: 'warning'
                });
            }
        },
        submitForm: function submitForm(ids) {
            if (this.curSelectedList.length === 0) {
                this.$message({
                    message: '请选择需要导出的字段',
                    type: 'warning'
                });
                return false;
            }
            var phaseMap = {
                resume: '0',
                written: '1',
                interview: '2',
                salary: '3',
                enry: '4'
            };
            var path = this.$route.path,
                phase = '';
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(phaseMap).map(function (cv) {
                if (path.indexOf(cv) > -1) {
                    phase = phaseMap[cv];
                }
            });
            var paramsStr = __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(this.paramsCallBack(phase, this.exportAll));
            var propertyCodes = this.curSelectedList.map(function (item, index) {
                return [index + 1, item.value, item.text].join(',');
            }).join(';');
            window.open(this.$axios.defaults.baseURL + '/system/export/exportExcel.api?propertyCodes=' + propertyCodes + '&' + paramsStr);
            console.log(this.$axios.defaults.baseURL + '/system/export/exportExcel.api?propertyCodes=' + propertyCodes + '&' + paramsStr);
            this.showDialog = false;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19bd0ffb"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/operation/exportCustomDialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('el-dropdown', [_c('el-button', {
    attrs: {
      "icon": "el-icon-my-daochu",
      "type": "info"
    }
  }, [_vm._v("自定义导出"), _c('i', {
    staticClass: "el-icon-caret-bottom el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [(_vm.showChoosedButton) ? _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.show(false)
      }
    }
  }, [_vm._v("导出已选记录")]) : _vm._e(), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.show(true)
      }
    }
  }, [_vm._v("导出所有查询结果")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.getExportTitle(),
      "visible": _vm.showDialog,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.showDialog = $event
      }
    }
  }, [_c('div', {
    staticClass: "export-custom"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择类别"
    },
    model: {
      value: (_vm.exportSelected),
      callback: function($$v) {
        _vm.exportSelected = $$v
      },
      expression: "exportSelected"
    }
  }, _vm._l((_vm.exportList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "item-list"
  }, [_c('el-checkbox-group', {
    on: {
      "change": _vm.handleCheckedItemChange
    },
    model: {
      value: (_vm.exportItemsIds),
      callback: function($$v) {
        _vm.exportItemsIds = $$v
      },
      expression: "exportItemsIds"
    }
  }, _vm._l((_vm.curExportList), function(item) {
    return _c('p', {
      key: item.value,
      staticClass: "item-list-detail",
      on: {
        "dblclick": function($event) {
          return _vm.addSingleToRight(item)
        }
      }
    }, [_c('el-checkbox', {
      attrs: {
        "label": item.value
      }
    }, [_vm._v(_vm._s(item.text))])], 1)
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "handler-row"
  }, [_c('el-checkbox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.curExportList.length),
      expression: "curExportList.length"
    }],
    on: {
      "change": _vm.handleCheckAllChange
    },
    model: {
      value: (_vm.checkAll),
      callback: function($$v) {
        _vm.checkAll = $$v
      },
      expression: "checkAll"
    }
  }, [_vm._v("全选")])], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "buttons",
    attrs: {
      "span": 4
    }
  }, [_c('el-button', {
    attrs: {
      "icon": "el-icon-arrow-right"
    },
    on: {
      "click": function($event) {
        return _vm.addToRight()
      }
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择模板"
    },
    model: {
      value: (_vm.templateSelected),
      callback: function($$v) {
        _vm.templateSelected = $$v
      },
      expression: "templateSelected"
    }
  }, _vm._l((_vm.templateList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.text,
        "label": item.text
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "item-list"
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.curSelectedItemIds),
      callback: function($$v) {
        _vm.curSelectedItemIds = $$v
      },
      expression: "curSelectedItemIds"
    }
  }, _vm._l((_vm.curSelectedList), function(item) {
    return _c('p', {
      key: item.value,
      staticClass: "item-list-detail"
    }, [_c('el-checkbox', {
      attrs: {
        "label": item.value
      }
    }, [_vm._v(_vm._s(item.text))]), _vm._v(" "), _c('el-button', {
      staticClass: "pull-right",
      staticStyle: {
        "color": "#ff0000"
      },
      attrs: {
        "type": "text",
        "icon": "el-icon-my-shanchu"
      },
      on: {
        "click": function($event) {
          return _vm.removeSelectedItem(item)
        }
      }
    })], 1)
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "handler-row"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.removeSelectedItem()
      }
    }
  }, [_vm._v("移除")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": _vm.saveTemplate
    }
  }, [_vm._v("保存模板")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.templateSelected),
      expression: "templateSelected"
    }],
    attrs: {
      "size": "mini"
    },
    on: {
      "click": _vm.removeTemplate
    }
  }, [_vm._v("删除当前模板")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 5
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.curSelectedList.length),
      expression: "curSelectedList.length"
    }]
  }, [_vm._v("共" + _vm._s(_vm.curSelectedList.length) + "个")])])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  }, [_vm._v("导出")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.showDialog = false
      }
    }
  }, [_vm._v("取消")])], 1)])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var operation_exportCustomDialog_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/views/operation/exportCustomDialog.vue
function injectStyle (ssrContext) {
  __webpack_require__(757)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  exportCustomDialog_defaultExport,
  operation_exportCustomDialog_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var views_operation_exportCustomDialog_defaultExport = (Component.exports);

// CONCATENATED MODULE: ./src/views/operation/operationMixin.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var operationMixin___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var operationMixin___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(operationMixin___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qs__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_qs__);








/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        ExportCustomDialog: views_operation_exportCustomDialog_defaultExport
    },
    data: function data() {
        return {
            multipleSelection: []
        };
    },

    computed: {
        idStr: function idStr() {
            var idsArr = this.multipleSelection.map(function (item) {
                return item.id;
            });
            return idsArr.join(',');
        },
        basePath: function basePath() {
            var nameToPath = {
                'resumeList': '/resume',
                'entryList': '/entry',
                'interviewList': '/employ',
                'paymentList': '/payment',
                'writtenList': '/written'
            },
                name = this.$route.query && this.$route.query.fromName || this.$route.name;

            return nameToPath[name] || '/employ';
        },
        employPhase: function employPhase() {
            var turn = this.$route.query && this.$route.query.turn || this.$route.params.id;
            return this.basePath === '/employ' ? parseInt(turn) - 1 : '';
        }
    },
    methods: {
        customExportValid: function customExportValid() {
            console.log(this.idStr);
            if (this.idStr === '') {
                this.$message({
                    message: '请先勾选数据',
                    type: 'warning'
                });
                return false;
            }
            return true;
        },
        customExportParams: function customExportParams(phase, exportAll) {
            if (this.idStr && !exportAll) {
                return { ids: this.idStr };
            } else {
                var searchData = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.$route.query));
                if (searchData.pageIndex) {
                    searchData.pageIndex = '';
                }
                if (typeof this.$route.params.id !== 'undefined') {
                    searchData.employPhase = parseInt(this.$route.params.id) - 1;
                }
                return operationMixin___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({ phase: phase }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, searchData));
            }
        },
        reloadList: function reloadList() {
            var isEmit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            if (isEmit) {
                this.$emit('reload');
            } else {
                this.fetchData();
            }
        },
        exportParamsFiles: function exportParamsFiles(path) {
            var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'EXCEL';

            var paramsStr = __WEBPACK_IMPORTED_MODULE_3_qs___default.a.stringify(operationMixin___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.searchData, {
                pageIndex: undefined,
                pageSize: undefined
            }));
            if (path.indexOf('?') > -1) {
                path += '&';
            } else {
                path += '?';
            }
            window.open('' + this.$axios.defaults.baseURL + path + 'token=' + this.$store.state.app.token + '&' + paramsStr + '&type=' + type);
        },
        exportFiles: function exportFiles(idStr, basePath) {
            var lastPath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '/exportResume.api';
            var paramStr = arguments[3];

            if (idStr === '') {
                this.$message({
                    message: '请先勾选数据',
                    type: 'warning'
                });
                return false;
            }
            var path = basePath || this.basePath;
            window.open('' + this.$axios.defaults.baseURL + path + lastPath + '?token=' + this.$store.state.app.token + '&ids=' + idStr + (paramStr ? '&' + paramStr : ''));
        },
        handleSelectionChange: function handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        handleCommand: function handleCommand(command) {
            var args = command.split('/');
            console.log('command:', command, args);
            this.changeStatus.apply(this, args);
        },
        checkDataValid: function checkDataValid(data) {
            var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '请先勾选数据';
            var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'warning';

            if (typeof data === 'number') {
                data = data + '';
            }
            if (data && data.length) {
                return true;
            }
            this.$message({
                message: message,
                type: type
            });
            return false;
        },
        getHandlerUserInfo: function getHandlerUserInfo(ids) {
            var _this = this;

            var userNames = [];
            if (this.lists) {
                ids.split(',').forEach(function (id) {
                    var user = _this.lists.filter(function (item) {
                        return String(item.id) === id;
                    })[0];
                    var name = user.resumeForm && user.resumeForm.name || user.name,
                        positionName = user.positionForm && user.positionForm.name || user.positionName;
                    user && userNames.push(name + '\u3010' + positionName + '\u3011');
                });
            }
            var nameStr = userNames.length > 10 ? userNames.slice(0, 9).join('、') + ' 等' + userNames.length + '人' : userNames.join('、');
            return userNames.length ? '应聘者：' + nameStr + '\n' : '';
        },
        resetInterview: function resetInterview(ids) {
            var _this2 = this;

            ids = ids || this.idStr;

            if (!this.checkDataValid(ids)) {
                return false;
            }
            var handlerInfo = this.getHandlerUserInfo(ids);
            var str = [];
            var h = this.$createElement;
            str.push(h('p', { style: 'color: #888' }, '' + handlerInfo));
            str.push(h('p', { style: 'color: #ff0000' }, '\u8BE5\u64CD\u4F5C\u5C06\u9009\u4E2D\u5E94\u8058\u8005\u7684\u7B80\u5386\u72B6\u6001\u91CD\u7F6E\u4E3A\u4E00\u9762\u672A\u5904\u7406\uFF0C\u9700\u91CD\u65B0\u5B89\u6392\u9762\u8BD5\u3002\u662F\u5426\u7EE7\u7EED\uFF1F'));
            var target = event.target;
            if (target.nodeName === 'SPAN' || target.nodeName === 'I') {
                target = event.target.parentNode;
            }
            target.blur();
            this.$msgbox({
                customClass: 'resume-state-wpr',
                title: '\u91CD\u7F6E\u9762\u8BD5\u5B89\u6392',
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                showCancelButton: true,
                message: h('div', null, str),
                type: 'warning'
            }).then(function () {
                _this2.$axios.post('/resumePosition/interviewArrange/repetInterview.api  ', { ids: ids }, { 'X-showMessage': true }).then(function (res) {
                    _this2.closeWindow();
                    _this2.reloadList();
                }).catch(function () {});
            }).catch(function () {});
        },
        changeStatus: function changeStatus(ids, status, url, statusText) {
            var _this3 = this;

            ids = ids || this.idStr;

            if (!this.checkDataValid(ids)) {
                return false;
            }

            var textMap = {
                'forceToWrite': '进入笔试',
                'pass': '通过',
                'undetermined': '待定',
                'notPass': '淘汰',
                'lh': '拉黑',
                'back': '回退',
                'fq': '放弃',
                'entry': '进入入职',
                'payment': '进入定薪'
            },
                operationText = statusText || textMap[status] || '';
            var handlerInfo = this.getHandlerUserInfo(ids);
            var str = [];
            var h = this.$createElement;
            if (handlerInfo) {
                str.push(h('p', { style: 'color: #888' }, '' + handlerInfo));
            }
            str.push(h('p', null, '\u76EE\u6807\u72B6\u6001\uFF1A ' + operationText));
            if (status === 'lh') {
                str.push(h('textarea', {
                    attrs: { id: 'state-comment-info', placeholder: '请填写备注(选填)', maxlength: 200 },
                    class: 'el-textarea__inner mt-5'
                }));
            }
            if (status === 'fq' || statusText === '毁约') {
                var btn = document.querySelector('.resume-state-wpr .confirm-btn');
                if (btn) {
                    btn.classList.add('is-disabled');
                }
                str.push(h('textarea', {
                    attrs: {
                        id: 'state-comment-info',
                        placeholder: '请填写原因(必填)',
                        maxlength: 500,
                        'oninput': '\n                            let btn = document.querySelector(\'.resume-state-wpr .confirm-btn\')\n                            if (!this.value) {\n                                btn.classList.add(\'is-disabled\')\n                            } else {\n                                btn.classList.remove(\'is-disabled\')\n                            }\n                        '
                    },
                    class: 'el-textarea__inner mt-5'
                }));
            }
            var $reson = document.getElementById('state-comment-info');
            if ($reson) {
                $reson.value = '';
            }
            var target = event.target;
            if (target.nodeName === 'SPAN' || target.nodeName === 'I') {
                target = event.target.parentNode;
            }
            target.blur();
            this.$msgbox({
                customClass: 'resume-state-wpr',
                title: operationText + '\u64CD\u4F5C',
                confirmButtonText: '我已确认',
                cancelButtonText: '取消',
                showCancelButton: true,
                confirmButtonClass: status === 'fq' || statusText === '毁约' ? 'is-disabled confirm-btn' : 'confirm-btn',
                message: h('div', null, str),
                type: 'warning',
                beforeClose: function beforeClose(action, instance, done) {
                    var $reson = document.getElementById('state-comment-info');
                    if (action !== 'confirm') {
                        var _btn = document.querySelector('.resume-state-wpr .confirm-btn');
                        _btn.classList.remove('is-disabled');
                    }
                    if (action === 'confirm' && (statusText === '毁约' || status === 'fq') && $reson.value === '') {
                        return false;
                    } else {
                        done();
                    }
                }
            }).then(function () {
                var $reson = document.getElementById('state-comment-info');
                var params = {
                    ids: ids,
                    isForceToWrite: status === 'forceToWrite',
                    status: status === 'forceToWrite' ? 'pass' : status,
                    employPhase: _this3.employPhase
                };
                if ($reson) {
                    params.operateReason = $reson.value;
                }
                _this3.$axios.post((url || _this3.basePath) + '/changeFlow.api', params, { 'X-showMessage': true }).then(function (res) {
                    _this3.closeWindow();

                    if (['pass', 'back', 'entry', 'payment'].indexOf(status) > -1 && _this3.lists.length === _this3.multipleSelection.length && _this3.searchData.pageIndex !== 1) {
                        _this3.pageIndexChange(1);
                    } else {
                        _this3.reloadList();
                    }
                }).catch(function () {});
            }).catch(function () {});
        },
        remove: function remove(ids, data) {
            var _this4 = this;

            if (!this.checkDataValid(ids)) {
                return false;
            }
            this.$confirm('是否继续删除该记录?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                _this4.$axios.post(_this4.removeUrl, { ids: ids }, { 'X-showMessage': true }).then(function (res) {
                    _this4.fetchData && _this4.fetchData();
                }).catch(function () {});
            }).catch(function () {});
        },
        closeWindow: function closeWindow() {
            if (this.$route.name === 'resumeDetail') {
                window.opener.refreshList();
                window.close();
            }
        },
        getPhase: function getPhase(status) {
            return status.substr(0, 1);
        },
        getResumeDetailUrl: function getResumeDetailUrl(id, status) {
            var from = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.$route.name;

            return '/resume/detail/' + id + '/' + this.getPhase(status) + '?fromName=' + from;
        }
    }
});

/***/ }),
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/userSelect/searchDownList.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_underscore__);




/* harmony default export */ var searchDownList_defaultExport = ({
    props: {
        holder: {
            type: String,
            default: '请输入工号或者姓名'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        searchUrl: {
            type: String,
            default: '/orgTree/user/search.api'
        },
        index: {
            type: Number,
            default: null
        },
        allowEmail: {
            type: Boolean,
            default: false
        },
        value: [String, Number],
        multiple: {
            type: Boolean,
            default: true
        },
        selected: this.multiple ? [] : {},
        leftFormater: {
            type: Function,
            default: function _default(obj) {
                return obj.lastName || obj.name;
            }
        },
        cacheOptions: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        rightFormater: {
            type: Function,
            default: function _default(obj) {
                var depNames = [];
                obj.dept1Name && depNames.push(obj.dept1Name);
                obj.dept2Name && depNames.push(obj.dept2Name);
                obj.dept3Name && depNames.push(obj.dept3Name);
                return depNames.join('->');
            }
        }
    },
    data: function data() {
        return {
            options: [],
            selectedList: [],
            selectValue: this.multiple ? [] : '',
            loading: false
        };
    },
    mounted: function mounted() {
        this.cacheOptionsProcess(this.cacheOptions);
    },

    watch: {
        selectValue: function selectValue() {
            this.$emit('change', this.multiple ? this.selectValue.join(',') : this.selectValue, this.index);
            this.$emit('input', this.selectValue instanceof Array ? this.selectValue.join(',') : this.selectValue);
        }
    },
    methods: {
        update: function update(val) {
            this.cacheOptionsProcess(this.cacheOptions);
        },
        isEmail: function isEmail(str) {
            return str.indexOf('@') > 0;
        },
        reset: function reset() {
            this.selectValue = this.multiple ? [] : '';
            this.options = [];
        },
        remoteMethod: function remoteMethod(query) {
            var _this = this;

            if (query !== '') {
                if (this.ajax) {
                    this.source.cancel('取消未返回的请求');
                }
                this.loading = true;
                var CancelToken = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.CancelToken;
                this.source = CancelToken.source();
                this.ajax = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.searchUrl, {
                    params: { queryKey: query },
                    cancelToken: this.source.token,
                    'X-loadingOff': true
                }).then(function (res) {
                    _this.ajax = null;
                    _this.loading = false;
                    _this.options = res.result.list;
                    if (_this.allowEmail && _this.isEmail(query)) {
                        _this.options.unshift({
                            id: query,
                            email: query,
                            lastName: query,
                            dept1Name: '',
                            dept2Name: '',
                            dept3Name: ''
                        });
                    }
                }).catch(function (e) {});
            } else {
                this.options = [];
            }
        },
        clearInput: function clearInput() {
            this.selectValue = this.multiple ? [] : '';
        },
        cacheOptionsProcess: function cacheOptionsProcess(cacheOptions) {
            var _this2 = this;

            if (cacheOptions.length) {
                var cacheOptionArr = [];
                cacheOptions.forEach(function (item) {
                    cacheOptionArr.push({
                        value: typeof _this2.value === 'string' ? String(item.id) : item.id,
                        currentLabel: item.name
                    });
                });
                this.$refs.select.$data.cachedOptions = cacheOptionArr;
                this.selectValue = this.multiple ? this.value.length ? this.value.split(',') : [] : this.value;
            }
        },
        setDefaultValueLater: function setDefaultValueLater(id, name) {
            console.log('setDefault user-select');
            var arr = void 0;
            if (id instanceof Array) {
                arr = id.map(function (item, index) {
                    return {
                        value: String(item),
                        currentLabel: name[index]
                    };
                });
                this.$refs.select.$data.cachedOptions = arr;
            } else {
                var ids = String(id).split(','),
                    names = name.indexOf(',') === -1 ? name.split('，') : name.split(',');
                arr = [];
                ids.forEach(function (item, index) {
                    arr.push({
                        value: item,
                        currentLabel: names[index]
                    });
                });
                id = this.multiple ? ids : id;
                this.$refs.select.$data.cachedOptions = arr;
            }
            this.selectValue = id;
        },
        setDefaultValue: function setDefaultValue(data, ids) {
            var conf = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : { valueName: 'id', textName: 'name' };

            var cacheOptions = [];
            this.$refs.select.$data.cachedOptions = '';
            ids = String(ids);
            if (ids !== '') {
                data.forEach(function (item) {
                    cacheOptions.push({
                        value: String(item[conf.valueName]),
                        currentLabel: item[conf.textName]
                    });
                });
                this.$refs.select.$data.cachedOptions = cacheOptions;
            }
            this.selectValue = ids.length ? ids.split(',') : this.multiple ? [] : '';
        },
        addUsers: function addUsers(data) {
            var conf = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { valueName: 'id', textName: 'name' };

            var cacheOptions = [],
                ids = [],
                curIds = __WEBPACK_IMPORTED_MODULE_1_underscore___default.a.pluck(this.getSelected(), 'id');
            data.forEach(function (item) {
                if (curIds.indexOf(String(item[conf.valueName])) === -1) {
                    cacheOptions.push({
                        value: String(item[conf.valueName]),
                        currentLabel: item[conf.textName]
                    });
                    ids.push(String(item[conf.valueName]));
                }
            });
            this.$refs.select.$data.cachedOptions = cacheOptions.concat(this.$refs.select.$data.cachedOptions);
            if (__WEBPACK_IMPORTED_MODULE_1_underscore___default.a.isArray(this.selectValue)) {
                this.selectValue = this.selectValue.concat(ids);
            } else {
                this.selectValue = this.selectValue.length === 0 ? ids.join('') : this.selectValue + ',' + ids.join('');
            }
        },
        getSelected: function getSelected() {
            var result = [];
            this.$refs.select.$data.selected.forEach(function (item) {
                result.push({
                    id: item.value,
                    name: item.currentLabel
                });
            });
            return result;
        },
        change: function change(value) {
            this.$refs.select.query = '';
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3717537c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/userSelect/searchDownList.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-selects-wpr"
  }, [_c('i', {
    staticClass: "el-icon-error remove-btn",
    attrs: {
      "title": "清空"
    },
    on: {
      "click": _vm.clearInput
    }
  }), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('el-select', {
    ref: "select",
    staticClass: "user-selects",
    attrs: {
      "size": "medium",
      "multiple": _vm.multiple,
      "filterable": "",
      "remote": "",
      "popper-class": "user-selects-list",
      "disabled": _vm.disabled,
      "placeholder": _vm.holder,
      "remote-method": _vm.remoteMethod,
      "loading": _vm.loading
    },
    on: {
      "change": _vm.change
    },
    model: {
      value: (_vm.selectValue),
      callback: function($$v) {
        _vm.selectValue = $$v
      },
      expression: "selectValue"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.lastName,
        "value": item.id
      }
    }, [_c('span', {
      staticClass: "user-name"
    }, [_vm._v(_vm._s(_vm.leftFormater(item)))]), _vm._v(" "), _c('span', {
      staticClass: "user-dept"
    }, [_vm._v(_vm._s(_vm.rightFormater(item)))])])
  }), 1)], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var userSelect_searchDownList_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/components/userSelect/searchDownList.vue
function injectStyle (ssrContext) {
  __webpack_require__(783)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  searchDownList_defaultExport,
  userSelect_searchDownList_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/thumbnail/src/main.vue


/* harmony default export */ var main_defaultExport = ({
    name: 'Thumbnail',
    props: {
        mode: {
            type: String,
            'default': 'vertical' },
        width: {
            type: Number,
            'default': 80
        },
        text: {
            type: String,
            'default': ''
        },
        fontSize: {
            type: Number,
            'default': 14
        },
        gender: {
            type: String,
            'default': 'man' }
    },
    data: function data() {
        return {};
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b0ac60b"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/thumbnail/src/main.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "thumbnail-wrap",
    class: ("thumbnail-wrap-" + _vm.mode)
  }, [(_vm.gender === 'man') ? _c('img', {
    staticClass: "round-image",
    attrs: {
      "width": _vm.width,
      "height": _vm.width,
      "src": __webpack_require__(632),
      "alt": "thumbnail"
    }
  }) : _c('img', {
    staticClass: "round-image",
    attrs: {
      "width": _vm.width,
      "height": _vm.width,
      "src": __webpack_require__(633),
      "alt": "thumbnail"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "thumbnail-text",
    style: ({
      fontSize: _vm.fontSize + 'px'
    })
  }, [(_vm.$slots.default) ? _vm._t("default") : (_vm.text.length) ? [_c('p', {
    domProps: {
      "textContent": _vm._s(_vm.text)
    }
  })] : _vm._e()], 2)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_main_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/components/thumbnail/src/main.vue
function injectStyle (ssrContext) {
  __webpack_require__(630)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  main_defaultExport,
  src_main_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var thumbnail_src_main_defaultExport = (Component.exports);

// CONCATENATED MODULE: ./src/components/thumbnail/index.js




thumbnail_src_main_defaultExport.install = function (Vue, options) {
  Vue.component(thumbnail_src_main_defaultExport.name, thumbnail_src_main_defaultExport);
};

/* harmony default export */ __webpack_exports__["a"] = (thumbnail_src_main_defaultExport);

/***/ }),
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  phone: /^[1-9]\d{10,10}$/,
  number: /(?:\d*\.)?\d+/ });

/***/ }),
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/common/multiSearch.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_inputCustom__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mixins_selectMapMixin__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_tools__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_throttle_debounce__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_throttle_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_throttle_debounce__);











var BaseFieldArr = [{
    filter: '',
    label: '姓名',
    mode: 'input',
    name: 'nameSearch'
}, {
    filter: 'WB_GENDER',
    label: '性别',
    mode: 'select',
    name: 'genderSearch'
}, {
    filter: '',
    label: '手机号',
    mode: 'input',
    name: 'mobilePhoneSearch'
}, {
    filter: '',
    label: '身份证号',
    mode: 'input',
    name: 'numberSearch'
}, {
    filter: '',
    label: '学校名称',
    mode: 'input',
    name: 'schoolSearch'
}, {
    filter: '',
    label: '邮箱',
    mode: 'input',
    name: 'emailSearch'
}, {
    filter: '',
    label: '职位名称',
    mode: 'input',
    name: 'positionSearch'
}, {
    filter: 'WB_POSITION_SEQUENCE_JSON',
    label: '岗位序列',
    mode: 'select',
    multiple: false,
    name: 'sequenceMainSearch'
}, {
    filter: 'WB_POSITION_SEQUENCE_JSON',
    label: '岗位子序列',
    mode: 'select',
    name: 'sequenceSubSearch',
    formatter: function formatter(rawOptions, ruleForm) {
        var mainSeq = rawOptions.find(function (_ref) {
            var value = _ref.value;
            return ruleForm.sequenceMainSearch === value;
        }) || {};
        return mainSeq.list || [];
    }
}, {
    filter: '',
    label: '招聘部门',
    mode: 'dept',
    name: 'deptCodeSearch'
}, {
    filter: 'WB_SOURCE_FROM',
    label: '招聘来源',
    mode: 'select',
    name: 'sourceFromSearch'
}, {
    filter: 'WB_RESUME_SOURCE',
    label: '简历来源',
    mode: 'select',
    name: 'resumeResumeSourceSearch'
}, {
    filter: 'WB_POSITION_CITY',
    label: '应聘城市',
    data: [],
    mode: 'select',
    name: 'cityIds'
}];
var fieldArr = BaseFieldArr.map(function (field) {
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, field);
}),
    arrToObj = function arrToObj(arr) {
    var temp = {};
    arr.forEach(function (field) {
        temp[field.name] = field.mode === 'daterange' ? [] : '';
    });
    return temp;
};

/* harmony default export */ var multiSearch_defaultExport = ({
    name: 'multiSearch',
    components: { InputCustom: __WEBPACK_IMPORTED_MODULE_4_components_inputCustom__["a" /* default */] },
    mixins: [__WEBPACK_IMPORTED_MODULE_5_mixins_selectMapMixin__["a" /* default */]],
    props: {
        mode: {
            type: String,
            default: 'append' },
        fields: {
            type: Array,
            default: function _default() {
                return [];
            }
        }
    },
    data: function data() {
        this.getFieldArr();
        var ruleForm = arrToObj(fieldArr);
        return {
            fieldArr: fieldArr,
            ruleForm: ruleForm,
            deptArr: []
        };
    },

    computed: {
        isExam: function isExam() {
            return ['interviewList', 'writtenList', 'entryList'].indexOf(this.$route.name) > -1;
        },
        dateRangeFieldsMap: function dateRangeFieldsMap() {
            return this.fieldArr.filter(function (f) {
                return f.mode === 'daterange';
            }).reduce(function (acc, f) {
                return acc[f.name] = f, acc;
            }, {});
        }
    },
    watch: {
        'ruleForm.sequenceMainSearch': function ruleFormSequenceMainSearch() {
            this.ruleForm.sequenceSubSearch = [];
        }
    },
    methods: {
        deptRemoteMethod: function deptRemoteMethod(query) {
            var _this = this;

            if (query !== '') {
                this.$axios.get('/system/department/seachDep.api', {
                    params: { name: query },
                    'X-loadingOff': true
                }).then(function (res) {
                    _this.deptArr = res.result.list;
                });
            }
        },
        submitForm: function submitForm() {
            var _this2 = this;

            var query = {};
            __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.ruleForm).forEach(function (key) {
                query[key] = _this2.getValueByArr(_this2.ruleForm[key]);
            });
            query = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.$parent.searchData, query, {
                pageIndex: 1,
                time: Date.now()
            });
            this.$router.push({ query: query });
        },
        clearAll: function clearAll() {
            var _this3 = this;

            __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.ruleForm).forEach(function (key) {
                _this3.ruleForm[key] = Array.isArray(_this3.ruleForm[key]) ? [] : '';
            });
            this.$emit('clear');
        },
        getFieldArr: function getFieldArr() {
            if (['resumeList', 'writtenList', 'interviewList', 'paymentList', 'entryList'].indexOf(this.$route.name) === -1) {
                fieldArr = fieldArr.filter(function (cv) {
                    return cv.name !== 'deptCodeSearch';
                });
            }
            if (['interviewList', 'writtenList', 'entryList'].indexOf(this.$route.name) > -1) {
                fieldArr = fieldArr.concat([{
                    filter: '',
                    label: '笔试成绩',
                    mode: 'input',
                    name: 'scoreSearch'
                }]);
            }
            if (['index'].indexOf(this.$route.name) > -1) {
                fieldArr.splice(9, 0, {
                    filter: '',
                    label: '招聘部门',
                    mode: 'dept',
                    name: 'deptCodeSearch'
                });
            }
            fieldArr = fieldArr.concat(this.fields);
            var insertIndex = 0;
            fieldArr.forEach(function (cv, index) {
                if (cv.label === '应聘城市') {
                    insertIndex = index + 1;
                }
            });
            if (insertIndex) {
                fieldArr.splice(insertIndex, 0, {
                    filter: '',
                    label: '招聘HR',
                    mode: 'input',
                    name: 'employerSearch'
                }, {
                    filter: '',
                    label: '投递时间',
                    mode: 'daterange',
                    name: 'commitDate'
                });
            }
            if (this.mode === 'cover') {
                fieldArr = this.fields;
            }
            return fieldArr;
        },
        getValueByArr: function getValueByArr(value) {
            return Array.isArray(value) ? value.join(',') : Object.prototype.toString.call(value) === '[object Date]' ? Object(__WEBPACK_IMPORTED_MODULE_6_modules_tools__["a" /* dateFormat */])(value) : value && value.replace(/\s+/g, ',').replace(/,,/g, ',');
        },
        getOptions: function getOptions(item) {
            var options = this.selectMap[item.filter] || [];
            if (typeof item.formatter === 'function' && options.length) {
                options = item.formatter(options, this.ruleForm);
            }
            return options;
        },
        onDateRangeChange: function onDateRangeChange(value, item) {
            var _ref2 = value || [],
                _ref3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref2, 2),
                _ref3$ = _ref3[0],
                startVal = _ref3$ === undefined ? '' : _ref3$,
                _ref3$2 = _ref3[1],
                endVal = _ref3$2 === undefined ? '' : _ref3$2;

            var _getDateRangeKeys = this.getDateRangeKeys(item),
                start = _getDateRangeKeys.start,
                end = _getDateRangeKeys.end;

            this.$set(this.ruleForm, start, startVal);
            this.$set(this.ruleForm, end, endVal);
        },
        onSelectChange: function onSelectChange(value, item) {
            if (item.name === 'statusSearch') {
                this.$set(this.ruleForm, 'isJobTransfer', value && value.includes('10000') ? '1' : '0');
            }
        },
        getDateRangeKeys: function getDateRangeKeys(item) {
            var name = item.name,
                keys = item.keys;

            var _ref4 = keys || [],
                _ref5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref4, 2),
                _ref5$ = _ref5[0],
                start = _ref5$ === undefined ? name + 'Start' : _ref5$,
                _ref5$2 = _ref5[1],
                end = _ref5$2 === undefined ? name + 'End' : _ref5$2;

            return {
                start: start,
                end: end
            };
        }
    },
    mounted: function mounted() {
        var _this4 = this;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.ruleForm).forEach(function (key) {
            var value = _this4.$route.query[key];
            if (value) {
                _this4.ruleForm[key] = Array.isArray(_this4.ruleForm[key]) ? value.split(',') : value;
            }

            if (key in _this4.dateRangeFieldsMap) {
                _this4.onDateRangeChange(_this4.ruleForm[key], _this4.dateRangeFieldsMap[key]);
            } else if (key === 'statusSearch') {
                _this4.onSelectChange(_this4.ruleForm[key], { name: 'statusSearch' });
            }
        });
        if (this.ruleForm.deptCodeSearch && this.ruleForm.deptCodeSearch.length) {
            this.$axios.get('/system/department/seachDep.api', {
                params: { deptCodes: this.ruleForm.deptCodeSearch.join(',') },
                'X-loadingOff': true
            }).then(function (res) {
                _this4.deptArr = res.result.list;
            });
        }
        function detectZoom() {
            var ratio = 0,
                screen = window.screen,
                ua = navigator.userAgent.toLowerCase();

            if (window.devicePixelRatio !== undefined) {
                ratio = window.devicePixelRatio;
            } else if (~ua.indexOf('msie')) {
                if (screen.deviceXDPI && screen.logicalXDPI) {
                    ratio = screen.deviceXDPI / screen.logicalXDPI;
                }
            } else if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
                ratio = window.outerWidth / window.innerWidth;
            }

            if (ratio) {
                ratio = Math.round(ratio * 100);
            }

            return ratio;
        };
        window.onresize = Object(__WEBPACK_IMPORTED_MODULE_7_throttle_debounce__["debounce"])(2000, function (e) {
            var result = detectZoom();
            if (result < 100) {
                if (!document.querySelector('#resizestyle')) {
                    var newElement = document.createElement('style');
                    newElement.id = 'resizestyle';
                    newElement.innerHTML = '.el-form--inline .el-select > .el-input > .el-input__inner {height: 36px !important;}';
                    document.body.appendChild(newElement);
                }
            } else {
                if (document.querySelector('#resizestyle')) {
                    document.querySelector('#resizestyle').remove();
                }
            }
        });
    },
    destroyed: function destroyed() {
        window.onresize = null;
    },
    created: function created() {
        fieldArr = BaseFieldArr.map(function (field) {
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, field);
        });
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76870ffa"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/common/multiSearch.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    staticClass: "mt-20",
    attrs: {
      "inline": true,
      "label-width": "75px"
    }
  }, [_c('div', [_vm._l((_vm.fieldArr), function(item) {
    return [_c('el-form-item', {
      key: item.label,
      class: ['multi-search-form-item', ("label-" + (item.name))],
      attrs: {
        "label": item.label
      }
    }, [(item.mode === 'input') ? _c('input-custom', {
      attrs: {
        "placeholder": "支持多个，以,或者空格隔开"
      },
      model: {
        value: (_vm.ruleForm[item.name]),
        callback: function($$v) {
          _vm.$set(_vm.ruleForm, item.name, (typeof $$v === 'string' ? $$v.trim() : $$v))
        },
        expression: "ruleForm[item.name]"
      }
    }) : (item.mode === 'select') ? _c('el-select', {
      ref: ((item.name) + "Select"),
      refInFor: true,
      attrs: {
        "size": "medium",
        "multiple": item.multiple !== false,
        "clearable": "",
        "placeholder": ("请选择" + (item.label))
      },
      on: {
        "change": function($event) {
          return _vm.onSelectChange($event, item)
        }
      },
      model: {
        value: (_vm.ruleForm[item.name]),
        callback: function($$v) {
          _vm.$set(_vm.ruleForm, item.name, $$v)
        },
        expression: "ruleForm[item.name]"
      }
    }, _vm._l((_vm.getOptions(item)), function(subItem) {
      return _c('el-option', {
        key: subItem.value,
        attrs: {
          "label": subItem.text,
          "value": subItem.value
        }
      })
    }), 1) : (item.mode === 'date') ? _c('el-date-picker', {
      attrs: {
        "type": item.mode,
        "placeholder": "请选择时间",
        "size": "medium",
        "editable": false,
        "format": "yyyy-MM-dd"
      },
      model: {
        value: (_vm.ruleForm[item.name]),
        callback: function($$v) {
          _vm.$set(_vm.ruleForm, item.name, $$v)
        },
        expression: "ruleForm[item.name]"
      }
    }) : (item.mode === 'dept') ? _c('el-select', {
      attrs: {
        "filterable": "",
        "remote": "",
        "size": "medium",
        "multiple": item.multiple !== false,
        "placeholder": "请输入关键词",
        "clearable": true,
        "remote-method": _vm.deptRemoteMethod
      },
      model: {
        value: (_vm.ruleForm[item.name]),
        callback: function($$v) {
          _vm.$set(_vm.ruleForm, item.name, $$v)
        },
        expression: "ruleForm[item.name]"
      }
    }, _vm._l((_vm.deptArr), function(item) {
      return _c('el-option', {
        key: item.deptCode,
        attrs: {
          "label": item.name,
          "value": item.deptCode
        }
      })
    }), 1) : (item.mode === 'daterange') ? _c('el-date-picker', {
      attrs: {
        "type": "daterange",
        "range-separator": "至",
        "start-placeholder": "开始日期",
        "end-placeholder": "结束日期",
        "value-format": "yyyy-MM-dd"
      },
      on: {
        "change": function($event) {
          return _vm.onDateRangeChange($event, item)
        }
      },
      model: {
        value: (_vm.ruleForm[item.name]),
        callback: function($$v) {
          _vm.$set(_vm.ruleForm, item.name, $$v)
        },
        expression: "ruleForm[item.name]"
      }
    }) : _vm._e()], 1)]
  }), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), _c('el-form-item', [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v(" ")]), _vm._v(" "), _c('el-button', {
    staticClass: "search-btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('el-button', {
    staticClass: "search-btn",
    on: {
      "click": function($event) {
        return _vm.clearAll()
      }
    }
  }, [_vm._v("清空")]), _vm._v(" "), _vm._t("operation")], 2)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var common_multiSearch_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/views/common/multiSearch.vue
function injectStyle (ssrContext) {
  __webpack_require__(760)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  multiSearch_defaultExport,
  common_multiSearch_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/fileUpload.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




function noop() {}

/* harmony default export */ var fileUpload_defaultExport = ({
    props: {
        action: {
            type: String,
            'default': '/hr/attach/fileInsert.api'
        },
        value: Array,
        onProgress: {
            type: Function,
            'default': noop
        },
        onSuccess: {
            type: Function,
            'default': noop
        },
        onRemove: {
            type: Function,
            'default': noop
        },
        onFail: {
            type: Function,
            'default': noop
        },
        showFileList: {
            type: Boolean,
            'default': true
        },
        showFailMsg: {
            type: Boolean,
            'default': true
        },
        showLoading: {
            type: Boolean,
            default: false
        },
        uploadMode: {
            type: String,
            default: 'default'
        },
        accept: {
            type: String,
            default: '.doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf,.jpg,.jpeg,.gif,.psd,.png,.swf,.avi,.htm,.html'
        },
        data: Object,
        fileList: {
            type: Array,
            'default': function _default() {
                return [];
            }
        },
        fileLimit: {
            type: Number,
            'default': 5 }
    },
    data: function data() {
        return {
            uploadedData: this.value || []
        };
    },

    computed: {
        getUploadMode: function getUploadMode() {
            return 'upload-' + this.uploadMode + '-mode';
        }
    },
    watch: {
        value: function value(newValue) {
            this.uploadedData = newValue;
        }
    },
    methods: {
        beforeUpload: function beforeUpload(file) {
            var isLt20M = file.size / 1024 / 1024 < 20;
            if (this.fileLimit > 0 && this.fileLimit === this.uploadedData.length) {
                this.$message.error('\u4E0A\u4F20\u6587\u4EF6\u4E2A\u6570\u4E0D\u80FD\u8D85\u8FC7' + this.fileLimit);
                return false;
            }
            if (!isLt20M) {
                this.$message.error('上传文件大小不能超过20MB！');
                return false;
            }
            this.uploadedData.push({
                fileName: file.name,
                fileSize: file.size,
                fileUid: file.uid
            });
            this.showLoading && this.$store.dispatch('LOADING', true);
        },
        uploadProgress: function uploadProgress(event, file, fileList) {
            this.onProgress(event, file, fileList);
        },
        uploadSuccess: function uploadSuccess(res, file) {
            var _this = this;

            this.showLoading && this.$store.dispatch('LOADING', false);
            if (res.status === true || res.status === 'true') {
                var uploadedItem = {
                    id: res.result.id,
                    md5: res.result.md5,
                    fileId: res.result.fileId,
                    fileName: file.name,
                    fileSize: file.size,
                    fileStatus: file.status,
                    fileUid: file.uid
                };
                this.uploadedData.forEach(function (item, index) {
                    if (item.fileUid === uploadedItem.fileUid) {
                        _this.uploadedData.splice(index, 1, uploadedItem);
                    }
                });
                this.$emit('input', this.uploadedData);
                this.onSuccess(res, file);
            } else {
                this.$refs.upload.handleRemove(file);
                this.onFail(res);
                this.showFailMsg && this.$message({
                    message: res.desc,
                    type: 'error'
                });
            }
        },
        uploadRemove: function uploadRemove(file, fileList) {
            var _this2 = this;

            if (!file) {
                return;
            }
            this.uploadedData.forEach(function (item, index) {
                if (item.fileUid === file.uid) {
                    _this2.uploadedData.splice(index, 1);
                }
            });
            this.$emit('input', this.uploadedData);
            this.onRemove(file, fileList);
        },
        uploadError: function uploadError(err, file, fileList) {
            var _this3 = this;

            console.log('upload error', err);
            this.uploadedData.forEach(function (item, index) {
                if (item.fileUid === file.uid) {
                    _this3.uploadedData.splice(index, 1);
                }
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-392bb8e1"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/fileUpload.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-upload', {
    ref: "upload",
    class: _vm.getUploadMode,
    attrs: {
      "headers": {
        token: _vm.$store.state.app.token
      },
      "action": _vm.action,
      "before-upload": _vm.beforeUpload,
      "on-success": _vm.uploadSuccess,
      "on-remove": _vm.uploadRemove,
      "on-progress": _vm.uploadProgress,
      "on-error": _vm.uploadError,
      "data": _vm.data,
      "show-file-list": this.showFileList,
      "accept": _vm.accept,
      "file-list": _vm.fileList
    }
  }, [(_vm.$slots.default) ? [_vm._t("default")] : [_c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("文件上传")])], _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "5px"
    },
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._t("tip", [_vm._v("支持doc、docx、xls、xlsx、ppt、pptx、pdf、jpg、jpeg、gif、psd、png、swf、avi、htm、html等格式，建议大小不超过20MB\n            ")])], 2)], 2)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_fileUpload_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/components/fileUpload.vue
function injectStyle (ssrContext) {
  __webpack_require__(777)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  fileUpload_defaultExport,
  components_fileUpload_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);



/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            urls: {
                positionList: '/position/vailList.api'
            },
            positionList: []
        };
    },

    methods: {
        fetchPositionList: function fetchPositionList() {
            var _this = this;

            var onlyNotSuspended = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            return this.$axios.get(onlyNotSuspended ? this.urls.positionList + '?state=1' : this.urls.positionList).then(function (res) {
                _this.positionList = res.result.list;
                _this.allPositionList = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res.result.list));
            }).catch(function () {});
        }
    }
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
    methods: {
        highEducationDesc: function highEducationDesc(highEducation) {
            return highEducation.school + ' - ' + highEducation.major;
        },
        followerText: function followerText(user) {
            return user && user.name || '-';
        },
        sourceFromSearchProcess: function sourceFromSearchProcess(res) {
            var fileName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'resumeResumeSourceSearch';

            var targetIndex = 0;
            res.result.WB_SOURCE_FROM = this.selectMap.WB_SOURCE_FROM;
            this.filterConf.forEach(function (item, index) {
                if (item.name === 'sourceFromSearch') {
                    targetIndex = index;
                }
            });
            if (this.searchData[fileName] && this.searchData[fileName].length) {
                if (this.searchData[fileName].split(',').indexOf('22') > -1) {
                    this.filterConf[targetIndex].visible = true;
                    this.filterConf[targetIndex].value = this.searchData.sourceFromSearch;
                    this.filterConf[targetIndex].data = this.selectMap.WB_SOURCE_FROM;
                    return true;
                }
            }
            this.filterConf[targetIndex].visible = false;
            this.filterConf[targetIndex].value = '';
            this.searchData.sourceFromSearch = '';
            this.$router.push({ query: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.searchData) });
        },
        multiChangePosition: function multiChangePosition(ids) {
            if (this.checkDataValid(ids)) {
                var $target = this.$refs.changePositionDialog;
                $target && $target.show(ids, this.multipleSelection);
            }
        },
        syncToSupplier: function syncToSupplier(ids) {
            var _this = this;

            if (this.checkDataValid(ids)) {
                this.$confirm('将进行批量同步供应商，是否继续？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    _this.$axios.post('/evaluation/syncEva.api', {
                        resumePositionIds: ids
                    }, { 'X-showMessage': true }).then(function (res) {});
                }).catch(console.error);
            }
        }
    }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e601df8c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/evaluation/score-tips/score-tips-tester.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', {
    staticClass: "rule-detail"
  }, [_c('tr', [_c('td', {
    staticClass: "fb",
    attrs: {
      "rowspan": "12",
      "width": "20"
    }
  }, [_vm._v("必要能力")]), _vm._v(" "), _c('td', {
    staticClass: "fb",
    attrs: {
      "rowspan": "2",
      "width": "60"
    }
  }, [_vm._v("执行能力")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "130",
      "rowspan": "2"
    }
  }, [_vm._v("如果让你去组织一次团建，打算如何做？如何快速收集大家意向（很多人会给出“都可以”的回复），如何处理询问后没有人回答的囧状。")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "240"
    }
  }, [_vm._v("1. 做事条理性强，思考有逻辑顺序。"), _c('span', {
    staticClass: "red"
  }, [_vm._v("有完备的计划性。")]), _c('br'), _vm._v("\n        2. 思考全面，会考虑到边缘情况。并给出解决方法。"), _c('br'), _vm._v("\n        3. 针对做事过程中出现的困难，可以有 "), _c('span', {
    staticClass: "red"
  }, [_vm._v("比较合适的解决方案。")]), _c('br'), _vm._v("\n        4.不畏惧困难，有信心和能力解决问题。")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "150"
    }
  }, [_vm._v("1. 做事条理性强，思考有逻辑顺序。有一定的计划。"), _c('br'), _vm._v("\n        2. 思考全面，会考虑到边缘情况。并给出解决方法。"), _c('br'), _vm._v("\n        3. 针对做事过程中出现的困难，可以有比较合适的解决方案。")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "150"
    }
  }, [_vm._v("1. 做事有条理性，思考有逻辑。"), _c('br'), _vm._v("\n        2. 思考较全面，"), _c('span', {
    staticClass: "red"
  }, [_vm._v("提示下可以比较完备")]), _vm._v("。"), _c('br'), _vm._v("\n        3. 针对做事过程中出现的困难，可以给出解决方案。")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "150"
    }
  }, [_vm._v("1.思维条理性不强，想到哪里说到哪里。"), _c('br'), _vm._v("\n        2. 对待问题处理能力不强，不能给出较好的解决方案。"), _c('br'), _vm._v("\n        3. 回答问题缓慢，结构框架凌乱。提示下并无改进。")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "100"
    }
  }, [_vm._v("1. 做事基本没有条理 "), _c('br'), _vm._v("\n        2. 基本上对待问题没有好的想法 "), _c('br'), _vm._v("\n        3. 做事情倾向放弃")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("首先在我们共同的群里面问下大家本次团建想做点什么。然后逐一统计大家的意见和建议，最后"), _c('span', {
    staticClass: "green"
  }, [_vm._v("汇总")]), _vm._v("有很明确目标的人。将很明确的这些目标整理出来，假设是看电影这种的，那就买不同的票即可。假设是大家都要一起参与的，那就先问没回复的成员或者是回复“都可以”的成员，"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("点对点的方式")]), _vm._v("，问清楚他们想干嘛之后，"), _c('span', {
    staticClass: "orange"
  }, [_vm._v("再去将还没有统一的意见从新征求下，直到完全统一意见")]), _vm._v("（仅仅针对团队活动，不是类似看电影这种）最后做汇总统一，"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("考虑下一些异常情况的解决方式")]), _vm._v("，例如：票卖完了，原定去的饭店关门了如何处理，最后发送到群里面给大家再次确认没有问题了（回答没有问题，思路严谨，条理清晰）")]), _vm._v(" "), _c('td', [_vm._v("首先在我们共同的群里面问下大家本次团建想做点什么。然后逐一统计大家的意见和建议，最后"), _c('span', {
    staticClass: "green"
  }, [_vm._v("汇总")]), _vm._v("有很明确目标的人。将很明确的这些目标整理出来，假设是看电影这种的，那就买不同的票即可。假设是大家都要一起参与的，那就先问没回复的成员或者是回复“都可以”的成员，"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("点对点的方式")]), _vm._v("，问清楚他们想干嘛之后，"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("考虑下一些异常情况的解决方式")]), _vm._v("，例如：票卖完了，原定去的饭店关门了如何处理，最后做汇总统一，发送到群里面给大家再次确认没有问题了（回答基本没有问题，思路严谨，条理清晰）\n    ")]), _vm._v(" "), _c('td', [_vm._v("首先在我们共同的群里面问下大家本次团建想做点什么。然后逐一统计大家的意见和建议，最后汇总下就好。假设没有人回复的话或者是回复“都可以”的情况下，那我就直接点对点的问下，没有回复的人对本次团建有没有想法，或回复了“都行”的成员看看我目前定的是去 XXX 是否满意。最后做汇总统一，定下大家去做什么就好了。（基本正常的回答了该如何去做，在面试官的引导下能够正常回答一些要点，并且不会紧张）\n    ")]), _vm._v(" "), _c('td', [_vm._v("首先在我们共同的群里面问下大家本次团建想做点什么。然后逐一统计大家的意见和建议，最后汇总下就好。假设没有人回复的话或者是回复“都可以”的情况下，那我就按照“少数服从多数”的规矩，以人数多的一组为主，定下大家去做什么就好了。（基本上完整回答了一个解决的办法，但是完全没有“民主”，没有照顾到其他成员的意愿和想法，自己直接做了决定。在面试官的进一步的引导下，能够回答到一些侧重点，但是还是没有组织性和条理性）")]), _vm._v(" "), _c('td', [_vm._v("就在群里问下，没有响应的我就按照多数人的方法处理就好了。（基本上说是错误的回答，没有理解团建的目的和意义，也没有充分考虑到其他成员的意愿。在面试官\n        的引导下也很难回答出个所以然。）")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "fb",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("工作态度")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("在测试过程中，我们新接受了一项工作，但是这份工作并不是你擅长的，并且要求完成的时间比较紧张。你会怎么看待或者如何去完成这项工作。（穿插可以提问如果需要加班会怎么处理，合作同事办事效率低并对自己工作造成影响如何处理。）")]), _vm._v(" "), _c('td', [_vm._v("1. 负责的任务能保质保量的完成"), _c('br'), _vm._v("\n        2. 责任心强，有担当"), _c('br'), _vm._v("\n        3. 加班耐性和稳定性极高"), _c('br'), _vm._v("\n        4. 工作积极性高，不懂的问题会主动学习和解决。"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "red"
  }, [_vm._v("5. 有精益求精的精神，对自己要求严格。")])]), _vm._v(" "), _c('td', [_vm._v("\n        1. 负责的任务能保质保量的完成"), _c('br'), _vm._v("\n        2. 有责任心"), _c('br'), _vm._v("\n        3. 加班耐性和稳定性极高"), _c('br'), _vm._v("\n        4. 工作积极性高，不懂的问题会主动学习和解决。"), _c('br'), _vm._v("\n        （可以独自承担工作，后续稍作迭代即可）\n    ")]), _vm._v(" "), _c('td', [_vm._v("\n        1. 负责的任务能保质保量的完成"), _c('br'), _vm._v("\n        2. 有责任心"), _c('br'), _vm._v("\n        3. 加班耐性和稳定性高（定义）"), _c('br'), _vm._v("\n        4. 不懂的问题不会问。"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "red"
  }, [_vm._v("（可以较好的完成工作，但需要后期迭代和主管督促）")])]), _vm._v(" "), _c('td', [_vm._v("\n        1. 部分程度完成任务"), _c('br'), _vm._v("\n        2. 加班耐性和稳定性一般"), _c('br'), _vm._v("\n        （"), _c('span', {
    staticClass: "red"
  }, [_vm._v("工作较为被动")]), _vm._v("，需要经常监督和跟进，工作质量一般，需要迭代数次。）\n    ")]), _vm._v(" "), _c('td', [_vm._v("1. 工作态度有一定的问题"), _c('br'), _vm._v("\n        2. 非常反对加班")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n        首先如果交给我的工作我会认真负责的尽最大努力去完成。如果时间比较紧张并且属于我的工作我会"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("主动加班完成")]), _vm._v("。如果是不擅长的，那我可能会和我的主管沟通看是不是有更合适的人选，如果没有那我会"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("尽力去学习并完成工作")]), _vm._v("。如果是我的同事自己没有完成工作并且阻碍了我，那我可能会跟他沟通看是不是可以"), _c('span', {
    staticClass: "orange"
  }, [_vm._v("帮上些忙")]), _vm._v("。或者先做一些不阻碍的工作。\n    ")]), _vm._v(" "), _c('td', [_vm._v("\n        首先如果交给我的工作我会认真负责的尽最大努力去完成。如果时间比较紧张\n        并且属于我的工作我会"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("主动加班完成")]), _vm._v("。如果是不擅长的，那我会"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("尽力去学习并完成工作")]), _vm._v("。如果是我的同事自己没有完成工作并且阻碍了我，会先做一些不阻碍的工作。（会积极的承担工作，并对加班没有太大意见。可以做好自己本职工作，但缺乏帮他人工作的意识。）\n    ")]), _vm._v(" "), _c('td', [_vm._v("\n        首先如果交给我的工作我会认真负责的尽最大努力去完成。如果时间比较紧张并且属于我的工作我会"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("主动加班完成")]), _vm._v("。如果是我的同事自己没有完成工作并且阻碍了我，会\n        先做一些不阻碍的工作。（会积极的承担工作，并对加班没有太大意见。可以做好自己本职工作，但缺乏帮他人工作的意识。但更希望完成自己会做的事情。）\n    ")]), _vm._v(" "), _c('td', [_vm._v("\n        会在自己工作时间努力完成工作，"), _c('span', {
    staticClass: "green"
  }, [_vm._v("不太能忍受加班，需要加班的情况下，可以加班一小时左右")]), _vm._v("。更希望可以有人督促的工作，自我约束能力不强。\n    ")]), _vm._v(" "), _c('td', [_vm._v("\n        工作懒散，不积极。能偷懒的时候就偷懒。\n    ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "fb",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("沟通协作")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("在我们测试过程中少不了需要和策划和程序进行沟通，假设现在你觉得策划的一个设定很不科学，你会怎么做？如果策划的脾气很差，并且觉得你的建议没有道理，你会怎么做？")]), _vm._v(" "), _c('td', [_vm._v("1. 自我表达流畅自信"), _c('br'), _vm._v("\n        2. 快速理解面试官问题"), _c('br'), _vm._v("\n        3. 回答问题清晰连贯"), _c('br'), _vm._v("\n        4. 积极主动表达更多的相关信息"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "red"
  }, [_vm._v("5. 顾及听众的感受，从听众的角度去考虑问题答案。")])]), _vm._v(" "), _c('td', [_vm._v("1. 自我表达流畅自信"), _c('br'), _vm._v("\n        2. 可以理解面试官问题"), _c('br'), _vm._v("\n        3. 回答问题有条理连贯"), _c('br'), _vm._v("\n        4. 积极主动表达更多的相关信息")]), _vm._v(" "), _c('td', [_vm._v("1. 自我表达流畅"), _c('br'), _vm._v("\n        2. 可以理解面试官问题"), _c('br'), _vm._v("\n        3. 回答问题清晰连贯"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "red"
  }, [_vm._v("（可以顺利完成问答流程，不能积极主动的表达和思考。）")])]), _vm._v(" "), _c('td', [_vm._v("1. 可以表达自己想法"), _c('br'), _vm._v("\n        2. 可以理解面试官问题"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "red"
  }, [_vm._v("（可以正常的沟通，但是组织语言能力较差，回答卡顿。）")])]), _vm._v(" "), _c('td', [_vm._v("1. 沟通有障碍"), _c('br'), _vm._v("\n        2. 正常沟通有一定难度")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n        首先我会跟他进行沟通并阐述我的观点和原因。根据熟悉程度和风格进行适当的调整沟通的语气和方式。为了证明我的观点，我可能会"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("使用一些数据")]), _vm._v("，或者"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("找一些有相同看法的人一起支持我的观点")]), _vm._v("。如果还不能达到目的，我可以后续进行"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("多次沟通和交流")]), _vm._v("。并"), _c('span', {
    staticClass: "orange"
  }, [_vm._v("听取他的想法和原因")]), _vm._v("，再作考虑。当然如果还是不行我可能"), _c('span', {
    staticClass: "green"
  }, [_vm._v("会跟我的上司交流")]), _vm._v("，看看是不是可以让他去沟通。\n    ")]), _vm._v(" "), _c('td', [_vm._v("\n        首先我会跟他进行沟通并阐述我的观点和原因。根据熟悉程度和风格进行适当的调整沟通的语气和方式。为了证明我的观点，我可能会"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("使用一些数据")]), _vm._v("，或者"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("找一些有相同看法的人一起支持我的观点")]), _vm._v("。如果还不能达到目的，我可以后续进行"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("多次沟通和交流")]), _vm._v("。并听取他的想法和原因，再作考虑。当然如果还是不行我可能"), _c('span', {
    staticClass: "green"
  }, [_vm._v("会跟我的上司交流")]), _vm._v("，看看是不是可以让他去沟通。\n    ")]), _vm._v(" "), _c('td', [_vm._v("\n        首先我会跟他进行沟通并阐述我的观点和原因。如果还不能达到目的，我可以后续进行"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("多次沟通和交流")]), _vm._v("。当然如果还是不行我可能"), _c('span', {
    staticClass: "green"
  }, [_vm._v("会跟我的上司交流")]), _vm._v("，看看是不是可以让他去沟通。\n    ")]), _vm._v(" "), _c('td', [_vm._v("\n        首先我会跟他进行沟通并阐述我的观点和原因。当然如果还是不行我可能"), _c('span', {
    staticClass: "green"
  }, [_vm._v("会跟我的上司交流")]), _vm._v("，看看是不是可以让他去沟通。\n    ")]), _vm._v(" "), _c('td', [_vm._v("\n        我会和他进行沟通吧。\n    ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "fb",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("认知能力")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("\n        1.产品负责人过来和QA说：我听说有玩家反馈我们的xx英雄太强了，主QA让你来负责处理这个问题，你怎么做？\n        2. 这个英雄是付费抽取英雄，概率设定付费1w rmb才可以获得，如果英雄确实强度超标，怎么处理？\n    ")]), _vm._v(" "), _c('td', [_vm._v("1. 快速理解面试官问题"), _c('br'), _vm._v("\n        2. 逻辑推理能力强"), _c('br'), _vm._v("\n        3. 发散思维能力强"), _c('br'), _vm._v("\n        4. 有很好的抽象思维的能力"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "red"
  }, [_vm._v("5. 具有复杂问题拆解成简易能解决问题的能力。")])]), _vm._v(" "), _c('td', [_vm._v("1. 可以理解面试官问题"), _c('br'), _vm._v("\n        2. 有一定的逻辑推理能力"), _c('br'), _vm._v("\n        3. 发散思维能力强"), _c('br'), _vm._v("\n        4. 具有的抽象思维的能力\n    ")]), _vm._v(" "), _c('td', [_vm._v("1. 可以理解面试官问题"), _c('br'), _vm._v("\n        2. 逻辑推理能力较差"), _c('br'), _vm._v("\n        3. 有一定发散思维能力"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "red"
  }, [_vm._v("（可以顺利完成举一反三过程，而不是换皮后还需要再次教学")])]), _vm._v(" "), _c('td', [_vm._v("1. 可以理解面试官问题"), _c('br'), _vm._v("\n        2. 逻辑推理能力几乎没有"), _c('br'), _vm._v("\n        3. 几乎没有发散思维能力"), _c('br'), _vm._v("\n        （"), _c('span', {
    staticClass: "red"
  }, [_vm._v("（事情换皮后还需要再次教学）")])]), _vm._v(" "), _c('td', [_vm._v("1. 对于面试官的问题理解较差"), _c('br'), _vm._v("\n        2. 逻辑理解经常出现偏差")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n        1. 首先我们需要了解到产品是"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("从什么反馈了解到这一现象的")]), _vm._v("，除了已知渠道我们可以还可以从营销、运维、贴吧、论坛等途径去了解类似问题的信息？是xx英雄太强，还是yy英雄太弱而让人觉得xx英雄太强，避免一刀切。然后我们需要了解"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("问题反馈的频率以及反馈的人")]), _vm._v("，这两个维度都是我们做出决策的重要标准，另外也需要考虑到"), _c('span', {
    staticClass: "orange"
  }, [_vm._v("选手的水平，以及胜率数据")]), _vm._v("，综合以上判断后如果这确实是个问题，我们需要"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("给出产品修改的建议")]), _vm._v("（削弱或者增强另一个英雄来动态平衡），如果这不是一个问题，我们应该"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("给出产品我们得出该结论的原因")]), _vm._v("：反馈人数过少，非关键人物反馈，不足以作为修改的依据"), _c('br'), _vm._v("\n        2. 因为这是一个付费英雄，同时已经证实是过强了，那么处理方式需要"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("考虑到玩家影响")]), _vm._v("，可以通过预先通知，客服沟通的形式来同大R玩家交流所做修改是否会引起玩家的反感；之前也提到过游戏的平衡性不仅仅只能做削弱，也可以"), _c('span', {
    staticClass: "orange"
  }, [_vm._v("增强其他克制英雄")]), _vm._v("，营造一个食物链关系，这样从玩家的角度看，他拥有的英雄并没有变弱，相比削弱影响会降低；综合而言，我们需要处理，但是可以"), _c('span', {
    staticClass: "orange"
  }, [_vm._v("通过一些方式降低影响")])]), _vm._v(" "), _c('td', [_vm._v("\n        1. 首先我们需要了解到产品是"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("从什么反馈了解到这一现象的")]), _vm._v("，除了已知渠道我们可以还可以从营销、运维、贴吧、论坛等途径去了解类似问题的信息？是xx英雄太强，还是yy英雄太弱而让人觉得xx英雄太强，避免一刀切。然后我们需要了解"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("问题反馈的频率以及反馈的人")]), _vm._v("，这两个维度都是我们做出决策的重要标准，如果这确实是个问题，我们需要"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("给出产品修改的建议")]), _vm._v("，如果这不是一个问题，我们应该"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("给出产品我们得出该结论的原因")]), _vm._v("：反馈人数过少，非关键人物反馈，不足以作为修改的依据"), _c('br'), _vm._v("\n        2. 因为这是一个付费英雄，同时已经证实是过强了，那么处理方式需要"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("考虑到玩家影响")]), _vm._v("，可以通过预先通知，客服沟通的形式来同大R玩家交流所做修改是否会引起玩家的反感；然后我们还是需要削弱这个英雄的，因为确实比较强。\n    ")]), _vm._v(" "), _c('td', [_vm._v("\n        1. 首先我们需要了解到产品是"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("从什么反馈了解到这一现象的")]), _vm._v("，除了已知渠道我们可以还可以从营销、运维、贴吧、论坛等途径去了解类似问题的信息？如果这确实是个问题，我们需要"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("给出产品修改的建议")]), _vm._v("。"), _c('br'), _vm._v("\n        2. 确认这个强度确实是需要修复的，那么就只能开始削弱了\n    ")]), _vm._v(" "), _c('td', [_vm._v("1. 询问产品具体的反馈是什么，根据自己的经验考虑下这个英雄强势点在哪里，给出削弱的方案"), _c('br'), _vm._v("\n        2. 比较纠结，不知道怎么做才好，提示这个强度是需要处理的，那么就削弱吧")]), _vm._v(" "), _c('td', [_vm._v("\n        1.那就把这个英雄削弱吧，我觉得xx技能比较强，削弱对应的技能"), _c('br'), _vm._v("\n        2. 感觉应该不能削弱，因为玩家充了很多钱（题干没理解清楚“强度超标”，充了很多钱也不能作为不削弱的标准）\n    ")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "fb",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("游戏经历与游戏热情")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("\n        谈谈之前玩过哪些游戏，以及这些游戏中的关键特点和模块。（如果可以简单的谈一下游戏的发展过程。）\n    ")]), _vm._v(" "), _c('td', [_vm._v("1. 经验丰富，体验游戏种类多"), _c('br'), _vm._v("\n        2. 重度、高端玩家，熟悉各种系统、玩法和功能"), _c('br'), _vm._v("\n        3. 在各类电子竞赛获过奖"), _c('br'), _vm._v("\n        4. 有组织过战队，担任过队长，公会会长等。\n    ")]), _vm._v(" "), _c('td', [_vm._v("1. 经验丰富，体验游戏种类多"), _c('br'), _vm._v("\n        2. 了解各种系统、玩法和功能"), _c('br'), _vm._v("\n        3. 至少有1个游戏重度游玩1年以上")]), _vm._v(" "), _c('td', [_vm._v("1. 有较多的游戏经验"), _c('br'), _vm._v("\n        2. 有持续玩游戏的习惯")]), _vm._v(" "), _c('td', [_vm._v("1. 平时玩游戏较少"), _c('br'), _vm._v("\n        2. 只针对性的玩简单的游戏"), _c('br'), _vm._v("\n        （听说过一些游戏玩法，但不清楚玩法细节）")]), _vm._v(" "), _c('td', [_vm._v("1. 基本不玩游戏"), _c('br'), _vm._v("\n        2. 游戏了解来源于看别人玩游戏")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("游戏经历了端游，页游，手游等历程。有rpg,mmp,fps,tps,塔防等多种风格。"), _c('span', {
    staticClass: "orange"
  }, [_vm._v("体验过多款端游")]), _vm._v("，手游，也玩过简单的卡牌和养成类游戏。清楚各个模块，功能，的具体玩法和流程。理解游戏相关设置的原因和目的（比如说：体力值的设置，是为了增加游戏寿命。），了解平衡性相关的设计（知道新英雄需要稍强与老英雄。）了解各个风格应该有的特色和优缺点。并"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("能针对个游戏的优缺点提出改进意见")]), _vm._v("。"), _c('span', {
    staticClass: "orange"
  }, [_vm._v("部分游戏排名靠前或者担任过指挥，会长")])]), _vm._v(" "), _c('td', [_vm._v("\n        了解游戏历史，"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("知道市面上主流的游戏类型。玩过多款，多种类型的游戏。")]), _vm._v("并针对游戏进行了思考。知道各个玩过游戏的优缺点，了解一下游戏秘籍和技巧，并"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("发现过一些 bug 和漏洞")])]), _vm._v(" "), _c('td', [_vm._v("\n        对游戏历史不熟悉，但是"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("非常熟悉几款游戏")]), _vm._v("。了解熟悉游戏的主流模块的玩法了解。"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("游戏术语了解一些")]), _vm._v("，但仅限于自己玩过的游戏。\n    ")]), _vm._v(" "), _c('td', [_vm._v("\n        玩游戏较少，只玩过几款简单的游戏，消消乐，跑酷等。只了解一些简单的功能签到等。复杂的玩法和功能不了解细节。\n    ")]), _vm._v(" "), _c('td', [_vm._v("\n        基本不玩游戏，对游戏并没有什么兴趣，或者本身对游戏有反感。\n    ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "fb",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("学习能力")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("\n        能说一下最近在学习的内容，或者之前学习某些技术的经历吗？学习了多久，\n        有什么样的学习计划（怎么设计的计划），是不是可以将该技术应用的生活工作中去，遇到\n        不能理解的问题如何解决？\n    ")]), _vm._v(" "), _c('td', [_vm._v("善于学习新的知识领域，能较快自学掌握复杂的专业知识，知识面广泛")]), _vm._v(" "), _c('td', [_vm._v("能独立学习自己专业相关、有一定难度和深度的知识")]), _vm._v(" "), _c('td', [_vm._v("学习能力较弱，只能基本掌握必须的专业知识")]), _vm._v(" "), _c('td', [_vm._v("缺乏学习能力，自己专业知识都无法掌握")]), _vm._v(" "), _c('td', [_vm._v("1. 对所学的知识都没有很好的认知，属于混知识")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n        最近在学习 python 语言，制定了一个学习计划，在"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("6个月内读完《Python 入门》这本书")]), _vm._v("。指定计划的依据根据书的厚度，和测试了一下自己可以接受的页数，以及考虑\n        了复习和稳固的时间。截至目前为止，看到了数据类型一章，还在按照计划进行。学习的知识在生活中有应用，目前会使用 python 处理一些表格和数据。在学习中如果出现了问题会"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("百度")]), _vm._v("或者 "), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("Google 寻找解答")]), _vm._v("。"), _c('span', {
    staticClass: "orange"
  }, [_vm._v("StackOverFlow")]), _vm._v(" 是经常访问的网站，很多问题都可以从中得到答案。相信自己可以通过学习解决工作中遇到的各种困难。")]), _vm._v(" "), _c('td', [_vm._v("\n        最近在学习 python 语言，制定了一个学习计划，但是由于基础比较差，进度很慢。"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("截至目前为止，学习了 2 个月")]), _vm._v("，看到了数据类型一章。学习的知识在生活中有应用，目前会使用 python 处理一些表格和数据。在学习中如果出现了问题会"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("百度")]), _vm._v("或者 "), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("Google")]), _vm._v("span> 寻找解答。感觉工作中的困难都可以通过学习来解决\n    ")]), _vm._v(" "), _c('td', [_vm._v("\n        目前正在学习 python 语言，但是基本上是有时间的时候就是看一会，"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("并没有制定详细完整的计划")]), _vm._v("。目前已经学会一些基础知识，但是很少应用，（在提出简单问题后，可以作答，不能主动想应用。）更希望在有人指导或者培训的情况下学习，"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("自己学习感觉效率不高")]), _vm._v("。遇到问题更喜欢问人，自己不是很了解解决问题的方法。\n    ")]), _vm._v(" "), _c('td', [_vm._v("\n        目前打算学习 python，"), _c('span', {
    staticClass: "green"
  }, [_vm._v("但是并没有什么时间看，或者还没有什么进展")]), _vm._v("，并没有制定计划。之前学习的内容一般需要较长时间消化了理解，并且应用到实际工作中"), _c('span', {
    staticClass: "green"
  }, [_vm._v("感觉比较困难")]), _vm._v("。\n    ")]), _vm._v(" "), _c('td', [_vm._v("\n        最近没有学习什么新的技术，之前的学习经验也没有什么可圈可点的地方。\n    ")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "9"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "fb",
    attrs: {
      "rowspan": "6"
    }
  }, [_vm._v("加分项")]), _vm._v(" "), _c('td', {
    staticClass: "fb",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("游戏经验")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("从面试者最熟悉的游戏引入问题，"), _c('br'), _vm._v("\n        1.你最喜欢的角色是什么？他的特点是什么？"), _c('br'), _vm._v("\n        2.你有办法解决你所提到的这个角色的缺点吗？"), _c('br'), _vm._v("\n        3.你觉得从提升游戏整体体验方面有哪些可以做的")]), _vm._v(" "), _c('td', [_vm._v("1. 对游戏和系统的深度理解"), _c('br'), _vm._v("\n        2. 能提出熟悉游戏的优点，缺点和建议"), _c('br'), _vm._v("\n        3. 能对游戏细节有独到的理解"), _c('br'), _vm._v("\n        4. 能够针对目前游戏情况给出更好的建议"), _c('br'), _vm._v("\n        5 对游戏的发展理解比较好")]), _vm._v(" "), _c('td', [_vm._v("1. 对游戏和系统的有较深度理解"), _c('br'), _vm._v("\n        2. 能提出熟悉游戏的优点，缺点和建议"), _c('br'), _vm._v("\n        3. 能对游戏细节有独到的理解"), _c('br'), _vm._v("\n        4. 能够针对目前游戏情况给出一定的建议"), _c('br'), _vm._v("\n        5. 能同步了解游戏发展趋势")]), _vm._v(" "), _c('td', [_vm._v("1. 对游戏和系统的有较深度理解"), _c('br'), _vm._v("\n        2. 能提出熟悉游戏的优点，缺点和想法"), _c('br'), _vm._v("\n        3. 能对游戏细节有独到的理解"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "red"
  }, [_vm._v("（不能提出有效建议）")])]), _vm._v(" "), _c('td', [_vm._v("1. 停留在玩游戏的层次"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "red"
  }, [_vm._v("2.从自己感觉出发不是站在游戏角度来理解游戏")]), _c('br'), _vm._v("\n        3. 对游戏本身没有太多想法和建议")]), _vm._v(" "), _c('td', [_vm._v("1. 对游戏本身类型和玩法理解都有偏差"), _c('br'), _vm._v("\n        2. 单纯只是娱乐手段")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n        1. 我最喜欢LOL中的疾风剑豪这个角色，人称“快乐风男”，这个英雄的特色是通过"), _c('span', {
    staticClass: "orange"
  }, [_vm._v("短cd技能造成高额伤害")]), _vm._v("，可以"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("通过操作提高这个英雄的强度")]), _vm._v("，不是脸滚键盘的那种。当然缺点也很明显，他的"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("下限非常低")]), _vm._v("，他的强度预计在中等水平，但是LOL大量的低年龄段玩家造成了存在较多的低水平亚索玩家拉低了这个角色的风评，但是无论如何，这个英雄很快乐。"), _c('br'), _vm._v("\n        2. "), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("这个角色的缺点其实也是他的优点")]), _vm._v("，正因为他的下限低，所以设计师才可以提高他的上限，这样也是一种平衡。如果我们需要"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("提升他的下限，那么也需要降低他的上限")]), _vm._v("。一个英雄为什么弱？大概可以分为，容易死，技能难以释放，技能伤害低，那么我们可以简单从这几个方面来提升这个英雄，提高这英雄的生命，将非指向性技能修改为指向性技能，那么这个英雄的伤害我们是否还应该提高呢？我觉得不能，因为我们已经强化了生存以及技能释放难度，这提升了他的下限，如果还提高伤害，那么上限也提升了，"), _c('span', {
    staticClass: "orange"
  }, [_vm._v("这会破坏游戏的平衡。")]), _c('br'), _vm._v("\n        3. 我觉得lol还有一定的发展前景，但是需要"), _c('span', {
    staticClass: "orange"
  }, [_vm._v("关注手游的发展趋势，可以考虑在缩短游戏时间，提升排位体验")]), _vm._v("方面做一些文章，比如加快游戏的节奏，提升兵线的经验、金钱，惩罚游戏内演员，给一些具体的方案等等\n    ")]), _vm._v(" "), _c('td', [_vm._v("\n        1. 我最喜欢LOL中的疾风剑豪这个角色，这个英雄的特色是"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("比较秀")]), _vm._v("，可以"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("通过操作提高这个英雄的强度")]), _vm._v("，不是脸滚键盘的那种。当然缺点也很明显，他的"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("下限非常低")]), _vm._v("，他的平均强度在中等偏下，但是LOL大量的低年龄段玩家造成了存在较多的低水平玩家拉低了这个角色的风评，但是无论如何，这个英雄很快乐。"), _c('br'), _vm._v("\n        2. "), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("这个角色的缺点其实也是他的优点")]), _vm._v("，正因为他的下限低，所以设计师才可以提高他的上限，这样也是一种平衡。如果我们需要"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("提升他的下限，那么也需要降低他的上限")]), _vm._v("。一个英雄为什么弱？大概可以分为，容易死，技能难以释放，技能伤害低，那么我们可以简单从这几个方面来提升这个英雄，提高这英雄的生命，将非指向性技能修改为指向性技能，提高这个英雄的伤害值"), _c('br'), _vm._v("\n        3. "), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("我觉得lol做的挺好的，或许他应该做一个手游试试看")]), _vm._v("（你知道王者荣耀吗？玩的不多吧，你觉得LOL手游版可以从哪些方面胜过王者荣耀呢？对游戏业的趋势不敏锐）\n    ")]), _vm._v(" "), _c('td', [_vm._v("\n        1. 我最喜欢LOL中的疾风剑豪这个角色，人称“快乐风男”，这个英雄可以"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("展现我的操作")]), _vm._v("，不是脸滚键盘的那种。我玩这个英雄胜率很高。"), _c('br'), _vm._v("\n        2. 这个角色的缺点我认为是使用难度高，可以考虑适当"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("降低这个英雄的使用难度")]), _vm._v("：提高这英雄的生命，将非指向性技能修改为指向性技能，提高这个英雄的伤害值"), _c('br'), _vm._v("\n        3. "), _c('span', {
    staticClass: "blue"
  }, [_vm._v("总得来说目前游戏体验挺好的，他们最好把游戏内的导演和演员全部封禁")]), _vm._v("（具体怎么做呢？给不出有效的方案）\n    ")]), _vm._v(" "), _c('td', [_vm._v("\n        1. 我最喜欢LOL中的疾风剑豪这个角色，人称“快乐风男”，我玩这个英雄胜率很高。"), _c('br'), _vm._v("\n        2. 缺点是容易死吧，"), _c('span', {
    staticClass: "green"
  }, [_vm._v("可能是我操作问题，提升下操作就好了")]), _vm._v("，我觉得可以出一些教学视频来教我们如何克服操作难度比较高的问题"), _c('br'), _vm._v("\n        3. 没什么想法，可能可以做pve吧（PVE已经有了，游戏体验不深入）\n    ")]), _vm._v(" "), _c('td', [_vm._v("\n        1. 我觉得什么英雄我都喜欢，要说最喜欢，那就是疾风剑豪，没什么原因就是感觉比较喜欢他"), _c('br'), _vm._v("\n        2. 缺点是容易死吧，可能是我操作问题，提升下操作就好了"), _c('br'), _vm._v("\n        3. 没什么想法可能可以做pve吧（PVE已经有了，游戏体验不深入）\n    ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "fb",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("计算机基础")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("在我们的测试过程中，不仅有黑盒测试，有能力的话也可以接触到白盒测试，\n        之前有做过什么项目或者写过什么软件么，有的话，简单讲下其原理，另外，假如现在我\n        们有个文件中保存了 10000 个玩家的等级数据，我想得到这些玩家中等级的中位数以及等\n        级是该中位数的玩家的个数，如果要你来写，你大概会怎么写（通过答案及回答的过程来\n        考察应聘者的技术能力）")]), _vm._v(" "), _c('td', [_vm._v("精通计算机各类相关知识，有深入的理解，具备丰富的实践经验")]), _vm._v(" "), _c('td', [_vm._v("熟悉计算机各类相关知识，具备一定实践经验")]), _vm._v(" "), _c('td', [_vm._v("对计算机相关知识理解不够深入，仅限于部分了解")]), _vm._v(" "), _c('td', [_vm._v("只懂得基本的概念")]), _vm._v(" "), _c('td', [_vm._v("对计算机相关知识不了解")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("做过了一些"), _c('span', {
    staticClass: "orange"
  }, [_vm._v("项目或者软件")]), _vm._v("（举例并讲述软件使用相关技术），对于题目，首先我会"), _c('span', {
    staticClass: "orange"
  }, [_vm._v("读取")]), _vm._v("这个文件，使用"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v(" xx 排序方法")]), _vm._v("对玩家的等级进行排序，取中间值得到中位数，再对全部数据进行"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("循环")]), _vm._v("，符合条件则计数加 1，最终计数及为个数（有较强代码能力，能开发工具，技术题目都回答正确）")]), _vm._v(" "), _c('td', [_vm._v("对于题目，首先我会使用"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v(" xx 排序方法")]), _vm._v("对玩家的等级进行排序，取中间值得到\n        中位数，再对全部数据进行"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("循环")]), _vm._v("，符合条件则计数加 1，最终计数及为个数（有基本的代码能力，了解计算机基础知识，技术题目能基本答上）")]), _vm._v(" "), _c('td', [_vm._v("首先我会把数据排序拿到中位数，再对全部数据进行"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("循环")]), _vm._v("，符合条件则计数加1，最终计数及为个数（有基本的计算机知识，知道一些逻辑的实现）")]), _vm._v(" "), _c('td', [_vm._v("我会把他们放在 excel 里，排下序再看下中位数，数下等于这种中位数的个数（完全不了解计算机知识，只能黑盒测试）")]), _vm._v(" "), _c('td', [_vm._v("我会排下序再输出下中位数吧（简历中书写熟练或者掌握一些编程内容但是实际并没有掌握）")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "fb",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("算法与编程")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("1.求给定整数是否是给定整数集中某两个数之和。只需返回是否。例如：输入：numbers=[2,11,7，15]，target=9输出：True（9=2+7）"), _c('br'), _vm._v("\n        2.每个孩子都有一个满足度，每个饼干都有一个大小，只有饼干的大小大于等于一个孩子的满足度，该孩子才会获得满足。求解最多可以获得满足的孩子数量。如输入:[2,3,4],[1,2,3]，第一个数组表示三个孩子的满足度，第二个数组表示饼干的大小。应输出2，表示这三个饼干只能满足两个孩子。")]), _vm._v(" "), _c('td', [_vm._v("熟悉高级数据结构和算法，有丰富编程实践经验，资深Coder；")]), _vm._v(" "), _c('td', [_vm._v("熟悉基础数据结构和算法，有一定编程经验；")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "red"
  }, [_vm._v("缺乏编程经验，能读懂简单的代码")])]), _vm._v(" "), _c('td', [_vm._v("没有编程经验，能读懂部分代码段")]), _vm._v(" "), _c('td', [_vm._v("完全不了解代码")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("第一二题均可以答出，要求有做一定的优化")]), _vm._v(" "), _c('td', [_vm._v("第一题可以答出，第二题无法答出")]), _vm._v(" "), _c('td', [_vm._v("了解题意，但无法答出第一题")]), _vm._v(" "), _c('td', [_vm._v("不明白题目意思是什么")]), _vm._v(" "), _c('td', [_vm._v("回答不了解算法")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var score_tips_tester_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/views/evaluation/score-tips/score-tips-tester.vue
var normalizeComponent = __webpack_require__(1)
/* script */
var __vue_script__ = null
/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  score_tips_tester_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var score_tips_score_tips_tester_defaultExport = (Component.exports);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c15cb1b0"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/evaluation/score-tips/score-tips-langtester.vue
var score_tips_langtester_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
}
var score_tips_langtester_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', [_c('td', {
    staticClass: "fb",
    attrs: {
      "rowspan": "5",
      "width": "20"
    }
  }, [_vm._v("必要能力")]), _vm._v(" "), _c('td', {
    staticClass: "fb",
    attrs: {
      "width": "60"
    }
  }, [_vm._v("语言能力")]), _vm._v(" "), _c('td', [_vm._v("听说能力极佳.语法及用词标准.母语水平")]), _vm._v(" "), _c('td', [_vm._v("可以熟练地进行沟通，听力口语均没有困难。沟通表达很好.")]), _vm._v(" "), _c('td', [_vm._v("可以比较熟练地进行沟通，虽有些困难，但不影响交流。")]), _vm._v(" "), _c('td', [_vm._v("可以使用基本的语言进行简单沟通，但无法达到工作语言水平。")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "fb"
  }, [_vm._v("互翻笔译")]), _vm._v(" "), _c('td', [_vm._v("互译内容准确。(掌握很多游戏及计算机方面专业词汇,有游戏相关行业翻译经验.)")]), _vm._v(" "), _c('td', [_vm._v("互译比较准确, 虽有小瑕疵但不会影响翻译结果。(熟悉部分游戏及计算机专业词汇。)")]), _vm._v(" "), _c('td', [_vm._v("互译较弱,用词不准。")]), _vm._v(" "), _c('td', [_vm._v("互翻笔译能力差.")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "fb"
  }, [_vm._v("积极主动")]), _vm._v(" "), _c('td', [_vm._v("面试表现积极，有主动分析问题解决问题的能力，并且能够在过程中改进方案，有备用方案保障计划的正常执行")]), _vm._v(" "), _c('td', [_vm._v("有较高的主动性，能够主动针对当前的主要矛盾提出自己的方案")]), _vm._v(" "), _c('td', [_vm._v("有一定自主能力，可以对指派的任务提出自己的想法")]), _vm._v(" "), _c('td', [_vm._v("几乎很少主动从事某件事情，需要指派任务")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "fb"
  }, [_vm._v("学习能力")]), _vm._v(" "), _c('td', [_vm._v("学习能力很强，对新事物表现出强烈的兴趣，有完成任务的自信，学习的方法、措施令人满意，遭遇问题不会轻易退缩")]), _vm._v(" "), _c('td', [_vm._v("学习能力较强，有对新事物的学习思路，可以自主学习，但是持续时间较久，对困难的处理偏弱")]), _vm._v(" "), _c('td', [_vm._v("学习能力一般，可以看到工作中的进步，但无法完成自主学习的目标，需要专人指导")]), _vm._v(" "), _c('td', [_vm._v("学习能力偏弱，过往经历无法看到明显的进步")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "fb"
  }, [_vm._v("工作态度")]), _vm._v(" "), _c('td', [_vm._v("加班耐性和稳定性极高，工作中责任心很强，负责的任务能保质保量的完成，此外还能主动针对产品的改进做出努力")]), _vm._v(" "), _c('td', [_vm._v("加班耐性和稳定性很高，责任心较强，可以保证委派任务的完成")]), _vm._v(" "), _c('td', [_vm._v("加班耐性和稳定性一般，责任心一般，仍有可能出现指派工作没有很好完成的情况")]), _vm._v(" "), _c('td', [_vm._v("加班耐性和稳定性差，对待工作没有责任感")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "7"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "fb",
    attrs: {
      "rowspan": "5"
    }
  }, [_vm._v("加分项")]), _vm._v(" "), _c('td', {
    staticClass: "fb"
  }, [_vm._v("游戏经验")]), _vm._v(" "), _c('td', [_vm._v("经验丰富，重度、高端玩家，熟悉各种系统，能说出对系统的理解")]), _vm._v(" "), _c('td', [_vm._v("喜欢玩游戏，涉猎广泛，游戏取向和我司游戏类型一致对游戏有自己的理解")]), _vm._v(" "), _c('td', [_vm._v("玩游戏比较丰富，但不够深入；或游戏玩的不多但很深入")]), _vm._v(" "), _c('td', [_vm._v("玩过较少游戏，对游戏有兴趣")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "fb"
  }, [_vm._v("测试思维")]), _vm._v(" "), _c('td', [_vm._v("有较好的测试经验，带过测试团队，能协调整体测试流程，回答问题的逻辑性极强，发散问题回答的点超出预期")]), _vm._v(" "), _c('td', [_vm._v("有较好的测试经验，深入测试过相关系统，了解测试的整体流程，逻辑思维较强，发散问题回答的面较广")]), _vm._v(" "), _c('td', [_vm._v("有一定的测试经验，只测试过基础系统，回答问题有有一定的条理，联想出中等数量的点")]), _vm._v(" "), _c('td', [_vm._v("薄弱的测试经验，思维广度有限，发散思维薄弱")]), _vm._v(" "), _c('td')])])
}]
var score_tips_langtester_esExports = { render: score_tips_langtester_render, staticRenderFns: score_tips_langtester_staticRenderFns }
/* harmony default export */ var score_tips_langtester_defaultExport = (score_tips_langtester_esExports);
// CONCATENATED MODULE: ./src/views/evaluation/score-tips/score-tips-langtester.vue
var score_tips_langtester_normalizeComponent = __webpack_require__(1)
/* script */
var score_tips_langtester___vue_script__ = null
/* template */

/* styles */
var score_tips_langtester___vue_styles__ = null
/* scopeId */
var score_tips_langtester___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var score_tips_langtester___vue_module_identifier__ = null
var score_tips_langtester_Component = score_tips_langtester_normalizeComponent(
  score_tips_langtester___vue_script__,
  score_tips_langtester_defaultExport,
  score_tips_langtester___vue_styles__,
  score_tips_langtester___vue_scopeId__,
  score_tips_langtester___vue_module_identifier__
)

/* harmony default export */ var score_tips_score_tips_langtester_defaultExport = (score_tips_langtester_Component.exports);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-483c331c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/evaluation/score-tips/score-tips-develop.vue
var score_tips_develop_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
}
var score_tips_develop_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', [_c('td', {
    staticClass: "fb",
    attrs: {
      "rowspan": "5",
      "width": "20"
    }
  }, [_vm._v("必要能力")]), _vm._v(" "), _c('td', {
    staticClass: "fb",
    attrs: {
      "width": "60"
    }
  }, [_vm._v("积极主动")]), _vm._v(" "), _c('td', [_vm._v("面试表现积极，有主动分析问题解决问题的能力，并且能够在过程中改进方案，有备用方案保障计划的正常执行")]), _vm._v(" "), _c('td', [_vm._v("有较高的主动性，能够主动针对当前的主要矛盾提出自己的方案")]), _vm._v(" "), _c('td', [_vm._v("有一定自主能力，可以对指派的任务提出自己的想法")]), _vm._v(" "), _c('td', [_vm._v("几乎很少主动从事某件事情，需要指派任务")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "fb"
  }, [_vm._v("沟通表达")]), _vm._v(" "), _c('td', [_vm._v("回答问题积极主动，能很好理解别人，描述清晰语言准确，言谈自信语言流畅")]), _vm._v(" "), _c('td', [_vm._v("能理解他人，会主动表达自己观点，回答积极，且回答切题")]), _vm._v(" "), _c('td', [_vm._v("交流顺畅，表达清晰，正常问答")]), _vm._v(" "), _c('td', [_vm._v("理解能力不足，沟通意愿弱，有问才有答")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "fb"
  }, [_vm._v("学习能力")]), _vm._v(" "), _c('td', [_vm._v("学习能力很强，对新事物表现出强烈的兴趣，有完成任务的自信，学习的方法、措施令人满意，遭遇问题不会轻易退缩")]), _vm._v(" "), _c('td', [_vm._v("学习能力较强，有对新事物的学习思路，可以自主学习，但是持续时间较久，对困难的处理偏弱")]), _vm._v(" "), _c('td', [_vm._v("学习能力一般，可以看到工作中的进步，但无法完成自主学习的目标，需要专人指导")]), _vm._v(" "), _c('td', [_vm._v("学习能力偏弱，过往经历无法看到明显的进步")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "fb"
  }, [_vm._v("技术能力")]), _vm._v(" "), _c('td', [_vm._v("有较好的开发经验，有较强代码能力，能开发工具，带过开发团队，能协调整体开发流程，回答问题的逻辑性极强，技术题目回答超出预期")]), _vm._v(" "), _c('td', [_vm._v("有较好的开发经验，有较好的代码能力，深入开发过相关系统，了解开发的整体流程，逻辑思维较强，发散思维面较广，技术题目能基本答上")]), _vm._v(" "), _c('td', [_vm._v("有一定的开发经验，有基本的计算机知识，只开发过基础系统，回答问题有有一定的条理，知道一些逻辑实现")]), _vm._v(" "), _c('td', [_vm._v("薄弱的开发经验，完全不了解计算机知识，思维广度有限，发散思维薄弱")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "fb"
  }, [_vm._v("工作态度")]), _vm._v(" "), _c('td', [_vm._v("加班耐性和稳定性极高，工作中责任心很强，负责的任务能保质保量的完成，此外还能主动针对产品的改进做出努力")]), _vm._v(" "), _c('td', [_vm._v("加班耐性和稳定性很高，责任心较强，可以保证委派任务的完成")]), _vm._v(" "), _c('td', [_vm._v("加班耐性和稳定性一般，责任心一般，仍有可能出现指派工作没有很好完成的情况")]), _vm._v(" "), _c('td', [_vm._v("加班耐性和稳定性差，对待工作没有责任感")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "7"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "fb",
    attrs: {
      "rowspan": "5"
    }
  }, [_vm._v("加分项")]), _vm._v(" "), _c('td', {
    staticClass: "fb"
  }, [_vm._v("游戏经验")]), _vm._v(" "), _c('td', [_vm._v("经验丰富，重度、高端玩家，熟悉各种系统，能说出对系统的理解")]), _vm._v(" "), _c('td', [_vm._v("喜欢玩游戏，涉猎广泛，游戏取向和我司游戏类型一致对游戏有自己的理解")]), _vm._v(" "), _c('td', [_vm._v("玩游戏比较丰富，但不够深入；或游戏玩的不多但很深入")]), _vm._v(" "), _c('td', [_vm._v("玩过较少游戏，对游戏有兴趣")]), _vm._v(" "), _c('td')])])
}]
var score_tips_develop_esExports = { render: score_tips_develop_render, staticRenderFns: score_tips_develop_staticRenderFns }
/* harmony default export */ var score_tips_develop_defaultExport = (score_tips_develop_esExports);
// CONCATENATED MODULE: ./src/views/evaluation/score-tips/score-tips-develop.vue
var score_tips_develop_normalizeComponent = __webpack_require__(1)
/* script */
var score_tips_develop___vue_script__ = null
/* template */

/* styles */
var score_tips_develop___vue_styles__ = null
/* scopeId */
var score_tips_develop___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var score_tips_develop___vue_module_identifier__ = null
var score_tips_develop_Component = score_tips_develop_normalizeComponent(
  score_tips_develop___vue_script__,
  score_tips_develop_defaultExport,
  score_tips_develop___vue_styles__,
  score_tips_develop___vue_scopeId__,
  score_tips_develop___vue_module_identifier__
)

/* harmony default export */ var score_tips_score_tips_develop_defaultExport = (score_tips_develop_Component.exports);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48701d8e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/evaluation/score-tips/score-tips-verify-qa.vue
var score_tips_verify_qa_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
}
var score_tips_verify_qa_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', [_c('td', {
    staticClass: "fb",
    attrs: {
      "rowspan": "6",
      "width": "20"
    }
  }, [_vm._v("必要能力")]), _vm._v(" "), _c('td', {
    staticClass: "fb",
    attrs: {
      "width": "60",
      "rowspan": "2"
    }
  }, [_vm._v("口语能力")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2",
      "width": "160"
    }
  }, [_vm._v("用对应语言做自我介绍，用对应语言介绍一款自己近期玩的游戏")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "150"
    }
  }, [_vm._v("口语能力好，外语地道，流利，无口音")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "150"
    }
  }, [_vm._v("口语基本流利，偶尔有口音")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "150"
    }
  }, [_vm._v("口语偶尔卡顿，可以听懂")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "150"
    }
  }, [_vm._v("结结巴巴，沟通吃力")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "150"
    }
  }, [_vm._v("无法口语沟通")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "160"
    }
  }, [_vm._v("在做介绍的时候全程非常流利，无卡顿，可以使用较长的句子进行介绍。")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "160"
    }
  }, [_vm._v("做介绍时会出现短暂的停顿，多数情况下比较顺利，说话可能带有一点口音。")]), _vm._v(" "), _c('td', [_vm._v("口语交流中出现一些卡顿，但是面试官可以听懂")]), _vm._v(" "), _c('td', [_vm._v("口语交流不太顺畅，无法完整地说话一整句话。")]), _vm._v(" "), _c('td', [_vm._v("完全不能用口语沟通。")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "fb",
    attrs: {
      "width": "60",
      "rowspan": "2"
    }
  }, [_vm._v("翻译能力")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("用对应外语翻译游戏词汇。游戏词汇翻译，例如攻击力，暴击，魔法值，式神，服务器更新，应用商店，闪退，停服维护。")]), _vm._v(" "), _c('td', [_vm._v("能很好的覆盖普通翻译，以及游戏翻译")]), _vm._v(" "), _c('td', [_vm._v("能很好的覆盖普通翻译")]), _vm._v(" "), _c('td', [_vm._v("翻译中存在少量错误")]), _vm._v(" "), _c('td', [_vm._v("翻译错误较多")]), _vm._v(" "), _c('td', [_vm._v("翻译结果难以阅读")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("可以清楚理解面试官所问内容，不会反复询问"), _c('br'), _vm._v("对于文本理解准确并且有自己的思考。可以对游戏词汇做出比较准确的翻译")]), _vm._v(" "), _c('td', [_vm._v("可以理解面试官所问内容，但是理解上存在偏差导致问题回答存在问题，对于文本理解较为准确但停留在表层，字面意思，对游戏词汇翻译不太准备。")]), _vm._v(" "), _c('td', [_vm._v("对游戏词汇不理解，翻译时有少量的错误，大致语义还是正确的。")]), _vm._v(" "), _c('td', [_vm._v("翻译时错误较多，语义已经完全偏离")]), _vm._v(" "), _c('td', [_vm._v("无法进行翻译工作。")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "fb",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("本地化经验")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("列举几种当地游戏发行时需要注意的事项？"), _c('br'), _vm._v("\r\n        如果项目组想做一次调研，大额内购和小额内购，哪一种受玩家欢迎，你会怎么做？"), _c('br'), _vm._v("\r\n        说说看当地人专有的节假日，并结合这个节假日主题设计一个游戏活动")]), _vm._v(" "), _c('td', [_vm._v("有本地化工作经验"), _c('br'), _vm._v("对于面试中涉及文化的部分有自己的理解，甚至主动发起提问")]), _vm._v(" "), _c('td', [_vm._v("对于面试中涉及文化的部分有自己的理解，甚至主动发起提问")]), _vm._v(" "), _c('td', [_vm._v("面试过程中没有注意各地文化问题，在提醒后能够说出正确解答")]), _vm._v(" "), _c('td', [_vm._v("面试过程中没有注意各地文化问题，在提醒后能够作答，但不准确，和理想结果有偏差")]), _vm._v(" "), _c('td', [_vm._v("面试过程中没有注意各地文化问题，提醒后依然不会作答，或者回答完全错误")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("有海外生活经验，能对当地的文化和节日了如指掌，了解当地人的生活习惯，每日作息等，了解当地游戏市场的热门趋势。有丰富的本地化发型经验")]), _vm._v(" "), _c('td', [_vm._v("了解当地的文化和节日，有海外生活经验，游戏相关涉及较少，但是可以通过人际关系等方法解决问题。本地化注意点回答较完整，比如：文化差异，超框。")]), _vm._v(" "), _c('td', [_vm._v("不太了解当地的特色节日和文化风俗，但是如果给出一个文化问题，还是可以有自己的理解和解决方案。有本地化经验，但没有完整参加过一个项目。")]), _vm._v(" "), _c('td', [_vm._v("不太了解当地的特色节日和文化风俗，给出一个文化的问题以后，解决方案也不太合理。没有本地化经验。")]), _vm._v(" "), _c('td', [_vm._v("对本地化的概念不理解，给不出相关解决方案。")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "9"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "fb",
    attrs: {
      "rowspan": "4"
    }
  }, [_vm._v("加分项")]), _vm._v(" "), _c('td', {
    staticClass: "fb",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("游戏理解")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("\r\n        可以从游戏切入，也可以从其他该同学熟悉的行业（例如：直播，短视频等）切入"), _c('br'), _vm._v("\r\n        以游戏切入为例："), _c('br'), _vm._v("\r\n        1.你最喜欢的角色是什么？他的特点是什么？"), _c('br'), _vm._v("\r\n        2.你有办法解决你所提到的这个角色的缺点吗？"), _c('br'), _vm._v("\r\n        3.你觉得从提升游戏整体体验方面有哪些可以做的"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\r\n        以直播为例："), _c('br'), _vm._v("\r\n        1. 你喜欢的主播是谁？他的日常直播内容是什么？"), _c('br'), _vm._v("\r\n        2. 你觉得这个主播他有缺点吗?如果你是他该如何改进？"), _c('br'), _vm._v("\r\n        3. 直播圈变动意向很大，要长久在此立足该如何去做呢？\r\n      ")]), _vm._v(" "), _c('td', [_vm._v("1. 对该业务（游戏和系统）有深度理解"), _c('br'), _vm._v("\r\n          2. 能提出熟悉业务（游戏）的优点，缺点和建议"), _c('br'), _vm._v("\r\n          3. 能对业务（游戏）细节有独到的理解"), _c('br'), _vm._v("\r\n          4. 能够针对目前业务（游戏）情况给出更好的建议"), _c('br'), _vm._v("\r\n          5. 对行业（游戏）的发展理解比较好"), _c('br')]), _vm._v(" "), _c('td', [_vm._v("\r\n        1. 对业务（游戏和系统）有较深度理解"), _c('br'), _vm._v("\r\n        2. 能提出熟悉业务（游戏）的优点，缺点和建议"), _c('br'), _vm._v("\r\n        3. 能对业务（游戏）细节有独到的理解"), _c('br'), _vm._v("\r\n        4. 能够针对目前业务（游戏）情况给出一定的建议"), _c('br'), _vm._v("\r\n        5. 能同步了解行业（游戏）发展趋势\r\n      ")]), _vm._v(" "), _c('td', [_vm._v("\r\n        1. 对业务（游戏和系统）有较深度理解"), _c('br'), _vm._v("\r\n        2. 能提出熟悉业务（游戏）的优点，缺点和想法"), _c('br'), _vm._v("\r\n        3. 能对业务（游戏）细节有独到的理解"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "red"
  }, [_vm._v("（不能提出有效建议）")])]), _vm._v(" "), _c('td', [_vm._v("\r\n        1.停留在业务表层（玩游戏）"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "red"
  }, [_vm._v("2.从自己感觉出发不是站在整体业务（游戏）角度来理解具体内容")]), _c('br'), _vm._v("\r\n        3.对业务（游戏）本身没有太多想法和建议"), _c('br')]), _vm._v(" "), _c('td', [_vm._v("\r\n        1. 对业务（游戏本身类型和玩法）理解都有偏差"), _c('br'), _vm._v("\r\n        2. 单纯只是娱乐手段"), _c('br')]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\r\n        1. 我最喜欢LOL中的疾风剑豪这个角色，人称“快乐风男”，这个英雄的特色是通过"), _c('span', {
    staticClass: "orange"
  }, [_vm._v("短cd技能造成高额伤害")]), _vm._v("，可以"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("通过操作提高这个英雄的强度")]), _vm._v("，不是脸滚键盘的那种。当然缺点也很明显，他的"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("下限非常低")]), _vm._v("，他的强度预计在中等水平，但是LOL大量的低年龄段玩家造成了存在较多的低水平亚索玩家拉低了这个角色的风评，但是无论如何，这个英雄很快乐。"), _c('br'), _vm._v("\r\n        2. "), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("这个角色的缺点其实也是他的优点")]), _vm._v("，正因为他的下限低，所以设计师才可以提高他的上限，这样也是一种平衡。如果我们需要"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("提升他的下限，那么也需要降低他的上限")]), _vm._v("。一个英雄为什么弱？大概可以分为，容易死，技能难以释放，技能伤害低，那么我们可以简单从这几个方面来提升这个英雄，提高这英雄的生命，将非指向性技能修改为指向性技能，那么这个英雄的伤害我们是否还应该提高呢？我觉得不能，因为我们已经强化了生存以及技能释放难度，这提升了他的下限，如果还提高伤害，那么上限也提升了，"), _c('span', {
    staticClass: "orange"
  }, [_vm._v("这会破坏游戏的平衡。")]), _c('br'), _vm._v("\r\n        3. 我觉得lol还有一定的发展前景，但是需要"), _c('span', {
    staticClass: "orange"
  }, [_vm._v("关注手游的发展趋势，")]), _vm._v("可以考虑在"), _c('span', {
    staticClass: "orange"
  }, [_vm._v("缩短游戏时间，提升排位体验")]), _vm._v("方面做一些文章，比如加快游戏的节奏，提升兵线的经验、金钱，惩罚游戏内演员，给一些具体的方案等等\r\n      ")]), _vm._v(" "), _c('td', [_vm._v("\r\n          1. 我最喜欢LOL中的疾风剑豪这个角色，这个英雄的特色是"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("比较秀")]), _vm._v("，可以"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("通过操作提高这个英雄的强度")]), _vm._v("，不是脸滚键盘的那种。当然缺点也很明显，他的"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("下限非常低")]), _vm._v("，他的平均强度在中等偏下，但是LOL大量的低年龄段玩家造成了存在较多的低水平玩家拉低了这个角色的风评，但是无论如何，这个英雄很快乐。"), _c('br'), _vm._v("\r\n          2. "), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("这个角色的缺点其实也是他的优点")]), _vm._v("，正因为他的下限低，所以设计师才可以提高他的上限，这样也是一种平衡。如果我们需要"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("提升他的下限，那么也需要降低他的上限")]), _vm._v("。一个英雄为什么弱？大概可以分为，容易死，技能难以释放，技能伤害低，那么我们可以简单从这几个方面来提升这个英雄，提高这英雄的生命，将非指向性技能修改为指向性技能，提高这个英雄的伤害值"), _c('br'), _vm._v("\r\n          3. "), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("我觉得lol做的挺好的，或许他应该做一个手游试试看")]), _vm._v("（你知道王者荣耀吗？玩的不多吧，你觉得LOL手游版可以从哪些方面胜过王者荣耀呢？对游戏业的趋势不敏锐）\r\n      ")]), _vm._v(" "), _c('td', [_vm._v("\r\n          1. 我最喜欢LOL中的疾风剑豪这个角色，人称“快乐风男”，这个英雄可以"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("展现我的操作")]), _vm._v("，不是脸滚键盘的那种。我玩这个英雄胜率很高。"), _c('br'), _vm._v("\r\n          2. 这个角色的缺点我认为是使用难度高，可以考虑适当"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("降低这个英雄的使用难度")]), _vm._v("：提高这英雄的生命，将非指向性技能修改为指向性技能，提高这个英雄的伤害值"), _c('br'), _vm._v("\r\n          3. "), _c('span', {
    staticClass: "blue"
  }, [_vm._v("总得来说目前游戏体验挺好的，他们最好把游戏内的导演和演员全部封禁")]), _vm._v("（具体怎么做呢？给不出有效的方案）\r\n      ")]), _vm._v(" "), _c('td', [_vm._v("\r\n          1. 我最喜欢LOL中的疾风剑豪这个角色，人称“快乐风男”，我玩这个英雄胜率很高。"), _c('br'), _vm._v("\r\n          2. 缺点是容易死吧，"), _c('span', {
    staticClass: "green"
  }, [_vm._v("可能是我操作问题，提升下操作就好了")]), _vm._v("，我觉得可以出一些教学视频来教我们如何克服操作难度比较高的问题"), _c('br'), _vm._v("\r\n          3. 没什么想法，可能可以做pve吧（PVE已经有了，游戏体验不深入）\r\n      ")]), _vm._v(" "), _c('td', [_vm._v("\r\n          1. 我觉得什么英雄我都喜欢，要说最喜欢，那就是疾风剑豪，没什么原因就是感觉比较喜欢他"), _c('br'), _vm._v("\r\n          2. 缺点是容易死吧，可能是我操作问题，提升下操作就好了"), _c('br'), _vm._v("\r\n          3. 没什么想法可能可以做pve吧（PVE已经有了，游戏体验不深入）\r\n      ")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "fb",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("综合素质")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("执行能力、沟通能力、工作态度"), _c('br'), _vm._v("考察软素质，例如分配一个任务怎么准备，怎么执行，遇到困难怎么处理")]), _vm._v(" "), _c('td', [_vm._v("\r\n          1. 计划完备有风险预案"), _c('br'), _vm._v("\r\n          2. 表达自信，有同理心，能主动表达"), _c('br'), _vm._v("\r\n          3. 有较强的抗压能力、会主动承担工作\r\n      ")]), _vm._v(" "), _c('td', [_vm._v("\r\n        1. 计划较完备但没有风险预案"), _c('br'), _vm._v("\r\n        2. 表达自信，能主动表达"), _c('br'), _vm._v("\r\n        3. 有较强的抗压能力\r\n      ")]), _vm._v(" "), _c('td', [_vm._v("\r\n        1. 需要给出提示才可以有较满意的计划"), _c('br'), _vm._v("\r\n        2. 表达顺畅"), _c('br'), _vm._v("\r\n        3. 负责任务可以正常完成，但其他工作需要敦促\r\n      ")]), _vm._v(" "), _c('td', [_vm._v("\r\n        1. 逻辑混乱，计划错误很多"), _c('br'), _vm._v("\r\n        2. 沟通过程卡顿，需要面试官给予较多的提示"), _c('br'), _vm._v("\r\n        3. 负责任务有较多遗漏，需要不停跟进\r\n      ")]), _vm._v(" "), _c('td', [_vm._v("\r\n          1. 计划不可执行、为人易于放弃"), _c('br'), _vm._v("\r\n          2. 沟通困难"), _c('br'), _vm._v("\r\n          3. 反对加班\r\n        ")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\r\n        计划团建会单对单询问，可以听取他人的建议结合实际情况确认是否可行，计划中包含了诸如飞机延误，门票售罄等情况的预案"), _c('br'), _vm._v("\r\n        在该计划没有得到上级审核通过的情况，能分析具体原因并且加班解决该问题，在发现潜在问题后主动汇报并且尝试解决该问题\r\n      ")]), _vm._v(" "), _c('td', [_vm._v("\r\n        计划团建会单对单询问，会多次和他人沟通确认方案"), _c('br'), _vm._v("\r\n        在该计划没有得到上级审核通过的情况，能分析具体原因并且加班解决该问题，发现潜在问题后会主动汇报问题\r\n      ")]), _vm._v(" "), _c('td', [_vm._v("\r\n        计划团建会单对单询问，但是对于不同人员的异议处理不佳，单纯给出主观见解"), _c('br'), _vm._v("\r\n        在该计划没有得到上级审核通过的情况，尝试加班解决该问题\r\n      ")]), _vm._v(" "), _c('td', [_vm._v("\r\n        计划只是对人员意见的汇总，没有单独的沟通"), _c('br'), _vm._v("\r\n        计划存在一定的矛盾，例如：未考虑到前往机场登机时间，行程过紧几乎无法实现"), _c('br'), _vm._v("\r\n        主管提出问题后简单修改，提交后没得到反馈的情况下人不在了"), _c('br')]), _vm._v(" "), _c('td', [_vm._v("\r\n        自己私自定下计划，没有沟通的过程"), _c('br'), _vm._v("\r\n        目光闪烁，顾左右而言他"), _c('br'), _vm._v("\r\n        对于加班非常抗拒"), _c('br')]), _vm._v(" "), _c('td')])])
}]
var score_tips_verify_qa_esExports = { render: score_tips_verify_qa_render, staticRenderFns: score_tips_verify_qa_staticRenderFns }
/* harmony default export */ var score_tips_verify_qa_defaultExport = (score_tips_verify_qa_esExports);
// CONCATENATED MODULE: ./src/views/evaluation/score-tips/score-tips-verify-qa.vue
var score_tips_verify_qa_normalizeComponent = __webpack_require__(1)
/* script */
var score_tips_verify_qa___vue_script__ = null
/* template */

/* styles */
var score_tips_verify_qa___vue_styles__ = null
/* scopeId */
var score_tips_verify_qa___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var score_tips_verify_qa___vue_module_identifier__ = null
var score_tips_verify_qa_Component = score_tips_verify_qa_normalizeComponent(
  score_tips_verify_qa___vue_script__,
  score_tips_verify_qa_defaultExport,
  score_tips_verify_qa___vue_styles__,
  score_tips_verify_qa___vue_scopeId__,
  score_tips_verify_qa___vue_module_identifier__
)

/* harmony default export */ var score_tips_score_tips_verify_qa_defaultExport = (score_tips_verify_qa_Component.exports);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05ad915a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/evaluation/score-tips/score-tips-2020-social-qa.vue
var score_tips_2020_social_qa_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
}
var score_tips_2020_social_qa_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', [_c('td', {
    staticClass: "fb",
    attrs: {
      "rowspan": "4",
      "width": "20"
    }
  }, [_vm._v("必要能力")]), _vm._v(" "), _c('td', {
    staticClass: "fb",
    attrs: {
      "width": "60"
    }
  }, [_vm._v("执行能力")]), _vm._v(" "), _c('td', [_vm._v("1. 做事条理性强，思考有逻辑顺序。"), _c('span', {
    staticClass: "red"
  }, [_vm._v("有完备的计划性。")]), _c('br'), _vm._v("\n        2. 思考全面，会考虑到边缘情况。并给出解决方法。"), _c('br'), _vm._v("\n        3. 针对做事过程中出现的困难，可以有"), _c('span', {
    staticClass: "red"
  }, [_vm._v("比较合适的解决方案。")]), _c('br'), _vm._v("\n        4. 不畏惧困难，有信心和能力解决问题。"), _c('br'), _vm._v("\n        5. "), _c('span', {
    staticClass: "red"
  }, [_vm._v("有担任过中型团队（10人左右）的leader经历")]), _vm._v("，并安排计划合理。\n    ")]), _vm._v(" "), _c('td', [_vm._v("1. 做事条理性强，思考有逻辑顺序。有一定的计划。"), _c('br'), _vm._v("\n        2. 思考全面，会考虑到边缘情况。并给出解决方法。"), _c('br'), _vm._v("\n        3. 针对做事过程中出现的困难，可以有比较合适的解决方案。"), _c('br'), _vm._v("\n        4. "), _c('span', {
    staticClass: "red"
  }, [_vm._v("有担任小团队（5人以下）leader的经历。")])]), _vm._v(" "), _c('td', [_vm._v("1. 做事有条理性，思考有逻辑。"), _c('br'), _vm._v("\n        2. 思考较全面，"), _c('span', {
    staticClass: "red"
  }, [_vm._v("提示下可以比较完备。")]), _c('br'), _vm._v("\n        3. 针对做事过程中出现的困难，可以给出解决方案。"), _c('br'), _vm._v("\n        4. 对工作优先级和事务优先级有见解，"), _c('span', {
    staticClass: "red"
  }, [_vm._v("时间意识和效率意识强。")])]), _vm._v(" "), _c('td', [_vm._v("1.思维条理性不强，想到哪里说到哪里。"), _c('br'), _vm._v("\n        2. 对待问题处理能力不强，不能给出较好的解决方案。"), _c('br'), _vm._v("\n        3. 回答问题缓慢，结构框架凌乱。提示下并无改进。"), _c('br')]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "23"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "fb"
  }, [_vm._v("沟通能力")]), _vm._v(" "), _c('td', [_vm._v("1. 自我表达流畅自信"), _c('br'), _vm._v("\n        2. 快速理解面试官问题"), _c('br'), _vm._v("\n        3. 回答问题清晰连贯"), _c('br'), _vm._v("\n        4. 积极主动表达更多的相关信息"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "red"
  }, [_vm._v("5. 顾及听众的感受，从听众的角度去考虑问题答案。")])]), _vm._v(" "), _c('td', [_vm._v("1. 自我表达流畅自信"), _c('br'), _vm._v("\n        2. 可以理解面试官问题"), _c('br'), _vm._v("\n        3. 回答问题有条理连贯"), _c('br'), _vm._v("\n        4. 积极主动表达更多的相关信息\n    ")]), _vm._v(" "), _c('td', [_vm._v("1. 自我表达流畅"), _c('br'), _vm._v("\n        2. 可以理解面试官问题"), _c('br'), _vm._v("\n        3. 回答问题清晰连贯"), _c('br'), _vm._v("\n        （"), _c('span', {
    staticClass: "red"
  }, [_vm._v("可以顺利完成问答流程，不能积极主动的表达和思考。")]), _vm._v("）\n    ")]), _vm._v(" "), _c('td', [_vm._v("1. 可以表达自己想法"), _c('br'), _vm._v("\n        2. 可以理解面试官问题"), _c('br'), _vm._v("\n        （"), _c('span', {
    staticClass: "red"
  }, [_vm._v("可以正常的沟通，但是组织语言能力较差，回答卡顿。")]), _vm._v("）\n    ")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "fb"
  }, [_vm._v("测试能力")]), _vm._v(" "), _c('td', [_vm._v("1.有较好的测试经验"), _c('br'), _vm._v("\n        2."), _c('span', {
    staticClass: "red"
  }, [_vm._v("带过测试团队")]), _vm._v("，能协调整体测试流程（参考：3年+）"), _c('br'), _vm._v("\n        3.有系统的测试思维，能逻辑清晰地描述几乎所有测试点，各方面都能考虑到"), _c('br'), _vm._v("\n        4. "), _c('span', {
    staticClass: "red"
  }, [_vm._v("对性能测试，兼容性测试等有了解或者工作经历。")]), _c('br'), _vm._v("\n        5. "), _c('span', {
    staticClass: "red"
  }, [_vm._v("测试相关理论基础扎实。知道边界值测试、等价类等。")])]), _vm._v(" "), _c('td', [_vm._v("\n        1.有较好的测试经验"), _c('br'), _vm._v("\n        2.深入测试过相关系统，了解测试的整体流程（参考：2-3年）"), _c('br'), _vm._v("\n        3.有系统的测试思维，测试点考虑的比较全面细致，逻辑清晰"), _c('br'), _vm._v("\n        4."), _c('span', {
    staticClass: "red"
  }, [_vm._v("在之前的工作中又发现比较隐蔽却重要的bug。")])]), _vm._v(" "), _c('td', [_vm._v("\n        1.有一定的测试经验"), _c('br'), _vm._v("\n        2.只测试过基础系统（参考：1-2年）"), _c('br'), _vm._v("\n        3.有一定的测试思维，能够答上较多测试点"), _c('br'), _vm._v("\n        4."), _c('span', {
    staticClass: "red"
  }, [_vm._v("提示下可以回答出较多测试点")]), _vm._v("，并且可以拓展思维。\n    ")]), _vm._v(" "), _c('td', [_vm._v("\n        1. 薄弱的测试经验（参考：1年-）只能答出较少的测试点。"), _c('br'), _vm._v("\n        2. 思考不是很积极，在提示下也不能发散出更多测试内容。\n    ")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "fb"
  }, [_vm._v("工作态度")]), _vm._v(" "), _c('td', [_vm._v("1. 负责的任务能保质保量的完成"), _c('br'), _vm._v("\n        2. 责任心强，有担当"), _c('br'), _vm._v("\n        3. 加班耐性和稳定性极高"), _c('br'), _vm._v("\n        4. 工作积极性高，不懂的问题会主动学习和解决。"), _c('br'), _vm._v("\n        5. "), _c('span', {
    staticClass: "red"
  }, [_vm._v("有精益求精的精神，对自己要求严格。")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "red"
  }, [_vm._v("6. 可以说出之前工作经历中认真负责的例子。")])]), _vm._v(" "), _c('td', [_vm._v("1. 负责的任务能保质保量的完成"), _c('br'), _vm._v("\n        2. 有责任心"), _c('br'), _vm._v("\n        3. 加班耐性和稳定性极高"), _c('br'), _vm._v("\n        4. 工作积极性高，不懂的问题会主动学习和解决。"), _c('br'), _vm._v("\n        （可以独自承担工作，后续稍作迭代即可）\n    ")]), _vm._v(" "), _c('td', [_vm._v("1. 负责的任务能保质保量的完成"), _c('br'), _vm._v("\n        2. 有责任心"), _c('br'), _vm._v("\n        3. 加班耐性和稳定性高（定义）"), _c('br'), _vm._v("\n        4. 不懂的问题不会问。"), _c('br'), _vm._v("\n        （"), _c('span', {
    staticClass: "red"
  }, [_vm._v("可以较好的完成工作，但需要后期迭代和主管督促")]), _vm._v("）\n    ")]), _vm._v(" "), _c('td', [_vm._v("1. 部分程度完成任务"), _c('br'), _vm._v("\n        2. 加班耐性和稳定性一般\n        （"), _c('span', {
    staticClass: "red"
  }, [_vm._v("工作较为被动")]), _vm._v("，需要经常监督和跟进，工作质量一般，需要迭代数次。）\n    ")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "7"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "fb",
    attrs: {
      "rowspan": "5"
    }
  }, [_vm._v("加分项")]), _vm._v(" "), _c('td', {
    staticClass: "fb"
  }, [_vm._v("游戏经验")]), _vm._v(" "), _c('td', [_vm._v("1. 经验丰富，体验游戏种类多"), _c('br'), _vm._v("\n        2. 重度、高端玩家，熟悉各种系统、玩法和功能"), _c('br'), _vm._v("\n        3. 对游戏和系统的深度理解"), _c('br'), _vm._v("\n        4. "), _c('span', {
    staticClass: "red"
  }, [_vm._v("能提出熟悉游戏的优点，缺点和建议")]), _c('br'), _vm._v("\n        5. 能对玩家的游戏趋势预测"), _c('br'), _vm._v("\n        6. 有组织过战队，担任过队长，公会会长等。\n    ")]), _vm._v(" "), _c('td', [_vm._v("1. 经验丰富，体验游戏种类多"), _c('br'), _vm._v("\n        2. 了解各种系统、玩法和功能"), _c('br'), _vm._v("\n        3. 能说出对游戏和系统的理解"), _c('br'), _vm._v("\n        4. 能提出熟悉游戏的优点，缺点"), _c('br'), _vm._v("\n        5. 对游戏平衡性，和市场发展趋势有理解。\n    ")]), _vm._v(" "), _c('td', [_vm._v("1. 有较多的游戏经验"), _c('br'), _vm._v("\n        2. 知道各种系统、玩法和功能"), _c('br'), _vm._v("\n        3. 对游戏玩法有一定的理解。"), _c('br'), _vm._v("\n        （不能提出有效意见和建议）\n    ")]), _vm._v(" "), _c('td', [_vm._v("1. 平时玩游戏较少"), _c('br'), _vm._v("\n        2. 只针对性的玩简单的游戏"), _c('br'), _vm._v("\n        （听说过一些游戏玩法，但不清楚玩法细节）\n    ")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "fb"
  }, [_vm._v("技术基础")]), _vm._v(" "), _c('td', [_vm._v("1.有较强代码能力，能开发工具，"), _c('br'), _vm._v("\n        2. 技术题目都回答正确，可以独立进行工具开发，多人项目可以承担主要编码工作。"), _c('br'), _vm._v("\n        3. 对游戏制作有一定的基础，知道简单模块的实现思路，"), _c('br'), _vm._v("\n        4. 针对游戏测试自己构思和设计工具。")]), _vm._v(" "), _c('td', [_vm._v("1. 有基本代码能力，了解计算机基础知识，"), _c('br'), _vm._v("\n        2. 技术题目能基本答上。熟悉数据结构，独立进行代码撰写。"), _c('br'), _vm._v("\n        3. 对面试官给出的小工具题目，可以说出自己实现的流程和使用技术。")]), _vm._v(" "), _c('td', [_vm._v("有基本的计算机知识，知道一些逻辑实现。"), _c('br'), _vm._v(" \n        还不能独立进行工具开发工作。")]), _vm._v(" "), _c('td', [_vm._v("完全不了解计算机知识，只能黑盒测试")]), _vm._v(" "), _c('td')])])
}]
var score_tips_2020_social_qa_esExports = { render: score_tips_2020_social_qa_render, staticRenderFns: score_tips_2020_social_qa_staticRenderFns }
/* harmony default export */ var score_tips_2020_social_qa_defaultExport = (score_tips_2020_social_qa_esExports);
// CONCATENATED MODULE: ./src/views/evaluation/score-tips/score-tips-2020-social-qa.vue
var score_tips_2020_social_qa_normalizeComponent = __webpack_require__(1)
/* script */
var score_tips_2020_social_qa___vue_script__ = null
/* template */

/* styles */
var score_tips_2020_social_qa___vue_styles__ = null
/* scopeId */
var score_tips_2020_social_qa___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var score_tips_2020_social_qa___vue_module_identifier__ = null
var score_tips_2020_social_qa_Component = score_tips_2020_social_qa_normalizeComponent(
  score_tips_2020_social_qa___vue_script__,
  score_tips_2020_social_qa_defaultExport,
  score_tips_2020_social_qa___vue_styles__,
  score_tips_2020_social_qa___vue_scopeId__,
  score_tips_2020_social_qa___vue_module_identifier__
)

/* harmony default export */ var score_tips_score_tips_2020_social_qa_defaultExport = (score_tips_2020_social_qa_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/evaluation/score-tips/score-tips.vue








/* harmony default export */ var score_tips_defaultExport = ({
    components: {
        TesterDetail: score_tips_score_tips_tester_defaultExport,
        LangtesterDetail: score_tips_score_tips_langtester_defaultExport,
        DevelopDetail: score_tips_score_tips_develop_defaultExport,
        gzRecruitment2020Detail: function gzRecruitment2020Detail() {
            return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 1038));
        },
        hzRecruitment2020DetailFirst: function hzRecruitment2020DetailFirst() {
            return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 1039));
        },
        hzRecruitment2020DetailSecond: function hzRecruitment2020DetailSecond() {
            return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 1040));
        },
        gzRecruitment2021Detail: function gzRecruitment2021Detail() {
            return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 1041));
        },
        hzRecruitment2021DetailFirst: function hzRecruitment2021DetailFirst() {
            return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 1042));
        },
        hzRecruitment2021DetailSecond: function hzRecruitment2021DetailSecond() {
            return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 1043));
        },
        GametestDetail: function GametestDetail() {
            return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 1044));
        },
        softwaretestdevDeatail: function softwaretestdevDeatail() {
            return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 1045));
        },
        softwaretestDeatail: function softwaretestDeatail() {
            return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 1046));
        },
        hzShRecruitment2022DetailFirst: function hzShRecruitment2022DetailFirst() {
            return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1047));
        },
        hzShRecruitment2022DetailSecond: function hzShRecruitment2022DetailSecond() {
            return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 1048));
        },
        gzGameTest2022Detail: function gzGameTest2022Detail() {
            return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 1049));
        },
        gzSoftWaretest2022Detail: function gzSoftWaretest2022Detail() {
            return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 1050));
        },
        gzSoftWaretestdev2022Detail: function gzSoftWaretestdev2022Detail() {
            return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 1051));
        },

        hzShSoftGametest2022DetailFirst: function hzShSoftGametest2022DetailFirst() {
            return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 1052));
        },
        hzShSoftGametest2022DetailSecond: function hzShSoftGametest2022DetailSecond() {
            return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 1053));
        },
        hzShSoftWaretest2022DetailFirst: function hzShSoftWaretest2022DetailFirst() {
            return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 1054));
        },
        hzShSoftWaretest2022DetailSecond: function hzShSoftWaretest2022DetailSecond() {
            return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 1055));
        },
        hzShSoftGametestdev2022DetailFirst: function hzShSoftGametestdev2022DetailFirst() {
            return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1056));
        },
        hzShSoftGametestdev2022DetailSecond: function hzShSoftGametestdev2022DetailSecond() {
            return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 1057));
        },
        lqa2022DetailFirst: function lqa2022DetailFirst() {
            return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 1058));
        },
        lqa2022DetailSecond: function lqa2022DetailSecond() {
            return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 1059));
        },
        SocialQa: score_tips_score_tips_2020_social_qa_defaultExport,
        VerifyQa: score_tips_score_tips_verify_qa_defaultExport
    },
    computed: {
        queryType: function queryType() {
            return this.$route.query.scoreType || this.type;
        },
        queryTurn: function queryTurn() {
            if (this.$route.meta.template && this.$route.meta.template === 'full') {
                return this.$route.query.turn;
            } else {
                return this.turn;
            }
        }
    },
    props: {
        type: {
            default: '1',
            type: String
        },
        turn: {
            default: '',
            type: String
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f85923c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/evaluation/score-tips/score-tips.vue
var score_tips_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "score-tip-popper"
  }, [_c('table', {
    staticClass: "tips-pop-table",
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0",
      "border": "0"
    }
  }, [_c('div', {
    staticClass: "tip-head"
  }, [_c('thead', [(_vm.queryType === '1' || _vm.queryType === '2' || _vm.queryType === '3' || _vm.queryType === '') ? _c('tr', [_vm._m(0), _c('th', {
    attrs: {
      "width": "130"
    }
  }, [_vm._v("参考问题")]), _c('th', {
    attrs: {
      "width": "240"
    }
  }, [_vm._v("S")]), _c('th', {
    attrs: {
      "width": "150"
    }
  }, [_vm._v("A")]), _c('th', {
    attrs: {
      "width": "150"
    }
  }, [_vm._v("B")]), _c('th', {
    attrs: {
      "width": "150"
    }
  }, [_vm._v("C")]), _c('th', {
    attrs: {
      "width": "100"
    }
  }, [_vm._v("D")]), _c('th', {
    attrs: {
      "width": "41"
    }
  }, [_vm._v("评分")])]) : _vm._e(), _vm._v(" "), (_vm.queryType === '4' || _vm.queryType === '5') ? _c('tr', [_vm._m(1), _c('th', {
    attrs: {
      "width": "130"
    }
  }, [_vm._v("参考问题")]), _vm._m(2), _vm._m(3), _vm._m(4), _vm._m(5), _vm._m(6), _c('th', {
    attrs: {
      "width": "41"
    }
  }, [_vm._v("评分")])]) : _vm._e(), _vm._v(" "), (_vm.queryType === '8') ? _c('tr', [_vm._m(7), _c('th', {
    attrs: {
      "width": "160"
    }
  }, [_vm._v("参考问题")]), _vm._m(8), _vm._m(9), _vm._m(10), _vm._m(11), _vm._m(12), _c('th', {
    attrs: {
      "width": "31"
    }
  }, [_vm._v("评分")])]) : _vm._e(), _vm._v(" "), (_vm.queryType === '7') ? _c('tr', [_vm._m(13), _c('th', {
    attrs: {
      "width": "248"
    }
  }, [_vm._v("S[9,10]")]), _c('th', {
    attrs: {
      "width": "208"
    }
  }, [_vm._v("A[7,9)")]), _c('th', {
    attrs: {
      "width": "187"
    }
  }, [_vm._v("B[4-7)")]), _c('th', {
    attrs: {
      "width": "299"
    }
  }, [_vm._v("C[0-4)")]), _c('th', {
    attrs: {
      "width": "41"
    }
  }, [_vm._v("评分")])]) : _vm._e(), _vm._v(" "), (_vm.queryType === '14') ? _c('tr', [_c('th', {
    attrs: {
      "width": "112"
    }
  }, [_vm._v("考察维度")]), _c('th', {
    attrs: {
      "width": "250"
    }
  }, [_vm._v("考察点")]), _c('th', {
    attrs: {
      "width": "100"
    }
  }, [_vm._v("分数（5分制）")]), _c('th', {
    attrs: {
      "width": "678"
    }
  }, [_vm._v("分数定义")])]) : _vm._e(), _vm._v(" "), (_vm.queryType === '15') ? _c('tr', [_c('th', {
    attrs: {
      "width": "134"
    }
  }, [_vm._v("考察维度")]), _c('th', {
    attrs: {
      "width": "258"
    }
  }, [_vm._v("考察点")]), _c('th', {
    attrs: {
      "width": "100"
    }
  }, [_vm._v("分数（5分制）")]), _c('th', {
    attrs: {
      "width": "678"
    }
  }, [_vm._v("分数定义")])]) : _vm._e(), _vm._v(" "), (_vm.queryType === '16') ? _c('tr', [_c('th', {
    attrs: {
      "width": "114"
    }
  }, [_vm._v("考察维度")]), _c('th', {
    attrs: {
      "width": "250"
    }
  }, [_vm._v("考察点")]), _c('th', {
    attrs: {
      "width": "100"
    }
  }, [_vm._v("分数（5分制）")]), _c('th', {
    attrs: {
      "width": "680"
    }
  }, [_vm._v("分数定义")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tip-body"
  }, [(_vm.queryType === '1' || _vm.queryType === '2' || _vm.queryType === '3' || _vm.queryType === '') ? _c('tester-detail') : (_vm.queryType === '4') ? _c('gzRecruitment2020Detail') : (_vm.queryType === '5' && _vm.queryTurn === '0') ? _c('hzRecruitment2020DetailFirst') : (_vm.queryType === '5' && _vm.queryTurn !== '0') ? _c('hzRecruitment2020DetailSecond') : (_vm.queryType === '9') ? _c('gzRecruitment2021Detail') : (_vm.queryType === '10' && _vm.queryTurn === '0') ? _c('hzRecruitment2021DetailFirst') : (_vm.queryType === '10' && _vm.queryTurn !== '0') ? _c('hzRecruitment2021DetailSecond') : (_vm.queryType === '7') ? _c('social-qa') : (_vm.queryType === '8') ? _c('verify-qa') : (_vm.queryType === '14') ? _c('gametest-detail') : (_vm.queryType === '15') ? _c('softwaretestdev-deatail') : (_vm.queryType === '16') ? _c('softwaretest-deatail') : (_vm.queryType === '17' && _vm.queryTurn === '0') ? _c('hzShRecruitment2022DetailFirst') : (_vm.queryType === '17' && _vm.queryTurn !== '0') ? _c('hzShRecruitment2022DetailSecond') : (_vm.queryType === '18') ? _c('gzGameTest2022Detail') : (_vm.queryType === '19') ? _c('gzSoftWaretest2022Detail') : (_vm.queryType === '20') ? _c('gzSoftWaretestdev2022Detail') : (_vm.queryType === '21' && _vm.queryTurn === '0') ? _c('hzShSoftGametest2022DetailFirst') : (_vm.queryType === '21' && _vm.queryTurn !== '0') ? _c('hzShSoftGametest2022DetailSecond') : (_vm.queryType === '22' && _vm.queryTurn === '0') ? _c('hzShSoftWaretest2022DetailFirst') : (_vm.queryType === '22' && _vm.queryTurn !== '0') ? _c('hzShSoftWaretest2022DetailSecond') : (_vm.queryType === '23' && _vm.queryTurn === '0') ? _c('hzShSoftGametestdev2022DetailFirst') : (_vm.queryType === '23' && _vm.queryTurn !== '0') ? _c('hzShSoftGametestdev2022DetailSecond') : (_vm.queryType === '24' && _vm.queryTurn === '0') ? _c('lqa2022DetailFirst') : (_vm.queryType === '24' && _vm.queryTurn !== '0') ? _c('lqa2022DetailSecond') : _vm._e()], 1)])])
}
var score_tips_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "colspan": "2",
      "width": "91"
    }
  }, [_vm._v("评分参考"), _c('br'), _vm._v("标准：")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "colspan": "2",
      "width": "91"
    }
  }, [_vm._v("评分参考"), _c('br'), _vm._v("标准：")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "width": "240"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("S")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "width": "150"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_vm._v("A")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "width": "150"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("B")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "width": "150"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("C")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "width": "100"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("D")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "colspan": "2",
      "width": "100"
    }
  }, [_vm._v("评分参考"), _c('br'), _vm._v("标准：")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "width": "160"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("S")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "width": "160"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_vm._v("A")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "width": "150"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("B")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "width": "150"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("C")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "width": "150"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("D")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "colspan": "2",
      "width": "91"
    }
  }, [_vm._v("评分参考"), _c('br'), _vm._v("标准：")])
}]
var score_tips_esExports = { render: score_tips_render, staticRenderFns: score_tips_staticRenderFns }
/* harmony default export */ var score_tips_score_tips_defaultExport = (score_tips_esExports);
// CONCATENATED MODULE: ./src/views/evaluation/score-tips/score-tips.vue
function injectStyle (ssrContext) {
  __webpack_require__(856)
}
var score_tips_normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var score_tips___vue_styles__ = injectStyle
/* scopeId */
var score_tips___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var score_tips___vue_module_identifier__ = null
var score_tips_Component = score_tips_normalizeComponent(
  score_tips_defaultExport,
  score_tips_score_tips_defaultExport,
  score_tips___vue_styles__,
  score_tips___vue_scopeId__,
  score_tips___vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (score_tips_Component.exports);


/***/ }),
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/operation/attachViewInList.vue


/* harmony default export */ var attachViewInList_defaultExport = ({
    props: {
        attachList: {
            type: Array,
            default: function _default() {
                return [];
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b06561b"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/operation/attachViewInList.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.attachList.length === 0) ? _c('div', [_vm._v("\n    -\n")]) : _c('div', [(_vm.attachList.length === 1) ? _c('div', [_c('p', [(_vm.attachList[0].preUrl) ? _c('a', {
    staticClass: "attachName",
    attrs: {
      "target": "_blank",
      "href": _vm.attachList[0].preUrl,
      "title": _vm.attachList[0].name
    }
  }, [_vm._v(_vm._s(_vm.attachList[0].name))]) : _c('span', {
    staticClass: "attachName",
    attrs: {
      "title": _vm.attachList[0].name
    }
  }, [_vm._v(_vm._s(_vm.attachList[0].name))]), _vm._v(" "), _c('a', {
    staticClass: "ml-10 mr-10",
    attrs: {
      "href": _vm.attachList[0].downUrl
    }
  }, [_c('i', {
    staticClass: "el-icon-my-daochu"
  })])])]) : _c('div', [_c('el-popover', {
    attrs: {
      "placement": "top",
      "title": "简历附件:",
      "width": "200",
      "trigger": "hover"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "reference",
      "type": "text",
      "size": "small"
    },
    slot: "reference"
  }, [_c('span', {
    staticClass: "attachName"
  }, [_vm._v(_vm._s(_vm.attachList[0].name))]), _c('i', {
    staticClass: "el-icon-my-gengduobiaoqian"
  })]), _vm._v(" "), _vm._l((_vm.attachList), function(item, index) {
    return _c('p', {
      key: index,
      staticStyle: {
        "margin": "10px 0"
      }
    }, [(item.preUrl) ? _c('a', {
      attrs: {
        "target": "_blank",
        "href": item.preUrl
      }
    }, [_vm._v(_vm._s(item.name))]) : _c('span', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('a', {
      staticClass: "ml-10 mr-10",
      attrs: {
        "href": item.downUrl
      }
    }, [_c('i', {
      staticClass: "el-icon-my-daochu"
    })])])
  })], 2)], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var operation_attachViewInList_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/views/operation/attachViewInList.vue
function injectStyle (ssrContext) {
  __webpack_require__(758)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1b06561b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  attachViewInList_defaultExport,
  operation_attachViewInList_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/operation/remarkEditDialog.vue


/* harmony default export */ var remarkEditDialog_defaultExport = ({
    data: function data() {
        return {
            remark: '',
            showDialog: false
        };
    },

    props: {
        id: '',
        value: ''
    },
    watch: {
        value: function value(val) {
            this.remark = val;
        }
    },
    methods: {
        showEditDialog: function showEditDialog() {
            this.remark = this.value;
            this.showDialog = true;
        },
        submitForm: function submitForm() {
            var _this = this;

            this.$axios.post('/desktop/task/updateRemark.api', {
                id: this.id,
                remark: this.remark
            }).then(function (res) {
                _this.$emit('input', _this.remark);
                _this.showDialog = false;
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e954ca0"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/operation/remarkEditDialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', [_c('span', {
    staticClass: "remark-desc",
    attrs: {
      "title": _vm.value
    }
  }, [_vm._v(_vm._s(_vm.value))]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-my-bishi edit-remark-btn",
    on: {
      "click": _vm.showEditDialog
    }
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑备注",
      "visible": _vm.showDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.showDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "form-beauty",
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "备注",
      "prop": "remark"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 500,
      "type": "textarea",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.remark),
      callback: function($$v) {
        _vm.remark = $$v
      },
      expression: "remark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.showDialog = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var operation_remarkEditDialog_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/views/operation/remarkEditDialog.vue
function injectStyle (ssrContext) {
  __webpack_require__(759)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  remarkEditDialog_defaultExport,
  operation_remarkEditDialog_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/common/empty.vue


/* harmony default export */ var empty_defaultExport = ({
    name: 'emptyTip',
    props: {
        show: {
            type: Boolean,
            'default': true
        },
        size: {
            type: String,
            'default': 'normal' }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e33ff2e2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/common/empty.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    class: ['empty-tips', ("empty-tips-" + _vm.size)]
  }, [(_vm.size === 'tiny') ? _c('img', {
    attrs: {
      "src": __webpack_require__(751),
      "alt": "empty"
    }
  }) : _c('img', {
    attrs: {
      "src": __webpack_require__(752),
      "alt": "empty"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._t("default", [_vm._v("亲，该页面暂时没有内容！")])], 2)]) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var common_empty_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/views/common/empty.vue
function injectStyle (ssrContext) {
  __webpack_require__(749)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e33ff2e2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  empty_defaultExport,
  common_empty_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 122 */,
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pattern_js__ = __webpack_require__(71);



/* harmony default export */ __webpack_exports__["a"] = ({
    name: { required: true, message: '请输入', trigger: 'blur' },
    mobilePhone: [{ required: true, message: '请输入', trigger: 'blur' }, { pattern: __WEBPACK_IMPORTED_MODULE_0__pattern_js__["a" /* default */].phone, message: '手机号格式不正确', trigger: 'blur' }],
    email: [{ required: true, message: '请输入', trigger: 'blur' }, { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }],
    gameExperience: { required: true, message: '请输入', trigger: 'blur' },
    maxMajor: { required: true, message: '请输入', trigger: 'blur' },
    maxSchool: { required: true, message: '请输入', trigger: 'blur' },
    maxDegree: { required: true, message: '请选择', trigger: 'change' },
    positionId: { required: true, message: '请选择', trigger: 'change' },
    expectCityId: { required: true, message: '请选择', trigger: 'change' },
    resumeSource: { required: true, message: '请选择', trigger: 'change' },
    gender: { required: true, message: '请选择' },
    acceptRegulate: { required: true, message: '请选择' },
    recommendable: { required: true, message: '请选择' }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/operation/multiRemarkEditDialog.vue


/* harmony default export */ var multiRemarkEditDialog_defaultExport = ({
    data: function data() {
        return {
            showDialog: false,
            preventKey: 1,
            ruleForm: {
                rIds: '',
                remark: ''
            }
        };
    },

    methods: {
        show: function show(data) {
            this.preventKey = +new Date();
            this.ruleForm.rIds = data || '';
            this.ruleForm.remark = '';
            this.showDialog = true;
        },
        submitForm: function submitForm(boolean) {
            var _this = this;

            this.$axios.post('/resume/changeRemark.api', this.ruleForm, { 'X-showMessage': true }).then(function (res) {
                _this.showDialog = false;
                _this.$emit('reload');
            }).catch(console.error);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3fb5a24d"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/operation/multiRemarkEditDialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": "批量编辑备注",
      "visible": _vm.showDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.showDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "form-beauty",
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "备注",
      "prop": "remark"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 500,
      "type": "textarea",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.ruleForm.remark),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "remark", $$v)
      },
      expression: "ruleForm.remark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.showDialog = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var operation_multiRemarkEditDialog_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/views/operation/multiRemarkEditDialog.vue
function injectStyle (ssrContext) {
  __webpack_require__(788)
  __webpack_require__(789)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3fb5a24d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  multiRemarkEditDialog_defaultExport,
  operation_multiRemarkEditDialog_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_tools__ = __webpack_require__(14);




/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        var that = this;
        return {
            startDateOption: {
                disabledDate: function disabledDate(date) {
                    if (that.rangeEndDate === '') {
                        return false;
                    } else {
                        return that.compareDate(date, Object(__WEBPACK_IMPORTED_MODULE_0_modules_tools__["a" /* dateFormat */])(that.rangeEndDate));
                    }
                }
            },
            endDateOption: {
                disabledDate: function disabledDate(date) {
                    if (that.rangeStartDate === '') {
                        return false;
                    } else {
                        return !that.compareDate(date, Object(__WEBPACK_IMPORTED_MODULE_0_modules_tools__["a" /* dateFormat */])(that.rangeStartDate));
                    }
                }
            }
        };
    },


    computed: {
        rangeStartDate: function rangeStartDate() {
            return this.ruleForm.startDate || this.ruleForm.beginTime;
        },
        rangeEndDate: function rangeEndDate() {
            return this.ruleForm.endDate || this.ruleForm.endTime;
        }
    },

    methods: {
        startDateChange: function startDateChange() {
            this.$refs.endDate.$forceUpdate();
        },
        endDateChange: function endDateChange() {
            this.$refs.startDate.$forceUpdate();
        },
        resetTime: function resetTime(date) {
            if (typeof date === 'string') {
                date = new Date(date);
            }
            date.setHours(0);
            date.setMinutes(0);
            date.setSeconds(0);
            date.setMilliseconds(0);
            return date;
        },
        compareDate: function compareDate(date1, date2) {
            if (date1 === '' || date2 === '') {
                return false;
            }
            return this.resetTime(date1).getTime() - this.resetTime(date2).getTime() > 0;
        }
    }
});

/***/ }),
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/banner-arrangement29867c62.jpg";

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pIcon.vue


/* harmony default export */ var pIcon_defaultExport = ({
    name: 'pIcon',
    props: {
        iconName: String,
        icon: String,
        tooltip: String,
        display: String },
    computed: {
        iconClass: function iconClass() {
            if (this.iconName) {
                var iconName = this.iconName;
                return iconName ? 'icon icon-' + iconName : '';
            } else if (this.icon) {
                var _iconName = this.icon;
                return _iconName ? 'el-icon-' + _iconName : '';
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36259975"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pIcon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    style: ({
      display: _vm.display
    })
  }, [(_vm.$slots.default) ? _c('span', {
    staticClass: "icon-text"
  }, [(_vm.tooltip) ? _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.tooltip,
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "mr-5",
    class: [_vm.iconClass, 'pointer']
  })]) : _c('i', {
    staticClass: "mr-5",
    class: _vm.iconClass
  }), _vm._v(" "), _vm._t("default")], 2) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_pIcon_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/components/pIcon.vue
function injectStyle (ssrContext) {
  __webpack_require__(836)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-36259975"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  pIcon_defaultExport,
  components_pIcon_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/vueditor/src/main.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_simditor__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_simditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_simditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_simditor_styles_simditor_css__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_simditor_styles_simditor_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_simditor_styles_simditor_css__);






/* harmony default export */ var main_defaultExport = ({
    name: 'VueEditor',
    props: {
        value: String,
        placeholder: {
            type: String,
            'default': '请输入...'
        },
        options: {
            type: Object,
            'default': function _default() {
                return {
                    toolbarFloat: false,
                    cleanPaste: true
                };
            }
        },
        insertContent: {
            type: String,
            'default': ''
        }
    },
    data: function data() {
        return {
            editor: null,
            lastRange: '',
            status: ''
        };
    },

    watch: {
        insertContent: function insertContent(newValue) {}
    },
    methods: {
        initVueditor: function initVueditor() {
            this.setEditor();
            this.setEditorListener();
        },
        resetContent: function resetContent(content) {
            this.editor.setValue(content);
            this.$emit('input', this.editor.getValue().replace(/font-size: 1px;/ig, ''));
        },
        addAfterCursor: function addAfterCursor(html) {
            var CaretPos = 0,
                ctrl = this.editor.body[0];
            if (this.lastRange && this.value !== '') {
                if (window.Selection) {
                    var sel = window.getSelection();
                    var range = this.lastRange;
                    var el = document.createElement('span');
                    el.innerHTML = html;
                    var frag = document.createDocumentFragment(),
                        node = void 0,
                        lastNode = void 0;
                    while (node = el.firstChild) {
                        lastNode = frag.appendChild(node);
                    }
                    range.insertNode(frag);
                    if (lastNode) {
                        range = range.cloneRange();
                        range.setStartAfter(lastNode);
                        range.collapse(true);
                        sel.removeAllRanges();
                        sel.addRange(range);
                    }
                    this.lastRange = range;
                } else if (document.selection && document.selection.type !== 'Control') {
                    this.lastRange.pasteHTML(html);
                }
            } else {
                this.editor.setValue(this.value + html);
                this.editor.focus();
            }
            this.$emit('input', this.editor.sync().replace(/font-size: 1px;/ig, ''));
        },
        getCursorHandler: function getCursorHandler() {
            var CaretPos = 0,
                ctrl = this.editor.body[0];
            if (window.Selection) {
                var sel = window.getSelection();
                if (sel.getRangeAt && sel.rangeCount) {
                    var range = sel.getRangeAt(0);
                    range.deleteContents();
                    return range;
                }
            } else if (document.selection && document.selection.type !== 'Control') {
                return document.selection.createRange();
            }
            return null;
        },
        setEditor: function setEditor() {
            this.editor = new __WEBPACK_IMPORTED_MODULE_1_simditor___default.a(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
                textarea: this.$refs.editorHolder,
                placeholder: this.placeholder,
                toolbar: ['title', 'bold', 'italic', 'underline', 'strikethrough', 'color', 'ol', 'ul', 'indent', 'outdent', 'alignment']
            }, this.options));

            this.editor.setValue(this.value);
        },
        setEditorListener: function setEditorListener() {
            var _this = this;

            this.editor.on('blur', function () {
                _this.status = 'blur';
                _this.lastRange = _this.getCursorHandler();
            });

            this.editor.on('valuechanged', function (e, src) {
                _this.status = 'valuechanged';
                var val = _this.editor.getValue();
                _this.$emit('input', val ? val.replace(/font-size: 1px;/ig, '') : val);
            });
        }
    },

    mounted: function mounted() {
        this.initVueditor();
    },
    destroy: function destroy() {
        this.editor.destroy();
        this.editor = null;
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4180bf9a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vueditor/src/main.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "simditor-wrapper"
  }, [_c('textarea', {
    ref: "editorHolder",
    attrs: {
      "id": "editor",
      "autofocus": "",
      "maxlength": "5000"
    }
  })])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_main_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/components/vueditor/src/main.vue
function injectStyle (ssrContext) {
  __webpack_require__(845)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  main_defaultExport,
  src_main_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vueditor_src_main_defaultExport = (Component.exports);

// CONCATENATED MODULE: ./src/components/vueditor/index.js




vueditor_src_main_defaultExport.install = function (Vue, options) {
  Vue.component(vueditor_src_main_defaultExport.name, vueditor_src_main_defaultExport);
};

/* harmony default export */ __webpack_exports__["a"] = (vueditor_src_main_defaultExport);

/***/ }),
/* 233 */,
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/operation/addPositionDialog.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mixins_selectMapMixin__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mixins_formCommonMixin__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_modules_pattern__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mixins_dateOptionMixin__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_modules_tools__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_utils__ = __webpack_require__(356);














var Model = {
    id: '',
    name: '',
    workPlace: '',
    sequenceMain: '',
    sequenceSub: '',
    onlineDate: '',
    offlineDate: '',
    recruitCount: '',
    state: '',
    description: '',
    requirement: '',
    cityIds: [],
    property: '',
    advise: '',
    toSupplier: '0',
    showInDesk: '2',
    recommendable: '0',
    linkmanAndSupplier: [],
    mark: '',
    paymentId: '',
    deptCode: '',
    scoreType: '',
    workType: '' };
/* harmony default export */ var addPositionDialog_defaultExport = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_5_mixins_selectMapMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6_mixins_formCommonMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8_mixins_dateOptionMixin__["a" /* default */]],
    data: function data() {
        return {
            urls: {
                add: '/position/insert.api',
                update: '/position/update.api',
                fetch: '/position/selectByKey.api'
            },
            showDialog: false,
            isEdit: false,
            preventKey: 1,
            ruleForm: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, Model, {
                mark: this.$store.state.user.name
            }),
            suppliers: [],
            filterEmpty: false,
            submitDisabled: false,
            rules: {
                name: { required: true, message: '请输入', trigger: 'blur' },
                recruitCount: [{ pattern: /^([1-9]+[0-9]*]*|0)$/, message: '请输入整数', trigger: 'blur' }],
                scoreType: { required: true, message: '请选择', trigger: 'change' },
                description: { required: true, message: '请输入', trigger: 'blur' },
                requirement: { required: true, message: '请输入', trigger: 'blur' },
                mark: { required: true, message: '请输入', trigger: 'blur' },
                workType: { required: true, message: '请输入', trigger: 'blur' },
                cityIds: { type: 'array', required: true, message: '请选择', trigger: 'change' },
                onlineDate: { type: 'date', required: true, message: '请选择', trigger: 'change' },
                offlineDate: { type: 'date', required: true, message: '请选择', trigger: 'change' },
                state: { required: true, message: '请选择', trigger: 'change' },
                deptCode: { required: true, message: '请选择', trigger: 'change' },
                sequenceMain: { required: true, message: '请选择', trigger: 'change' },
                property: { required: true, message: '请选择', trigger: 'change' },
                toSupplier: { required: true, message: '请选择', trigger: 'change' },
                showInDesk: { required: true, message: '请选择', trigger: 'change' },
                paymentId: { required: true, message: '请选择', trigger: 'change' },
                recommendable: { required: true, message: '请选择', trigger: 'change' },
                linkmanAndSupplier: { type: 'array', required: true, message: '请选择', trigger: 'change' },
                sequenceSub: { required: true, message: '请选择', trigger: 'change' },
                workPlace: { required: true, message: '请输入', trigger: 'blur' }
            },
            deptArr: [],
            paymentRuleList: []
        };
    },

    computed: {
        needIds: function needIds() {
            return this.$store.state.needIds.needIds;
        },
        projectId: function projectId() {
            return this.$store.state.user.projectId.toString();
        },
        hasSalary: function hasSalary() {
            return this.$store.state.user.paymentFlag;
        },
        rangeStartDate: function rangeStartDate() {
            return this.ruleForm.onlineDate;
        },
        rangeEndDate: function rangeEndDate() {
            return this.ruleForm.offlineDate;
        },
        mainSeqList: function mainSeqList() {
            return this.selectMap.WB_POSITION_SEQUENCE_JSON || [];
        },
        subSeqList: function subSeqList() {
            var _this = this;

            var mainSeq = this.mainSeqList.find(function (_ref) {
                var value = _ref.value;
                return _this.ruleForm.sequenceMain === value;
            }) || {};
            return mainSeq.list || [];
        }
    },
    watch: {
        'ruleForm.cityIds': function ruleFormCityIds(nV) {
            var _this2 = this;

            if (!nV.length) {
                this.ruleForm.linkmanAndSupplier = [];
            }
            var citys = nV.join(',');
            this.$axios.get('/supplierLinkman/listAllLinkman.api?citys=' + citys).then(function (res) {
                _this2.suppliers = (res.result.list || []).map(function (item) {
                    return {
                        compName: item[0].company,
                        compId: 'sp' + item[0].companyId,
                        users: item.map(function (user) {
                            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, user, { visible: true });
                        }),
                        checkAll: false
                    };
                });
                var list = res.result.list || [];
                var flattenList = list.map(function (section) {
                    return section.map(function (s) {
                        return s.id + '';
                    });
                }).flatten();
                var compList = _this2.suppliers.map(function (s) {
                    return s.compId;
                });
                var checkList = flattenList.concat(compList);

                _this2.ruleForm.linkmanAndSupplier = _this2.ruleForm.linkmanAndSupplier.filter(function (id) {
                    return checkList.includes(id);
                });
            });
        }
    },
    created: function created() {
        var _this3 = this;

        this.hasSalary && this.$axios.get('/payment/template/list.api?state=1&pageSize=100').then(function (res) {
            _this3.paymentRuleList = res.result.list;
        });
    },

    methods: {
        show: function show(data) {
            this.preventKey++;
            this.ruleForm = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, Model, {
                mark: this.$store.state.user.name
            });
            if (data) {
                this.fetchData(data.id);
            }
            this.isEdit = Boolean(data && data.id);
            this.$refs.ruleForm && this.$refs.ruleForm.resetFields();
            this.showDialog = true;
        },
        checkStateOption: function checkStateOption(state) {
            if (this.isEdit === false) {
                return state.value === '0' || state.value === '3';
            } else {
                return true;
            }
        },
        handleOptionChange: function handleOptionChange(ids) {
            var values = ids.slice();

            this.suppliers.forEach(function (item) {
                if (ids.includes(item.compId)) {
                    var userIds = item.users.map(function (u) {
                        return u.id + '';
                    });
                    values = values.filter(function (l) {
                        return !userIds.includes(l);
                    });
                }
            });

            this.ruleForm.linkmanAndSupplier = values;
        },

        selectFilter: Object(__WEBPACK_IMPORTED_MODULE_10_utils__["a" /* debouncing */])(function (keyword) {
            var filterEmpty = true;
            if (keyword) {
                this.suppliers.forEach(function (item) {
                    item.users.forEach(function (user) {
                        user.visible = user.name.includes(keyword) || item.compName.includes(keyword);
                        if (filterEmpty && user.visible) {
                            filterEmpty = false;
                        }
                    });
                });
            } else {
                this.suppliers.forEach(function (item) {
                    item.users.forEach(function (user) {
                        user.visible = true;
                    });
                });
                filterEmpty = false;
            }
            this.filterEmpty = filterEmpty;
        }, 500),
        saveForm: function saveForm(boolean) {
            var _this4 = this;

            var supplierIds = [],
                linkmanIds = [];

            if (this.ruleForm.toSupplier == '1') {
                var allLinkmanList = this.suppliers.map(function (s) {
                    return s.users.map(function (u) {
                        return u.id + '';
                    });
                }).flatten();
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(this.ruleForm.linkmanAndSupplier), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var item = _step.value;

                        if (allLinkmanList.includes(item)) {
                            linkmanIds.push(item);
                        } else if (this.suppliers.map(function (s) {
                            return s.compId;
                        }).includes(item)) {
                            supplierIds.push(item.slice(2));
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }

            var postData = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, this.ruleForm, {
                cityIds: this.ruleForm.cityIds.join(','),
                onlineDate: Object(__WEBPACK_IMPORTED_MODULE_9_modules_tools__["a" /* dateFormat */])(this.ruleForm.onlineDate),
                offlineDate: Object(__WEBPACK_IMPORTED_MODULE_9_modules_tools__["a" /* dateFormat */])(this.ruleForm.offlineDate),
                supplierIds: supplierIds.join(','),
                linkmanIds: linkmanIds.join(',')
            });

            delete postData.linkmanAndSupplier;

            this.submitDisabled = true;
            this.$axios.post(this.ruleForm.id ? this.urls.update : this.urls.add, postData, { 'X-showMessage': true }).then(function (res) {
                _this4.resetForm('ruleForm');
                if (boolean === true) {
                    _this4.showDialog = false;
                }
                _this4.$emit('reload');
                _this4.submitDisabled = false;
            }).catch(function () {
                _this4.submitDisabled = false;
            });
        },
        remoteMethod: function remoteMethod(query) {
            var _this5 = this;

            if (query !== '') {
                this.$axios.get('/system/department/seachDep.api', {
                    params: { name: query }
                }).then(function (res) {
                    _this5.deptArr = res.result.list;
                });
            } else {
                this.deptArr = [];
            }
        },
        fetchData: function fetchData(id) {
            var _this6 = this;

            var params = {
                id: id,
                notShowAllLinkMan: 1
            };
            this.$axios.get(this.urls.fetch, { params: params }).then(function (res) {
                var data = res.result.bean;
                for (var attr in _this6.ruleForm) {
                    if (attr === 'cityIds') {
                        _this6.ruleForm[attr] = data['citys'].map(function (item) {
                            return String(item.id);
                        });
                    } else if (attr === 'linkmanAndSupplier') {
                        var linkmanIds = data.linkmanIds && data.linkmanIds.split(',') || [];
                        var supplierIds = (data.supplierIds && data.supplierIds.split(',') || []).map(function (s) {
                            return 'sp' + s;
                        });
                        _this6.ruleForm[attr] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(linkmanIds.concat(supplierIds)));
                    } else if (attr === 'onlineDate' || attr === 'offlineDate') {
                        _this6.ruleForm[attr] = new Date(data[attr]);
                    } else {
                        _this6.ruleForm[attr] = typeof data[attr] === 'number' ? data[attr] + '' : data[attr];
                    }
                }
                data.deptCode && (_this6.deptArr = [{ deptCode: data.deptCode, name: data.deptNames }]);
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-827b1898"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/operation/addPositionDialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": ((_vm.isEdit ? '编辑':'新建') + "职位"),
      "visible": _vm.showDialog,
      "close-on-click-modal": false,
      "close-on-press-escape": false
    },
    on: {
      "update:visible": function($event) {
        _vm.showDialog = $event
      }
    }
  }, [_c('el-form', {
    key: _vm.preventKey,
    ref: "ruleForm",
    tag: "component",
    staticClass: "form-col",
    staticStyle: {
      "margin-left": "-35px"
    },
    attrs: {
      "rules": _vm.rules,
      "model": _vm.ruleForm,
      "label-width": "140px"
    }
  }, [_c('div', {
    staticClass: "col-2 clearfix"
  }, [_c('el-form-item', {
    attrs: {
      "label": "职位名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 50,
      "disabled": _vm.ruleForm.state == 1,
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.ruleForm.name),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "工作地点",
      "prop": "cityIds"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.ruleForm.cityIds),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "cityIds", $$v)
      },
      expression: "ruleForm.cityIds"
    }
  }, _vm._l((_vm.selectMap.WB_POSITION_CITY), function(item, index) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "办公地点",
      "prop": "workPlace"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 20,
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.ruleForm.workPlace),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "workPlace", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.workPlace"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "岗位序列",
      "prop": "sequenceMain",
      "required": ""
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        _vm.ruleForm.sequenceSub = ''
      }
    },
    model: {
      value: (_vm.ruleForm.sequenceMain),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "sequenceMain", $$v)
      },
      expression: "ruleForm.sequenceMain"
    }
  }, _vm._l((_vm.mainSeqList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "岗位子序列",
      "prop": "sequenceSub",
      "required": ""
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.ruleForm.sequenceSub),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "sequenceSub", $$v)
      },
      expression: "ruleForm.sequenceSub"
    }
  }, _vm._l((_vm.subSeqList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "招聘部门",
      "prop": "deptCode"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "placeholder": "请输入关键词",
      "clearable": true,
      "remote-method": _vm.remoteMethod
    },
    model: {
      value: (_vm.ruleForm.deptCode),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "deptCode", $$v)
      },
      expression: "ruleForm.deptCode"
    }
  }, _vm._l((_vm.deptArr), function(item, index) {
    return _c('el-option', {
      key: item.deptCode,
      attrs: {
        "label": item.name,
        "value": item.deptCode
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.needIds.includes(_vm.projectId)) ? _c('el-form-item', {
    attrs: {
      "label": "评分标准",
      "prop": "scoreType"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "clearable": true
    },
    model: {
      value: (_vm.ruleForm.scoreType),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "scoreType", $$v)
      },
      expression: "ruleForm.scoreType"
    }
  }, _vm._l((_vm.scoreTypeList), function(item, index) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "招聘人数",
      "prop": "recruitCount"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 5,
      "placeholder": "请输入（0或者不填表示不限）"
    },
    model: {
      value: (_vm.ruleForm.recruitCount),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "recruitCount", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.recruitCount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "状态",
      "prop": "state"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "disabled": _vm.isEdit,
      "clearable": true
    },
    model: {
      value: (_vm.ruleForm.state),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "state", $$v)
      },
      expression: "ruleForm.state"
    }
  }, _vm._l((_vm.selectMap.WB_POSITION_STATE), function(state, key) {
    return (_vm.checkStateOption(state)) ? _c('el-option', {
      key: key,
      attrs: {
        "label": state.text,
        "value": state.value
      }
    }) : _vm._e()
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "招聘范围",
      "prop": "property"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "clearable": true
    },
    model: {
      value: (_vm.ruleForm.property),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "property", $$v)
      },
      expression: "ruleForm.property"
    }
  }, _vm._l((_vm.selectMap.WB_PROPERTY_TYPE), function(state, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": state.text,
        "value": state.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否门户展示",
      "prop": "showInDesk"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.ruleForm.showInDesk),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "showInDesk", $$v)
      },
      expression: "ruleForm.showInDesk"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2"
    }
  }, [_vm._v("否")])], 1)], 1), _vm._v(" "), (_vm.hasSalary) ? _c('el-form-item', {
    attrs: {
      "label": "定薪规则",
      "prop": "paymentId"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "clearable": true
    },
    model: {
      value: (_vm.ruleForm.paymentId),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "paymentId", $$v)
      },
      expression: "ruleForm.paymentId"
    }
  }, _vm._l((_vm.paymentRuleList), function(item, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": item.name,
        "value": item.id + ''
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否推送供应商",
      "prop": "toSupplier"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.ruleForm.toSupplier),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "toSupplier", $$v)
      },
      expression: "ruleForm.toSupplier"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    }
  }, [_vm._v("否")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "内推职位",
      "prop": "recommendable"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.ruleForm.recommendable),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "recommendable", $$v)
      },
      expression: "ruleForm.recommendable"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    }
  }, [_vm._v("否")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "招聘HR",
      "prop": "mark"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 50,
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.ruleForm.mark),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "mark", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.mark"
    }
  })], 1), _vm._v(" "), (String(_vm.ruleForm.toSupplier) === '1') ? _c('el-form-item', {
    attrs: {
      "label": "供应商选择",
      "prop": "linkmanAndSupplier",
      "required": ""
    }
  }, [_c('el-select', {
    attrs: {
      "value": _vm.ruleForm.linkmanAndSupplier,
      "filterable": "",
      "multiple": "",
      "placeholder": "请选择",
      "no-data-text": _vm.filterEmpty ? '无匹配数据' : '无数据',
      "clearable": true,
      "filter-method": _vm.selectFilter,
      "popper-class": "supplier-select-popover"
    },
    on: {
      "input": _vm.handleOptionChange
    }
  }, [(!_vm.filterEmpty) ? _vm._l((_vm.suppliers), function(supplier) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (supplier.users.length),
        expression: "supplier.users.length"
      }],
      key: supplier.compId
    }, [(supplier.users.filter(function (u) { return u.visible; }).length) ? _c('el-option', {
      staticClass: "supplier-checkbox",
      attrs: {
        "label": supplier.compName,
        "value": supplier.compId
      }
    }, [_vm._v("\n                                " + _vm._s('所属公司：' + supplier.compName) + "\n                            ")]) : _vm._e(), _vm._v(" "), _vm._l((supplier.users), function(item) {
      return _c('el-option', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (item.visible),
          expression: "item.visible"
        }],
        key: item.id,
        attrs: {
          "label": item.name,
          "disabled": _vm.ruleForm.linkmanAndSupplier.includes(supplier.compId),
          "value": String(item.id)
        }
      }, [_c('span', {
        staticStyle: {
          "float": "left"
        }
      }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
        staticStyle: {
          "float": "right",
          "color": "#8492a6",
          "margin-right": "25px"
        }
      }, [_vm._v(_vm._s(item.company))])])
    })], 2)
  }) : _vm._e()], 2)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "width-longer",
    attrs: {
      "label": "在线时间:",
      "prop": "onlineDate"
    }
  }, [_c('div', {
    staticClass: "f-edit"
  }, [_c('el-date-picker', {
    ref: "startDate",
    attrs: {
      "type": "date",
      "placeholder": "上线时间",
      "editable": false,
      "picker-options": _vm.startDateOption
    },
    on: {
      "change": _vm.startDateChange
    },
    model: {
      value: (_vm.ruleForm.onlineDate),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "onlineDate", $$v)
      },
      expression: "ruleForm.onlineDate"
    }
  }), _vm._v("\n                至\n                "), _c('el-form-item', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "prop": "offlineDate"
    }
  }, [_c('el-date-picker', {
    ref: "endDate",
    attrs: {
      "type": "date",
      "placeholder": "下线时间",
      "editable": false,
      "picker-options": _vm.endDateOption
    },
    on: {
      "change": _vm.endDateChange
    },
    model: {
      value: (_vm.ruleForm.offlineDate),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "offlineDate", $$v)
      },
      expression: "ruleForm.offlineDate"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "工作性质",
      "prop": "workType",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 50,
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.ruleForm.workType),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "workType", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.workType"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "岗位建议方向"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 50,
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.ruleForm.advise),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "advise", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.advise"
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#b1b1b1",
      "font-size": "12px",
      "line-height": "24px"
    }
  }, [_vm._v("若存在多个方向，请用顿号‘、’隔开，例如：‘开发、设计、测试’，若不填写，则面试官填写面试评价时无须选择")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "职位描述",
      "prop": "description"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 3,
        maxRows: 6
      },
      "resize": "none",
      "maxlength": 1000,
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.ruleForm.description),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "description", $$v)
      },
      expression: "ruleForm.description"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "职位要求",
      "prop": "requirement"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 3,
        maxRows: 6
      },
      "resize": "none",
      "maxlength": 1000,
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.ruleForm.requirement),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "requirement", $$v)
      },
      expression: "ruleForm.requirement"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.submitDisabled
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm', true)
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), (!_vm.isEdit) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.submitDisabled
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm', false)
      }
    }
  }, [_vm._v("保存并继续添加")]) : _vm._e()], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var operation_addPositionDialog_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/views/operation/addPositionDialog.vue
function injectStyle (ssrContext) {
  __webpack_require__(944)
  __webpack_require__(946)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  addPositionDialog_defaultExport,
  operation_addPositionDialog_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var views_operation_addPositionDialog_defaultExport = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/position/previewPosition.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mixins_selectMapMixin__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui__);






/* harmony default export */ var previewPosition_defaultExport = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_1_mixins_selectMapMixin__["a" /* default */]],
    data: function data() {
        return {
            configMap: this.$store.state.baseData.selectMap,
            formLabelWidth: '110px',
            hunterList: [],
            paymentRuleList: [],
            baseData: null,
            dialogVisible: false
        };
    },

    computed: {
        hasSalary: function hasSalary() {
            return this.$store.state.user.paymentFlag;
        }
    },
    created: function created() {
        var _this = this;

        this.hasSalary && this.$axios.get('/payment/template/list.api?state=1&pageSize=100').then(function (res) {
            _this.paymentRuleList = res.result.list;
        });
    },

    methods: {
        getHeaderInfos: function getHeaderInfos(ids) {
            var list = [];
            if (ids === '') {
                return list;
            }
            ids = ids.split(',');
            this.hunterList.forEach(function (company) {
                if (company.list) {
                    company.list.forEach(function (user) {
                        if (ids.indexOf(String(user.value)) > -1) {
                            list.push({
                                companyName: company.text,
                                userName: user.text
                            });
                        }
                    });
                }
            });
            return list;
        },
        show: function show(data) {
            this.dialogVisible = true;
            console.log(this.paymentRuleList);
            this.paymentRuleList.forEach(function (item) {
                console.log(item.id === data.paymentId);
                if (item.id === data.paymentId) {
                    data.paymentName = item.name;
                }
            });
            this.baseData = data;
        },
        getSupplierStr: function getSupplierStr(item) {
            if (item.name) {
                return item.companyName + '-' + item.name;
            }

            return item.companyName;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9e24d6de"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/position/previewPosition.vue
var previewPosition_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "preview-dialog",
    attrs: {
      "title": "职位预览",
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [(_vm.baseData) ? _c('el-form', {
    staticClass: "preview-inlineForm",
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "职位名称",
      "label-width": _vm.formLabelWidth
    }
  }, [_vm._v("\n            " + _vm._s(_vm.baseData.name) + "【" + _vm._s(_vm.baseData.code) + "】\n        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "职位状态",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.getSelectMapText('WB_POSITION_STATE', _vm.baseData.state)))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "办公地点",
      "label-width": _vm.formLabelWidth
    }
  }, [_vm._v("\n            " + _vm._s(_vm.baseData.workPlace) + "\n        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "岗位序列",
      "label-width": _vm.formLabelWidth
    }
  }, [_vm._v("\n            " + _vm._s(_vm.getSelectMapText('WB_POSITION_SEQUENCE_ALL', _vm.baseData.sequenceMain)) + "\n        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "岗位子序列",
      "label-width": _vm.formLabelWidth
    }
  }, [_vm._v("\n            " + _vm._s(_vm.getSelectMapText('WB_POSITION_SEQUENCE_ALL', _vm.baseData.sequenceSub)) + "\n        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "发布暂停时间",
      "label-width": _vm.formLabelWidth
    }
  }, [_vm._v("\n            " + _vm._s(_vm.baseData.onlineDate ? _vm.baseData.onlineDate.slice(0, 10) : '无') + "\n            至\n            " + _vm._s(_vm.baseData.offlineDate ? _vm.baseData.offlineDate.slice(0, 10) : '无') + "\n        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "工作地点",
      "label-width": _vm.formLabelWidth
    }
  }, [_vm._v("\n            " + _vm._s(_vm.baseData.cityNames) + "\n        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "招聘人数",
      "label-width": _vm.formLabelWidth
    }
  }, [_vm._v("\n            " + _vm._s(_vm.baseData.recruitCount || '不限') + "\n        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否门户展示",
      "label-width": _vm.formLabelWidth
    }
  }, [_vm._v("\n            " + _vm._s(_vm.baseData.showInDesk == 1 ? '是' : '否') + "\n        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "招聘范围",
      "label-width": _vm.formLabelWidth
    }
  }, [_vm._v("\n            " + _vm._s(_vm.getSelectMapText('WB_PROPERTY_TYPE', _vm.baseData.property)) + "\n        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "工作性质",
      "label-width": _vm.formLabelWidth
    }
  }, [_vm._v("\n            " + _vm._s(_vm.baseData.workType) + "\n        ")]), _vm._v(" "), (_vm.baseData.paymentId && _vm.baseData.paymentState) ? _c('el-form-item', {
    attrs: {
      "label": "定薪规则",
      "label-width": _vm.formLabelWidth
    }
  }, [_vm._v("\n            " + _vm._s(_vm.baseData.paymentName) + "\n        ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.baseData) ? _c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "内推职位",
      "label-width": _vm.formLabelWidth
    }
  }, [_vm._v("\n            " + _vm._s(_vm.getSelectMapText('WB_YES_OR_NO', _vm.baseData.recommendable) || '-') + "\n        ")]), _vm._v(" "), (_vm.baseData.toSupplier) ? _c('el-form-item', {
    attrs: {
      "label": "供应商",
      "label-width": _vm.formLabelWidth
    }
  }, _vm._l((_vm.baseData.linkmanIdList), function(item) {
    return _c('span', {
      key: item.id,
      staticClass: "mr-15"
    }, [_vm._v(_vm._s(_vm.getSupplierStr(item)))])
  }), 0) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "应聘部门",
      "label-width": _vm.formLabelWidth
    }
  }, [_vm._v("\n            " + _vm._s(_vm.baseData.deptNames) + "\n        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "岗位建议方向",
      "label-width": _vm.formLabelWidth
    }
  }, [_vm._v("\n            " + _vm._s(_vm.baseData.advise) + "\n        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "职位职责",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('pre', [_vm._v(_vm._s(_vm.baseData.description))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "要求",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('pre', [_vm._v(_vm._s(_vm.baseData.requirement))])])], 1) : _vm._e()], 1)
}
var previewPosition_staticRenderFns = []
var previewPosition_esExports = { render: previewPosition_render, staticRenderFns: previewPosition_staticRenderFns }
/* harmony default export */ var position_previewPosition_defaultExport = (previewPosition_esExports);
// CONCATENATED MODULE: ./src/views/position/previewPosition.vue
function previewPosition_injectStyle (ssrContext) {
  __webpack_require__(948)
}
var previewPosition_normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var previewPosition___vue_styles__ = previewPosition_injectStyle
/* scopeId */
var previewPosition___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var previewPosition___vue_module_identifier__ = null
var previewPosition_Component = previewPosition_normalizeComponent(
  previewPosition_defaultExport,
  position_previewPosition_defaultExport,
  previewPosition___vue_styles__,
  previewPosition___vue_scopeId__,
  previewPosition___vue_module_identifier__
)

/* harmony default export */ var views_position_previewPosition_defaultExport = (previewPosition_Component.exports);

// CONCATENATED MODULE: ./src/views/position/positionMixin.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__operation_operationMixin_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mixins_selectMapMixin__ = __webpack_require__(4);







/* harmony default export */ __webpack_exports__["a"] = ({
    'mixins': [__WEBPACK_IMPORTED_MODULE_3_mixins_selectMapMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__operation_operationMixin_js__["a" /* default */]],
    components: {
        AddPositionDialog: views_operation_addPositionDialog_defaultExport, PreviewPosition: views_position_previewPosition_defaultExport
    }
});

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            companyList: this.$route.meta.companyList
        };
    },

    methods: {
        getSourceName: function getSourceName(code) {
            var data = this.companyList.filter(function (item) {
                return item.code === code;
            });
            return data.length ? data[0].name : '-';
        }
    }
});

/***/ }),
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
    methods: {
        successLogin: function successLogin(res) {
            var isReload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var routeData = {};

            var _ref = res.result || {},
                _ref$needEditScoreTyp = _ref.needEditScoreTypeIds,
                needEditScoreTypeIds = _ref$needEditScoreTyp === undefined ? [] : _ref$needEditScoreTyp,
                _ref$needEntryWritePr = _ref.needEntryWritePrject,
                needEntryWritePrject = _ref$needEntryWritePr === undefined ? [] : _ref$needEntryWritePr;

            this.$store.commit('APP_IN', res.result.sysConfig);
            this.$store.commit('USER_SIGN_IN', res.result.user);
            this.$store.commit('NEED_IDS', {
                needEditScoreTypeIds: needEditScoreTypeIds,
                needEntryWritePrject: needEntryWritePrject
            });
            if (this.$route.query.from) {
                routeData = { path: this.$route.query.from, force: true };
            } else {
                routeData = { name: this.defaultRoute(res.result.sysConfig.menu), force: true };
            }
            if (isReload && this.$route.name === routeData.name) {
                this.$router.go(0);
                return true;
            }
            this.$router.replace(routeData);
        },
        defaultRoute: function defaultRoute(menu) {
            var name = 'index';
            if (menu.length && menu[0].value !== name) {
                name = menu[0].list[0] && menu[0].list[0].value || menu[0].value;
            }
            return name;
        }
    }
});

/***/ }),
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/inputCustom/src/main.vue


/* harmony default export */ var main_defaultExport = ({
    name: 'InputCustom',
    props: {
        value: [String, Number],
        clearable: { type: Boolean, default: true },
        placeholder: { type: String, default: '请输入' }
    },
    data: function data() {
        return {
            inputValue: this.value
        };
    },

    watch: {
        value: function value(newValue) {
            this.inputValue = newValue;
        },
        inputValue: function inputValue(newValue) {
            this.$emit('input', newValue);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59d42f08"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inputCustom/src/main.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-custom-component",
    class: {
      'has-clear': _vm.clearable
    }
  }, [_c('el-input', {
    attrs: {
      "size": "medium",
      "placeholder": _vm.placeholder
    },
    model: {
      value: (_vm.inputValue),
      callback: function($$v) {
        _vm.inputValue = $$v
      },
      expression: "inputValue"
    }
  }), _vm._v(" "), (_vm.inputValue) ? _c('i', {
    staticClass: "clear-icon el-icon-circle-close",
    on: {
      "click": function($event) {
        _vm.inputValue = ''
      }
    }
  }) : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_main_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/components/inputCustom/src/main.vue
function injectStyle (ssrContext) {
  __webpack_require__(768)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  main_defaultExport,
  src_main_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var inputCustom_src_main_defaultExport = (Component.exports);

// CONCATENATED MODULE: ./src/components/inputCustom/index.js




inputCustom_src_main_defaultExport.install = function (Vue, options) {
  Vue.component(inputCustom_src_main_defaultExport.name, inputCustom_src_main_defaultExport);
};

/* harmony default export */ __webpack_exports__["a"] = (inputCustom_src_main_defaultExport);

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            popoverResult: {
                list: []
            }
        };
    },

    methods: {
        beforeShowPopover: function beforeShowPopover(data) {
            var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/arrangeExam/getPaperScore.api';

            var _this = this;

            var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'id';
            var $event = arguments[3];

            var params = {};
            params[key] = data.id;
            if (this.ajax) {
                this.source.cancel('取消未返回的请求');
            }
            var CancelToken = this.$axios.CancelToken;
            this.source = CancelToken.source();
            this.oneScoreList = [];
            this.$set(data, 'loading', true);
            this.ajax = this.$axios.get(url, {
                params: params,
                cancelToken: this.source.token,
                'X-loadingOff': 'off'
            }).then(function (res) {
                _this.ajax = null;
                _this.popoverResult = res.result;
                _this.showPopover(data, $event);
                _this.$set(data, 'loading', false);
            }).catch(function (err) {
                _this.$set(data, 'loading', false);
            });
        },
        hidePopover: function hidePopover(data) {
            if (this.ajax) {
                this.source.cancel('取消未返回的请求');
            }
            data.isPopoverShow = false;
            this.$nextTick(function () {
                var doms = document.querySelectorAll('.tooltip-status-popover');
                doms.forEach(function (item, index) {
                    item.remove();
                });
            });
            this.$set(data, 'isPopoverShow', false);
        },
        showPopover: function showPopover(data, $event) {
            this.$set(data, 'isPopoverShow', true);
            this.$nextTick(function () {
                var doms = document.querySelectorAll('.tooltip-status-popover');
                doms.forEach(function (item, index) {
                    if (index !== doms.length - 1) item.style.display = 'none';
                });
            });
        }
    }
});

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/operation/addResumeDialog.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mixins_selectMapMixin__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mixins_formCommonMixin__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__resumeDetail_items_attach_vue__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fetchPositionListMixin__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_pattern__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_modules_rules__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mixins_dateOptionMixin__ = __webpack_require__(159);












/* harmony default export */ var addResumeDialog_defaultExport = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_2_mixins_selectMapMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3_mixins_formCommonMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__fetchPositionListMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8_mixins_dateOptionMixin__["a" /* default */]],
    components: {
        AttachView: __WEBPACK_IMPORTED_MODULE_4__resumeDetail_items_attach_vue__["a" /* default */]
    },
    data: function data() {
        var _this = this;

        var validatorattendTimes = function validatorattendTimes(rule, value, callback) {
            if (!_this.ruleForm.beginTime || !_this.ruleForm.endTime) {
                return callback(new Error('请选择'));
            }
            callback();
        };
        __WEBPACK_IMPORTED_MODULE_7_modules_rules__["a" /* default */].attendTimes = { required: true, validator: validatorattendTimes, message: '请选择', trigger: 'change' };
        return {
            urls: {
                add: '/resume/insert.api'
            },
            showDialog: false,
            cacheData: [],
            ruleForm: {
                name: '',
                gender: '',
                email: '',
                mobilePhone: '',
                maxDegree: '',
                acceptRegulate: '',
                maxMajor: '',
                maxSchool: '',
                expectCityId: '',
                positionId: '',
                beginTime: '',
                endTime: '',
                resumeSource: '',
                gameExperience: '',
                residence: ''
            },
            rules: __WEBPACK_IMPORTED_MODULE_7_modules_rules__["a" /* default */]
        };
    },

    methods: {
        show: function show() {
            this.showDialog = true;

            this.fetchPositionList();
        },
        saveForm: function saveForm(boolean) {
            var _this2 = this;

            var attachs = void 0;

            this.$refs.attach.saveData(function (data) {
                var attachArr = data.map(function (item, index) {
                    return {
                        resumeId: item.resumeId,
                        fileId: item.fileId,
                        md5: item.md5
                    };
                });
                attachs = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(attachArr);
            });
            this.$axios.post(this.urls.add, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.ruleForm, {
                attachs: attachs
            }), { 'X-showMessage': true }).then(function (res) {
                _this2.resetForm('ruleForm');
                _this2.cacheData = [];
                if (boolean === true) {
                    _this2.showDialog = false;
                }
                _this2.$emit('reload');
            }).catch(function () {});
        },
        positionIdRemoteMethod: function positionIdRemoteMethod(query) {
            var _this3 = this;

            if (query !== '') {
                this.$axios.get('/position/searchByName.api', {
                    params: { searchWord: query }
                }).then(function (res) {
                    _this3.positionList = res.result.list;
                });
            } else {
                this.positionList = this.allPositionList;
            }
        },
        remoteMethod: function remoteMethod(query, cb) {
            var params = {
                'X-loadingOff': true
            };
            params.queryKey = query;
            if (query !== '') {
                this.$axios.get('/school/search.api', {
                    params: params
                }).then(function (res) {
                    cb(res.result.list.map(function (item) {
                        return {
                            value: item.name
                        };
                    }));
                });
            } else {
                var arr = [];
                cb(arr);
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13f1a478"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/operation/addResumeDialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "新建简历",
      "visible": _vm.showDialog,
      "close-on-click-modal": false,
      "close-on-press-escape": false
    },
    on: {
      "update:visible": function($event) {
        _vm.showDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "form-beauty",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.ruleForm,
      "label-width": "100px"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "medium",
      "maxlength": 50
    },
    model: {
      value: (_vm.ruleForm.name),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "性别",
      "prop": "gender"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.ruleForm.gender),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "gender", $$v)
      },
      expression: "ruleForm.gender"
    }
  }, _vm._l((_vm.selectMap.WB_GENDER), function(item, index) {
    return _c('el-radio', {
      key: item.value,
      attrs: {
        "label": item.value
      }
    }, [_vm._v(_vm._s(item.text) + "\n                        ")])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "手机号",
      "prop": "mobilePhone"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "medium",
      "maxlength": 50
    },
    model: {
      value: (_vm.ruleForm.mobilePhone),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "mobilePhone", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.mobilePhone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "邮箱",
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "medium",
      "maxlength": 50
    },
    model: {
      value: (_vm.ruleForm.email),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "email", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.email"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "最高学历",
      "prop": "maxDegree"
    }
  }, [_c('el-select', {
    attrs: {
      "size": "medium",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.ruleForm.maxDegree),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "maxDegree", $$v)
      },
      expression: "ruleForm.maxDegree"
    }
  }, _vm._l((_vm.selectMap.WB_EDU_DEGREE), function(item, index) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "应聘城市:",
      "prop": "expectCityId"
    }
  }, [_c('el-select', {
    attrs: {
      "size": "medium",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.ruleForm.expectCityId),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "expectCityId", $$v)
      },
      expression: "ruleForm.expectCityId"
    }
  }, _vm._l((_vm.selectMap.WB_POSITION_CITY), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "最高学校",
      "prop": "maxSchool"
    }
  }, [_c('el-autocomplete', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "size": "medium",
      "fetch-suggestions": _vm.remoteMethod,
      "maxlength": 50
    },
    model: {
      value: (_vm.ruleForm.maxSchool),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "maxSchool", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.maxSchool"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "专业",
      "prop": "maxMajor"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "medium",
      "maxlength": 50
    },
    model: {
      value: (_vm.ruleForm.maxMajor),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "maxMajor", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.maxMajor"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    staticClass: "width-longer",
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "label": "就读时间:",
      "prop": "attendTimes"
    }
  }, [_c('el-date-picker', {
    ref: "startDate",
    attrs: {
      "type": "month",
      "placeholder": "开始时间",
      "size": "medium",
      "picker-options": _vm.startDateOption
    },
    on: {
      "change": _vm.startDateChange
    },
    model: {
      value: (_vm.ruleForm.beginTime),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "beginTime", $$v)
      },
      expression: "ruleForm.beginTime"
    }
  }), _vm._v("\n                至\n                "), _c('el-date-picker', {
    ref: "endDate",
    attrs: {
      "type": "month",
      "placeholder": "结束时间",
      "size": "medium",
      "picker-options": _vm.endDateOption
    },
    on: {
      "change": _vm.endDateChange
    },
    model: {
      value: (_vm.ruleForm.endTime),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "endTime", $$v)
      },
      expression: "ruleForm.endTime"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "简历来源",
      "prop": "resumeSource"
    }
  }, [_c('el-select', {
    attrs: {
      "size": "medium",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.ruleForm.resumeSource),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "resumeSource", $$v)
      },
      expression: "ruleForm.resumeSource"
    }
  }, _vm._l((_vm.selectMap.WB_RESUME_SOURCE), function(item, index) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "接受调剂:",
      "prop": "acceptRegulate"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.ruleForm.acceptRegulate),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "acceptRegulate", $$v)
      },
      expression: "ruleForm.acceptRegulate"
    }
  }, _vm._l((_vm.selectMap.WB_ACCEPT_REGULATE), function(item, index) {
    return _c('el-radio', {
      key: item.value,
      attrs: {
        "label": item.value
      }
    }, [_vm._v("\n                            " + _vm._s(item.text) + "\n                        ")])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "应聘职位",
      "prop": "positionId"
    }
  }, [_c('el-select', {
    attrs: {
      "size": "medium",
      "filterable": "",
      "remote": "",
      "placeholder": "请输入关键词",
      "clearable": true,
      "remote-method": _vm.positionIdRemoteMethod
    },
    model: {
      value: (_vm.ruleForm.positionId),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "positionId", $$v)
      },
      expression: "ruleForm.positionId"
    }
  }, _vm._l((_vm.positionList), function(item, index) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "游戏经验",
      "prop": "gameExperience"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 3,
        maxRows: 6
      },
      "resize": "none",
      "maxlength": 1000
    },
    model: {
      value: (_vm.ruleForm.gameExperience),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "gameExperience", $$v)
      },
      expression: "ruleForm.gameExperience"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "当前所在地",
      "prop": "residence"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "medium",
      "maxlength": 50
    },
    model: {
      value: (_vm.ruleForm.residence),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "residence", $$v)
      },
      expression: "ruleForm.residence"
    }
  })], 1), _vm._v(" "), _c('attach-view', {
    ref: "attach",
    attrs: {
      "data": [],
      "rid": "",
      "init": _vm.cacheData,
      "action": ((_vm.$axios.defaults.baseURL) + "/resumeAttach/resumefileInsertNew.api")
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm', true)
      }
    }
  }, [_vm._v("完成")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm', false)
      }
    }
  }, [_vm._v("保存并添加下一位")])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var operation_addResumeDialog_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/views/operation/addResumeDialog.vue
function injectStyle (ssrContext) {
  __webpack_require__(773)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  addResumeDialog_defaultExport,
  operation_addResumeDialog_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var views_operation_addResumeDialog_defaultExport = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/operation/recommendResumeDialog.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fetchPositionListMixin__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jobTransfer__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_userSelect_searchDownList__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mixins_selectMapMixin__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mixins_formCommonMixin__ = __webpack_require__(25);








/* harmony default export */ var recommendResumeDialog_defaultExport = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_0__fetchPositionListMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3_mixins_selectMapMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4_mixins_formCommonMixin__["a" /* default */]],
    extends: __WEBPACK_IMPORTED_MODULE_1__jobTransfer__["a" /* default */],
    watch: {
        'positionList': function positionList(nv, ov) {
            if (this.positionList && this.positionList.length > 0) {
                var idList = this.positionList.map(function (cv) {
                    return cv.value;
                });
                if (!idList.includes(this.ruleForm.positionId)) {
                    this.ruleForm.positionId = '';
                }
            }
        }
    },
    data: function data() {
        return {
            showDialog: false,
            isSingle: true,
            confirmInfo: {
                name: '',
                gender: '',
                phone: '',
                email: '',
                position: ''
            },
            multiConfirmInfo: [],
            preventKey: 1,
            ruleForm: {
                positionId: '',
                evaluator: '',
                ccList: '',
                ids: '',
                reason: '',
                noticeType: '1'
            },
            rules: {
                positionId: { required: true, message: '请选择', trigger: 'change' },
                evaluator: { required: true, message: '请输入搜索', trigger: 'blur,change' },
                reason: { required: true, message: '请输入', trigger: 'blur' }
            }
        };
    },

    methods: {
        show: function show(data) {
            var single = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            this.preventKey = +new Date();
            this.isSingle = single;

            this.fetchPositionList(true);
            if (this.isSingle) {
                this.confirmInfo = {
                    name: data.resumeForm.name,
                    gender: data.resumeForm.gender,
                    phone: data.resumeForm.mobilePhone,
                    email: data.resumeForm.email,
                    position: data.positionForm.name
                };
                this.ruleForm.positionId = data.positionForm.id + '';
                this.ruleForm.ids = data.id;
            } else {
                this.multiConfirmInfo = data;
                this.ruleForm.ids = data.map(function (item) {
                    return item.id;
                }).join(',');
                this.ruleForm.positionId = '';
            }
            this.ruleForm.evaluator = '';
            this.ruleForm.ccList = '';
            this.ruleForm.reason = '';
            this.showDialog = true;
        },
        saveForm: function saveForm(boolean) {
            var _this = this;

            this.$axios.post('/resumePosition/changePosition.api', this.ruleForm, { 'X-showMessage': true }).then(function (res) {
                _this.showDialog = false;
                _this.$emit('reload');
            }).catch(console.error);
        }
    },
    components: {
        UserSearch: __WEBPACK_IMPORTED_MODULE_2_components_userSelect_searchDownList__["a" /* default */]
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9874b1da"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/operation/recommendResumeDialog.vue
var recommendResumeDialog_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "recommend-resume-dialog",
    attrs: {
      "title": "推荐简历",
      "visible": _vm.showDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.showDialog = $event
      }
    }
  }, [_c('div', {
    key: _vm.preventKey + 'a',
    staticClass: "content-confirm border-radius"
  }, [_c('h1', {
    staticClass: "text-center"
  }, [_vm._v("候选人信息")]), _vm._v(" "), (_vm.isSingle) ? _c('el-row', [_c('el-col', [_c('p', [_c('span', [_vm._v("候选人：" + _vm._s(_vm.confirmInfo.name))]), _vm._v(" "), _c('span', {
    staticClass: "ml-20"
  }, [_vm._v("性别：" + _vm._s(_vm.getSelectMapText('WB_GENDER', _vm.confirmInfo.gender) || '-'))]), _vm._v(" "), _c('span', {
    staticClass: "ml-20"
  }, [_vm._v("手机号：" + _vm._s(_vm.confirmInfo.phone))]), _vm._v(" "), _c('span', {
    staticClass: "ml-20"
  }, [_vm._v("邮箱：" + _vm._s(_vm.confirmInfo.email))])]), _vm._v(" "), _c('p', {
    staticClass: "mt-10"
  }, [_vm._v("当前职位：" + _vm._s(_vm.confirmInfo.position))])])], 1) : _c('el-table', {
    attrs: {
      "data": _vm.multiConfirmInfo
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "候选人",
      "prop": "resumeForm.name",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "性别",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm.getSelectMapText('WB_GENDER', scope.row.resumeForm.gender) || '-'))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "手机号",
      "prop": "resumeForm.mobilePhone",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "邮箱",
      "prop": "resumeForm.email",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "当前职位",
      "prop": "positionForm.name",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "recommend-wrap border-radius"
  }, [_c('el-tabs', {
    staticClass: "recommend-tabs",
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.ruleForm.noticeType),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "noticeType", $$v)
      },
      expression: "ruleForm.noticeType"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "邮件",
      "name": "1"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "POPO推送",
      "name": "0"
    }
  })], 1), _vm._v(" "), _c('el-form', {
    key: _vm.preventKey + 'b',
    ref: "ruleForm",
    tag: "component",
    staticClass: "form-beauty",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "推荐职位",
      "prop": _vm.isSingle ? 'positionId' : ''
    }
  }, [_c('transfer-select', {
    attrs: {
      "positionList": _vm.positionList
    },
    model: {
      value: (_vm.ruleForm.positionId),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "positionId", $$v)
      },
      expression: "ruleForm.positionId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "评估人",
      "prop": "evaluator"
    }
  }, [_c('user-search', {
    ref: "evaluator",
    model: {
      value: (_vm.ruleForm.evaluator),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "evaluator", $$v)
      },
      expression: "ruleForm.evaluator"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ruleForm.noticeType === '1'),
      expression: "ruleForm.noticeType === '1'"
    }],
    attrs: {
      "label": "抄送人",
      "prop": "ccs"
    }
  }, [_c('user-search', {
    ref: "ccs",
    model: {
      value: (_vm.ruleForm.ccList),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "ccList", $$v)
      },
      expression: "ruleForm.ccList"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "推荐说明",
      "prop": "reason"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 3,
        maxRows: 6
      },
      "resize": "none"
    },
    model: {
      value: (_vm.ruleForm.reason),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "reason", $$v)
      },
      expression: "ruleForm.reason"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showDialog = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("发送" + _vm._s(_vm.ruleForm.noticeType === '1' ? '邮件' : 'POPO消息'))])], 1)])
}
var recommendResumeDialog_staticRenderFns = []
var recommendResumeDialog_esExports = { render: recommendResumeDialog_render, staticRenderFns: recommendResumeDialog_staticRenderFns }
/* harmony default export */ var operation_recommendResumeDialog_defaultExport = (recommendResumeDialog_esExports);
// CONCATENATED MODULE: ./src/views/operation/recommendResumeDialog.vue
function recommendResumeDialog_injectStyle (ssrContext) {
  __webpack_require__(779)
}
var recommendResumeDialog_normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var recommendResumeDialog___vue_styles__ = recommendResumeDialog_injectStyle
/* scopeId */
var recommendResumeDialog___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var recommendResumeDialog___vue_module_identifier__ = null
var recommendResumeDialog_Component = recommendResumeDialog_normalizeComponent(
  recommendResumeDialog_defaultExport,
  operation_recommendResumeDialog_defaultExport,
  recommendResumeDialog___vue_styles__,
  recommendResumeDialog___vue_scopeId__,
  recommendResumeDialog___vue_module_identifier__
)

/* harmony default export */ var views_operation_recommendResumeDialog_defaultExport = (recommendResumeDialog_Component.exports);

// CONCATENATED MODULE: ./src/views/resume/resumeMixin.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__operation_operationMixin_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__operation_queryListMixin_js__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mixins_selectMapMixin__ = __webpack_require__(4);








/* harmony default export */ __webpack_exports__["a"] = ({
    'mixins': [__WEBPACK_IMPORTED_MODULE_4_mixins_selectMapMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__operation_operationMixin_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__operation_queryListMixin_js__["a" /* default */]],
    components: {
        AddResumeDialog: views_operation_addResumeDialog_defaultExport,
        RecommendResumeDialog: views_operation_recommendResumeDialog_defaultExport
    }
});

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/resumeDetail/items/attach.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_underscore__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qs__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_fileUpload__ = __webpack_require__(89);








var fieldName = 'resumeAttachs';

/* harmony default export */ var attach_defaultExport = ({
    props: {
        init: {
            type: Array,
            required: true
        },
        rid: [Number, String],
        action: {
            type: String,
            default: function _default() {
                return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.baseURL + '/resumeAttach/resumefileInsert.api';
            }
        }
    },
    data: function data() {
        return {
            urls: {
                remove: '/resume/resumeAttach/delete.api'
            },
            ruleForm: {
                attaches: []
            },
            fileList: []
        };
    },

    watch: {
        init: function init(newValue) {
            var _this = this;

            this.ruleForm.attaches = [];
            this.fileList = [];
            newValue.forEach(function (item, index) {
                _this.ruleForm.attaches.push({
                    fileId: item.fileId,
                    md5: item.md5,
                    resumeId: item.resumeId
                });
                _this.fileList.push({
                    name: item.name,
                    fileId: item.fileId,
                    md5: item.md5,
                    status: 'finished',
                    downUrl: item.downUrl,
                    preUrl: item.preUrl
                });
            });
        }
    },
    computed: {
        postData: function postData() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.ruleForm, {
                'resumePositionId': this.$route.params.id
            });
        }
    },
    methods: {
        uploadSuccess: function uploadSuccess(res, file) {
            console.log('attach:', res, file);
        },
        updateData: function updateData() {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.urls.update, this.postData, { 'X-showMessage': true }).then(function (res) {
                _this2.editData();
            });
        },
        removeData: function removeData() {
            var _this3 = this;

            var removeData = __WEBPACK_IMPORTED_MODULE_2_underscore___default.a.pick(this.postData, ['id', 'resumeId', 'resumePositionId']);
            this.$confirm('是否删除该记录?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(_this3.urls.remove, removeData, { 'X-showMessage': true }).then(function (res) {
                    _this3.$emit('remove', removeData, fieldName);
                });
            });
        },
        saveData: function saveData(callback) {
            callback(this.ruleForm.attaches);
        },
        uploadRemove: function uploadRemove(file, fileList) {
            var targetIndex = '',
                fileId = file.response && file.response.result.fileId || file.fileId;
            this.ruleForm.attaches.forEach(function (item, index) {
                if (fileId === item.fileId) {
                    targetIndex = index;
                }
            });
            if (targetIndex !== '' && targetIndex >= 0) {
                this.ruleForm.attaches.splice(targetIndex, 1);
            }
        }
    },
    components: {
        FileUpload: __WEBPACK_IMPORTED_MODULE_4_components_fileUpload__["a" /* default */]
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20e2e18f"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/resumeDetail/items/attach.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "20px 100px"
    }
  }, [_c('file-upload', {
    staticClass: "f-edit",
    attrs: {
      "action": _vm.action,
      "data": {
        resumeId: _vm.rid
      },
      "on-success": _vm.uploadSuccess,
      "on-remove": _vm.uploadRemove,
      "fileList": _vm.fileList
    },
    model: {
      value: (_vm.ruleForm.attaches),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "attaches", $$v)
      },
      expression: "ruleForm.attaches"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("点击上传")])], 1), _vm._v(" "), _c('div', {
    staticClass: "f-view"
  }, [_vm._l((_vm.fileList), function(item, index) {
    return (_vm.fileList.length) ? [_c('p', [(item.preUrl) ? _c('a', {
      attrs: {
        "target": "_blank",
        "href": item.preUrl
      }
    }, [_vm._v(_vm._s(item.name))]) : _c('span', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('a', {
      staticClass: "ml-10 mr-10",
      attrs: {
        "href": item.downUrl
      }
    }, [_c('i', {
      staticClass: "el-icon-my-daochu"
    })])])] : _vm._e()
  })], 2)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var items_attach_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/views/resumeDetail/items/attach.vue
function injectStyle (ssrContext) {
  __webpack_require__(775)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  attach_defaultExport,
  items_attach_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/operation/jobTransfer.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);



/* harmony default export */ var jobTransfer_defaultExport = ({
    components: {
        TransferSelect: {
            props: {
                value: String,
                delivery: Boolean,
                positionList: {
                    type: Array,
                    default: function _default() {
                        return [];
                    }
                }
            },
            methods: {
                handleInput: function handleInput(v) {
                    var _this = this;

                    if (this.value === v) return;
                    this.$confirm('转岗将结束当前应聘流程，并生成新的应聘流程', '是否确认转岗？', {
                        distinguishCancelAndClose: true
                    }).then(function () {
                        _this.$listeners.input instanceof Function && _this.$listeners.input(v);
                        _this.$refs.recommendSelect && _this.$refs.recommendSelect.handleClose();
                    }).catch(function () {});
                }
            },
            computed: {
                selectListeners: function selectListeners() {
                    return this.delivery ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.$listeners, {
                        input: this.handleInput.bind(this)
                    }) : this.$listeners;
                }
            },
            render: function render() {
                var h = arguments[0];

                return h(
                    'el-select',
                    __WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props___default()([{
                        'class': 'recommend-select',
                        attrs: { filterable: true,
                            placeholder: '\u8BF7\u8F93\u5165',
                            value: this.value
                        },
                        ref: 'recommendSelect'
                    }, { attrs: this.$attrs, on: this.selectListeners }]),
                    [(this.positionList || []).map(function (item) {
                        return h(
                            'el-option',
                            {
                                'class': 'recommend-select-option',
                                key: item.value,
                                attrs: { value: item.value,
                                    label: item.text
                                }
                            },
                            [h(
                                'p',
                                { 'class': 'recommend-select-text' },
                                [item.text]
                            ), item.additionData && item.additionData.followUpWorkCode && h('span', ['\u8D1F\u8D23HR\uFF1A', item.additionData.followUpName, '\uFF08', item.additionData.followUpWorkCode, '\uFF09'])]
                        );
                    })]
                );
            }
        }
    }
});
// CONCATENATED MODULE: ./src/views/operation/jobTransfer.vue
function injectStyle (ssrContext) {
  __webpack_require__(781)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */
var __vue_template__ = null
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  jobTransfer_defaultExport,
  __vue_template__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/operation/changePositionDialog.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fetchPositionListMixin__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mixins_formCommonMixin__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__jobTransfer__ = __webpack_require__(336);










/* harmony default export */ var changePositionDialog_defaultExport = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_4__fetchPositionListMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5_mixins_formCommonMixin__["a" /* default */]],
    extends: __WEBPACK_IMPORTED_MODULE_6__jobTransfer__["a" /* default */],
    data: function data() {
        return {
            showDialog: false,
            preventKey: 1,
            ruleForm: {
                positionId: '',
                rpIds: ''
            },
            rules: {
                positionId: { required: true, message: '请选择', trigger: 'change' }
            }
        };
    },

    methods: {
        show: function show(data, list) {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.preventKey = +new Date();
                                _this.ruleForm.rpIds = data || '';
                                _this.ruleForm.positionId = '';
                                _context.next = 5;
                                return _this.fetchPositionList();

                            case 5:
                                _this.initPos(list);
                                _this.showDialog = true;

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        initPos: function initPos(list) {
            var posIds = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(list.map(function (l) {
                return l.positionForm && l.positionForm.id;
            }))));
            var id = posIds.length === 1 && posIds[0] ? posIds[0].toString() : '';
            if (id) {
                var ids = this.positionList.map(function (l) {
                    return l.value;
                });
                this.ruleForm.positionId = ids.includes(id) ? id : '';
            }
        },
        saveForm: function saveForm(boolean) {
            var _this2 = this;

            this.$axios.post('/resume/changeDelivery.api', this.ruleForm, { 'X-showMessage': true }).then(function (res) {
                _this2.showDialog = false;
                _this2.$emit('reload');
            }).catch(console.error);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-de48f3a2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/operation/changePositionDialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "recommend-resume-dialog",
    attrs: {
      "title": "修改职位",
      "visible": _vm.showDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.showDialog = $event
      }
    }
  }, [_c('el-form', {
    key: _vm.preventKey,
    ref: "ruleForm",
    tag: "component",
    staticClass: "form-beauty",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择职位",
      "prop": "positionId"
    }
  }, [_c('transfer-select', {
    attrs: {
      "positionList": _vm.positionList,
      "delivery": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.ruleForm.positionId),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "positionId", $$v)
      },
      expression: "ruleForm.positionId"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showDialog = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("确定")])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var operation_changePositionDialog_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/views/operation/changePositionDialog.vue
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  changePositionDialog_defaultExport,
  operation_changePositionDialog_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/operation/vistorFlowDialog.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);





/* harmony default export */ var vistorFlowDialog_defaultExport = ({
    data: function data() {
        return {
            formLabelWidth: '100px',
            initData: null,
            showDialog: false,
            form: {
                resumePositionId: null,
                id: null,
                areaid: null,
                interviewPlace: '',
                interviewDate: ''
            },
            rules: {}
        };
    },

    methods: {
        baseData: function baseData() {
            return this.$store.state.baseData.selectMap;
        },
        submit: function submit() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/resumePosition/interviewArrange/setGuestSign.api', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.form, {
                interviewDate: this.getDateStr(this.form.interviewDate)
            }), {
                'X-showMessage': true
            }).then(function (res) {
                _this.showDialog = false;
                _this.$emit('reloadList', res);
            }).catch(function () {});
        },
        show: function show(data, initData) {
            this.initData = initData;
            this.form.resumePositionId = data.resumePositionId;
            this.form.id = data.id;
            this.form.interviewPlace = data.interviewPlace;
            this.form.interviewDate = data.interviewDate;
            this.showDialog = true;
        },
        getDateStr: function getDateStr(date) {
            if ((typeof date === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(date)) === 'object') {
                var M = date.getMonth() + 1,
                    d = date.getDate(),
                    h = date.getHours(),
                    m = date.getMinutes(),
                    dateStr = [date.getFullYear(), M < 10 ? '0' + M : M, d < 10 ? '0' + d : d].join('-'),
                    timeStr = [h < 10 ? '0' + h : h, m < 10 ? '0' + m : m].join(':');
                return dateStr + ' ' + timeStr;
            } else {
                return date;
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02358f8a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/operation/vistorFlowDialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "访客申请",
      "visible": _vm.showDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.showDialog = $event
      }
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [(_vm.initData) ? _c('el-form', {
    attrs: {
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "应聘者姓名"
    }
  }, [_vm._v(_vm._s(_vm.initData.resumeForm && _vm.initData.resumeForm.name))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机"
    }
  }, [_vm._v(_vm._s(_vm.initData.resumeForm && _vm.initData.resumeForm.mobilePhone || '-'))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "应聘职位"
    }
  }, [_vm._v(_vm._s(_vm.initData.positionForm && _vm.initData.positionForm.name))])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [(_vm.baseData) ? _c('el-form', {
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择会议室",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请输入关键词"
    },
    model: {
      value: (_vm.form.areaid),
      callback: function($$v) {
        _vm.$set(_vm.form, "areaid", $$v)
      },
      expression: "form.areaid"
    }
  }, _vm._l((_vm.baseData.MEETING_AREA_NAME), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "面试地点",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.form.interviewPlace),
      callback: function($$v) {
        _vm.$set(_vm.form, "interviewPlace", $$v)
      },
      expression: "form.interviewPlace"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "面试时间",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.form.interviewDate),
      callback: function($$v) {
        _vm.$set(_vm.form, "interviewDate", $$v)
      },
      expression: "form.interviewDate"
    }
  })], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确 定")])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var operation_vistorFlowDialog_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/views/operation/vistorFlowDialog.vue
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  vistorFlowDialog_defaultExport,
  operation_vistorFlowDialog_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var views_operation_vistorFlowDialog_defaultExport = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/arrangement/arrangementItem.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_userSelect_searchDownList__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_thumbnail__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_pIcon__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_underscore__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mixins_selectMapMixin__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_modules_tools__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__arrangeCommon__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_dayjs__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_dayjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_dayjs__);














/* harmony default export */ var arrangementItem_defaultExport = ({
    components: {
        UserSearch: __WEBPACK_IMPORTED_MODULE_2_components_userSelect_searchDownList__["a" /* default */], VisitorFlowHandler: views_operation_vistorFlowDialog_defaultExport, PIcon: __WEBPACK_IMPORTED_MODULE_4_components_pIcon__["a" /* default */], Thumbnail: __WEBPACK_IMPORTED_MODULE_3_components_thumbnail__["a" /* default */], ArrangeCommon: __WEBPACK_IMPORTED_MODULE_9__arrangeCommon__["a" /* default */]
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_7_mixins_selectMapMixin__["a" /* default */]],
    props: {
        init: Object,
        isSingle: {
            type: Boolean,
            'default': true
        }
    },
    computed: {
        hasMainInterview: function hasMainInterview() {
            return !this.$store.state.app.isMutilInterview;
        }
    },
    watch: {
        init: function init(value) {
            this.rpId = value.id;
            this.tableData = value.list;
            this.tableData.forEach(function (item, index) {
                item.userSelectIndex = index;
            });
            this.setTurnOptions(value.turnMap);
        }
    },
    created: function created() {
        this.cacheData = {};
        this.setTurnOptions(this.init.turnMap);
        if (this.tableData.length === 0) {
            this.addInterview();
        } else {
            this.tableData.forEach(function (item, index) {
                item.userSelectIndex = index;
            });
        }
    },
    data: function data() {
        return {
            tableData: this.init.list || [],
            rpId: this.init.id,
            checked: false,
            turnMap: {},
            turnOptions: [],
            interviewObject: {
                interviewDate: '',
                turnType: '',
                interviewType: null,
                interviewer: '',
                masterInterviewer: '',
                isHr: '',
                id: null,
                interviewPlace: ''
            },
            form: {
                interviewDate: '',
                interviewType: '',
                turn: '',
                turnName: '',
                isHr: '',
                turnType: '',
                interviewer: '',
                interviewerNames: '',
                masterInterviewer: '',
                masterInterviewerNames: '',
                userSelectIndex: null,
                id: null,
                interviewPlace: '',
                conferenceLinks: ''
            }
        };
    },

    methods: {
        selectedRow: function selectedRow(row) {
            !row.isEdit && this.$refs.table.toggleRowSelection(row);
        },
        updateColData: function updateColData(rows, attr, value, names) {
            var _this = this;

            rows.forEach(function (item, index) {
                if (item.id === null || item.hasEvl === false) {
                    if (!item.isEdit) {
                        _this.toggleEdit(item, index);
                    }
                    _this.$nextTick(function () {
                        if (attr === 'masterInterviewer') {
                            var userIndex = item.userSelectIndex === undefined ? index : item.userSelectIndex;
                            _this.$refs['masterInterviewer' + userIndex].setDefaultValueLater(value, names);
                        } else {
                            _this.$set(item, attr, value);
                        }
                    });
                }
            });
        },
        toggleAllSelect: function toggleAllSelect(isSelect) {
            var _this2 = this;

            var checkedPhase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

            this.tableData.forEach(function (item) {
                if (checkedPhase.length) {
                    _this2.$refs.table.toggleRowSelection(item, checkedPhase.indexOf(item.turnType.split(',')[0]) > -1);
                } else {
                    _this2.$refs.table.toggleRowSelection(item, isSelect);
                }
            });
        },
        removeInterview: function removeInterview() {
            var ids = this.$route.params.ids.split(',');
            var index = ids.indexOf(this.rpId + '');
            ids.splice(index, 1);
            this.$router.replace({
                name: 'multiArrangement',
                params: { ids: ids.length ? ids.join(',') : -1 }
            });
        },
        setInterviewsValue: function setInterviewsValue(data) {
            if (this.hasMainInterview) {
                var ids = data.interviewer.split(',');
                var index = ids.indexOf(data.masterInterviewer);
                if (ids.length && index > -1) {
                    ids.splice(index, 1);
                    data.interviewer = ids.join(',');
                }
            }
        },
        handleChangeInterviewType: function handleChangeInterviewType(newVal, index) {
            var oldVal = this.tableData[index].interviewType;

            if (newVal !== '5' && oldVal === '5') {
                this.tableData[index].conferenceLinks = '';
            }

            this.tableData[index].interviewType = newVal;
        },
        addInterview: function addInterview() {
            var index = this.tableData.length;
            if (index === 4) {
                return false;
            }
            this.tableData.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
                resumePositionId: this.rpId
            }, this.interviewObject, {
                userSelectIndex: index
            }));
            this.$set(this.tableData[index], 'isEdit', true);
            return this.tableData[index];
        },
        toggleEdit: function toggleEdit(item, index) {
            this.$set(item, 'isEdit', !item.isEdit);
            if (item.isEdit) {
                this.$nextTick(function () {
                    var userIndex = item.userSelectIndex === undefined ? index : item.userSelectIndex;
                    this.$refs['masterInterviewer' + userIndex].setDefaultValueLater(String(item.masterInterviewer), item.masterInterviewerNames);
                    var interviewers = item.interviewer.split(','),
                        names = item.interviewerNames.split('，');
                    if (item.interviewer) {
                        console.log(1223423, item.interviewer, interviewers, names);
                        this.$refs.interviewer.setDefaultValueLater(interviewers, names);
                    }
                });
                this.cacheData[index] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);
            } else {
                if (item.id) {
                    this.setFormData(item, this.cacheData[index]);
                    delete this.cacheData[index];
                    item = null;
                } else {
                    this.tableData.splice(index, 1);
                }
            }
        },
        setFormData: function setFormData(item, data) {
            for (var key in this.form) {
                this.$set(item, key, data[key]);
            }
            this.form.interviewDate = data.interviewDate ? this.getDateObj(data.interviewDate) : '';
            var newTurnType = [data.turn, data.isHr].join(',');
            this.$set(item, 'turnType', newTurnType);
            this.form.turnType = newTurnType;
        },
        getFormData: function getFormData(item) {
            var obj = {};
            for (var key in this.form) {
                obj[key] = item[key];
            }
            if (obj.turnType) {
                obj.turn = obj.turnType.split(',')[0];
                obj.isHr = obj.turnType.split(',')[1];
            }
            return obj;
        },
        removeRow: function removeRow(item, pIndex) {
            var that = this;
            if (item.id) {
                this.$confirm('确定删除该面试安排?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/resumePosition/interviewArrange/delete.api', {
                        resumePositionId: item.resumePositionId,
                        id: item.id
                    }, { 'X-showMessage': true }).then(function (res) {
                        that.tableData.splice(pIndex, 1);
                    });
                }).catch(function () {});
            }
        },
        getSelected: function getSelected() {
            return this.$refs.table.store.states.selection;
        },
        sendEmail: function sendEmail(type) {
            var data = this.getSelected();
            if (data.length === 0) {
                this.$message({
                    message: '请勾选面试阶段',
                    type: 'warning'
                });
                return false;
            }
            this.$emit('sendEmail', data, type);
        },
        checkData: function checkData(item, curIndex) {
            var tips = '';
            if (item.turnType == null || item.turnType === '') {
                tips = '面试阶段必填';
            } else if (item.interviewDate == null || item.interviewDate === '') {
                tips = '面试时间必填';
            } else if (item.interviewType === '5' && __WEBPACK_IMPORTED_MODULE_10_dayjs___default()(item.interviewDate).isBefore(__WEBPACK_IMPORTED_MODULE_10_dayjs___default()(), 'minute')) {
                tips = '面试时间不可小于当前时间';
            } else if (item.interviewType == null || item.interviewType === '') {
                tips = '面试形式必填';
            } else if (item.interviewPlace == null || item.interviewPlace === '') {
                tips = '面试地点必填';
            } else if (item.conferenceLinks && !/^https?:\/\//.test(item.conferenceLinks)) {
                tips = '会议链接仅允许输入网址';
            }
            if (this.hasMainInterview) {
                if (item.masterInterviewer == null || item.masterInterviewer === '') {
                    tips = '面试官必填';
                }
            } else {
                if (item.interviewer == null || item.interviewer === '') {
                    tips = '面试官必填';
                }
            }

            if (tips.length) {
                this.$message({
                    message: tips,
                    type: 'warning'
                });
                return false;
            } else {
                return true;
            }
        },
        collectionsSelectedData: function collectionsSelectedData() {
            var _this3 = this;

            var params = [];
            var hasError = false;
            this.getSelected().forEach(function (item, index) {
                if (item.hasEvl !== true) {
                    var param = _this3.collectionsRowData(item, index);
                    param ? params = params.concat(param) : hasError = true;
                }
            });
            return hasError ? false : params;
        },
        collectionsRowData: function collectionsRowData(item, index) {
            var params = this.getFormData(item);
            if (this.checkData(params, index) === false) {
                return false;
            }
            var that = this;
            params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, params, {
                interviewDate: this.dateFormat(params.interviewDate),
                resumePositionId: this.rpId,
                turn: item.turnType.split(',')[0],
                isHr: item.turnType.split(',')[1]
            });
            return params;
        },
        onSubmit: function onSubmit(item, index) {
            var _this4 = this;

            var params = this.collectionsRowData(item, index);
            var that = this;
            params && __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/resumePosition/interviewArrange/save.api', params, { 'X-showMessage': true }).then(function (res) {
                var item = res.result.bean;
                _this4.$set(that.tableData[index], 'isEdit', !that.tableData[index].isEdit);
                that.setFormData(that.tableData[index], item);
                _this4.sortByTurn();
                that.$forceUpdate();
            }).catch(function () {});
        },
        sortByTurn: function sortByTurn() {
            this.tableData = __WEBPACK_IMPORTED_MODULE_6_underscore___default.a.sortBy(this.tableData, function (item) {
                return item.turn;
            });
        },
        dateFormat: function dateFormat(date) {
            var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'yyyy-MM-dd hh:mm';

            return Object(__WEBPACK_IMPORTED_MODULE_8_modules_tools__["a" /* dateFormat */])(date, format);
        },
        getDateObj: function getDateObj(dateStr) {
            if (typeof dateStr === 'string') {
                dateStr = dateStr.slice(0, 10);
                var date = new Date();
                date.setHours(0);
                date.setMinutes(0);
                date.setSeconds(0);
                var arr = dateStr.split('-');
                date.setFullYear(Number(arr[0]));
                date.setMonth(Number(arr[1]) - 1);
                date.setDate(Number(arr[2]));
                return date;
            } else {
                return dateStr;
            }
        },
        showVisitorFlow: function showVisitorFlow(item) {
            this.$refs.visitorFlow.show(item, this.init);
        },
        setTurnOptions: function setTurnOptions(turnMap) {
            var turnOptions = [];
            for (var turn in turnMap) {
                turnOptions.push({
                    label: turnMap[turn],
                    value: [turn, '0'].join(',')
                });
                turnOptions.push({
                    label: turnMap[turn] + '（HR面）',
                    value: [turn, '1'].join(',')
                });
            }
            this.turnMap = turnMap;
            this.turnOptions = turnOptions;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50e1c0c2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/arrangement/arrangementItem.vue
var arrangementItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.selectMap) ? _c('div', {
    staticClass: "scope-arrangement-item"
  }, [(_vm.isSingle) ? _c('el-row', {
    staticClass: "top-handler-wpr"
  }, [_c('el-col', [(this.tableData.length < 4) ? _c('el-button', {
    attrs: {
      "icon": "el-icon-plus",
      "type": "primary"
    },
    on: {
      "click": _vm.addInterview
    }
  }, [_vm._v("添加面试\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('arrange-common', {
    on: {
      "sendEmail": _vm.sendEmail
    }
  })], 1)], 1)], 1) : _c('el-row', {
    staticClass: "top-handler-wpr mb-20",
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    staticClass: "name user-name",
    attrs: {
      "span": 19
    }
  }, [_c('thumbnail', {
    attrs: {
      "width": 36,
      "gender": _vm.init.resume.gender === 2 ? 'woman' : 'man',
      "mode": "horizontal"
    }
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "color": "#000"
    },
    domProps: {
      "textContent": _vm._s(_vm.init.resume.name)
    }
  })])]), _vm._v(" "), _c('PIcon', {
    staticClass: "dept-name multi-info",
    attrs: {
      "tooltip": "应聘部门",
      "display": "inline-block",
      "icon": "el-icon-my-xiugaibumen"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.init.position.deptNames) + "\n            ")]), _vm._v(" "), _c('PIcon', {
    staticClass: "dept-name multi-info",
    attrs: {
      "tooltip": "应聘职位",
      "display": "inline-block",
      "icon": "el-icon-my-gongzuojingli"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.init.position.name) + "\n            ")]), _vm._v(" "), _c('PIcon', {
    staticClass: "dept-name multi-info",
    attrs: {
      "tooltip": "联系方式",
      "display": "inline-block",
      "icon": "el-icon-my-shouji"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.init.resume.mobilePhone || '无') + "\n            ")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 5
    }
  }, [(this.tableData.length < 4) ? _c('el-button', {
    attrs: {
      "icon": "el-icon-plus",
      "type": "primary"
    },
    on: {
      "click": _vm.addInterview
    }
  }, [_vm._v("添加面试\n            ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": true
    },
    on: {
      "click": _vm.removeInterview
    }
  }, [_vm._v("移除")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-list mt-10"
  }, [_c('el-table', {
    ref: "table",
    class: {
      'multi': !_vm.isSingle
    },
    attrs: {
      "data": _vm.tableData,
      "row-class-name": "interview-one"
    },
    on: {
      "row-click": _vm.selectedRow
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "type": "selection",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "面试阶段",
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isEdit) ? _c('div', [_c('el-select', {
          attrs: {
            "size": "medium",
            "placeholder": "请选择"
          },
          model: {
            value: (scope.row.turnType),
            callback: function($$v) {
              _vm.$set(scope.row, "turnType", $$v)
            },
            expression: "scope.row.turnType"
          }
        }, _vm._l((_vm.turnOptions), function(item, index) {
          return _c('el-option', {
            key: index,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1) : [_c('span', [_vm._v(_vm._s(_vm.turnMap[scope.row.turn]) + "\n                        "), (~~scope.row.isHr) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("HR面")]) : _vm._e()], 1)]]
      }
    }], null, false, 1957778102)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "面试时间",
      "align": "center",
      "min-width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isEdit) ? _c('div', [_c('el-date-picker', {
          staticClass: "el-input--noprefix",
          attrs: {
            "size": "medium",
            "prefix-icon": " ",
            "format": "yyyy-MM-dd HH:mm",
            "type": "datetime",
            "placeholder": "选择日期时间"
          },
          model: {
            value: (scope.row.interviewDate),
            callback: function($$v) {
              _vm.$set(scope.row, "interviewDate", $$v)
            },
            expression: "scope.row.interviewDate"
          }
        })], 1) : _c('div', [_c('span', {
          staticClass: "ml-5"
        }, [_vm._v(_vm._s(_vm.dateFormat(scope.row.interviewDate)))])])]
      }
    }], null, false, 1027157844)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "面试形式",
      "align": "center",
      "min-width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isEdit) ? _c('div', [_c('el-select', {
          attrs: {
            "size": "medium",
            "value": scope.row.interviewType,
            "placeholder": "请选择"
          },
          on: {
            "input": function($event) {
              return _vm.handleChangeInterviewType($event, scope.$index)
            }
          }
        }, _vm._l((_vm.selectMap.WB_INTERVIEW_TYPE), function(item, index) {
          return _c('el-option', {
            key: index,
            attrs: {
              "label": item.text,
              "value": item.value
            }
          })
        }), 1)], 1) : _c('div', [_c('span', [_vm._v(_vm._s(_vm.getSelectMapText('WB_INTERVIEW_TYPE', scope.row.interviewType)))])])]
      }
    }], null, false, 4164630613)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "面试官",
      "align": "center",
      "min-width": "280"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isEdit) ? _c('div', [_c('user-search', {
          ref: ("masterInterviewer" + (scope.$index)),
          staticStyle: {
            "width": "95%",
            "display": "inline-block"
          },
          attrs: {
            "index": scope.$index,
            "holder": "面试官"
          },
          model: {
            value: (scope.row.masterInterviewer),
            callback: function($$v) {
              _vm.$set(scope.row, "masterInterviewer", $$v)
            },
            expression: "scope.row.masterInterviewer"
          }
        }), _vm._v(" "), _c('user-search', {
          ref: "interviewer",
          staticStyle: {
            "width": "50%",
            "display": "none"
          },
          attrs: {
            "index": scope.$index,
            "holder": "副面试官"
          },
          model: {
            value: (scope.row.interviewer),
            callback: function($$v) {
              _vm.$set(scope.row, "interviewer", $$v)
            },
            expression: "scope.row.interviewer"
          }
        })], 1) : [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('span', [_c('span', {
          staticClass: "mr-15"
        }, [_vm._v(_vm._s(scope.row.masterInterviewerNames))])])])]]
      }
    }], null, false, 1679468098)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "面试地点",
      "align": "center",
      "min-width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isEdit) ? _c('div', {
          staticClass: "text-ellipsis"
        }, [_c('el-input', {
          attrs: {
            "size": "medium",
            "placeholder": "请输入内容"
          },
          model: {
            value: (scope.row.interviewPlace),
            callback: function($$v) {
              _vm.$set(scope.row, "interviewPlace", $$v)
            },
            expression: "scope.row.interviewPlace"
          }
        })], 1) : _c('div', {
          staticClass: "text-ellipsis"
        }, [_c('span', [_vm._v(_vm._s(scope.row.interviewPlace))])])]
      }
    }], null, false, 605741618)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "会议链接",
      "align": "center",
      "min-width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isEdit) ? _c('div', {
          staticClass: "text-ellipsis"
        }, [(scope.row.interviewType === '5') ? _c('span', {
          staticStyle: {
            "font-size": "12px",
            "color": "#c4c4c4"
          }
        }, [_vm._v("安排后自动生成")]) : _c('el-input', {
          attrs: {
            "size": "medium",
            "placeholder": "请输入",
            "maxlength": "1000"
          },
          model: {
            value: (scope.row.conferenceLinks),
            callback: function($$v) {
              _vm.$set(scope.row, "conferenceLinks", $$v)
            },
            expression: "scope.row.conferenceLinks"
          }
        })], 1) : _c('div', {
          staticClass: "text-ellipsis"
        }, [(scope.row.interviewType === '5') ? _c('a', {
          attrs: {
            "href": scope.row.conferenceLinks,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(scope.row.conferenceLinks))]) : _c('span', [_vm._v(_vm._s(scope.row.conferenceLinks || ''))])])]
      }
    }], null, false, 364412834)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "min-width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isEdit) ? _c('div', [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.onSubmit(scope.row, scope.$index)
            }
          }
        }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.toggleEdit(scope.row, scope.$index)
            }
          }
        }, [_c('span', {
          staticClass: "color-danger"
        }, [_vm._v("取消")])])], 1) : _c('div', [(scope.row.id) ? _c('el-button', {
          staticClass: "hide",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.showVisitorFlow(scope.row)
            }
          }
        }, [_vm._v("发起访客申请\n                        ")]) : _vm._e(), _vm._v(" "), (scope.row.id && scope.row.hasEvl !== true) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.toggleEdit(scope.row, scope.$index)
            }
          }
        }, [_vm._v("编辑\n                        ")]) : _vm._e(), _vm._v(" "), (scope.row.id && scope.row.hasEvl !== true) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.removeRow(scope.row, scope.$index)
            }
          }
        }, [_c('span', {
          staticClass: "color-danger"
        }, [_vm._v("删除")])]) : _vm._e(), _vm._v(" "), (scope.row.hasEvl) ? _c('span', {
          staticStyle: {
            "font-size": "12px",
            "color": "#c4c4c4"
          }
        }, [_vm._v("已评价不可操作")]) : _vm._e()], 1)]
      }
    }], null, false, 88713239)
  })], 1)], 1), _vm._v(" "), _c('visitor-flow-handler', {
    ref: "visitorFlow"
  })], 1) : _vm._e()
}
var arrangementItem_staticRenderFns = []
var arrangementItem_esExports = { render: arrangementItem_render, staticRenderFns: arrangementItem_staticRenderFns }
/* harmony default export */ var arrangement_arrangementItem_defaultExport = (arrangementItem_esExports);
// CONCATENATED MODULE: ./src/views/arrangement/arrangementItem.vue
function injectStyle (ssrContext) {
  __webpack_require__(834)
}
var arrangementItem_normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var arrangementItem___vue_styles__ = injectStyle
/* scopeId */
var arrangementItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var arrangementItem___vue_module_identifier__ = null
var arrangementItem_Component = arrangementItem_normalizeComponent(
  arrangementItem_defaultExport,
  arrangement_arrangementItem_defaultExport,
  arrangementItem___vue_styles__,
  arrangementItem___vue_scopeId__,
  arrangementItem___vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (arrangementItem_Component.exports);


/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/arrangement/arrangeCommon.vue


/* harmony default export */ var arrangeCommon_defaultExport = ({
    data: function data() {
        return {};
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-268a567c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/arrangement/arrangeCommon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "button-inline"
  }, [_c('el-button', {
    attrs: {
      "type": "success",
      "plain": true,
      "icon": "el-icon-my-youjian color-success"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('sendEmail', 4)
      }
    }
  }, [_vm._v("\n        通知供应商\n    ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": true,
      "icon": "el-icon-my-youjian color-primary"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('sendEmail', 1)
      }
    }
  }, [_vm._v("\n        通知应聘者\n    ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "warning",
      "plain": true,
      "icon": "el-icon-my-youjian color-warning"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('sendEmail', 2)
      }
    }
  }, [_vm._v("\n        通知面试官\n    ")])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var arrangement_arrangeCommon_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/views/arrangement/arrangeCommon.vue
function injectStyle (ssrContext) {
  __webpack_require__(839)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-268a567c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  arrangeCommon_defaultExport,
  arrangement_arrangeCommon_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 352 */,
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/operation/interviewerEmailDialog.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_userSelect_searchDownList__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_userSelect_userSelect__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_fileUpload__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_tools__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_underscore__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_vueditor__ = __webpack_require__(232);












/* harmony default export */ var interviewerEmailDialog_defaultExport = ({
    components: {
        Vueditor: __WEBPACK_IMPORTED_MODULE_8_components_vueditor__["a" /* default */], UserSearch: __WEBPACK_IMPORTED_MODULE_2_components_userSelect_searchDownList__["a" /* default */], FileUpload: __WEBPACK_IMPORTED_MODULE_4_components_fileUpload__["a" /* default */], UserGroup: __WEBPACK_IMPORTED_MODULE_3_components_userSelect_userSelect__["a" /* default */]
    },
    data: function data() {
        return {
            dialogFormVisible: false,
            renderKey: 1,
            ccUsers: [],
            params: null,
            isPreview: false,
            showInterviewPhase: true,
            checkAllParse: true,
            interviewArrangeForms: [],
            filterIntViewArrIds: [],
            interviewerUsers: [],
            allInterviewsIds: [],
            supplierList: [],
            isIndeterminate: false,
            form: {
                name: '',
                sendEmail: '',
                ccList: '',
                delivery: false,
                mailAttachInfos: [],
                hrAttachIds: [],
                content: '',
                contentCode: ''
            },
            fileList: [],
            selectTpl: '',
            baseData: null,
            formLabelWidth: '120px',
            uploadData: {
                code: '',
                fileType: 'upload'
            }
        };
    },

    methods: {
        updateData: function updateData(data) {
            this.form.contentCode = data;
        },
        handleCheckAllChange: function handleCheckAllChange(val) {
            this.filterIntViewArrIds = val ? this.allInterviewsIds : [];
            this.isIndeterminate = false;
        },
        handleCheckedPharseChange: function handleCheckedPharseChange(value) {
            var checkedCount = value.length;
            this.checkAllParse = checkedCount === this.interviewArrangeForms.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.interviewArrangeForms.length;
        },
        selectedTpl: function selectedTpl(id) {
            var data = void 0;
            if (__WEBPACK_IMPORTED_MODULE_7_underscore___default.a.isObject(id)) {
                data = id;
            } else {
                data = this.baseData.list.filter(function (item) {
                    return item.id === id;
                })[0];
            }
            if (data) {
                __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.form, data, {
                    name: data.title,
                    contentCode: data.content,
                    hrAttachIds: data.hrattachids === '' ? [] : data.hrattachids.split(',')
                });
                this.$refs.editor && this.$refs.editor.resetContent(data.content);
            }
        },
        toEditView: function toEditView() {
            this.isPreview = false;
        },
        initDataBeforeShow: function initDataBeforeShow(params) {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post('/resumePosition/mailSend/mailList.api', params).then(function (res) {
                _this.baseData = res.result;
                _this.baseData.resumePositionList = params.resumePositionList;
                _this.interviewArrangeForms = params.selecteds;
                var ids = [],
                    interviewUsers = [],
                    paramsInterviewIds = _this.params.interviewIds ? _this.params.interviewIds.split(',') : [];
                _this.interviewArrangeForms.forEach(function (item) {
                    ids.push(item.id);
                    interviewUsers = interviewUsers.concat(item.interviewerUsers);
                });
                interviewUsers = __WEBPACK_IMPORTED_MODULE_7_underscore___default.a.uniq(interviewUsers, function (item) {
                    return item.id;
                });
                _this.filterIntViewArrIds = ids;
                _this.allInterviewsIds = ids;
                _this.checkAllParse = true;
                _this.isIndeterminate = false;
                if (_this.isForInterviewers) {
                    _this.interviewerUsers = interviewUsers;
                    _this.form.sendEmail = __WEBPACK_IMPORTED_MODULE_7_underscore___default.a.pluck(_this.interviewerUsers, 'id').join(',');
                    _this.$refs.sendEmail && _this.$refs.sendEmail.setDefaultValue(_this.interviewerUsers, _this.form.sendEmail);
                }
                _this.setMultiInterviewEmailsTpl();
                _this.dialogFormVisible = true;
            });

            if (params.userAttributes === 4) {
                __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post('/resumePosition/supplierNotify.api', {
                    rpIds: params.ids
                }).then(function (res) {
                    if (res.status === true) {
                        _this.supplierList = res.result.supplierInfo || [];
                        _this.supplierList.forEach(function (supplier) {
                            if (supplier.contactList && supplier.contactList.length) {
                                supplier.contactList.forEach(function (item) {
                                    _this.$set(item, 'disabled', true);
                                });
                            }
                        });
                    }
                });
            }
        },
        setMultiInterviewEmailsTpl: function setMultiInterviewEmailsTpl() {
            if (this.isMultiEmail && this.isForInterviewers) {
                this.selectedTpl({
                    name: '【专业面试安排确认】',
                    type: 'interviewTpl',
                    hrattachids: '',
                    content: 'Hi 面试官，我们安排了以下人选进行面试，如果有其他问题可以与我联系。 <br> [!--interview_table--]  <br> [!--conferenceLinks--]  <br>'
                });
                this.baseData.mailHolder = [{
                    value: '[!--interview_table--]',
                    text: '面试安排表格（面试官）'
                }, {
                    value: '[!--conferenceLinks--]',
                    text: '会议链接表格'
                }];
            }
        },
        show: function show(params) {
            console.log(params);
            this.params = params;
            this.isPreview = false;
            this.selectTpl = '';
            this.ccUsers = [];
            this.form.name = '';

            this.form.sendEmail = '';
            this.$refs.sendEmail && this.$refs.sendEmail.reset();

            this.$refs.ccList && this.$refs.ccList.$refs.select && this.$refs.ccList.$refs.select.reset();
            this.form.delivery = false;
            this.form.hrAttachIds = [];
            this.fileList = [];
            this.form.content = '';
            this.form.contentCode = '';
            this.showInterviewPhase = typeof params.showInterviewPhase !== 'undefined' ? params.showInterviewPhase : true;
            this.renderKey++;
            this.initDataBeforeShow(params);
            this.$refs.editor && (this.$refs.editor.lastRange = null);
        },
        checkForm: function checkForm() {
            if (!this.form.name) {
                this.$message({
                    message: '邮件标题不能为空',
                    type: 'warning'
                });
                return false;
            }
            if (this.form.contentCode === '') {
                this.$message({
                    message: '邮件内容不能为空',
                    type: 'warning'
                });
                return false;
            }
            if (this.params.userAttributes === 2) {
                if (this.filterIntViewArrIds.length === 0) {
                    this.$message({
                        message: '面试阶段不能为空',
                        type: 'warning'
                    });
                    return false;
                }
            }
            return true;
        },
        getUserEmailInfo: function getUserEmailInfo() {
            var _this2 = this;

            this.interviewerUsers = [];
            this.baseData.resumePositionList.forEach(function (item) {
                _this2.interviewerUsers.push({
                    id: item.resume.email,
                    name: item.resume.name
                });
            });
            return __WEBPACK_IMPORTED_MODULE_7_underscore___default.a.pluck(this.interviewerUsers, 'id').join(',');
        },
        generateSupplierReceiveList: function generateSupplierReceiveList(supplier) {
            var _this3 = this;

            var rpIds = [];
            this.interviewerUsers = [];

            supplier.contactList.filter(function (contact) {
                return !contact.disabled;
            }).forEach(function (contact) {
                _this3.interviewerUsers.push({
                    id: contact.email,
                    name: contact.name
                });
            });

            if (this.interviewerUsers.length === 0) {
                return false;
            }

            supplier.rpIdList.forEach(function (rpId) {
                var resumePosition = _this3.baseData.resumePositionList.find(function (rpl) {
                    return rpl.rpId == rpId;
                }) || {};

                var arrangeIdList = (resumePosition.list || []).map(function (item) {
                    return item.id;
                }).filter(function (aId) {
                    return _this3.filterIntViewArrIds.includes(aId);
                });
                rpIds.push({ rpId: rpId, arrangeIdList: arrangeIdList });
            });

            return {
                emails: this.interviewerUsers.map(function (i) {
                    return i.id;
                }).join(','),
                rpIds: rpIds
            };
        },
        previewEmailSupplier: function previewEmailSupplier(row) {
            var _this4 = this;

            if (this.checkForm() === false) {
                return false;
            }

            var filteredSupplierList = row ? this.supplierList.filter(function (supplier) {
                return supplier.supplierCode === row.supplierCode;
            }) : this.supplierList;

            var receiver = this.generateSupplierReceiveList(filteredSupplierList[0]);
            if (!receiver) {
                this.$message({
                    message: '供应商对接人不能为空',
                    type: 'warning'
                });
                return false;
            }

            var receiveList = [receiver];

            this.ccUsers = this.$refs.ccList.getSelected();

            var url = '/resumePosition/mailSend/lookSendMail.api';

            var params = {
                name: this.form.name,
                content: this.form.contentCode + this.getSign(),
                userAttributes: 4,
                receiveList: receiveList,
                attachList: this.fileList.map(function (file) {
                    return {
                        md5: file.md5,
                        fileId: file.fileId
                    };
                }),
                ccList: this.ccUsers.map(function (c) {
                    return c.id;
                }).join(',')
            };

            __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(url, params, {
                headers: {
                    'Content-Type': 'application/json'
                },
                transformRequest: function transformRequest(data) {
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data);
                }
            }).then(function (res) {
                _this4.form.content = res.result.bean;
                _this4.isPreview = true;
            }).catch(function () {});
        },
        previewEmail: function previewEmail(id, index) {
            var _this5 = this;

            if (this.checkForm() === false) {
                return false;
            }
            if (this.params.userAttributes === 2) {
                this.interviewerUsers = this.$refs.sendEmail.getSelected();
            } else {
                this.interviewerUsers = [];
                this.baseData.resumePositionList.forEach(function (item) {
                    _this5.interviewerUsers.push({
                        id: item.resume.email,
                        name: item.resume.name
                    });
                });
            }
            this.ccUsers = this.$refs.ccList.getSelected();

            if (this.params.userAttributes === 1) {
                this.form.sendEmail = this.getUserEmailInfo();
            } else {
                this.form.sendEmail = __WEBPACK_IMPORTED_MODULE_7_underscore___default.a.pluck(this.interviewerUsers, 'id').join(',');
            }
            this.form.ccList = __WEBPACK_IMPORTED_MODULE_7_underscore___default.a.pluck(this.ccUsers, 'id').join(',');
            var params = {
                name: this.form.name,
                resumePositionId: id || this.params.ids + '',
                userAttributes: this.params.userAttributes,
                interviewId: this.params.interviewIds.split(',')[index || 0],
                content: this.form.contentCode + this.getSign(),
                sendEmail: this.form.sendEmail,
                ccUsers: this.form.ccUsers
            };
            var url = '/resumePosition/mailSend/lookMail.api';
            if (this.isForInterviewers && this.isMultiEmail) {
                url = '/resumePosition/mailSend/lookMutliMail.api';
                params.filterIntViewArrIds = this.allInterviewsIds.join(',');
                params.interviewId = undefined;
                params.resumePositionId = undefined;
                params.id = undefined;
                params.ccList = this.form.ccList;
            } else {
                params.filterIntViewArrIds = this.filterIntViewArrIds.length ? this.filterIntViewArrIds.join(',') : undefined;
            }
            __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(url, params).then(function (res) {
                _this5.form.content = res.result.bean;
                _this5.isPreview = true;
            }).catch(function () {});
        },
        previewAll: function previewAll() {
            if (this.params.userAttributes === 4) {
                this.previewEmailSupplier(null);
            } else {
                this.previewEmail(null);
            }
        },
        sendEmailSupplier: function sendEmailSupplier() {
            var _this6 = this;

            if (this.checkForm() === false) {
                return false;
            }

            var receiveList = this.supplierList.map(function (supplier) {
                return _this6.generateSupplierReceiveList(supplier);
            }).filter(Boolean);

            if (receiveList.length === 0) {
                this.$message({
                    message: '供应商对接人不能为空',
                    type: 'warning'
                });
                return false;
            }

            this.ccUsers = this.$refs.ccList.getSelected();

            var url = '/resumePosition/mailSend/sendMailToSupplier.api';
            var params = {
                name: this.form.name,
                content: this.form.contentCode + this.getSign(),
                userAttributes: 4,
                receiveList: receiveList,
                attachList: this.fileList.map(function (file) {
                    return {
                        md5: file.md5,
                        fileId: file.fileId
                    };
                }),
                ccList: this.ccUsers.map(function (c) {
                    return c.id;
                }).join(',')
            };

            __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(url, params, {
                headers: {
                    'Content-Type': 'application/json'
                },
                transformRequest: function transformRequest(data) {
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data);
                },
                'X-showMessage': true
            }).then(function (res) {
                _this6.dialogFormVisible = false;
                _this6.$emit('sendSuccess', _this6.params);
            }).catch(function () {});
        },
        sendEmail: function sendEmail() {
            var _this7 = this;

            if (this.checkForm() === false) {
                return false;
            }
            var url = '/resumePosition/mailSend/sendMail.api';
            if (this.isForInterviewers && this.isMultiEmail) {
                url = '/resumePosition/mailSend/sendMutliMail.api';
            } else if (this.isForEmployee && this.isMultiEmail) {
                url = '/resumePosition/mailSend/sendMutliMailForResume.api';
            }
            if (this.params.userAttributes === 2) {
                if (this.$refs.sendEmail) {
                    this.interviewerUsers = this.$refs.sendEmail.getSelected();
                    this.form.sendEmail = __WEBPACK_IMPORTED_MODULE_7_underscore___default.a.pluck(this.interviewerUsers, 'id').join(',');
                }
            } else {
                this.form.sendEmail = this.getUserEmailInfo();
            }

            if (this.$refs.ccList) {
                this.ccUsers = this.$refs.ccList.getSelected();
                this.form.ccList = __WEBPACK_IMPORTED_MODULE_7_underscore___default.a.pluck(this.ccUsers, 'id').join(',');
            }
            var params = {
                resumePositionId: this.params.ids,
                userAttributes: this.params.userAttributes,
                interviewId: this.params.interviewIds.split(',')[0],
                name: this.form.name,
                mailAttachInfos: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.form.mailAttachInfos),
                hrAttachIds: this.form.hrAttachIds.join(','),
                filemd5Id: this.getFileData(),
                attaches: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.fileList),
                content: '<div style="font-family:微软雅黑;">' + this.form.contentCode + this.getSign() + '</div>',
                ccList: this.form.ccList,
                sendEmail: this.form.sendEmail
            };
            if (this.isForInterviewers && this.isMultiEmail) {
                params.filterIntViewArrIds = this.allInterviewsIds.join(',');
                params.interviewId = undefined;
                params.resumePositionId = undefined;
            } else if (this.isForEmployee && this.isMultiEmail) {
                params.interviewIds = this.params.interviewIds;
                params.ids = this.params.ids;
                params.resumePositionId = undefined;
                params.interviewId = undefined;
            } else {
                params.filterIntViewArrIds = this.filterIntViewArrIds.length ? this.filterIntViewArrIds.join(',') : undefined;
            }

            __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(url, params, {
                'X-showMessage': true
            }).then(function (res) {
                _this7.dialogFormVisible = false;
                _this7.$emit('sendSuccess', _this7.params);
            });
        },
        sendEmailAll: function sendEmailAll() {
            if (this.params.userAttributes === 4) {
                this.sendEmailSupplier();
            } else {
                this.sendEmail();
            }
        },
        getFileData: function getFileData() {
            var _this8 = this;

            var data = [];
            this.form.hrAttachIds.forEach(function (id) {
                var item = __WEBPACK_IMPORTED_MODULE_7_underscore___default.a.findWhere(_this8.baseData.hrAttachList, { id: id });
                item && data.push(['hr', item.md5, item.fileId, item.attachName].join(','));
            });
            return data.join(';');
        },
        getSign: function getSign() {
            var userInfo = this.$store.state.user;
            var needUserInfo = this.params.userAttributes !== 1;

            var html = '<div style="color: #999;margin-top: 50px;font-family: \u5FAE\u8F6F\u96C5\u9ED1;font-size: 14px;">\n                <p style="margin: 5px 0;border-bottom: 1px solid #999;width: 300px;">' + Object(__WEBPACK_IMPORTED_MODULE_5_modules_tools__["a" /* dateFormat */])(new Date()) + '</p>';
            if (needUserInfo) {
                html += '<p style="margin:5px 0;">\u53D1\u4EF6\u4EBA\uFF1A' + (userInfo.name || '-') + '</p>\n                    <p style="margin:5px 0;">\u90E8\u95E8\uFF1A' + (userInfo.deptName || '-') + '</p>\n                    <p style="margin:5px 0;">POPO\uFF1A' + (userInfo.email || '-') + '</p>';
            }
            html += '</div>';

            return html;
        },
        togglerUserActive: function togglerUserActive(item) {
            this.$nextTick(function () {
                item.disabled = !item.disabled;
            });
        }
    },
    computed: {
        getAttachItems: function getAttachItems() {
            var ids = this.form.hrAttachIds,
                res = [];
            this.baseData.hrAttachList.forEach(function (item) {
                if (ids.indexOf(item.id) > -1) {
                    res.push(item);
                }
            });
            return res;
        },
        senderTitle: function senderTitle() {
            if (this.isPreview) {
                return '邮件预览';
            }

            if (this.params && this.params.userAttributes) {
                var map = {
                    1: '通知应聘者',
                    2: '通知面试官',
                    4: '供应商邮件发送'
                };
                return map[this.params.userAttributes] || '';
            }
        },
        isForInterviewers: function isForInterviewers() {
            return this.params.userAttributes === 2;
        },
        isForEmployee: function isForEmployee() {
            return this.params.userAttributes === 1;
        },
        showPreviewBtn: function showPreviewBtn() {
            if (this.params.userAttributes === 4) {
                return false;
            } else if (this.isForInterviewers) {
                return !this.isPreview;
            } else {
                return !this.isPreview && !this.isMultiEmail;
            }
        },
        isInterviewPhase: function isInterviewPhase() {
            return this.params.phase !== '0' && this.params.phase !== '10';
        },
        isMultiEmail: function isMultiEmail() {
            if (this.params) {
                var ids = this.params.ids;
                return ids.split(',').length > 1;
            } else {
                return false;
            }
        },
        showSendBtn: function showSendBtn() {
            if (this.params.userAttributes === 4) {
                return !this.isPreview;
            }
            return true;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-074c5078"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/operation/interviewerEmailDialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.params) ? _c('el-dialog', {
    staticClass: "scoped-interivew-email",
    attrs: {
      "title": _vm.senderTitle,
      "visible": _vm.dialogFormVisible,
      "close-on-click-modal": false,
      "close-on-press-escape": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isPreview),
      expression: "!isPreview"
    }],
    key: _vm.renderKey,
    staticClass: "editView"
  }, [(_vm.params.userAttributes === 4) ? _c('div', {
    staticStyle: {
      "width": "85%",
      "margin": "0px auto 20px"
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.supplierList
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "供应商",
      "width": "100",
      "prop": "supplierName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "候选人数量",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.rpIdList.length))]
      }
    }], null, false, 3940408418)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "对接人(点击名字标签可发送给该对接人)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.contactList), function(item, index) {
          return _c('el-tag', {
            key: index,
            staticClass: "user-tag",
            class: {
              'disabled': item.disabled === true
            },
            nativeOn: {
              "click": function($event) {
                return _vm.togglerUserActive(item)
              }
            }
          }, [_vm._v(_vm._s(item.name) + "(" + _vm._s(item.email) + ")")])
        })
      }
    }], null, false, 311185674)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          attrs: {
            "href": "javascript:;"
          },
          on: {
            "click": function($event) {
              return _vm.previewEmailSupplier(scope.row)
            }
          }
        }, [_vm._v("预览")])]
      }
    }], null, false, 3920799250)
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.baseData) ? _c('el-form', {
    staticClass: "form-beauty",
    attrs: {
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择模板",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择模板"
    },
    on: {
      "change": _vm.selectedTpl
    },
    model: {
      value: (_vm.selectTpl),
      callback: function($$v) {
        _vm.selectTpl = $$v
      },
      expression: "selectTpl"
    }
  }, _vm._l((_vm.baseData.list), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.name
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.interviewArrangeForms.length && !_vm.isMultiEmail && _vm.isInterviewPhase && _vm.showInterviewPhase) ? _c('el-form-item', {
    attrs: {
      "label": "面试阶段",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-checkbox', {
    staticClass: "mr-20",
    attrs: {
      "indeterminate": _vm.isIndeterminate
    },
    on: {
      "change": _vm.handleCheckAllChange
    },
    model: {
      value: (_vm.checkAllParse),
      callback: function($$v) {
        _vm.checkAllParse = $$v
      },
      expression: "checkAllParse"
    }
  }, [_vm._v("全选\n                ")]), _vm._v(" "), _c('el-checkbox-group', {
    staticStyle: {
      "display": "inline-block"
    },
    on: {
      "change": _vm.handleCheckedPharseChange
    },
    model: {
      value: (_vm.filterIntViewArrIds),
      callback: function($$v) {
        _vm.filterIntViewArrIds = $$v
      },
      expression: "filterIntViewArrIds"
    }
  }, _vm._l((_vm.interviewArrangeForms), function(item) {
    return _c('el-checkbox', {
      key: item.id,
      attrs: {
        "label": item.id
      }
    }, [_vm._v("\n                        " + _vm._s(item.turnName) + "\n                    ")])
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.params.userAttributes !== 4) ? _c('el-form-item', {
    attrs: {
      "label": "收件人",
      "label-width": _vm.formLabelWidth
    }
  }, [(_vm.params.userAttributes === 2) ? _c('user-group', {
    ref: "sendEmail",
    attrs: {
      "allowEmail": true,
      "cacheOptions": _vm.interviewerUsers
    },
    model: {
      value: (_vm.form.sendEmail),
      callback: function($$v) {
        _vm.$set(_vm.form, "sendEmail", $$v)
      },
      expression: "form.sendEmail"
    }
  }) : _c('div', [(_vm.isMultiEmail) ? _c('div', _vm._l((_vm.baseData.resumePositionList), function(item, index) {
    return _c('el-tag', {
      key: index,
      staticClass: "mr-5",
      nativeOn: {
        "click": function($event) {
          return _vm.previewEmail(item.id, index)
        }
      }
    }, [_vm._v("\n                            " + _vm._s(item.resume.name) + "（" + _vm._s(item.resume.email) + "）"), _c('b', [_vm._v("【预览】")])])
  }), 1) : _c('div', _vm._l((_vm.baseData.resumePositionList), function(item, index) {
    return _c('el-tag', {
      key: index,
      staticClass: "mr-5"
    }, [_vm._v("\n                            " + _vm._s(item.resume.name) + "（" + _vm._s(item.resume.email) + "）\n                        ")])
  }), 1)])], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "抄送人",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('user-group', {
    ref: "ccList",
    attrs: {
      "cacheOptions": _vm.ccUsers,
      "allowEmail": true
    },
    model: {
      value: (_vm.form.ccList),
      callback: function($$v) {
        _vm.$set(_vm.form, "ccList", $$v)
      },
      expression: "form.ccList"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "邮件标题",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "maxlength": 200
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "附件",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('file-upload', {
    staticClass: "upload-desc",
    attrs: {
      "action": ((_vm.$axios.defaults.baseURL) + "/payment/template/fileInsert.api")
    },
    model: {
      value: (_vm.fileList),
      callback: function($$v) {
        _vm.fileList = $$v
      },
      expression: "fileList"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("点击上传")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "邮件内容",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('div', {
    staticClass: "quickTool"
  }, _vm._l((_vm.baseData.mailHolder), function(item, key) {
    return _c('el-tag', {
      key: key,
      attrs: {
        "icon": "el-icon-plus",
        "size": "small"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.$refs.editor.addAfterCursor(item.value)
        }
      }
    }, [_vm._v(_vm._s(item.text) + "\n                    ")])
  }), 1), _vm._v(" "), _c('vueditor', {
    ref: "editor",
    model: {
      value: (_vm.form.contentCode),
      callback: function($$v) {
        _vm.$set(_vm.form, "contentCode", $$v)
      },
      expression: "form.contentCode"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.isPreview) ? _c('div', {
    staticClass: "previewView"
  }, [_c('div', {
    staticStyle: {
      "border-bottom": "1px solid #ddd"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bold"
    }
  }, [_vm._v("邮件标题：" + _vm._s(_vm.form.name))]), _vm._v(" "), _c('p', [_vm._v("收件人："), _vm._l((_vm.interviewerUsers), function(item, index) {
    return _c('span', {
      key: item.id
    }, [_vm._v(_vm._s(item.name)), (index < _vm.interviewerUsers.length - 1) ? _c('span', [_vm._v("、")]) : _vm._e()])
  })], 2), _vm._v(" "), _c('p', [_vm._v("抄送人："), _vm._l((_vm.ccUsers), function(item, index) {
    return _c('span', {
      key: item.id
    }, [_vm._v(_vm._s(item.name)), (index < _vm.ccUsers.length - 1) ? _c('span', [_vm._v("、")]) : _vm._e()])
  })], 2)]), _vm._v(" "), (_vm.form.hrAttachIds.length || _vm.form.mailAttachInfos.length) ? _c('p', [_vm._v("\n            附件：\n            "), (_vm.form.hrAttachIds.length) ? _c('span', _vm._l((_vm.getAttachItems), function(item, index) {
    return _c('span', {
      key: item.id,
      staticClass: "mr-5"
    }, [_vm._v(_vm._s(item.name)), (index < _vm.getAttachItems.length - 1) ? _c('span', [_vm._v("、")]) : _vm._e()])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.form.mailAttachInfos.length) ? _c('span', _vm._l((_vm.form.mailAttachInfos), function(item, index) {
    return _c('span', {
      key: item.id,
      staticClass: "mr-5"
    }, [_vm._v(_vm._s(item.fileName)), (index < _vm.form.mailAttachInfos.length - 1) ? _c('span', [_vm._v("、")]) : _vm._e()])
  }), 0) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "border-top": "1px solid #ddd"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.form.content)
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.showPreviewBtn) ? _c('el-button', {
    staticClass: "left",
    attrs: {
      "type": "success"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.previewAll($event)
      }
    }
  }, [_vm._v("预 览")]) : _vm._e(), _vm._v(" "), (!_vm.isPreview) ? _c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("取 消")]) : _vm._e(), _vm._v(" "), (_vm.isPreview) ? _c('el-button', {
    staticClass: "left",
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.toEditView
    }
  }, [_vm._v("返 回")]) : _vm._e(), _vm._v(" "), (_vm.showSendBtn) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.sendEmailAll
    }
  }, [_vm._v("发 送")]) : _vm._e()], 1)]) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var operation_interviewerEmailDialog_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/views/operation/interviewerEmailDialog.vue
function injectStyle (ssrContext) {
  __webpack_require__(841)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  interviewerEmailDialog_defaultExport,
  operation_interviewerEmailDialog_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/components/userSelect/vue-click-outside.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);



var VueClickOutSide = {
    id: 'clickoutside',
    bind: function bind(el, props) {
        el.clickCatcher = function (e) {
            if (props.modifiers.hidden) {
                props.modifiers.hidden = false;
                return;
            }
            if (!el.contains(e.target) && typeof props.value === 'function') {
                props.value(props.arg);
            }
        };
        window.addEventListener('click', el.clickCatcher);
    },

    unbind: function unbind(el) {
        return window.removeEventListener('click', el.clickCatcher);
    },
    install: function install(Vue) {
        Vue.directive('clickoutside', {
            bind: this.bind,
            unbind: this.unbind
        });
    }
};
/* harmony default export */ var vue_click_outside_defaultExport = (VueClickOutSide);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/userSelect/userSelect.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__searchDownList_vue__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_underscore__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_underscore__);









/* harmony default export */ var userSelect_defaultExport = ({
    props: {
        value: '',
        cacheOptions: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        allowEmail: true,
        disabled: false
    },
    created: function created() {
        this.getList();
    },

    watch: {
        'cacheOptions': function cacheOptions() {
            this.cacheList = this.cacheOptions;
        },
        'value': function value() {
            this.userValues = this.value;
        },
        'userValues': function userValues() {
            this.$emit('input', this.userValues);
        }
    },
    data: function data() {
        return {
            cacheList: this.cacheOptions,
            enableOutClick: true,
            userValues: this.value,
            emptyText: '无分组信息',
            showGroupTable: false,
            gridData: []
        };
    },

    components: {
        searchDownList: __WEBPACK_IMPORTED_MODULE_2__searchDownList_vue__["a" /* default */]
    },
    directives: {
        ClickOutside: vue_click_outside_defaultExport
    },
    methods: {
        getList: function getList() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('/resumePosition/MailCcRecord/list.api').then(function (res) {
                _this.gridData = res.result.list;
            });
        },
        removeItem: function removeItem(id) {
            var _this2 = this;

            if (this.disabled) {
                return;
            }
            this.enableOutClick = false;
            this.$confirm('此操作将永久删除改分组, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post('/resumePosition/MailCcRecord/delete.api', {
                    id: id
                }, {
                    'X-showMessage': true
                }).then(function (res) {
                    _this2.getList();
                    _this2.enableOutClick = true;
                });
            }).catch(function () {
                _this2.enableOutClick = false;
            });
        },
        addToGroup: function addToGroup() {
            var _this3 = this;

            if (this.disabled) {
                return;
            }
            this.cacheList = this.$refs.select.getSelected();
            if (this.cacheList.length === 0) {
                this.$message({
                    type: 'warning',
                    message: '分组成员不能为空'
                });
                return false;
            }
            this.$prompt('请输入新的分组名', '新加分组', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern: /^[\S]{1,20}$/,
                inputErrorMessage: '不能为空，不能空字符开头，长度不能超过20'
            }).then(function (_ref) {
                var value = _ref.value;

                __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post('/resumePosition/MailCcRecord/insert.api', {
                    recordName: value,
                    record: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this3.cacheList)
                }, {
                    'X-showMessage': true
                }).then(function (res) {
                    _this3.getList();
                });
            }).catch(function () {});
        },
        rowClick: function rowClick(data) {
            var _this4 = this;

            var list = JSON.parse(data.record);
            this.cacheList = this.$refs.select.getSelected();
            var ids = __WEBPACK_IMPORTED_MODULE_5_underscore___default.a.pluck(this.cacheList, 'id');
            list.forEach(function (item) {
                if (ids.indexOf(String(item.id)) === -1) {
                    ids.push(item.id);
                    _this4.cacheList.push({
                        id: item.id,
                        name: item.title || item.name
                    });
                }
            });
            this.$refs.select.setDefaultValue(this.cacheList, ids.join(','));
            this.$emit('input', ids.join(','));
        },
        leftFormater: function leftFormater(obj) {
            return obj.lastName;
        },
        rightFormater: function rightFormater(obj) {
            var depNames = [];
            obj.dept1Name && depNames.push(obj.dept1Name);
            obj.dept2Name && depNames.push(obj.dept2Name);
            obj.dept3Name && depNames.push(obj.dept3Name);
            return depNames.join('->');
        },
        toggleGroup: function toggleGroup() {
            if (this.disabled) {
                return;
            }
            this.showGroupTable = true;
        },
        hideGroup: function hideGroup() {
            if (this.enableOutClick && this.showGroupTable === true) {
                this.showGroupTable = false;
            }
        },
        reset: function reset() {
            this.$refs.select.reset();
        },
        setDefaultValue: function setDefaultValue(data, ids, conf) {
            this.$refs.select.setDefaultValue(data, ids, conf);
        },
        getSelected: function getSelected() {
            return this.$refs.select.getSelected();
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e888f0a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/userSelect/userSelect.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-selects-group-wpr"
  }, [_c('search-down-list', {
    ref: "select",
    attrs: {
      "disabled": _vm.disabled,
      "leftFormater": _vm.leftFormater,
      "rightFormater": _vm.rightFormater,
      "cacheOptions": _vm.cacheList,
      "allowEmail": _vm.allowEmail
    },
    model: {
      value: (_vm.userValues),
      callback: function($$v) {
        _vm.userValues = $$v
      },
      expression: "userValues"
    }
  }, [_c('i', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.hideGroup),
      expression: "hideGroup"
    }],
    staticClass: "el-icon-menu group-btn",
    style: (_vm.disabled ? 'cursor: not-allowed;' : ''),
    attrs: {
      "title": "分组"
    },
    on: {
      "click": _vm.toggleGroup
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-plus save-to-group",
    style: (_vm.disabled ? 'cursor: not-allowed;' : ''),
    attrs: {
      "title": "新加分组"
    },
    on: {
      "click": _vm.addToGroup
    }
  })]), _vm._v(" "), (_vm.showGroupTable) ? _c('div', {
    staticClass: "group-info"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.gridData
    },
    on: {
      "row-click": _vm.rowClick
    }
  }, [_c('el-table-column', {
    attrs: {
      "width": "150",
      "prop": "recordName",
      "label": "组名",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "data",
      "label": "成员"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((JSON.parse(scope.row.record)), function(item, index) {
          return _c('el-tag', {
            key: index,
            attrs: {
              "type": "primary"
            }
          }, [_vm._v(_vm._s(item.title || item.name))])
        })
      }
    }], null, false, 3967572706)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "50",
      "prop": "recordName",
      "label": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticStyle: {
            "float": "right",
            "font-size": "14px"
          },
          style: (_vm.disabled ? 'cursor: not-allowed;' : ''),
          attrs: {
            "type": "text",
            "icon": "el-icon-close"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.removeItem(scope.row.id)
            }
          }
        })]
      }
    }], null, false, 1306990467)
  })], 1)], 1) : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var userSelect_userSelect_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/components/userSelect/userSelect.vue
function injectStyle (ssrContext) {
  __webpack_require__(843)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  userSelect_defaultExport,
  userSelect_userSelect_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/views/evaluation/society-form/society-form-base.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dayjs__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dayjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_dayjs__);





function isExisted(comp) {
    if (Array.isArray(comp)) {
        return comp.length > 0;
    }

    return comp;
}

/* harmony default export */ var society_form_base_defaultExport = ({
    data: function data() {
        var advise = this.$parent.advise;
        return {
            form: null,
            advise: this.getAdviseValue(advise),
            insertUrl: '/evaluation/insert.api',
            updateUrl: '/evaluation/update.api',
            errorMsg: {
                content: '综合评价不能为空',
                userViewpoint: '评价意见不能为空',
                grade: '建议定级不能为空',
                score: '评分标准不能为空',
                monthBaseSalary: '月基本薪资不能为空',
                monthCount: '薪资一年发放月份不能为空',
                expectSalary: '期望薪资不能为空',
                interviewRecord: '面试记录不能为空',
                adviceSalary: '建议薪资不能为空',
                hireAdvice: '岗位建议方向不能为空',
                otherWelfare: '其他福利说明不能为空',
                lastEntryTime: '最快到岗时间不能为空',
                comCommunication: '请选择“综合能力-沟通表达”评分',
                comLogical: '请选择“综合能力-逻辑思维”评分',
                comLearning: '请选择“综合能力-学习能力”评分',
                comCrush: '请选择“综合能力-抗压力”评分',
                comExecutive: '请选择“综合能力-执行力”评分',
                comStrain: '请选择“综合能力-应变”评分',
                perAffinity: '请选择“个人素质-亲和力”评分',
                perSolid: '请选择“个人素质-踏实度”评分',
                perExtroversion: '请选择“个人素质-外向性”评分',
                otherRecognition: '其他-热爱度与平台认可度不能为空',
                otherCareerPlan: '其他-职业规划不能为空',
                otherFamilyInfo: '其他-家庭情况不能为空',
                professionalProjMgr: '专业能力-项目管理不能为空',
                professionalArt: '专业能力-美术背景不能为空'
            }
        };
    },
    created: function created() {},

    methods: {
        setForm: function setForm(initForm) {
            for (var name in this.form) {
                this.form[name] = initForm[name];
            }
            var advice = initForm.hireAdvice && this.getAdviseValue(initForm.hireAdvice);
            var realAdvice = [];

            this.advise.forEach(function (item) {
                if (advice.indexOf(item) > -1) {
                    realAdvice.push(item);
                }
            });
            if (realAdvice.length > 0) {
                this.form.hireAdvice = realAdvice;
            }
            this.form.hireAdvice = this.form.hireAdvice || [];
            this.form.userViewpoint = String(initForm.userViewpoint);
            initForm.id && (this.form.id = String(initForm.id));
        },
        getAdviseValue: function getAdviseValue(advise) {
            var splitUnit = ',';
            if (advise && advise.indexOf('、') > -1) {
                splitUnit = '、';
            }
            var adviseArr = advise === '' || advise === undefined ? [] : advise.split(splitUnit);
            return adviseArr;
        },
        checkData: function checkData() {
            var pass = true;
            var firstName = '';
            var message = '';
            var salaryList = ['grade', 'monthBaseSalary', 'monthCount', 'otherWelfare', 'adviceSalary', 'expectSalary'];
            for (var name in this.form) {
                if (name === 'hireAdvice' && (this.advise.length === 0 || ['11', '12', '13', '14', '15', '16'].includes(this.scoreType))) {
                    continue;
                }
                if (salaryList.includes(name) && (this.form.userViewpoint === '3' || this.form.userViewpoint === '4')) {
                    continue;
                }
                if (name === 'otherInfo') continue;

                if (name !== 'id' && (typeof this.form[name] === 'string' && this.form[name].trim() === '' || typeof this.form[name] === 'undefined') && isExisted(this.$refs[name])) {
                    pass = false;
                    firstName = name;
                    message = this.errorMsg[name] || '表单不能为空';
                    if (name === 'professionalProjMgr' && this.scoreType === '12') {
                        message = '专业能力不能为空';
                    }
                    break;
                } else if (name !== 'id' && this.form[name] instanceof Array && this.form[name].length === 0) {
                    pass = false;
                    firstName = name;
                    message = this.errorMsg[name] || '表单不能为空';
                    break;
                } else if (this.formValidator && this.formValidator[name]) {
                    var result = this.formValidator[name](this.form[name].trim());
                    if (result) {
                        message = result;
                        pass = false;
                        firstName = name;
                        break;
                    }
                }
            }
            if (!pass) {
                this.$message({
                    message: message,
                    type: 'warning'
                });
                var view = this.$refs[firstName];
                if (Array.isArray(view)) view = view[0];
                var childArr = view.$el.children || view.$el.childNodes;
                this.blinkFormItemContent(view.type && view.type === 'textarea' ? childArr[0] : view.$el.parentElement);
            }
            return pass;
        },
        blinkFormItemContent: function blinkFormItemContent($el) {
            var Timer = null,
                i = 0,
                that = this;
            window.scrollTo(0, __WEBPACK_IMPORTED_MODULE_1_utils__["b" /* dom */].offset($el).top - 160);
            Timer = setInterval(function () {
                i = i + 1;
                i === 6 ? clearInterval(Timer) : i % 2 === 0 ? $el.style.backgroundColor = '#ffd4d4' : $el.style.backgroundColor = '#fff';
            }, 120);
        },
        submit: function submit() {
            var _this = this;

            if (this.checkData()) {
                this.$axios.post(this.isEdit ? this.updateUrl : this.insertUrl, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.form, {
                    lastEntryTime: this.form.lastEntryTime ? __WEBPACK_IMPORTED_MODULE_2_dayjs___default()(this.form.lastEntryTime).format('YYYY-MM-DD') : '',
                    hireAdvice: this.form.hireAdvice instanceof Array ? this.form.hireAdvice.join('、') : '',
                    resumePositionId: this.$route.params.id
                }, this.extInfo || {}), { 'X-showMessage': true }).then(function (res) {
                    _this.$emit('refresh');
                });
            }
        },
        cancel: function cancel() {
            this.$emit('cancel');
        }
    },
    computed: {
        viewPointOptions: function viewPointOptions() {
            return this.selectMap ? this.selectMap['WB_USER_VIEWPOINT'] : [];
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/evaluation/society-form/society-form-tips.vue


/* harmony default export */ var society_form_tips_defaultExport = ({
    props: {
        isSociety: {
            type: Boolean,
            default: true
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32046bb3"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/evaluation/society-form/society-form-tips.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isSociety) ? _c('div', {
    staticClass: "evaluation-tips"
  }, [_c('p', {
    staticClass: "point"
  }, [_vm._v("使用说明：")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "point",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("面试记录：")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "point",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("参考说明：")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "point em",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v(" 通过方式参考：")]), _vm._v(" "), _vm._m(3)]) : _c('div', {
    staticClass: "evaluation-tips"
  }, [_c('p', {
    staticClass: "point",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v(" 使用说明：")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('p', {
    staticClass: "point",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("面试记录：")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('p', {
    staticClass: "point",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("参考说明：")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('p', {
    staticClass: "point em",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v(" 通过方式参考：")]), _vm._v(" "), _vm._m(7)])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('i'), _c('span', {
    staticClass: "em"
  }, [_vm._v("建议薪资")]), _vm._v("和"), _c('span', {
    staticClass: "em"
  }, [_vm._v("期望薪资")]), _vm._v("为必填项，建议薪资和期望薪资请面试官填写年薪")]), _vm._v(" "), _c('li', [_c('i'), _vm._v("评分标准作为参考，统一各组面试标准。面试者是否通过面试"), _c('span', {
    staticClass: "em"
  }, [_vm._v("由面试官根据实际情况决定")]), _vm._v("；")]), _vm._v(" "), _c('li', [_c('i'), _vm._v("以S\\A\\B\\C\\D数量作为面试者定级的参考。面试官给出建议薪资，最终"), _c('span', {
    staticClass: "em"
  }, [_vm._v("定级由外包管理委员会综合面试官提供的面试评估决定")]), _vm._v("。")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('i'), _vm._v("填写面试过程中评级的原因或者面试题目和答案；")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('i'), _vm._v("主属性采用SABCD的方式评价。")]), _vm._v(" "), _c('li', [_c('i'), _vm._v("表格中提供的题目以及解答为"), _c('span', {
    staticClass: "em"
  }, [_vm._v("参考题目以及参考解答，请勿直接使用")]), _vm._v("，关键点已经用对应的颜色标明"), _c('span', {
    staticClass: "orange"
  }, [_vm._v("S橙色")]), _vm._v("、"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("A黄色")]), _vm._v("、"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("B蓝色")]), _vm._v("、"), _c('span', {
    staticClass: "green"
  }, [_vm._v("C绿色")]), _vm._v("、"), _c('span', {
    staticClass: "black"
  }, [_vm._v("D黑色")])]), _vm._v(" "), _c('li', [_c('i'), _vm._v("评级中分值表示的是培养后外包所能到达的绩效水平（例如：预计王三同学在培养后该项能力可以达到S绩效同学的预期，给出S即可）")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("1. 所有必要属性评级为B,或者大于等于B；")]), _vm._v(" "), _c('li', [_vm._v("2. 游戏理解S，其他属性要求可以酌情降低，允许有一个C；")]), _vm._v(" "), _c('li', [_vm._v("3. 计算机基础和算法编程取最高分作为计算机综合分，计算机综合分为A或者以上，其他非计算机相关属性要求可以酌情降低，允许有一个C。")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('i'), _c('span', {
    staticClass: "em"
  }, [_vm._v("期望描述")]), _vm._v("为必填项；")]), _vm._v(" "), _c('li', [_c('i'), _vm._v("评分标准作为参考，统一各组面试标准。面试者是否通过面试"), _c('span', {
    staticClass: "em"
  }, [_vm._v("由面试官根据实际情况决定")]), _vm._v("；")]), _vm._v(" "), _c('li', [_c('i'), _vm._v("以S\\A\\B\\C\\D数量作为面试者定级的参考。面试官给出建议薪资，最终"), _c('span', {
    staticClass: "em"
  }, [_vm._v("定级由外包管理委员会综合面试官提供的面试评估决定")]), _vm._v("。")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('i'), _vm._v("填写面试过程中评级的原因或者面试题目和答案；")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('i'), _vm._v("主属性采用SABCD的方式评价；")]), _vm._v(" "), _c('li', [_c('i'), _vm._v("表格中提供的题目以及解答为"), _c('span', {
    staticClass: "em"
  }, [_vm._v("参考题目以及参考解答，请勿直接使用")]), _vm._v("，关键点已经用对应的颜色标明"), _c('span', {
    staticClass: "orange"
  }, [_vm._v("S橙色")]), _vm._v("、"), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("A黄色")]), _vm._v("、"), _c('span', {
    staticClass: "blue"
  }, [_vm._v("B蓝色")]), _vm._v("、"), _c('span', {
    staticClass: "green"
  }, [_vm._v("C绿色")]), _vm._v("、"), _c('span', {
    staticClass: "black"
  }, [_vm._v("D黑色")])]), _vm._v(" "), _c('li', [_c('i'), _vm._v("评级中分值表示的是培养后外包所能到达的绩效水平（例如：预计王三同学在培养后该项能力可以达到S绩效同学的预期，给出S即可）")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("1. 所有必要属性评级为B,或者大于等于B；")]), _vm._v(" "), _c('li', [_vm._v("2. 游戏理解S，其他属性要求可以酌情降低，允许有一个C；")]), _vm._v(" "), _c('li', [_vm._v("3. 计算机基础和算法编程取最高分作为计算机综合分，计算机综合分为A或者以上，其他非计算机相关属性要求可以酌情降低，允许有一个C。")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var society_form_society_form_tips_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/views/evaluation/society-form/society-form-tips.vue
function injectStyle (ssrContext) {
  __webpack_require__(859)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  society_form_tips_defaultExport,
  society_form_society_form_tips_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var evaluation_society_form_society_form_tips_defaultExport = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/evaluation/society-form/society-form-2020recruitment-guangzhou.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mixins_selectMapMixin__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__score_tips_score_tips_vue__ = __webpack_require__(92);







/* harmony default export */ var society_form_2020recruitment_guangzhou_defaultExport = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_0_mixins_selectMapMixin__["a" /* default */]],
    extends: society_form_base_defaultExport,
    data: function data() {
        return {
            showScoreTip: false,
            form: {
                score: '',
                userViewpoint: '',
                hireAdvice: [],
                adviceSalary: '',
                expectSalary: '',
                interviewRecord: '',
                content: ''
            }
        };
    },

    props: {
        recruitType: null,
        isEdit: false,
        scoreType: null,
        extInfo: null
    },
    components: {
        ScoreTips: __WEBPACK_IMPORTED_MODULE_2__score_tips_score_tips_vue__["default"],
        SocietyFormTips: evaluation_society_form_society_form_tips_defaultExport
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61847a68"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/evaluation/society-form/society-form-2020recruitment-guangzhou.vue
var society_form_2020recruitment_guangzhou_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticStyle: {
      "margin": "15px 0"
    }
  }, [_vm._v("评分参考标准："), _c('router-link', {
    staticClass: "el-button--text",
    attrs: {
      "to": {
        path: '/scoreTips',
        query: {
          scoreType: _vm.scoreType,
          turn: _vm.turn
        }
      },
      "target": "_blank"
    }
  }, [_vm._v("点击查看")])], 1), _vm._v(" "), _c('el-form', {
    staticClass: "evaluation-form-scoped",
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "label-width": "200px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "评分标准",
      "required": ""
    }
  }, [_c('el-input', {
    ref: "score",
    staticClass: "text-content",
    attrs: {
      "placeholder": "请按照参考评分标准，依次填写评分。如：ABBCBDSBD，如有非必考察项请用“-”代替，如：ABBCBD---（根据每轮面试要求定）",
      "maxlength": 9
    },
    on: {
      "focus": function($event) {
        _vm.showScoreTip = true
      },
      "blur": function($event) {
        _vm.showScoreTip = false
      }
    },
    model: {
      value: (_vm.form.score),
      callback: function($$v) {
        _vm.$set(_vm.form, "score", $$v)
      },
      expression: "form.score"
    }
  })], 1), _vm._v(" "), _c('score-tips', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showScoreTip),
      expression: "showScoreTip"
    }],
    attrs: {
      "type": _vm.scoreType
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "评价意见",
      "required": ""
    }
  }, [_c('el-radio-group', {
    ref: "userViewpoint",
    model: {
      value: (_vm.form.userViewpoint),
      callback: function($$v) {
        _vm.$set(_vm.form, "userViewpoint", $$v)
      },
      expression: "form.userViewpoint"
    }
  }, _vm._l((_vm.viewPointOptions), function(item, index) {
    return (item.value != '-1') ? _c('el-radio', {
      key: index,
      staticClass: "mr-20",
      attrs: {
        "label": item.value
      }
    }, [_vm._v(_vm._s(item.text))]) : _vm._e()
  }), 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.userViewpoint === '3' || _vm.form.userViewpoint === '4'),
      expression: "form.userViewpoint === '3' || form.userViewpoint === '4'"
    }],
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("无须填写薪资相关信息")])], 1), _vm._v(" "), (_vm.advise.length) ? _c('el-form-item', {
    attrs: {
      "label": "岗位建议方向",
      "required": ""
    }
  }, [_c('el-checkbox-group', {
    ref: "hireAdvice",
    model: {
      value: (_vm.form.hireAdvice),
      callback: function($$v) {
        _vm.$set(_vm.form, "hireAdvice", $$v)
      },
      expression: "form.hireAdvice"
    }
  }, _vm._l((_vm.advise), function(item, index) {
    return _c('el-checkbox', {
      key: index,
      staticClass: "mr-20",
      attrs: {
        "label": item
      }
    }, [_vm._v(_vm._s(item))])
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "建议薪资",
      "required": _vm.form.userViewpoint !== '3' && _vm.form.userViewpoint !== '4'
    }
  }, [_c('el-input', {
    ref: "adviceSalary",
    staticClass: "text-content",
    attrs: {
      "placeholder": "请输入建议薪资",
      "maxlength": 300
    },
    model: {
      value: (_vm.form.adviceSalary),
      callback: function($$v) {
        _vm.$set(_vm.form, "adviceSalary", $$v)
      },
      expression: "form.adviceSalary"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "期望薪资",
      "required": _vm.form.userViewpoint !== '3' && _vm.form.userViewpoint !== '4'
    }
  }, [_c('el-input', {
    ref: "expectSalary",
    staticClass: "text-content",
    attrs: {
      "placeholder": "请输入期望薪资",
      "maxlength": 66
    },
    model: {
      value: (_vm.form.expectSalary),
      callback: function($$v) {
        _vm.$set(_vm.form, "expectSalary", $$v)
      },
      expression: "form.expectSalary"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "面试记录",
      "required": ""
    }
  }, [_c('el-input', {
    ref: "interviewRecord",
    staticClass: "text-content",
    attrs: {
      "maxlength": 8000,
      "placeholder": "请输入面试问答详情",
      "type": "textarea"
    },
    model: {
      value: (_vm.form.interviewRecord),
      callback: function($$v) {
        _vm.$set(_vm.form, "interviewRecord", $$v)
      },
      expression: "form.interviewRecord"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "综合评价",
      "required": ""
    }
  }, [_c('el-input', {
    ref: "content",
    staticClass: "text-content",
    attrs: {
      "maxlength": 2000,
      "placeholder": "请输入评价内容",
      "type": "textarea"
    },
    model: {
      value: (_vm.form.content),
      callback: function($$v) {
        _vm.$set(_vm.form, "content", $$v)
      },
      expression: "form.content"
    }
  })], 1)], 1), _vm._v(" "), (false) ? _c('society-form-tips', {
    attrs: {
      "isSociety": true,
      "scoreType": _vm.scoreType
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "button-footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("提交评估")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])], 1)], 1)
}
var society_form_2020recruitment_guangzhou_staticRenderFns = []
var society_form_2020recruitment_guangzhou_esExports = { render: society_form_2020recruitment_guangzhou_render, staticRenderFns: society_form_2020recruitment_guangzhou_staticRenderFns }
/* harmony default export */ var society_form_society_form_2020recruitment_guangzhou_defaultExport = (society_form_2020recruitment_guangzhou_esExports);
// CONCATENATED MODULE: ./src/views/evaluation/society-form/society-form-2020recruitment-guangzhou.vue
function society_form_2020recruitment_guangzhou_injectStyle (ssrContext) {
  __webpack_require__(854)
}
var society_form_2020recruitment_guangzhou_normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var society_form_2020recruitment_guangzhou___vue_styles__ = society_form_2020recruitment_guangzhou_injectStyle
/* scopeId */
var society_form_2020recruitment_guangzhou___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var society_form_2020recruitment_guangzhou___vue_module_identifier__ = null
var society_form_2020recruitment_guangzhou_Component = society_form_2020recruitment_guangzhou_normalizeComponent(
  society_form_2020recruitment_guangzhou_defaultExport,
  society_form_society_form_2020recruitment_guangzhou_defaultExport,
  society_form_2020recruitment_guangzhou___vue_styles__,
  society_form_2020recruitment_guangzhou___vue_scopeId__,
  society_form_2020recruitment_guangzhou___vue_module_identifier__
)

/* harmony default export */ var evaluation_society_form_society_form_2020recruitment_guangzhou_defaultExport = (society_form_2020recruitment_guangzhou_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/evaluation/society-form/society-form-2020recruitment-hangzhou.vue
/* harmony import */ var society_form_2020recruitment_hangzhou___WEBPACK_IMPORTED_MODULE_0_mixins_selectMapMixin__ = __webpack_require__(4);
/* harmony import */ var society_form_2020recruitment_hangzhou___WEBPACK_IMPORTED_MODULE_2__score_tips_score_tips_vue__ = __webpack_require__(92);







/* harmony default export */ var society_form_2020recruitment_hangzhou_defaultExport = ({
    mixins: [society_form_2020recruitment_hangzhou___WEBPACK_IMPORTED_MODULE_0_mixins_selectMapMixin__["a" /* default */]],
    extends: society_form_base_defaultExport,
    data: function data() {
        return {
            showScoreTip: false,
            form: {
                score: '',
                userViewpoint: '',
                hireAdvice: [],
                adviceSalary: '',
                expectSalary: '',
                interviewRecord: '',
                content: ''
            }
        };
    },

    props: {
        recruitType: null,
        isEdit: false,
        scoreType: null,
        extInfo: null,
        turn: null
    },
    components: {
        ScoreTips: society_form_2020recruitment_hangzhou___WEBPACK_IMPORTED_MODULE_2__score_tips_score_tips_vue__["default"],
        SocietyFormTips: evaluation_society_form_society_form_tips_defaultExport
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fba0eee4"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/evaluation/society-form/society-form-2020recruitment-hangzhou.vue
var society_form_2020recruitment_hangzhou_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "evaluation-form-scoped"
  }, [_c('p', {
    staticStyle: {
      "margin": "15px 0"
    }
  }, [_vm._v("评分参考标准："), _c('router-link', {
    staticClass: "el-button--text",
    attrs: {
      "to": {
        path: '/scoreTips',
        query: {
          scoreType: _vm.scoreType,
          turn: _vm.turn
        }
      },
      "target": "_blank"
    }
  }, [_vm._v("点击查看")])], 1), _vm._v(" "), _c('el-form', {
    staticClass: "evaluation-form-scoped",
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "label-width": "200px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "评分标准",
      "required": ""
    }
  }, [_c('el-input', {
    ref: "score",
    staticClass: "text-content",
    attrs: {
      "placeholder": "请按照参考评分标准，依次填写评分，如：ABBABB",
      "maxlength": 9
    },
    on: {
      "focus": function($event) {
        _vm.showScoreTip = true
      },
      "blur": function($event) {
        _vm.showScoreTip = false
      }
    },
    model: {
      value: (_vm.form.score),
      callback: function($$v) {
        _vm.$set(_vm.form, "score", $$v)
      },
      expression: "form.score"
    }
  })], 1), _vm._v(" "), _c('score-tips', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showScoreTip),
      expression: "showScoreTip"
    }],
    attrs: {
      "type": _vm.scoreType,
      "turn": _vm.turn
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "评价意见",
      "required": ""
    }
  }, [_c('el-radio-group', {
    ref: "userViewpoint",
    model: {
      value: (_vm.form.userViewpoint),
      callback: function($$v) {
        _vm.$set(_vm.form, "userViewpoint", $$v)
      },
      expression: "form.userViewpoint"
    }
  }, _vm._l((_vm.viewPointOptions), function(item, index) {
    return (item.value != '-1') ? _c('el-radio', {
      key: index,
      staticClass: "mr-20",
      attrs: {
        "label": item.value
      }
    }, [_vm._v(_vm._s(item.text))]) : _vm._e()
  }), 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.userViewpoint === '3' || _vm.form.userViewpoint === '4'),
      expression: "form.userViewpoint === '3' || form.userViewpoint === '4'"
    }],
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("无须填写薪资相关信息")])], 1), _vm._v(" "), (_vm.advise.length) ? _c('el-form-item', {
    attrs: {
      "label": "岗位建议方向",
      "required": ""
    }
  }, [_c('el-checkbox-group', {
    ref: "hireAdvice",
    model: {
      value: (_vm.form.hireAdvice),
      callback: function($$v) {
        _vm.$set(_vm.form, "hireAdvice", $$v)
      },
      expression: "form.hireAdvice"
    }
  }, _vm._l((_vm.advise), function(item, index) {
    return _c('el-checkbox', {
      key: index,
      staticClass: "mr-20",
      attrs: {
        "label": item
      }
    }, [_vm._v(_vm._s(item))])
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "建议薪资",
      "required": _vm.form.userViewpoint !== '3' && _vm.form.userViewpoint !== '4'
    }
  }, [_c('el-input', {
    ref: "adviceSalary",
    staticClass: "text-content",
    attrs: {
      "placeholder": "请输入建议薪资",
      "maxlength": 300
    },
    model: {
      value: (_vm.form.adviceSalary),
      callback: function($$v) {
        _vm.$set(_vm.form, "adviceSalary", $$v)
      },
      expression: "form.adviceSalary"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "期望薪资",
      "required": _vm.form.userViewpoint !== '3' && _vm.form.userViewpoint !== '4'
    }
  }, [_c('el-input', {
    ref: "expectSalary",
    staticClass: "text-content",
    attrs: {
      "placeholder": "请输入评价内容",
      "maxlength": 66
    },
    model: {
      value: (_vm.form.expectSalary),
      callback: function($$v) {
        _vm.$set(_vm.form, "expectSalary", $$v)
      },
      expression: "form.expectSalary"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "面试记录",
      "required": ""
    }
  }, [_c('el-input', {
    ref: "interviewRecord",
    staticClass: "text-content",
    attrs: {
      "maxlength": 8000,
      "placeholder": "请输入面试问答详情",
      "type": "textarea"
    },
    model: {
      value: (_vm.form.interviewRecord),
      callback: function($$v) {
        _vm.$set(_vm.form, "interviewRecord", $$v)
      },
      expression: "form.interviewRecord"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "综合评价",
      "required": ""
    }
  }, [_c('el-input', {
    ref: "content",
    staticClass: "text-content",
    attrs: {
      "maxlength": 2000,
      "placeholder": "请输入评价内容",
      "type": "textarea"
    },
    model: {
      value: (_vm.form.content),
      callback: function($$v) {
        _vm.$set(_vm.form, "content", $$v)
      },
      expression: "form.content"
    }
  })], 1)], 1), _vm._v(" "), (false) ? _c('society-form-tips', {
    attrs: {
      "isSociety": true,
      "scoreType": _vm.scoreType
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "button-footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("提交评估")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])], 1)], 1)
}
var society_form_2020recruitment_hangzhou_staticRenderFns = []
var society_form_2020recruitment_hangzhou_esExports = { render: society_form_2020recruitment_hangzhou_render, staticRenderFns: society_form_2020recruitment_hangzhou_staticRenderFns }
/* harmony default export */ var society_form_society_form_2020recruitment_hangzhou_defaultExport = (society_form_2020recruitment_hangzhou_esExports);
// CONCATENATED MODULE: ./src/views/evaluation/society-form/society-form-2020recruitment-hangzhou.vue
function society_form_2020recruitment_hangzhou_injectStyle (ssrContext) {
  __webpack_require__(861)
}
var society_form_2020recruitment_hangzhou_normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var society_form_2020recruitment_hangzhou___vue_styles__ = society_form_2020recruitment_hangzhou_injectStyle
/* scopeId */
var society_form_2020recruitment_hangzhou___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var society_form_2020recruitment_hangzhou___vue_module_identifier__ = null
var society_form_2020recruitment_hangzhou_Component = society_form_2020recruitment_hangzhou_normalizeComponent(
  society_form_2020recruitment_hangzhou_defaultExport,
  society_form_society_form_2020recruitment_hangzhou_defaultExport,
  society_form_2020recruitment_hangzhou___vue_styles__,
  society_form_2020recruitment_hangzhou___vue_scopeId__,
  society_form_2020recruitment_hangzhou___vue_module_identifier__
)

/* harmony default export */ var evaluation_society_form_society_form_2020recruitment_hangzhou_defaultExport = (society_form_2020recruitment_hangzhou_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/evaluation/society-form/society-form-social-qa.vue
/* harmony import */ var society_form_social_qa___WEBPACK_IMPORTED_MODULE_0_mixins_selectMapMixin__ = __webpack_require__(4);
/* harmony import */ var society_form_social_qa___WEBPACK_IMPORTED_MODULE_2__score_tips_score_tips_vue__ = __webpack_require__(92);







/* harmony default export */ var society_form_social_qa_defaultExport = ({
    mixins: [society_form_social_qa___WEBPACK_IMPORTED_MODULE_0_mixins_selectMapMixin__["a" /* default */]],
    extends: society_form_base_defaultExport,
    data: function data() {
        return {
            showScoreTip: false,
            form: {
                score: '',
                userViewpoint: '',
                hireAdvice: [],
                adviceSalary: '',
                monthBaseSalary: '',
                monthCount: '',
                otherWelfare: '',
                expectSalary: '',
                interviewRecord: '',
                content: ''
            }
        };
    },

    props: {
        recruitType: null,
        isEdit: false,
        scoreType: null,
        extInfo: null
    },
    components: {
        ScoreTips: society_form_social_qa___WEBPACK_IMPORTED_MODULE_2__score_tips_score_tips_vue__["default"],
        SocietyFormTips: evaluation_society_form_society_form_tips_defaultExport
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11a2bb05"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/evaluation/society-form/society-form-social-qa.vue
var society_form_social_qa_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticStyle: {
      "margin": "15px 0"
    }
  }, [_vm._v("评分参考标准："), _c('router-link', {
    staticClass: "el-button--text",
    attrs: {
      "to": {
        path: '/scoreTips',
        query: {
          scoreType: _vm.scoreType
        }
      },
      "target": "_blank"
    }
  }, [_vm._v("点击查看")])], 1), _vm._v(" "), _c('el-form', {
    staticClass: "evaluation-form-scoped",
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "label-width": "200px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "评分标准",
      "required": ""
    }
  }, [_c('el-input', {
    ref: "score",
    staticClass: "text-content",
    attrs: {
      "placeholder": "请按照参考评分标准，依次填写评分。如：ABBCBDSBD，如有非必考察项请用“-”代替，如：ABBCBD---（根据每轮面试要求定）",
      "maxlength": 9
    },
    on: {
      "focus": function($event) {
        _vm.showScoreTip = true
      },
      "blur": function($event) {
        _vm.showScoreTip = false
      }
    },
    model: {
      value: (_vm.form.score),
      callback: function($$v) {
        _vm.$set(_vm.form, "score", $$v)
      },
      expression: "form.score"
    }
  })], 1), _vm._v(" "), _c('score-tips', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showScoreTip),
      expression: "showScoreTip"
    }],
    attrs: {
      "type": _vm.scoreType
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "评价意见",
      "required": ""
    }
  }, [_c('el-radio-group', {
    ref: "userViewpoint",
    model: {
      value: (_vm.form.userViewpoint),
      callback: function($$v) {
        _vm.$set(_vm.form, "userViewpoint", $$v)
      },
      expression: "form.userViewpoint"
    }
  }, _vm._l((_vm.viewPointOptions), function(item, index) {
    return (item.value != '-1') ? _c('el-radio', {
      key: index,
      staticClass: "mr-20",
      attrs: {
        "label": item.value
      }
    }, [_vm._v(_vm._s(item.text))]) : _vm._e()
  }), 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.userViewpoint === '3' || _vm.form.userViewpoint === '4'),
      expression: "form.userViewpoint === '3' || form.userViewpoint === '4'"
    }],
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("无须填写薪资相关信息")])], 1), _vm._v(" "), (_vm.advise.length) ? _c('el-form-item', {
    attrs: {
      "label": "岗位建议方向",
      "required": ""
    }
  }, [_c('el-checkbox-group', {
    ref: "hireAdvice",
    model: {
      value: (_vm.form.hireAdvice),
      callback: function($$v) {
        _vm.$set(_vm.form, "hireAdvice", $$v)
      },
      expression: "form.hireAdvice"
    }
  }, _vm._l((_vm.advise), function(item, index) {
    return _c('el-checkbox', {
      key: index,
      staticClass: "mr-20",
      attrs: {
        "label": item
      }
    }, [_vm._v(_vm._s(item))])
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "建议薪资",
      "required": _vm.form.userViewpoint !== '3' && _vm.form.userViewpoint !== '4'
    }
  }, [_c('el-input', {
    ref: "adviceSalary",
    staticClass: "text-content",
    attrs: {
      "placeholder": "请输入建议薪资",
      "maxlength": 300
    },
    model: {
      value: (_vm.form.adviceSalary),
      callback: function($$v) {
        _vm.$set(_vm.form, "adviceSalary", $$v)
      },
      expression: "form.adviceSalary"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "inner-row",
    attrs: {
      "label": "当前薪资",
      "required": _vm.form.userViewpoint !== '3' && _vm.form.userViewpoint !== '4'
    }
  }, [_c('el-row', [_c('el-col', {
    staticClass: "inner-td",
    attrs: {
      "span": 4
    }
  }, [_vm._v("月基本薪资")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    ref: "monthBaseSalary",
    staticClass: "text-content",
    attrs: {
      "maxlength": 20,
      "placeholder": "建议注明 税前/税后",
      "type": "textarea"
    },
    model: {
      value: (_vm.form.monthBaseSalary),
      callback: function($$v) {
        _vm.$set(_vm.form, "monthBaseSalary", $$v)
      },
      expression: "form.monthBaseSalary"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "inner-td",
    attrs: {
      "span": 4
    }
  }, [_vm._v("薪资一年发放月数")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    ref: "monthCount",
    staticClass: "text-content",
    attrs: {
      "maxlength": 20,
      "placeholder": "填写实际月份数即可，如一年薪资发放13个月则填写：13",
      "type": "textarea"
    },
    model: {
      value: (_vm.form.monthCount),
      callback: function($$v) {
        _vm.$set(_vm.form, "monthCount", $$v)
      },
      expression: "form.monthCount"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "inner-td",
    attrs: {
      "span": 4
    }
  }, [_vm._v("其他福利补充")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    ref: "otherWelfare",
    staticClass: "text-content",
    attrs: {
      "maxlength": 100,
      "placeholder": "如：包三餐、包住宿、每月项目奖金、其他奖金等",
      "type": "textarea"
    },
    model: {
      value: (_vm.form.otherWelfare),
      callback: function($$v) {
        _vm.$set(_vm.form, "otherWelfare", $$v)
      },
      expression: "form.otherWelfare"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "期望薪资",
      "required": _vm.form.userViewpoint !== '3' && _vm.form.userViewpoint !== '4'
    }
  }, [_c('el-input', {
    ref: "expectSalary",
    staticClass: "text-content",
    attrs: {
      "placeholder": "请输入期望薪资",
      "maxlength": 66
    },
    model: {
      value: (_vm.form.expectSalary),
      callback: function($$v) {
        _vm.$set(_vm.form, "expectSalary", $$v)
      },
      expression: "form.expectSalary"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "面试记录",
      "required": ""
    }
  }, [_c('el-input', {
    ref: "interviewRecord",
    staticClass: "text-content",
    attrs: {
      "maxlength": 8000,
      "placeholder": "请输入面试问答详情",
      "type": "textarea"
    },
    model: {
      value: (_vm.form.interviewRecord),
      callback: function($$v) {
        _vm.$set(_vm.form, "interviewRecord", $$v)
      },
      expression: "form.interviewRecord"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "综合评价",
      "required": ""
    }
  }, [_c('el-input', {
    ref: "content",
    staticClass: "text-content",
    attrs: {
      "maxlength": 2000,
      "placeholder": "请输入评价内容",
      "type": "textarea"
    },
    model: {
      value: (_vm.form.content),
      callback: function($$v) {
        _vm.$set(_vm.form, "content", $$v)
      },
      expression: "form.content"
    }
  })], 1)], 1), _vm._v(" "), (false) ? _c('society-form-tips', {
    attrs: {
      "isSociety": true,
      "scoreType": _vm.scoreType
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "button-footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("提交评估")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])], 1)], 1)
}
var society_form_social_qa_staticRenderFns = []
var society_form_social_qa_esExports = { render: society_form_social_qa_render, staticRenderFns: society_form_social_qa_staticRenderFns }
/* harmony default export */ var society_form_society_form_social_qa_defaultExport = (society_form_social_qa_esExports);
// CONCATENATED MODULE: ./src/views/evaluation/society-form/society-form-social-qa.vue
function society_form_social_qa_injectStyle (ssrContext) {
  __webpack_require__(863)
}
var society_form_social_qa_normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var society_form_social_qa___vue_styles__ = society_form_social_qa_injectStyle
/* scopeId */
var society_form_social_qa___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var society_form_social_qa___vue_module_identifier__ = null
var society_form_social_qa_Component = society_form_social_qa_normalizeComponent(
  society_form_social_qa_defaultExport,
  society_form_society_form_social_qa_defaultExport,
  society_form_social_qa___vue_styles__,
  society_form_social_qa___vue_scopeId__,
  society_form_social_qa___vue_module_identifier__
)

/* harmony default export */ var evaluation_society_form_society_form_social_qa_defaultExport = (society_form_social_qa_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/evaluation/society-form/society-form-social-notqa.vue
/* harmony import */ var society_form_social_notqa___WEBPACK_IMPORTED_MODULE_0_mixins_selectMapMixin__ = __webpack_require__(4);






/* harmony default export */ var society_form_social_notqa_defaultExport = ({
    mixins: [society_form_social_notqa___WEBPACK_IMPORTED_MODULE_0_mixins_selectMapMixin__["a" /* default */]],
    extends: society_form_base_defaultExport,
    data: function data() {
        return {
            showScoreTip: false,
            form: {
                userViewpoint: '',
                hireAdvice: [],
                adviceSalary: '',
                monthBaseSalary: '',
                monthCount: '',
                otherWelfare: '',
                expectSalary: '',
                interviewRecord: '',
                content: ''
            }
        };
    },

    props: {
        recruitType: null,
        isEdit: false,
        scoreType: null,
        extInfo: null
    },
    components: {
        SocietyFormTips: evaluation_society_form_society_form_tips_defaultExport
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b2408484"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/evaluation/society-form/society-form-social-notqa.vue
var society_form_social_notqa_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    staticClass: "evaluation-form-scoped",
    attrs: {
      "label-width": "200px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "评价意见",
      "required": ""
    }
  }, [_c('el-radio-group', {
    ref: "userViewpoint",
    model: {
      value: (_vm.form.userViewpoint),
      callback: function($$v) {
        _vm.$set(_vm.form, "userViewpoint", $$v)
      },
      expression: "form.userViewpoint"
    }
  }, _vm._l((_vm.viewPointOptions), function(item, index) {
    return (item.value != '-1') ? _c('el-radio', {
      key: index,
      staticClass: "mr-20",
      attrs: {
        "label": item.value
      }
    }, [_vm._v(_vm._s(item.text))]) : _vm._e()
  }), 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.userViewpoint === '3' || _vm.form.userViewpoint === '4'),
      expression: "form.userViewpoint === '3' || form.userViewpoint === '4'"
    }],
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("无须填写薪资相关信息")])], 1), _vm._v(" "), (_vm.advise.length) ? _c('el-form-item', {
    attrs: {
      "label": "岗位建议方向",
      "required": ""
    }
  }, [_c('el-checkbox-group', {
    ref: "hireAdvice",
    model: {
      value: (_vm.form.hireAdvice),
      callback: function($$v) {
        _vm.$set(_vm.form, "hireAdvice", $$v)
      },
      expression: "form.hireAdvice"
    }
  }, _vm._l((_vm.advise), function(item, index) {
    return _c('el-checkbox', {
      key: index,
      staticClass: "mr-20",
      attrs: {
        "label": item
      }
    }, [_vm._v(_vm._s(item))])
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "建议薪资",
      "required": _vm.form.userViewpoint !== '3' && _vm.form.userViewpoint !== '4'
    }
  }, [_c('el-input', {
    ref: "adviceSalary",
    staticClass: "text-content",
    attrs: {
      "placeholder": "请输入建议薪资",
      "maxlength": 300
    },
    model: {
      value: (_vm.form.adviceSalary),
      callback: function($$v) {
        _vm.$set(_vm.form, "adviceSalary", $$v)
      },
      expression: "form.adviceSalary"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "inner-row",
    attrs: {
      "label": "当前薪资",
      "required": _vm.form.userViewpoint !== '3' && _vm.form.userViewpoint !== '4'
    }
  }, [_c('el-row', [_c('el-col', {
    staticClass: "inner-td",
    attrs: {
      "span": 4
    }
  }, [_vm._v("月基本薪资")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    ref: "monthBaseSalary",
    staticClass: "text-content",
    attrs: {
      "maxlength": 20,
      "placeholder": "建议注明 税前/税后",
      "type": "textarea"
    },
    model: {
      value: (_vm.form.monthBaseSalary),
      callback: function($$v) {
        _vm.$set(_vm.form, "monthBaseSalary", $$v)
      },
      expression: "form.monthBaseSalary"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "inner-td",
    attrs: {
      "span": 4
    }
  }, [_vm._v("薪资一年发放月数")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    ref: "monthCount",
    staticClass: "text-content",
    attrs: {
      "maxlength": 20,
      "placeholder": "填写实际月份数即可，如一年薪资发放13个月则填写：13",
      "type": "textarea"
    },
    model: {
      value: (_vm.form.monthCount),
      callback: function($$v) {
        _vm.$set(_vm.form, "monthCount", $$v)
      },
      expression: "form.monthCount"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "inner-td",
    attrs: {
      "span": 4
    }
  }, [_vm._v("其他福利补充")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    ref: "otherWelfare",
    staticClass: "text-content",
    attrs: {
      "maxlength": 100,
      "placeholder": "如：包三餐、包住宿、每月项目奖金、其他奖金等",
      "type": "textarea"
    },
    model: {
      value: (_vm.form.otherWelfare),
      callback: function($$v) {
        _vm.$set(_vm.form, "otherWelfare", $$v)
      },
      expression: "form.otherWelfare"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "期望薪资",
      "required": _vm.form.userViewpoint !== '3' && _vm.form.userViewpoint !== '4'
    }
  }, [_c('el-input', {
    ref: "expectSalary",
    staticClass: "text-content",
    attrs: {
      "placeholder": "请输入期望薪资",
      "maxlength": 66
    },
    model: {
      value: (_vm.form.expectSalary),
      callback: function($$v) {
        _vm.$set(_vm.form, "expectSalary", $$v)
      },
      expression: "form.expectSalary"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "面试记录",
      "required": ""
    }
  }, [_c('el-input', {
    ref: "interviewRecord",
    staticClass: "text-content",
    attrs: {
      "maxlength": 8000,
      "placeholder": "请输入面试问答详情",
      "type": "textarea"
    },
    model: {
      value: (_vm.form.interviewRecord),
      callback: function($$v) {
        _vm.$set(_vm.form, "interviewRecord", $$v)
      },
      expression: "form.interviewRecord"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "综合评价",
      "required": ""
    }
  }, [_c('el-input', {
    ref: "content",
    staticClass: "text-content",
    attrs: {
      "maxlength": 2000,
      "placeholder": "请输入评价内容",
      "type": "textarea"
    },
    model: {
      value: (_vm.form.content),
      callback: function($$v) {
        _vm.$set(_vm.form, "content", $$v)
      },
      expression: "form.content"
    }
  })], 1)], 1), _vm._v(" "), (false) ? _c('society-form-tips', {
    attrs: {
      "isSociety": true,
      "scoreType": _vm.scoreType
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "button-footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("提交评估")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])], 1)], 1)
}
var society_form_social_notqa_staticRenderFns = []
var society_form_social_notqa_esExports = { render: society_form_social_notqa_render, staticRenderFns: society_form_social_notqa_staticRenderFns }
/* harmony default export */ var society_form_society_form_social_notqa_defaultExport = (society_form_social_notqa_esExports);
// CONCATENATED MODULE: ./src/views/evaluation/society-form/society-form-social-notqa.vue
function society_form_social_notqa_injectStyle (ssrContext) {
  __webpack_require__(865)
}
var society_form_social_notqa_normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var society_form_social_notqa___vue_styles__ = society_form_social_notqa_injectStyle
/* scopeId */
var society_form_social_notqa___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var society_form_social_notqa___vue_module_identifier__ = null
var society_form_social_notqa_Component = society_form_social_notqa_normalizeComponent(
  society_form_social_notqa_defaultExport,
  society_form_society_form_social_notqa_defaultExport,
  society_form_social_notqa___vue_styles__,
  society_form_social_notqa___vue_scopeId__,
  society_form_social_notqa___vue_module_identifier__
)

/* harmony default export */ var evaluation_society_form_society_form_social_notqa_defaultExport = (society_form_social_notqa_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/evaluation/society-form/society-form-verify-qa.vue
/* harmony import */ var society_form_verify_qa___WEBPACK_IMPORTED_MODULE_0_mixins_selectMapMixin__ = __webpack_require__(4);
/* harmony import */ var society_form_verify_qa___WEBPACK_IMPORTED_MODULE_2__score_tips_score_tips_vue__ = __webpack_require__(92);







/* harmony default export */ var society_form_verify_qa_defaultExport = ({
    mixins: [society_form_verify_qa___WEBPACK_IMPORTED_MODULE_0_mixins_selectMapMixin__["a" /* default */]],
    extends: society_form_base_defaultExport,
    data: function data() {
        return {
            showScoreTip: false,
            form: {
                score: '',
                userViewpoint: '',
                hireAdvice: [],
                adviceSalary: '',
                monthBaseSalary: '',
                monthCount: '',
                otherWelfare: '',
                expectSalary: '',
                interviewRecord: '',
                content: ''
            }
        };
    },

    props: {
        recruitType: null,
        isEdit: false,
        scoreType: null,
        extInfo: null
    },
    components: {
        ScoreTips: society_form_verify_qa___WEBPACK_IMPORTED_MODULE_2__score_tips_score_tips_vue__["default"],
        SocietyFormTips: evaluation_society_form_society_form_tips_defaultExport
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75674479"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/evaluation/society-form/society-form-verify-qa.vue
var society_form_verify_qa_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticStyle: {
      "margin": "15px 0"
    }
  }, [_vm._v("评分参考标准："), _c('router-link', {
    staticClass: "el-button--text",
    attrs: {
      "to": {
        path: '/scoreTips',
        query: {
          scoreType: _vm.scoreType
        }
      },
      "target": "_blank"
    }
  }, [_vm._v("点击查看")])], 1), _vm._v(" "), _c('el-form', {
    staticClass: "evaluation-form-scoped",
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "label-width": "200px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "评分标准",
      "required": ""
    }
  }, [_c('el-input', {
    ref: "score",
    staticClass: "text-content",
    attrs: {
      "placeholder": "请按照参考评分标准，依次填写评分。如：ABBCBDSBD，如有非必考察项请用“-”代替，如：ABBCBD---（根据每轮面试要求定）",
      "maxlength": 9
    },
    on: {
      "focus": function($event) {
        _vm.showScoreTip = true
      },
      "blur": function($event) {
        _vm.showScoreTip = false
      }
    },
    model: {
      value: (_vm.form.score),
      callback: function($$v) {
        _vm.$set(_vm.form, "score", $$v)
      },
      expression: "form.score"
    }
  })], 1), _vm._v(" "), _c('score-tips', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showScoreTip),
      expression: "showScoreTip"
    }],
    attrs: {
      "type": _vm.scoreType
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "评价意见",
      "required": ""
    }
  }, [_c('el-radio-group', {
    ref: "userViewpoint",
    model: {
      value: (_vm.form.userViewpoint),
      callback: function($$v) {
        _vm.$set(_vm.form, "userViewpoint", $$v)
      },
      expression: "form.userViewpoint"
    }
  }, _vm._l((_vm.viewPointOptions), function(item, index) {
    return (item.value != '-1') ? _c('el-radio', {
      key: index,
      staticClass: "mr-20",
      attrs: {
        "label": item.value
      }
    }, [_vm._v(_vm._s(item.text))]) : _vm._e()
  }), 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.userViewpoint === '3' || _vm.form.userViewpoint === '4'),
      expression: "form.userViewpoint === '3' || form.userViewpoint === '4'"
    }],
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("无须填写薪资相关信息")])], 1), _vm._v(" "), (_vm.advise.length) ? _c('el-form-item', {
    attrs: {
      "label": "岗位建议方向",
      "required": ""
    }
  }, [_c('el-checkbox-group', {
    ref: "hireAdvice",
    model: {
      value: (_vm.form.hireAdvice),
      callback: function($$v) {
        _vm.$set(_vm.form, "hireAdvice", $$v)
      },
      expression: "form.hireAdvice"
    }
  }, _vm._l((_vm.advise), function(item, index) {
    return _c('el-checkbox', {
      key: index,
      staticClass: "mr-20",
      attrs: {
        "label": item
      }
    }, [_vm._v(_vm._s(item))])
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "建议薪资",
      "required": _vm.form.userViewpoint !== '3' && _vm.form.userViewpoint !== '4'
    }
  }, [_c('el-input', {
    ref: "adviceSalary",
    staticClass: "text-content",
    attrs: {
      "placeholder": "请输入建议薪资",
      "maxlength": 300
    },
    model: {
      value: (_vm.form.adviceSalary),
      callback: function($$v) {
        _vm.$set(_vm.form, "adviceSalary", $$v)
      },
      expression: "form.adviceSalary"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "inner-row",
    attrs: {
      "label": "当前薪资",
      "required": _vm.form.userViewpoint !== '3' && _vm.form.userViewpoint !== '4'
    }
  }, [_c('el-row', [_c('el-col', {
    staticClass: "inner-td",
    attrs: {
      "span": 4
    }
  }, [_vm._v("月基本薪资")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    ref: "monthBaseSalary",
    staticClass: "text-content",
    attrs: {
      "maxlength": 20,
      "placeholder": "建议注明 税前/税后",
      "type": "textarea"
    },
    model: {
      value: (_vm.form.monthBaseSalary),
      callback: function($$v) {
        _vm.$set(_vm.form, "monthBaseSalary", $$v)
      },
      expression: "form.monthBaseSalary"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "inner-td",
    attrs: {
      "span": 4
    }
  }, [_vm._v("薪资一年发放月数")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    ref: "monthCount",
    staticClass: "text-content",
    attrs: {
      "maxlength": 20,
      "placeholder": "填写实际月份数即可，如一年薪资发放13个月则填写：13",
      "type": "textarea"
    },
    model: {
      value: (_vm.form.monthCount),
      callback: function($$v) {
        _vm.$set(_vm.form, "monthCount", $$v)
      },
      expression: "form.monthCount"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "inner-td",
    attrs: {
      "span": 4
    }
  }, [_vm._v("其他福利补充")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    ref: "otherWelfare",
    staticClass: "text-content",
    attrs: {
      "maxlength": 100,
      "placeholder": "如：包三餐、包住宿、每月项目奖金、其他奖金等",
      "type": "textarea"
    },
    model: {
      value: (_vm.form.otherWelfare),
      callback: function($$v) {
        _vm.$set(_vm.form, "otherWelfare", $$v)
      },
      expression: "form.otherWelfare"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "期望薪资",
      "required": _vm.form.userViewpoint !== '3' && _vm.form.userViewpoint !== '4'
    }
  }, [_c('el-input', {
    ref: "expectSalary",
    staticClass: "text-content",
    attrs: {
      "placeholder": "请输入期望薪资",
      "maxlength": 66
    },
    model: {
      value: (_vm.form.expectSalary),
      callback: function($$v) {
        _vm.$set(_vm.form, "expectSalary", $$v)
      },
      expression: "form.expectSalary"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "面试记录",
      "required": ""
    }
  }, [_c('el-input', {
    ref: "interviewRecord",
    staticClass: "text-content",
    attrs: {
      "maxlength": 8000,
      "placeholder": "请输入面试问答详情",
      "type": "textarea"
    },
    model: {
      value: (_vm.form.interviewRecord),
      callback: function($$v) {
        _vm.$set(_vm.form, "interviewRecord", $$v)
      },
      expression: "form.interviewRecord"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "综合评价",
      "required": ""
    }
  }, [_c('el-input', {
    ref: "content",
    staticClass: "text-content",
    attrs: {
      "maxlength": 2000,
      "placeholder": "请输入评价内容",
      "type": "textarea"
    },
    model: {
      value: (_vm.form.content),
      callback: function($$v) {
        _vm.$set(_vm.form, "content", $$v)
      },
      expression: "form.content"
    }
  })], 1)], 1), _vm._v(" "), (false) ? _c('society-form-tips', {
    attrs: {
      "isSociety": true,
      "scoreType": _vm.scoreType
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "button-footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("提交评估")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])], 1)], 1)
}
var society_form_verify_qa_staticRenderFns = []
var society_form_verify_qa_esExports = { render: society_form_verify_qa_render, staticRenderFns: society_form_verify_qa_staticRenderFns }
/* harmony default export */ var society_form_society_form_verify_qa_defaultExport = (society_form_verify_qa_esExports);
// CONCATENATED MODULE: ./src/views/evaluation/society-form/society-form-verify-qa.vue
function society_form_verify_qa_injectStyle (ssrContext) {
  __webpack_require__(867)
}
var society_form_verify_qa_normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var society_form_verify_qa___vue_styles__ = society_form_verify_qa_injectStyle
/* scopeId */
var society_form_verify_qa___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var society_form_verify_qa___vue_module_identifier__ = null
var society_form_verify_qa_Component = society_form_verify_qa_normalizeComponent(
  society_form_verify_qa_defaultExport,
  society_form_society_form_verify_qa_defaultExport,
  society_form_verify_qa___vue_styles__,
  society_form_verify_qa___vue_scopeId__,
  society_form_verify_qa___vue_module_identifier__
)

/* harmony default export */ var evaluation_society_form_society_form_verify_qa_defaultExport = (society_form_verify_qa_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/evaluation/society-form/society-form-simple.vue
/* harmony import */ var society_form_simple___WEBPACK_IMPORTED_MODULE_0_mixins_selectMapMixin__ = __webpack_require__(4);




/* harmony default export */ var society_form_simple_defaultExport = ({
    data: function data() {
        return {
            gradeOption: [{ text: 'S', value: 'S' }, { text: 'A', value: 'A' }, { text: 'B', value: 'B' }, { text: 'C', value: 'C' }],
            form: {
                userViewpoint: '',
                hireAdvice: [],
                grade: '',
                content: ''
            }
        };
    },

    extends: society_form_base_defaultExport,
    mixins: [society_form_simple___WEBPACK_IMPORTED_MODULE_0_mixins_selectMapMixin__["a" /* default */]],
    props: {
        extInfo: null,
        isEdit: false
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60b5906d"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/evaluation/society-form/society-form-simple.vue
var society_form_simple_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    staticClass: "evaluation-form-scoped",
    attrs: {
      "label-width": "200px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "评价意见",
      "required": ""
    }
  }, [_c('el-radio-group', {
    ref: "userViewpoint",
    model: {
      value: (_vm.form.userViewpoint),
      callback: function($$v) {
        _vm.$set(_vm.form, "userViewpoint", $$v)
      },
      expression: "form.userViewpoint"
    }
  }, _vm._l((_vm.viewPointOptions), function(item, index) {
    return (item.value != '-1') ? _c('el-radio', {
      key: index,
      staticClass: "mr-20",
      attrs: {
        "label": item.value
      }
    }, [_vm._v(_vm._s(item.text))]) : _vm._e()
  }), 1)], 1), _vm._v(" "), (_vm.advise.length) ? _c('el-form-item', {
    attrs: {
      "label": "岗位建议方向",
      "required": ""
    }
  }, [_c('el-checkbox-group', {
    ref: "hireAdvice",
    model: {
      value: (_vm.form.hireAdvice),
      callback: function($$v) {
        _vm.$set(_vm.form, "hireAdvice", $$v)
      },
      expression: "form.hireAdvice"
    }
  }, _vm._l((_vm.advise), function(item, index) {
    return _c('el-checkbox', {
      key: index,
      staticClass: "mr-20",
      attrs: {
        "label": item
      }
    }, [_vm._v(_vm._s(item))])
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "评价等级",
      "required": ""
    }
  }, [_c('el-radio-group', {
    ref: "grade",
    model: {
      value: (_vm.form.grade),
      callback: function($$v) {
        _vm.$set(_vm.form, "grade", $$v)
      },
      expression: "form.grade"
    }
  }, _vm._l((_vm.gradeOption), function(item, index) {
    return _c('el-radio', {
      key: index,
      staticClass: "mr-20",
      attrs: {
        "label": item.value
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    ref: "content",
    attrs: {
      "label": "综合评价",
      "required": ""
    }
  }, [_c('el-input', {
    ref: "content",
    staticClass: "text-content",
    attrs: {
      "maxlength": 2000,
      "placeholder": "请输入评价内容",
      "type": "textarea"
    },
    model: {
      value: (_vm.form.content),
      callback: function($$v) {
        _vm.$set(_vm.form, "content", $$v)
      },
      expression: "form.content"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "button-footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("提交评估")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])], 1)], 1)
}
var society_form_simple_staticRenderFns = []
var society_form_simple_esExports = { render: society_form_simple_render, staticRenderFns: society_form_simple_staticRenderFns }
/* harmony default export */ var society_form_society_form_simple_defaultExport = (society_form_simple_esExports);
// CONCATENATED MODULE: ./src/views/evaluation/society-form/society-form-simple.vue
function society_form_simple_injectStyle (ssrContext) {
  __webpack_require__(869)
}
var society_form_simple_normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var society_form_simple___vue_styles__ = society_form_simple_injectStyle
/* scopeId */
var society_form_simple___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var society_form_simple___vue_module_identifier__ = null
var society_form_simple_Component = society_form_simple_normalizeComponent(
  society_form_simple_defaultExport,
  society_form_society_form_simple_defaultExport,
  society_form_simple___vue_styles__,
  society_form_simple___vue_scopeId__,
  society_form_simple___vue_module_identifier__
)

/* harmony default export */ var evaluation_society_form_society_form_simple_defaultExport = (society_form_simple_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/evaluation/society-form/society-form-normal.vue
/* harmony import */ var society_form_normal___WEBPACK_IMPORTED_MODULE_0_mixins_selectMapMixin__ = __webpack_require__(4);






/* harmony default export */ var society_form_normal_defaultExport = ({
    mixins: [society_form_normal___WEBPACK_IMPORTED_MODULE_0_mixins_selectMapMixin__["a" /* default */]],
    extends: society_form_base_defaultExport,
    data: function data() {
        return {
            form: {
                userViewpoint: '',
                hireAdvice: [],
                content: ''
            }
        };
    },

    props: {
        recruitType: null,
        isEdit: false,
        extInfo: null
    },
    components: {
        SocietyFormTips: evaluation_society_form_society_form_tips_defaultExport
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b317922"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/evaluation/society-form/society-form-normal.vue
var society_form_normal_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    staticClass: "evaluation-form-scoped",
    attrs: {
      "label-width": "200px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "评价意见",
      "required": ""
    }
  }, [_c('el-radio-group', {
    ref: "userViewpoint",
    model: {
      value: (_vm.form.userViewpoint),
      callback: function($$v) {
        _vm.$set(_vm.form, "userViewpoint", $$v)
      },
      expression: "form.userViewpoint"
    }
  }, _vm._l((_vm.viewPointOptions), function(item, index) {
    return (item.value != '-1') ? _c('el-radio', {
      key: index,
      staticClass: "mr-20",
      attrs: {
        "label": item.value
      }
    }, [_vm._v(_vm._s(item.text))]) : _vm._e()
  }), 1)], 1), _vm._v(" "), (_vm.advise.length) ? _c('el-form-item', {
    attrs: {
      "label": "岗位建议方向",
      "required": ""
    }
  }, [_c('el-checkbox-group', {
    ref: "hireAdvice",
    model: {
      value: (_vm.form.hireAdvice),
      callback: function($$v) {
        _vm.$set(_vm.form, "hireAdvice", $$v)
      },
      expression: "form.hireAdvice"
    }
  }, _vm._l((_vm.advise), function(item, index) {
    return _c('el-checkbox', {
      key: index,
      staticClass: "mr-20",
      attrs: {
        "label": item
      }
    }, [_vm._v(_vm._s(item))])
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    ref: "content",
    attrs: {
      "label": "综合评价",
      "required": ""
    }
  }, [_c('el-input', {
    staticClass: "text-content",
    attrs: {
      "maxlength": 2000,
      "placeholder": "请输入评价内容",
      "type": "textarea"
    },
    model: {
      value: (_vm.form.content),
      callback: function($$v) {
        _vm.$set(_vm.form, "content", $$v)
      },
      expression: "form.content"
    }
  })], 1)], 1), _vm._v(" "), _c('society-form-tips', {
    attrs: {
      "isSociety": this.recruitType !== 'campus'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "button-footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("提交评估")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])], 1)], 1)
}
var society_form_normal_staticRenderFns = []
var society_form_normal_esExports = { render: society_form_normal_render, staticRenderFns: society_form_normal_staticRenderFns }
/* harmony default export */ var society_form_society_form_normal_defaultExport = (society_form_normal_esExports);
// CONCATENATED MODULE: ./src/views/evaluation/society-form/society-form-normal.vue
function society_form_normal_injectStyle (ssrContext) {
  __webpack_require__(871)
}
var society_form_normal_normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var society_form_normal___vue_styles__ = society_form_normal_injectStyle
/* scopeId */
var society_form_normal___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var society_form_normal___vue_module_identifier__ = null
var society_form_normal_Component = society_form_normal_normalizeComponent(
  society_form_normal_defaultExport,
  society_form_society_form_normal_defaultExport,
  society_form_normal___vue_styles__,
  society_form_normal___vue_scopeId__,
  society_form_normal___vue_module_identifier__
)

/* harmony default export */ var evaluation_society_form_society_form_normal_defaultExport = (society_form_normal_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/evaluation/society-form/society-form-more.vue
/* harmony import */ var society_form_more___WEBPACK_IMPORTED_MODULE_0_mixins_selectMapMixin__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__score_tips_score_tips_vue__ = __webpack_require__(92);







/* harmony default export */ var society_form_more_defaultExport = ({
    components: {
        SocietyFormTips: evaluation_society_form_society_form_tips_defaultExport, ScoreTips: __WEBPACK_IMPORTED_MODULE_3__score_tips_score_tips_vue__["default"]
    },
    mixins: [society_form_more___WEBPACK_IMPORTED_MODULE_0_mixins_selectMapMixin__["a" /* default */]],
    extends: society_form_base_defaultExport,
    data: function data() {
        var FormModel = null;
        if (this.recruitType === 'campus') {
            FormModel = {
                score: '',
                userViewpoint: '',
                hireAdvice: [],
                expectSalary: '',
                interviewRecord: '',
                content: ''
            };
        } else {
            FormModel = {
                score: '',
                userViewpoint: '',
                hireAdvice: [],
                grade: '',
                monthBaseSalary: '',
                monthCount: '',
                otherWelfare: '',
                expectSalary: '',
                interviewRecord: '',
                content: ''
            };
        }
        return {
            showScoreTip: false,
            form: FormModel,
            formValidator: {
                score: function score(val) {
                    if (/^([S|A|B|C|D|-]{9})$/.test(val)) {
                        return '';
                    } else {
                        return '评分标准的格式不符合';
                    }
                }
            }
        };
    },

    props: {
        recruitType: null,
        isEdit: false,
        scoreType: null,
        extInfo: null
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ca340560"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/evaluation/society-form/society-form-more.vue
var society_form_more_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "evaluation-form-scoped"
  }, [_c('p', {
    staticStyle: {
      "margin": "15px 0"
    }
  }, [_vm._v("评分参考标准："), _c('router-link', {
    staticClass: "el-button--text",
    attrs: {
      "to": {
        path: '/scoreTips',
        query: {
          scoreType: _vm.scoreType
        }
      },
      "target": "_blank"
    }
  }, [_vm._v("点击查看")])], 1), _vm._v(" "), _c('el-form', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "label-width": "200px",
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "评分标准",
      "required": ""
    }
  }, [_c('el-input', {
    ref: "score",
    staticClass: "text-content",
    attrs: {
      "placeholder": "请按照参考评分标准，依次填写评分。如：ABBCBDSBD，如有非必考察项请用“-”代替，如：ABBCBD---（根据每轮面试要求定）",
      "maxlength": 9
    },
    on: {
      "focus": function($event) {
        _vm.showScoreTip = true
      },
      "blur": function($event) {
        _vm.showScoreTip = false
      }
    },
    model: {
      value: (_vm.form.score),
      callback: function($$v) {
        _vm.$set(_vm.form, "score", $$v)
      },
      expression: "form.score"
    }
  })], 1), _vm._v(" "), _c('score-tips', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showScoreTip),
      expression: "showScoreTip"
    }],
    attrs: {
      "type": _vm.scoreType
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "评价意见",
      "required": ""
    }
  }, [_c('el-radio-group', {
    ref: "userViewpoint",
    model: {
      value: (_vm.form.userViewpoint),
      callback: function($$v) {
        _vm.$set(_vm.form, "userViewpoint", $$v)
      },
      expression: "form.userViewpoint"
    }
  }, _vm._l((_vm.viewPointOptions), function(item, index) {
    return (item.value != '-1') ? _c('el-radio', {
      key: item.value,
      staticClass: "mr-20",
      attrs: {
        "label": item.value
      }
    }, [_vm._v(_vm._s(item.text))]) : _vm._e()
  }), 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.userViewpoint === '3' || _vm.form.userViewpoint === '4'),
      expression: "form.userViewpoint === '3' || form.userViewpoint === '4'"
    }],
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("无须填写薪资相关信息")])], 1), _vm._v(" "), (_vm.advise.length) ? _c('el-form-item', {
    attrs: {
      "label": "岗位建议方向",
      "required": ""
    }
  }, [_c('el-checkbox-group', {
    ref: "hireAdvice",
    model: {
      value: (_vm.form.hireAdvice),
      callback: function($$v) {
        _vm.$set(_vm.form, "hireAdvice", $$v)
      },
      expression: "form.hireAdvice"
    }
  }, _vm._l((_vm.advise), function(item, index) {
    return _c('el-checkbox', {
      key: index,
      staticClass: "mr-20",
      attrs: {
        "label": item
      }
    }, [_vm._v(_vm._s(item))])
  }), 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.userViewpoint === '3' || _vm.form.userViewpoint === '4'),
      expression: "form.userViewpoint === '3' || form.userViewpoint === '4'"
    }],
    staticClass: "red"
  }, [_vm._v("无须填写薪资相关信息")])], 1) : _vm._e(), _vm._v(" "), (_vm.recruitType === 'social') ? _c('el-form-item', {
    attrs: {
      "label": "建议定级",
      "required": _vm.form.userViewpoint !== '3' && _vm.form.userViewpoint !== '4'
    }
  }, [_c('el-input', {
    ref: "grade",
    staticClass: "text-content",
    attrs: {
      "maxlength": 50,
      "placeholder": "主属性中5项B级以上建议初一，游戏/软件/兼容性测试对应的关键主属性有3项A级以上参考初二，有1项S其他A参考中一"
    },
    model: {
      value: (_vm.form.grade),
      callback: function($$v) {
        _vm.$set(_vm.form, "grade", $$v)
      },
      expression: "form.grade"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.recruitType === 'social') ? _c('el-form-item', {
    staticClass: "inner-row",
    attrs: {
      "label": "当前薪资",
      "required": _vm.form.userViewpoint !== '3' && _vm.form.userViewpoint !== '4'
    }
  }, [_c('el-row', [_c('el-col', {
    staticClass: "inner-td",
    attrs: {
      "span": 4
    }
  }, [_vm._v("月基本薪资")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    ref: "monthBaseSalary",
    staticClass: "text-content",
    attrs: {
      "maxlength": 20,
      "placeholder": "建议注明 税前/税后",
      "type": "textarea"
    },
    model: {
      value: (_vm.form.monthBaseSalary),
      callback: function($$v) {
        _vm.$set(_vm.form, "monthBaseSalary", $$v)
      },
      expression: "form.monthBaseSalary"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "inner-td",
    attrs: {
      "span": 4
    }
  }, [_vm._v("薪资一年发放月份")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    ref: "monthCount",
    staticClass: "text-content",
    attrs: {
      "maxlength": 20,
      "placeholder": "填写实际月份数即可，如一年薪资发放13个月则填写：13",
      "type": "textarea"
    },
    model: {
      value: (_vm.form.monthCount),
      callback: function($$v) {
        _vm.$set(_vm.form, "monthCount", $$v)
      },
      expression: "form.monthCount"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "inner-td",
    attrs: {
      "span": 4
    }
  }, [_vm._v("其他福利说明")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    ref: "otherWelfare",
    staticClass: "text-content",
    attrs: {
      "maxlength": 100,
      "placeholder": "如：包三餐、包住宿、每月项目奖金、其他奖金等",
      "type": "textarea"
    },
    model: {
      value: (_vm.form.otherWelfare),
      callback: function($$v) {
        _vm.$set(_vm.form, "otherWelfare", $$v)
      },
      expression: "form.otherWelfare"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "期望描述",
      "required": _vm.form.userViewpoint !== '3' && _vm.form.userViewpoint !== '4'
    }
  }, [_c('el-input', {
    ref: "expectSalary",
    staticClass: "text-content",
    attrs: {
      "maxlength": 100,
      "placeholder": "根据候选人实际要求填写即可，请尽可能详细；如年薪XX万、月薪6k*13"
    },
    model: {
      value: (_vm.form.expectSalary),
      callback: function($$v) {
        _vm.$set(_vm.form, "expectSalary", $$v)
      },
      expression: "form.expectSalary"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "面试记录",
      "required": ""
    }
  }, [_c('el-input', {
    ref: "interviewRecord",
    staticClass: "text-content",
    attrs: {
      "maxlength": 8000,
      "placeholder": "请输入面试问答详情",
      "type": "textarea"
    },
    model: {
      value: (_vm.form.interviewRecord),
      callback: function($$v) {
        _vm.$set(_vm.form, "interviewRecord", $$v)
      },
      expression: "form.interviewRecord"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "综合评价",
      "required": ""
    }
  }, [_c('el-input', {
    ref: "content",
    staticClass: "text-content",
    staticStyle: {
      "height": "100px"
    },
    attrs: {
      "maxlength": 2000,
      "placeholder": "请输入评价内容",
      "type": "textarea"
    },
    model: {
      value: (_vm.form.content),
      callback: function($$v) {
        _vm.$set(_vm.form, "content", $$v)
      },
      expression: "form.content"
    }
  })], 1)], 1), _vm._v(" "), (false) ? _c('society-form-tips', {
    attrs: {
      "isSociety": this.recruitType !== 'campus'
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "button-footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("提交评估")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])], 1)], 1)
}
var society_form_more_staticRenderFns = []
var society_form_more_esExports = { render: society_form_more_render, staticRenderFns: society_form_more_staticRenderFns }
/* harmony default export */ var society_form_society_form_more_defaultExport = (society_form_more_esExports);
// CONCATENATED MODULE: ./src/views/evaluation/society-form/society-form-more.vue
function society_form_more_injectStyle (ssrContext) {
  __webpack_require__(873)
}
var society_form_more_normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var society_form_more___vue_styles__ = society_form_more_injectStyle
/* scopeId */
var society_form_more___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var society_form_more___vue_module_identifier__ = null
var society_form_more_Component = society_form_more_normalizeComponent(
  society_form_more_defaultExport,
  society_form_society_form_more_defaultExport,
  society_form_more___vue_styles__,
  society_form_more___vue_scopeId__,
  society_form_more___vue_module_identifier__
)

/* harmony default export */ var evaluation_society_form_society_form_more_defaultExport = (society_form_more_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/evaluation/society-form/society-form-pma.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mixins_selectMapMixin__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs__ = __webpack_require__(357);







/* harmony default export */ var society_form_pma_defaultExport = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_1_mixins_selectMapMixin__["a" /* default */]],
    extends: society_form_base_defaultExport,
    data: function data() {
        return {
            scoreMapList: __WEBPACK_IMPORTED_MODULE_3__libs__["c" /* scoreMapList */],
            otherMapList: __WEBPACK_IMPORTED_MODULE_3__libs__["a" /* otherMapList */],
            skillMapList: __WEBPACK_IMPORTED_MODULE_3__libs__["e" /* skillMapList */],
            form: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
                userViewpoint: ''
            }, __WEBPACK_IMPORTED_MODULE_3__libs__["d" /* scoreProp */], __WEBPACK_IMPORTED_MODULE_3__libs__["f" /* skillProp */], __WEBPACK_IMPORTED_MODULE_3__libs__["b" /* otherProp */], {
                monthBaseSalary: '',
                monthCount: '',
                otherWelfare: '',
                expectSalary: '',
                lastEntryTime: '',
                content: ''
            })
        };
    },

    props: {
        isEdit: false,
        scoreType: null,
        turn: null,
        extInfo: null
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b0fa8f4e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/evaluation/society-form/society-form-pma.vue
var society_form_pma_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    staticClass: "evaluation-form-scoped",
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "label-width": "200px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "是否通过",
      "required": ""
    }
  }, [_c('el-radio-group', {
    ref: "userViewpoint",
    model: {
      value: (_vm.form.userViewpoint),
      callback: function($$v) {
        _vm.$set(_vm.form, "userViewpoint", $$v)
      },
      expression: "form.userViewpoint"
    }
  }, _vm._l((_vm.viewPointOptions), function(item, index) {
    return (item.value != '-1') ? _c('el-radio', {
      key: index,
      staticClass: "mr-20",
      attrs: {
        "label": item.value
      }
    }, [_vm._v(_vm._s(item.text))]) : _vm._e()
  }), 1)], 1), _vm._v(" "), (['12', '13'].includes(_vm.scoreType) && _vm.turn === '0') ? _c('el-form-item', {
    staticClass: "inner-row inner-row--pma",
    attrs: {
      "label": "综合能力",
      "required": ""
    }
  }, _vm._l((_vm.scoreMapList.slice(0, 6)), function(scoreMapItem) {
    return _c('el-row', {
      key: scoreMapItem.name
    }, [_c('el-col', {
      staticClass: "shorter inner-td required",
      attrs: {
        "span": 4
      }
    }, [_vm._v(_vm._s(scoreMapItem.name))]), _vm._v(" "), _c('el-col', {
      staticClass: "shorter",
      attrs: {
        "span": 20
      }
    }, [_c('el-radio-group', {
      ref: scoreMapItem.prop,
      refInFor: true,
      staticClass: "score-group",
      model: {
        value: (_vm.form[scoreMapItem.prop]),
        callback: function($$v) {
          _vm.$set(_vm.form, scoreMapItem.prop, $$v)
        },
        expression: "form[scoreMapItem.prop]"
      }
    }, _vm._l((5), function(n) {
      return _c('el-radio', {
        key: n,
        staticClass: "score-item",
        attrs: {
          "label": n + ''
        }
      }, [_vm._v(_vm._s(n))])
    }), 1)], 1)], 1)
  }), 1) : _vm._e(), _vm._v(" "), (['12', '13'].includes(_vm.scoreType) && _vm.turn === '0') ? _c('el-form-item', {
    staticClass: "inner-row inner-row--pma",
    attrs: {
      "label": "个人素质",
      "required": ""
    }
  }, _vm._l((_vm.scoreMapList.slice(6, 9)), function(scoreMapItem) {
    return _c('el-row', {
      key: scoreMapItem.name
    }, [_c('el-col', {
      staticClass: "shorter inner-td required",
      attrs: {
        "span": 4
      }
    }, [_vm._v(_vm._s(scoreMapItem.name))]), _vm._v(" "), _c('el-col', {
      staticClass: "shorter",
      attrs: {
        "span": 20
      }
    }, [_c('el-radio-group', {
      ref: scoreMapItem.prop,
      refInFor: true,
      staticClass: "score-group",
      model: {
        value: (_vm.form[scoreMapItem.prop]),
        callback: function($$v) {
          _vm.$set(_vm.form, scoreMapItem.prop, $$v)
        },
        expression: "form[scoreMapItem.prop]"
      }
    }, _vm._l((5), function(n) {
      return _c('el-radio', {
        key: n,
        staticClass: "score-item",
        attrs: {
          "label": n + ''
        }
      }, [_vm._v(_vm._s(n))])
    }), 1)], 1)], 1)
  }), 1) : _vm._e(), _vm._v(" "), (_vm.scoreType === '12' && _vm.turn === '0') ? _c('el-form-item', {
    attrs: {
      "label": "专业能力",
      "required": ""
    }
  }, [_c('el-input', {
    ref: "professionalProjMgr",
    staticClass: "text-content",
    attrs: {
      "maxlength": 2000,
      "placeholder": "（重点考察：计划制定、进度跟进、风险管理、干系人管理、团队配合情况等）",
      "type": "textarea"
    },
    model: {
      value: (_vm.form.professionalProjMgr),
      callback: function($$v) {
        _vm.$set(_vm.form, "professionalProjMgr", $$v)
      },
      expression: "form.professionalProjMgr"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.scoreType === '13' && _vm.turn === '0') ? _c('el-form-item', {
    staticClass: "inner-row inner-row--pma",
    attrs: {
      "label": "专业能力",
      "required": ""
    }
  }, _vm._l((_vm.skillMapList), function(skillMap) {
    return _c('el-row', {
      key: skillMap.name
    }, [_c('el-col', {
      staticClass: "inner-td required",
      attrs: {
        "span": 4
      }
    }, [_vm._v(_vm._s(skillMap.name))]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 20
      }
    }, [_c('el-input', {
      ref: skillMap.prop,
      refInFor: true,
      staticClass: "text-content",
      attrs: {
        "maxlength": 2000,
        "placeholder": skillMap.placeholder,
        "type": "textarea"
      },
      model: {
        value: (_vm.form[skillMap.prop]),
        callback: function($$v) {
          _vm.$set(_vm.form, skillMap.prop, $$v)
        },
        expression: "form[skillMap.prop]"
      }
    })], 1)], 1)
  }), 1) : _vm._e(), _vm._v(" "), (['12', '13'].includes(_vm.scoreType) && _vm.turn === '0') ? _c('el-form-item', {
    staticClass: "inner-row inner-row--pma",
    attrs: {
      "label": "其他",
      "required": ""
    }
  }, _vm._l((_vm.otherMapList), function(otherMap) {
    return _c('el-row', {
      key: otherMap.name
    }, [_c('el-col', {
      staticClass: "shorter inner-td",
      class: {
        'required': otherMap.required
      },
      attrs: {
        "span": 4
      }
    }, [_vm._v(_vm._s(otherMap.name))]), _vm._v(" "), _c('el-col', {
      staticClass: "shorter",
      attrs: {
        "span": 20
      }
    }, [_c('el-input', {
      ref: otherMap.prop,
      refInFor: true,
      staticClass: "text-content",
      attrs: {
        "maxlength": 500,
        "placeholder": "请输入"
      },
      model: {
        value: (_vm.form[otherMap.prop]),
        callback: function($$v) {
          _vm.$set(_vm.form, otherMap.prop, $$v)
        },
        expression: "form[otherMap.prop]"
      }
    })], 1)], 1)
  }), 1) : _vm._e(), _vm._v(" "), (['12', '13'].includes(_vm.scoreType)) ? _c('el-form-item', {
    attrs: {
      "label": "综合评价",
      "required": ""
    }
  }, [_c('el-input', {
    ref: "content",
    staticClass: "text-content",
    attrs: {
      "maxlength": 2000,
      "placeholder": "请输入评价内容",
      "type": "textarea"
    },
    model: {
      value: (_vm.form.content),
      callback: function($$v) {
        _vm.$set(_vm.form, "content", $$v)
      },
      expression: "form.content"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.turn === '0') ? _c('el-form-item', {
    staticClass: "inner-row",
    attrs: {
      "label": "当前薪资",
      "required": _vm.form.userViewpoint !== '3' && _vm.form.userViewpoint !== '4'
    }
  }, [_c('el-row', [_c('el-col', {
    staticClass: "inner-td",
    attrs: {
      "span": 4
    }
  }, [_vm._v("月基本薪资")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    ref: "monthBaseSalary",
    staticClass: "text-content",
    attrs: {
      "maxlength": 20,
      "placeholder": "建议注明 税前/税后",
      "type": "textarea"
    },
    model: {
      value: (_vm.form.monthBaseSalary),
      callback: function($$v) {
        _vm.$set(_vm.form, "monthBaseSalary", $$v)
      },
      expression: "form.monthBaseSalary"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "inner-td",
    attrs: {
      "span": 4
    }
  }, [_vm._v("薪资一年发放月数")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    ref: "monthCount",
    staticClass: "text-content",
    attrs: {
      "maxlength": 20,
      "placeholder": "填写实际月份数即可，如一年薪资发放16个月则填写：16",
      "type": "textarea"
    },
    model: {
      value: (_vm.form.monthCount),
      callback: function($$v) {
        _vm.$set(_vm.form, "monthCount", $$v)
      },
      expression: "form.monthCount"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "inner-td",
    attrs: {
      "span": 4
    }
  }, [_vm._v("其他福利补充")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    ref: "otherWelfare",
    staticClass: "text-content",
    attrs: {
      "maxlength": 100,
      "placeholder": "如：包三餐、包住宿、每月项目奖金、其他奖金等",
      "type": "textarea"
    },
    model: {
      value: (_vm.form.otherWelfare),
      callback: function($$v) {
        _vm.$set(_vm.form, "otherWelfare", $$v)
      },
      expression: "form.otherWelfare"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.turn === '0') ? _c('el-form-item', {
    attrs: {
      "label": "期望薪资",
      "required": _vm.form.userViewpoint !== '3' && _vm.form.userViewpoint !== '4'
    }
  }, [_c('el-input', {
    ref: "expectSalary",
    staticClass: "text-content",
    attrs: {
      "placeholder": "根据候选人实际要求填写即可，请尽可能详细；如年薪XX万、月薪6k*13",
      "maxlength": 66
    },
    model: {
      value: (_vm.form.expectSalary),
      callback: function($$v) {
        _vm.$set(_vm.form, "expectSalary", $$v)
      },
      expression: "form.expectSalary"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.scoreType === '11') ? _c('el-form-item', {
    attrs: {
      "label": "综合评价",
      "required": ""
    }
  }, [_c('el-input', {
    ref: "content",
    staticClass: "text-content",
    attrs: {
      "maxlength": 2000,
      "placeholder": "请输入评价内容",
      "type": "textarea"
    },
    model: {
      value: (_vm.form.content),
      callback: function($$v) {
        _vm.$set(_vm.form, "content", $$v)
      },
      expression: "form.content"
    }
  })], 1) : _vm._e(), _vm._v(" "), (['12', '13'].includes(_vm.scoreType) && _vm.turn === '0') ? _c('el-form-item', {
    attrs: {
      "label": "最快到岗时间",
      "required": ""
    }
  }, [_c('el-date-picker', {
    ref: "lastEntryTime",
    attrs: {
      "align": "left",
      "editable": false,
      "valueFormat": "yyyy-MM-dd",
      "placeholder": "请选择日期"
    },
    model: {
      value: (_vm.form.lastEntryTime),
      callback: function($$v) {
        _vm.$set(_vm.form, "lastEntryTime", $$v)
      },
      expression: "form.lastEntryTime"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "button-footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("提交评估")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])], 1)], 1)
}
var society_form_pma_staticRenderFns = []
var society_form_pma_esExports = { render: society_form_pma_render, staticRenderFns: society_form_pma_staticRenderFns }
/* harmony default export */ var society_form_society_form_pma_defaultExport = (society_form_pma_esExports);
// CONCATENATED MODULE: ./src/views/evaluation/society-form/society-form-pma.vue
function society_form_pma_injectStyle (ssrContext) {
  __webpack_require__(875)
}
var society_form_pma_normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var society_form_pma___vue_styles__ = society_form_pma_injectStyle
/* scopeId */
var society_form_pma___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var society_form_pma___vue_module_identifier__ = null
var society_form_pma_Component = society_form_pma_normalizeComponent(
  society_form_pma_defaultExport,
  society_form_society_form_pma_defaultExport,
  society_form_pma___vue_styles__,
  society_form_pma___vue_scopeId__,
  society_form_pma___vue_module_identifier__
)

/* harmony default export */ var evaluation_society_form_society_form_pma_defaultExport = (society_form_pma_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/evaluation/society-form/society-form-2021-qa.vue
/* harmony import */ var society_form_2021_qa___WEBPACK_IMPORTED_MODULE_0_mixins_selectMapMixin__ = __webpack_require__(4);
/* harmony import */ var society_form_2021_qa___WEBPACK_IMPORTED_MODULE_2__score_tips_score_tips_vue__ = __webpack_require__(92);







/* harmony default export */ var society_form_2021_qa_defaultExport = ({
    mixins: [society_form_2021_qa___WEBPACK_IMPORTED_MODULE_0_mixins_selectMapMixin__["a" /* default */]],
    extends: society_form_base_defaultExport,
    data: function data() {
        return {
            showScoreTip: false,
            form: {
                score: '',
                hireAdvice: [],
                userViewpoint: '',
                expectSalary: '',
                interviewRecord: '',
                content: ''
            }
        };
    },

    props: {
        recruitType: null,
        isEdit: false,
        scoreType: null,
        extInfo: null,
        turn: null
    },
    components: {
        ScoreTips: society_form_2021_qa___WEBPACK_IMPORTED_MODULE_2__score_tips_score_tips_vue__["default"],
        SocietyFormTips: evaluation_society_form_society_form_tips_defaultExport
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c3e5296"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/evaluation/society-form/society-form-2021-qa.vue
var society_form_2021_qa_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "evaluation-form-scoped"
  }, [_c('p', {
    staticStyle: {
      "margin": "15px 0"
    }
  }, [_vm._v("评分参考标准："), _c('router-link', {
    staticClass: "el-button--text",
    attrs: {
      "to": {
        path: '/scoreTips',
        query: {
          scoreType: _vm.scoreType,
          turn: _vm.turn
        }
      },
      "target": "_blank"
    }
  }, [_vm._v("点击查看")])], 1), _vm._v(" "), _c('el-form', {
    staticClass: "evaluation-form-scoped",
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "label-width": "200px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "评分标准",
      "required": ""
    }
  }, [_c('el-input', {
    ref: "score",
    staticClass: "text-content",
    attrs: {
      "placeholder": "请按照参考评分标准，依次填写评分，如：124321",
      "maxlength": 9
    },
    on: {
      "focus": function($event) {
        _vm.showScoreTip = true
      },
      "blur": function($event) {
        _vm.showScoreTip = false
      }
    },
    model: {
      value: (_vm.form.score),
      callback: function($$v) {
        _vm.$set(_vm.form, "score", $$v)
      },
      expression: "form.score"
    }
  })], 1), _vm._v(" "), _c('score-tips', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showScoreTip),
      expression: "showScoreTip"
    }],
    attrs: {
      "type": _vm.scoreType,
      "turn": _vm.turn
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否通过",
      "required": ""
    }
  }, [_c('el-radio-group', {
    ref: "userViewpoint",
    model: {
      value: (_vm.form.userViewpoint),
      callback: function($$v) {
        _vm.$set(_vm.form, "userViewpoint", $$v)
      },
      expression: "form.userViewpoint"
    }
  }, _vm._l((_vm.viewPointOptions), function(item, index) {
    return (item.value != '-1') ? _c('el-radio', {
      key: index,
      staticClass: "mr-20",
      attrs: {
        "label": item.value
      }
    }, [_vm._v(_vm._s(item.text))]) : _vm._e()
  }), 1)], 1), _vm._v(" "), (['18', '19', '20'].includes(_vm.scoreType) && _vm.advise.length) ? _c('el-form-item', {
    attrs: {
      "label": "岗位建议方向",
      "required": ""
    }
  }, [_c('el-checkbox-group', {
    ref: "hireAdvice",
    model: {
      value: (_vm.form.hireAdvice),
      callback: function($$v) {
        _vm.$set(_vm.form, "hireAdvice", $$v)
      },
      expression: "form.hireAdvice"
    }
  }, _vm._l((_vm.advise), function(item, index) {
    return _c('el-checkbox', {
      key: index,
      staticClass: "mr-20",
      attrs: {
        "label": item
      }
    }, [_vm._v(_vm._s(item))])
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "期望薪资",
      "required": _vm.form.userViewpoint !== '3' && _vm.form.userViewpoint !== '4'
    }
  }, [_c('el-input', {
    ref: "expectSalary",
    staticClass: "text-content",
    attrs: {
      "placeholder": "根据候选人实际要求填写即可，请尽可能详细；建议使用年薪作为填写内容",
      "maxlength": 66
    },
    model: {
      value: (_vm.form.expectSalary),
      callback: function($$v) {
        _vm.$set(_vm.form, "expectSalary", $$v)
      },
      expression: "form.expectSalary"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "面试记录",
      "required": ""
    }
  }, [_c('el-input', {
    ref: "interviewRecord",
    staticClass: "text-content",
    attrs: {
      "maxlength": 8000,
      "placeholder": "请输入面试问答详情",
      "type": "textarea"
    },
    model: {
      value: (_vm.form.interviewRecord),
      callback: function($$v) {
        _vm.$set(_vm.form, "interviewRecord", $$v)
      },
      expression: "form.interviewRecord"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "综合评价",
      "required": ""
    }
  }, [_c('el-input', {
    ref: "content",
    staticClass: "text-content",
    attrs: {
      "maxlength": 2000,
      "placeholder": "请输入评价内容",
      "type": "textarea"
    },
    model: {
      value: (_vm.form.content),
      callback: function($$v) {
        _vm.$set(_vm.form, "content", $$v)
      },
      expression: "form.content"
    }
  })], 1)], 1), _vm._v(" "), (false) ? _c('society-form-tips', {
    attrs: {
      "isSociety": true,
      "scoreType": _vm.scoreType
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "button-footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("提交评估")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])], 1)], 1)
}
var society_form_2021_qa_staticRenderFns = []
var society_form_2021_qa_esExports = { render: society_form_2021_qa_render, staticRenderFns: society_form_2021_qa_staticRenderFns }
/* harmony default export */ var society_form_society_form_2021_qa_defaultExport = (society_form_2021_qa_esExports);
// CONCATENATED MODULE: ./src/views/evaluation/society-form/society-form-2021-qa.vue
function society_form_2021_qa_injectStyle (ssrContext) {
  __webpack_require__(877)
}
var society_form_2021_qa_normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var society_form_2021_qa___vue_styles__ = society_form_2021_qa_injectStyle
/* scopeId */
var society_form_2021_qa___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var society_form_2021_qa___vue_module_identifier__ = null
var society_form_2021_qa_Component = society_form_2021_qa_normalizeComponent(
  society_form_2021_qa_defaultExport,
  society_form_society_form_2021_qa_defaultExport,
  society_form_2021_qa___vue_styles__,
  society_form_2021_qa___vue_scopeId__,
  society_form_2021_qa___vue_module_identifier__
)

/* harmony default export */ var evaluation_society_form_society_form_2021_qa_defaultExport = (society_form_2021_qa_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/evaluation/society-form/society-form.vue












/* harmony default export */ var society_form_defaultExport = ({
    components: {
        SocietyFormSimple: evaluation_society_form_society_form_simple_defaultExport,
        SocietyFormMore: evaluation_society_form_society_form_more_defaultExport,
        SocietyForm: evaluation_society_form_society_form_normal_defaultExport,
        SocietyFormRecruitmentGuangzhou: evaluation_society_form_society_form_2020recruitment_guangzhou_defaultExport,
        SocietyFormRecruitmentHangzhou: evaluation_society_form_society_form_2020recruitment_hangzhou_defaultExport,
        SocietyFormSocialQa: evaluation_society_form_society_form_social_qa_defaultExport,
        SocietyFormSocialNotqa: evaluation_society_form_society_form_social_notqa_defaultExport,
        SocietyFormVerifyQa: evaluation_society_form_society_form_verify_qa_defaultExport,
        SocietyFormPma: evaluation_society_form_society_form_pma_defaultExport,
        SocietyForm2021Qa: evaluation_society_form_society_form_2021_qa_defaultExport
    },
    data: function data() {
        return {
            typeList: ['4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24']
        };
    },

    props: {
        isSimple: true,
        isFull: false,
        isEdit: false,
        advise: '',
        recruitType: null,
        scoreType: null,
        extInfo: null,
        turn: null
    },
    methods: {
        refresh: function refresh() {
            this.$emit('refresh');
        },
        cancel: function cancel() {
            this.$emit('cancel');
        },
        setForm: function setForm(data) {
            this.$refs.form.setForm(data);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e0f9a22"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/evaluation/society-form/society-form.vue
var society_form_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      editForm: _vm.isEdit
    }
  }, [(_vm.isSimple) ? _c('society-form-simple', {
    ref: "form",
    attrs: {
      "isEdit": _vm.isEdit,
      "extInfo": _vm.extInfo
    },
    on: {
      "cancel": _vm.cancel,
      "refresh": _vm.refresh
    }
  }) : _c('div', [(_vm.isFull) ? _c('div', [(!_vm.typeList.includes(_vm.scoreType)) ? _c('society-form-more', {
    ref: "form",
    attrs: {
      "isEdit": _vm.isEdit,
      "advise": _vm.advise,
      "extInfo": _vm.extInfo,
      "recruitType": _vm.recruitType,
      "scoreType": _vm.scoreType
    },
    on: {
      "cancel": _vm.cancel,
      "refresh": _vm.refresh
    }
  }) : (['4', '9'].includes(_vm.scoreType)) ? _c('society-form-recruitment-guangzhou', {
    ref: "form",
    attrs: {
      "advise": _vm.advise,
      "isEdit": _vm.isEdit,
      "extInfo": _vm.extInfo,
      "recruitType": _vm.recruitType,
      "scoreType": _vm.scoreType
    },
    on: {
      "cancel": _vm.cancel,
      "refresh": _vm.refresh
    }
  }) : (['5', '10', '17', '21', '22', '23', '24'].includes(_vm.scoreType)) ? _c('society-form-recruitment-hangzhou', {
    ref: "form",
    attrs: {
      "advise": _vm.advise,
      "turn": _vm.turn,
      "isEdit": _vm.isEdit,
      "extInfo": _vm.extInfo,
      "recruitType": _vm.recruitType,
      "scoreType": _vm.scoreType
    },
    on: {
      "cancel": _vm.cancel,
      "refresh": _vm.refresh
    }
  }) : (_vm.scoreType === '6') ? _c('society-form-social-notqa', {
    ref: "form",
    attrs: {
      "advise": _vm.advise,
      "isEdit": _vm.isEdit,
      "extInfo": _vm.extInfo,
      "recruitType": _vm.recruitType,
      "scoreType": _vm.scoreType
    },
    on: {
      "cancel": _vm.cancel,
      "refresh": _vm.refresh
    }
  }) : (_vm.scoreType === '7') ? _c('society-form-social-qa', {
    ref: "form",
    attrs: {
      "advise": _vm.advise,
      "isEdit": _vm.isEdit,
      "extInfo": _vm.extInfo,
      "recruitType": _vm.recruitType,
      "scoreType": _vm.scoreType
    },
    on: {
      "cancel": _vm.cancel,
      "refresh": _vm.refresh
    }
  }) : (_vm.scoreType === '8') ? _c('society-form-verify-qa', {
    ref: "form",
    attrs: {
      "advise": _vm.advise,
      "isEdit": _vm.isEdit,
      "extInfo": _vm.extInfo,
      "recruitType": _vm.recruitType,
      "scoreType": _vm.scoreType
    },
    on: {
      "cancel": _vm.cancel,
      "refresh": _vm.refresh
    }
  }) : (['11', '12', '13'].includes(_vm.scoreType)) ? _c('society-form-pma', {
    ref: "form",
    attrs: {
      "isEdit": _vm.isEdit,
      "extInfo": _vm.extInfo,
      "scoreType": _vm.scoreType,
      "turn": _vm.turn
    },
    on: {
      "refresh": _vm.refresh,
      "cancel": _vm.cancel
    }
  }) : (['14', '15', '16', '18', '19', '20'].includes(_vm.scoreType)) ? _c('society-form-2021-qa', {
    ref: "form",
    attrs: {
      "scoreType": _vm.scoreType,
      "turn": _vm.turn,
      "advise": _vm.advise,
      "isEdit": _vm.isEdit,
      "extInfo": _vm.extInfo
    },
    on: {
      "cancel": _vm.cancel,
      "refresh": _vm.refresh
    }
  }) : _c('society-form-simple', {
    ref: "form",
    attrs: {
      "advise": _vm.advise,
      "isEdit": _vm.isEdit,
      "extInfo": _vm.extInfo
    },
    on: {
      "cancel": _vm.cancel,
      "refresh": _vm.refresh
    }
  })], 1) : _c('div', [(_vm.scoreType) ? _c('society-form', {
    ref: "form",
    attrs: {
      "isEdit": _vm.isEdit,
      "advise": _vm.advise,
      "extInfo": _vm.extInfo,
      "recruitType": _vm.recruitType
    },
    on: {
      "cancel": _vm.cancel,
      "refresh": _vm.refresh
    }
  }) : _c('society-form-simple', {
    ref: "form",
    attrs: {
      "isEdit": _vm.isEdit,
      "advise": _vm.advise,
      "extInfo": _vm.extInfo
    },
    on: {
      "cancel": _vm.cancel,
      "refresh": _vm.refresh
    }
  })], 1)])], 1)
}
var society_form_staticRenderFns = []
var society_form_esExports = { render: society_form_render, staticRenderFns: society_form_staticRenderFns }
/* harmony default export */ var society_form_society_form_defaultExport = (society_form_esExports);
// CONCATENATED MODULE: ./src/views/evaluation/society-form/society-form.vue
var society_form_normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var society_form___vue_styles__ = null
/* scopeId */
var society_form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var society_form___vue_module_identifier__ = null
var society_form_Component = society_form_normalizeComponent(
  society_form_defaultExport,
  society_form_society_form_defaultExport,
  society_form___vue_styles__,
  society_form___vue_scopeId__,
  society_form___vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (society_form_Component.exports);


/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = debouncing;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return dom; });

function debouncing(fn, delay, context) {
    var timer = void 0;
    return function () {
        clearTimeout(timer);
        var args = arguments;
        var _context = context || this;
        timer = setTimeout(function () {
            fn.apply(_context, args);
        }, delay);
    };
}

var dom = {
    offset: function offset(curEle) {
        var totalLeft = null,
            totalTop = null,
            par = curEle.offsetParent;

        totalLeft += curEle.offsetLeft;
        totalTop += curEle.offsetTop;

        while (par) {
            if (navigator.userAgent.indexOf('MSIE 8.0') === -1) {
                totalLeft += par.clientLeft;
                totalTop += par.clientTop;
            }

            totalLeft += par.offsetLeft;
            totalTop += par.offsetTop;
            par = par.offsetParent;
        }
        return { left: totalLeft, top: totalTop };
    }
};

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return scoreMapList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return otherMapList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return skillMapList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return scoreProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return otherProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return skillProp; });
var scoreMapList = [{ name: '沟通表达', prop: 'comCommunication' }, { name: '逻辑思维', prop: 'comLogical' }, { name: '学习能力', prop: 'comLearning' }, { name: '抗压力', prop: 'comCrush' }, { name: '执行力', prop: 'comExecutive' }, { name: '应变', prop: 'comStrain' }, { name: '亲和力', prop: 'perAffinity' }, { name: '踏实度', prop: 'perSolid' }, { name: '外向性', prop: 'perExtroversion' }];

var otherMapList = [{ name: '热爱度与平台认可度', prop: 'otherRecognition', required: true }, { name: '职业规划', prop: 'otherCareerPlan', required: true }, { name: '家庭情况', prop: 'otherFamilyInfo', required: true }, { name: '其他加分项', prop: 'otherInfo', required: false }];

var skillMapList = [{ name: '项目管理', prop: 'professionalProjMgr', placeholder: '（重点考察：计划制定、进度跟进、风险管理、干系人管理、团队配合情况等）' }, { name: '美术背景', prop: 'professionalArt', placeholder: '（重点考察：绘画、MAX/Maya、视频剪辑等美术相关功底；美术外包管理经验、影视动画管理经验）' }];

function getProps(list) {
    var initVal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    return list.reduce(function (ret, next) {
        return ret[next.prop] = initVal, ret;
    }, {});
}

var scoreProp = getProps(scoreMapList);
var otherProp = getProps(otherMapList);
var skillProp = getProps(skillMapList);

/***/ }),
/* 358 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAkCAYAAAGMO0iAAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA4RpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo3NjJmNzQ5ZC00NTM5LTAyNDQtYmRhOS1mM2RlYjY1MzliMjMiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6Q0FBM0Q0Nzc4NkY4MTFFN0E2MDNBRkE1RDMzOUVEMEMiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6Q0FBM0Q0NzY4NkY4MTFFN0E2MDNBRkE1RDMzOUVEMEMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKFdpbmRvd3MpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6ODU0NWQ3ZmUtZWI0Yy1mMjRhLTkyOTAtMzRlMDJhODhlMzlmIiBzdFJlZjpkb2N1bWVudElEPSJhZG9iZTpkb2NpZDpwaG90b3Nob3A6NTIxOGZjZDUtODMyZC0xMWU3LWEzY2QtZWM1ZDQyYWEwN2UzIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+tkX+hAAAAdFJREFUeNpiFNxZwAAE/xmQABO6AEyQAafgO7d+hjl6cWA2CxB/AmI+oV2FcJUAAcQItAjdzE/YzOTDbRHIEmZGhDzIIgZkS0AAIICwWcSA1+30VwgQQCA3rgXSQQTUqTERoQgEbg2gZ3AqnKYThcJnQVcAik9sUYihEF0ByW4ECCBiA5yBFE9TzTCsfkYOJJD/YYFFbNgQnQ9o6kJcriPJhSesKxisj3UxzNSNAfNTLi2ij5eZGKgMQAZqUtG8DwABBPKyKpBxBlRyUmjYOiAOBsXyLSq5DpRB1lI7DINoEikMIysvD9MwpEppAwOglsYhyxJwyUORl6foRIINe+3ay2B3vIf0MIR5FUZzM7OBDRPdXczw9/8/6nl56Ccbahv4BWTgByoaaAoQYKBIUQdVakAswDC4AMijFqCcd4oK1QktACjAzjANUsfBAA8TwyAHg96BLKRqQO9K4KphcQF8NQdditbRKKZVFJMataNRjNwCmq0XCw5p9M48TaKYEJilG8sQImnEsOHFBYZ/DP8ZgiQMGda9OE+wIUS1KMaXBmFioFDbZV7AwMfCwWBxtIMsh42mwRHlwHWD2H3rQA4MBmINqEM/DwJHfYa6BeSmYACulJ7eySAmXQAAAABJRU5ErkJggg=="

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/operation/modifySalaryDialog.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fetchPositionListMixin__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mixins_selectMapMixin__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mixins_formCommonMixin__ = __webpack_require__(25);






/* harmony default export */ var modifySalaryDialog_defaultExport = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_1__fetchPositionListMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2_mixins_selectMapMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3_mixins_formCommonMixin__["a" /* default */]],
    data: function data() {
        return {
            showDialog: false,
            isSingle: true,
            confirmInfo: {
                name: '',
                gender: '',
                phone: '',
                email: '',
                position: '',
                school: ''
            },
            sSchoolLevelList: [],
            sStructureList: [],
            sLevelList: [],
            selectedCount: 0,
            preventKey: 1,
            ruleForm: {
                resumePositionId: null,
                resumePositionIdList: null,
                paymentLevel: null,
                remark: '',
                secLevel: null
            },
            paymentConf: {},
            rules: {
                paymentLevel: { required: true, message: '请输入定薪结构', trigger: 'change' },
                secLevel: { required: true, message: '请输入定薪级别', trigger: 'change' },
                interviewersEvaluate: { required: true, message: '请输入面试官综合评价', trigger: 'blur,change' }
            }
        };
    },

    computed: {
        paymentInfo: function paymentInfo() {
            var _this = this;

            var obj = null;
            console.log(this.paymentConf.list);
            if (this.paymentConf && this.ruleForm.paymentLevel && this.paymentConf.list) {
                this.paymentConf.list.forEach(function (item) {
                    if (item.secLevel === _this.ruleForm.secLevel) {
                        item.paymentList.forEach(function (one) {
                            if (one.paymentLevel === _this.ruleForm.paymentLevel) {
                                obj = one;
                            }
                        });
                    }
                });
            }
            return obj;
        },
        paymentMonth: function paymentMonth() {
            return this.paymentInfo ? this.paymentInfo.paymentMonth : 0;
        },
        paymentTotal: function paymentTotal() {
            return this.paymentInfo ? this.paymentInfo.paymentTotal : 0;
        }
    },
    methods: {
        changeLevel: function changeLevel(data) {
            var _this2 = this;

            if (this.paymentConf.list) {
                this.paymentConf.list.forEach(function (item) {
                    if (item.secLevel === data) {
                        _this2.sStructureList = item.paymentList;
                    }
                });
                this.ruleForm.paymentLevel = '';
            }
        },
        initData: function initData() {},
        getTitle: function getTitle() {
            return this.isSingle ? '定薪修改' : '定薪批量修改';
        },
        show: function show(data) {
            var _this3 = this;

            var single = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            console.log(data);
            this.preventKey = +new Date();
            this.isSingle = single;
            this.initData();
            if (this.isSingle) {
                this.confirmInfo = {
                    name: data.resumeForm.name,
                    gender: data.resumeForm.gender,
                    phone: data.resumeForm.mobilePhone,
                    email: data.resumeForm.email,
                    position: data.positionForm.name,
                    school: data.resumeForm.resumeMaxEducation.school,
                    sLevel: data.resumeForm.resumeMaxEducation.sLevel
                };
                for (var key in this.ruleForm) {
                    this.ruleForm[key] = data.resumePayment[key];
                }
                this.ruleForm.resumePositionId = data.id;
            } else {
                this.selectedCount = data.length;
                this.ruleForm.resumePositionIdList = data.map(function (item) {
                    return item.id;
                }).join(',');
            }
            this.$axios.post('/payment/queryTemplateByPositionId.api', {
                id: this.isSingle ? data.positionForm.id : data[0].positionForm.id
            }).then(function (res) {
                _this3.paymentConf = res.result;
                if (_this3.ruleForm.secLevel) {
                    var paymentLevel = _this3.ruleForm.paymentLevel;
                    _this3.changeLevel(_this3.ruleForm.secLevel);
                    _this3.ruleForm.paymentLevel = paymentLevel;
                }
                _this3.showDialog = true;
            });
        },
        saveForm: function saveForm() {
            var _this4 = this;

            var url = this.isSingle ? '/payment/updateEva.api' : '/payment/batchUpdateEva.api';
            this.$axios.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.ruleForm, {
                paymentTotal: this.paymentTotal,
                paymentMonth: this.paymentMonth
            }), { 'X-showMessage': true }).then(function (res) {
                _this4.showDialog = false;
                _this4.$emit('reload');
            }).catch(console.error);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f24e7cc"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/operation/modifySalaryDialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "recommend-resume-dialog",
    attrs: {
      "title": _vm.getTitle(),
      "visible": _vm.showDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.showDialog = $event
      }
    }
  }, [(_vm.isSingle) ? _c('div', {
    key: _vm.preventKey,
    staticClass: "content-confirm border-radius"
  }, [_c('h1', {
    staticClass: "text-center"
  }, [_vm._v("候选人信息")]), _vm._v(" "), _c('el-row', [_c('el-col', [_c('p', [_c('span', [_vm._v("候选人：" + _vm._s(_vm.confirmInfo.name))]), _vm._v(" "), _c('span', {
    staticClass: "ml-20"
  }, [_vm._v("性别：" + _vm._s(_vm.getSelectMapText('WB_GENDER', _vm.confirmInfo.gender) || '-'))]), _vm._v(" "), _c('span', {
    staticClass: "ml-20"
  }, [_vm._v("手机号：" + _vm._s(_vm.confirmInfo.phone))]), _vm._v(" "), _c('span', {
    staticClass: "ml-20"
  }, [_vm._v("邮箱：" + _vm._s(_vm.confirmInfo.email))])]), _vm._v(" "), _c('p', {
    staticClass: "mt-10"
  }, [_vm._v("当前职位：" + _vm._s(_vm.confirmInfo.position)), _c('span', {
    staticClass: "ml-20"
  }, [_vm._v("最高学历学校：" + _vm._s(_vm.confirmInfo.school))]), (_vm.confirmInfo.sLevel) ? _c('span', [_vm._v("【" + _vm._s(_vm.confirmInfo.sLevel) + "】")]) : _vm._e()])])], 1)], 1) : _c('div', {
    staticClass: "content-confirm-multiple"
  }, [_c('h1', [_vm._v("已勾选"), _c('span', [_vm._v(_vm._s(_vm.selectedCount))]), _vm._v("条记录")])]), _vm._v(" "), _c("el-form", {
    key: _vm.preventKey,
    ref: "ruleForm",
    tag: "el-form",
    staticClass: "form-beauty",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "150px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "定级",
      "prop": "secLevel"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "300px",
      "display": "inline-block"
    },
    attrs: {
      "size": "medium",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.changeLevel
    },
    model: {
      value: (_vm.ruleForm.secLevel),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "secLevel", $$v)
      },
      expression: "ruleForm.secLevel"
    }
  }, _vm._l((_vm.paymentConf.list), function(option, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": option.secLevel,
        "value": option.secLevel
      }
    })
  }), 1), _vm._v(" "), (_vm.paymentConf.preUrl) ? _c('span', {
    staticClass: "ml-20"
  }, [_c('a', {
    attrs: {
      "href": _vm.paymentConf.preUrl,
      "target": "_blank"
    }
  }, [_vm._v("查看定级说明")])]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "定薪",
      "prop": "paymentLevel"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "300px",
      "display": "inline-block"
    },
    attrs: {
      "size": "medium",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.ruleForm.paymentLevel),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "paymentLevel", $$v)
      },
      expression: "ruleForm.paymentLevel"
    }
  }, _vm._l((_vm.sStructureList), function(option, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": option.paymentLevel,
        "value": option.paymentLevel
      }
    })
  }), 1), _vm._v(" "), (_vm.paymentInfo) ? _c('span', {
    staticClass: "ml-20"
  }, [_vm._v("offer标准：" + _vm._s(_vm.paymentMonth))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "row": 2,
      "placeholder": "请输入内容",
      "maxlength": 1000
    },
    model: {
      value: (_vm.ruleForm.remark),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "remark", $$v)
      },
      expression: "ruleForm.remark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showDialog = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("确认")])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var operation_modifySalaryDialog_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/views/operation/modifySalaryDialog.vue
function injectStyle (ssrContext) {
  __webpack_require__(897)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  modifySalaryDialog_defaultExport,
  operation_modifySalaryDialog_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/statusIcon.vue


/* harmony default export */ var statusIcon_defaultExport = ({
    name: 'statusIcon',
    props: {
        icon: String
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05ace6cf"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/statusIcon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    class: ['status-icon', _vm.icon]
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_statusIcon_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/components/statusIcon.vue
function injectStyle (ssrContext) {
  __webpack_require__(920)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-05ace6cf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  statusIcon_defaultExport,
  components_statusIcon_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            lists: [],
            watchRoute: true
        };
    },

    computed: {
        ids: function ids() {
            return this.$route.params.ids;
        },
        idsLength: function idsLength() {
            return this.ids === -1 ? 0 : this.ids.split(',').length;
        }
    },
    watch: {
        $route: function $route() {
            this.watchRoute && this.fetchList();
        }
    },
    methods: {
        fetchList: function fetchList() {
            var _this = this;

            var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/arrangeExam/newArrange.api';

            if (String(this.ids) === '-1') {
                this.lists = [];
                return false;
            }
            this.$axios.get(url, { params: { ids: this.ids } }).then(function (res) {
                _this.lists = res.result.list;
                _this.fetchCallback(res);
            }).catch(console.error);
        },
        fetchCallback: function fetchCallback(res) {},
        removeItem: function removeItem(id) {
            console.log(this.$refs);
            var ids = this.ids.split(',');
            var index = ids.indexOf(id + '');
            ids.splice(index, 1);
            this.$router.replace({
                name: this.$route.name,
                params: { ids: ids.length ? ids.join(',') : -1 }
            });
        },
        cancelAndBack: function cancelAndBack() {
            var _this2 = this;

            this.$confirm('确定放弃操作，并返回笔试列表？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                _this2.$router.replace({ name: 'writtenList' });
            }).catch(function () {});
        }
    }
});

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/position/recommendList.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_queryListExtend__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__positionMixin__ = __webpack_require__(234);





/* harmony default export */ var recommendList_defaultExport = ({
    'extends': __WEBPACK_IMPORTED_MODULE_0_components_queryListExtend__["a" /* default */],
    'mixins': [__WEBPACK_IMPORTED_MODULE_1__positionMixin__["a" /* default */]],
    data: function data() {
        return {
            fetchUrl: '/resume/list.api',
            filterConf: [{
                filter: 'WB_RESUME_STATUS_0',
                label: '简历状态',
                data: [],
                name: 'statusSearch'
            }, {
                filter: 'WB_RESUME_SOURCE',
                label: '简历来源',
                data: [],
                name: 'resumeResumeSourceSearch'
            }],
            searchData: {
                searchWord: null
            }
        };
    },

    methods: {
        addResume: function addResume() {
            this.$refs.addResumeDialog.show();
        },
        fetchCallback: function fetchCallback(res) {
            console.log('resumeList:', res);
        },
        recommendResume: function recommendResume(item) {
            this.$refs.recommendResumeDialog.show(item);
        }
    },
    components: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00915f0c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/position/recommendList.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.firstRendered) ? _c('div', [_c('div', {
    staticClass: "filter-condition box-shadow-small border-radius"
  }, [_c('div', {
    staticClass: "search-box"
  }, [_c('el-button', {
    staticClass: "search-hd",
    attrs: {
      "type": "primary",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        return _vm.searchKeyword(_vm.keyword)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "search-bd"
  }, [_c('search-bar', {
    attrs: {
      "ajaxSearch": false,
      "placeholder": "请输入职位、姓名、手机号、邮箱进行搜索"
    },
    on: {
      "enter-key": _vm.searchKeyword,
      "select": _vm.searchKeyword
    },
    model: {
      value: (_vm.keyword),
      callback: function($$v) {
        _vm.keyword = $$v
      },
      expression: "keyword"
    }
  })], 1)], 1), _vm._v(" "), _c('filter-panel', {
    ref: "condition",
    on: {
      "params-change": _vm.getParams
    }
  }, _vm._l((_vm.filterConf), function(item, index) {
    return _c('filter-panel-item', {
      key: index,
      attrs: {
        "label": item.label,
        "mode": item.mode,
        "name": item.name,
        "data": item.data,
        "initValue": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "filter-result background-white box-shadow-small border-radius"
  }, [_c('div', {
    staticClass: "filter-result-header mt-15 clearfix"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [(_vm.lists.length) ? _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "end"
    }
  }, [_c('el-button', {
    attrs: {
      "icon": "el-icon-my-queding color-success",
      "type": "success",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.idStr, '010')
      }
    }
  }, [_vm._v("加入专场\n                        ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-guanbi color-danger",
      "type": "danger",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.idStr, '002')
      }
    }
  }, [_vm._v("移出专场\n                        ")])], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.partialLoading),
      expression: "partialLoading"
    }]
  }, [_c('empty-tip', {
    attrs: {
      "show": !_vm.lists.length
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "table-list mt-20"
  }, [(_vm.lists.length) ? _c('el-table', {
    attrs: {
      "data": _vm.lists
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "职位编号",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('router-link', {
          staticClass: "name-txt",
          attrs: {
            "target": "_blank",
            "to": ("/resume/detail/" + (scope.row.id) + "/" + (_vm.getPhase(scope.row.status)))
          }
        }, [_vm._v("\n                                " + _vm._s(scope.row.resumeForm.name) + "\n                                "), _c('i', {
          class: {
            'el-icon-my-nan': scope.row.resumeForm.gender === 1, 'el-icon-my-nv color-danger': scope.row.resumeForm.gender === 2
          },
          staticStyle: {
            "transform": "scale(.7)"
          }
        })])]
      }
    }], null, false, 2054537056)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resumeForm.mobilePhone",
      "label": "职位名称",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "工作地点",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.positionForm.name) + "\n                        ")]
      }
    }], null, false, 2092161755)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "招聘人数",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.resumeForm.workYears || '-') + "\n                        ")]
      }
    }], null, false, 2631934092)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "招聘部门",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.getSelectMapText('WB_RESUME_SOURCE', scope.row.resumeForm.resumeSource)) + "\n                        ")]
      }
    }], null, false, 3166876443)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "审核时间",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.resumeForm.gameExperience) + "\n                        ")]
      }
    }], null, false, 3038609676)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "跟进人",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.getSelectMapText('WB_FLOW_STATUS', scope.row.status)) + "\n                        ")]
      }
    }], null, false, 1024731912)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.getSelectMapText('WB_FLOW_STATUS', scope.row.status)) + "\n                        ")]
      }
    }], null, false, 1024731912)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "class-name": "no-wrap",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.recommendResume(scope.row)
            }
          }
        }, [_vm._v("移出")])]
      }
    }], null, false, 3718448925)
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.lists.length) ? _c('el-pagination', {
    staticClass: "text-center mt-20 mb-20",
    attrs: {
      "current-page": _vm.pagination.pageIndex,
      "page-size": _vm.pagination.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.pagination.recordCounts
    },
    on: {
      "size-change": _vm.pageSizeChange,
      "current-change": _vm.pageIndexChange
    }
  }) : _vm._e()], 1)])]) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var position_recommendList_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/views/position/recommendList.vue
function injectStyle (ssrContext) {
  __webpack_require__(953)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  recommendList_defaultExport,
  position_recommendList_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-614be14b"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/listItemTpl.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-item"
  }, [(_vm.$slots.top) ? _c('div', {
    staticClass: "list-item-bottom"
  }, [_vm._t("bottom", [_vm._v("list-item-top的内容")])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "list-item-body"
  }, [_vm._t("default", [_vm._v("list-item-body的内容")])], 2), _vm._v(" "), (_vm.$slots.bottom) ? _c('div', {
    staticClass: "list-item-bottom"
  }, [_vm._t("bottom", [_vm._v("list-item-bottom的内容")])], 2) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var listItemTpl_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/components/listItemTpl.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_listItemTpl_vue__ = __webpack_require__(965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_listItemTpl_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_listItemTpl_vue__);
function injectStyle (ssrContext) {
  __webpack_require__(963)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-614be14b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_listItemTpl_vue___default.a,
  listItemTpl_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_listItemTpl_defaultExport = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/roundButton.vue


/* harmony default export */ var roundButton_defaultExport = ({
    props: {
        'type': {
            'type': String,
            'default': 'info'
        },
        fontSize: {
            type: Number,
            'default': 14
        },
        size: {
            type: Number,
            'default': 60
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ae3f04c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/roundButton.vue
var roundButton_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-button', {
    staticClass: "round-button",
    style: ({
      width: _vm.size + 'px',
      height: _vm.size + 'px'
    }),
    attrs: {
      "type": _vm.type
    }
  }, [_c('span', {
    style: ({
      fontSize: _vm.fontSize + 'px'
    })
  }, [_vm._t("default")], 2)])
}
var roundButton_staticRenderFns = []
var roundButton_esExports = { render: roundButton_render, staticRenderFns: roundButton_staticRenderFns }
/* harmony default export */ var components_roundButton_defaultExport = (roundButton_esExports);
// CONCATENATED MODULE: ./src/components/roundButton.vue
function roundButton_injectStyle (ssrContext) {
  __webpack_require__(966)
}
var roundButton_normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var roundButton___vue_styles__ = roundButton_injectStyle
/* scopeId */
var roundButton___vue_scopeId__ = "data-v-2ae3f04c"
/* moduleIdentifier (server only) */
var roundButton___vue_module_identifier__ = null
var roundButton_Component = roundButton_normalizeComponent(
  roundButton_defaultExport,
  components_roundButton_defaultExport,
  roundButton___vue_styles__,
  roundButton___vue_scopeId__,
  roundButton___vue_module_identifier__
)

/* harmony default export */ var src_components_roundButton_defaultExport = (roundButton_Component.exports);

// CONCATENATED MODULE: ./src/mixins/typeClass.js
var typeArr = ['primary', 'info', 'success', 'warning', 'purple'];

/* harmony default export */ var typeClass_defaultExport = ({
    props: {
        index: {
            type: Number
        }
    },
    computed: {
        typeClass: function typeClass() {
            return typeArr[this.index % typeArr.length];
        }
    },
    methods: {
        getTypeClass: function getTypeClass(index) {
            return typeArr[index % typeArr.length];
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/supplier/listItem.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_pIcon__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mixins_selectMapMixin__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__companyList__ = __webpack_require__(235);










/* harmony default export */ var listItem_defaultExport = ({
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_3_mixins_selectMapMixin__["a" /* default */], typeClass_defaultExport, __WEBPACK_IMPORTED_MODULE_6__companyList__["a" /* default */]],
    computed: {
        firstLetter: function firstLetter() {
            return this.getSourceName(this.item.companyAbbr).substr(0, 1);
        },
        contractDuration: function contractDuration() {
            return (this.item.contractStartDate || '-') + ' 至 ' + (this.item.contractEndDate || '-');
        },
        rateTypeText: function rateTypeText() {
            return this.item.rateType === '1' ? this.item.price ? '每人' + this.item.price : '-' : this.getSelectMapText('HUNTER_PERSENT', this.item.monthlySalaryPercent) + '*' + this.getSelectMapText('HUNTER_FL', this.item.monthNum);
        }
    },
    methods: {
        remove: function remove(id) {
            var _this = this;

            if (!id) {
                return;
            }
            this.$confirm('是否继续删除该记录?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post('/supplier/delete.api', { id: id }, { 'X-showMessage': true }).then(function () {
                    _this.$emit('remove', id);
                }).catch(function () {});
            }).catch(function () {});
        }
    },
    components: {
        ListItemTpl: components_listItemTpl_defaultExport,
        RoundButton: src_components_roundButton_defaultExport,
        PIcon: __WEBPACK_IMPORTED_MODULE_0_components_pIcon__["a" /* default */]
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-927fe284"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/supplier/listItem.vue
var listItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('list-item-tpl', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('round-button', {
    attrs: {
      "type": _vm.typeClass,
      "font-size": 24
    }
  }, [_vm._v(_vm._s(_vm.firstLetter))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('p', {
    staticClass: "line-text-1"
  }, [_vm._v(_vm._s(_vm.item.linkman))]), _vm._v(" "), _c('p', {
    staticClass: "line-text-2"
  }, [_vm._v(_vm._s(_vm.getSourceName(_vm.item.companyAbbr)))])])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('p-icon', {
    staticClass: "line-text-1",
    attrs: {
      "icon-name": "phone"
    }
  }, [_vm._v(_vm._s(_vm.item.tel))]), _vm._v(" "), _c('p-icon', {
    staticClass: "line-text-2",
    attrs: {
      "icon-name": "email"
    }
  }, [_vm._v(_vm._s(_vm.item.email))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('p-icon', {
    staticClass: "line-text-1",
    attrs: {
      "icon-name": "list"
    }
  }, [_vm._v(_vm._s(_vm.item.companyFullName))]), _vm._v(" "), _c('p-icon', {
    staticClass: "line-text-2",
    attrs: {
      "icon-name": "clock"
    }
  }, [_vm._v(_vm._s(_vm.item.createTime))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$emit('edit', _vm.item)
      }
    }
  }, [_vm._v("\n                修改公司信息\n            ")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'supplierUsers',
        query: {
          id: _vm.item.id
        }
      }
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_vm._v("修改人员信息")])], 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "type": "danger",
      "size": "small"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.remove(_vm.item.id)
      }
    }
  }, [_vm._v("删除当前数据")])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "supplier-bottom",
    attrs: {
      "slot": "bottom"
    },
    slot: "bottom"
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('label', [_vm._v("跟进HR：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.item.applicant))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('label', [_vm._v("签约部门：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.item.projectName))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('label', [_vm._v("备注：")]), _vm._v(" "), _c('span', [(_vm.item.remark && _vm.item.remark.length > 30) ? _c('span', [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.item.remark,
      "placement": "top-start"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.item.remark.slice(0, 30)) + "...")])])], 1) : _c('span', [_vm._v("\n                    " + _vm._s(_vm.item.remark) + "\n                ")])])])], 1)], 1)
}
var listItem_staticRenderFns = []
var listItem_esExports = { render: listItem_render, staticRenderFns: listItem_staticRenderFns }
/* harmony default export */ var supplier_listItem_defaultExport = (listItem_esExports);
// CONCATENATED MODULE: ./src/views/supplier/listItem.vue
function listItem_injectStyle (ssrContext) {
  __webpack_require__(962)
}
var listItem_normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var listItem___vue_styles__ = listItem_injectStyle
/* scopeId */
var listItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var listItem___vue_module_identifier__ = null
var listItem_Component = listItem_normalizeComponent(
  listItem_defaultExport,
  supplier_listItem_defaultExport,
  listItem___vue_styles__,
  listItem___vue_scopeId__,
  listItem___vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (listItem_Component.exports);


/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/supplier/editSupplierDialog.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_pattern__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mixins_formCommonMixin__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__companyList__ = __webpack_require__(235);






var Model = {
    id: '',
    companyAbbr: '',
    companyFullName: '',
    linkman: '',
    email: '',
    tel: '',
    remark: ''
};
/* harmony default export */ var editSupplierDialog_defaultExport = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_2_mixins_formCommonMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__companyList__["a" /* default */]],
    data: function data() {
        return {
            showDialog: false,
            isEdit: false,
            formIndex: 1,
            ruleForm: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, Model),
            rules: {
                companyAbbr: [{ required: true, message: '请选择公司简称', trigger: 'change' }],
                companyFullName: [{ required: true, message: '请输入公司全称', trigger: 'change' }],
                linkman: [{ required: true, message: '请输入对接人姓名', trigger: 'blur' }],
                email: [{ required: true, message: '请输入对接人邮箱', trigger: 'blur' }, { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur,change' }],
                tel: [{ required: true, message: '请输入对接人电话', trigger: 'blur' }, { pattern: /^[0-9]+$/, message: '请输入数字', trigger: 'blur,change' }]
            }
        };
    },

    computed: {},
    methods: {
        show: function show() {
            var isEdit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
            var data = arguments[1];

            this.isEdit = isEdit;
            this.resetForm('ruleForm');
            if (data) {
                for (var name in Model) {
                    this.ruleForm[name] = data[name];
                }
            } else {
                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.ruleForm, Model);
            }
            console.log(this.ruleForm);
            this.showDialog = true;
        },
        saveForm: function saveForm(boolean) {
            var _this = this;

            var url = this.isEdit ? '/supplier/update.api' : '/supplier/insert.api';
            this.$axios.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.ruleForm), { 'X-showMessage': true }).then(function (res) {
                _this.ruleForm = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this.ruleForm, Model);
                _this.formIndex++;
                if (boolean === true) {
                    _this.showDialog = false;
                }
                _this.$emit('reload');
            }).catch(function () {});
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-437757ea"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/supplier/editSupplierDialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": ((_vm.isEdit === true ? '编辑':'创建') + "供应商"),
      "visible": _vm.showDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.showDialog = $event
      }
    }
  }, [_c('el-form', {
    key: _vm.formIndex,
    ref: "ruleForm",
    staticClass: "form-beauty",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "跟进HR"
    }
  }, [_vm._v(_vm._s(_vm.$store.state.user.name))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "公司简称",
      "prop": "companyAbbr"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择公司简称"
    },
    model: {
      value: (_vm.ruleForm.companyAbbr),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "companyAbbr", $$v)
      },
      expression: "ruleForm.companyAbbr"
    }
  }, _vm._l((_vm.companyList), function(company, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": company.name,
        "value": company.code
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "公司全称",
      "prop": "companyFullName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入公司全称",
      "maxlength": 100
    },
    model: {
      value: (_vm.ruleForm.companyFullName),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "companyFullName", $$v)
      },
      expression: "ruleForm.companyFullName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "对接人姓名",
      "prop": "linkman"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入对接人姓名",
      "maxlength": 50
    },
    model: {
      value: (_vm.ruleForm.linkman),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "linkman", $$v)
      },
      expression: "ruleForm.linkman"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "对接人邮箱",
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入对接人邮箱",
      "maxlength": 50
    },
    model: {
      value: (_vm.ruleForm.email),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "email", $$v)
      },
      expression: "ruleForm.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "对接人电话",
      "prop": "tel"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入对接人电话",
      "maxlength": 20
    },
    model: {
      value: (_vm.ruleForm.tel),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "tel", $$v)
      },
      expression: "ruleForm.tel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入备注",
      "type": "textarea",
      "maxlength": 500
    },
    model: {
      value: (_vm.ruleForm.remark),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "remark", $$v)
      },
      expression: "ruleForm.remark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm', true)
      }
    }
  }, [_vm._v("完成")]), _vm._v(" "), (!_vm.isEdit) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm', false)
      }
    }
  }, [_vm._v("保存并添加下一位")]) : _c('el-button', {
    on: {
      "click": function($event) {
        _vm.showDialog = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var supplier_editSupplierDialog_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/views/supplier/editSupplierDialog.vue
function injectStyle (ssrContext) {
  __webpack_require__(968)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  editSupplierDialog_defaultExport,
  supplier_editSupplierDialog_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(366);
module.exports = __webpack_require__(570);


/***/ }),
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/common/header.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_thumbnail__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_views_login_switchProjectMixin__ = __webpack_require__(287);






/* harmony default export */ var header_defaultExport = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_2_views_login_switchProjectMixin__["a" /* default */]],
    data: function data() {
        return {
            projectId: '',
            changeCount: 1
        };
    },

    computed: {
        hasSalary: function hasSalary() {
            return this.$store.state.user.paymentFlag;
        },
        hasWritten: function hasWritten() {
            return this.$store.state.user.writtenFlag;
        },
        folding: function folding() {
            return this.$store.state.folding;
        },
        user: function user() {
            this.projectId = this.$store.state.user.projectId;
            return this.$store.state.user;
        },
        project: function project() {
            return this.$store.state.app.project;
        },
        showTopMenu: function showTopMenu() {
            return ['resumeDetail', 'singleArrangement', 'writtenPersonDetail', 'evaluationResume', 'evaluation', 'paymentDetail'].indexOf(this.$route.name);
        },
        showInterviewMenu: function showInterviewMenu() {
            return this.$route.name === 'interviewList';
        },
        topMenu: function topMenu() {
            var index = this.$route.fullPath.indexOf(this.$route.path),
                query = this.$route.fullPath.substr(index + this.$route.path.length);
            var menuMap = {
                resumeDetail: '/resume/detail/' + this.$route.params.id + '/0' + query,
                singleArrangement: '/arrangement/' + this.$route.params.id + query,
                evaluation: '/evaluation/' + this.$route.params.id + query,
                evaluationResume: '/evaluationResume/' + this.$route.params.id + query,
                salary: '/salary/detail/' + this.$route.params.id + query,
                writtenPersonDetail: '/written/detail/' + this.$route.params.id + query
            };
            menuMap[this.$route.name] = this.$route.fullPath;
            return menuMap;
        }
    },
    methods: {
        logout: function logout() {
            var _this = this;

            this.$axios.get('/logout.api', {
                'X-loadingOff': true
            }).then(function (res) {
                _this.$store.commit('USER_SIGN_OUT');
                _this.$router.replace({ name: 'login' });
            }).catch(function () {});
        },
        toggleFold: function toggleFold(boolean) {
            this.$store.commit('FOLDING', !boolean);
        },
        projectChange: function projectChange(projectId) {
            var _this2 = this;

            if (this.changeCount >= 1 && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.user).length) {
                this.$axios.post('/loginProject.api', { projectId: projectId }).then(function (res) {
                    _this2.successLogin(res, true);
                }).catch(function () {});
            }
            this.changeCount++;
        }
    },
    components: {
        Thumbnail: __WEBPACK_IMPORTED_MODULE_1_components_thumbnail__["a" /* default */]
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-157e228a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/common/header.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header box-shadow main-header"
  }, [_c('h1', {
    staticClass: "main-title"
  }, [_vm._v("外包招聘系统")]), _vm._v(" "), _c('div', {
    staticClass: "header-row"
  }, [_c('div', {
    staticClass: "main-header-right pull-right"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('thumbnail', {
    attrs: {
      "width": 36,
      "mode": "horizontal"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#666"
    },
    domProps: {
      "textContent": _vm._s(_vm.user.name)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "opt-area"
  }, [_c('span', {
    staticClass: "divider"
  }, [_vm._v("|")]), _c('span', {
    staticClass: "opt-text",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("退出")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "main-header-left pull-left"
  }, [_c('i', {
    class: [_vm.folding ? 'el-icon-my-zhankaidaohanglan' : 'el-icon-my-shouqidaohanglan'],
    on: {
      "click": function($event) {
        return _vm.toggleFold(_vm.folding)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ml-15 mr-5"
  }, [_vm._v("选择项目：")]), _vm._v(" "), _c('el-select', {
    on: {
      "change": function($event) {
        return _vm.projectChange(_vm.projectId)
      }
    },
    model: {
      value: (_vm.projectId),
      callback: function($$v) {
        _vm.projectId = $$v
      },
      expression: "projectId"
    }
  }, _vm._l((_vm.project), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.text,
        "value": parseInt(item.value)
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "menu-inline-block"
  }, [(_vm.showTopMenu > -1) ? [_c('el-menu', {
    attrs: {
      "mode": "horizontal",
      "default-active": _vm.$route.fullPath,
      "router": ""
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": _vm.topMenu.resumeDetail
    }
  }, [_vm._v("简历详情")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": _vm.topMenu.evaluationResume
    }
  }, [_vm._v("简历评价")]), _vm._v(" "), (_vm.hasWritten) ? _c('el-menu-item', {
    attrs: {
      "index": _vm.topMenu.writtenPersonDetail
    }
  }, [_vm._v("笔试安排")]) : _vm._e(), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": _vm.topMenu.singleArrangement
    }
  }, [_vm._v("面试安排")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": _vm.topMenu.evaluation
    }
  }, [_vm._v("面试评价")]), _vm._v(" "), (_vm.hasSalary) ? _c('el-menu-item', {
    attrs: {
      "index": _vm.topMenu.salary
    }
  }, [_vm._v("定薪评价")]) : _vm._e()], 1)] : _vm._e(), _vm._v(" "), (_vm.showInterviewMenu) ? _c('el-menu', {
    staticStyle: {
      "height": "60px",
      "min-width": "250px"
    },
    attrs: {
      "mode": "horizontal",
      "default-active": _vm.$route.path,
      "router": ""
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/interview/1"
    }
  }, [_vm._v("一面")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/interview/2"
    }
  }, [_vm._v("二面")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/interview/3"
    }
  }, [_vm._v("三面")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/interview/4"
    }
  }, [_vm._v("四面")])], 1) : _vm._e()], 2)])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var common_header_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/views/common/header.vue
function injectStyle (ssrContext) {
  __webpack_require__(623)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  header_defaultExport,
  common_header_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var views_common_header_defaultExport = (Component.exports);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57e2ea6e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/common/footer.vue
var footer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(634),
      "alt": ""
    }
  })]), _vm._v(" "), _c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 12
    }
  }, [_vm._v("网易公司版权所有 ©1997-2017　粤网文[2014]0636-236号")])], 1)], 1)
}
var footer_staticRenderFns = []
var footer_esExports = { render: footer_render, staticRenderFns: footer_staticRenderFns }
/* harmony default export */ var footer_defaultExport = (footer_esExports);
// CONCATENATED MODULE: ./src/views/common/footer.vue
var footer_normalizeComponent = __webpack_require__(1)
/* script */
var __vue_script__ = null
/* template */

/* styles */
var footer___vue_styles__ = null
/* scopeId */
var footer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var footer___vue_module_identifier__ = null
var footer_Component = footer_normalizeComponent(
  __vue_script__,
  footer_defaultExport,
  footer___vue_styles__,
  footer___vue_scopeId__,
  footer___vue_module_identifier__
)

/* harmony default export */ var common_footer_defaultExport = (footer_Component.exports);

// CONCATENATED MODULE: ./src/store/modules/baseData.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);




var baseFields = ['WB_EVALUATION_STATUS', 'WB_PAYMENT_STATUS', 'WB_SEND_STATUS', 'WB_GENDER', 'WB_EDU_DEGREE', 'WB_ADD_SOURCE', 'WB_RESUME_SOURCE', 'WB_POSITION_CITY', 'WB_WORK_YEARS', 'WB_ID_CARD_TYPE', 'WB_EXPECTED_SALARY', 'WB_COUNTRY_ALL', 'WB_FLOW_STATUS', 'WB_RESUME_STATUS_0', 'WB_RESUME_STATUS_1', 'FLOW_STATUS_EMPLOY_TURN_TYPE', 'WB_RESUME_STATUS_6', 'WB_RESUME_STATUS_7', 'WB_PHASE', 'WB_USER_ATTRIBUTES', 'WB_INTERVIEW_TYPE', 'WB_USER_VIEWPOINT', 'WB_JOB_TYPE', 'WB_JOB_POSITION_TYPE', 'WB_SCORE_TYPE', 'WB_PROPERTY_TYPE', 'WB_POSITION_STATE', 'WB_SMS_SEND', 'WB_ACCEPT_REGULATE', 'WB_INTERVIEW_STATUS', 'YES_OR_NO', 'WB_SOURCE_FROM', 'WB_RESUME_EXAM_STATUS', 'WB_RESUME_STATUS_1', 'WB_SKILL_PROFICIENCY', 'WB_SKILL_YEARS', 'PROVINCE_ALL', 'CITY_ALL', 'PROVINCE_ALL_WITH_CITY', 'SCHOOL_TYPES', 'SYNC_STATUS', 'WB_POSITION_SEQUENCE_ALL', 'WB_POSITION_SEQUENCE_JSON'];

var state = {
    selectMap: {
        WB_RESUME_STATUS_INTERVIEW: []
    }
};

var actions = {
    FETCH_BASE_DATA: function FETCH_BASE_DATA(_ref) {
        var commit = _ref.commit,
            state = _ref.state;

        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/share/getBasicData.api?BASE_DATA_KEY=' + baseFields.join(','), { 'X-loadingOff': false }).then(function (res) {
            return commit('FETCH_BASE_DATA_SUCCESS', res);
        }).catch(function (err) {
            return commit('FETCH_BASE_DATA_FAIL', err);
        });
    }
};

var mutations = {
    FETCH_BASE_DATA_SUCCESS: function FETCH_BASE_DATA_SUCCESS(state, res) {
        delete res.result.signOut;
        state.selectMap = res.result;
        state.selectMap.WB_SCHOOL_LEVEL = [{ text: '1档', value: '1' }, { text: '2档', value: '2' }, { text: '3档', value: '3' }, { text: '4档', value: '4' }];
    },
    UPDATE_SELECT_MAP_DATA: function UPDATE_SELECT_MAP_DATA(state, data) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state.selectMap, data);
    },
    FETCH_BASE_DATA_FAIL: function FETCH_BASE_DATA_FAIL(state, err) {}
};

/* harmony default export */ var baseData_defaultExport = ({
    state: state,
    actions: actions,
    mutations: mutations
});
// CONCATENATED MODULE: ./src/store/modules/user.js
/* harmony import */ var user___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(36);
/* harmony import */ var user___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(user___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(18);





var user_state = {};

var user_mutations = {
    USER_SIGN_IN: function USER_SIGN_IN(state, user) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(state, user);
        window.waterMarkContext.onLoad(function () {
            window.WaterMark.mark({ text: [user.email.split('@')[0] || 'undefined', user.encryptData.ciphertext || 'undefined', user.name || 'undefined'].join('_') });
        });
    },
    USER_SIGN_OUT: function USER_SIGN_OUT(state) {
        user___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(state).forEach(function (key) {
            return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].delete(state, key);
        });

        window.WaterMark instanceof Function && window.WaterMark.clear();
    }
};

/* harmony default export */ var user_defaultExport = ({
    state: user_state,
    mutations: user_mutations
});
// CONCATENATED MODULE: ./src/store/modules/needIds.js
var needIds_mutations = {
    NEED_IDS: function NEED_IDS(state, ids) {
        var _ref = ids || {},
            _ref$needEditScoreTyp = _ref.needEditScoreTypeIds,
            needEditScoreTypeIds = _ref$needEditScoreTyp === undefined ? [] : _ref$needEditScoreTyp,
            _ref$needEntryWritePr = _ref.needEntryWritePrject,
            needEntryWritePrject = _ref$needEntryWritePr === undefined ? [] : _ref$needEntryWritePr;

        state.needIds = needEditScoreTypeIds;
        state.needEntryWritePrject = needEntryWritePrject;
    }
};

/* harmony default export */ var needIds_defaultExport = ({
    mutations: needIds_mutations
});
// CONCATENATED MODULE: ./src/store/modules/app.js
/* harmony import */ var app___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(36);
/* harmony import */ var app___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(app___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var app___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var app___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(app___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var app___WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(18);





var app_state = {
    menu: []
};

var app_mutations = {
    APP_IN: function APP_IN(state, app) {
        app___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(state, app);
    },
    APP_OUT: function APP_OUT(state) {
        app___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(state).forEach(function (key) {
            return app___WEBPACK_IMPORTED_MODULE_2_vue__["default"].delete(state, key);
        });
    }
};

/* harmony default export */ var app_defaultExport = ({
    state: app_state,
    mutations: app_mutations
});
// CONCATENATED MODULE: ./src/store/index.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui__);











__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var timer = null;

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    state: {
        loading: false,
        folding: false
    },
    modules: {
        user: user_defaultExport,
        app: app_defaultExport,
        baseData: baseData_defaultExport,
        needIds: needIds_defaultExport
    },
    mutations: {
        LOADING: function LOADING(state, boolean) {
            state.loading = boolean;
        },
        FOLDING: function FOLDING(state, boolean) {
            state.folding = boolean;
        },
        MESSAGE_ERROR: function MESSAGE_ERROR(state, msg) {
            __WEBPACK_IMPORTED_MODULE_6_element_ui__["Message"].error(msg);
        },
        MESSAGE_SUCCESS: function MESSAGE_SUCCESS(state, msg) {
            __WEBPACK_IMPORTED_MODULE_6_element_ui__["Message"].success(msg);
        }
    },
    actions: {
        LOADING: function LOADING(_ref, boolean) {
            var commit = _ref.commit;

            clearTimeout(timer);
            timer = setTimeout(function () {
                commit('LOADING', !!boolean);
            }, 250);
        }
    }
});

/* harmony default export */ var store_defaultExport = (store);
// CONCATENATED MODULE: ./src/router/routes.js
/* harmony import */ var routes___WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var routes___WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(13);
/* harmony import */ var routes___WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(routes___WEBPACK_IMPORTED_MODULE_1_axios__);





/* harmony default export */ var routes_defaultExport = ([{
    path: '/login',
    name: 'login',
    meta: {
        auth: false
    },
    beforeEnter: function beforeEnter(to, from, next) {
        routes___WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/sessionObj.api', {
            'X-loadingOff': false
        }).then(function (res) {
            if (res.result.sysConfig && res.result.user) {
                var _ref = res.result || {},
                    _ref$needEditScoreTyp = _ref.needEditScoreTypeIds,
                    needEditScoreTypeIds = _ref$needEditScoreTyp === undefined ? [] : _ref$needEditScoreTyp,
                    _ref$needEntryWritePr = _ref.needEntryWritePrject,
                    needEntryWritePrject = _ref$needEntryWritePr === undefined ? [] : _ref$needEntryWritePr;

                store_defaultExport.commit('APP_IN', res.result.sysConfig);
                store_defaultExport.commit('USER_SIGN_IN', res.result.user);
                store_defaultExport.commit('NEED_IDS', {
                    needEditScoreTypeIds: needEditScoreTypeIds,
                    needEntryWritePrject: needEntryWritePrject
                });
                next({
                    path: to.query.from || '/'
                });
            } else {
                store_defaultExport.commit('USER_SIGN_OUT');
                next();
            }
        }).catch(function () {
            store_defaultExport.commit('USER_SIGN_OUT');
            next();
        });
    },

    components: __webpack_require__(657)
}, {
    path: '/index',
    name: 'index',
    meta: {
        menuIcon: 'el-icon-my-shouye'
    },
    components: __webpack_require__(746)
}, {
    path: '/resumeDuplication',
    name: 'resumeDuplication',
    meta: {
        menuIcon: 'el-icon-my-jianlichi'
    },
    components: __webpack_require__(770)
}, {
    path: '/resume',
    name: 'resumeList',
    meta: {
        menuIcon: 'el-icon-my-jianlichi'
    },
    components: __webpack_require__(785)
}, {
    path: '/resume/detail/:id/:phase',
    name: 'resumeDetail',
    components: __webpack_require__(816)
}, {
    path: '/arrangement/:id',
    name: 'singleArrangement',
    components: __webpack_require__(831)
}, {
    path: '/evaluationResume/:id',
    name: 'evaluationResume',
    components: __webpack_require__(851)
}, {
    path: '/evaluation/:id',
    name: 'evaluation',
    components: __webpack_require__(879)
}, {
    path: '/scoreTips',
    name: 'scoreTips',
    meta: {
        template: 'full'
    },
    components: __webpack_require__(92)
}, {
    path: '/arrangements/:ids',
    name: 'multiArrangement',
    components: __webpack_require__(882)
}, {
    path: '/interview/:id',
    name: 'interviewList',
    meta: {
        activeMenuItem: 'interviewList',
        oneToMore: true,
        menuIcon: 'el-icon-my-mianshi'
    },
    components: __webpack_require__(887)
}, {
    path: '/salary',
    name: 'paymentList',
    meta: {
        menuIcon: 'el-icon-my-mianshipinggu'
    },
    components: __webpack_require__(892)
}, {
    path: '/salary/detail/:id',
    name: 'paymentDetail',
    components: __webpack_require__(907)
}, {
    path: '/salary/rules',
    name: 'paymentRules',
    components: __webpack_require__(910)
}, {
    path: '/salary/rules/:id',
    name: 'paymentRuleDetail',
    components: __webpack_require__(911)
}, {
    path: '/entry',
    name: 'entryList',
    meta: {
        menuIcon: 'el-icon-my-ruzhi'
    },
    components: __webpack_require__(914)
}, {
    path: '/written',
    name: 'writtenList',
    meta: {
        menuIcon: 'el-icon-my-bishi'
    },
    components: __webpack_require__(917)
}, {
    path: '/written/detail/:id',
    name: 'writtenPersonDetail',
    meta: {
        menuIcon: 'el-icon-my-bishi'
    },
    components: __webpack_require__(923)
}, {
    path: '/written/topic/:id',
    name: 'examTopic',
    components: __webpack_require__(926)
}, {
    path: '/written/arrangement/:ids',
    name: 'writtenArrangement',
    components: __webpack_require__(929)
}, {
    path: '/written/exam/detail/:id',
    name: 'writtenExamDetail',
    components: __webpack_require__(932)
}, {
    path: '/written/exam/list',
    name: 'writtenExamList',
    components: __webpack_require__(935)
}, {
    path: '/written/recommend/:ids',
    name: 'writtenRecommend',
    components: __webpack_require__(938)
}, {
    path: '/position/manager',
    name: 'positionManager',
    meta: {
        menuIcon: 'el-icon-my-zhaopinguanli'
    },
    components: __webpack_require__(941)
}, {
    path: '/position/review',
    name: 'positionReview',
    components: __webpack_require__(950)
}, {
    path: '/position/recommend',
    name: 'positionRecommend',
    components: __webpack_require__(362)
}, {
    path: '/more',
    name: 'more',
    meta: {
        menuIcon: 'el-icon-my-gengduo'
    },
    components: __webpack_require__(955)
}, {
    path: '/supplier',
    name: 'supplier',
    components: __webpack_require__(959),
    beforeEnter: function beforeEnter(to, from, next) {
        routes___WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/supplier/getAllSupplier.api', {
            'X-cacheable': true
        }).then(function (res) {
            to.meta.companyList = res.result.list;
            next();
        });
    }
}, {
    path: '/supplier/users',
    name: 'supplierUsers',
    components: __webpack_require__(970),
    beforeEnter: function beforeEnter(to, from, next) {
        routes___WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/supplier/getAllSupplier.api', {
            'X-cacheable': true
        }).then(function (res) {
            to.meta.companyList = res.result.list;
            next();
        });
    }
}, {
    path: '/supplier/statistic',
    name: 'supplierStatistic',
    components: __webpack_require__(976)
}, {
    path: '/bole',
    name: 'boleList',
    components: __webpack_require__(979)
}, {
    path: '/project',
    name: 'project',
    components: __webpack_require__(362)
}, {
    path: '/school/level',
    name: 'schoolLevel',
    components: __webpack_require__(983)
}, {
    path: '/permission/project',
    name: 'projectPermission',
    components: __webpack_require__(988)
}, {
    path: '/message/email',
    name: 'emailTpl',
    components: __webpack_require__(990)
}, {
    path: '/message/emailHistory',
    name: 'emailHistory',
    meta: {
        menuIcon: 'el-icon-my-youjian'
    },
    components: __webpack_require__(997)
}, {
    path: '*',
    name: 'defaultView',
    redirect: {
        name: 'index'
    }
}]);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/common/menu.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_thumbnail__ = __webpack_require__(60);





var nameToUrl = {};
var nameToIcon = {};

routes_defaultExport.forEach(function (item, index) {
    if (item.name) {
        nameToUrl[item.name] = item.path;
        if (item.meta && item.meta.menuIcon) {
            nameToIcon[item.name] = item.meta.menuIcon;
        }
    } else {
        console.log(item);
        console.warn('\u8BF7\u7ED9\u8DEF\u7531\u201C' + item.path + '\u201D\u8BBE\u7F6Ename\u7684\u503C');
    }
});

console.log(nameToUrl);

/* harmony default export */ var menu_defaultExport = ({
    data: function data() {
        return {
            menuActive: this.getActiveMenu()
        };
    },

    computed: {
        menus: function menus() {
            return this.$store.state.app.menu;
        },
        user: function user() {
            return this.$store.state.user;
        }
    },
    watch: {
        '$route': function $route(to, from) {
            this.menuActive = this.getActiveMenu();
        }
    },
    methods: {
        getIcon: function getIcon(name) {
            if (name.indexOf('/interview/') > -1) {
                name = 'interviewList';
            }
            return nameToIcon[name] || '';
        },
        getRoute: function getRoute(name) {
            var text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

            if (text.indexOf('面试') > -1) {
                return '/interview/0';
            }
            if (name.indexOf('/') > -1) {
                return name;
            }
            var nameArr = name.split('?');
            return (nameArr[1] ? nameToUrl[nameArr[0]] + '?' + nameArr[1] : nameToUrl[nameArr[0]]) || '';
        },
        getActiveMenu: function getActiveMenu() {
            var route = this.$route;
            if (route.meta.oneToMore === true) {
                return route.path;
            }
            return this.getRoute(route.meta.activeMenuItem || route.name);
        },
        openSubMenu: function openSubMenu(index, indexPath) {
            this.$router.push({ path: index });
        }
    },
    components: {
        Thumbnail: __WEBPACK_IMPORTED_MODULE_0_components_thumbnail__["a" /* default */]
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ffa713e6"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/common/menu.vue
var menu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slide-menu box-shadow"
  }, [_c('thumbnail', {
    staticStyle: {
      "padding": "30px 0"
    },
    attrs: {
      "text": _vm.user.name,
      "font-size": 16
    }
  }), _vm._v(" "), _c('el-menu', {
    staticClass: "fixed-menu",
    attrs: {
      "default-active": _vm.menuActive,
      "mode": "vertical",
      "unique-opened": true,
      "router": ""
    },
    on: {
      "open": _vm.openSubMenu
    }
  }, [_vm._l((_vm.menus), function(item, index) {
    return [(item.list.length) ? _c('el-submenu', {
      key: index,
      attrs: {
        "index": _vm.getRoute(item.value, item.text)
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: _vm.getIcon(item.value)
    }), _vm._v(" "), _c('span', {
      staticClass: "folded-hide"
    }, [_vm._v(_vm._s(item.text))])]), _vm._v(" "), (item.value === '/interview/1') ? _c('el-menu-item', {
      attrs: {
        "index": "/interview/0"
      }
    }, [_vm._v("所有面试")]) : _vm._e(), _vm._v(" "), _vm._l((item.list), function(sub, subIndex) {
      return [_c('el-menu-item', {
        key: subIndex,
        attrs: {
          "index": _vm.getRoute(sub.value)
        }
      }, [_vm._v(_vm._s(sub.text))])]
    })], 2) : _c('el-menu-item', {
      key: index,
      attrs: {
        "index": _vm.getRoute(item.value)
      }
    }, [_c('i', {
      class: _vm.getIcon(item.value)
    }), _c('span', [_vm._v(_vm._s(item.text))])])]
  })], 2)], 1)
}
var menu_staticRenderFns = []
var menu_esExports = { render: menu_render, staticRenderFns: menu_staticRenderFns }
/* harmony default export */ var common_menu_defaultExport = (menu_esExports);
// CONCATENATED MODULE: ./src/views/common/menu.vue
function menu_injectStyle (ssrContext) {
  __webpack_require__(635)
}
var menu_normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var menu___vue_styles__ = menu_injectStyle
/* scopeId */
var menu___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var menu___vue_module_identifier__ = null
var menu_Component = menu_normalizeComponent(
  menu_defaultExport,
  common_menu_defaultExport,
  menu___vue_styles__,
  menu___vue_scopeId__,
  menu___vue_module_identifier__
)

/* harmony default export */ var views_common_menu_defaultExport = (menu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/app.vue






/* harmony default export */ var src_app_defaultExport = ({
    data: function data() {
        return {};
    },

    props: ['template'],
    components: {
        mainHeader: views_common_header_defaultExport,
        mainFooter: common_footer_defaultExport,
        mainMenu: views_common_menu_defaultExport
    },
    computed: {
        classScoped: function classScoped() {
            var path = (this.$route.path || '').replace(/^\//, '');
            return 'scoped-' + path.split('/').join('-');
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f16a5e8"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app.vue
var app_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.$store.state.loading),
      expression: "$store.state.loading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    staticClass: "page-main",
    class: [_vm.$store.state.folding ? 'folded' : '']
  }, [(_vm.template === 'default') ? [_c('main-header'), _vm._v(" "), _c('div', {
    staticClass: "page-main-content"
  }, [_c('div', {
    staticClass: "slide-menu-wrap"
  }, [_c('main-menu')], 1), _vm._v(" "), _c('div', {
    staticClass: "page-right-content"
  }, [_c('div', {
    staticClass: "main-view"
  }, [_c('router-view', {
    class: ['main-container', _vm.classScoped]
  })], 1), _vm._v(" "), _c('main-footer', {
    staticClass: "hide"
  })], 1)])] : (_vm.template === 'full') ? [_c('router-view', {
    class: [_vm.classScoped]
  })] : _vm._e()], 2)
}
var app_staticRenderFns = []
var app_esExports = { render: app_render, staticRenderFns: app_staticRenderFns }
/* harmony default export */ var selector_js_type_template_index_0___src_app_defaultExport = (app_esExports);
// CONCATENATED MODULE: ./src/app.vue
function app_injectStyle (ssrContext) {
  __webpack_require__(622)
}
var app_normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var app___vue_styles__ = app_injectStyle
/* scopeId */
var app___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var app___vue_module_identifier__ = null
var app_Component = app_normalizeComponent(
  src_app_defaultExport,
  selector_js_type_template_index_0___src_app_defaultExport,
  app___vue_styles__,
  app___vue_scopeId__,
  app___vue_module_identifier__
)

/* harmony default export */ var __src_app_defaultExport = (app_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js
/* harmony import */ var router___WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(1002);







router___WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var oRouter = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    base: '/wb/',
    mode: 'history',
    routes: routes_defaultExport
});

oRouter.beforeEach(function (to, from, next) {
    var _to$meta$auth = to.meta.auth,
        auth = _to$meta$auth === undefined ? true : _to$meta$auth;

    var isLogin = !!store_defaultExport.state.user.id;

    if (auth && !isLogin) {
        return next({
            name: 'login',
            query: {
                from: to.fullPath
            }
        });
    }
    next();
});

oRouter.afterEach(function (to) {
    var path = (to.path || '').replace(/^\//, '');
    document.body.setAttribute('data-root', path.split('/').join('-'));
});

oRouter.afterEach(function (to, from) {});

/* harmony default export */ var router_defaultExport = (oRouter);
// CONCATENATED MODULE: ./src/modules/axios.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_qs__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_qs__);



var _this = this;






__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.baseURL = '/apiWb';

__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers.common['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers.common['Cache-Control'] = 'no-cache';
__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers.common['Pragma'] = 'no-cache';

__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.transformRequest = [function (data, header) {
    if (header['X-JSON']) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data);
    }
    return __WEBPACK_IMPORTED_MODULE_5_qs___default.a.stringify(data);
}];

var cacheData = {};

__WEBPACK_IMPORTED_MODULE_2_axios___default.a.interceptors.request.use(function () {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    config.headers['token'] = store_defaultExport.state.app.token || '';

    if (!config['X-loadingOff']) {
        store_defaultExport.dispatch('LOADING', true);
    }
    if (config['X-JSON']) {
        config.headers['Content-Type'] = 'application/json';
        config.headers['X-JSON'] = true;
    }

    if (config['X-cacheable'] && cacheData[config.url]) {
        var CancelToken = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.CancelToken;
        _this.source = CancelToken.source();
        config.cancelToken = _this.source.token;
        _this.source.cancel({
            url: config.url,
            isCache: true
        });
    }
    return config;
}, function (error) {
    store_defaultExport.dispatch('LOADING', false);
    store_defaultExport.commit('MESSAGE_ERROR', '请求出错了！请稍后重试');
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

__WEBPACK_IMPORTED_MODULE_2_axios___default.a.interceptors.response.use(function (response) {
    store_defaultExport.dispatch('LOADING', false);
    if (response.config['X-cacheable']) {
        cacheData[response.config.url] = response.data;
    }
    var res = response.data;
    if (res.status === true || res.status === 'true') {
        if (response.config['X-showMessage'] && response.config['X-showMessage'] === true) {
            store_defaultExport.commit('MESSAGE_SUCCESS', res.desc || '操作成功');
        }
        return res;
    } else {
        if (res.code === 1 && store_defaultExport.state.user.id) {
            store_defaultExport.commit('USER_SIGN_OUT');
            router_defaultExport.push({
                name: 'login',
                query: {
                    from: router_defaultExport.history.current.fullPath
                }
            });
        } else {
            store_defaultExport.commit('MESSAGE_ERROR', res.desc);
        }
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res);
    }
}, function (error) {
    store_defaultExport.dispatch('LOADING', false);

    if (error.message && error.message.isCache) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(cacheData[error.message.url]);
    }
    if (__WEBPACK_IMPORTED_MODULE_2_axios___default.a.isCancel(error)) {
        console.log('Request canceled, message is: ', error.message);
    } else {
        store_defaultExport.commit('MESSAGE_ERROR', '服务器有点忙！请稍后重试');
    }
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/* harmony default export */ var axios_defaultExport = (__WEBPACK_IMPORTED_MODULE_2_axios___default.a);
// CONCATENATED MODULE: ./src/main.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_style__ = __webpack_require__(1003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_style_element_ui_theme_chalk__ = __webpack_require__(1004);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_style_element_ui_theme_chalk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_style_element_ui_theme_chalk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_style_iconfont_iconfont__ = __webpack_require__(1005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_style_iconfont_iconfont___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_style_iconfont_iconfont__);

















__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$axios = axios_defaultExport;

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_element_ui___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('ElMenu').options.methods.routeToItem = function (item) {
    var route = item.route || item.index;
    try {
        if (item.$route.path.indexOf('interview') > -1 && item.index.indexOf('interview') > -1) {
            this.$router.push({ path: item.index, query: item.$route.query });
            return;
        }
        this.$router.push(route);
    } catch (e) {
        console.error(e);
    }
};


__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.devtools = true;
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$win = {
    close: window.close
};
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$back = function (conf) {
    router_defaultExport.back();
    var curHref = window.location.href;
    clearTimeout(window._back_timer);
    window._back_timer = setTimeout(function () {
        if (window.location.href === curHref) {
            if ((typeof conf === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(conf)) === 'object') {
                router_defaultExport.push(conf);
            }
        }
    }, 300);
};

window.app = new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
    store: store_defaultExport,
    router: router_defaultExport,
    watch: {
        template: function template(newValue) {
            if (newValue === 'default') {
                this.$store.dispatch('FETCH_BASE_DATA');
            }
        }
    },
    computed: {
        template: function template() {
            var template = void 0,
                meta = this.$route.meta,
                name = this.$route.name;
            switch (true) {
                case name === null:
                    template = null;
                    break;
                case name === 'login' || meta.template === 'full':
                    template = 'full';
                    break;
                default:
                    template = 'default';
            }
            return template;
        }
    },
    template: '<App :template="template"></App>',
    components: {
        App: __src_app_defaultExport
    }
}).$mount('#main');

/***/ }),
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(624);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("e8685bae", content, true);

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".main-header .main-title{transition:all .4s ease 0s;float:left;width:200px;text-indent:-99999px;height:60px;background:#2481ff url(" + __webpack_require__(625) + ") no-repeat 50%}.main-header .header-row{height:60px;line-height:60px}.main-header-left{padding-left:30px;width:350px}.main-header-left>i{cursor:pointer;font-size:20px;color:#96a1af}.main-header-left span{color:#999}.main-header-right{padding-right:30px}.main-header-right .opt-area{display:inline-block;vertical-align:middle}.main-header-right .opt-text{color:#2481ff;cursor:pointer}.main-header-right .divider{color:#999;margin:0 10px}.main-header .menu-inline-block{text-align:center}.main-header .menu-inline-block>.el-menu{display:inline-block;background-color:transparent}.main-header .menu-inline-block>.el-menu>.el-menu-item{border-bottom-width:3px;margin:0 5px;padding:0 10px}.main-header .menu-inline-block>.el-menu>.el-menu-item.is-active{border-bottom:3px solid #2481ff;background-color:transparent}@media screen and (max-width:1400px){.main-header .menu-inline-block>.el-menu>.el-menu-item{padding:0 5px;font-size:12px}}@media screen and (max-width:1200px){.main-header .menu-inline-block>.el-menu>.el-menu-item{padding:0;font-size:12px}}", ""]);

// exports


/***/ }),
/* 625 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJ0AAAAiCAYAAABFutt2AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RTEyNzUyMUY2MUY5MTFFN0FFQ0NFMjgwQjNDNDZGOUYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RTEyNzUyMjA2MUY5MTFFN0FFQ0NFMjgwQjNDNDZGOUYiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpFMTI3NTIxRDYxRjkxMUU3QUVDQ0UyODBCM0M0NkY5RiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpFMTI3NTIxRTYxRjkxMUU3QUVDQ0UyODBCM0M0NkY5RiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PqwBidoAAAmBSURBVHja7FxbjBRFFO2RRYOCDGgwwgfzgY8ohMFXTER3NkRiAsrK+kATZYgf8jCyK9FofOysRCXxsYuo8KGZBT8MEV1QfiAhswRMTCTOYAgomsyQiIpGZuShAuuO97Kn1ktR1V09DPJB3+Sw3V3v6lO36t7bQ6xarXoh5RrCMsI03G8hPEv4zoskEgeJhSRdI2EjYbj2/ChhJqE3mtJI6km68YQ8YZQlvUyYQtgXTWskfnJBiLxvC8L9Q1hIWEA4jmec9k40pZEESYNjvhsJ94j75wkrcX0J4Q1c8xZ7E2FHNLWRnKmmWyyufyC8Je6XE74X909G0xqJq6YbSbiLMJFwOeFvwq+EvYRmkY813Alx30foIryLe877AOFqwhjCRYS/CN/ACPk1mvbzXNiQICwiHK66yQyUkRhNOOFQ9ghhoaG8CxKEFP+1jCOJ9HiIsafClqlX23V4b3G/+TjXbau5NXDtpPU6m+7XsSUbot1vYTSsJhzBs22EqY7lHyZ8FHKsnYRWQlssFusyDDJHf3iQTZTe60I4+sNlKpR/1Bm+hFPapvs0XbuSoZvKlESfzG4GbUyi/x2UlrGRg/4kaxhSCjtfEvXrbat3MY/Sui1tV9HvmCSd2l5fEoQ7TNhM+J0wjDAOhsGlWp3XgnRLCa8TVngDPjpFumOELwglbL+XEaYTRiD96RpIp7b4ydR5Ockl28ADpF0jTbB/KRZrcqx7snjZikgFJrjIw+lxzFsJz3I+xG6ypLdTWru4l4su6VdngFTQ55LlXXD6evTNusi0d3XyfTHprtc00EaDscHnPNaIz+KM5gk3yaswNL4Uz/k8OE2r527CZ7i+voaVpwaV1tJ4grtDaqY06ixZJtXUvnFbBXHUtpo8uX3EYm36iodWKBi0o5Qmqb3wwtrxXEkbyJCE9u/GjqPupRS0snI87WL+Ovy0qkHDJqChK4ZFJrUr19OoVTGSSbffG3D8sow1tNMP4s3QCCflCsIszSgZh7o9Q90Ha9RKg+pcvJCtIQmnyhV0IviUqfps+Snt3jMdVVzaqbeAFL3adtuJhVsBubv07RjEqlj6vFiVxaJjrbdBLTTMLz/vkotPbq98sVYc9HcRhorDO1+/ZjASjhNWEt7DtUluF/U0EHaLtLUhDIg0yvRoA+jB84zSHLhP+ZCnSChzmZAGR9WHeNa2YWCw5F3K4PAtx5RReURakKQsB/8Mxm4cP+a5jDpypvkRfWjV3kEC9wnUUZTlOT/qHyAe/XOH1umXhLX4lWFQnxEmCFJMwDNd5og8HVraHSEJlzNMUh5pzdpL7PGxcPW8VqkT6XpkH0OQ7jQiibSUhaCpAOIryaNtiSLSyqa+anOeR1unKQPUVYYG9DTSqXEMmrHrRKf6CC8QftM6WyG0+BCkRawUlgV4Ph11Kvk4hJarYlV6+jsX9SUsRMr6kC8n8mQ01IV04qVkDa6GtOhn3EC6LK6zBtK14rrVkjdpIJ0kmBpnVpuvziDtb1kQSaSp+tIWTVtGnkHSjSUcCFj82xxIsk3kX4It9oh4dgBthfHNeULbtQp/HUvR8OIz4rqstgIXzWQjWBjSAZ3qRVq2J9W3tCW91u2109GnmLUtTtyXHXxwg+2JBVDWCJ439DEhX/BUwjGfAW1yIMlmLf9Rcc9131ajY7hVG0BRn2SdSChTNpGlnqTDS8yLSR/URjX4+6ykq4NDN60tRuNOgEV9ioY2aK2iPLeJuvNa/UWhRRUxW2UYTJ/UP+Fru7PGcU6voyHWBSRheapzx3Ify62LBsiWWzaMpz3ki6wa3DcdsO7SjmQZdA77+N6cfYnKraIsTyzMtHDrsPW/AW6PtGEtjVSuKT6LG/rWibqalMsEHoVu4bAu0LN56HMC1m0v5reiSHcl4VPChYJwHIe9RZDuYofBDvNJuxBt8Dd3P9XoAihQx3eCdKaXZcrv59DlFSgdtglBHhdh5+hOuIt4QSxHm9IPFiS9Bl+h8r3NFX5J5Rqai352BDh2lejHi7TB1+lpDmzlB1wMv+CgQYCyPO5mGB3jmWCOY82oiISHiMIYXPO3cg8hrDVRFJhEaCF8YqnwXi0/yy+o+2XCELTB2un+WmN+0k8Uwlfl+Uyy/Oh0K+ruxtaTEH64iqHue9GvRhuhbFEMi3NYyT5ohpRoS7k52hGFyTiOPxakqfU8aKdHaEdPOH5VRKJZEDSUNCB01SKevSIiBwc1tcsx2s8JT3kDnzixTPAGvqebpdW9nfAgtNoQEI/lPrS5vQbeqYloC9JyjrLa5n3Hqm4XhGvzzp3wubEg46iW7bagO2QNsVrOM8Xmx8RCazItFhDdj+wJsZh9STdf3O9BPFXJj4Yyd2Pr/QDnwMfEtuwh1vom4UXvv0+gloGAKvw1vwbSZaEZuk0B/7PgzQ+a4LNCLhVWgjHRKM5RKg5q0vDjfbZMGYnwPQej7izyTnHcfZLQvBWheLYGFSoJq3C+ZjWOq4aTHYQpFgv0cZHv55DWa9bPonKNSNSS12DF5oLqE1ZoLqRvT3fi5m3OZYvVm7NYmz2m+bNY6lnhZI8b+qw7lHWXTj5oXhoQI1WyX+sz3/8hLBq2em5FrFWXY0jvQ6y231CXktGO71nGCrtDHFiDpCKsRNcyihxhtvW4hdgyKC7ra5IxTxHHrDj2rWKIwGSFRdsVZKnD6tyHszOTnsut17KVoM0KQAJHH25/nmGeU5jnWarxgmDsIUQnOK76PmEL4W+RvpQwnPAc4aCPxqug7BrCKkQhDon0rx01XI8KzQSRI6SmS2or1VWK0uMP/5T0TcUDwlmhnLl+fjpDG2VDCCyDPsZ9Igs5H39c2vBpkmcJceV0vx/6WNYjRZwwm9DvOEkyKsHke4KwJ+SL60ebrk7huCkMZhh8Jwae9P4nwaSqsFLiLNSfto1JhNRCf/0s+pyuw1fTzY7bf0pFmNTvXhfhsD88oI0+bK36p0kzYdUGCX8k+gxhlRfJeSvKT8c/qlkLq3QSzhzH4WfbC0t1BPLPIbyn1XO1Rqx5eMZOZ/4G7zfCLsImb+BH2ZGcx+L6C/81hEdwzT83vA5aj2UoYTf8dSwfEh6NpjYSm7j+7nWFuL7KO/V3sEsE4fS8kURSs6bzcGabiWveelvhHOYf6AzB841wHkcSSV1Ix9ZZ3js9Hid9MjcQitG0RlKP7ZWl5A0E9Y8a0vjZ7IhwkdSbdCy93sB/prMeVuphXN/s1f77ykjOM/lXgAEAr3OsHmxVDhAAAAAASUVORK5CYII="

/***/ }),
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(631);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("bf8bb7d4", content, true);

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".thumbnail-wrap .round-image{border-radius:50%}.thumbnail-wrap .thumbnail-text{color:#2481ff}.thumbnail-wrap-vertical{text-align:center}.thumbnail-wrap-vertical .round-image{margin-bottom:10px}.thumbnail-wrap-horizontal{display:inline-block}.thumbnail-wrap-horizontal .round-image{margin-right:10px}.thumbnail-wrap-horizontal .thumbnail-text{display:inline-block;vertical-align:middle}", ""]);

// exports


/***/ }),
/* 632 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 633 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 634 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(636);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("6090b4a9", content, true);

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".slide-menu-wrap{width:200px;position:fixed;z-index:10;left:0;height:100%}.slide-menu-wrap,.slide-menu-wrap *{transition:all .4s ease 0s}.fixed-menu{overflow:auto;position:fixed;top:235px;bottom:0;width:200px;left:0;padding-bottom:20px}.fixed-menu::-webkit-scrollbar{width:6px;height:6px}.fixed-menu::-webkit-scrollbar-track{background-color:#eee}.fixed-menu::-webkit-scrollbar-thumb{background-color:rgba(0,0,0,.2);border-radius:6px}.fixed-menu::-webkit-scrollbar-button{display:none}.page-right-content{position:absolute;left:200px;top:0;bottom:0;right:0;width:auto;transition:all .4s ease 0s}.fixed-bar .container{padding-left:200px;transition:all .4s ease 0s}.page-main.folded .main-title{width:60px;background-image:url(" + __webpack_require__(637) + ")}.page-main.folded .el-menu.fixed-menu{width:60px;overflow-x:hidden}.page-main.folded .folded-hide{opacity:0}.page-main.folded .el-icon-arrow-down{opacity:0;transition-delay:.4s}.page-main.folded .el-submenu>.el-menu{opacity:0;height:0}.page-main.folded .slide-menu-wrap{width:60px}.page-main.folded .slide-menu-wrap .thumbnail-wrap{opacity:0}.page-main.folded .slide-menu-wrap .el-menu-item>span{display:none}.page-main.folded .page-right-content{left:60px}.page-main.folded .fixed-bar .container{padding-left:60px}.page-main-content{position:absolute;width:100%;top:60px;bottom:0}.slide-menu{box-sizing:border-box;min-height:100%;background:#fff}.slide-menu .el-menu{background:transparent}.slide-menu .el-menu-item{font-size:15px;height:36px;line-height:36px;margin:20px 0;border-left:4px solid transparent}.slide-menu .el-menu-item.is-active{border-color:#2481ff;background:#f3f4f6}.slide-menu .el-submenu .el-submenu__title{font-size:15px;height:36px;line-height:36px;margin-top:20px;border-left:4px solid transparent}.slide-menu .el-submenu .el-menu-item{margin:10px 0;border-color:transparent;background:#fff}.slide-menu .el-submenu.is-active .el-submenu__title{border-color:#2481ff;background:#f3f4f6}", ""]);

// exports


/***/ }),
/* 637 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/views/login/md5.js

var hexcase = 0;

var b64pad = '';




function hex_md5(s) {
    return rstr2hex(rstr_md5(str2rstr_utf8(s)));
}
function b64_md5(s) {
    return rstr2b64(rstr_md5(str2rstr_utf8(s)));
}
function any_md5(s, e) {
    return rstr2any(rstr_md5(str2rstr_utf8(s)), e);
}
function hex_hmac_md5(k, d) {
    return rstr2hex(rstr_hmac_md5(str2rstr_utf8(k), str2rstr_utf8(d)));
}
function b64_hmac_md5(k, d) {
    return rstr2b64(rstr_hmac_md5(str2rstr_utf8(k), str2rstr_utf8(d)));
}
function any_hmac_md5(k, d, e) {
    return rstr2any(rstr_hmac_md5(str2rstr_utf8(k), str2rstr_utf8(d)), e);
}

function md5_vm_test() {
    return hex_md5('abc').toLowerCase() == '900150983cd24fb0d6963f7d28e17f72';
}

function rstr_md5(s) {
    return binl2rstr(binl_md5(rstr2binl(s), s.length * 8));
}

function rstr_hmac_md5(key, data) {
    var bkey = rstr2binl(key);
    if (bkey.length > 16) bkey = binl_md5(bkey, key.length * 8);

    var ipad = Array(16),
        opad = Array(16);
    for (var i = 0; i < 16; i++) {
        ipad[i] = bkey[i] ^ 0x36363636;
        opad[i] = bkey[i] ^ 0x5C5C5C5C;
    }

    var hash = binl_md5(ipad.concat(rstr2binl(data)), 512 + data.length * 8);
    return binl2rstr(binl_md5(opad.concat(hash), 512 + 128));
}

function rstr2hex(input) {
    try {
        hexcase;
    } catch (e) {
        hexcase = 0;
    }
    var hex_tab = hexcase ? '0123456789ABCDEF' : '0123456789abcdef';
    var output = '';
    var x;
    for (var i = 0; i < input.length; i++) {
        x = input.charCodeAt(i);
        output += hex_tab.charAt(x >>> 4 & 0x0F) + hex_tab.charAt(x & 0x0F);
    }
    return output;
}

function rstr2b64(input) {
    try {
        b64pad;
    } catch (e) {
        b64pad = '';
    }
    var tab = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    var output = '';
    var len = input.length;
    for (var i = 0; i < len; i += 3) {
        var triplet = input.charCodeAt(i) << 16 | (i + 1 < len ? input.charCodeAt(i + 1) << 8 : 0) | (i + 2 < len ? input.charCodeAt(i + 2) : 0);
        for (var j = 0; j < 4; j++) {
            if (i * 8 + j * 6 > input.length * 8) output += b64pad;else output += tab.charAt(triplet >>> 6 * (3 - j) & 0x3F);
        }
    }
    return output;
}

function rstr2any(input, encoding) {
    var divisor = encoding.length;
    var i, j, q, x, quotient;

    var dividend = Array(Math.ceil(input.length / 2));
    for (i = 0; i < dividend.length; i++) {
        dividend[i] = input.charCodeAt(i * 2) << 8 | input.charCodeAt(i * 2 + 1);
    }

    var full_length = Math.ceil(input.length * 8 / (Math.log(encoding.length) / Math.log(2)));
    var remainders = Array(full_length);
    for (j = 0; j < full_length; j++) {
        quotient = Array();
        x = 0;
        for (i = 0; i < dividend.length; i++) {
            x = (x << 16) + dividend[i];
            q = Math.floor(x / divisor);
            x -= q * divisor;
            if (quotient.length > 0 || q > 0) quotient[quotient.length] = q;
        }
        remainders[j] = x;
        dividend = quotient;
    }

    var output = '';
    for (i = remainders.length - 1; i >= 0; i--) {
        output += encoding.charAt(remainders[i]);
    }return output;
}

function str2rstr_utf8(input) {
    var output = '';
    var i = -1;
    var x, y;

    while (++i < input.length) {
        x = input.charCodeAt(i);
        y = i + 1 < input.length ? input.charCodeAt(i + 1) : 0;
        if (0xD800 <= x && x <= 0xDBFF && 0xDC00 <= y && y <= 0xDFFF) {
            x = 0x10000 + ((x & 0x03FF) << 10) + (y & 0x03FF);
            i++;
        }

        if (x <= 0x7F) output += String.fromCharCode(x);else if (x <= 0x7FF) output += String.fromCharCode(0xC0 | x >>> 6 & 0x1F, 0x80 | x & 0x3F);else if (x <= 0xFFFF) output += String.fromCharCode(0xE0 | x >>> 12 & 0x0F, 0x80 | x >>> 6 & 0x3F, 0x80 | x & 0x3F);else if (x <= 0x1FFFFF) output += String.fromCharCode(0xF0 | x >>> 18 & 0x07, 0x80 | x >>> 12 & 0x3F, 0x80 | x >>> 6 & 0x3F, 0x80 | x & 0x3F);
    }
    return output;
}

function str2rstr_utf16le(input) {
    var output = '';
    for (var i = 0; i < input.length; i++) {
        output += String.fromCharCode(input.charCodeAt(i) & 0xFF, input.charCodeAt(i) >>> 8 & 0xFF);
    }return output;
}

function str2rstr_utf16be(input) {
    var output = '';
    for (var i = 0; i < input.length; i++) {
        output += String.fromCharCode(input.charCodeAt(i) >>> 8 & 0xFF, input.charCodeAt(i) & 0xFF);
    }return output;
}

function rstr2binl(input) {
    var output = Array(input.length >> 2);
    for (var i = 0; i < output.length; i++) {
        output[i] = 0;
    }for (var i = 0; i < input.length * 8; i += 8) {
        output[i >> 5] |= (input.charCodeAt(i / 8) & 0xFF) << i % 32;
    }return output;
}

function binl2rstr(input) {
    var output = '';
    for (var i = 0; i < input.length * 32; i += 8) {
        output += String.fromCharCode(input[i >> 5] >>> i % 32 & 0xFF);
    }return output;
}

function binl_md5(x, len) {
    x[len >> 5] |= 0x80 << len % 32;
    x[(len + 64 >>> 9 << 4) + 14] = len;

    var a = 1732584193;
    var b = -271733879;
    var c = -1732584194;
    var d = 271733878;

    for (var i = 0; i < x.length; i += 16) {
        var olda = a;
        var oldb = b;
        var oldc = c;
        var oldd = d;

        a = md5_ff(a, b, c, d, x[i + 0], 7, -680876936);
        d = md5_ff(d, a, b, c, x[i + 1], 12, -389564586);
        c = md5_ff(c, d, a, b, x[i + 2], 17, 606105819);
        b = md5_ff(b, c, d, a, x[i + 3], 22, -1044525330);
        a = md5_ff(a, b, c, d, x[i + 4], 7, -176418897);
        d = md5_ff(d, a, b, c, x[i + 5], 12, 1200080426);
        c = md5_ff(c, d, a, b, x[i + 6], 17, -1473231341);
        b = md5_ff(b, c, d, a, x[i + 7], 22, -45705983);
        a = md5_ff(a, b, c, d, x[i + 8], 7, 1770035416);
        d = md5_ff(d, a, b, c, x[i + 9], 12, -1958414417);
        c = md5_ff(c, d, a, b, x[i + 10], 17, -42063);
        b = md5_ff(b, c, d, a, x[i + 11], 22, -1990404162);
        a = md5_ff(a, b, c, d, x[i + 12], 7, 1804603682);
        d = md5_ff(d, a, b, c, x[i + 13], 12, -40341101);
        c = md5_ff(c, d, a, b, x[i + 14], 17, -1502002290);
        b = md5_ff(b, c, d, a, x[i + 15], 22, 1236535329);

        a = md5_gg(a, b, c, d, x[i + 1], 5, -165796510);
        d = md5_gg(d, a, b, c, x[i + 6], 9, -1069501632);
        c = md5_gg(c, d, a, b, x[i + 11], 14, 643717713);
        b = md5_gg(b, c, d, a, x[i + 0], 20, -373897302);
        a = md5_gg(a, b, c, d, x[i + 5], 5, -701558691);
        d = md5_gg(d, a, b, c, x[i + 10], 9, 38016083);
        c = md5_gg(c, d, a, b, x[i + 15], 14, -660478335);
        b = md5_gg(b, c, d, a, x[i + 4], 20, -405537848);
        a = md5_gg(a, b, c, d, x[i + 9], 5, 568446438);
        d = md5_gg(d, a, b, c, x[i + 14], 9, -1019803690);
        c = md5_gg(c, d, a, b, x[i + 3], 14, -187363961);
        b = md5_gg(b, c, d, a, x[i + 8], 20, 1163531501);
        a = md5_gg(a, b, c, d, x[i + 13], 5, -1444681467);
        d = md5_gg(d, a, b, c, x[i + 2], 9, -51403784);
        c = md5_gg(c, d, a, b, x[i + 7], 14, 1735328473);
        b = md5_gg(b, c, d, a, x[i + 12], 20, -1926607734);

        a = md5_hh(a, b, c, d, x[i + 5], 4, -378558);
        d = md5_hh(d, a, b, c, x[i + 8], 11, -2022574463);
        c = md5_hh(c, d, a, b, x[i + 11], 16, 1839030562);
        b = md5_hh(b, c, d, a, x[i + 14], 23, -35309556);
        a = md5_hh(a, b, c, d, x[i + 1], 4, -1530992060);
        d = md5_hh(d, a, b, c, x[i + 4], 11, 1272893353);
        c = md5_hh(c, d, a, b, x[i + 7], 16, -155497632);
        b = md5_hh(b, c, d, a, x[i + 10], 23, -1094730640);
        a = md5_hh(a, b, c, d, x[i + 13], 4, 681279174);
        d = md5_hh(d, a, b, c, x[i + 0], 11, -358537222);
        c = md5_hh(c, d, a, b, x[i + 3], 16, -722521979);
        b = md5_hh(b, c, d, a, x[i + 6], 23, 76029189);
        a = md5_hh(a, b, c, d, x[i + 9], 4, -640364487);
        d = md5_hh(d, a, b, c, x[i + 12], 11, -421815835);
        c = md5_hh(c, d, a, b, x[i + 15], 16, 530742520);
        b = md5_hh(b, c, d, a, x[i + 2], 23, -995338651);

        a = md5_ii(a, b, c, d, x[i + 0], 6, -198630844);
        d = md5_ii(d, a, b, c, x[i + 7], 10, 1126891415);
        c = md5_ii(c, d, a, b, x[i + 14], 15, -1416354905);
        b = md5_ii(b, c, d, a, x[i + 5], 21, -57434055);
        a = md5_ii(a, b, c, d, x[i + 12], 6, 1700485571);
        d = md5_ii(d, a, b, c, x[i + 3], 10, -1894986606);
        c = md5_ii(c, d, a, b, x[i + 10], 15, -1051523);
        b = md5_ii(b, c, d, a, x[i + 1], 21, -2054922799);
        a = md5_ii(a, b, c, d, x[i + 8], 6, 1873313359);
        d = md5_ii(d, a, b, c, x[i + 15], 10, -30611744);
        c = md5_ii(c, d, a, b, x[i + 6], 15, -1560198380);
        b = md5_ii(b, c, d, a, x[i + 13], 21, 1309151649);
        a = md5_ii(a, b, c, d, x[i + 4], 6, -145523070);
        d = md5_ii(d, a, b, c, x[i + 11], 10, -1120210379);
        c = md5_ii(c, d, a, b, x[i + 2], 15, 718787259);
        b = md5_ii(b, c, d, a, x[i + 9], 21, -343485551);

        a = safe_add(a, olda);
        b = safe_add(b, oldb);
        c = safe_add(c, oldc);
        d = safe_add(d, oldd);
    }
    return Array(a, b, c, d);
}

function md5_cmn(q, a, b, x, s, t) {
    return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s), b);
}
function md5_ff(a, b, c, d, x, s, t) {
    return md5_cmn(b & c | ~b & d, a, b, x, s, t);
}
function md5_gg(a, b, c, d, x, s, t) {
    return md5_cmn(b & d | c & ~d, a, b, x, s, t);
}
function md5_hh(a, b, c, d, x, s, t) {
    return md5_cmn(b ^ c ^ d, a, b, x, s, t);
}
function md5_ii(a, b, c, d, x, s, t) {
    return md5_cmn(c ^ (b | ~d), a, b, x, s, t);
}

function safe_add(x, y) {
    var lsw = (x & 0xFFFF) + (y & 0xFFFF);
    var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
    return msw << 16 | lsw & 0xFFFF;
}

function bit_rol(num, cnt) {
    return num << cnt | num >>> 32 - cnt;
}
// CONCATENATED MODULE: ./src/views/login/myStore.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);



var cookies = {
    set: function set(key, value) {
        var days = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 7;

        var expires = void 0;
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            expires = '; expires=' + date.toGMTString();
        } else {
            expires = '';
        }
        document.cookie = key + '=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value) + expires + '; path=/';
    },
    get: function get(key) {
        if (document.cookie.length > 0) {
            var start = document.cookie.indexOf(key + '=');
            if (start !== -1) {
                start = start + key.length + 1;
                var end = document.cookie.indexOf(';', start);
                if (end === -1) {
                    end = document.cookie.length;
                }
                return JSON.parse(document.cookie.substring(start, end));
            }
        }
        return null;
    },
    remove: function remove(key) {
        this.set(key, '', -1);
    }
};
var storage = {
    set: function set(key, value) {
        var days = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 7;

        localStorage.setItem(key, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value));
    },
    get: function get(key) {
        var value = localStorage.getItem(key);
        return value ? JSON.parse(value) : null;
    },
    remove: function remove(key) {
        localStorage.removeItem(key);
    }
};

function supportStorage() {
    var test = 'supportStorageTest';
    try {
        localStorage.setItem(test, test);
        localStorage.removeItem(test);
        return true;
    } catch (e) {
        return false;
    }
}

var myStore = function () {
    return supportStorage() ? storage : cookies;
}();

/* harmony default export */ var myStore_defaultExport = (myStore);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/login/main.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__security__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__security___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__security__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sjcl__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sjcl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sjcl__);







var exponent = '10001';
var modulus = '009bd7bb03bbdceb1f640f46c1ca855d17ef308c0afd695cfe28ce4cb79d9c6e19f88d13950c391d5463404fce7f8a56a75cbc8585c5979ed0c4f0f0eb090a7355ee673753a0d35f20fbcbc54b5114b32de7a2619627730f36e68dcbb43729b4d0b7e53057adc66a322c8feabb5208a2812b24dabcaae6738685063695efdb83ad';

/* harmony default export */ var main_defaultExport = ({
    data: function data() {
        return {
            urls: {
                login: '/logindo.api'
            },
            ruleForm: {
                username: '',
                email: '',
                password: ''
            },
            remember: false,
            rules: {
                username: [{ required: true, message: '请输入工号', trigger: 'blur' }],
                email: [{ required: true, message: '请输入邮箱前缀', trigger: 'blur' }],
                password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
            },
            emailMode: false,
            loading: false
        };
    },

    methods: {
        toggleView: function toggleView() {
            this.emailMode = !this.emailMode;
            var ruleName = this.emailMode ? 'email' : 'username';
            if (this.rememberCurrent(ruleName)) {
                return;
            }
            this.ruleForm[ruleName] = '';
            this.ruleForm.password = '';
            this.remember = false;
        },
        rememberCurrent: function rememberCurrent(rName) {
            var storeInfo = myStore_defaultExport.get(this.getUnitKey());
            if (storeInfo) {
                var last = rName ? this.emailMode ? 'email' : 'user' : storeInfo.last,
                    ruleName = rName || (last === 'email' ? 'email' : 'username'),
                    targetInfo = storeInfo[last];
                if (!rName) {
                    this.emailMode = storeInfo.last === 'email';
                }
                if (targetInfo) {
                    var name = __WEBPACK_IMPORTED_MODULE_3_sjcl___default.a.decrypt(modulus, targetInfo._n),
                        pwd = __WEBPACK_IMPORTED_MODULE_3_sjcl___default.a.decrypt(name, targetInfo._p);
                    this.ruleForm[ruleName] = name;
                    this.ruleForm.password = pwd;
                    this.remember = true;
                    return true;
                }
            }
            return false;
        },
        toggleRemember: function toggleRemember(isRemember) {
            var storeInfo = myStore_defaultExport.get(this.getUnitKey());

            if (isRemember === true) {
                var userInfo = {
                    _p: '',
                    _n: this.emailMode ? this.ruleForm.email : this.ruleForm.username
                };
                userInfo['_p'] = __WEBPACK_IMPORTED_MODULE_3_sjcl___default.a.encrypt(userInfo['_n'], this.ruleForm.password);
                userInfo['_n'] = __WEBPACK_IMPORTED_MODULE_3_sjcl___default.a.encrypt(modulus, userInfo['_n']);
                var store = storeInfo || {};
                store['last'] = this.emailMode ? 'email' : 'user';
                store[store.last] = userInfo;
                myStore_defaultExport.set(this.getUnitKey(), store);
            } else {
                if (storeInfo) {
                    delete storeInfo[this.emailMode ? 'email' : 'user'];
                    storeInfo['last'] = this.emailMode ? 'email' : 'user';
                    myStore_defaultExport.set(this.getUnitKey(), storeInfo);
                }
            }
        },
        getUnitKey: function getUnitKey() {
            var key = '_waibao',
                projectKey = location.pathname.split('/')[1];
            return projectKey ? '_' + projectKey : key;
        },
        encryPasswd: function encryPasswd(pwd) {
            var key = window.RSAUtils.getKeyPair(exponent, '', modulus);
            return window.RSAUtils.encryptedString(key, pwd);
        },
        dataProcess: function dataProcess() {
            return {
                username: this.emailMode ? this.ruleForm.email : this.ruleForm.username,
                passwd: this.emailMode ? hex_md5(this.ruleForm.password) : this.encryPasswd(this.ruleForm.password),
                type: this.emailMode ? 'email' : 'loginId'
            };
        },
        submitForm: function submitForm(form) {
            var _this = this;

            this.$refs[form].validate(function (vaild) {
                if (vaild) {
                    _this.loading = true;
                    _this.$axios.post(_this.urls.login, _this.dataProcess(), { 'X-loadingOff': true }).then(function (res) {
                        _this.loading = false;
                        _this.toggleRemember(_this.remember);
                        if (res.result.project.length > 1) {
                            _this.$emit('change', res.result.project);
                        } else {
                            if (res.result.sysConfig.menu.length === 0) {
                                _this.$message({
                                    message: '您还没有访问权限',
                                    type: 'warning'
                                });
                                return false;
                            }
                            _this.$emit('success', res);
                        }
                    }).catch(function () {
                        _this.loading = false;
                    });
                } else {
                    console.log('not valid');
                    return false;
                }
            });
        }
    },
    created: function created() {
        this.rememberCurrent();
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d509c0f6"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/login/main.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "sub-title",
    class: [_vm.emailMode ? '' : 'active'],
    on: {
      "click": _vm.toggleView
    }
  }, [_vm._v("工号登录")]), _vm._v(" "), _c('span', {
    staticClass: "divider"
  }), _vm._v(" "), _c('span', {
    staticClass: "sub-title",
    class: [_vm.emailMode ? 'active' : ''],
    on: {
      "click": _vm.toggleView
    }
  }, [_vm._v("邮箱登录")])]), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.ruleForm,
      "autocomplete": "off"
    }
  }, [(!_vm.emailMode) ? _c('el-form-item', {
    key: 1,
    attrs: {
      "prop": "username"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入工号"
    },
    model: {
      value: (_vm.ruleForm.username),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "username", $$v)
      },
      expression: "ruleForm.username"
    }
  })], 1) : _c('el-form-item', {
    key: 2,
    attrs: {
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入邮箱前缀"
    },
    model: {
      value: (_vm.ruleForm.email),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "email", $$v)
      },
      expression: "ruleForm.email"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("@corp.netease.com")])], 2)], 1), _vm._v(" "), _c('el-form-item', {
    key: _vm.emailMode ? 3 : 4,
    attrs: {
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "请输入密码",
      "auto-complete": "new-password"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitForm('ruleForm')
      }
    },
    model: {
      value: (_vm.ruleForm.password),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "password", $$v)
      },
      expression: "ruleForm.password"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-left mb-20"
  }, [_c('el-checkbox', {
    attrs: {
      "label": "记住密码"
    },
    model: {
      value: (_vm.remember),
      callback: function($$v) {
        _vm.remember = $$v
      },
      expression: "remember"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("登录\n            ")])], 1), _vm._v(" "), _c('el-form-item', [_c('a', {
    attrs: {
      "href": ((_vm.$axios.defaults.baseURL) + "/logindoOpenID.html")
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    }
  }, [_vm._v("OpenId登录")])], 1)])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var login_main_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/views/login/main.vue
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  main_defaultExport,
  login_main_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var views_login_main_defaultExport = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/login/project.vue


/* harmony default export */ var project_defaultExport = ({
    name: 'project',
    props: {
        projects: Array
    },
    data: function data() {
        return {
            url: '/loginProject.api',
            ruleForm: {
                projectId: ''
            },
            rules: {
                projectId: [{ required: true, message: '请选择项目', trigger: 'blur,change' }]
            },
            loading: false
        };
    },

    methods: {
        submitForm: function submitForm(form) {
            var _this = this;

            this.$refs[form].validate(function (vaild) {
                if (vaild) {
                    _this.loading = true;
                    _this.$axios.post(_this.url, _this.ruleForm, { 'X-loadingOff': true }).then(function (res) {
                        _this.loading = false;
                        _this.$emit('success', res);
                    }).catch(function () {
                        _this.loading = false;
                    });
                } else {
                    console.log('not valid');
                    return false;
                }
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5182d0fd"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/login/project.vue
var project_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_vm._m(0), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.ruleForm
    }
  }, [(_vm.projects.length) ? _c('el-form-item', {
    staticClass: "select-drop",
    attrs: {
      "prop": "projectId"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择项目"
    },
    model: {
      value: (_vm.ruleForm.projectId),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "projectId", $$v)
      },
      expression: "ruleForm.projectId"
    }
  }, _vm._l((_vm.projects), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "50px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("进入项目\n            ")])], 1)], 1)], 1)
}
var project_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "sub-title active"
  }, [_vm._v("选择项目")])])
}]
var project_esExports = { render: project_render, staticRenderFns: project_staticRenderFns }
/* harmony default export */ var login_project_defaultExport = (project_esExports);
// CONCATENATED MODULE: ./src/views/login/project.vue
var project_normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var project___vue_styles__ = null
/* scopeId */
var project___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var project___vue_module_identifier__ = null
var project_Component = project_normalizeComponent(
  project_defaultExport,
  login_project_defaultExport,
  project___vue_styles__,
  project___vue_scopeId__,
  project___vue_module_identifier__
)

/* harmony default export */ var views_login_project_defaultExport = (project_Component.exports);

// CONCATENATED MODULE: ./src/views/login/openIDhandlerMixin.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);



/* harmony default export */ var openIDhandlerMixin_defaultExport = ({
    methods: {
        opIdHandler: function opIdHandler() {
            var res = this.$route.query.opid || this.$route.query.unity;
            res = res ? JSON.parse(res) : {};
            if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(res).length) {
                if (res.status === true || res.status === 'true') {
                    if (res.result && res.result.project.length > 1) {
                        this.trans(res.result.project);
                    }
                } else {
                    this.$store.commit('MESSAGE_ERROR', res.desc);
                }
            }
        }
    },
    created: function created() {
        this.opIdHandler();
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/login/login.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__switchProjectMixin__ = __webpack_require__(287);







/* harmony default export */ var login_defaultExport = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_2__switchProjectMixin__["a" /* default */], openIDhandlerMixin_defaultExport],
    data: function data() {
        return {
            transition: 'slide-right',
            transitionKey: 1,
            currentView: views_login_main_defaultExport,
            options: [],
            copyrightText: '网易公司版权所有©1997-2020',
            icpLink: 'http://www.beian.miit.gov.cn',
            icpText: 'ICP备案：粤B2-20090191-18'
        };
    },
    created: function created() {
        var _this = this;

        window.frontendCommonContext.onLoad(function () {
            if (window.frontendCommonConfig) {
                _this.icpLink = window.frontendCommonConfig.icpLink;
                _this.icpText = window.frontendCommonConfig.icpText['.163.com'];
                _this.copyrightText = window.frontendCommonConfig.copyright;
            }
        });
    },

    computed: {
        year: function year() {
            return new Date().getFullYear();
        }
    },
    methods: {
        trans: function trans() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

            this.options = options;
            this.currentView = this.currentView === views_login_main_defaultExport ? views_login_project_defaultExport : views_login_main_defaultExport;
            this.transition = this.transition === 'slide-left' ? 'slide-right' : 'slide-left';
            this.transitionKey = this.transitionKey === 1 ? 2 : 1;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75f55f66"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/login/login.vue
var login_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-page"
  }, [_c('div', {
    staticClass: "login-main"
  }, [_c('div', {
    staticClass: "login-form"
  }, [_c('div', {
    staticClass: "center-box"
  }, [_vm._m(0), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "login-left"
  })]), _vm._v(" "), _c('el-col', {
    staticClass: "rule-form",
    attrs: {
      "span": 12
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.transition
    }
  }, [_c('div', {
    key: _vm.transitionKey,
    staticClass: "transition-wrap"
  }, [_c(_vm.currentView, {
    tag: "component",
    attrs: {
      "projects": _vm.options
    },
    on: {
      "change": _vm.trans,
      "success": _vm.successLogin
    }
  })], 1)])], 1)], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(744),
      "alt": "logo"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "mt-10"
  }, [_vm._v(_vm._s(_vm.copyrightText))]), _vm._v(" "), _c('p', {
    staticClass: "ml-10",
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "#333"
    },
    attrs: {
      "href": _vm.icpLink,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.icpText))])])])])
}
var login_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "left",
      "top": "-50px",
      "position": "absolute"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(745),
      "alt": "netease"
    }
  })])
}]
var login_esExports = { render: login_render, staticRenderFns: login_staticRenderFns }
/* harmony default export */ var login_login_defaultExport = (login_esExports);
// CONCATENATED MODULE: ./src/views/login/login.vue
function injectStyle (ssrContext) {
  __webpack_require__(658)
}
var login_normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var login___vue_styles__ = injectStyle
/* scopeId */
var login___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var login___vue_module_identifier__ = null
var login_Component = login_normalizeComponent(
  login_defaultExport,
  login_login_defaultExport,
  login___vue_styles__,
  login___vue_scopeId__,
  login___vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (login_Component.exports);


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(659);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("c2c7c550", content, true);

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "@-moz-keyframes background-move{0%{background-position-x:0}to{background-position-x:-1920px}}@-webkit-keyframes background-move{0%{background-position-x:0}to{background-position-x:-1920px}}@keyframes background-move{0%{background-position-x:0}to{background-position-x:-1920px}}.login-page{height:100%;background:#edf1f2 url(" + __webpack_require__(660) + ") no-repeat bottom;background-size:200%;-moz-animation:background-move 30s linear infinite;-webkit-animation:background-move 30s linear infinite;animation:background-move 30s linear infinite;background-position-y:bottom;background-position-x:0}.login-page .login-main{display:table;table-layout:fixed;height:100%;width:100%}.login-page .login-main .login-form{display:table-cell;vertical-align:middle;text-align:center;width:100%;height:100%}.login-page .login-main .center-box{width:1000px;height:550px;margin:0 auto;position:relative;box-sizing:border-box;box-shadow:0 0 6px rgba(0,0,0,.2);background:#fff;border-radius:5px}.login-page .login-main .login-left{height:550px;background:url(" + __webpack_require__(661) + ") no-repeat 50%}.login-page .login-main .rule-form{display:inline-block;box-sizing:border-box}.login-page .login-main .rule-form .transition-wrap{position:absolute;top:60px;padding:30px 60px 20px;box-sizing:border-box;border-left:1px solid #f2f5f9;height:415px;width:440px;transition:all .5s cubic-bezier(.55,0,.1,1)}.login-page .login-main .rule-form .line{margin:25px 0 0;border-top:1px solid #e2e7eb}.login-page .login-main .rule-form .line span{display:inline-block;padding:0 10px;background:#fff;position:relative;top:-12px}.login-page .login-main .rule-form .title{font-size:18px;color:#999;margin-top:20px;margin-bottom:40px}.login-page .login-main .rule-form .title .divider{margin:0 30px;height:17px;display:inline-block;border-left:1px solid #e0e0e0;vertical-align:middle}.login-page .login-main .rule-form .title .sub-title{cursor:pointer}.login-page .login-main .rule-form .title .sub-title.active{font-weight:700;color:#2481ff}.login-page .login-main .rule-form .select-drop .el-select{display:block}.login-page .footer{text-align:center;margin-top:-130px;height:auto}", ""]);

// exports


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/bgddaacd8a.png";

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/left-side097f2674.png";

/***/ }),
/* 662 */
/***/ (function(module, exports) {



(function ($w) {

    if (typeof $w.RSAUtils === 'undefined') var RSAUtils = $w.RSAUtils = {};

    var biRadixBase = 2;
    var biRadixBits = 16;
    var bitsPerDigit = biRadixBits;
    var biRadix = 1 << 16;
    var biHalfRadix = biRadix >>> 1;
    var biRadixSquared = biRadix * biRadix;
    var maxDigitVal = biRadix - 1;
    var maxInteger = 9999999999999998;

    var maxDigits;
    var ZERO_ARRAY;
    var bigZero, bigOne;

    var BigInt = $w.BigInt = function (flag) {
        if (typeof flag == 'boolean' && flag == true) {
            this.digits = null;
        } else {
            this.digits = ZERO_ARRAY.slice(0);
        }
        this.isNeg = false;
    };

    RSAUtils.setMaxDigits = function (value) {
        maxDigits = value;
        ZERO_ARRAY = new Array(maxDigits);
        for (var iza = 0; iza < ZERO_ARRAY.length; iza++) {
            ZERO_ARRAY[iza] = 0;
        }bigZero = new BigInt();
        bigOne = new BigInt();
        bigOne.digits[0] = 1;
    };
    RSAUtils.setMaxDigits(20);

    var dpl10 = 15;

    RSAUtils.biFromNumber = function (i) {
        var result = new BigInt();
        result.isNeg = i < 0;
        i = Math.abs(i);
        var j = 0;
        while (i > 0) {
            result.digits[j++] = i & maxDigitVal;
            i = Math.floor(i / biRadix);
        }
        return result;
    };

    var lr10 = RSAUtils.biFromNumber(1000000000000000);

    RSAUtils.biFromDecimal = function (s) {
        var isNeg = s.charAt(0) == '-';
        var i = isNeg ? 1 : 0;
        var result;

        while (i < s.length && s.charAt(i) == '0') {
            ++i;
        }if (i == s.length) {
            result = new BigInt();
        } else {
            var digitCount = s.length - i;
            var fgl = digitCount % dpl10;
            if (fgl == 0) fgl = dpl10;
            result = RSAUtils.biFromNumber(Number(s.substr(i, fgl)));
            i += fgl;
            while (i < s.length) {
                result = RSAUtils.biAdd(RSAUtils.biMultiply(result, lr10), RSAUtils.biFromNumber(Number(s.substr(i, dpl10))));
                i += dpl10;
            }
            result.isNeg = isNeg;
        }
        return result;
    };

    RSAUtils.biCopy = function (bi) {
        var result = new BigInt(true);
        result.digits = bi.digits.slice(0);
        result.isNeg = bi.isNeg;
        return result;
    };

    RSAUtils.reverseStr = function (s) {
        var result = '';
        for (var i = s.length - 1; i > -1; --i) {
            result += s.charAt(i);
        }
        return result;
    };

    var hexatrigesimalToChar = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];

    RSAUtils.biToString = function (x, radix) {
        var b = new BigInt();
        b.digits[0] = radix;
        var qr = RSAUtils.biDivideModulo(x, b);
        var result = hexatrigesimalToChar[qr[1].digits[0]];
        while (RSAUtils.biCompare(qr[0], bigZero) == 1) {
            qr = RSAUtils.biDivideModulo(qr[0], b);
            digit = qr[1].digits[0];
            result += hexatrigesimalToChar[qr[1].digits[0]];
        }
        return (x.isNeg ? '-' : '') + RSAUtils.reverseStr(result);
    };

    RSAUtils.biToDecimal = function (x) {
        var b = new BigInt();
        b.digits[0] = 10;
        var qr = RSAUtils.biDivideModulo(x, b);
        var result = String(qr[1].digits[0]);
        while (RSAUtils.biCompare(qr[0], bigZero) == 1) {
            qr = RSAUtils.biDivideModulo(qr[0], b);
            result += String(qr[1].digits[0]);
        }
        return (x.isNeg ? '-' : '') + RSAUtils.reverseStr(result);
    };

    var hexToChar = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f'];

    RSAUtils.digitToHex = function (n) {
        var mask = 0xf;
        var result = '';
        for (i = 0; i < 4; ++i) {
            result += hexToChar[n & mask];
            n >>>= 4;
        }
        return RSAUtils.reverseStr(result);
    };

    RSAUtils.biToHex = function (x) {
        var result = '';
        var n = RSAUtils.biHighIndex(x);
        for (var i = RSAUtils.biHighIndex(x); i > -1; --i) {
            result += RSAUtils.digitToHex(x.digits[i]);
        }
        return result;
    };

    RSAUtils.charToHex = function (c) {
        var ZERO = 48;
        var NINE = ZERO + 9;
        var littleA = 97;
        var littleZ = littleA + 25;
        var bigA = 65;
        var bigZ = 65 + 25;
        var result;

        if (c >= ZERO && c <= NINE) {
            result = c - ZERO;
        } else if (c >= bigA && c <= bigZ) {
            result = 10 + c - bigA;
        } else if (c >= littleA && c <= littleZ) {
            result = 10 + c - littleA;
        } else {
            result = 0;
        }
        return result;
    };

    RSAUtils.hexToDigit = function (s) {
        var result = 0;
        var sl = Math.min(s.length, 4);
        for (var i = 0; i < sl; ++i) {
            result <<= 4;
            result |= RSAUtils.charToHex(s.charCodeAt(i));
        }
        return result;
    };

    RSAUtils.biFromHex = function (s) {
        var result = new BigInt();
        var sl = s.length;
        for (var i = sl, j = 0; i > 0; i -= 4, ++j) {
            result.digits[j] = RSAUtils.hexToDigit(s.substr(Math.max(i - 4, 0), Math.min(i, 4)));
        }
        return result;
    };

    RSAUtils.biFromString = function (s, radix) {
        var isNeg = s.charAt(0) == '-';
        var istop = isNeg ? 1 : 0;
        var result = new BigInt();
        var place = new BigInt();
        place.digits[0] = 1;
        for (var i = s.length - 1; i >= istop; i--) {
            var c = s.charCodeAt(i);
            var digit = RSAUtils.charToHex(c);
            var biDigit = RSAUtils.biMultiplyDigit(place, digit);
            result = RSAUtils.biAdd(result, biDigit);
            place = RSAUtils.biMultiplyDigit(place, radix);
        }
        result.isNeg = isNeg;
        return result;
    };

    RSAUtils.biDump = function (b) {
        return (b.isNeg ? '-' : '') + b.digits.join(' ');
    };

    RSAUtils.biAdd = function (x, y) {
        var result;

        if (x.isNeg != y.isNeg) {
            y.isNeg = !y.isNeg;
            result = RSAUtils.biSubtract(x, y);
            y.isNeg = !y.isNeg;
        } else {
            result = new BigInt();
            var c = 0;
            var n;
            for (var i = 0; i < x.digits.length; ++i) {
                n = x.digits[i] + y.digits[i] + c;
                result.digits[i] = n % biRadix;
                c = Number(n >= biRadix);
            }
            result.isNeg = x.isNeg;
        }
        return result;
    };

    RSAUtils.biSubtract = function (x, y) {
        var result;
        if (x.isNeg != y.isNeg) {
            y.isNeg = !y.isNeg;
            result = RSAUtils.biAdd(x, y);
            y.isNeg = !y.isNeg;
        } else {
            result = new BigInt();
            var n, c;
            c = 0;
            for (var i = 0; i < x.digits.length; ++i) {
                n = x.digits[i] - y.digits[i] + c;
                result.digits[i] = n % biRadix;

                if (result.digits[i] < 0) result.digits[i] += biRadix;
                c = 0 - Number(n < 0);
            }

            if (c == -1) {
                c = 0;
                for (var i = 0; i < x.digits.length; ++i) {
                    n = 0 - result.digits[i] + c;
                    result.digits[i] = n % biRadix;

                    if (result.digits[i] < 0) result.digits[i] += biRadix;
                    c = 0 - Number(n < 0);
                }

                result.isNeg = !x.isNeg;
            } else {
                result.isNeg = x.isNeg;
            }
        }
        return result;
    };

    RSAUtils.biHighIndex = function (x) {
        var result = x.digits.length - 1;
        while (result > 0 && x.digits[result] == 0) {
            --result;
        }return result;
    };

    RSAUtils.biNumBits = function (x) {
        var n = RSAUtils.biHighIndex(x);
        var d = x.digits[n];
        var m = (n + 1) * bitsPerDigit;
        var result;
        for (result = m; result > m - bitsPerDigit; --result) {
            if ((d & 0x8000) != 0) break;
            d <<= 1;
        }
        return result;
    };

    RSAUtils.biMultiply = function (x, y) {
        var result = new BigInt();
        var c;
        var n = RSAUtils.biHighIndex(x);
        var t = RSAUtils.biHighIndex(y);
        var u, uv, k;

        for (var i = 0; i <= t; ++i) {
            c = 0;
            k = i;
            for (j = 0; j <= n; ++j, ++k) {
                uv = result.digits[k] + x.digits[j] * y.digits[i] + c;
                result.digits[k] = uv & maxDigitVal;
                c = uv >>> biRadixBits;
            }
            result.digits[i + n + 1] = c;
        }

        result.isNeg = x.isNeg != y.isNeg;
        return result;
    };

    RSAUtils.biMultiplyDigit = function (x, y) {
        var n, c, uv;

        var result = new BigInt();
        n = RSAUtils.biHighIndex(x);
        c = 0;
        for (var j = 0; j <= n; ++j) {
            uv = result.digits[j] + x.digits[j] * y + c;
            result.digits[j] = uv & maxDigitVal;
            c = uv >>> biRadixBits;
        }
        result.digits[1 + n] = c;
        return result;
    };

    RSAUtils.arrayCopy = function (src, srcStart, dest, destStart, n) {
        var m = Math.min(srcStart + n, src.length);
        for (var i = srcStart, j = destStart; i < m; ++i, ++j) {
            dest[j] = src[i];
        }
    };

    var highBitMasks = [0x0000, 0x8000, 0xC000, 0xE000, 0xF000, 0xF800, 0xFC00, 0xFE00, 0xFF00, 0xFF80, 0xFFC0, 0xFFE0, 0xFFF0, 0xFFF8, 0xFFFC, 0xFFFE, 0xFFFF];

    RSAUtils.biShiftLeft = function (x, n) {
        var digitCount = Math.floor(n / bitsPerDigit);
        var result = new BigInt();
        RSAUtils.arrayCopy(x.digits, 0, result.digits, digitCount, result.digits.length - digitCount);
        var bits = n % bitsPerDigit;
        var rightBits = bitsPerDigit - bits;
        for (var i = result.digits.length - 1, i1 = i - 1; i > 0; --i, --i1) {
            result.digits[i] = result.digits[i] << bits & maxDigitVal | (result.digits[i1] & highBitMasks[bits]) >>> rightBits;
        }
        result.digits[0] = result.digits[i] << bits & maxDigitVal;
        result.isNeg = x.isNeg;
        return result;
    };

    var lowBitMasks = [0x0000, 0x0001, 0x0003, 0x0007, 0x000F, 0x001F, 0x003F, 0x007F, 0x00FF, 0x01FF, 0x03FF, 0x07FF, 0x0FFF, 0x1FFF, 0x3FFF, 0x7FFF, 0xFFFF];

    RSAUtils.biShiftRight = function (x, n) {
        var digitCount = Math.floor(n / bitsPerDigit);
        var result = new BigInt();
        RSAUtils.arrayCopy(x.digits, digitCount, result.digits, 0, x.digits.length - digitCount);
        var bits = n % bitsPerDigit;
        var leftBits = bitsPerDigit - bits;
        for (var i = 0, i1 = i + 1; i < result.digits.length - 1; ++i, ++i1) {
            result.digits[i] = result.digits[i] >>> bits | (result.digits[i1] & lowBitMasks[bits]) << leftBits;
        }
        result.digits[result.digits.length - 1] >>>= bits;
        result.isNeg = x.isNeg;
        return result;
    };

    RSAUtils.biMultiplyByRadixPower = function (x, n) {
        var result = new BigInt();
        RSAUtils.arrayCopy(x.digits, 0, result.digits, n, result.digits.length - n);
        return result;
    };

    RSAUtils.biDivideByRadixPower = function (x, n) {
        var result = new BigInt();
        RSAUtils.arrayCopy(x.digits, n, result.digits, 0, result.digits.length - n);
        return result;
    };

    RSAUtils.biModuloByRadixPower = function (x, n) {
        var result = new BigInt();
        RSAUtils.arrayCopy(x.digits, 0, result.digits, 0, n);
        return result;
    };

    RSAUtils.biCompare = function (x, y) {
        if (x.isNeg != y.isNeg) {
            return 1 - 2 * Number(x.isNeg);
        }
        for (var i = x.digits.length - 1; i >= 0; --i) {
            if (x.digits[i] != y.digits[i]) {
                if (x.isNeg) {
                    return 1 - 2 * Number(x.digits[i] > y.digits[i]);
                } else {
                    return 1 - 2 * Number(x.digits[i] < y.digits[i]);
                }
            }
        }
        return 0;
    };

    RSAUtils.biDivideModulo = function (x, y) {
        var nb = RSAUtils.biNumBits(x);
        var tb = RSAUtils.biNumBits(y);
        var origYIsNeg = y.isNeg;
        var q, r;
        if (nb < tb) {
            if (x.isNeg) {
                q = RSAUtils.biCopy(bigOne);
                q.isNeg = !y.isNeg;
                x.isNeg = false;
                y.isNeg = false;
                r = biSubtract(y, x);

                x.isNeg = true;
                y.isNeg = origYIsNeg;
            } else {
                q = new BigInt();
                r = RSAUtils.biCopy(x);
            }
            return [q, r];
        }

        q = new BigInt();
        r = x;

        var t = Math.ceil(tb / bitsPerDigit) - 1;
        var lambda = 0;
        while (y.digits[t] < biHalfRadix) {
            y = RSAUtils.biShiftLeft(y, 1);
            ++lambda;
            ++tb;
            t = Math.ceil(tb / bitsPerDigit) - 1;
        }

        r = RSAUtils.biShiftLeft(r, lambda);
        nb += lambda;
        var n = Math.ceil(nb / bitsPerDigit) - 1;

        var b = RSAUtils.biMultiplyByRadixPower(y, n - t);
        while (RSAUtils.biCompare(r, b) != -1) {
            ++q.digits[n - t];
            r = RSAUtils.biSubtract(r, b);
        }
        for (var i = n; i > t; --i) {
            var ri = i >= r.digits.length ? 0 : r.digits[i];
            var ri1 = i - 1 >= r.digits.length ? 0 : r.digits[i - 1];
            var ri2 = i - 2 >= r.digits.length ? 0 : r.digits[i - 2];
            var yt = t >= y.digits.length ? 0 : y.digits[t];
            var yt1 = t - 1 >= y.digits.length ? 0 : y.digits[t - 1];
            if (ri == yt) {
                q.digits[i - t - 1] = maxDigitVal;
            } else {
                q.digits[i - t - 1] = Math.floor((ri * biRadix + ri1) / yt);
            }

            var c1 = q.digits[i - t - 1] * (yt * biRadix + yt1);
            var c2 = ri * biRadixSquared + (ri1 * biRadix + ri2);
            while (c1 > c2) {
                --q.digits[i - t - 1];
                c1 = q.digits[i - t - 1] * (yt * biRadix | yt1);
                c2 = ri * biRadix * biRadix + (ri1 * biRadix + ri2);
            }

            b = RSAUtils.biMultiplyByRadixPower(y, i - t - 1);
            r = RSAUtils.biSubtract(r, RSAUtils.biMultiplyDigit(b, q.digits[i - t - 1]));
            if (r.isNeg) {
                r = RSAUtils.biAdd(r, b);
                --q.digits[i - t - 1];
            }
        }
        r = RSAUtils.biShiftRight(r, lambda);

        q.isNeg = x.isNeg != origYIsNeg;
        if (x.isNeg) {
            if (origYIsNeg) {
                q = RSAUtils.biAdd(q, bigOne);
            } else {
                q = RSAUtils.biSubtract(q, bigOne);
            }
            y = RSAUtils.biShiftRight(y, lambda);
            r = RSAUtils.biSubtract(y, r);
        }

        if (r.digits[0] == 0 && RSAUtils.biHighIndex(r) == 0) r.isNeg = false;

        return [q, r];
    };

    RSAUtils.biDivide = function (x, y) {
        return RSAUtils.biDivideModulo(x, y)[0];
    };

    RSAUtils.biModulo = function (x, y) {
        return RSAUtils.biDivideModulo(x, y)[1];
    };

    RSAUtils.biMultiplyMod = function (x, y, m) {
        return RSAUtils.biModulo(RSAUtils.biMultiply(x, y), m);
    };

    RSAUtils.biPow = function (x, y) {
        var result = bigOne;
        var a = x;
        while (true) {
            if ((y & 1) != 0) result = RSAUtils.biMultiply(result, a);
            y >>= 1;
            if (y == 0) break;
            a = RSAUtils.biMultiply(a, a);
        }
        return result;
    };

    RSAUtils.biPowMod = function (x, y, m) {
        var result = bigOne;
        var a = x;
        var k = y;
        while (true) {
            if ((k.digits[0] & 1) != 0) result = RSAUtils.biMultiplyMod(result, a, m);
            k = RSAUtils.biShiftRight(k, 1);
            if (k.digits[0] == 0 && RSAUtils.biHighIndex(k) == 0) break;
            a = RSAUtils.biMultiplyMod(a, a, m);
        }
        return result;
    };

    $w.BarrettMu = function (m) {
        this.modulus = RSAUtils.biCopy(m);
        this.k = RSAUtils.biHighIndex(this.modulus) + 1;
        var b2k = new BigInt();
        b2k.digits[2 * this.k] = 1;
        this.mu = RSAUtils.biDivide(b2k, this.modulus);
        this.bkplus1 = new BigInt();
        this.bkplus1.digits[this.k + 1] = 1;
        this.modulo = BarrettMu_modulo;
        this.multiplyMod = BarrettMu_multiplyMod;
        this.powMod = BarrettMu_powMod;
    };

    function BarrettMu_modulo(x) {
        var $dmath = RSAUtils;
        var q1 = $dmath.biDivideByRadixPower(x, this.k - 1);
        var q2 = $dmath.biMultiply(q1, this.mu);
        var q3 = $dmath.biDivideByRadixPower(q2, this.k + 1);
        var r1 = $dmath.biModuloByRadixPower(x, this.k + 1);
        var r2term = $dmath.biMultiply(q3, this.modulus);
        var r2 = $dmath.biModuloByRadixPower(r2term, this.k + 1);
        var r = $dmath.biSubtract(r1, r2);
        if (r.isNeg) {
            r = $dmath.biAdd(r, this.bkplus1);
        }
        var rgtem = $dmath.biCompare(r, this.modulus) >= 0;
        while (rgtem) {
            r = $dmath.biSubtract(r, this.modulus);
            rgtem = $dmath.biCompare(r, this.modulus) >= 0;
        }
        return r;
    }

    function BarrettMu_multiplyMod(x, y) {
        var xy = RSAUtils.biMultiply(x, y);
        return this.modulo(xy);
    }

    function BarrettMu_powMod(x, y) {
        var result = new BigInt();
        result.digits[0] = 1;
        var a = x;
        var k = y;
        while (true) {
            if ((k.digits[0] & 1) != 0) result = this.multiplyMod(result, a);
            k = RSAUtils.biShiftRight(k, 1);
            if (k.digits[0] == 0 && RSAUtils.biHighIndex(k) == 0) break;
            a = this.multiplyMod(a, a);
        }
        return result;
    }

    var RSAKeyPair = function RSAKeyPair(encryptionExponent, decryptionExponent, modulus) {
        var $dmath = RSAUtils;
        this.e = $dmath.biFromHex(encryptionExponent);
        this.d = $dmath.biFromHex(decryptionExponent);
        this.m = $dmath.biFromHex(modulus);

        this.chunkSize = 2 * $dmath.biHighIndex(this.m);
        this.radix = 16;
        this.barrett = new $w.BarrettMu(this.m);
    };

    RSAUtils.getKeyPair = function (encryptionExponent, decryptionExponent, modulus) {
        return new RSAKeyPair(encryptionExponent, decryptionExponent, modulus);
    };

    if (typeof $w.twoDigit === 'undefined') {
        $w.twoDigit = function (n) {
            return (n < 10 ? '0' : '') + String(n);
        };
    }

    RSAUtils.encryptedString = function (key, s) {
        var a = [];
        var sl = s.length;
        var i = 0;
        while (i < sl) {
            a[i] = s.charCodeAt(i);
            i++;
        }

        while (a.length % key.chunkSize != 0) {
            a[i++] = 0;
        }

        var al = a.length;
        var result = '';
        var j, k, block;
        for (i = 0; i < al; i += key.chunkSize) {
            block = new BigInt();
            j = 0;
            for (k = i; k < i + key.chunkSize; ++j) {
                block.digits[j] = a[k++];
                block.digits[j] += a[k++] << 8;
            }
            var crypt = key.barrett.powMod(block, key.e);
            var text = key.radix == 16 ? RSAUtils.biToHex(crypt) : RSAUtils.biToString(crypt, key.radix);
            result += text + ' ';
        }
        return result.substring(0, result.length - 1);
    };

    RSAUtils.decryptedString = function (key, s) {
        var blocks = s.split(' ');
        var result = '';
        var i, j, block;
        for (i = 0; i < blocks.length; ++i) {
            var bi;
            if (key.radix == 16) {
                bi = RSAUtils.biFromHex(blocks[i]);
            } else {
                bi = RSAUtils.biFromString(blocks[i], key.radix);
            }
            block = key.barrett.powMod(bi, key.d);
            for (j = 0; j <= RSAUtils.biHighIndex(block); ++j) {
                result += String.fromCharCode(block.digits[j] & 255, block.digits[j] >> 8);
            }
        }

        if (result.charCodeAt(result.length - 1) == 0) {
            result = result.substring(0, result.length - 1);
        }
        return result;
    };

    RSAUtils.setMaxDigits(130);
})(window);

/***/ }),
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 699 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 700 */
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */
/***/ (function(module, exports) {

module.exports = {"_args":[["elliptic@6.4.0","/home/jenkins/jenkinsData/workspace/前端_外包招聘后台B"]],"_development":true,"_from":"elliptic@6.4.0","_id":"elliptic@6.4.0","_inBundle":false,"_integrity":"sha1-ysmvh2LIWDYYcAPI3+GT5eLq5d8=","_location":"/elliptic","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"elliptic@6.4.0","name":"elliptic","escapedName":"elliptic","rawSpec":"6.4.0","saveSpec":null,"fetchSpec":"6.4.0"},"_requiredBy":["/browserify-sign","/create-ecdh"],"_resolved":"https://registry.npmjs.org/elliptic/-/elliptic-6.4.0.tgz","_spec":"6.4.0","_where":"/home/jenkins/jenkinsData/workspace/前端_外包招聘后台B","author":{"name":"Fedor Indutny","email":"fedor@indutny.com"},"bugs":{"url":"https://github.com/indutny/elliptic/issues"},"dependencies":{"bn.js":"^4.4.0","brorand":"^1.0.1","hash.js":"^1.0.0","hmac-drbg":"^1.0.0","inherits":"^2.0.1","minimalistic-assert":"^1.0.0","minimalistic-crypto-utils":"^1.0.0"},"description":"EC cryptography","devDependencies":{"brfs":"^1.4.3","coveralls":"^2.11.3","grunt":"^0.4.5","grunt-browserify":"^5.0.0","grunt-cli":"^1.2.0","grunt-contrib-connect":"^1.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^1.0.1","grunt-mocha-istanbul":"^3.0.1","grunt-saucelabs":"^8.6.2","istanbul":"^0.4.2","jscs":"^2.9.0","jshint":"^2.6.0","mocha":"^2.1.0"},"files":["lib"],"homepage":"https://github.com/indutny/elliptic","keywords":["EC","Elliptic","curve","Cryptography"],"license":"MIT","main":"lib/elliptic.js","name":"elliptic","repository":{"type":"git","url":"git+ssh://git@github.com/indutny/elliptic.git"},"scripts":{"jscs":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","jshint":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","lint":"npm run jscs && npm run jshint","test":"npm run lint && npm run unit","unit":"istanbul test _mocha --reporter=spec test/index.js","version":"grunt dist && git add dist/"},"version":"6.4.0"}

/***/ }),
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/login-logo7082d003.png";

/***/ }),
/* 745 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/index/index.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_queryListExtend__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__operation_operationMixin__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mixins_selectMapMixin__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__operation_attachViewInList_vue__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__operation_remarkEditDialog_vue__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_underscore__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_modules_tools__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_views_common_multiSearch__ = __webpack_require__(88);













/* harmony default export */ var index_defaultExport = ({
    components: {
        AttachViewInList: __WEBPACK_IMPORTED_MODULE_4__operation_attachViewInList_vue__["a" /* default */],
        RemarkEdit: __WEBPACK_IMPORTED_MODULE_5__operation_remarkEditDialog_vue__["a" /* default */],
        MultiSearch: __WEBPACK_IMPORTED_MODULE_9_views_common_multiSearch__["a" /* default */]
    },
    data: function data() {
        return {
            fetchUrl: '/desktop/task/list.api',
            tasks: [],
            searchData: {
                searchWord: null
            },
            searchInputIcon: '',
            tableData: [],
            tasksExtend: {
                '0': {
                    urls: ['/resume?statusSearch=000', '/resume?statusSearch=001', '/resume?statusSearch=002,003', ''],
                    className: 'el-icon-my-daichulijianli color-success'
                },
                '1': {
                    urls: ['/written?resumeStatus=010', '/written?resumeStatus=011,012,013', '/written?resumeStatus=014', ''],
                    className: 'el-icon-my-luyonghuanjie color-purple'
                },
                '2': {
                    urls: [['/interview/1?interviewStatusSearch=2', '/interview/1?interviewStatusSearch=1'], ['/interview/2?interviewStatusSearch=2', '/interview/2?interviewStatusSearch=1'], ['/interview/3?interviewStatusSearch=2', '/interview/3?interviewStatusSearch=1'], ['/interview/4?interviewStatusSearch=2', '/interview/4?interviewStatusSearch=1']],
                    childrenUrls: [['/interview/1?statusSearch=020,021', '/interview/1?statusSearch=022', '', '/interview/1?statusSearch=024,023'], ['/interview/2?statusSearch=120,121', '/interview/2?statusSearch=122', '', '/interview/2?statusSearch=124,123'], ['/interview/3?statusSearch=220,221', '/interview/3?statusSearch=222', '', '/interview/3?statusSearch=224,223'], ['/interview/4?statusSearch=320,321', '/interview/4?statusSearch=322', '', '/interview/4?statusSearch=324,323']],
                    className: 'el-icon-my-mianshihuanjie color-info'
                },
                '3': {
                    urls: ['/salary?statusSearch=030', '/salary?statusSearch=032', '/salary?statusSearch=040'],
                    className: 'el-icon-my-mianshipinggu color-primary'
                },
                '4': {
                    urls: ['/entry?statusSearch=040', '/entry?statusSearch=042', '/entry?statusSearch=050'],
                    className: 'el-icon-my-ruzhihuanjie color-primary'
                }
            }
        };
    },

    extends: __WEBPACK_IMPORTED_MODULE_1_components_queryListExtend__["a" /* default */],
    mixins: [__WEBPACK_IMPORTED_MODULE_2__operation_operationMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3_mixins_selectMapMixin__["a" /* default */]],
    computed: {
        selectMap: function selectMap() {
            return this.$store.state.baseData.selectMap;
        },
        hasSalary: function hasSalary() {
            return this.$store.state.user.paymentFlag;
        },
        hasWritten: function hasWritten() {
            return this.$store.state.user.writtenFlag;
        },
        interviewData: function interviewData() {
            var data = this.tasks.filter(function (item) {
                return item.type === '2';
            });
            var result = [];
            if (data.length) {
                data = data[0];
                data.taskCount.forEach(function (item, index) {
                    if (index % 5 === 0) {
                        item.children = [];
                        result.push(item);
                    } else {
                        var order = Math.floor(index / 5);
                        result[order] && result[order].children.push(item);
                    }
                });
            }
            console.log(result);
            return result;
        }
    },
    methods: {
        dateFormat: function dateFormat(date) {
            var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'yyyy/MM/dd';

            return Object(__WEBPACK_IMPORTED_MODULE_8_modules_tools__["a" /* dateFormat */])(date, format);
        },
        transToText: function transToText(base, value) {
            var target = __WEBPACK_IMPORTED_MODULE_7_underscore___default.a.findWhere(this.selectMap[base], { value: value + '' });
            return target && target.text || '';
        },
        getStatusText: function getStatusText(row) {
            if (row.isJobTransfer == 1) {
                return '已转岗';
            }

            return this.transToText('WB_FLOW_STATUS', row.status);
        },
        colSpan: function colSpan(index) {
            var colSpanArr = [];
            if (this.hasWritten) {
                if (this.hasSalary) {
                    colSpanArr = [3, 4, 12, 3, 3];
                } else {
                    colSpanArr = [4, 4, 12, 4];
                }
            } else {
                if (this.hasSalary) {
                    colSpanArr = [4, 12, 4, 4];
                } else {
                    colSpanArr = [5, 14, 5];
                }
            }

            return colSpanArr[index];
        },
        getInterviewTurn: function getInterviewTurn(status) {
            var phase = status.slice(1, 2);
            if (phase === '2') {
                return Number(status.slice(0, 1)) + 1;
            }
            return undefined;
        },
        getPhaseName: function getPhaseName(status) {
            var phase = +status.slice(1, 2);
            return ['resumeList', 'writtenList', 'interviewList', '', 'entryList', 'entryList'][phase];
        },
        toResumeDetail: function toResumeDetail(row) {
            var phaseName = this.getPhaseName(row.status);
            var turn = this.getInterviewTurn(row.status);
            var path = this.getResumeDetailUrl(row.id, row.status, phaseName) + '&turn=' + turn;
            var routeData = this.$router.resolve({ path: path });
            window.open(routeData.href, '_blank');
        }
    },
    created: function created() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get('/desktop/task/statistics.api').then(function (res) {
            var temp = { urls: [], className: '' };
            res.result.list.map(function (item, index) {
                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(item, _this.tasksExtend[item.type] || temp);
                if (item.type === '2') {
                    item.taskCount = ['1', '2', '3', '4'].map(function (interviewIndex) {
                        var temp = [];
                        item.taskCount.forEach(function (taskItem) {
                            if (taskItem.type === interviewIndex) {
                                temp.push(taskItem);
                            }
                        });
                        return {
                            arrangeText: interviewIndex + ' \u9762',
                            notArrange: temp[0].taskNum,
                            arranged: temp[1].taskNum,
                            list: temp.splice(2)
                        };
                    });
                }
            });

            _this.tasks = res.result.list;
        }).catch(console.error);
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ae61142"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/index/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.firstRendered) ? _c('div', {
    staticClass: "scoped-index"
  }, [_c('div', {
    staticClass: "index-count-bar box-shadow-small border-radius"
  }, _vm._l((_vm.tasks), function(item, index) {
    return _c('div', {
      key: index,
      attrs: {
        "data-type": item.type
      }
    }, [_c('div', {
      staticClass: "count-item"
    }, [_c('p', {
      staticClass: "index-summary-title"
    }, [_c('i', {
      class: [item.className, 'mr-5']
    }), _vm._v("\n\t\t\t\t\t\t" + _vm._s(item.taskName) + "\n\t\t\t\t\t\t"), _c('span', {
      staticClass: "ml-15"
    }, [_vm._v(_vm._s(item.taskNum))])]), _vm._v(" "), _c('el-row', {
      attrs: {
        "type": "flex"
      }
    }, _vm._l((item.taskCount), function(subItem, index) {
      return _c('el-col', {
        key: index,
        attrs: {
          "span": 24 / item.taskCount.length
        }
      }, [(item.type === '2') ? _c('el-row', {
        class: {
          'interview-list-set': index > 0
        }
      }, [_c('p', {
        staticClass: "interview-text"
      }, [_c('strong', [_vm._v(_vm._s(subItem.arrangeText))]), _vm._v(" "), _c('router-link', {
        attrs: {
          "to": item.urls[index][0]
        }
      }, [_c('span', {
        staticClass: "ml-5 color-primary"
      }, [_c('small', [_vm._v("未安排：")]), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(subItem.notArrange) + "\n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('router-link', {
        attrs: {
          "to": item.urls[index][1]
        }
      }, [_c('span', {
        staticClass: "ml-5 color-primary"
      }, [_c('small', [_vm._v("已安排：")]), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(subItem.arranged) + "\n\t\t\t\t\t\t\t\t\t\t")])])], 1), _vm._v(" "), _vm._l((subItem.list), function(listItem, listIndex) {
        return _c('el-col', {
          key: listIndex,
          attrs: {
            "span": 6
          }
        }, [(item.childrenUrls[index][listIndex]) ? _c('router-link', {
          attrs: {
            "to": item.childrenUrls[index][listIndex]
          }
        }, [_c('p', {
          staticClass: "total-num"
        }, [_vm._v(_vm._s(listItem.taskNum))]), _vm._v(" "), _c('small', {
          domProps: {
            "innerHTML": _vm._s(listItem.taskName.replace('&', '&<br/>'))
          }
        })]) : [_c('p', {
          staticClass: "total-num"
        }, [_vm._v(_vm._s(listItem.taskNum))]), _vm._v(" "), _c('small', {
          domProps: {
            "innerHTML": _vm._s(listItem.taskName.replace('&', '&<br/>'))
          }
        })]], 2)
      })], 2) : [(item.urls[index]) ? _c('router-link', {
        attrs: {
          "to": item.urls[index]
        }
      }, [_c('p', {
        staticClass: "mt-20 total-num"
      }, [_vm._v(_vm._s(subItem.taskNum))]), _vm._v(" "), _c('p', {
        staticClass: "sub-title"
      }, [_vm._v(_vm._s(subItem.taskName))])]) : [_c('p', {
        staticClass: "mt-20 total-num"
      }, [_vm._v(_vm._s(subItem.taskNum))]), _vm._v(" "), _c('p', {
        staticClass: "sub-title"
      }, [_vm._v(_vm._s(subItem.taskName))])]]], 2)
    }), 1)], 1)])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "filter-result background-white box-shadow-small border-radius"
  }, [_c('div', {
    staticClass: "clearfix mb-15"
  }, [_c('export-custom-dialog', {
    staticClass: "pull-right ml-10",
    attrs: {
      "showChoosedButton": false,
      "params-call-back": _vm.customExportParams
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "pull-right",
    attrs: {
      "icon": "el-icon-my-daochu",
      "type": "info"
    },
    on: {
      "click": function($event) {
        return _vm.exportParamsFiles('/resume/exportAllResumeUnlimited.api')
      }
    }
  }, [_vm._v("导出所有查询结果")])], 1), _vm._v(" "), _c('div', {
    staticClass: "search-box mt-20 hide"
  }, [_c('el-button', {
    staticClass: "search-hd",
    attrs: {
      "type": "primary",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        return _vm.searchKeyword(_vm.keyword)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "search-bd"
  }, [_c('search-bar', {
    attrs: {
      "ajaxSearch": false,
      "placeholder": "请输入应聘者姓名、职位名称、手机号、邮箱进行搜索"
    },
    on: {
      "enter-key": _vm.searchKeyword,
      "select": _vm.searchKeyword
    },
    model: {
      value: (_vm.keyword),
      callback: function($$v) {
        _vm.keyword = $$v
      },
      expression: "keyword"
    }
  })], 1)], 1), _vm._v(" "), _c('multi-search'), _vm._v(" "), _c('div', {}, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.partialLoading),
      expression: "partialLoading"
    }],
    staticClass: "filter-result"
  }, [_c('empty-tip', {
    attrs: {
      "show": !_vm.lists.length
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "table-list"
  }, [(_vm.lists.length) ? _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "border": "",
      "data": _vm.lists
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "姓名",
      "show-overflow-tooltip": true,
      "align": "center",
      "fixed": "",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "name-txt",
          on: {
            "click": function($event) {
              return _vm.toResumeDetail(scope.row)
            }
          }
        }, [_vm._v("\n                    " + _vm._s(scope.row.resumeForm.name) + "\n                  ")])]
      }
    }], null, false, 1871207498)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resumeForm.gender",
      "label": "性别",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s({
          1: '男',
          2: '女'
        }[scope.row.resumeForm.gender] || '-'))]
      }
    }], null, false, 3168019877)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "positionForm.name",
      "label": "岗位",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "positionForm.deptNames",
      "label": "招聘部门",
      "show-overflow-tooltip": true,
      "align": "center",
      "width": "95"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resumeForm.mobilePhone",
      "show-overflow-tooltip": true,
      "label": "手机号",
      "align": "center",
      "min-width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resumeForm.email",
      "show-overflow-tooltip": true,
      "label": "邮箱",
      "align": "center",
      "min-width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.resumeForm.email || '-'))]
      }
    }], null, false, 80548093)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resumeForm.resumeMaxEducation.major",
      "label": "最高学历",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.getSelectMapText('WB_EDU_DEGREE', scope.row.resumeForm.resumeMaxEducation.degree)) + "\n\t\t\t\t\t\t\t\t")]
      }
    }], null, false, 892024750)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resumeForm.resumeMaxEducation.school",
      "label": "最高学历学校",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resumeForm.resumeMaxEducation.major",
      "label": "专业",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "source",
      "show-overflow-tooltip": true,
      "label": "简历来源",
      "align": "center",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(scope.row.resumeForm && _vm.transToText('WB_RESUME_SOURCE',
          scope.row.resumeForm.resumeSource)) + "\n\t\t\t\t\t\t\t\t")]
      }
    }], null, false, 2757125052)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "positionForm.sourceFrom",
      "label": "招聘来源",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(scope.row.resumeForm && _vm.transToText('WB_SOURCE_FROM',
          scope.row.resumeForm.sourceFrom)) + "\n\t\t\t\t\t\t\t\t")]
      }
    }], null, false, 410720988)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "应聘城市",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm.getSelectMapText('WB_POSITION_CITY', scope.row.resumeForm.expectCityId)))]
      }
    }], null, false, 2191189520)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "positionForm.sourceFrom",
      "label": "投递渠道",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(scope.row.resumeForm && _vm.transToText('WB_ADD_SOURCE',
          scope.row.resumeForm.addSource)) + "\n\t\t\t\t\t\t\t\t")]
      }
    }], null, false, 3394074780)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "投递人",
      "prop": "resumeForm.addName",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "推荐人",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.resumeForm.recommenderUser) ? _c('span', [_vm._v(_vm._s(scope.row.resumeForm.recommenderUser.name))]) : _vm._e()]
      }
    }], null, false, 2383682320)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "positionForm.mark",
      "show-overflow-tooltip": true,
      "label": "招聘HR",
      "align": "center",
      "min-width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "简历附件",
      "align": "center",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('attach-view-in-list', {
          attrs: {
            "attachList": scope.row.resumeForm.resumeAttachList
          }
        })]
      }
    }], null, false, 2021903071)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "投递时间",
      "show-overflow-tooltip": true,
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm.dateFormat(scope.row.commitTime)))]
      }
    }], null, false, 3274253775)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "show-overflow-tooltip": true,
      "label": "状态",
      "align": "center",
      "min-width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.operateReason) ? _c('el-tooltip', {
          attrs: {
            "effect": "dark",
            "content": scope.row.operateReason,
            "placement": "top-start"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text",
            "icon": "el-icon-my-xinxi"
          }
        }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.getStatusText(scope.row)) + "\n\t\t\t\t\t\t\t\t\t\t")])], 1) : _c('span', [_vm._v(_vm._s(_vm.getStatusText(scope.row)))])]
      }
    }], null, false, 3642883953)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resumeForm.remark",
      "show-overflow-tooltip": true,
      "label": "备注",
      "align": "center",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('remark-edit', {
          attrs: {
            "id": scope.row.resumeForm.id
          },
          model: {
            value: (scope.row.resumeForm.remark),
            callback: function($$v) {
              _vm.$set(scope.row.resumeForm, "remark", $$v)
            },
            expression: "scope.row.resumeForm.remark"
          }
        })]
      }
    }], null, false, 1691095712)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "lastOperateUserInfo.remark",
      "show-overflow-tooltip": true,
      "label": "最近操作人",
      "align": "center",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticStyle: {
            "font-size": "12px"
          }
        }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(scope.row.lastOperateUserInfo ? scope.row.lastOperateUserInfo.name :
          '') + "\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(scope.row.lastOperateTime && scope.row.lastOperateTime.slice(5)))])])]
      }
    }], null, false, 1559643906)
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.lists.length) ? _c('el-pagination', {
    staticClass: "text-center mb-20 mt-20",
    attrs: {
      "current-page": _vm.pagination.pageIndex,
      "page-size": _vm.pagination.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.pagination.recordCounts
    },
    on: {
      "size-change": _vm.pageSizeChange,
      "current-change": _vm.pageIndexChange
    }
  }) : _vm._e()], 1)])], 1)]) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var views_index_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/views/index/index.vue
function injectStyle (ssrContext) {
  __webpack_require__(747)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  index_defaultExport,
  views_index_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(748);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("747aefb0", content, true);

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".index-count-bar{margin-top:0;padding:20px 0;display:flex}.index-count-bar:after,.index-count-bar:before{content:\" \";display:table}.index-count-bar:after{clear:both}.index-count-bar>div{margin-right:-1px;padding:0 5px;flex:1}.index-count-bar>div:not(:last-child){border-right:1px solid #e2e7eb}.index-count-bar>div[data-type=\"2\"]{flex:4}.index-count-bar .todo-icon{margin-left:5px;background:#50bfff;color:#fff;font-size:12px;padding:0 5px;border-radius:50px}.index-count-bar .count-item{text-align:center;color:#6f7b91}.index-count-bar .count-item>.el-row{margin-top:15px}.index-count-bar .count-item .index-summary-title{font-size:18px;font-weight:700}.index-count-bar .count-item [class^=el-icon-my-]{font-size:26px;vertical-align:middle}.index-count-bar .count-item .el-icon-my-mianshipinggu{font-size:19px}.index-count-bar .count-item .sub-title{color:#6f7b91}.index-count-bar .count-item .total-num{font-size:19px;color:#333}.index-count-bar .count-item .interview-text,.index-count-bar .count-item small{color:#6f7b91}.index-count-bar .interview-list-set{border-left:1px solid #e2e7eb}", ""]);

// exports


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(750);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("75725496", content, true);

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".empty-tips[data-v-e33ff2e2]{text-align:center;padding:120px 0}.empty-tips>.text[data-v-e33ff2e2]{margin-top:15px;font-size:20px;color:#555}.empty-tips-tiny[data-v-e33ff2e2]{padding:10px 0}.empty-tips-tiny>.text[data-v-e33ff2e2]{font-size:14px}", ""]);

// exports


/***/ }),
/* 751 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 752 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(754);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("a440bcba", content, true);

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".filter-panel .el-button{color:#555;font-size:14px}.filter-panel .el-button--danger{padding:4px 9px}.filter-panel .el-button--text{padding:5px 9px}.filter-panel .active{background:#96a1af;color:#fff}", ""]);

// exports


/***/ }),
/* 755 */,
/* 756 */,
/* 757 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 758 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 759 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(761);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("3476955e", content, true);

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".el-form--inline .el-form-item{margin-right:25px}.el-form--inline .el-date-editor.el-input,.el-form--inline .el-form-item__content,.el-form--inline .el-select{width:300px}.el-form--inline .el-select>.el-select__tags>span{line-height:30px;display:block;white-space:nowrap;overflow:auto}.el-form--inline .el-date-editor{width:300px}.el-form--inline .search-btn{padding:10px 40px}.el-form--inline .search-btn+.search-btn{margin-left:30px}.multi-search-form-item .el-form-item__label{white-space:nowrap}", ""]);

// exports


/***/ }),
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(769);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("24753ab0", content, true);

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".input-custom-component{position:relative}.input-custom-component>.clear-icon{display:none;position:absolute;right:5px;top:11px;color:#999}.input-custom-component.has-clear .clear-icon{display:block}.input-custom-component.has-clear .el-input__inner{padding-right:20px}", ""]);

// exports


/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/resumeDuplication/index.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_queryListExtend__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_views_common_multiSearch__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mixins_manualPopoverMixin__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__resume_resumeMixin__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__operation_attachViewInList_vue__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_tools__ = __webpack_require__(14);









/* harmony default export */ var resumeDuplication_defaultExport = ({
    extends: __WEBPACK_IMPORTED_MODULE_0_components_queryListExtend__["a" /* default */],
    mixins: [__WEBPACK_IMPORTED_MODULE_3__resume_resumeMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2_mixins_manualPopoverMixin__["a" /* default */]],
    components: { MultiSearch: __WEBPACK_IMPORTED_MODULE_1_views_common_multiSearch__["a" /* default */], manualPopoverMixin: __WEBPACK_IMPORTED_MODULE_2_mixins_manualPopoverMixin__["a" /* default */], AttachViewInList: __WEBPACK_IMPORTED_MODULE_4__operation_attachViewInList_vue__["a" /* default */] },
    data: function data() {
        return {
            fetchUrl: '/resume/repeat/list.api',
            multiFields: [{
                filter: '',
                label: '姓名',
                mode: 'input',
                name: 'nameSearch'
            }, {
                filter: '',
                label: '手机号',
                mode: 'input',
                name: 'mobilePhoneSearch'
            }, {
                filter: '',
                label: '邮箱',
                mode: 'input',
                name: 'emailSearch'
            }]
        };
    },

    computed: {
        isSchool: function isSchool() {
            return this.$store.state.user.property === '0';
        }
    },
    methods: {
        dateFormat: function dateFormat(date) {
            var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'yyyy/MM/dd';

            return Object(__WEBPACK_IMPORTED_MODULE_5_modules_tools__["a" /* dateFormat */])(date, format);
        },
        resetSearchDateBeforeFetch: function resetSearchDateBeforeFetch() {
            var _searchData = this.searchData,
                _searchData$nameSearc = _searchData.nameSearch,
                nameSearch = _searchData$nameSearc === undefined ? '' : _searchData$nameSearc,
                _searchData$mobilePho = _searchData.mobilePhoneSearch,
                mobilePhoneSearch = _searchData$mobilePho === undefined ? '' : _searchData$mobilePho,
                _searchData$emailSear = _searchData.emailSearch,
                emailSearch = _searchData$emailSear === undefined ? '' : _searchData$emailSear;

            if (!nameSearch.trim() && !mobilePhoneSearch.trim() && !emailSearch.trim()) {
                this.firstRendered = true;
                this.partialLoading = false;
                this.lists = [];
                return false;
            } else {
                return true;
            }
        },
        getPositionTipText: function getPositionTipText(row) {
            var oldPositionName = row.oldPositionName,
                newPositionName = row.newPositionName,
                isJobTransfer = row.isJobTransfer;


            if (isJobTransfer == 1 && newPositionName) {
                return '\u5DF2\u8F6C\u5C97\u5230' + newPositionName + '\u804C\u4F4D';
            } else {
                return '\u8F6C\u5C97\u524D\uFF1A' + oldPositionName + '\u804C\u4F4D';
            }
        },
        getStatusText: function getStatusText(row) {
            if (row.isJobTransfer == 1) {
                return '已转岗';
            }

            return this.getSelectMapText('WB_FLOW_STATUS', row.status);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03f5d98e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/resumeDuplication/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "filter-condition box-shadow-small border-radius"
  }, [_c('multi-search', {
    attrs: {
      "fields": _vm.multiFields,
      "mode": "cover"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "filter-result background-white box-shadow-small border-radius"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.partialLoading),
      expression: "partialLoading"
    }]
  }, [_c('empty-tip', {
    attrs: {
      "show": !_vm.lists.length
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "table-list mt-20"
  }, [(_vm.lists.length) ? _c('el-table', {
    attrs: {
      "data": _vm.lists
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "姓名",
      "show-overflow-tooltip": "",
      "align": "center",
      "fixed": "",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.resumeForm.name))]
      }
    }], null, false, 2733853115)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "岗位",
      "class-name": "no-wrap",
      "align": "center",
      "fixed": "",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.oldPositionName || scope.row.newPositionName) ? _c('el-tooltip', {
          attrs: {
            "effect": "dark",
            "content": _vm.getPositionTipText(scope.row),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text",
            "icon": "el-icon-my-xinxi"
          }
        })], 1) : _vm._e(), _vm._v(" "), _c('span', {
          attrs: {
            "title": scope.row.positionForm.name
          }
        }, [_vm._v(_vm._s(scope.row.positionForm.name))])]
      }
    }], null, false, 455889647)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "proName",
      "label": "所属项目",
      "show-overflow-tooltip": "",
      "align": "center",
      "fixed": "",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resumeForm.gender",
      "label": "性别",
      "show-overflow-tooltip": "",
      "align": "center",
      "min-width": "70"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s({
          1: '男',
          2: '女'
        }[scope.row.resumeForm.gender] || '-'))]
      }
    }], null, false, 3168019877)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resumeForm.mobilePhone",
      "label": "手机",
      "show-overflow-tooltip": "",
      "align": "center",
      "min-width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resumeForm.email",
      "label": "邮箱",
      "show-overflow-tooltip": "",
      "align": "center",
      "min-width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "最高学历",
      "align": "center",
      "show-overflow-tooltip": "",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(_vm.getSelectMapText('WB_EDU_DEGREE', scope.row.resumeForm.resumeMaxEducation.degree)) + "\n              ")]
      }
    }], null, false, 2196099462)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "最高学历学校",
      "align": "center",
      "show-overflow-tooltip": "",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.resumeForm.schoolType === '1') ? _c('el-tag', {
          attrs: {
            "type": "primary"
          }
        }, [_vm._v("985")]) : (scope.row.resumeForm.schoolType === '2') ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("211")]) : _vm._e(), _vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(scope.row.resumeForm.resumeMaxEducation.school) + "\n\t\t\t\t\t\t\t")]
      }
    }], null, false, 904880564)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resumeForm.resumeMaxEducation.major",
      "label": "专业",
      "show-overflow-tooltip": "",
      "align": "center",
      "min-width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "positionForm.mark",
      "label": "招聘HR",
      "show-overflow-tooltip": "",
      "align": "center",
      "min-width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "应聘城市",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm.getSelectMapText('WB_POSITION_CITY', scope.row.resumeForm.expectCityId)))]
      }
    }], null, false, 2191189520)
  }), _vm._v(" "), (!_vm.isSchool) ? _c('el-table-column', {
    attrs: {
      "label": "游戏经验",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.resumeForm.gameExperience))]
      }
    }], null, false, 4049949644)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "简历附件",
      "align": "center",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('attach-view-in-list', {
          attrs: {
            "attachList": scope.row.resumeForm.resumeAttachList
          }
        })]
      }
    }], null, false, 2021903071)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "投递时间",
      "show-overflow-tooltip": "",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm.dateFormat(scope.row.commitTime)))]
      }
    }], null, false, 3274253775)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "align": "center",
      "min-width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.operateReason) ? _c('el-tooltip', {
          attrs: {
            "effect": "dark",
            "content": scope.row.operateReason,
            "placement": "top-start"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text",
            "icon": "el-icon-my-xinxi"
          }
        }, [_vm._v(_vm._s(_vm.getStatusText(scope.row)))])], 1) : _c('span', [_vm._v(_vm._s(_vm.getStatusText(scope.row)))])]
      }
    }], null, false, 613067865)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resumeForm.remark",
      "show-overflow-tooltip": "",
      "label": "备注",
      "align": "center",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resumeForm.remark",
      "show-overflow-tooltip": "",
      "label": "最近操作人",
      "align": "center",
      "min-width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticStyle: {
            "font-size": "12px"
          }
        }, [_c('p', [_vm._v(_vm._s(scope.row.lastOperateUserInfo ? scope.row.lastOperateUserInfo.name : ''))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(scope.row.lastOperateTime && scope.row.lastOperateTime.slice(5)))])])]
      }
    }], null, false, 4062077065)
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.lists.length) ? _c('el-pagination', {
    staticClass: "text-center mb-20 mt-10",
    attrs: {
      "current-page": _vm.pagination.pageIndex,
      "page-size": _vm.pagination.pageSize,
      "page-sizes": [20, 50, 100, 200],
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.pagination.recordCounts
    },
    on: {
      "size-change": _vm.pageSizeChange,
      "current-change": _vm.pageIndexChange
    }
  }) : _vm._e()], 1)])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var views_resumeDuplication_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/views/resumeDuplication/index.vue
function injectStyle (ssrContext) {
  __webpack_require__(771)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-03f5d98e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  resumeDuplication_defaultExport,
  views_resumeDuplication_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(772);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("18e1e3f6", content, true);

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".page[data-v-03f5d98e] .el-table__body-wrapper{overflow-x:scroll}", ""]);

// exports


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(774);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("e66ccb64", content, true);

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(776);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("5209cd67", content, true);

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(778);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("8b7d72c8", content, true);

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".upload-silence-mode .el-upload-list{display:none!important}", ""]);

// exports


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(780);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("439af75a", content, true);

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".recommend-resume-dialog .content-confirm{background-color:#2481ff;color:#fff;margin:0 20px 20px}.recommend-resume-dialog .content-confirm>h1{font-size:18px;padding:15px}.recommend-resume-dialog .content-confirm>.el-row{background-color:#59a0ff;padding:15px;border-radius:0 0 5px 5px}.recommend-resume-dialog .recommend-wrap{border:1px solid #dcdfe6;margin:0 20px;padding:1px 0;box-shadow:0 2px 4px 0 #0000001f}.recommend-resume-dialog .recommend-tabs{border:0;box-shadow:none}.recommend-resume-dialog .recommend-tabs .el-tabs__content{display:none}.recommend-resume-dialog .el-form{margin:0 20px;padding:15px 0 0}", ""]);

// exports


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(782);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("356d4eb6", content, true);

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".recommend-select-option{display:flex;justify-content:space-between}.recommend-select-text{max-width:400px;overflow:hidden;text-overflow:ellipsis}", ""]);

// exports


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(784);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("ac7bd516", content, true);

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".user-selects-wpr{position:relative}.user-selects-wpr .remove-btn{position:absolute;right:10px;top:13px;z-index:1;font-size:12px;color:#ddd;cursor:pointer}.user-selects-wpr .remove-btn:hover{color:#20a0ff}.user-selects{width:100%}.user-selects-list .user-name{float:left}.user-selects-list .user-dept{margin:1px 25px 0 10px;float:right;font-size:12px;color:#bbb}", ""]);

// exports


/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/resume/resumeList.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_queryListExtend__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_fileUpload__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resumeMixin__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__operation_remarkEditDialog_vue__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__operation_multiRemarkEditDialog_vue__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__operation_attachViewInList_vue__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_tools__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mixins_manualPopoverMixin__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_views_operation_changePositionDialog__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_views_common_multiSearch__ = __webpack_require__(88);













/* harmony default export */ var resumeList_defaultExport = ({
    'extends': __WEBPACK_IMPORTED_MODULE_0_components_queryListExtend__["a" /* default */],
    'mixins': [__WEBPACK_IMPORTED_MODULE_2__resumeMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7_mixins_manualPopoverMixin__["a" /* default */]],
    components: {
        FileUpload: __WEBPACK_IMPORTED_MODULE_1_components_fileUpload__["a" /* default */], AttachViewInList: __WEBPACK_IMPORTED_MODULE_5__operation_attachViewInList_vue__["a" /* default */], ChangePositionDialog: __WEBPACK_IMPORTED_MODULE_8_views_operation_changePositionDialog__["a" /* default */], RemarkEdit: __WEBPACK_IMPORTED_MODULE_3__operation_remarkEditDialog_vue__["a" /* default */], MultiRemarkEditDialog: __WEBPACK_IMPORTED_MODULE_4__operation_multiRemarkEditDialog_vue__["a" /* default */], MultiSearch: __WEBPACK_IMPORTED_MODULE_9_views_common_multiSearch__["a" /* default */]
    },
    data: function data() {
        return {
            popper: {
                onCreate: function onCreate() {
                    console.log('crarrrr');
                }
            },
            fetchUrl: '/resume/list.api',
            multiFields: [{
                filter: 'WB_RESUME_STATUS_0',
                label: '简历状态',
                mode: 'select',
                name: 'statusSearch'
            }]
        };
    },

    computed: {
        downloadTemplateUrl: function downloadTemplateUrl() {
            return this.$axios.defaults.baseURL + '/resume/downloadTemplate.api?token=' + this.$store.state.app.token + '&property=' + this.$store.state.user.property;
        },
        isSchool: function isSchool() {
            return this.$store.state.user.property === '0';
        },
        hasWritten: function hasWritten() {
            var _$store$state = this.$store.state,
                _$store$state$needIds = _$store$state.needIds;
            _$store$state$needIds = _$store$state$needIds === undefined ? {} : _$store$state$needIds;
            var needEntryWritePrject = _$store$state$needIds.needEntryWritePrject,
                _$store$state$user = _$store$state.user;
            _$store$state$user = _$store$state$user === undefined ? {} : _$store$state$user;
            var projectId = _$store$state$user.projectId;

            return needEntryWritePrject.includes(projectId.toString());
        }
    },
    methods: {
        multiRemarkEdit: function multiRemarkEdit(ids) {
            if (this.checkDataValid(ids)) {
                var $target = this.$refs.multiRemarkEditDialog;
                var rids = this.lists.filter(function (cv) {
                    return ids.indexOf(cv.id) > -1;
                }).map(function (cv) {
                    return cv.resumeForm.id;
                }).join(',');
                $target && $target.show(rids);
            }
        },

        pageIndexChange: function pageIndexChange(val) {
            this.searchData.pageIndex = val;
            console.log();
        },
        dateFormat: function dateFormat(date) {
            var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'yyyy/MM/dd';

            return Object(__WEBPACK_IMPORTED_MODULE_6_modules_tools__["a" /* dateFormat */])(date, format);
        },
        addResume: function addResume() {
            this.$refs.addResumeDialog.show();
        },
        recommendResume: function recommendResume(item) {
            if (Array.isArray(item)) {
                if (this.checkDataValid(item)) {
                    if (item.length > 1) {
                        this.$refs.recommendResumeDialog.show(item, false);
                    } else {
                        this.$refs.recommendResumeDialog.show(item[0]);
                    }
                }
            } else {
                this.$refs.recommendResumeDialog.show(item);
            }
        },
        uploadSuccess: function uploadSuccess(res, file) {
            this.fetchData();
            var h = this.$createElement;
            var nodeContent = res.result.list.map(function (item) {
                return h('p', null, item);
            });
            this.$notify({
                title: '导入结果提示：',
                message: h('div', null, nodeContent),
                type: res.result.isAllSuccess ? 'success' : 'error'
            });
        },
        toResumeDetail: function toResumeDetail(row) {
            var path = this.getResumeDetailUrl(row.id, row.status);

            var routeData = this.$router.resolve({ path: path });
            window.open(routeData.href, '_blank');
        },
        getPositionTipText: function getPositionTipText(row) {
            var oldPositionName = row.oldPositionName,
                newPositionName = row.newPositionName,
                isJobTransfer = row.isJobTransfer;


            if (isJobTransfer == 1 && newPositionName) {
                return '\u5DF2\u8F6C\u5C97\u5230' + newPositionName + '\u804C\u4F4D';
            } else {
                return '\u8F6C\u5C97\u524D\uFF1A' + oldPositionName + '\u804C\u4F4D';
            }
        },
        getStatusText: function getStatusText(row) {
            if (row.isJobTransfer == 1) {
                return '已转岗';
            }

            return this.getSelectMapText('WB_FLOW_STATUS', row.status);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-667dd617"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/resume/resumeList.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.firstRendered) ? _c('div', [_c('div', {
    staticClass: "filter-condition box-shadow-small border-radius"
  }, [_c('multi-search', {
    attrs: {
      "fields": _vm.multiFields
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "filter-result background-white box-shadow-small border-radius"
  }, [_c('div', {
    staticClass: "filter-result-header mt-15 clearfix"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    attrs: {
      "icon": "el-icon-plus",
      "type": "primary"
    },
    on: {
      "click": _vm.addResume
    }
  }, [_vm._v("新建简历")]), _vm._v(" "), _c('el-dropdown', [_c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("批量操作"), _c('i', {
    staticClass: "el-icon-caret-bottom el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.recommendResume(_vm.multipleSelection)
      }
    }
  }, [_vm._v("批量推荐")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.multiChangePosition(_vm.idStr)
      }
    }
  }, [_vm._v("批量修改职位")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.multiRemarkEdit(_vm.idStr)
      }
    }
  }, [_vm._v("批量修改备注")])], 1)], 1), _vm._v(" "), _c('el-dropdown', [_c('el-button', {
    attrs: {
      "icon": "el-icon-my-daochu",
      "type": "info"
    }
  }, [_vm._v("导出简历"), _c('i', {
    staticClass: "el-icon-caret-bottom el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.exportFiles(_vm.idStr)
      }
    }
  }, [_vm._v("导出已选记录(excel)")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.exportFiles(_vm.idStr, undefined, undefined, 'type=HTML')
      }
    }
  }, [_vm._v("导出已选记录(html)")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.exportParamsFiles('/resume/exportAllResume.api')
      }
    }
  }, [_vm._v("\n                                导出所有查询结果(excel)\n                            ")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.exportParamsFiles('/resume/exportAllResume.api', 'HTML')
      }
    }
  }, [_vm._v("\n                                导出所有查询结果(html)\n                            ")])], 1)], 1), _vm._v(" "), _c('export-custom-dialog', {
    attrs: {
      "valid-call-back": _vm.customExportValid,
      "params-call-back": _vm.customExportParams
    }
  }), _vm._v(" "), _c('file-upload', {
    staticClass: "ml-5 mr-5",
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "upload-mode": "silence",
      "action": ((_vm.$axios.defaults.baseURL) + "/resume/importResume.api"),
      "accept": ".rar,.zip",
      "on-success": _vm.uploadSuccess,
      "fileLimit": 0,
      "showLoading": true
    }
  }, [_c('el-button', {
    attrs: {
      "plain": true,
      "icon": "el-icon-upload2",
      "type": "primary"
    }
  }, [_vm._v("导入简历")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  })], 1), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.downloadTemplateUrl
    }
  }, [_c('el-button', {
    attrs: {
      "icon": "el-icon-my-daochu",
      "plain": true,
      "type": "text"
    }
  }, [_vm._v("下载导入模版")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [(_vm.lists.length) ? _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "end"
    }
  }, [(_vm.hasWritten) ? _c('el-button', {
    attrs: {
      "icon": "el-icon-my-queding color-success",
      "type": "success",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.idStr, 'forceToWrite')
      }
    }
  }, [_vm._v("进入笔试\n                        ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-queding color-success",
      "type": "success",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.idStr, 'pass')
      }
    }
  }, [_vm._v("通过\n                        ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-daiding color-warning",
      "type": "warning",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.idStr, 'undetermined')
      }
    }
  }, [_vm._v("待定\n                        ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-guanbi color-danger",
      "type": "danger",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.idStr, 'notPass')
      }
    }
  }, [_vm._v("淘汰\n                        ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-lahei color-purple",
      "type": "purple",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.idStr, 'lh')
      }
    }
  }, [_vm._v("拉黑\n                        ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-huitui color-info",
      "type": "info",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.idStr, 'back')
      }
    }
  }, [_vm._v("回退\n                        ")])], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.partialLoading),
      expression: "partialLoading"
    }]
  }, [_c('empty-tip', {
    attrs: {
      "show": !_vm.lists.length
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "table-list mt-20"
  }, [(_vm.lists.length) ? _c('el-table', {
    attrs: {
      "border": "",
      "data": _vm.lists
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "姓名",
      "show-overflow-tooltip": true,
      "align": "center",
      "fixed": "",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "name-txt",
          on: {
            "click": function($event) {
              return _vm.toResumeDetail(scope.row)
            }
          }
        }, [_vm._v("\n                                " + _vm._s(scope.row.resumeForm.name) + "\n                            ")])]
      }
    }], null, false, 1635889994)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resumeForm.gender",
      "label": "性别",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "70"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s({
          1: '男',
          2: '女'
        }[scope.row.resumeForm.gender] || '-'))]
      }
    }], null, false, 3168019877)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "岗位",
      "class-name": "no-wrap",
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.oldPositionName || scope.row.newPositionName) ? _c('el-tooltip', {
          attrs: {
            "effect": "dark",
            "content": _vm.getPositionTipText(scope.row),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text",
            "icon": "el-icon-my-xinxi"
          }
        })], 1) : _vm._e(), _vm._v(" "), _c('span', {
          attrs: {
            "title": scope.row.positionForm.name
          }
        }, [_vm._v(_vm._s(scope.row.positionForm.name))])]
      }
    }], null, false, 455889647)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "招聘部门",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.positionForm.deptNames) + "\n                        ")]
      }
    }], null, false, 2934477005)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resumeForm.mobilePhone",
      "label": "手机号",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resumeForm.email",
      "label": "邮箱",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "最高学历",
      "align": "center",
      "show-overflow-tooltip": true,
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.getSelectMapText('WB_EDU_DEGREE', scope.row.resumeForm.resumeMaxEducation.degree)) + "\n                        ")]
      }
    }], null, false, 433538694)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "最高学历学校",
      "align": "center",
      "show-overflow-tooltip": true,
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.resumeForm.schoolType === '1') ? _c('el-tag', {
          attrs: {
            "type": "primary"
          }
        }, [_vm._v("985")]) : (scope.row.resumeForm.schoolType === '2') ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("211")]) : _vm._e(), _vm._v("\n                            " + _vm._s(scope.row.resumeForm.resumeMaxEducation.school) + "\n                        ")]
      }
    }], null, false, 2122314332)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resumeForm.resumeMaxEducation.major",
      "label": "专业",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "简历来源",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.getSelectMapText('WB_RESUME_SOURCE', scope.row.resumeForm.resumeSource)) + "\n                        ")]
      }
    }], null, false, 3166876443)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "招聘来源",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.getSelectMapText('WB_SOURCE_FROM', scope.row.resumeForm.sourceFrom)) + "\n                        ")]
      }
    }], null, false, 1760054299)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "应聘城市",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.getSelectMapText('WB_POSITION_CITY', scope.row.resumeForm.expectCityId)) + "\n                        ")]
      }
    }], null, false, 2621839696)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "positionForm.sourceFrom",
      "label": "投递渠道",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.resumeForm && _vm.getSelectMapText('WB_ADD_SOURCE',
          scope.row.resumeForm.addSource)) + "\n                        ")]
      }
    }], null, false, 3698601694)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "投递人",
      "prop": "resumeForm.addName",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "推荐人",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.resumeForm.recommenderUser) ? _c('span', [_vm._v(_vm._s(scope.row.resumeForm.recommenderUser.name))]) : _vm._e()]
      }
    }], null, false, 2383682320)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "招聘HR",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.positionForm.mark) + "\n                        ")]
      }
    }], null, false, 1790940105)
  }), _vm._v(" "), (!_vm.isSchool) ? _c('el-table-column', {
    attrs: {
      "label": "游戏经验",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.resumeForm.gameExperience) + "\n                        ")]
      }
    }], null, false, 3038609676)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "简历附件",
      "align": "center",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('attach-view-in-list', {
          attrs: {
            "attachList": scope.row.resumeForm.resumeAttachList
          }
        })]
      }
    }], null, false, 2021903071)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "投递时间",
      "show-overflow-tooltip": true,
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm.dateFormat(scope.row.commitTime)))]
      }
    }], null, false, 3274253775)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "align": "center",
      "min-width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-popover', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.evaluator),
            expression: "scope.row.evaluator"
          }],
          attrs: {
            "placement": "top",
            "popper-class": "dark-theme popper-line text-center tooltip-status-popover",
            "value": scope.row.isPopoverShow,
            "popper-options": _vm.popper,
            "trigger": "manual"
          },
          nativeOn: {
            "mouseenter": function($event) {
              return _vm.beforeShowPopover(scope.row, '/resume/getResumeEvaList.api', 'resumePositionId')
            },
            "mouseleave": function($event) {
              return _vm.hidePopover(scope.row)
            }
          }
        }, [_c('div', {
          staticStyle: {
            "width": "550px",
            "max-height": "483px",
            "overflow": "hidden"
          }
        }, [(_vm.popoverResult.list.length) ? _c('span', [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 4
          }
        }, [_vm._v("评估人")]), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 10
          }
        }, [_vm._v("内容")]), _vm._v(" "), _c('el-col', {
          staticStyle: {
            "padding-left": "10px"
          },
          attrs: {
            "span": 3
          }
        }, [_vm._v("状态")]), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 7
          }
        }, [_vm._v("时间")])], 1), _vm._v(" "), _vm._l((_vm.popoverResult.list), function(item, index) {
          return _c('el-row', {
            key: index
          }, [_c('el-col', {
            attrs: {
              "span": 4
            }
          }, [_vm._v(_vm._s(item.evaluationUser.name))]), _vm._v(" "), _c('el-col', {
            staticStyle: {
              "display": "-webkit-box",
              "-webkit-line-clamp": "6",
              "-webkit-box-orient": "vertical",
              "overflow": "hidden"
            },
            attrs: {
              "span": 10
            }
          }, [_vm._v(_vm._s(item.content || '-'))]), _vm._v(" "), _c('el-col', {
            staticStyle: {
              "padding-left": "10px"
            },
            attrs: {
              "span": 3
            }
          }, [_vm._v(_vm._s(_vm.getSelectMapText('WB_USER_VIEWPOINT', item.userViewpoint)))]), _vm._v(" "), _c('el-col', {
            attrs: {
              "span": 7
            }
          }, [_vm._v(_vm._s(item.evaluateTime || '-'))])], 1)
        })], 2) : _c('el-row', [_vm._v("暂无数据")])], 1), _vm._v(" "), _c('span', {
          directives: [{
            name: "loading",
            rawName: "v-loading",
            value: (scope.row.loading),
            expression: "scope.row.loading"
          }],
          staticClass: "status-loading",
          staticStyle: {
            "cursor": "default"
          },
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [_c('i', {
          staticClass: "el-icon-my-xinxi"
        })])]), _vm._v(" "), (scope.row.operateReason) ? _c('el-tooltip', {
          attrs: {
            "effect": "dark",
            "content": scope.row.operateReason,
            "placement": "top-start"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text",
            "icon": "el-icon-my-xinxi"
          }
        }, [_vm._v("\n                                    " + _vm._s(_vm.getStatusText(scope.row)) + "\n                                ")])], 1) : _c('span', [_vm._v(_vm._s(_vm.getStatusText(scope.row)))])]
      }
    }], null, false, 2434282966)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "class-name": "no-wrap",
      "min-width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-dropdown', {
          attrs: {
            "hide-on-click": false
          },
          on: {
            "command": _vm.handleCommand
          }
        }, [_c('span', {
          staticClass: "el-dropdown-link"
        }, [_vm._v("简历评估")]), _vm._v(" "), _c('el-dropdown-menu', {
          attrs: {
            "slot": "dropdown"
          },
          slot: "dropdown"
        }, [_c('el-dropdown-item', {
          attrs: {
            "command": ((scope.row.id) + "/pass")
          }
        }, [_c('i', {
          staticClass: "el-icon-my-queding color-success mr-10"
        }), _vm._v("通过\n                                    ")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": ((scope.row.id) + "/undetermined")
          }
        }, [_c('i', {
          staticClass: "el-icon-my-daiding color-warning mr-10"
        }), _vm._v("待定\n                                    ")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": ((scope.row.id) + "/notPass")
          }
        }, [_c('i', {
          staticClass: "el-icon-my-guanbi color-danger mr-10"
        }), _vm._v("淘汰\n                                    ")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": ((scope.row.id) + "/lh")
          }
        }, [_c('i', {
          staticClass: "el-icon-my-lahei color-purple mr-10"
        }), _vm._v("拉黑\n                                    ")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": ((scope.row.id) + "/back")
          }
        }, [_c('i', {
          staticClass: "el-icon-my-huitui color-info mr-10"
        }), _vm._v("回退\n                                    ")])], 1)], 1), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.recommendResume(scope.row)
            }
          }
        }, [_vm._v("推荐")])]
      }
    }], null, false, 2235286389)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resumeForm.remark",
      "show-overflow-tooltip": true,
      "label": "备注",
      "align": "center",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('remark-edit', {
          attrs: {
            "id": scope.row.resumeForm.id
          },
          model: {
            value: (scope.row.resumeForm.remark),
            callback: function($$v) {
              _vm.$set(scope.row.resumeForm, "remark", $$v)
            },
            expression: "scope.row.resumeForm.remark"
          }
        })]
      }
    }], null, false, 1691095712)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resumeForm.remark",
      "show-overflow-tooltip": true,
      "label": "最近操作人",
      "align": "center",
      "min-width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticStyle: {
            "font-size": "12px"
          }
        }, [_c('p', [_vm._v(_vm._s(scope.row.lastOperateUserInfo ? scope.row.lastOperateUserInfo.name : ''))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(scope.row.lastOperateTime && scope.row.lastOperateTime.slice(5)))])])]
      }
    }], null, false, 4062077065)
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.lists.length) ? _c('el-pagination', {
    staticClass: "text-center mb-20 mt-10",
    attrs: {
      "current-page": _vm.pagination.pageIndex,
      "page-size": _vm.pagination.pageSize,
      "page-sizes": [20, 50, 100, 200],
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.pagination.recordCounts
    },
    on: {
      "size-change": _vm.pageSizeChange,
      "current-change": _vm.pageIndexChange
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('Add-Resume-Dialog', {
    ref: "addResumeDialog",
    on: {
      "reload": _vm.fetchData
    }
  }), _vm._v(" "), _c('recommend-Resume-Dialog', {
    ref: "recommendResumeDialog",
    on: {
      "reload": _vm.fetchData
    }
  }), _vm._v(" "), _c('change-position-dialog', {
    ref: "changePositionDialog",
    on: {
      "reload": _vm.fetchData
    }
  }), _vm._v(" "), _c('multi-remark-edit-dialog', {
    ref: "multiRemarkEditDialog",
    on: {
      "reload": _vm.fetchData
    }
  })], 1) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var resume_resumeList_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/views/resume/resumeList.vue
function injectStyle (ssrContext) {
  __webpack_require__(786)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  resumeList_defaultExport,
  resume_resumeList_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(787);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("3fbbe4a1", content, true);

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".el-table__fixed{overflow:hidden}.status-loading .el-loading-spinner{margin-top:-10px}.status-loading .el-loading-spinner .circular{width:20px;height:20px}", ""]);

// exports


/***/ }),
/* 788 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(790);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("12713089", content, true);

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".el-dialog__wrapper[data-v-3fb5a24d] .el-dialog__header{text-align:center}", ""]);

// exports


/***/ }),
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/resumeDetail/items/personal.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_tools__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_rules__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_userSelect_searchDownList__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mixins_formCommonMixin__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mixins_selectMapMixin__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_views_operation_fetchPositionListMixin__ = __webpack_require__(90);











var formFields = {
    id: '',
    name: '',
    mobilePhone: '',
    gender: '',
    email: '',
    remark: '',
    acceptRegulate: '',
    sourceFrom: '',
    resumeSource: '',
    workYears: '',
    birthday: '',
    origin: '',
    expectSalary: '',
    papersType: '',
    papersNumber: '',
    recommender: '',
    relationship: '',
    recommenderUser: null,
    residence: '',
    expectCityId: '',
    gameExperience: '',
    contactResult: '' };

/* harmony default export */ var personal_defaultExport = ({
    props: {
        init: {
            type: Object,
            required: true
        }
    },
    data: function data() {
        return {
            urls: {
                personUpdate: '/resume/update.api',
                personUpdateCheck: '/resume/checkEdit.api'
            },
            ruleForm: formFields,
            resetData: {},
            rules: __WEBPACK_IMPORTED_MODULE_3_modules_rules__["a" /* default */],
            isEdit: true
        };
    },

    mixins: [__WEBPACK_IMPORTED_MODULE_5_mixins_formCommonMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6_mixins_selectMapMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7_views_operation_fetchPositionListMixin__["a" /* default */]],
    computed: {
        recommenderText: function recommenderText() {
            return this.ruleForm.recommenderUser && this.ruleForm.recommenderUser.name || '';
        },
        postData: function postData() {
            var temp = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.ruleForm, { birthday: Object(__WEBPACK_IMPORTED_MODULE_2_modules_tools__["a" /* dateFormat */])(this.ruleForm.birthday) });
            delete temp.recommenderUser;
            return temp;
        },
        genderText: function genderText() {
            var baseMap = {
                1: '男',
                2: '女'
            };
            return baseMap[this.ruleForm.gender];
        },
        birthdayText: function birthdayText() {
            return Object(__WEBPACK_IMPORTED_MODULE_2_modules_tools__["a" /* dateFormat */])(this.ruleForm.birthday);
        }
    },
    watch: {
        init: 'extendRuleForm'
    },
    methods: {
        extendRuleForm: function extendRuleForm() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(formFields).forEach(function (item, index) {
                var val = typeof _this.init[item] === 'number' ? _this.init[item] + '' : _this.init[item] || '';
                _this.ruleForm[item] = val;
                _this.resetData[item] = val;
            });
        },
        updateCheck: function updateCheck() {
            var _this2 = this;

            axios.post(this.urls.personUpdateCheck, this.postData).then(function (res) {
                _this2.updateData();
            });
        },
        updateData: function updateData() {
            var _this3 = this;

            axios.post(this.urls.personUpdate, this.postData, { 'X-showMessage': true }).then(function (res) {
                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(formFields).forEach(function (item, index) {
                    _this3.ruleForm[item] = res.result.bean[item];
                    _this3.resetData[item] = res.result.bean[item];
                });
                _this3.editData();
            });
        },
        editData: function editData() {
            this.isEdit = !this.isEdit;
        },
        cancelEdit: function cancelEdit() {
            this.resetForm('ruleForm');
            this.resetDataFn();
            this.editData();
        },
        resetDataFn: function resetDataFn() {
            var _this4 = this;

            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(formFields).forEach(function (item, index) {
                _this4.ruleForm[item] = _this4.resetData[item];
            });
        },
        saveData: function saveData(formName, callback) {
            var _this5 = this;

            this.$refs[formName].validate(function (valid) {
                if (valid) {
                    callback(_this5.postData);
                } else {
                    console.log('not valid');
                    return false;
                }
            });
        }
    },
    created: function created() {
        this.fetchPositionList();
    },

    components: {
        UserSearch: __WEBPACK_IMPORTED_MODULE_4_components_userSelect_searchDownList__["a" /* default */]
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-243d9f8a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/resumeDetail/items/personal.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "ruleForm",
    class: [{
      'form-view': !_vm.isEdit
    }, 'form-switch', 'form-col', 'form-personal'],
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('div', {
    staticClass: "col-2 clearfix"
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名:",
      "prop": "name"
    }
  }, [_c('p', {
    staticClass: "f-view",
    domProps: {
      "textContent": _vm._s(_vm.ruleForm.name)
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "f-edit",
    attrs: {
      "maxlength": 20
    },
    model: {
      value: (_vm.ruleForm.name),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "性别:",
      "prop": "gender"
    }
  }, [_c('p', {
    staticClass: "f-view",
    domProps: {
      "textContent": _vm._s(_vm.genderText)
    }
  }), _vm._v(" "), _c('el-radio-group', {
    staticClass: "f-edit",
    model: {
      value: (_vm.ruleForm.gender),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "gender", $$v)
      },
      expression: "ruleForm.gender"
    }
  }, _vm._l((_vm.selectMap.WB_GENDER), function(item, index) {
    return _c('el-radio', {
      key: item.value,
      attrs: {
        "label": item.value
      }
    }, [_vm._v("\n                    " + _vm._s(item.text) + "\n                ")])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号:",
      "prop": "mobilePhone"
    }
  }, [_c('p', {
    staticClass: "f-view",
    domProps: {
      "textContent": _vm._s(_vm.ruleForm.mobilePhone)
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "f-edit",
    attrs: {
      "maxlength": 20
    },
    model: {
      value: (_vm.ruleForm.mobilePhone),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "mobilePhone", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.mobilePhone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "邮箱:",
      "prop": "email"
    }
  }, [_c('p', {
    staticClass: "f-view",
    domProps: {
      "textContent": _vm._s(_vm.ruleForm.email)
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "f-edit",
    attrs: {
      "maxlength": 50
    },
    model: {
      value: (_vm.ruleForm.email),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "email", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "简历来源:",
      "prop": "resumeSource"
    }
  }, [_c('p', {
    staticClass: "f-view",
    domProps: {
      "textContent": _vm._s(_vm.getSelectMapText('WB_RESUME_SOURCE', _vm.ruleForm.resumeSource))
    }
  }), _vm._v(" "), _c('el-select', {
    staticClass: "f-edit",
    attrs: {
      "placeholder": "请选择简历来源"
    },
    model: {
      value: (_vm.ruleForm.resumeSource),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "resumeSource", $$v)
      },
      expression: "ruleForm.resumeSource"
    }
  }, _vm._l((_vm.selectMap.WB_RESUME_SOURCE), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "招聘信息来源:"
    }
  }, [_c('p', {
    staticClass: "f-view",
    domProps: {
      "textContent": _vm._s(_vm.getSelectMapText('WB_SOURCE_FROM', _vm.ruleForm.sourceFrom))
    }
  }), _vm._v(" "), _c('el-select', {
    staticClass: "f-edit",
    attrs: {
      "placeholder": "请选择招聘信息来源"
    },
    model: {
      value: (_vm.ruleForm.sourceFrom),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "sourceFrom", $$v)
      },
      expression: "ruleForm.sourceFrom"
    }
  }, _vm._l((_vm.selectMap.WB_SOURCE_FROM), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "当前所在地:",
      "prop": "residence"
    }
  }, [_c('p', {
    staticClass: "f-view",
    domProps: {
      "textContent": _vm._s(_vm.ruleForm.residence)
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "f-edit",
    attrs: {
      "maxlength": 50
    },
    model: {
      value: (_vm.ruleForm.residence),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "residence", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.residence"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "应聘城市:",
      "prop": "expectCityId"
    }
  }, [_c('p', {
    staticClass: "f-view",
    domProps: {
      "textContent": _vm._s(_vm.getSelectMapText('WB_POSITION_CITY', _vm.ruleForm.expectCityId))
    }
  }), _vm._v(" "), _c('el-select', {
    staticClass: "f-edit",
    attrs: {
      "placeholder": "请选择应聘城市"
    },
    model: {
      value: (_vm.ruleForm.expectCityId),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "expectCityId", $$v)
      },
      expression: "ruleForm.expectCityId"
    }
  }, _vm._l((_vm.selectMap.WB_POSITION_CITY), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "工作年限:",
      "prop": "workYears"
    }
  }, [_c('p', {
    staticClass: "f-view",
    domProps: {
      "textContent": _vm._s(_vm.getSelectMapText('WB_WORK_YEARS', _vm.ruleForm.workYears))
    }
  }), _vm._v(" "), _c('el-select', {
    staticClass: "f-edit",
    attrs: {
      "placeholder": "请选择工作年限"
    },
    model: {
      value: (_vm.ruleForm.workYears),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "workYears", $$v)
      },
      expression: "ruleForm.workYears"
    }
  }, _vm._l((_vm.selectMap.WB_WORK_YEARS), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "出生日期:",
      "prop": "birthday"
    }
  }, [_c('p', {
    staticClass: "f-view",
    domProps: {
      "textContent": _vm._s(_vm.birthdayText)
    }
  }), _vm._v(" "), _c('el-date-picker', {
    staticClass: "f-edit",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "editable": false,
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.ruleForm.birthday),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "birthday", $$v)
      },
      expression: "ruleForm.birthday"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "籍贯:",
      "prop": "origin"
    }
  }, [_c('p', {
    staticClass: "f-view",
    domProps: {
      "textContent": _vm._s(_vm.ruleForm.origin)
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "f-edit",
    attrs: {
      "maxlength": 50,
      "placeholder": "户籍所在地，如：广东广州"
    },
    model: {
      value: (_vm.ruleForm.origin),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "origin", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.origin"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "证件类型:",
      "prop": "papersType"
    }
  }, [_c('p', {
    staticClass: "f-view",
    domProps: {
      "textContent": _vm._s(_vm.getSelectMapText('WB_ID_CARD_TYPE', _vm.ruleForm.papersType))
    }
  }), _vm._v(" "), _c('el-select', {
    staticClass: "f-edit",
    attrs: {
      "placeholder": "请选择证件类型"
    },
    model: {
      value: (_vm.ruleForm.papersType),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "papersType", $$v)
      },
      expression: "ruleForm.papersType"
    }
  }, _vm._l((_vm.selectMap.WB_ID_CARD_TYPE), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "证件号:",
      "prop": "papersNumber"
    }
  }, [_c('p', {
    staticClass: "f-view",
    domProps: {
      "textContent": _vm._s(_vm.ruleForm.papersNumber)
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "f-edit",
    attrs: {
      "placeholder": "请输入证件号码",
      "maxlength": 30
    },
    model: {
      value: (_vm.ruleForm.papersNumber),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "papersNumber", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.papersNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "推荐人:",
      "prop": "recommender"
    }
  }, [_c('p', {
    staticClass: "f-view",
    domProps: {
      "textContent": _vm._s(_vm.recommenderText)
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "f-edit",
    attrs: {
      "placeholder": "请输入内推码和姓名，如：GO0111张三",
      "maxlength": 30
    },
    model: {
      value: (_vm.ruleForm.recommender),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "recommender", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.recommender"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "与推荐人关系:"
    }
  }, [_c('p', {
    staticClass: "f-view",
    domProps: {
      "textContent": _vm._s(_vm.ruleForm.relationship)
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "f-edit",
    attrs: {
      "placeholder": "请输入与推荐人的关系",
      "maxlength": 30
    },
    model: {
      value: (_vm.ruleForm.relationship),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "relationship", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.relationship"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "期望薪资:",
      "prop": "expectSalary"
    }
  }, [_c('p', {
    staticClass: "f-view"
  }, [_vm._v(_vm._s(_vm.ruleForm.expectSalary))]), _vm._v(" "), _c('el-input', {
    staticClass: "f-edit",
    attrs: {
      "min": 0,
      "placeholder": "请输入期望薪资",
      "maxlength": 30,
      "type": "number"
    },
    model: {
      value: (_vm.ruleForm.expectSalary),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "expectSalary", _vm._n($$v))
      },
      expression: "ruleForm.expectSalary"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "接受调剂:",
      "prop": "acceptRegulate"
    }
  }, [_c('p', {
    staticClass: "f-view",
    domProps: {
      "textContent": _vm._s(_vm.getSelectMapText('WB_ACCEPT_REGULATE', _vm.ruleForm.acceptRegulate))
    }
  }), _vm._v(" "), _c('el-radio-group', {
    staticClass: "f-edit",
    model: {
      value: (_vm.ruleForm.acceptRegulate),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "acceptRegulate", $$v)
      },
      expression: "ruleForm.acceptRegulate"
    }
  }, _vm._l((_vm.selectMap.WB_ACCEPT_REGULATE), function(item, index) {
    return _c('el-radio', {
      key: item.value,
      attrs: {
        "label": item.value
      }
    }, [_vm._v("\n                    " + _vm._s(item.text) + "\n                ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-right": "30px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "游戏经验:",
      "prop": "gameExperience"
    }
  }, [_c('p', {
    staticClass: "f-view pre-wrap",
    staticStyle: {
      "white-space": "pre-line"
    },
    domProps: {
      "textContent": _vm._s(_vm.ruleForm.gameExperience)
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "f-edit",
    attrs: {
      "type": "textarea",
      "maxlength": 1000,
      "autosize": {
        minRows: 3,
        maxRows: 5
      },
      "placeholder": "请填写相关游戏经验",
      "resize": "none"
    },
    model: {
      value: (_vm.ruleForm.gameExperience),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "gameExperience", $$v)
      },
      expression: "ruleForm.gameExperience"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "沟通记录:",
      "prop": "contactResult"
    }
  }, [_c('p', {
    staticClass: "f-view pre-wrap",
    staticStyle: {
      "white-space": "pre-line"
    },
    domProps: {
      "textContent": _vm._s(_vm.ruleForm.contactResult)
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "f-edit",
    attrs: {
      "type": "textarea",
      "maxlength": 1000,
      "autosize": {
        minRows: 3,
        maxRows: 5
      },
      "placeholder": "请填写候选人沟通记录",
      "resize": "none"
    },
    model: {
      value: (_vm.ruleForm.contactResult),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "contactResult", $$v)
      },
      expression: "ruleForm.contactResult"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "简历备注:",
      "prop": "remark"
    }
  }, [_c('p', {
    staticClass: "f-view pre-wrap",
    staticStyle: {
      "white-space": "pre-line"
    },
    domProps: {
      "textContent": _vm._s(_vm.ruleForm.remark || '无')
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "f-edit",
    attrs: {
      "type": "textarea",
      "maxlength": 1000,
      "autosize": {
        minRows: 3,
        maxRows: 5
      },
      "placeholder": "请填写简历备注",
      "resize": "none"
    },
    model: {
      value: (_vm.ruleForm.remark),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "remark", $$v)
      },
      expression: "ruleForm.remark"
    }
  })], 1)], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var items_personal_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/views/resumeDetail/items/personal.vue
function injectStyle (ssrContext) {
  __webpack_require__(821)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  personal_defaultExport,
  items_personal_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var resumeDetail_items_personal_defaultExport = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/resumeDetail/personalModule.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_thumbnail__ = __webpack_require__(60);





/* harmony default export */ var personalModule_defaultExport = ({
    props: {
        data: Object
    },
    data: function data() {
        return {};
    },

    components: {
        Personal: resumeDetail_items_personal_defaultExport,
        Thumbnail: __WEBPACK_IMPORTED_MODULE_1_components_thumbnail__["a" /* default */]
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc750bb2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/resumeDetail/personalModule.vue
var personalModule_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "resume-item-module personal-module"
  }, [_c('h1', {
    staticClass: "module-title"
  }, [_vm._v("个人信息")]), _vm._v(" "), _c('thumbnail', {
    staticClass: "mt-20",
    attrs: {
      "width": 110,
      "gender": _vm.data.gender === 1 ? 'man' : 'woman'
    }
  }), _vm._v(" "), _c('personal', {
    ref: "personal",
    attrs: {
      "init": _vm.data
    }
  })], 1)
}
var personalModule_staticRenderFns = []
var personalModule_esExports = { render: personalModule_render, staticRenderFns: personalModule_staticRenderFns }
/* harmony default export */ var resumeDetail_personalModule_defaultExport = (personalModule_esExports);
// CONCATENATED MODULE: ./src/views/resumeDetail/personalModule.vue
function personalModule_injectStyle (ssrContext) {
  __webpack_require__(819)
}
var personalModule_normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var personalModule___vue_styles__ = personalModule_injectStyle
/* scopeId */
var personalModule___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var personalModule___vue_module_identifier__ = null
var personalModule_Component = personalModule_normalizeComponent(
  personalModule_defaultExport,
  resumeDetail_personalModule_defaultExport,
  personalModule___vue_styles__,
  personalModule___vue_scopeId__,
  personalModule___vue_module_identifier__
)

/* harmony default export */ var views_resumeDetail_personalModule_defaultExport = (personalModule_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/remoteSelect.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ var remoteSelect_defaultExport = ({
    props: {
        url: {
            type: String,
            'default': '/schoolSearch.api'
        },
        multiple: {
            type: Boolean,
            'default': false
        },
        clearable: {
            type: Boolean,
            'default': true
        },
        name: {
            type: String,
            'default': 'name'
        },
        value: {
            type: String
        },
        optionLabel: {
            type: String,
            'default': 'text'
        },
        optionValue: {
            type: String,
            'default': 'value'
        }
    },

    data: function data() {
        return {
            options: [],
            query: this.value || '',
            loading: false
        };
    },

    watch: {
        query: function query(value) {
            this.$emit('input', value);
        }
    },
    methods: {
        remoteMethod: function remoteMethod(query) {
            var _this = this;

            var params = {
                'X-loadingOff': true
            };
            params[this.name] = query;
            if (query !== '') {
                this.loading = true;
                __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.url, {
                    params: params
                }).then(function (res) {
                    _this.loading = false;
                    _this.options = res.result.list;
                });
            } else {
                this.options = [];
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37b6c4b4"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/remoteSelect.vue
var remoteSelect_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "remote-select"
  }, [_c('el-select', {
    attrs: {
      "multiple": _vm.multiple,
      "filterable": "",
      "clearable": "",
      "remote": "",
      "placeholder": "请输入关键词",
      "remote-method": _vm.remoteMethod,
      "loading": _vm.loading
    },
    model: {
      value: (_vm.query),
      callback: function($$v) {
        _vm.query = $$v
      },
      expression: "query"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item[_vm.optionValue],
      attrs: {
        "label": item[_vm.optionLabel],
        "value": item[_vm.optionValue]
      }
    })
  }), 1)], 1)
}
var remoteSelect_staticRenderFns = []
var remoteSelect_esExports = { render: remoteSelect_render, staticRenderFns: remoteSelect_staticRenderFns }
/* harmony default export */ var components_remoteSelect_defaultExport = (remoteSelect_esExports);
// CONCATENATED MODULE: ./src/components/remoteSelect.vue
function remoteSelect_injectStyle (ssrContext) {
  __webpack_require__(825)
}
var remoteSelect_normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var remoteSelect___vue_styles__ = remoteSelect_injectStyle
/* scopeId */
var remoteSelect___vue_scopeId__ = "data-v-37b6c4b4"
/* moduleIdentifier (server only) */
var remoteSelect___vue_module_identifier__ = null
var remoteSelect_Component = remoteSelect_normalizeComponent(
  remoteSelect_defaultExport,
  components_remoteSelect_defaultExport,
  remoteSelect___vue_styles__,
  remoteSelect___vue_scopeId__,
  remoteSelect___vue_module_identifier__
)

/* harmony default export */ var src_components_remoteSelect_defaultExport = (remoteSelect_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/resumeDetail/items/education.vue
/* harmony import */ var education___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(36);
/* harmony import */ var education___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(education___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var education___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var education___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(education___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_pattern__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_underscore__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_tools__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mixins_dateOptionMixin__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mixins_formCommonMixin__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mixins_selectMapMixin__ = __webpack_require__(4);













var fieldName = 'resumeEducations';

/* harmony default export */ var education_defaultExport = ({
    props: {
        init: {
            type: Object,
            required: true
        }
    },
    data: function data() {
        return {
            urls: {
                add: '/resume/resumeEducation/insert.api',
                update: '/resume/resumeEducation/update.api',
                remove: '/resume/resumeEducation/delete.api'
            },
            ruleForm: this.init,
            resetData: education___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.init),
            rules: {
                school: [{ required: true, message: '请输入学校名称', trigger: 'blur' }],
                major: [{ required: true, message: '请输入专业名称', trigger: 'blur' }],
                degree: [{ type: 'number', required: true, message: '请选择学历', trigger: 'blur,change' }]
            },
            isEdit: !(this.init.isEdit === false)
        };
    },

    mixins: [__WEBPACK_IMPORTED_MODULE_7_mixins_dateOptionMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8_mixins_formCommonMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9_mixins_selectMapMixin__["a" /* default */]],
    computed: {
        rangeStartDate: function rangeStartDate() {
            return this.ruleForm.beginDate;
        },
        selectMap: function selectMap() {
            return this.$store.state.baseData.selectMap;
        },
        postData: function postData() {
            return education___WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_4_underscore___default.a.omit(this.ruleForm, ['beginDate', 'endDate', '_index', 'isEdit', 'degreeName', 'degrees']), {
                'beginDate': Object(__WEBPACK_IMPORTED_MODULE_5_modules_tools__["a" /* dateFormat */])(this.ruleForm.beginDate),
                'endDate': Object(__WEBPACK_IMPORTED_MODULE_5_modules_tools__["a" /* dateFormat */])(this.ruleForm.endDate)
            });
        },
        durationDateText: function durationDateText() {
            return this.ruleForm.beginDate ? Object(__WEBPACK_IMPORTED_MODULE_5_modules_tools__["a" /* dateFormat */])(this.ruleForm.beginDate, 'yyyy年MM月') + ' - ' + (this.ruleForm.endDate ? Object(__WEBPACK_IMPORTED_MODULE_5_modules_tools__["a" /* dateFormat */])(this.ruleForm.endDate, 'yyyy年MM月') : '至今') : '-';
        }
    },
    methods: {
        updateData: function updateData() {
            var _this = this;

            var type = this.ruleForm.id ? 'update' : 'add';
            __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(this.urls[type], this.postData, { 'X-showMessage': true }).then(function (res) {
                if (type === 'add') {
                    _this.$emit('add', res.result.bean, _this.ruleForm._index, fieldName);
                }
                education___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this.resetData).forEach(function (item, index) {
                    _this.resetData[item] = res.result.bean[item];
                });
                _this.editData();
            });
        },
        removeData: function removeData() {
            var _this2 = this;

            var removeData = __WEBPACK_IMPORTED_MODULE_4_underscore___default.a.pick(this.postData, ['id', 'resumeId', 'resumePositionId']);
            this.$confirm('是否删除该记录?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(_this2.urls.remove, removeData, { 'X-showMessage': true }).then(function (res) {
                    _this2.$emit('remove', removeData, fieldName);
                });
            });
        },
        removeItem: function removeItem(itemData) {
            this.$emit('remove', itemData.id || itemData['_index']);
        },
        transToText: function transToText(base, field) {
            var target = __WEBPACK_IMPORTED_MODULE_4_underscore___default.a.findWhere(this.selectMap[base], { value: this.ruleForm[field] + '' });
            return target && target.text || '';
        },
        editData: function editData() {
            this.isEdit = !this.isEdit;
        },
        cancelEdit: function cancelEdit() {
            if (this.postData.id) {
                this.resetForm('ruleForm');
                this.resetDataFn();
                this.editData();
            } else {
                this.$emit('remove', __WEBPACK_IMPORTED_MODULE_4_underscore___default.a.pick(this.postData, ['id', 'resumeId', 'resumePositionId']), fieldName);
            }
        },
        resetDataFn: function resetDataFn() {
            var _this3 = this;

            education___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.ruleForm).forEach(function (item, index) {
                _this3.ruleForm[item] = _this3.resetData[item];
            });
        },
        saveData: function saveData(formName, callback) {
            var _this4 = this;

            this.$refs[formName].validate(function (valid) {
                if (valid) {
                    callback(_this4.postData);
                } else {
                    return false;
                }
            });
        }
    },
    components: {
        RemoteSelect: src_components_remoteSelect_defaultExport
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cd0e1464"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/resumeDetail/items/education.vue
var education_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-divider"
  }, [_c('el-button', {
    staticClass: "remove-btn f-edit",
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.removeItem(_vm.ruleForm)
      }
    }
  }, [_c('span', {
    staticClass: "color-danger"
  }, [_vm._v("删除")])]), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    class: [{
      'form-view': !_vm.isEdit
    }, 'form-switch', 'form-col'],
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('div', {
    staticClass: "col-2 clearfix"
  }, [_c('el-form-item', {
    attrs: {
      "label": "学校名称:",
      "prop": "school"
    }
  }, [_c('p', {
    staticClass: "f-view",
    domProps: {
      "textContent": _vm._s(_vm.ruleForm.school)
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "f-edit",
    attrs: {
      "maxlength": 20,
      "placeholder": "请输入学校名称"
    },
    model: {
      value: (_vm.ruleForm.school),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "school", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.school"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "专业名称:",
      "prop": "major"
    }
  }, [_c('p', {
    staticClass: "f-view",
    domProps: {
      "textContent": _vm._s(_vm.ruleForm.major)
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "f-edit",
    attrs: {
      "maxlength": 20,
      "placeholder": "请输入专业名称"
    },
    model: {
      value: (_vm.ruleForm.major),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "major", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.major"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-2 clearfix"
  }, [_c('el-form-item', {
    attrs: {
      "label": "学历:",
      "prop": "degree"
    }
  }, [_c('p', {
    staticClass: "f-view",
    domProps: {
      "textContent": _vm._s(_vm.getSelectMapText('WB_EDU_DEGREE', _vm.ruleForm.degree))
    }
  }), _vm._v(" "), _c('el-select', {
    staticClass: "f-edit",
    attrs: {
      "placeholder": "请选择学历"
    },
    model: {
      value: (_vm.ruleForm.degree),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "degree", $$v)
      },
      expression: "ruleForm.degree"
    }
  }, _vm._l((_vm.selectMap.WB_EDU_DEGREE), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.text,
        "value": parseInt(item.value)
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "width-longer",
    attrs: {
      "label": "就读时间:"
    }
  }, [_c('p', {
    staticClass: "f-view",
    domProps: {
      "textContent": _vm._s(_vm.durationDateText)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "f-edit"
  }, [_c('el-date-picker', {
    ref: "startDate",
    attrs: {
      "type": "month",
      "placeholder": "开始时间",
      "picker-options": _vm.startDateOption
    },
    on: {
      "change": _vm.startDateChange
    },
    model: {
      value: (_vm.ruleForm.beginDate),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "beginDate", $$v)
      },
      expression: "ruleForm.beginDate"
    }
  }), _vm._v("\n                    至\n                    "), _c('el-date-picker', {
    ref: "endDate",
    attrs: {
      "type": "month",
      "placeholder": "结束时间",
      "picker-options": _vm.endDateOption
    },
    on: {
      "change": _vm.endDateChange
    },
    model: {
      value: (_vm.ruleForm.endDate),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "endDate", $$v)
      },
      expression: "ruleForm.endDate"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "padding-right": "30px"
    },
    attrs: {
      "label": "专业描述:"
    }
  }, [_c('p', {
    staticClass: "f-view pre-wrap",
    domProps: {
      "textContent": _vm._s(_vm.ruleForm.majorDesc)
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "f-edit",
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 3,
        maxRows: 5
      },
      "maxlength": 1000,
      "resize": "none"
    },
    model: {
      value: (_vm.ruleForm.majorDesc),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "majorDesc", $$v)
      },
      expression: "ruleForm.majorDesc"
    }
  })], 1)], 1)], 1)
}
var education_staticRenderFns = []
var education_esExports = { render: education_render, staticRenderFns: education_staticRenderFns }
/* harmony default export */ var items_education_defaultExport = (education_esExports);
// CONCATENATED MODULE: ./src/views/resumeDetail/items/education.vue
var education_normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var education___vue_styles__ = null
/* scopeId */
var education___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var education___vue_module_identifier__ = null
var education_Component = education_normalizeComponent(
  education_defaultExport,
  items_education_defaultExport,
  education___vue_styles__,
  education___vue_scopeId__,
  education___vue_module_identifier__
)

/* harmony default export */ var resumeDetail_items_education_defaultExport = (education_Component.exports);

// CONCATENATED MODULE: ./src/views/resumeDetail/itemsData.js
var itemsData_namespaceObject = {};
__webpack_require__.d(itemsData_namespaceObject, "education", function() { return education; });
__webpack_require__.d(itemsData_namespaceObject, "work", function() { return work; });
__webpack_require__.d(itemsData_namespaceObject, "project", function() { return project; });
__webpack_require__.d(itemsData_namespaceObject, "skill", function() { return skill; });
__webpack_require__.d(itemsData_namespaceObject, "experience", function() { return experience; });

var education = {
    resumeId: '',
    school: '',
    major: '',
    degree: '',
    beginDate: '',
    endDate: '',
    majorDesc: '' };

var work = {
    resumeId: '',
    company: '',
    position: '',
    beginDate: '',
    endDate: ''
};

var project = {
    resumeId: '',
    name: '',
    role: '',
    description: '',
    responsibility: '',
    beginDate: '',
    endDate: ''
};

var skill = {
    resumeId: '',
    skill: '',
    proficiency: '',
    experience: ''
};

var experience = {
    resumeId: '',
    name: '',
    duration: '',
    achievement: ''
};


// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/resumeDetail/educationModule.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);






/* harmony default export */ var educationModule_defaultExport = ({
    props: {
        data: [Object, Array]
    },
    data: function data() {
        return {
            isPass: true
        };
    },

    methods: {
        addItem: function addItem() {
            if (this.data.length === 5) {
                this.$message.error('\u6559\u80B2\u7ECF\u5386\u4E0D\u80FD\u8D85\u8FC7' + this.data.length);
                return false;
            }
            var item = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, education, {
                resumeId: this.$route.params.id,
                isEdit: true,
                _index: Date.now()
            });
            this.data.push(item);
        },
        removeItem: function removeItem(id) {
            if (this.data.length === 1) {
                this.$message.error('\u6559\u80B2\u7ECF\u5386\u81F3\u5C11\u8981\u6709\u4E00\u4E2A');
                return false;
            }
            var targetIndex = '';
            this.data.forEach(function (item, index) {
                if (id === item.id || id === item['_index']) {
                    targetIndex = index;
                }
            });
            this.data.splice(targetIndex, 1);
        },
        saveAllEducation: function saveAllEducation(callback) {
            var _this = this;

            var arr = [];
            this.data.forEach(function (item, index) {
                _this.$refs['education' + index][0].saveData('ruleForm', function (data) {
                    arr.push(data);
                });
            });
            this.isPass = arr.length === this.data.length;
            callback(arr);
        },
        resetAllEducation: function resetAllEducation() {
            var _this2 = this;

            this.data.forEach(function (item, index) {
                _this2.$refs['education' + index][0].resetForm('ruleForm');
            });
        }
    },
    components: {
        Education: resumeDetail_items_education_defaultExport
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1626af2e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/resumeDetail/educationModule.vue
var educationModule_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "resume-item-module"
  }, [_c('h1', {
    staticClass: "module-title"
  }, [_vm._v("教育经历\n        "), _c('el-button', {
    staticClass: "pull-right f-edit",
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.addItem
    }
  }, [_vm._v("添加")])], 1), _vm._v(" "), _vm._l((_vm.data), function(item, index) {
    return [_c('education', {
      key: item.id || item._index,
      ref: 'education' + index,
      refInFor: true,
      attrs: {
        "init": item
      },
      on: {
        "remove": _vm.removeItem
      }
    })]
  })], 2)
}
var educationModule_staticRenderFns = []
var educationModule_esExports = { render: educationModule_render, staticRenderFns: educationModule_staticRenderFns }
/* harmony default export */ var resumeDetail_educationModule_defaultExport = (educationModule_esExports);
// CONCATENATED MODULE: ./src/views/resumeDetail/educationModule.vue
function educationModule_injectStyle (ssrContext) {
  __webpack_require__(823)
}
var educationModule_normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var educationModule___vue_styles__ = educationModule_injectStyle
/* scopeId */
var educationModule___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var educationModule___vue_module_identifier__ = null
var educationModule_Component = educationModule_normalizeComponent(
  educationModule_defaultExport,
  resumeDetail_educationModule_defaultExport,
  educationModule___vue_styles__,
  educationModule___vue_scopeId__,
  educationModule___vue_module_identifier__
)

/* harmony default export */ var views_resumeDetail_educationModule_defaultExport = (educationModule_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/resumeDetail/attachModule.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__items_attach__ = __webpack_require__(335);




/* harmony default export */ var attachModule_defaultExport = ({
    props: {
        data: [Object, Array],
        rid: [Number, String]
    },
    data: function data() {
        return {};
    },

    components: {
        Attach: __WEBPACK_IMPORTED_MODULE_0__items_attach__["a" /* default */]
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f3efd6a8"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/resumeDetail/attachModule.vue
var attachModule_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "resume-item-module"
  }, [_c('h1', {
    staticClass: "module-title"
  }, [_vm._v("附件上传")]), _vm._v(" "), _c('attach', {
    ref: "attach",
    attrs: {
      "init": _vm.data,
      "rid": _vm.rid
    }
  })], 1)
}
var attachModule_staticRenderFns = []
var attachModule_esExports = { render: attachModule_render, staticRenderFns: attachModule_staticRenderFns }
/* harmony default export */ var resumeDetail_attachModule_defaultExport = (attachModule_esExports);
// CONCATENATED MODULE: ./src/views/resumeDetail/attachModule.vue
function attachModule_injectStyle (ssrContext) {
  __webpack_require__(827)
}
var attachModule_normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var attachModule___vue_styles__ = attachModule_injectStyle
/* scopeId */
var attachModule___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var attachModule___vue_module_identifier__ = null
var attachModule_Component = attachModule_normalizeComponent(
  attachModule_defaultExport,
  resumeDetail_attachModule_defaultExport,
  attachModule___vue_styles__,
  attachModule___vue_scopeId__,
  attachModule___vue_module_identifier__
)

/* harmony default export */ var views_resumeDetail_attachModule_defaultExport = (attachModule_Component.exports);

// CONCATENATED MODULE: ./src/views/resumeDetail/items/multiItemMixin.js
/* harmony import */ var multiItemMixin___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var multiItemMixin___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(multiItemMixin___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_rules__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mixins_formCommonMixin__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mixins_selectMapMixin__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mixins_dateOptionMixin__ = __webpack_require__(159);
/* harmony import */ var multiItemMixin___WEBPACK_IMPORTED_MODULE_5_modules_tools__ = __webpack_require__(14);







/* harmony default export */ var multiItemMixin_defaultExport = ({
    props: {
        init: {
            type: Object,
            required: true
        }
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_4_mixins_dateOptionMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2_mixins_formCommonMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3_mixins_selectMapMixin__["a" /* default */]],
    computed: {
        rangeStartDate: function rangeStartDate() {
            return this.ruleForm.beginDate;
        },
        postData: function postData() {
            var dataCopy = multiItemMixin___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.ruleForm);
            delete dataCopy.isEdit;
            delete dataCopy._index;
            return multiItemMixin___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(dataCopy, {
                'beginDate': Object(multiItemMixin___WEBPACK_IMPORTED_MODULE_5_modules_tools__["a" /* dateFormat */])(this.ruleForm.beginDate),
                'endDate': Object(multiItemMixin___WEBPACK_IMPORTED_MODULE_5_modules_tools__["a" /* dateFormat */])(this.ruleForm.endDate)
            });
        },
        durationDateText: function durationDateText() {
            return this.ruleForm.beginDate ? Object(multiItemMixin___WEBPACK_IMPORTED_MODULE_5_modules_tools__["a" /* dateFormat */])(this.ruleForm.beginDate, 'yyyy年MM月') + ' - ' + (this.ruleForm.endDate ? Object(multiItemMixin___WEBPACK_IMPORTED_MODULE_5_modules_tools__["a" /* dateFormat */])(this.ruleForm.endDate, 'yyyy年MM月') : '至今') : '-';
        }
    },
    methods: {
        removeItem: function removeItem(itemData) {
            this.$emit('remove', itemData.id || itemData['_index']);
        },
        saveData: function saveData(formName, callback) {
            var _this = this;

            this.$refs[formName].validate(function (valid) {
                if (valid) {
                    callback(_this.postData);
                } else {
                    return false;
                }
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/resumeDetail/items/work.vue
/* harmony import */ var work___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var work___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(work___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);





/* harmony default export */ var work_defaultExport = ({
    mixins: [multiItemMixin_defaultExport],
    data: function data() {
        return {
            ruleForm: this.init,
            resetData: work___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.init),
            rules: {
                company: [{ required: true, message: '请输入公司名称', trigger: 'blur' }],
                position: [{ required: true, message: '请输入职位名称', trigger: 'blur' }]
            },
            isEdit: !(this.init.isEdit === false)
        };
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b1e0ce4a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/resumeDetail/items/work.vue
var work_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-divider"
  }, [_c('el-button', {
    staticClass: "remove-btn f-edit",
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.removeItem(_vm.ruleForm)
      }
    }
  }, [_c('span', {
    staticClass: "color-danger"
  }, [_vm._v("删除")])]), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    class: [{
      'form-view': !_vm.isEdit
    }, 'form-switch', 'form-col'],
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('div', {
    staticClass: "col-2 clearfix"
  }, [_c('el-form-item', {
    attrs: {
      "label": "公司名称:",
      "prop": "company"
    }
  }, [_c('p', {
    staticClass: "f-view",
    domProps: {
      "textContent": _vm._s(_vm.ruleForm.company)
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "f-edit",
    attrs: {
      "maxlength": 20,
      "placeholder": "请输入公司名称"
    },
    model: {
      value: (_vm.ruleForm.company),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "company", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.company"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "职位名称:",
      "prop": "position"
    }
  }, [_c('p', {
    staticClass: "f-view",
    domProps: {
      "textContent": _vm._s(_vm.ruleForm.position)
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "f-edit",
    attrs: {
      "maxlength": 20,
      "placeholder": "请输入职位名称"
    },
    model: {
      value: (_vm.ruleForm.position),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "position", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.position"
    }
  })], 1)], 1), _vm._v(" "), _c('div', [_c('el-form-item', {
    staticClass: "width-longer",
    attrs: {
      "label": "工作时间:"
    }
  }, [_c('p', {
    staticClass: "f-view",
    domProps: {
      "textContent": _vm._s(_vm.durationDateText)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "f-edit"
  }, [_c('el-date-picker', {
    ref: "startDate",
    attrs: {
      "type": "month",
      "placeholder": "开始时间",
      "picker-options": _vm.startDateOption
    },
    on: {
      "change": _vm.startDateChange
    },
    model: {
      value: (_vm.ruleForm.beginDate),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "beginDate", $$v)
      },
      expression: "ruleForm.beginDate"
    }
  }), _vm._v("\n                    至\n                    "), _c('el-date-picker', {
    ref: "endDate",
    attrs: {
      "type": "month",
      "placeholder": "结束时间",
      "picker-options": _vm.endDateOption
    },
    on: {
      "change": _vm.endDateChange
    },
    model: {
      value: (_vm.ruleForm.endDate),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "endDate", $$v)
      },
      expression: "ruleForm.endDate"
    }
  })], 1)])], 1)])], 1)
}
var work_staticRenderFns = []
var work_esExports = { render: work_render, staticRenderFns: work_staticRenderFns }
/* harmony default export */ var items_work_defaultExport = (work_esExports);
// CONCATENATED MODULE: ./src/views/resumeDetail/items/work.vue
var work_normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var work___vue_styles__ = null
/* scopeId */
var work___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var work___vue_module_identifier__ = null
var work_Component = work_normalizeComponent(
  work_defaultExport,
  items_work_defaultExport,
  work___vue_styles__,
  work___vue_scopeId__,
  work___vue_module_identifier__
)

/* harmony default export */ var resumeDetail_items_work_defaultExport = (work_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/resumeDetail/items/project.vue
/* harmony import */ var project___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var project___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(project___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);





/* harmony default export */ var project_defaultExport = ({
    mixins: [multiItemMixin_defaultExport],
    data: function data() {
        return {
            ruleForm: this.init,
            resetData: project___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.init),
            rules: {
                name: [{ required: true, message: '请输入项目名称', trigger: 'blur' }],
                role: [{ required: true, message: '请输入职务', trigger: 'blur' }],
                description: [{ required: true, message: '请输入项目描述', trigger: 'blur' }],
                responsibility: [{ required: true, message: '请输入职责描述', trigger: 'blur' }]
            },
            isEdit: !(this.init.isEdit === false)
        };
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a417782"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/resumeDetail/items/project.vue
var project_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-divider"
  }, [_c('el-button', {
    staticClass: "remove-btn f-edit",
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.removeItem(_vm.ruleForm)
      }
    }
  }, [_c('span', {
    staticClass: "color-danger"
  }, [_vm._v("删除")])]), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    class: [{
      'form-view': !_vm.isEdit
    }, 'form-switch', 'form-col'],
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('div', {
    staticClass: "col-2 clearfix"
  }, [_c('el-form-item', {
    attrs: {
      "label": "项目名称:",
      "prop": "name"
    }
  }, [_c('p', {
    staticClass: "f-view",
    domProps: {
      "textContent": _vm._s(_vm.ruleForm.name)
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "f-edit",
    attrs: {
      "maxlength": 20,
      "placeholder": "请输入项目名称"
    },
    model: {
      value: (_vm.ruleForm.name),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "职务:",
      "prop": "role"
    }
  }, [_c('p', {
    staticClass: "f-view",
    domProps: {
      "textContent": _vm._s(_vm.ruleForm.role)
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "f-edit",
    attrs: {
      "maxlength": 20,
      "placeholder": "请输入职务"
    },
    model: {
      value: (_vm.ruleForm.role),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "role", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.role"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-2 clearfix"
  }, [_c('el-form-item', {
    attrs: {
      "label": "项目描述:",
      "prop": "description"
    }
  }, [_c('p', {
    staticClass: "f-view",
    domProps: {
      "textContent": _vm._s(_vm.ruleForm.description)
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "f-edit",
    attrs: {
      "maxlength": 20,
      "placeholder": "请输入项目描述"
    },
    model: {
      value: (_vm.ruleForm.description),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "description", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.description"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "职责描述:",
      "prop": "responsibility"
    }
  }, [_c('p', {
    staticClass: "f-view",
    domProps: {
      "textContent": _vm._s(_vm.ruleForm.responsibility)
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "f-edit",
    attrs: {
      "maxlength": 20,
      "placeholder": "请输入职责描述"
    },
    model: {
      value: (_vm.ruleForm.responsibility),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "responsibility", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.responsibility"
    }
  })], 1)], 1), _vm._v(" "), _c('div', [_c('el-form-item', {
    staticClass: "width-longer",
    attrs: {
      "label": "项目时间:"
    }
  }, [_c('p', {
    staticClass: "f-view",
    domProps: {
      "textContent": _vm._s(_vm.durationDateText)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "f-edit"
  }, [_c('el-date-picker', {
    ref: "startDate",
    attrs: {
      "type": "month",
      "placeholder": "开始时间",
      "picker-options": _vm.startDateOption
    },
    on: {
      "change": _vm.startDateChange
    },
    model: {
      value: (_vm.ruleForm.beginDate),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "beginDate", $$v)
      },
      expression: "ruleForm.beginDate"
    }
  }), _vm._v("\n                    至\n                    "), _c('el-date-picker', {
    ref: "endDate",
    attrs: {
      "type": "month",
      "placeholder": "结束时间",
      "picker-options": _vm.endDateOption
    },
    on: {
      "change": _vm.endDateChange
    },
    model: {
      value: (_vm.ruleForm.endDate),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "endDate", $$v)
      },
      expression: "ruleForm.endDate"
    }
  })], 1)])], 1)])], 1)
}
var project_staticRenderFns = []
var project_esExports = { render: project_render, staticRenderFns: project_staticRenderFns }
/* harmony default export */ var items_project_defaultExport = (project_esExports);
// CONCATENATED MODULE: ./src/views/resumeDetail/items/project.vue
var project_normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var project___vue_styles__ = null
/* scopeId */
var project___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var project___vue_module_identifier__ = null
var project_Component = project_normalizeComponent(
  project_defaultExport,
  items_project_defaultExport,
  project___vue_styles__,
  project___vue_scopeId__,
  project___vue_module_identifier__
)

/* harmony default export */ var resumeDetail_items_project_defaultExport = (project_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/resumeDetail/items/skill.vue
/* harmony import */ var skill___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var skill___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(skill___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);





/* harmony default export */ var skill_defaultExport = ({
    mixins: [multiItemMixin_defaultExport],
    data: function data() {
        return {
            ruleForm: this.init,
            resetData: skill___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.init),
            rules: {
                skill: [{ required: true, message: '请输入职位技能', trigger: 'blur' }],
                experience: [{ required: true, message: '请选择使用时间', trigger: 'blur,change' }],
                proficiency: [{ required: true, message: '请选择熟练度', trigger: 'blur,change' }]
            },
            isEdit: !(this.init.isEdit === false)
        };
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7332d2f7"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/resumeDetail/items/skill.vue
var skill_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-divider"
  }, [_c('el-button', {
    staticClass: "remove-btn f-edit",
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.removeItem(_vm.ruleForm)
      }
    }
  }, [_c('span', {
    staticClass: "color-danger"
  }, [_vm._v("删除")])]), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    class: [{
      'form-view': !_vm.isEdit
    }, 'form-switch', 'form-col'],
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('div', {
    staticClass: "col-2 clearfix"
  }, [_c('el-form-item', {
    attrs: {
      "label": "职位技能:",
      "prop": "skill"
    }
  }, [_c('p', {
    staticClass: "f-view",
    domProps: {
      "textContent": _vm._s(_vm.ruleForm.skill)
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "f-edit",
    attrs: {
      "maxlength": 20,
      "placeholder": "请输入职位技能"
    },
    model: {
      value: (_vm.ruleForm.skill),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "skill", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.skill"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "熟练度:",
      "prop": "proficiency"
    }
  }, [_c('p', {
    staticClass: "f-view",
    domProps: {
      "textContent": _vm._s(_vm.getSelectMapText('WB_SKILL_PROFICIENCY', _vm.ruleForm.proficiency))
    }
  }), _vm._v(" "), _c('el-select', {
    staticClass: "f-edit",
    attrs: {
      "placeholder": "请选择熟练度"
    },
    model: {
      value: (_vm.ruleForm.proficiency),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "proficiency", $$v)
      },
      expression: "ruleForm.proficiency"
    }
  }, _vm._l((_vm.selectMap.WB_SKILL_PROFICIENCY), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', [_c('el-form-item', {
    attrs: {
      "label": "使用时间:",
      "prop": "experience"
    }
  }, [_c('p', {
    staticClass: "f-view",
    domProps: {
      "textContent": _vm._s(_vm.getSelectMapText('WB_SKILL_YEARS', _vm.ruleForm.experience))
    }
  }), _vm._v(" "), _c('el-select', {
    staticClass: "f-edit",
    attrs: {
      "placeholder": "请选择使用时间"
    },
    model: {
      value: (_vm.ruleForm.experience),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "experience", $$v)
      },
      expression: "ruleForm.experience"
    }
  }, _vm._l((_vm.selectMap.WB_SKILL_YEARS), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)])], 1)
}
var skill_staticRenderFns = []
var skill_esExports = { render: skill_render, staticRenderFns: skill_staticRenderFns }
/* harmony default export */ var items_skill_defaultExport = (skill_esExports);
// CONCATENATED MODULE: ./src/views/resumeDetail/items/skill.vue
var skill_normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var skill___vue_styles__ = null
/* scopeId */
var skill___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var skill___vue_module_identifier__ = null
var skill_Component = skill_normalizeComponent(
  skill_defaultExport,
  items_skill_defaultExport,
  skill___vue_styles__,
  skill___vue_scopeId__,
  skill___vue_module_identifier__
)

/* harmony default export */ var resumeDetail_items_skill_defaultExport = (skill_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/resumeDetail/items/experience.vue
/* harmony import */ var experience___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var experience___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(experience___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);





/* harmony default export */ var experience_defaultExport = ({
    mixins: [multiItemMixin_defaultExport],
    data: function data() {
        return {
            ruleForm: this.init,
            resetData: experience___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.init),
            rules: {
                name: [{ required: true, message: '请输入游戏名称', trigger: 'blur' }],
                duration: [{ required: true, message: '请输入游戏时长', trigger: 'blur' }],
                achievement: [{ required: true, message: '请输入游戏成就', trigger: 'blur' }]
            },
            isEdit: !(this.init.isEdit === false)
        };
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30d94934"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/resumeDetail/items/experience.vue
var experience_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-divider"
  }, [_c('el-button', {
    staticClass: "remove-btn f-edit",
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.removeItem(_vm.ruleForm)
      }
    }
  }, [_c('span', {
    staticClass: "color-danger"
  }, [_vm._v("删除")])]), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    class: [{
      'form-view': !_vm.isEdit
    }, 'form-switch', 'form-col'],
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('div', {
    staticClass: "col-2 clearfix"
  }, [_c('el-form-item', {
    attrs: {
      "label": "游戏名称:",
      "prop": "name"
    }
  }, [_c('p', {
    staticClass: "f-view",
    domProps: {
      "textContent": _vm._s(_vm.ruleForm.name)
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "f-edit",
    attrs: {
      "maxlength": 20,
      "placeholder": "请输入游戏名称"
    },
    model: {
      value: (_vm.ruleForm.name),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "游戏时长:",
      "prop": "duration"
    }
  }, [_c('p', {
    staticClass: "f-view",
    domProps: {
      "textContent": _vm._s(_vm.ruleForm.duration)
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "f-edit",
    attrs: {
      "maxlength": 20,
      "placeholder": "请输入游戏时长"
    },
    model: {
      value: (_vm.ruleForm.duration),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "duration", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.duration"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('el-form-item', {
    attrs: {
      "label": "游戏成就:",
      "prop": "achievement"
    }
  }, [_c('p', {
    staticClass: "f-view",
    domProps: {
      "textContent": _vm._s(_vm.ruleForm.achievement)
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "f-edit",
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 3,
        maxRows: 5
      },
      "placeholder": "请输入游戏成就",
      "resize": "none"
    },
    model: {
      value: (_vm.ruleForm.achievement),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "achievement", $$v)
      },
      expression: "ruleForm.achievement"
    }
  })], 1)], 1)])], 1)
}
var experience_staticRenderFns = []
var experience_esExports = { render: experience_render, staticRenderFns: experience_staticRenderFns }
/* harmony default export */ var items_experience_defaultExport = (experience_esExports);
// CONCATENATED MODULE: ./src/views/resumeDetail/items/experience.vue
var experience_normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var experience___vue_styles__ = null
/* scopeId */
var experience___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var experience___vue_module_identifier__ = null
var experience_Component = experience_normalizeComponent(
  experience_defaultExport,
  items_experience_defaultExport,
  experience___vue_styles__,
  experience___vue_scopeId__,
  experience___vue_module_identifier__
)

/* harmony default export */ var resumeDetail_items_experience_defaultExport = (experience_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/resumeDetail/itemModule.vue
/* harmony import */ var itemModule___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var itemModule___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(itemModule___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);










var ITEM_TYPE = {
    education: {
        label: '教育经历',
        tpl: resumeDetail_items_education_defaultExport
    },
    work: {
        label: '工作经历',
        tpl: resumeDetail_items_work_defaultExport
    },
    project: {
        label: '项目经验',
        tpl: resumeDetail_items_project_defaultExport
    },
    skill: {
        label: '职位技能',
        tpl: resumeDetail_items_skill_defaultExport
    },
    experience: {
        label: '游戏经历',
        tpl: resumeDetail_items_experience_defaultExport
    }
};

/* harmony default export */ var itemModule_defaultExport = ({
    props: {
        data: [Object, Array],
        label: String,
        multiple: {
            type: Boolean,
            'default': false
        },
        type: {
            type: String
        }
    },
    data: function data() {
        return {
            isPass: true,
            tpl: ITEM_TYPE[this.type].tpl,
            labelText: this.label || ITEM_TYPE[this.type].label
        };
    },

    methods: {
        addItem: function addItem() {
            if (this.data.length === 5) {
                this.$message.error(this.labelText + '\u4E0D\u80FD\u8D85\u8FC7' + this.data.length);
                return false;
            }
            var item = itemModule___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, itemsData_namespaceObject[this.type], {
                resumeId: this.$route.params.id,
                isEdit: true,
                _index: Date.now()
            });
            this.data.push(item);
        },
        removeItem: function removeItem(id) {
            if (this.data.length === 1) {
                this.$message.error(this.labelText + '\u81F3\u5C11\u8981\u6709\u4E00\u6761\u8BB0\u5F55');
                return false;
            }
            var targetIndex = '';
            this.data.forEach(function (item, index) {
                if (id === item.id || id === item['_index']) {
                    targetIndex = index;
                }
            });
            this.data.splice(targetIndex, 1);
        },
        saveAll: function saveAll(callback) {
            var _this = this;

            var arr = [];
            this.data.forEach(function (item, index) {
                _this.$refs[_this.type + index][0].saveData('ruleForm', function (data) {
                    arr.push(data);
                });
            });
            this.isPass = arr.length === this.data.length;
            callback(arr);
        },
        resetAll: function resetAll() {
            var _this2 = this;

            this.data.forEach(function (item, index) {
                _this2.$refs[_this2.type + index][0].resetForm('ruleForm');
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b3c068c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/resumeDetail/itemModule.vue
var itemModule_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "resume-item-module"
  }, [_c('h1', {
    staticClass: "module-title"
  }, [_vm._v(_vm._s(_vm.labelText) + "\n        "), (_vm.multiple) ? _c('el-button', {
    staticClass: "pull-right f-edit",
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.addItem
    }
  }, [_vm._v("添加")]) : _vm._e()], 1), _vm._v(" "), _vm._l((_vm.data), function(item, index) {
    return [_c(_vm.tpl, {
      key: item.id || item._index,
      ref: _vm.type + index,
      refInFor: true,
      tag: "component",
      attrs: {
        "init": item
      },
      on: {
        "remove": _vm.removeItem
      }
    })]
  })], 2)
}
var itemModule_staticRenderFns = []
var itemModule_esExports = { render: itemModule_render, staticRenderFns: itemModule_staticRenderFns }
/* harmony default export */ var resumeDetail_itemModule_defaultExport = (itemModule_esExports);
// CONCATENATED MODULE: ./src/views/resumeDetail/itemModule.vue
function itemModule_injectStyle (ssrContext) {
  __webpack_require__(829)
}
var itemModule_normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var itemModule___vue_styles__ = itemModule_injectStyle
/* scopeId */
var itemModule___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var itemModule___vue_module_identifier__ = null
var itemModule_Component = itemModule_normalizeComponent(
  itemModule_defaultExport,
  resumeDetail_itemModule_defaultExport,
  itemModule___vue_styles__,
  itemModule___vue_scopeId__,
  itemModule___vue_module_identifier__
)

/* harmony default export */ var views_resumeDetail_itemModule_defaultExport = (itemModule_Component.exports);

// CONCATENATED MODULE: ./src/directives/vue-sticky.js


var VueSticky = {
    id: 'Sticky',
    name: 'directive-sticky',
    bind: function bind(el, binding, vnode) {
        el.handleScroll = function (e) {
            if (el.style.position === 'initial') {
                if (window.scrollY >= el.offsetTop) {
                    el.style.position = 'fixed';
                    el.style.top = 0;
                    el.style.width = '100%';
                    el.style.zIndex = 1000;
                }
            } else {
                if (window.scrollY - el.offsetHeight < el.offsetTop) {
                    el.style.position = 'initial';
                    el.style.top = 'initial';
                    el.style.width = 'initial';
                    el.style.zIndex = 'initial';
                }
            }
        };
        window.addEventListener('scroll', el.handleScroll);
    },
    unbind: function unbind(el) {
        window.removeEventListener('scroll', el.handleScroll);
    },
    install: function install(Vue) {
        Vue.directive(this.id, {
            bind: this.bind,
            unbind: this.unbind
        });
    }
};

/* harmony default export */ var vue_sticky_defaultExport = (VueSticky);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/resumeDetail/resumeDetail.vue
/* harmony import */ var resumeDetail___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(36);
/* harmony import */ var resumeDetail___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(resumeDetail___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__operation_operationMixin__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mixins_selectMapMixin__ = __webpack_require__(4);












/* harmony default export */ var resumeDetail_defaultExport = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_6__operation_operationMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8_mixins_selectMapMixin__["a" /* default */]],
    data: function data() {
        return {
            urls: {
                fetch: '/resumePosition/detail.api',
                save: '/resume/update.api'
            },
            lists: [],
            flowList: [],
            personalData: {
                resumeWorkList: []
            },
            positionData: {},
            educationData: [],
            attachData: [],
            preventKey: 1,
            rid: '',
            isEdit: false,
            showCloseBtn: !!window.opener };
    },

    computed: {
        id: function id() {
            return this.$route.params.id;
        },
        from: function from() {
            return this.$route.query.fromName;
        }
    },
    methods: {
        submitAll: function submitAll() {
            var _this = this;

            var postData = {},
                isEducationOK = void 0,
                isPersonalOK = void 0,
                isWorkOK = void 0,
                itemMap = {
                work: 'works',
                project: 'projects',
                skill: 'itSkills',
                experience: 'gameExperiences'
            },
                okArr = [];

            this.$refs.personalModule.$refs.personal.saveData('ruleForm', function (data) {
                isPersonalOK = !!data;
                postData = data;
            });

            this.$refs.educationModule.saveAllEducation(function (data) {
                postData.edus = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data);
                isEducationOK = _this.$refs.educationModule.isPass;
            });
            resumeDetail___WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(itemMap).forEach(function (key) {
                _this.$refs[key + 'Module'].saveAll(function (data) {
                    postData[itemMap[key]] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data);
                    okArr.push(_this.$refs[key + 'Module'].isPass);
                    console.log(key + ':', postData[itemMap[key]], okArr);
                });
            });

            this.$refs.attachModule.$refs.attach.saveData(function (data) {
                var attachArr = data.map(function (item, index) {
                    return {
                        resumeId: item.resumeId,
                        fileId: item.fileId,
                        md5: item.md5
                    };
                });

                postData.attachs = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(attachArr);
            });

            if (isPersonalOK && isEducationOK && okArr.indexOf(false) === -1) {
                this.$axios.post(this.urls.save, postData, { 'X-showMessage': true }).then(function (res) {
                    _this.editData();
                    _this.setInitData(res.result.bean);
                    _this.lists = [res.result.bean];
                }).catch(function () {});
            }
        },
        editData: function editData() {
            this.isEdit = !this.isEdit;
        },
        cancelEdit: function cancelEdit() {
            this.editData();
            this.$refs.personalModule.$refs.personal.resetForm('ruleForm');
            this.$refs.educationModule.resetAllEducation();
            this.fetchData();
        },
        setInitData: function setInitData(data) {
            this.rid = data.resumeForm.id;
            this.personalData = data.resumeForm;
            this.positionData = data.positionForm;
            this.personalData.positionId = data.positionForm.id + '';
            this.educationData = data.resumeForm.resumeEducationList;
            this.attachData = data.resumeForm.resumeAttachList;
        },
        fetchData: function fetchData() {
            var _this2 = this;

            this.$axios.post(this.urls.fetch, { id: this.id }).then(function (res) {
                _this2.setInitData(res.result.bean);
                _this2.lists = [res.result.bean];
            }).catch(function () {});
            this.$axios.get('/resumePosition/flowList.api?resumePositionId=' + this.id).then(function (res) {
                _this2.flowList = res.result.list;
            });
        },
        exportFile: function exportFile() {
            window.open(this.$axios.defaults.baseURL + '/resume/exportResumeDetail.api?id=' + this.id + '&token=' + this.$store.state.app.token);
        },
        getStateDirect: function getStateDirect(oldState, newState) {
            if (oldState.length && newState.length) {
                var oldPhase = parseInt(oldState.slice(1, 2)),
                    newPhase = parseInt(newState.slice(1, 2));
                if (oldPhase > newPhase && !(oldPhase === 5 && newPhase === 4)) {
                    return '回退到';
                }
            }
            return '变为';
        }
    },
    created: function created() {
        this.fetchData();
    },

    directives: {
        Sticky: vue_sticky_defaultExport
    },
    components: {
        PersonalModule: views_resumeDetail_personalModule_defaultExport,
        EducationModule: views_resumeDetail_educationModule_defaultExport,
        AttachModule: views_resumeDetail_attachModule_defaultExport,
        ItemModule: views_resumeDetail_itemModule_defaultExport
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fcd2b80e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/resumeDetail/resumeDetail.vue
var resumeDetail_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scope-resume-detail"
  }, [_c('div', {
    staticClass: "fixed-bar"
  }, [_c('div', {
    staticStyle: {
      "margin-left": "230px",
      "margin-right": "30px"
    }
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "space-between",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [(_vm.personalData.name) ? _c('h1', {
    staticClass: "fixed-bar-title pull-left"
  }, [_vm._v(_vm._s(_vm.personalData.name) + " - " + _vm._s(_vm.positionData.name))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pull-left"
  }, [(!_vm.isEdit) ? [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        _vm.isEdit = !_vm.isEdit
      }
    }
  }, [_vm._v("编辑")]), _vm._v(" "), (_vm.showCloseBtn) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": _vm.$win.close
    }
  }, [_vm._v("关闭")]) : _vm._e()] : [_c('el-button', {
    staticClass: "f-edit",
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.submitAll
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    staticClass: "f-edit",
    on: {
      "click": _vm.cancelEdit
    }
  }, [_vm._v("取消")])]], 2)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "end"
    }
  }, [(_vm.from === 'entryList') ? [_c('el-button', {
    attrs: {
      "icon": "el-icon-my-queding color-success",
      "type": "success",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.id, 'pass', null, '入职')
      }
    }
  }, [_vm._v("入职\n                            ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-guanbi color-danger",
      "type": "danger",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.id, 'notPass', null, '毁约')
      }
    }
  }, [_vm._v("毁约\n                            ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-huitui color-info",
      "type": "info",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.id, 'back')
      }
    }
  }, [_vm._v("回退\n                            ")])] : (_vm.from === 'interviewList' || _vm.from === 'resumeList') ? [_c('el-button', {
    attrs: {
      "icon": "el-icon-my-queding color-success",
      "type": "success",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.id, 'pass')
      }
    }
  }, [_vm._v("通过\n                            ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-daiding color-warning",
      "type": "warning",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.id, 'undetermined')
      }
    }
  }, [_vm._v("待定\n                            ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-guanbi color-danger",
      "type": "danger",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.id, 'notPass')
      }
    }
  }, [_vm._v("淘汰\n                            ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-lahei color-purple",
      "type": "purple",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.id, 'lh')
      }
    }
  }, [_vm._v("拉黑\n                            ")]), _vm._v(" "), (_vm.basePath === '/employ') ? _c('el-button', {
    attrs: {
      "icon": "el-icon-my-guanbi color-danger",
      "type": "danger",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.id, 'fq')
      }
    }
  }, [_vm._v("放弃\n                            ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-huitui color-info",
      "type": "info",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.id, 'back')
      }
    }
  }, [_vm._v("回退\n                            ")]), _vm._v(" "), (_vm.basePath === '/employ') ? _c('el-button', {
    attrs: {
      "icon": "el-icon-my-queding color-success",
      "type": "success",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.id, 'entry')
      }
    }
  }, [_vm._v("进入入职\n                            ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-daochu color-info",
      "type": "info",
      "plain": true
    },
    on: {
      "click": _vm.exportFile
    }
  }, [_vm._v("\n                                导出简历\n                            ")])] : (_vm.from === 'paymentList') ? [_c('el-button', {
    attrs: {
      "icon": "el-icon-my-queding color-success",
      "type": "success",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.id, 'pass')
      }
    }
  }, [_vm._v("接受Offer\n                            ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-guanbi color-danger",
      "type": "danger",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.id, 'fq')
      }
    }
  }, [_vm._v("放弃Offer\n                            ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-huitui color-info",
      "type": "info",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.id, 'back')
      }
    }
  }, [_vm._v("回退\n                            ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-lahei color-purple",
      "type": "info",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.id, 'lh')
      }
    }
  }, [_vm._v("拉黑\n                            ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-daochu color-info",
      "type": "info",
      "plain": true
    },
    on: {
      "click": _vm.exportFile
    }
  }, [_vm._v("\n                                导出简历\n                            ")])] : _vm._e()], 2)], 1)], 1)], 1)]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    class: [{
      'form-view': !_vm.isEdit
    }, 'form-switch'],
    attrs: {
      "span": 17
    }
  }, [_c('div', {
    staticClass: "box-shadow-small border-radius"
  }, [_c('personal-module', {
    key: _vm.preventKey + 1,
    ref: "personalModule",
    class: {
      'module-view': !_vm.isEdit
    },
    attrs: {
      "data": _vm.personalData
    }
  }), _vm._v(" "), _c('education-module', {
    key: _vm.preventKey + 2,
    ref: "educationModule",
    class: {
      'module-view': !_vm.isEdit
    },
    attrs: {
      "data": _vm.educationData
    }
  }), _vm._v(" "), _c('item-module', {
    key: _vm.preventKey + 3,
    ref: "workModule",
    class: {
      'module-view': !_vm.isEdit
    },
    attrs: {
      "type": "work",
      "multiple": true,
      "data": _vm.personalData.resumeWorkList
    }
  }), _vm._v(" "), _c('item-module', {
    key: _vm.preventKey + 4,
    ref: "projectModule",
    class: {
      'module-view': !_vm.isEdit
    },
    attrs: {
      "type": "project",
      "multiple": true,
      "data": _vm.personalData.resumeProjectList
    }
  }), _vm._v(" "), _c('item-module', {
    key: _vm.preventKey + 5,
    ref: "skillModule",
    class: {
      'module-view': !_vm.isEdit
    },
    attrs: {
      "type": "skill",
      "multiple": true,
      "data": _vm.personalData.resumeITSkillList
    }
  }), _vm._v(" "), _c('item-module', {
    key: _vm.preventKey + 6,
    ref: "experienceModule",
    class: {
      'module-view': !_vm.isEdit
    },
    attrs: {
      "type": "experience",
      "multiple": true,
      "data": _vm.personalData.resumeGameExperienceList
    }
  }), _vm._v(" "), _c('attach-module', {
    ref: "attachModule",
    class: {
      'module-view': !_vm.isEdit
    },
    attrs: {
      "data": _vm.attachData,
      "rid": _vm.rid
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('div', {
    staticClass: "box-shadow-small border-radius"
  }, [_c('div', {
    staticClass: "flow-step-module"
  }, [_c('h1', {
    staticClass: "module-title"
  }, [_vm._v("操作流转记录")]), _vm._v(" "), _c('div', {
    staticClass: "mt-20 flow-lists scrollbar-beauty"
  }, [(_vm.flowList.length) ? _c('el-steps', {
    attrs: {
      "space": 100,
      "direction": "vertical"
    }
  }, _vm._l((_vm.flowList), function(item, index) {
    return _c('el-step', {
      key: index,
      attrs: {
        "title": "",
        "icon": "el-icon-self-circle-icon"
      }
    }, [_c('div', {
      staticClass: "flow-info-box",
      attrs: {
        "slot": "description"
      },
      slot: "description"
    }, [(item.newPositionName || item.positionName) ? _c('p', {
      staticClass: "title"
    }, [_vm._v("\n                                        职位从 "), _c('span', {
      staticStyle: {
        "color": "#8c939d"
      }
    }, [_vm._v(_vm._s(item.positionName))]), _vm._v(" 变为 "), _c('span', {
      staticClass: "color-primary"
    }, [_vm._v(_vm._s(item.newPositionName))])]) : _c('p', {
      staticClass: "title"
    }, [_vm._v("\n                                        从 "), _c('span', {
      staticStyle: {
        "color": "#8c939d"
      }
    }, [_vm._v(_vm._s(_vm.getSelectMapText('WB_FLOW_STATUS', item.oldStatus) || '无'))]), _vm._v("\n                                        " + _vm._s(_vm.getStateDirect(item.oldStatus, item.newStatus)) + " "), _c('span', {
      staticClass: "color-success"
    }, [_vm._v(_vm._s(_vm.getSelectMapText('WB_FLOW_STATUS', item.newStatus)))])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix ext-info",
      staticStyle: {
        "width": "100%"
      }
    }, [_c('p', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v(_vm._s(item.operateTime))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v("操作者：" + _vm._s(item.operatUser.name))])])])])
  }), 1) : _c('div', {
    staticStyle: {
      "color": "#c4c4c4",
      "text-align": "center"
    }
  }, [_vm._v("\n                            暂无数据\n                        ")])], 1)])])])], 1)], 1)
}
var resumeDetail_staticRenderFns = []
var resumeDetail_esExports = { render: resumeDetail_render, staticRenderFns: resumeDetail_staticRenderFns }
/* harmony default export */ var resumeDetail_resumeDetail_defaultExport = (resumeDetail_esExports);
// CONCATENATED MODULE: ./src/views/resumeDetail/resumeDetail.vue
function resumeDetail_injectStyle (ssrContext) {
  __webpack_require__(817)
}
var resumeDetail_normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var resumeDetail___vue_styles__ = resumeDetail_injectStyle
/* scopeId */
var resumeDetail___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var resumeDetail___vue_module_identifier__ = null
var resumeDetail_Component = resumeDetail_normalizeComponent(
  resumeDetail_defaultExport,
  resumeDetail_resumeDetail_defaultExport,
  resumeDetail___vue_styles__,
  resumeDetail___vue_scopeId__,
  resumeDetail___vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (resumeDetail_Component.exports);


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(818);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("2a71d6c6", content, true);

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".scope-resume-detail{margin-top:50px}.scope-resume-detail .fixed-bar{padding:10px 0;position:fixed;left:0;z-index:9;width:100%;top:60px;background:rgba(36,129,255,.6)}.scope-resume-detail .fixed-bar .fixed-bar-title{line-height:36px;font-size:16px;color:#fff;margin-right:30px}.scope-resume-detail .item-divider{position:relative;padding-top:20px}.scope-resume-detail .item-divider:not(:last-child){margin-bottom:10px;border-bottom:1px solid #e2e7eb}.scope-resume-detail .item-divider .remove-btn{position:absolute;right:0;top:10px}.scope-resume-detail .module-title{font-size:18px;border-bottom:1px solid #f2f5f9;padding-bottom:5px;margin-bottom:5px}.scope-resume-detail .resume-item-module{padding:30px 0 0}.scope-resume-detail .resume-item-module .form-switch{padding:20px 0}.scope-resume-detail .resume-item-module.module-view{padding:30px 30px 0!important}.scope-resume-detail .resume-item-module.module-view .form-switch{padding:20px 140px!important}.scope-resume-detail .flow-step-module{padding:30px 15px;min-width:300px}.scope-resume-detail .flow-step-module .flow-lists{height:600px;overflow-y:auto}.scope-resume-detail .flow-step-module .el-step__head{width:20px;height:20px;line-height:20px}.scope-resume-detail .flow-step-module .el-step__main{width:80%}.scope-resume-detail .flow-step-module .el-step__line.is-vertical{left:9px;top:18px}.scope-resume-detail .flow-step-module .el-step__line-inner{display:none}.scope-resume-detail .flow-step-module .el-step__icon{width:100%;height:100%}.scope-resume-detail .flow-step-module .el-icon-self-circle-icon{background:#c7d9ed;border-radius:200%;display:block;width:100%;height:100%;position:relative}.scope-resume-detail .flow-step-module .el-step__icon:after{display:block;width:10px;height:10px;background:#fff;position:absolute;left:5px;top:5px;z-index:2;content:\"\";border-radius:200%}.scope-resume-detail .flow-step-module .flow-info-box{border:1px solid #e2e7eb;max-width:300px;padding:5px 10px;box-sizing:border-box;line-height:28px;border-radius:5px}.scope-resume-detail .flow-step-module .flow-info-box .title{font-size:14px;color:#666}.scope-resume-detail .flow-step-module .flow-info-box .ext-info{color:#c7d9ed}.scope-resume-detail .flow-step-module .el-step:last-child .el-icon-self-circle-icon{background:#2481ff}", ""]);

// exports


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(820);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("2d7c1586", content, true);

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(822);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("6c31ba88", content, true);

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".form-personal{position:relative}.form-personal .toggle-line{margin:6px 0}.form-personal .toggle-line .toggle-trigger{width:100%}.form-personal .toggle-line .toggle-trigger .el-icon-arrow-down{transition:transform .2s ease}.form-personal .toggle-line .toggle-trigger .turn-around{transform:rotate(180deg)}", ""]);

// exports


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(824);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("c82ddba0", content, true);

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(826);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("1870f3ee", content, true);

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(828);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("67dd40ee", content, true);

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(830);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("312953c0", content, true);

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/arrangement/arrangement.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_thumbnail__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__arrangementItem_vue__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__operation_interviewerEmailDialog__ = __webpack_require__(353);







/* harmony default export */ var arrangement_defaultExport = ({
    components: {
        Thumbnail: __WEBPACK_IMPORTED_MODULE_1_components_thumbnail__["a" /* default */], ArrangementItem: __WEBPACK_IMPORTED_MODULE_2__arrangementItem_vue__["a" /* default */], EmailSender: __WEBPACK_IMPORTED_MODULE_3__operation_interviewerEmailDialog__["a" /* default */]
    },
    data: function data() {
        return {
            urls: {
                fetch: '/resumePosition/interviewArrange/list.api'
            },
            interviewObject: {
                interviewDate: new Date(),
                interviewType: null,
                interviewer: null,
                interviewerUsers: [],
                isHr: '',
                interviewPlace: ''
            },
            baseInfo: {},
            baseData: {} };
    },

    computed: {
        id: function id() {
            return this.$route.params.id;
        }
    },
    methods: {
        fetchData: function fetchData() {
            var _this = this;

            this.$axios.get(this.urls.fetch, {
                params: {
                    resumePositionId: this.id
                }
            }).then(function (res) {
                _this.baseInfo = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, res.result.resume, {
                    positionName: res.result.position.name,
                    deptNames: res.result.position.deptNames
                });
                res.result.list.forEach(function (form) {
                    form.turnType = [form.turn, form.isHr].join(',');
                });
                _this.baseData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, res.result, {
                    id: _this.id
                });
                _this.result = res.result;
            }).catch(function () {});
        },
        sendEmail: function sendEmail(data, type) {
            var ids = [];
            var users = {};
            data.forEach(function (item) {
                ids.push(item.id);
                var masterIds = item.masterInterviewer.split(','),
                    masterNames = item.masterInterviewerNames.split('，'),
                    interviewIds = item.interviewer.split(','),
                    interviewNames = item.interviewerNames.split('，');
                item.interviewerUsers = [];
                if (item.masterInterviewer !== '') {
                    masterIds.forEach(function (mid, mindex) {
                        users[mid] = masterNames[mindex];
                        item.interviewerUsers.push({
                            id: mid,
                            name: masterNames[mindex]
                        });
                    });
                }
                if (item.interviewer !== '') {
                    interviewIds.forEach(function (iid, iindex) {
                        users[iid] = interviewNames[iindex];
                        item.interviewerUsers.push({
                            id: iid,
                            name: interviewNames[iindex]
                        });
                    });
                }
            });
            this.$refs.sendEmail.show({
                ids: this.baseData.id,
                interviewIds: ids.join(','),
                selecteds: data,
                resumePositionList: [this.result],
                phase: 2,
                userAttributes: type
            });
        }
    },
    created: function created() {
        this.fetchData();
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a00768f"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/arrangement/arrangement.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scope-arrangement-setting"
  }, [_c('div', {
    staticClass: "box-shadow-small border-radius"
  }, [_c('div', {}, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "mb-15"
  }, [_c('thumbnail', {
    attrs: {
      "text": _vm.baseInfo.name,
      "gender": _vm.baseInfo.gender === 1 ? 'man' : 'woman',
      "font-size": 16,
      "width": 110
    }
  }), _vm._v(" "), _c('el-row', {
    staticClass: "mt-10 text-center",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("应聘职位：" + _vm._s(_vm.baseInfo.positionName))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("应聘部门：" + _vm._s(_vm.baseInfo.deptNames))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("手机号：" + _vm._s(_vm.baseInfo.mobilePhone))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mt-20"
  }, [_c('el-row', {
    staticClass: "arrangement-list"
  }, [_c('arrangement-item', {
    ref: "arrangement",
    attrs: {
      "init": _vm.baseData
    },
    on: {
      "sendEmail": _vm.sendEmail
    }
  })], 1)], 1)]), _vm._v(" "), _c('email-sender', {
    ref: "sendEmail"
  })], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "clearfix mt-15 ml-20"
  }, [_c('strong', [_vm._v("面试安排")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var arrangement_arrangement_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/views/arrangement/arrangement.vue
function injectStyle (ssrContext) {
  __webpack_require__(832)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  arrangement_defaultExport,
  arrangement_arrangement_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(833);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("73f05a32", content, true);

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".scope-arrangement-setting .grey-line{position:absolute;height:100%;width:1px;background:#f4f4f3;padding:60px 0;box-sizing:border-box;left:83px}.scope-arrangement-setting .arrangement-first .grey-line{margin-top:50px}.scope-arrangement-setting .arrangement-last .grey-line{margin-top:-100px}.scope-arrangement-setting .c-text-banner.page-banner{background:url(" + __webpack_require__(230) + ") no-repeat;height:105px;position:relative}.scope-arrangement-setting .c-text-banner.page-banner h3{color:#fff;width:500px;font-size:20px;margin:0 0 0 80px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.scope-arrangement-setting .c-text-banner.page-banner .photo-img{display:inline-block;width:80px;height:80px;border-radius:100%;position:absolute}.scope-arrangement-setting .c-text-banner.page-banner .text-area-right{width:650px;top:30px;position:static;margin-left:110px;margin-top:20px}.scope-arrangement-setting .c-text-banner.page-banner .text-area-left{position:static}.scope-arrangement-setting .c-text-banner.page-banner .text-area{top:12px}.scope-arrangement-setting .top-handler-wpr{padding-top:10px;padding-bottom:10px}.scope-arrangement-setting .arrangement-list{margin-bottom:50px}.scope-arrangement-setting .arrangement-list .parse-name{width:60px;height:60px;margin-top:45px;border:2px solid #2481ff;color:#2481ff;border-radius:100%;text-align:center;line-height:60px;font-size:16px;display:inline-block;z-index:2;background:#fff;position:relative}.scope-arrangement-setting .arrangement-list .handler-btns{text-align:center}.scope-arrangement-setting .arrangement-list .arrangement-item{position:relative}.scope-arrangement-setting .arrangement-list .arrangement-item .el-form-item{margin-bottom:0}.scope-arrangement-setting .arrangement-list .arrangement-item .el-form-item__label{color:#888}.scope-arrangement-setting .arrangement-list .arrangement-item .name{color:#888;margin-right:15px;display:inline-block;width:70px;text-align:right}.scope-arrangement-setting .arrangement-list .arrangement-item .date-item input,.scope-arrangement-setting .arrangement-list .arrangement-item .way-item input{width:190px}.scope-arrangement-setting .arrangement-list .arrange-phase{text-align:center}.scope-arrangement-setting .arrangement-list .interview-one{height:50px;line-height:50px}.scope-arrangement-setting .arrangement-list .arrange-info-wpr{border:1px solid #e2e7eb;width:800px;margin:20px 0;border-radius:5px}.scope-arrangement-setting .arrangement-list .arrange-info-wpr .arrange-info{padding:25px}.scope-arrangement-setting .edit-state .arrange-info-wpr .arrange-info{padding:16px 25px}.scope-arrangement-setting .edit-state .parse-name{color:#333;border-color:#bfcbd9}.scope-arrangement-setting .edit-state .handler-btns{line-height:80px}", ""]);

// exports


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(835);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("54fc9629", content, true);

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".scope-arrangement-item{margin-top:10px}.scope-arrangement-item .img-wpr img{width:72px;height:72px;border-radius:100%}.scope-arrangement-item .dept-name{color:#333;font-size:14px;margin-left:20px}.scope-arrangement-item .dept-name.multi-info{font-weight:400;color:#999}.scope-arrangement-item .top-info{padding:15px 13px;color:#333}.scope-arrangement-item .top-info .name{font-size:16px;font-weight:700}.scope-arrangement-item .el-table__header div,.scope-arrangement-item .el-table__header th{background:#fafafa}.scope-arrangement-item .el-date-editor.el-input{width:165px}.scope-arrangement-item .el-table .cell{padding-left:10px;padding-right:10px}.scope-arrangement-item .user-type{width:18px;height:18px;text-align:center;line-height:18px;color:#fff;font-size:12px;background:#11b970;display:inline-block;border-radius:3px;margin-right:5px;vertical-align:text-bottom}.scope-arrangement-item .user-type.user-main{background:#61a4ff}.scope-arrangement-item .text-ellipsis{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.scope-arrangement-item .text-ellipsis a,.scope-arrangement-item .text-ellipsis span{overflow:hidden}", ""]);

// exports


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(837);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("405b1052", content, true);

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "p i.icon[data-v-36259975]{width:16px;height:19px;margin-right:5px;display:inline-block;vertical-align:middle;background:url(" + __webpack_require__(838) + ") no-repeat 0 0}p i.icon-phone[data-v-36259975]{background-position:0 0}p i.icon-list[data-v-36259975]{background-position:0 -36px}p i.icon-email[data-v-36259975]{background-position:0 -69px}p i.icon-clock[data-v-36259975]{background-position:0 -104px}p i.icon-white-phone[data-v-36259975]{background-position:0 -138px}p i.pointer[data-v-36259975]{cursor:pointer}p .icon-text[data-v-36259975]{word-break:break-all}", ""]);

// exports


/***/ }),
/* 838 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(840);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("41fc53aa", content, true);

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".button-inline[data-v-268a567c]{display:inline-block}", ""]);

// exports


/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(842);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("511ae42e", content, true);

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".scoped-interivew-email .user-tag{cursor:pointer;margin:5px}.scoped-interivew-email .user-tag.disabled{text-decoration:line-through;background:#ddd;color:#fff;border-color:transparent}.scoped-interivew-email .previewView{overflow:auto;height:520px}.scoped-interivew-email .quickTool .el-tag{cursor:pointer;margin-right:5px}.scoped-interivew-email .dialog-footer button{width:150px}", ""]);

// exports


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(844);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("41802e86", content, true);

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".user-selects-group-wpr{position:relative}.user-selects-group-wpr .group-btn,.user-selects-group-wpr .save-to-group{position:absolute;right:60px;top:13px;z-index:2;font-size:12px;color:#ddd;cursor:pointer}.user-selects-group-wpr .group-btn:hover,.user-selects-group-wpr .save-to-group:hover{color:#20a0ff}.user-selects-group-wpr .save-to-group{right:35px}.group-info{color:red;position:absolute;top:40px;width:100%;z-index:10000;box-shadow:1px 1px 1px #ddd}.group-info .el-table tr{cursor:pointer}.group-info .el-table tr td,.group-info .el-table tr th{height:34px}.group-info .el-table tr td .cell,.group-info .el-table tr th .cell{border-right:none;border-left:none;text-align:left}.group-info .el-tag{margin:5px 5px 5px 0}", ""]);

// exports


/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(846);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("dc1c3f12", content, true);

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".simditor-wrapper .simditor .simditor-body{padding:10px;min-height:150px;max-height:300px;overflow:auto}.simditor-wrapper .simditor .simditor-body::-webkit-scrollbar{width:10px;height:10px;background-color:#eee}.simditor-wrapper .simditor .simditor-body::-webkit-scrollbar-track{background-color:#eee}.simditor-wrapper .simditor .simditor-body::-webkit-scrollbar-thumb{height:10px;background-color:#ddd}.simditor-wrapper .simditor .simditor-body div,.simditor-wrapper .simditor .simditor-body p{margin-bottom:5px}.simditor-wrapper .simditor .simditor-body ol{list-style-type:decimal}.simditor-wrapper .simditor .simditor-body ul{list-style-type:disc}.simditor-wrapper .simditor .simditor-body li{list-style:inherit}.simditor-wrapper .simditor .simditor-wrapper .simditor-placeholder{padding:10px}", ""]);

// exports


/***/ }),
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/evaluation/resume.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_thumbnail__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__society_form_society_form__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mixins_selectMapMixin__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_views_common_empty__ = __webpack_require__(121);







/* harmony default export */ var resume_defaultExport = ({
    components: {
        Thumbnail: __WEBPACK_IMPORTED_MODULE_0_components_thumbnail__["a" /* default */], SocietyForm: __WEBPACK_IMPORTED_MODULE_1__society_form_society_form__["a" /* default */], EmptyTip: __WEBPACK_IMPORTED_MODULE_3_views_common_empty__["a" /* default */]
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_2_mixins_selectMapMixin__["a" /* default */]],
    data: function data() {
        return {
            baseInfo: null,
            evaInfo: null,
            formKey: 1,
            showEdit: false,
            interviews: [],
            turn: null,
            dialogVisible: false,
            interviewInfo: {
                interviewArrangeId: null,
                evaluator: ''
            },
            dialogInfo: {
                extInfo: ''
            },
            form: {
                status: '',
                content: ''
            }
        };
    },
    created: function created() {
        this.getPhaseInfo();
        this.getEvaList();
    },

    methods: {
        getPhaseInfo: function getPhaseInfo() {
            var _this = this;

            this.$axios.post('/resumePosition/interviewArrange/getListWithOutEva.api', { resumePositionId: this.$route.params.id }).then(function (res) {
                _this.baseInfo = res.result;
            });
        },
        getEvaList: function getEvaList() {
            var _this2 = this;

            this.$axios.get('/resume/getResumeEvaList.api?resumePositionId=' + this.$route.params.id).then(function (res) {
                _this2.evaInfo = res.result;
            });
        },
        refresh: function refresh() {
            this.getEvaList();
        },
        cancelEdit: function cancelEdit() {
            this.showEdit = false;
        },
        showEditPopup: function showEditPopup(item) {
            var _this3 = this;

            this.dialogInfo.extInfo = {};
            this.dialogVisible = true;

            this.$nextTick(function () {
                _this3.$refs.updateForm.$refs.form.$data.updateUrl = '/resume/updateEvaluation.api';
                _this3.$refs.updateForm.setForm(item);
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef5f5d2c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/evaluation/resume.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "evaluation-scoped evaluation-resume-scoped container"
  }, [(_vm.baseInfo) ? _c('div', {
    staticClass: "resume-doc-wpr box-shadow-small border-radius"
  }, [_c('div', {
    staticStyle: {
      "padding-top": "30px"
    }
  }, [_c('div', {
    staticClass: "mb-15"
  }, [_c('thumbnail', {
    attrs: {
      "text": _vm.baseInfo.resume.name,
      "gender": _vm.baseInfo.resume.gender == 1 ? 'man' : 'woman',
      "font-size": 16,
      "width": 110
    }
  }), _vm._v(" "), _c('el-row', {
    staticClass: "mt-10 text-center",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("应聘职位：" + _vm._s(_vm.baseInfo.position.name))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("应聘部门：" + _vm._s(_vm.baseInfo.position.deptNames))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("手机号：" + _vm._s(_vm.baseInfo.resume.mobilePhone))])], 1)], 1)]), _vm._v(" "), (_vm.evaInfo && !_vm.evaInfo.list.length) ? _c('div', [_c('empty-tip')], 1) : _c('div', {
    staticClass: "resume-doc"
  }, [(_vm.evaInfo && _vm.evaInfo.list.length) ? _c('div', {
    staticClass: "history-form"
  }, _vm._l((_vm.evaInfo.list), function(item, index) {
    return _c('el-table', {
      key: index,
      staticClass: "evaluation-item",
      attrs: {
        "row-class-name": "evaluate-row",
        "show-header": false,
        "data": [{}]
      }
    }, [_c('el-table-column', {
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('div', {
            staticClass: "evaluate-row"
          }, [_c('div', {
            staticClass: "isView"
          }, [_c('el-row', {
            staticClass: "mt-15"
          }, [_c('el-col', {
            attrs: {
              "span": 8
            }
          }, [_c('span', {
            staticClass: "txt-label"
          }, [_vm._v("简历筛选结果：")]), _vm._v(_vm._s(_vm.getSelectMapText('WB_USER_VIEWPOINT', item.userViewpoint)) + "\n                                        ")])], 1), _vm._v(" "), _c('el-row', {
            staticClass: "mt-15"
          }, [_c('el-col', {
            attrs: {
              "span": 8
            }
          }, [_c('span', {
            staticClass: "txt-label"
          }, [_vm._v("简历筛选人：")]), _vm._v(_vm._s(item.evaluationUser ? item.evaluationUser.name : '') + "\n                                        ")]), _vm._v(" "), _c('el-col', {
            attrs: {
              "span": 8
            }
          }, [_c('span', {
            staticClass: "txt-label"
          }, [_vm._v("时间：")]), _vm._v(_vm._s(item.evaluateTime) + "\n                                        ")])], 1), _vm._v(" "), _c('el-row', {
            staticClass: "mt-15 mb-15"
          }, [_c('el-col', [_c('span', {
            staticClass: "txt-label"
          }, [_vm._v("评价：")]), _vm._v(" "), _c('pre', {
            staticClass: "multi-row-content"
          }, [_vm._v(_vm._s(item.content))])])], 1), _vm._v(" "), _c('el-button', {
            staticStyle: {
              "float": "right",
              "margin-bottom": "10px"
            },
            attrs: {
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.showEditPopup(item)
              }
            }
          }, [_vm._v("编辑")])], 1)])]
        }
      }], null, true)
    })], 1)
  }), 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "修改评价",
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [(_vm.dialogInfo && _vm.baseInfo && _vm.evaInfo) ? _c('div', {
    staticClass: "isEdit"
  }, [_c('society-form', {
    ref: "updateForm",
    attrs: {
      "isSimple": _vm.evaInfo.isSimple,
      "isEdit": true,
      "isFull": false,
      "extInfo": _vm.dialogInfo.extInfo,
      "scoreType": "",
      "recruitType": ""
    },
    on: {
      "refresh": _vm.refresh,
      "cancel": function($event) {
        _vm.dialogVisible = false
      }
    }
  })], 1) : _vm._e()])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var evaluation_resume_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/views/evaluation/resume.vue
function injectStyle (ssrContext) {
  __webpack_require__(852)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  resume_defaultExport,
  evaluation_resume_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(853);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("71d53a52", content, true);

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".scoped-evaluation-society{padding:0}.evaluation-scoped .top-nav{position:absolute;width:200px;top:0;z-index:200;background-color:transparent;left:46%}.evaluation-scoped .top-nav .title{position:absolute;left:10px;font-size:18px;color:#fff;border-bottom:0}.evaluation-scoped .top-nav .title:hover{border-bottom:0}.evaluation-scoped .resume-top-bar{background:#fff;height:80px;line-height:80px}.evaluation-scoped .resume-top-bar .resume-top{width:1200px;margin:0 auto}.evaluation-scoped .resume-top-bar .top-user-info{width:50%;float:left;text-align:left;position:relative}.evaluation-scoped .resume-top-bar .top-user-info .user-name{font-size:18px;font-weight:700;margin-top:10px}.evaluation-scoped .resume-top-bar .top-user-info .round-image{position:absolute;top:10px}.evaluation-scoped .resume-top-bar .top-user-info .thumbnail-text{display:inline-block;margin-left:80px}.evaluation-scoped .resume-top-bar .top-user-info .thumbnail-text p{height:30px;line-height:30px}.evaluation-scoped .button-footer{text-align:center;margin:20px}.evaluation-scoped .multi-row-content{display:inline-block;vertical-align:top;margin:0;word-break:break-all;width:795px;word-wrap:break-word;white-space:pre-wrap}.evaluation-scoped .history-form{margin-bottom:50px}.evaluation-scoped .history-form .evaluate-row{color:#333}.evaluation-scoped .history-form .evaluate-row:hover td{background:none}.evaluation-scoped .history-form .evaluate-row:hover .name-td{background:#f6f9fc}.evaluation-scoped .history-form .txt-label{font-weight:700}.evaluation-scoped .history-form .name-td{background:#f6f9fc;text-align:center;border-right:1px solid #dfe3ec;font-weight:700}.evaluation-scoped .history-form .evaluation-item{margin-top:-1px}.evaluation-resume-scoped .mask-tip{position:absolute;left:0;top:0;background:rgba(0,0,0,.1);text-align:center;width:100%;height:100%;z-index:20}.evaluation-resume-scoped .mask-tip p{position:absolute;width:100%;top:48%}.evaluation-resume-scoped .evaluate-row{position:relative;padding:10px 0}", ""]);

// exports


/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(855);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("20fb5742", content, true);

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".evaluation-form-scoped .el-form-item{border:1px solid #ddd;padding:0;margin:0;position:relative;margin-top:-1px;background:#f6f9fc}.evaluation-form-scoped .el-form-item .el-form-item__label{position:absolute;top:50%;margin-top:-18px;text-align:center;font-weight:700}.evaluation-form-scoped .el-form-item .el-form-item__content{padding:10px;background:#fff;border-left:1px solid #dfe3ec}.evaluation-form-scoped .el-form-item .el-textarea{height:100px}.evaluation-form-scoped .el-form-item .el-textarea textarea{height:100%;border:0;resize:none}.evaluation-form-scoped .el-form-item .el-input__inner{border:0}.evaluation-form-scoped .inner-td{background:#f6f9fc;text-align:center;font-weight:700;border-left:1px solid #dfe3ec;border-right:1px solid #dfe3ec}.evaluation-form-scoped .inner-row .el-form-item__content{border-left:0;padding:0}.evaluation-form-scoped .inner-row .el-form-item__content .el-col{height:120px;line-height:120px}.evaluation-form-scoped .inner-row .el-form-item__content .el-col textarea{height:120px}.evaluation-form-scoped .inner-row .el-form-item__content .el-col .el-radio-group.score-group{width:100%}.evaluation-form-scoped .inner-row .el-form-item__content .el-col .el-radio.score-item{width:20%;text-align:center}.evaluation-form-scoped .inner-row .el-form-item__content .el-col .el-radio.score-item+.el-radio{margin-left:0}", ""]);

// exports


/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(857);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("6ef107e3", content, true);

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports
exports.i(__webpack_require__(858), "");

// module
exports.push([module.i, ".score-tip-popper{position:absolute;background:#fff;z-index:9;top:57px;left:0;box-shadow:1px 1px 1px #ddd;border-radius:5px}.score-tip-popper .tips-pop-table td,.score-tip-popper .tips-pop-table th{border:1px solid #ddd;padding:5px}.score-tip-popper .tips-pop-table .fb{font-weight:700}.score-tip-popper .tip-head{width:1140px}.score-tip-popper .tip-body{width:1140px;height:600px;overflow-y:auto}.scoped-scoreTips{width:1140px;position:static;margin:40px auto;padding:20px;border-top:none}.scoped-scoreTips .tips-pop-table{position:relative}.scoped-scoreTips .tips-pop-table .tip-head{background:#fff;width:1141px}.scoped-scoreTips .tips-pop-table .tip-head tr{width:100%;border-top:1px solid #ddd}.scoped-scoreTips .tips-pop-table .tip-head th{border-top:none}.scoped-scoreTips .tips-pop-table .tip-body{width:1140px;height:calc(100vh - 140px);overflow-y:auto;border-bottom:1px solid #ddd}", ""]);

// exports


/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".red{color:red}.blue{color:#339}.green{color:#396}.yellow{color:#f90}.orange{color:#c65911}.black{color:#000}.rule-detail{font-size:12px}", ""]);

// exports


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(860);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("5d97d527", content, true);

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".evaluation-tips{background:#f3fefd;border:1px solid #abe5dc;margin:30px 0;padding:15px}.evaluation-tips .point{font-weight:700;margin:5px 0}.evaluation-tips li{color:#333;padding:5px 0}.evaluation-tips li i{display:inline-block;width:6px;height:6px;background:#27c9b4;margin-right:10px;border-radius:100%;position:relative;top:-2px}.evaluation-tips .em{color:red}", ""]);

// exports


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(862);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("59ba3374", content, true);

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".evaluation-form-scoped .el-form-item{border:1px solid #ddd;padding:0;margin:0;position:relative;margin-top:-1px;background:#f6f9fc}.evaluation-form-scoped .el-form-item .el-form-item__label{position:absolute;top:50%;margin-top:-18px;text-align:center;font-weight:700}.evaluation-form-scoped .el-form-item .el-form-item__content{padding:10px;background:#fff;border-left:1px solid #dfe3ec}.evaluation-form-scoped .el-form-item .el-textarea{height:100px}.evaluation-form-scoped .el-form-item .el-textarea textarea{height:100%;border:0;resize:none}.evaluation-form-scoped .el-form-item .el-input__inner{border:0}.evaluation-form-scoped .inner-td{background:#f6f9fc;text-align:center;font-weight:700;border-left:1px solid #dfe3ec;border-right:1px solid #dfe3ec}.evaluation-form-scoped .inner-row .el-form-item__content{border-left:0;padding:0}.evaluation-form-scoped .inner-row .el-form-item__content .el-col{height:120px;line-height:120px}.evaluation-form-scoped .inner-row .el-form-item__content .el-col textarea{height:120px}.evaluation-form-scoped .inner-row .el-form-item__content .el-col .el-radio-group.score-group{width:100%}.evaluation-form-scoped .inner-row .el-form-item__content .el-col .el-radio.score-item{width:20%;text-align:center}.evaluation-form-scoped .inner-row .el-form-item__content .el-col .el-radio.score-item+.el-radio{margin-left:0}", ""]);

// exports


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(864);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("4c025cef", content, true);

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".evaluation-form-scoped .el-form-item{border:1px solid #ddd;padding:0;margin:0;position:relative;margin-top:-1px;background:#f6f9fc}.evaluation-form-scoped .el-form-item .el-form-item__label{position:absolute;top:50%;margin-top:-18px;text-align:center;font-weight:700}.evaluation-form-scoped .el-form-item .el-form-item__content{padding:10px;background:#fff;border-left:1px solid #dfe3ec}.evaluation-form-scoped .el-form-item .el-textarea{height:100px}.evaluation-form-scoped .el-form-item .el-textarea textarea{height:100%;border:0;resize:none}.evaluation-form-scoped .el-form-item .el-input__inner{border:0}.evaluation-form-scoped .inner-td{background:#f6f9fc;text-align:center;font-weight:700;border-left:1px solid #dfe3ec;border-right:1px solid #dfe3ec}.evaluation-form-scoped .inner-row .el-form-item__content{border-left:0;padding:0}.evaluation-form-scoped .inner-row .el-form-item__content .el-col{height:120px;line-height:120px}.evaluation-form-scoped .inner-row .el-form-item__content .el-col textarea{height:120px}.evaluation-form-scoped .inner-row .el-form-item__content .el-col .el-radio-group.score-group{width:100%}.evaluation-form-scoped .inner-row .el-form-item__content .el-col .el-radio.score-item{width:20%;text-align:center}.evaluation-form-scoped .inner-row .el-form-item__content .el-col .el-radio.score-item+.el-radio{margin-left:0}", ""]);

// exports


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(866);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("c6a45040", content, true);

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".evaluation-form-scoped .el-form-item{border:1px solid #ddd;padding:0;margin:0;position:relative;margin-top:-1px;background:#f6f9fc}.evaluation-form-scoped .el-form-item .el-form-item__label{position:absolute;top:50%;margin-top:-18px;text-align:center;font-weight:700}.evaluation-form-scoped .el-form-item .el-form-item__content{padding:10px;background:#fff;border-left:1px solid #dfe3ec}.evaluation-form-scoped .el-form-item .el-textarea{height:100px}.evaluation-form-scoped .el-form-item .el-textarea textarea{height:100%;border:0;resize:none}.evaluation-form-scoped .el-form-item .el-input__inner{border:0}.evaluation-form-scoped .inner-td{background:#f6f9fc;text-align:center;font-weight:700;border-left:1px solid #dfe3ec;border-right:1px solid #dfe3ec}.evaluation-form-scoped .inner-row .el-form-item__content{border-left:0;padding:0}.evaluation-form-scoped .inner-row .el-form-item__content .el-col{height:120px;line-height:120px}.evaluation-form-scoped .inner-row .el-form-item__content .el-col textarea{height:120px}.evaluation-form-scoped .inner-row .el-form-item__content .el-col .el-radio-group.score-group{width:100%}.evaluation-form-scoped .inner-row .el-form-item__content .el-col .el-radio.score-item{width:20%;text-align:center}.evaluation-form-scoped .inner-row .el-form-item__content .el-col .el-radio.score-item+.el-radio{margin-left:0}", ""]);

// exports


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(868);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("27279b70", content, true);

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".evaluation-form-scoped .el-form-item{border:1px solid #ddd;padding:0;margin:0;position:relative;margin-top:-1px;background:#f6f9fc}.evaluation-form-scoped .el-form-item .el-form-item__label{position:absolute;top:50%;margin-top:-18px;text-align:center;font-weight:700}.evaluation-form-scoped .el-form-item .el-form-item__content{padding:10px;background:#fff;border-left:1px solid #dfe3ec}.evaluation-form-scoped .el-form-item .el-textarea{height:100px}.evaluation-form-scoped .el-form-item .el-textarea textarea{height:100%;border:0;resize:none}.evaluation-form-scoped .el-form-item .el-input__inner{border:0}.evaluation-form-scoped .inner-td{background:#f6f9fc;text-align:center;font-weight:700;border-left:1px solid #dfe3ec;border-right:1px solid #dfe3ec}.evaluation-form-scoped .inner-row .el-form-item__content{border-left:0;padding:0}.evaluation-form-scoped .inner-row .el-form-item__content .el-col{height:120px;line-height:120px}.evaluation-form-scoped .inner-row .el-form-item__content .el-col textarea{height:120px}.evaluation-form-scoped .inner-row .el-form-item__content .el-col .el-radio-group.score-group{width:100%}.evaluation-form-scoped .inner-row .el-form-item__content .el-col .el-radio.score-item{width:20%;text-align:center}.evaluation-form-scoped .inner-row .el-form-item__content .el-col .el-radio.score-item+.el-radio{margin-left:0}", ""]);

// exports


/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(870);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("24d9ab9f", content, true);

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".evaluation-form-scoped .el-form-item{border:1px solid #ddd;padding:0;margin:0;position:relative;margin-top:-1px;background:#f6f9fc}.evaluation-form-scoped .el-form-item .el-form-item__label{position:absolute;top:50%;margin-top:-18px;text-align:center;font-weight:700}.evaluation-form-scoped .el-form-item .el-form-item__content{padding:10px;background:#fff;border-left:1px solid #dfe3ec}.evaluation-form-scoped .el-form-item .el-textarea{height:100px}.evaluation-form-scoped .el-form-item .el-textarea textarea{height:100%;border:0;resize:none}.evaluation-form-scoped .el-form-item .el-input__inner{border:0}.evaluation-form-scoped .inner-td{background:#f6f9fc;text-align:center;font-weight:700;border-left:1px solid #dfe3ec;border-right:1px solid #dfe3ec}.evaluation-form-scoped .inner-row .el-form-item__content{border-left:0;padding:0}.evaluation-form-scoped .inner-row .el-form-item__content .el-col{height:120px;line-height:120px}.evaluation-form-scoped .inner-row .el-form-item__content .el-col textarea{height:120px}.evaluation-form-scoped .inner-row .el-form-item__content .el-col .el-radio-group.score-group{width:100%}.evaluation-form-scoped .inner-row .el-form-item__content .el-col .el-radio.score-item{width:20%;text-align:center}.evaluation-form-scoped .inner-row .el-form-item__content .el-col .el-radio.score-item+.el-radio{margin-left:0}", ""]);

// exports


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(872);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("4322d738", content, true);

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".evaluation-form-scoped .el-form-item{border:1px solid #ddd;padding:0;margin:0;position:relative;margin-top:-1px;background:#f6f9fc}.evaluation-form-scoped .el-form-item .el-form-item__label{position:absolute;top:50%;margin-top:-18px;text-align:center;font-weight:700}.evaluation-form-scoped .el-form-item .el-form-item__content{padding:10px;background:#fff;border-left:1px solid #dfe3ec}.evaluation-form-scoped .el-form-item .el-textarea{height:100px}.evaluation-form-scoped .el-form-item .el-textarea textarea{height:100%;border:0;resize:none}.evaluation-form-scoped .el-form-item .el-input__inner{border:0}.evaluation-form-scoped .inner-td{background:#f6f9fc;text-align:center;font-weight:700;border-left:1px solid #dfe3ec;border-right:1px solid #dfe3ec}.evaluation-form-scoped .inner-row .el-form-item__content{border-left:0;padding:0}.evaluation-form-scoped .inner-row .el-form-item__content .el-col{height:120px;line-height:120px}.evaluation-form-scoped .inner-row .el-form-item__content .el-col textarea{height:120px}.evaluation-form-scoped .inner-row .el-form-item__content .el-col .el-radio-group.score-group{width:100%}.evaluation-form-scoped .inner-row .el-form-item__content .el-col .el-radio.score-item{width:20%;text-align:center}.evaluation-form-scoped .inner-row .el-form-item__content .el-col .el-radio.score-item+.el-radio{margin-left:0}", ""]);

// exports


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(874);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("330af870", content, true);

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".evaluation-form-scoped .el-form-item{border:1px solid #ddd;padding:0;margin:0;position:relative;margin-top:-1px;background:#f6f9fc}.evaluation-form-scoped .el-form-item .el-form-item__label{position:absolute;top:50%;margin-top:-18px;text-align:center;font-weight:700}.evaluation-form-scoped .el-form-item .el-form-item__content{padding:10px;background:#fff;border-left:1px solid #dfe3ec}.evaluation-form-scoped .el-form-item .el-textarea{height:100px}.evaluation-form-scoped .el-form-item .el-textarea textarea{height:100%;border:0;resize:none}.evaluation-form-scoped .el-form-item .el-input__inner{border:0}.evaluation-form-scoped .inner-td{background:#f6f9fc;text-align:center;font-weight:700;border-left:1px solid #dfe3ec;border-right:1px solid #dfe3ec}.evaluation-form-scoped .inner-row .el-form-item__content{border-left:0;padding:0}.evaluation-form-scoped .inner-row .el-form-item__content .el-col{height:120px;line-height:120px}.evaluation-form-scoped .inner-row .el-form-item__content .el-col textarea{height:120px}.evaluation-form-scoped .inner-row .el-form-item__content .el-col .el-radio-group.score-group{width:100%}.evaluation-form-scoped .inner-row .el-form-item__content .el-col .el-radio.score-item{width:20%;text-align:center}.evaluation-form-scoped .inner-row .el-form-item__content .el-col .el-radio.score-item+.el-radio{margin-left:0}", ""]);

// exports


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(876);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("71f19289", content, true);

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".evaluation-form-scoped .el-form-item{border:1px solid #ddd;padding:0;margin:0;position:relative;margin-top:-1px;background:#f6f9fc}.evaluation-form-scoped .el-form-item .el-form-item__label{position:absolute;top:50%;margin-top:-18px;text-align:center;font-weight:700}.evaluation-form-scoped .el-form-item .el-form-item__content{padding:10px;background:#fff;border-left:1px solid #dfe3ec}.evaluation-form-scoped .el-form-item .el-textarea{height:100px}.evaluation-form-scoped .el-form-item .el-textarea textarea{height:100%;border:0;resize:none}.evaluation-form-scoped .el-form-item .el-input__inner{border:0}.evaluation-form-scoped .inner-td{background:#f6f9fc;text-align:center;font-weight:700;border-left:1px solid #dfe3ec;border-right:1px solid #dfe3ec}.evaluation-form-scoped .inner-row .el-form-item__content{border-left:0;padding:0}.evaluation-form-scoped .inner-row .el-form-item__content .el-col{height:120px;line-height:120px}.evaluation-form-scoped .inner-row .el-form-item__content .el-col textarea{height:120px}.evaluation-form-scoped .inner-row .el-form-item__content .el-col .el-radio-group.score-group{width:100%}.evaluation-form-scoped .inner-row .el-form-item__content .el-col .el-radio.score-item{width:20%;text-align:center}.evaluation-form-scoped .inner-row .el-form-item__content .el-col .el-radio.score-item+.el-radio{margin-left:0}.evaluation-form-scoped .inner-row.inner-row--pma .el-form-item__content .el-row+.el-row{border-top:1px solid #dfe3ec}.evaluation-form-scoped .inner-row.inner-row--pma .el-form-item__content .el-col{background:#fff}.evaluation-form-scoped .inner-row.inner-row--pma .el-form-item__content .el-col.shorter{height:56px;line-height:56px}.evaluation-form-scoped .inner-row.inner-row--pma .el-form-item__content .el-col.required:before{content:\"*\";color:#ff4949;margin-right:4px}", ""]);

// exports


/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(878);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("6c959f3a", content, true);

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".evaluation-form-scoped .el-form-item{border:1px solid #ddd;padding:0;margin:0;position:relative;margin-top:-1px;background:#f6f9fc}.evaluation-form-scoped .el-form-item .el-form-item__label{position:absolute;top:50%;margin-top:-18px;text-align:center;font-weight:700}.evaluation-form-scoped .el-form-item .el-form-item__content{padding:10px;background:#fff;border-left:1px solid #dfe3ec}.evaluation-form-scoped .el-form-item .el-textarea{height:100px}.evaluation-form-scoped .el-form-item .el-textarea textarea{height:100%;border:0;resize:none}.evaluation-form-scoped .el-form-item .el-input__inner{border:0}.evaluation-form-scoped .inner-td{background:#f6f9fc;text-align:center;font-weight:700;border-left:1px solid #dfe3ec;border-right:1px solid #dfe3ec}.evaluation-form-scoped .inner-row .el-form-item__content{border-left:0;padding:0}.evaluation-form-scoped .inner-row .el-form-item__content .el-col{height:120px;line-height:120px}.evaluation-form-scoped .inner-row .el-form-item__content .el-col textarea{height:120px}.evaluation-form-scoped .inner-row .el-form-item__content .el-col .el-radio-group.score-group{width:100%}.evaluation-form-scoped .inner-row .el-form-item__content .el-col .el-radio.score-item{width:20%;text-align:center}.evaluation-form-scoped .inner-row .el-form-item__content .el-col .el-radio.score-item+.el-radio{margin-left:0}", ""]);

// exports


/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/evaluation/society.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_thumbnail__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__society_form_society_form__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mixins_selectMapMixin__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs__ = __webpack_require__(357);







/* harmony default export */ var society_defaultExport = ({
    components: {
        Thumbnail: __WEBPACK_IMPORTED_MODULE_0_components_thumbnail__["a" /* default */], SocietyForm: __WEBPACK_IMPORTED_MODULE_1__society_form_society_form__["a" /* default */]
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_2_mixins_selectMapMixin__["a" /* default */]],
    data: function data() {
        return {
            typeList: ['4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '21', '22', '23', '24'],
            baseInfo: null,
            evaInfo: null,
            formKey: 1,
            showEdit: false,
            interviews: [],
            turn: null,
            dialogVisible: false,
            interviewInfo: {
                interviewArrangeId: null,
                evaluator: ''
            },
            dialogInfo: {
                turn: '',
                extInfo: ''
            },
            form: {
                status: '',
                content: ''
            },
            scoreMapList: __WEBPACK_IMPORTED_MODULE_3__libs__["c" /* scoreMapList */],
            otherMapList: __WEBPACK_IMPORTED_MODULE_3__libs__["a" /* otherMapList */],
            skillMapList: __WEBPACK_IMPORTED_MODULE_3__libs__["e" /* skillMapList */]
        };
    },
    created: function created() {
        this.getPhaseInfo();
        this.getEvaList();
    },

    computed: {
        canSync: function canSync() {
            return this.evaInfo && this.evaInfo.syncInfo && this.evaInfo.syncInfo.canSync;
        }
    },
    methods: {
        getPhaseInfo: function getPhaseInfo() {
            var _this = this;

            this.$axios.post('/resumePosition/interviewArrange/getListWithOutEva.api', { resumePositionId: this.$route.params.id }).then(function (res) {
                _this.baseInfo = res.result;
            });
        },
        getEvaList: function getEvaList() {
            var _this2 = this;

            this.$axios.get('/evaluation/getEvaList.api?resumePositionId=' + this.$route.params.id).then(function (res) {
                _this2.evaInfo = res.result;
            });
        },
        refresh: function refresh() {
            this.getEvaList();
        },
        changePhase: function changePhase(val) {
            var _this3 = this;

            var turnInfo = this.baseInfo.list.filter(function (item) {
                return item.id === val;
            })[0];
            var masterIds = turnInfo.masterInterviewer.split(','),
                masterNames = turnInfo.masterInterviewerNames.split('，');
            this.interviews = [];
            masterIds.forEach(function (mid, mindex) {
                _this3.interviews.push({
                    id: mid,
                    name: masterNames[mindex]
                });
            });
            this.interviewInfo.evaluator = '';
            this.turn = turnInfo.turn;
        },
        cancelEdit: function cancelEdit() {
            this.showEdit = false;
        },
        updateSuccess: function updateSuccess() {
            this.refresh();
            this.dialogVisible = false;
        },
        addSuccess: function addSuccess() {
            this.refresh();
            this.showEdit = false;
            this.interviewInfo.interviewArrangeId = '';
            this.interviewInfo.evaluator = '';
            this.getPhaseInfo();
            this.formKey++;
        },
        showEditPopup: function showEditPopup(item, evaluate) {
            var _this4 = this;

            this.dialogInfo.extInfo = {
                resumePositionId: evaluate.resumePositionId,
                interviewArrangeId: evaluate.id
            };
            this.dialogInfo.turn = evaluate.turn;
            this.dialogVisible = true;
            this.$nextTick(function () {
                _this4.$refs.updateForm.setForm(item);
            });
        },
        syncToSupplier: function syncToSupplier() {
            var _this5 = this;

            this.$confirm('同步后供应商可查看面试评价信息，是否继续？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                _this5.$axios.post('/evaluation/syncEva.api', {
                    resumePositionIds: _this5.$route.params.id
                }).then(function (res) {
                    _this5.$message({
                        message: '操作成功',
                        type: 'success'
                    });
                    _this5.refresh();
                });
            }).catch(function () {});
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15e2168a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/evaluation/society.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "evaluation-scoped evaluation-society-scoped container"
  }, [(_vm.baseInfo) ? _c('div', {
    staticClass: "resume-doc-wpr box-shadow-small border-radius"
  }, [_c('div', {
    staticStyle: {
      "padding-top": "30px"
    }
  }, [_c('div', {
    staticClass: "mb-15"
  }, [_c('thumbnail', {
    attrs: {
      "text": _vm.baseInfo.resume.name,
      "gender": _vm.baseInfo.resume.gender == 1 ? 'man' : 'woman',
      "font-size": 16,
      "width": 110
    }
  }), _vm._v(" "), _c('el-row', {
    staticClass: "mt-10 text-center",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("应聘职位：" + _vm._s(_vm.baseInfo.position.name))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("应聘部门：" + _vm._s(_vm.baseInfo.position.deptNames))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("手机号：" + _vm._s(_vm.baseInfo.resume.mobilePhone))])], 1), _vm._v(" "), (_vm.canSync) ? _c('el-row', {
    staticClass: "mt-10 text-center",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("同步供应商：" + _vm._s(_vm.evaInfo.syncInfo.isSync ? '已同步' : '未同步'))]), _vm._v(" "), (_vm.evaInfo.syncInfo.isSync) ? _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("同步供应商时间：" + _vm._s(_vm.evaInfo.syncInfo.syncTime))]) : _vm._e()], 1) : _vm._e()], 1)]), _vm._v(" "), (!_vm.baseInfo.list.length && _vm.evaInfo && !_vm.evaInfo.list.length) ? _c('div', [_vm._m(0)]) : _c('div', {
    staticClass: "resume-doc"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "margin-top": "50px"
    }
  }, [(!_vm.showEdit) ? _c('el-button', {
    staticStyle: {
      "float": "right",
      "margin-bottom": "20px"
    },
    attrs: {
      "type": "primary",
      "disabled": _vm.baseInfo.list.length ? _vm.showEdit : true
    },
    on: {
      "click": function($event) {
        _vm.showEdit = true
      }
    }
  }, [_vm._v("添加评价")]) : _vm._e(), _vm._v(" "), (_vm.showEdit) ? _c('el-button', {
    staticStyle: {
      "float": "right",
      "margin-bottom": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showEdit = false && _vm.formKey++
      }
    }
  }, [_vm._v("取消编辑")]) : _vm._e(), _vm._v(" "), (_vm.canSync) ? _c('el-button', {
    staticStyle: {
      "float": "right",
      "margin-bottom": "20px",
      "margin-right": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.syncToSupplier
    }
  }, [_vm._v("同步供应商")]) : _vm._e()], 1), _vm._v(" "), (_vm.showEdit) ? _c('div', {
    key: _vm.formKey,
    staticClass: "edit-form"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "inline": true,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "面试阶段"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择面试阶段"
    },
    on: {
      "change": _vm.changePhase
    },
    model: {
      value: (_vm.interviewInfo.interviewArrangeId),
      callback: function($$v) {
        _vm.$set(_vm.interviewInfo, "interviewArrangeId", $$v)
      },
      expression: "interviewInfo.interviewArrangeId"
    }
  }, _vm._l((_vm.baseInfo.list), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.turnName,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "面试官"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择面试官"
    },
    model: {
      value: (_vm.interviewInfo.evaluator),
      callback: function($$v) {
        _vm.$set(_vm.interviewInfo, "evaluator", $$v)
      },
      expression: "interviewInfo.evaluator"
    }
  }, _vm._l((_vm.interviews), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [(_vm.interviewInfo.evaluator) ? _c('society-form', {
    attrs: {
      "turn": _vm.turn,
      "isSimple": _vm.evaInfo.isSimple,
      "isFull": true,
      "extInfo": _vm.interviewInfo,
      "scoreType": _vm.baseInfo.position.scoreType,
      "advise": _vm.baseInfo.position.advise,
      "recruitType": _vm.evaInfo.recruitType
    },
    on: {
      "refresh": _vm.addSuccess,
      "cancel": _vm.cancelEdit
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.evaInfo && _vm.evaInfo.list.length) ? _c('div', {
    staticClass: "history-form"
  }, _vm._l((_vm.evaInfo.list), function(evaluate, index) {
    return (evaluate.evaList.length) ? _c('el-table', {
      key: index,
      staticClass: "evaluation-item",
      attrs: {
        "row-class-name": "evaluate-row",
        "show-header": false,
        "data": [{}]
      }
    }, [_c('el-table-column', {
      attrs: {
        "width": "200",
        "class-name": "name-td"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(evaluate.turnName) + "评价结果")]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return _vm._l((evaluate.evaList), function(item, idx) {
            return _c('div', {
              key: idx,
              staticClass: "evaluate-row"
            }, [_c('div', {
              staticClass: "isView"
            }, [_c('el-row', {
              staticClass: "mt-15"
            }, [_c('el-col', {
              attrs: {
                "span": 8
              }
            }, [_c('span', {
              staticClass: "txt-label"
            }, [_vm._v("面试结果：")]), _vm._v(_vm._s(_vm.getSelectMapText('WB_USER_VIEWPOINT', item.userViewpoint)) + "\n                                        ")])], 1), _vm._v(" "), _c('el-row', {
              staticClass: "mt-15"
            }, [_c('el-col', {
              attrs: {
                "span": 8
              }
            }, [_c('span', {
              staticClass: "txt-label"
            }, [_vm._v("面试官：")]), _vm._v(_vm._s(item.interviewer.name) + "\n                                        ")]), _vm._v(" "), _c('el-col', {
              attrs: {
                "span": 8
              }
            }, [_c('span', {
              staticClass: "txt-label"
            }, [_vm._v("时间：")]), _vm._v(_vm._s(item.evaluateTime) + "\n                                        ")])], 1), _vm._v(" "), (!_vm.baseInfo.position.scoreType || !_vm.typeList.includes(_vm.baseInfo.position.scoreType)) ? _c('div', [_c('span', [(!_vm.evaInfo.isSimple && _vm.baseInfo.position.scoreType) ? _c('el-row', {
              staticClass: "mt-15"
            }, [(_vm.evaInfo.recruitType === 'social') ? _c('el-col', {
              attrs: {
                "span": 8
              }
            }, [_c('span', {
              staticClass: "txt-label"
            }, [_vm._v("建议定级：")]), _vm._v(_vm._s(item.grade))]) : _vm._e(), _vm._v(" "), _c('el-col', {
              attrs: {
                "span": 8
              }
            }, [_c('span', {
              staticClass: "txt-label"
            }, [_vm._v("评分标准：")]), _vm._v(_vm._s(item.score))])], 1) : (_vm.evaInfo.isSimple) ? _c('el-row', {
              staticClass: "mt-15 mb-15"
            }, [_c('el-col', [_c('span', {
              staticClass: "txt-label"
            }, [_vm._v("评价等级：")]), _c('pre', {
              staticClass: "multi-row-content"
            }, [_vm._v(_vm._s(item.grade))])])], 1) : _vm._e()], 1), _vm._v(" "), (!_vm.evaInfo.isSimple && _vm.baseInfo.position.scoreType) ? _c('el-row', {
              staticClass: "mt-15 mb-15"
            }, [_c('el-col', [_c('span', {
              staticClass: "txt-label"
            }, [_vm._v("面试记录：")]), _vm._v(" "), _c('pre', {
              staticClass: "multi-row-content"
            }, [_vm._v(_vm._s(item.interviewRecord))])])], 1) : _vm._e(), _vm._v(" "), (!_vm.evaInfo.isSimple && _vm.evaInfo.recruitType === 'social' && _vm.baseInfo.position.scoreType) ? _c('el-row', {
              staticClass: "mt-15 mb-15"
            }, [_c('el-col', [_c('span', {
              staticClass: "txt-label"
            }, [_vm._v("当前薪酬：")]), _vm._v(" "), (item.monthBaseSalary) ? _c('pre', {
              staticClass: "multi-row-content"
            }, [_vm._v("月薪" + _vm._s(item.monthBaseSalary) + "*" + _vm._s(item.monthCount) + "个月，" + _vm._s(item.otherWelfare))]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (!_vm.evaInfo.isSimple && _vm.baseInfo.position.scoreType) ? _c('el-row', {
              staticClass: "mt-15 mb-15"
            }, [_c('el-col', [_c('span', {
              staticClass: "txt-label"
            }, [_vm._v(_vm._s(['18', '19', '20'].includes(_vm.baseInfo.position.scoreType) ? '期望薪资：' : '期望描述：'))]), _vm._v(" "), _c('pre', {
              staticClass: "multi-row-content"
            }, [_vm._v(_vm._s(item.expectSalary))])])], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
              staticClass: "mt-15 mb-15"
            }, [_c('el-col', [_c('span', {
              staticClass: "txt-label"
            }, [_vm._v("综合评价：")]), _vm._v(" "), _c('pre', {
              staticClass: "multi-row-content"
            }, [_vm._v(_vm._s(item.content))])])], 1), _vm._v(" "), (item.hireAdvice) ? _c('el-row', {
              staticClass: "mt-15 mb-15"
            }, [_c('el-col', [_c('span', {
              staticClass: "txt-label"
            }, [_vm._v(_vm._s(['18', '19', '20'].includes(_vm.baseInfo.position.scoreType) ? '岗位建议方向：' : '录用方向建议：'))]), _vm._v(" "), _c('pre', {
              staticClass: "multi-row-content"
            }, [_vm._v(_vm._s(item.hireAdvice))])])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (['4', '5', '6', '7', '8', '9', '10', '17', '21', '22', '23', '24'].includes(_vm.baseInfo.position.scoreType)) ? _c('div', [(_vm.baseInfo.position.scoreType !== '6') ? _c('el-row', {
              staticClass: "mt-15"
            }, [_c('el-col', [_c('span', {
              staticClass: "txt-label"
            }, [_vm._v("评分标准：")]), _vm._v(" "), _c('pre', {
              staticClass: "multi-row-content"
            }, [_vm._v(_vm._s(item.score))])])], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
              staticClass: "mt-15"
            }, [_c('el-col', [_c('span', {
              staticClass: "txt-label"
            }, [_vm._v("建议薪资：")]), _vm._v(" "), _c('pre', {
              staticClass: "multi-row-content"
            }, [_vm._v(_vm._s(item.adviceSalary))])])], 1), _vm._v(" "), (_vm.baseInfo.position.scoreType === '6' || _vm.baseInfo.position.scoreType === '7' || _vm.baseInfo.position.scoreType === '8') ? _c('el-row', {
              staticClass: "mt-15"
            }, [_c('el-col', [_c('span', {
              staticClass: "txt-label"
            }, [_vm._v("当前薪资：")]), _vm._v(" "), (item.monthBaseSalary) ? _c('pre', {
              staticClass: "multi-row-content"
            }, [_vm._v("月薪" + _vm._s(item.monthBaseSalary) + "*" + _vm._s(item.monthCount) + "个月，" + _vm._s(item.otherWelfare))]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
              staticClass: "mt-15"
            }, [_c('el-col', [_c('span', {
              staticClass: "txt-label"
            }, [_vm._v("期望薪资：")]), _vm._v(" "), _c('pre', {
              staticClass: "multi-row-content"
            }, [_vm._v(_vm._s(item.expectSalary))])])], 1), _vm._v(" "), _c('el-row', {
              staticClass: "mt-15 mb-15"
            }, [_c('el-col', [_c('span', {
              staticClass: "txt-label"
            }, [_vm._v("面试记录：")]), _vm._v(" "), _c('pre', {
              staticClass: "multi-row-content"
            }, [_vm._v(_vm._s(item.interviewRecord))])])], 1), _vm._v(" "), _c('el-row', {
              staticClass: "mt-15"
            }, [_c('el-col', [_c('span', {
              staticClass: "txt-label"
            }, [_vm._v("综合评价：")]), _vm._v(" "), _c('pre', {
              staticClass: "multi-row-content"
            }, [_vm._v(_vm._s(item.content))])])], 1), _vm._v(" "), (item.hireAdvice) ? _c('el-row', {
              staticClass: "mt-15 mb-15"
            }, [_c('el-col', [_c('span', {
              staticClass: "txt-label"
            }, [_vm._v(_vm._s(['17', '21', '22', '23', '24'].includes(_vm.baseInfo.position.scoreType) ? '岗位建议方向：' : '录用方向建议：'))]), _vm._v(" "), _c('pre', {
              staticClass: "multi-row-content"
            }, [_vm._v(_vm._s(item.hireAdvice))])])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (['11', '12', '13'].includes(_vm.baseInfo.position.scoreType)) ? _c('div', [(['12', '13'].includes(_vm.baseInfo.position.scoreType) && evaluate.turn === '0') ? _c('div', _vm._l((_vm.scoreMapList), function(scoreMap, index) {
              return _c('el-row', {
                key: scoreMap.name,
                class: [
                  [0, 6].includes(index) ? 'mt-15' : 'mt-5'
                ]
              }, [_c('el-col', [_c('span', {
                staticClass: "txt-label"
              }, [_vm._v(_vm._s([6, 7, 8].includes(index) ? '个人素质' : '综合能力') + "-" + _vm._s(scoreMap.name) + "：")]), _vm._v(" "), (item[scoreMap.prop]) ? _c('pre', {
                staticClass: "multi-row-content"
              }, [_vm._v(_vm._s(item[scoreMap.prop]))]) : _vm._e()])], 1)
            }), 1) : _vm._e(), _vm._v(" "), (_vm.baseInfo.position.scoreType === '12' && evaluate.turn === '0') ? _c('el-row', {
              staticClass: "mt-15"
            }, [_c('el-col', [_c('span', {
              staticClass: "txt-label"
            }, [_vm._v("专业能力：")]), _vm._v(" "), (item.professionalProjMgr) ? _c('pre', {
              staticClass: "multi-row-content"
            }, [_vm._v(_vm._s(item.professionalProjMgr))]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.baseInfo.position.scoreType === '13' && evaluate.turn === '0') ? _c('div', _vm._l((_vm.skillMapList), function(skillMap, index) {
              return _c('el-row', {
                key: skillMap.name,
                class: [index ? 'mt-5' : 'mt-15']
              }, [_c('el-col', [_c('span', {
                staticClass: "txt-label"
              }, [_vm._v("专业能力-" + _vm._s(skillMap.name) + "：")]), _vm._v(" "), (item[skillMap.prop]) ? _c('pre', {
                staticClass: "multi-row-content"
              }, [_vm._v(_vm._s(item[skillMap.prop]))]) : _vm._e()])], 1)
            }), 1) : _vm._e(), _vm._v(" "), (['12', '13'].includes(_vm.baseInfo.position.scoreType) && evaluate.turn === '0') ? _c('div', _vm._l((_vm.otherMapList), function(otherMap, index) {
              return _c('el-row', {
                key: otherMap.name,
                class: [index ? 'mt-5' : 'mt-15']
              }, [_c('el-col', [_c('span', {
                staticClass: "txt-label"
              }, [_vm._v("其他-" + _vm._s(otherMap.name) + "：")]), _vm._v(" "), (item[otherMap.prop]) ? _c('pre', {
                staticClass: "multi-row-content",
                staticStyle: {
                  "width": "690px"
                }
              }, [_vm._v(_vm._s(item[otherMap.prop]))]) : _vm._e()])], 1)
            }), 1) : _vm._e(), _vm._v(" "), (evaluate.turn === '0') ? _c('el-row', {
              staticClass: "mt-15"
            }, [_c('el-col', [_c('span', {
              staticClass: "txt-label"
            }, [_vm._v("当前薪资：")]), _vm._v(" "), (item.monthBaseSalary) ? _c('pre', {
              staticClass: "multi-row-content"
            }, [_vm._v("月薪" + _vm._s(item.monthBaseSalary) + "*" + _vm._s(item.monthCount) + "个月，" + _vm._s(item.otherWelfare))]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (evaluate.turn === '0') ? _c('el-row', {
              staticClass: "mt-15"
            }, [_c('el-col', [_c('span', {
              staticClass: "txt-label"
            }, [_vm._v("期望薪资：")]), _vm._v(" "), _c('pre', {
              staticClass: "multi-row-content"
            }, [_vm._v(_vm._s(item.expectSalary))])])], 1) : _vm._e(), _vm._v(" "), (['12', '13'].includes(_vm.baseInfo.position.scoreType) && evaluate.turn === '0') ? _c('el-row', {
              staticClass: "mt-15"
            }, [_c('el-col', [_c('span', {
              staticClass: "txt-label"
            }, [_vm._v("最快到岗时间：")]), _vm._v(" "), (item.lastEntryTime) ? _c('pre', {
              staticClass: "multi-row-content"
            }, [_vm._v(_vm._s(item.lastEntryTime))]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
              staticClass: "mt-15"
            }, [_c('el-col', [_c('span', {
              staticClass: "txt-label"
            }, [_vm._v("综合评价：")]), _vm._v(" "), _c('pre', {
              staticClass: "multi-row-content"
            }, [_vm._v(_vm._s(item.content))])])], 1)], 1) : _vm._e(), _vm._v(" "), (['14', '15', '16'].includes(_vm.baseInfo.position.scoreType)) ? _c('div', [_c('el-row', {
              staticClass: "mt-15"
            }, [_c('el-col', [_c('span', {
              staticClass: "txt-label"
            }, [_vm._v("评分标准：")]), _vm._v(_vm._s(item.score))])], 1), _vm._v(" "), _c('el-row', {
              staticClass: "mt-15"
            }, [_c('el-col', [_c('span', {
              staticClass: "txt-label"
            }, [_vm._v("期望薪资：")]), _vm._v(" "), _c('pre', {
              staticClass: "multi-row-content"
            }, [_vm._v(_vm._s(item.expectSalary))])])], 1), _vm._v(" "), _c('el-row', {
              staticClass: "mt-15 mb-15"
            }, [_c('el-col', [_c('span', {
              staticClass: "txt-label"
            }, [_vm._v("面试记录：")]), _vm._v(" "), _c('pre', {
              staticClass: "multi-row-content"
            }, [_vm._v(_vm._s(item.interviewRecord))])])], 1), _vm._v(" "), _c('el-row', {
              staticClass: "mt-15 mb-15"
            }, [_c('el-col', [_c('span', {
              staticClass: "txt-label"
            }, [_vm._v("综合评价：")]), _vm._v(" "), _c('pre', {
              staticClass: "multi-row-content"
            }, [_vm._v(_vm._s(item.content))])])], 1), _vm._v(" "), (item.hireAdvice) ? _c('el-row', {
              staticClass: "mt-15 mb-15"
            }, [_c('el-col', [_c('span', {
              staticClass: "txt-label"
            }, [_vm._v("录用方向建议：")]), _vm._v(" "), _c('pre', {
              staticClass: "multi-row-content"
            }, [_vm._v(_vm._s(item.hireAdvice))])])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('el-button', {
              staticStyle: {
                "position": "absolute",
                "right": "0px",
                "bottom": "10px"
              },
              attrs: {
                "size": "small"
              },
              on: {
                "click": function($event) {
                  return _vm.showEditPopup(item, evaluate)
                }
              }
            }, [_vm._v("编辑")])], 1)])
          })
        }
      }], null, true)
    })], 1) : _vm._e()
  }), 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "修改评价",
      "close-on-click-modal": false,
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [(_vm.dialogInfo && _vm.baseInfo && _vm.evaInfo) ? _c('div', {
    staticClass: "isEdit"
  }, [_c('society-form', {
    ref: "updateForm",
    attrs: {
      "turn": _vm.dialogInfo.turn,
      "isSimple": _vm.evaInfo.isSimple,
      "isEdit": true,
      "isFull": true,
      "extInfo": _vm.dialogInfo.extInfo,
      "scoreType": _vm.baseInfo.position.scoreType,
      "advise": _vm.baseInfo.position.advise,
      "recruitType": _vm.evaInfo.recruitType
    },
    on: {
      "refresh": _vm.updateSuccess,
      "cancel": function($event) {
        _vm.dialogVisible = false
      }
    }
  })], 1) : _vm._e()])], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin": "100px 0",
      "text-align": "center",
      "color": "#ccc"
    }
  }, [_c('i', {
    staticClass: "el-icon-information"
  }), _vm._v("该应聘者还没有面试安排，不可添加面试评价")])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var evaluation_society_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/views/evaluation/society.vue
function injectStyle (ssrContext) {
  __webpack_require__(880)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  society_defaultExport,
  evaluation_society_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(881);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("0a438fda", content, true);

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".scoped-evaluation-society{padding:0}.evaluation-scoped .top-nav{position:absolute;width:200px;top:0;z-index:200;background-color:transparent;left:46%}.evaluation-scoped .top-nav .title{position:absolute;left:10px;font-size:18px;color:#fff;border-bottom:0}.evaluation-scoped .top-nav .title:hover{border-bottom:0}.evaluation-scoped .resume-top-bar{background:#fff;height:80px;line-height:80px}.evaluation-scoped .resume-top-bar .resume-top{width:1200px;margin:0 auto}.evaluation-scoped .resume-top-bar .top-user-info{width:50%;float:left;text-align:left;position:relative}.evaluation-scoped .resume-top-bar .top-user-info .user-name{font-size:18px;font-weight:700;margin-top:10px}.evaluation-scoped .resume-top-bar .top-user-info .round-image{position:absolute;top:10px}.evaluation-scoped .resume-top-bar .top-user-info .thumbnail-text{display:inline-block;margin-left:80px}.evaluation-scoped .resume-top-bar .top-user-info .thumbnail-text p{height:30px;line-height:30px}.evaluation-scoped .button-footer{text-align:center;margin:20px}.evaluation-scoped .multi-row-content{display:inline-block;vertical-align:top;margin:0;word-break:break-all;width:795px;word-wrap:break-word;white-space:pre-wrap}.evaluation-scoped .history-form{margin-bottom:50px}.evaluation-scoped .history-form .evaluate-row{color:#333}.evaluation-scoped .history-form .evaluate-row:hover td{background:none}.evaluation-scoped .history-form .evaluate-row:hover .name-td{background:#f6f9fc}.evaluation-scoped .history-form .txt-label{font-weight:700}.evaluation-scoped .history-form .name-td{background:#f6f9fc;text-align:center;border-right:1px solid #dfe3ec;font-weight:700}.evaluation-scoped .history-form .evaluation-item{margin-top:-1px}.evaluation-society-scoped .mask-tip{position:absolute;left:0;top:0;background:rgba(0,0,0,.1);text-align:center;width:100%;height:100%;z-index:20}.evaluation-society-scoped .mask-tip p{position:absolute;width:100%;top:48%}.evaluation-society-scoped .evaluate-row{position:relative;border-bottom:1px dashed #ddd;padding:10px 0;margin-bottom:-1px}", ""]);

// exports


/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/arrangement/arrangements.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arrangementItem__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__arrangeCommon__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__operation_interviewerEmailDialog__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mixins_selectMapMixin__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_userSelect_searchDownList__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_underscore__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_underscore__);










/* harmony default export */ var arrangements_defaultExport = ({
    components: {
        ArrangementItem: __WEBPACK_IMPORTED_MODULE_1__arrangementItem__["a" /* default */], EmailSender: __WEBPACK_IMPORTED_MODULE_3__operation_interviewerEmailDialog__["a" /* default */], ArrangeCommon: __WEBPACK_IMPORTED_MODULE_2__arrangeCommon__["a" /* default */], UserSearch: __WEBPACK_IMPORTED_MODULE_5_components_userSelect_searchDownList__["a" /* default */]
    },
    created: function created() {
        this.getData();
    },

    mixins: [__WEBPACK_IMPORTED_MODULE_4_mixins_selectMapMixin__["a" /* default */]],
    data: function data() {
        return {
            listData: null,
            allChecked: false,
            isIndeterminate: false,
            checkedPhase: [],
            counter: 0,
            topObj: {
                turnType: '',
                interviewDate: '',
                interviewType: '',
                masterInterviewer: '',
                interviewPlace: ''
            }
        };
    },

    computed: {
        ids: function ids() {
            return this.$route.params.ids;
        }
    },
    watch: {
        $route: function $route() {
            this.getData();
        }
    },
    methods: {
        setBetchCol: function setBetchCol(attr) {
            var val = this.topObj[attr],
                names = '';
            if (attr === 'masterInterviewer') {
                var list = this.$refs.topInterviewer.getSelected();
                val = list.map(function (item) {
                    return item.id;
                }).join(',');
                names = list.map(function (item) {
                    return item.name;
                }).join('，');
            }
            if (val === '') {
                this.$message({
                    message: '数据不能为空',
                    type: 'warning'
                });
            } else {
                var selecteds = {};
                var hasSelectedRow = false;
                this.$refs.arrangement.forEach(function (item, index) {
                    var tableSelected = item.getSelected();
                    if (tableSelected.length) {
                        hasSelectedRow = true;
                        selecteds[index] = tableSelected;
                    }
                });
                if (hasSelectedRow === false) {
                    this.$message({
                        message: '请勾选面试阶段',
                        type: 'warning'
                    });
                } else {
                    for (var key in selecteds) {
                        var view = this.$refs.arrangement[key];
                        view.updateColData(selecteds[key], attr, val, names);
                    }
                }
            }
        },
        counterCheckbox: function counterCheckbox(value) {
            value ? this.counter++ : this.counter--;
            this.allChecked = this.counter === this.listData.length;
        },
        addNextPhase: function addNextPhase() {
            this.$refs.arrangement.forEach(function (item) {
                var rowData = item.addInterview();
                item.$refs.table.toggleRowSelection(rowData, true);
            });
        },
        getData: function getData() {
            var _this = this;

            if (String(this.$route.params.ids) === '-1') {
                this.listData = [];
                return false;
            }
            this.$axios.get('/resumePosition/interviewRecord/recordDetail.api?rpIds=' + this.ids).then(function (res) {
                var list = res.result.list;
                list.forEach(function (item) {
                    item.id = item.rpId || '';
                    item.list.forEach(function (form) {
                        form.turnType = [form.turn, form.isHr].join(',');
                    });
                });
                _this.listData = list;
            }).catch(console.error);
        },
        saveToMine: function saveToMine() {
            var _this2 = this;

            this.$prompt('请输入面试安排记录名称', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern: /^[\S]{1,20}$/,
                inputErrorMessage: '不能为空，不能空字符开头，长度不能超过20'
            }).then(function (_ref) {
                var value = _ref.value;

                _this2.$axios.post('/resumePosition/interviewRecord/insert.api', {
                    recordName: value,
                    rpIds: _this2.$route.params.ids
                }, {
                    'X-showMessage': true
                }).catch(function () {});
            }).catch();
        },
        toggleAllChecked: function toggleAllChecked(event) {
            var _this3 = this;

            this.isIndeterminate = false;
            this.checkedPhase = event ? ['0', '1', '2', '3'] : [];
            this.$refs.arrangement.forEach(function (item) {
                item.toggleAllSelect(_this3.allChecked);
            });
        },
        handleCheckedChange: function handleCheckedChange(checkedArr) {
            var _this4 = this;

            var checkedCount = checkedArr.length;
            this.allChecked = checkedCount === 4;
            this.isIndeterminate = checkedCount > 0 && checkedCount < 4;

            this.$refs.arrangement.forEach(function (item) {
                item.toggleAllSelect(_this4.allChecked, _this4.checkedPhase);
            });
        },
        saveSelectedData: function saveSelectedData() {
            var _this5 = this;

            var list = [];
            var selecteds = [];
            var hasError = false;
            var map = {};
            var tips = '';
            this.$refs.arrangement.forEach(function (item) {
                var tableSelected = item.getSelected();
                if (hasError) {
                    return;
                }
                if (tableSelected.length) {
                    selecteds = selecteds.concat(tableSelected);
                    var itemParam = item.collectionsSelectedData();
                    var mapKey = {};
                    if (itemParam) {
                        list = list.concat(itemParam);
                        itemParam.forEach(function (one) {
                            var isExist = !!mapKey['key-' + one.resumePositionId + '-' + one.turn];
                            if (isExist) {
                                hasError = true;
                                tips = '同一个应聘者，面试阶段不能重复';
                            } else {
                                mapKey['key-' + one.resumePositionId + '-' + one.turn] = true;
                            }
                        });
                    } else {
                        hasError = true;
                    }
                }
            });
            if (selecteds.length === 0) {
                this.$message({
                    message: '请勾选面试阶段',
                    type: 'warning'
                });
                return false;
            }
            if (!hasError) {
                if (list.length === 0) {
                    this.$message({
                        message: '除去不可更改的记录，当前无可保存的面试阶段',
                        type: 'warning'
                    });
                    return false;
                }
                this.$axios.post('/resumePosition/interviewArrange/insertMutil.api', {
                    interviewArranges: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(list)
                }, {
                    'X-showMessage': true
                }).then(function (res) {
                    if (res.result.failList && res.result.failList.length) {
                        var _res$result = res.result,
                            failList = _res$result.failList,
                            sucessList = _res$result.sucessList;

                        _this5.$message({
                            message: sucessList.length + '\u573A\u521B\u5EFA\u6210\u529F\uFF1B' + failList.length + '\u573A\u521B\u5EFA\u5931\u8D25\uFF0C\u8BF7\u91CD\u65B0\u5C1D\u8BD5',
                            type: 'warning'
                        });

                        _this5.$refs.arrangement.forEach(function (item) {
                            item.tableData.forEach(function (tableItem) {
                                var successItem = sucessList.find(function (s) {
                                    return s.id === tableItem.id;
                                });
                                if (successItem) {
                                    _this5.$set(tableItem, 'isEdit', false);
                                    item.setFormData(tableItem, successItem);
                                    item.sortByTurn();
                                    item.$forceUpdate();
                                }
                            });
                        });
                    } else {
                        _this5.getData();
                    }
                });
            } else {
                tips && this.$message({
                    message: tips,
                    type: 'warning'
                });
            }
        },
        sendEmail: function sendEmail(type) {
            var selecteds = [],
                rpIds = [],
                ids = [],
                needWarn = false,
                unsafeDataCounter = 0,
                that = this;
            this.$refs.arrangement.forEach(function (item) {
                var tableSelected = item.getSelected();
                if (tableSelected.length) {
                    var curTableRows = [];
                    tableSelected.forEach(function (rowItem) {
                        if (rowItem.isEdit === true) {
                            needWarn = true;
                            unsafeDataCounter++;
                        } else {
                            curTableRows.push(rowItem);
                        }
                    });
                    if (curTableRows.length) {
                        selecteds = selecteds.concat(curTableRows);
                        rpIds.push(item.rpId);
                        ids.push(curTableRows[0].id);
                    }
                }
            });
            if (selecteds.length === 0) {
                this.$message({
                    message: '请勾选面试阶段',
                    type: 'warning'
                });
                return false;
            }
            if (needWarn) {
                this.$confirm(unsafeDataCounter + '条数据未保存, 继续操作将忽略未保存的数据，是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    notify();
                }).catch(function () {});
            } else {
                notify();
            }

            function notify() {
                var users = {};
                selecteds.forEach(function (item, index) {
                    var masterIds = item.masterInterviewer.split(','),
                        masterNames = item.masterInterviewerNames.split('，'),
                        interviewIds = item.interviewer.split(','),
                        interviewNames = item.interviewerNames.split('，');
                    item.interviewerUsers = [];
                    if (item.masterInterviewer !== '') {
                        masterIds.forEach(function (mid, mindex) {
                            users[mid] = masterNames[mindex];
                            item.interviewerUsers.push({
                                id: mid,
                                name: masterNames[mindex]
                            });
                        });
                    }
                    if (item.interviewer !== '') {
                        interviewIds.forEach(function (iid, iindex) {
                            users[iid] = interviewNames[iindex];
                            item.interviewerUsers.push({
                                id: iid,
                                name: interviewNames[iindex]
                            });
                        });
                    }
                });
                var list = [];
                rpIds.forEach(function (id) {
                    list.push(__WEBPACK_IMPORTED_MODULE_6_underscore___default.a.findWhere(that.listData, { rpId: +id }));
                });
                that.$refs.sendEmail.show({
                    ids: rpIds.join(','),
                    interviewIds: ids.join(','),
                    resumePositionList: list,
                    phase: 2,
                    selecteds: selecteds,
                    userAttributes: type,
                    showInterviewPhase: type !== 4
                });
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c8c0718"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/arrangement/arrangements.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scope-arrangement-setting scope-arrangements"
  }, [_c('div', {
    staticClass: "top-bar background-white box-shadow-small border-radius"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-checkbox', {
    staticClass: "ml-10",
    attrs: {
      "indeterminate": _vm.isIndeterminate
    },
    on: {
      "change": _vm.toggleAllChecked
    },
    model: {
      value: (_vm.allChecked),
      callback: function($$v) {
        _vm.allChecked = $$v
      },
      expression: "allChecked"
    }
  }, [_vm._v("全选\n                ")]), _vm._v(" "), _c('el-checkbox-group', {
    staticStyle: {
      "display": "inline-block"
    },
    on: {
      "change": _vm.handleCheckedChange
    },
    model: {
      value: (_vm.checkedPhase),
      callback: function($$v) {
        _vm.checkedPhase = $$v
      },
      expression: "checkedPhase"
    }
  }, [_c('el-checkbox', {
    staticClass: "ml-10",
    attrs: {
      "label": "0"
    }
  }, [_vm._v("全选一面")]), _vm._v(" "), _c('el-checkbox', {
    staticClass: "ml-10",
    attrs: {
      "label": "1"
    }
  }, [_vm._v("全选二面")]), _vm._v(" "), _c('el-checkbox', {
    staticClass: "ml-10",
    attrs: {
      "label": "2"
    }
  }, [_vm._v("全选三面")]), _vm._v(" "), _c('el-checkbox', {
    staticClass: "ml-10",
    attrs: {
      "label": "3"
    }
  }, [_vm._v("全选四面")])], 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "8px"
    },
    on: {
      "click": _vm.addNextPhase
    }
  }, [_vm._v("全部追加一个面试阶段")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 14
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-right": "8px"
    },
    attrs: {
      "type": "primary",
      "title": "会自动忽略已评价记录"
    },
    on: {
      "click": _vm.saveSelectedData
    }
  }, [_vm._v("\n                    保存已选中数据\n                ")]), _vm._v(" "), _c('arrange-common', {
    on: {
      "sendEmail": _vm.sendEmail
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "8px"
    },
    on: {
      "click": _vm.saveToMine
    }
  }, [_vm._v("保存到我的面试")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "icon": "el-icon-arrow-left"
    },
    on: {
      "click": function($event) {
        return _vm.$router.back()
      }
    }
  }, [_vm._v("返回")])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "text-center multi-setting",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v("面试阶段")]), _vm._v(" "), _c('div', {
    staticClass: "betch"
  }, [_c('el-select', {
    staticClass: "betch-left",
    attrs: {
      "size": "medium",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.topObj.turnType),
      callback: function($$v) {
        _vm.$set(_vm.topObj, "turnType", $$v)
      },
      expression: "topObj.turnType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "一面",
      "value": "0,0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "一面(HR面)",
      "value": "0,1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "二面",
      "value": "1,0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "二面(HR面)",
      "value": "1,1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "三面",
      "value": "2,0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "三面(HR面)",
      "value": "2,1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "四面",
      "value": "3,0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "四面(HR面)",
      "value": "3,1"
    }
  })], 1), _vm._v(" "), _c('a', {
    staticClass: "betch-btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.setBetchCol('turnType')
      }
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v("面试时间")]), _vm._v(" "), _c('div', {
    staticClass: "betch"
  }, [_c('el-date-picker', {
    staticClass: "betch-left",
    attrs: {
      "size": "medium",
      "format": "yyyy-MM-dd HH:mm",
      "type": "datetime",
      "placeholder": "选择日期时间"
    },
    model: {
      value: (_vm.topObj.interviewDate),
      callback: function($$v) {
        _vm.$set(_vm.topObj, "interviewDate", $$v)
      },
      expression: "topObj.interviewDate"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "betch-btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.setBetchCol('interviewDate')
      }
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v("面试形式")]), _vm._v(" "), _c('div', {
    staticClass: "betch"
  }, [_c('el-select', {
    staticClass: "betch-left",
    attrs: {
      "size": "medium",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.topObj.interviewType),
      callback: function($$v) {
        _vm.$set(_vm.topObj, "interviewType", $$v)
      },
      expression: "topObj.interviewType"
    }
  }, _vm._l((_vm.selectMap.WB_INTERVIEW_TYPE), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('a', {
    staticClass: "betch-btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.setBetchCol('interviewType')
      }
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v("面试官")]), _vm._v(" "), _c('div', {
    staticClass: "betch"
  }, [_c('user-search', {
    ref: "topInterviewer",
    staticClass: "betch-left",
    staticStyle: {
      "width": "60%",
      "display": "inline-block"
    },
    attrs: {
      "holder": "面试官"
    },
    model: {
      value: (_vm.topObj.masterInterviewer),
      callback: function($$v) {
        _vm.$set(_vm.topObj, "masterInterviewer", $$v)
      },
      expression: "topObj.masterInterviewer"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "betch-btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.setBetchCol('masterInterviewer')
      }
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v("面试地点")]), _vm._v(" "), _c('div', {
    staticClass: "betch"
  }, [_c('el-input', {
    staticClass: "betch-left",
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "size": "medium",
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.topObj.interviewPlace),
      callback: function($$v) {
        _vm.$set(_vm.topObj, "interviewPlace", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "topObj.interviewPlace"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "betch-btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.setBetchCol('interviewPlace')
      }
    }
  })], 1)])], 1)], 1), _vm._v(" "), (_vm.listData) ? _c('div', {
    staticClass: "arrangement-list"
  }, _vm._l((_vm.listData), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "box-shadow-small border-radius mt-20"
    }, [_c('arrangement-item', {
      ref: "arrangement",
      refInFor: true,
      staticClass: "background-white mb-10",
      attrs: {
        "isSingle": false,
        "init": item
      },
      on: {
        "sendEmail": _vm.sendEmail,
        "checkbox": _vm.counterCheckbox
      }
    })], 1)
  }), 0) : _vm._e(), _vm._v(" "), _c('email-sender', {
    ref: "sendEmail"
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var arrangement_arrangements_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/views/arrangement/arrangements.vue
function injectStyle (ssrContext) {
  __webpack_require__(883)
  __webpack_require__(885)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2c8c0718"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  arrangements_defaultExport,
  arrangement_arrangements_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(884);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("3df89f04", content, true);

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".scope-arrangement-setting .grey-line{position:absolute;height:100%;width:1px;background:#f4f4f3;padding:60px 0;box-sizing:border-box;left:83px}.scope-arrangement-setting .arrangement-first .grey-line{margin-top:50px}.scope-arrangement-setting .arrangement-last .grey-line{margin-top:-100px}.scope-arrangement-setting .c-text-banner.page-banner{background:url(" + __webpack_require__(230) + ") no-repeat;height:105px;position:relative}.scope-arrangement-setting .c-text-banner.page-banner h3{color:#fff;width:500px;font-size:20px;margin:0 0 0 80px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.scope-arrangement-setting .c-text-banner.page-banner .photo-img{display:inline-block;width:80px;height:80px;border-radius:100%;position:absolute}.scope-arrangement-setting .c-text-banner.page-banner .text-area-right{width:650px;top:30px;position:static;margin-left:110px;margin-top:20px}.scope-arrangement-setting .c-text-banner.page-banner .text-area-left{position:static}.scope-arrangement-setting .c-text-banner.page-banner .text-area{top:12px}.scope-arrangement-setting .top-handler-wpr{padding-top:10px;padding-bottom:10px}.scope-arrangement-setting .arrangement-list{margin-bottom:50px}.scope-arrangement-setting .arrangement-list .parse-name{width:60px;height:60px;margin-top:45px;border:2px solid #2481ff;color:#2481ff;border-radius:100%;text-align:center;line-height:60px;font-size:16px;display:inline-block;z-index:2;background:#fff;position:relative}.scope-arrangement-setting .arrangement-list .handler-btns{text-align:center}.scope-arrangement-setting .arrangement-list .arrangement-item{position:relative}.scope-arrangement-setting .arrangement-list .arrangement-item .el-form-item{margin-bottom:0}.scope-arrangement-setting .arrangement-list .arrangement-item .el-form-item__label{color:#888}.scope-arrangement-setting .arrangement-list .arrangement-item .name{color:#888;margin-right:15px;display:inline-block;width:70px;text-align:right}.scope-arrangement-setting .arrangement-list .arrangement-item .date-item input,.scope-arrangement-setting .arrangement-list .arrangement-item .way-item input{width:190px}.scope-arrangement-setting .arrangement-list .arrange-phase{text-align:center}.scope-arrangement-setting .arrangement-list .interview-one{height:50px;line-height:50px}.scope-arrangement-setting .arrangement-list .arrange-info-wpr{border:1px solid #e2e7eb;width:800px;margin:20px 0;border-radius:5px}.scope-arrangement-setting .arrangement-list .arrange-info-wpr .arrange-info{padding:25px}.scope-arrangement-setting .edit-state .arrange-info-wpr .arrange-info{padding:16px 25px}.scope-arrangement-setting .edit-state .parse-name{color:#333;border-color:#bfcbd9}.scope-arrangement-setting .edit-state .handler-btns{line-height:80px}", ""]);

// exports


/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(886);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("736f187a", content, true);

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".scope-arrangements[data-v-2c8c0718]{margin-bottom:50px}.scope-arrangements .multi-setting[data-v-2c8c0718]{border-top:1px solid #ddd;margin-top:15px}.scope-arrangements .multi-setting .label[data-v-2c8c0718]{font-weight:700;margin:5px}.scope-arrangements .multi-setting .betch[data-v-2c8c0718]{display:flex}.scope-arrangements .multi-setting .betch-left[data-v-2c8c0718]{flex:1;max-width:200px;margin-right:5px;display:inline-block}.scope-arrangements .multi-setting .betch-btn[data-v-2c8c0718]{background:url(" + __webpack_require__(358) + ") no-repeat 50%;flex:0 0 40px;width:40px;height:36px;display:inline-block;vertical-align:bottom}", ""]);

// exports


/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/operation/myArrangementListDialog.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);



/* harmony default export */ var myArrangementListDialog_defaultExport = ({
    data: function data() {
        return {
            showDialog: false,
            page: null,
            tableData: [],
            pageIndex: 1
        };
    },

    watch: {
        pageIndex: function pageIndex() {
            this.getList();
        }
    },
    methods: {
        show: function show() {
            this.showDialog = true;
        },
        editName: function editName(item) {
            var _this = this;

            this.$prompt('请输入面试安排记录名称', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputValue: item.recordName,
                inputPattern: /^[\S]{1,20}$/,
                inputErrorMessage: '不能为空，不能空字符开头，长度不能超过20'
            }).then(function (_ref) {
                var value = _ref.value;

                __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/resumePosition/interviewRecord/update.api', {
                    recordName: value,
                    rpIds: item.rpIds,
                    id: item.id
                }, {
                    'X-showMessage': true
                }).then(function (res) {
                    _this.getList();
                }).catch(function () {});
            }).catch(function () {});
        },
        getList: function getList() {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/resumePosition/interviewRecord/list.api', {
                params: {
                    pageSize: 10,
                    pageIndex: this.pageIndex
                }
            }).then(function (res) {
                _this2.tableData = res.result.list;
                _this2.page = res.page;
            }).catch(function () {});
        },
        pageIndexChange: function pageIndexChange(val) {
            this.pageIndex = val;
        },
        removeRow: function removeRow(item) {
            var _this3 = this;

            this.$confirm('您确认删除该记录?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/resumePosition/interviewRecord/delete.api', { id: item.id }, {
                    'X-showMessage': true
                }).then(function (res) {
                    _this3.getList();
                }).catch(function () {});
            });
        }
    },
    created: function created() {
        this.getList();
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17e4b046"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/operation/myArrangementListDialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "我的面试安排",
      "visible": _vm.showDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.showDialog = $event
      }
    }
  }, [(_vm.tableData.length) ? _c('div', {
    staticStyle: {
      "min-height": "300px"
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.tableData
    }
  }, [_c('el-table-column', {
    attrs: {
      "property": "recordName",
      "label": "名称",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('router-link', {
          attrs: {
            "to": '/arrangements/' + scope.row.rpIds
          }
        }, [_vm._v(_vm._s(scope.row.recordName))])]
      }
    }], null, false, 2526403307)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "address",
      "align": "right",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "icon": "el-icon-my-bianji"
          },
          on: {
            "click": function($event) {
              return _vm.editName(scope.row, scope.$index)
            }
          }
        }), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "icon": "el-icon-my-shanchu color-danger"
          },
          on: {
            "click": function($event) {
              return _vm.removeRow(scope.row, scope.$index)
            }
          }
        })]
      }
    }], null, false, 3205082401)
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticClass: "text-center mt-20",
    attrs: {
      "small": "",
      "layout": "total, prev, pager, next",
      "current-page": ~~_vm.page.pageIndex,
      "page-size": ~~_vm.page.pageSize,
      "total": ~~_vm.page.recordCounts
    },
    on: {
      "current-change": _vm.pageIndexChange
    }
  })], 1) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var operation_myArrangementListDialog_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/views/operation/myArrangementListDialog.vue
function injectStyle (ssrContext) {
  __webpack_require__(890)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-17e4b046"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  myArrangementListDialog_defaultExport,
  operation_myArrangementListDialog_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var views_operation_myArrangementListDialog_defaultExport = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/interview/interviewList.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_queryListExtend__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mixins_selectMapMixin__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__operation_operationMixin__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__operation_remarkEditDialog_vue__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__operation_multiRemarkEditDialog_vue__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__operation_queryListMixin__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_views_operation_changePositionDialog__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__operation_attachViewInList_vue__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_modules_tools__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_underscore__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_qs__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_views_common_multiSearch__ = __webpack_require__(88);


















/* harmony default export */ var interviewList_defaultExport = ({
    'extends': __WEBPACK_IMPORTED_MODULE_2_components_queryListExtend__["a" /* default */],
    'mixins': [__WEBPACK_IMPORTED_MODULE_3_mixins_selectMapMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__operation_operationMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__operation_queryListMixin__["a" /* default */]],
    components: {
        MyArrangementListDialog: views_operation_myArrangementListDialog_defaultExport, AttachViewInList: __WEBPACK_IMPORTED_MODULE_10__operation_attachViewInList_vue__["a" /* default */], ChangePositionDialog: __WEBPACK_IMPORTED_MODULE_9_views_operation_changePositionDialog__["a" /* default */], RemarkEdit: __WEBPACK_IMPORTED_MODULE_5__operation_remarkEditDialog_vue__["a" /* default */], MultiSearch: __WEBPACK_IMPORTED_MODULE_14_views_common_multiSearch__["a" /* default */], MultiRemarkEditDialog: __WEBPACK_IMPORTED_MODULE_6__operation_multiRemarkEditDialog_vue__["a" /* default */]
    },
    beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
        if (to.params.id && from.params.id && to.params.id !== from.params.id) {
            to.query.pageIndex = null;
            to.query.pageSize = null;
        }
        next();
    },
    data: function data() {
        return {
            fetchUrl: '/employ/list.api',
            RESUME_STATUS_ALL: [],
            multiFields: [{
                filter: 'WB_RESUME_STATUS_INTERVIEW',
                label: '简历状态',
                data: [],
                mode: 'select',
                name: 'statusSearch'
            }, {
                filter: 'WB_INTERVIEW_STATUS',
                label: '面试安排',
                data: [],
                mode: 'select',
                name: 'interviewStatusSearch'
            }, {
                filter: 'WB_SYNC_STATUS',
                label: '是否同步',
                multiple: false,
                data: '',
                mode: 'select',
                name: 'isSync'
            }]
        };
    },

    methods: {
        multiRemarkEdit: function multiRemarkEdit(ids) {
            if (this.checkDataValid(ids)) {
                var $target = this.$refs.multiRemarkEditDialog;
                var rids = this.lists.filter(function (cv) {
                    return ids.indexOf(cv.id) > -1;
                }).map(function (cv) {
                    return cv.resumeForm.id;
                }).join(',');
                $target && $target.show(rids);
            }
        },
        dateFormat: function dateFormat(date) {
            var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'yyyy/MM/dd';

            return Object(__WEBPACK_IMPORTED_MODULE_11_modules_tools__["a" /* dateFormat */])(date, format);
        },
        transToText: function transToText(base, value) {
            var target = __WEBPACK_IMPORTED_MODULE_12_underscore___default.a.findWhere(this.selectMap[base], { value: value + '' });
            return target && target.text || '';
        },
        multiArrangement: function multiArrangement() {
            if (!this.checkDataValid(this.idStr)) {
                return false;
            }
            this.$router.push({ name: 'multiArrangement', params: { ids: this.idStr } });
        },
        download: function download() {
            var paramsStr = __WEBPACK_IMPORTED_MODULE_13_qs___default.a.stringify(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({
                ids: this.idStr
            }, this.searchData));
            window.open(this.$axios.defaults.baseURL + '/employ/exportEvaluation.api?token=' + this.$store.state.app.token + '&' + paramsStr);
        },
        fetchCallback: function fetchCallback(res) {
            this.RESUME_STATUS_ALL = res.result.FLOW_STATUS_EMPLOY_TURN_TYPE;
            this.$store.commit('UPDATE_SELECT_MAP_DATA', { WB_RESUME_STATUS_INTERVIEW: res.result.FLOW_STATUS_EMPLOY_TURN_TYPE });
            this.$refs.MultiSearch && this.$refs.MultiSearch.$forceUpdate();
        },
        resetSearchDateBeforeFetch: function resetSearchDateBeforeFetch() {
            if (this.$route.params.id === '0') {
                return true;
            }

            var statusSearch = this.searchData.statusSearch ? this.searchData.statusSearch.replace(/10000[,]?/, '') : '';
            if (statusSearch) {
                var phase = parseInt(statusSearch.substr(0, 1));
                var id = parseInt(this.$route.params.id) - 1;
                if (id !== phase) {
                    this.searchData.statusSearch = '';
                    this.searchData.isJobTransfer = '';
                    this.$router.replace({
                        query: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.$route.query, {
                            statusSearch: '',
                            isJobTransfer: ''
                        })
                    });
                    return true;
                }
            }
            return true;
        },
        extendParamsBeforeFetch: function extendParamsBeforeFetch() {
            var interviewId = parseInt(this.$route.params.id);
            if (interviewId === 0) {
                return {
                    turnType: 'RESUME_STATUS_' + (interviewId + 1)
                };
            }
            return {
                turnType: 'RESUME_STATUS_' + (interviewId + 1),
                employPhase: '' + (interviewId - 1)
            };
        },
        recommendResume: function recommendResume(item) {
            this.$refs.recommendResumeDialog.show(item);
        },
        getArrangementUrl: function getArrangementUrl(id) {
            var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.$route.name;
            var turn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.$route.params.id;

            return '/arrangement/' + id + '?fromName=' + from + '&turn=' + turn;
        },
        checkPaymentData: function checkPaymentData() {
            var names = [],
                namesObj = {};
            this.multipleSelection.forEach(function (item) {
                if (item.positionForm.paymentState !== 1 && !namesObj[item.positionForm.name]) {
                    namesObj[item.positionForm.name] = true;
                    names.push(item.positionForm.name);
                }
            });
            if (names.length === 0) {
                this.changeStatus(this.idStr, 'payment');
            } else {
                var str = [];
                var h = this.$createElement;
                str.push(h('p', { style: 'color: #000' }, '\u4EE5\u4E0B\u804C\u4F4D\u5C1A\u672A\u8BBE\u7F6E\u5B9A\u85AA\u89C4\u5219\uFF0C\u8BF7\u5148\u8BBE\u7F6E\u540E\u518D\u64CD\u4F5C\u5B9A\u85AA\uFF1A'));
                str.push(h('p', { style: 'color: #ff0000' }, '' + names.join('、')));
                var target = event.target;
                if (target.nodeName === 'SPAN' || target.nodeName === 'I') {
                    target = event.target.parentNode;
                }
                target.blur();
                this.$msgbox({
                    customClass: 'resume-state-wpr',
                    title: '\u63D0\u793A',
                    confirmButtonText: '我知道了',
                    message: h('div', null, str),
                    type: 'warning'
                });
            }
        },
        toResumeDetail: function toResumeDetail(row) {
            var path = this.getResumeDetailUrl(row.id, row.status) + ('&turn=' + this.$route.params.id);

            var routeData = this.$router.resolve({ path: path });
            window.open(routeData.href, '_blank');
        },
        getPositionTipText: function getPositionTipText(row) {
            var oldPositionName = row.oldPositionName,
                newPositionName = row.newPositionName,
                isJobTransfer = row.isJobTransfer;


            if (isJobTransfer == 1 && newPositionName) {
                return '\u5DF2\u8F6C\u5C97\u5230' + newPositionName + '\u804C\u4F4D';
            } else {
                return '\u8F6C\u5C97\u524D\uFF1A' + oldPositionName + '\u804C\u4F4D';
            }
        },
        getStatusText: function getStatusText(row) {
            if (row.isJobTransfer == 1) {
                return '已转岗';
            }

            return this.getSelectMapText(this.RESUME_STATUS_ALL, row.status);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fa14abb"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/interview/interviewList.vue
var interviewList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.firstRendered) ? _c('div', [_c('div', {
    staticClass: "filter-condition box-shadow-small border-radius"
  }, [_c('multi-search', {
    key: _vm.$route.params.id,
    ref: "MultiSearch",
    attrs: {
      "fields": _vm.multiFields
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "filter-result background-white box-shadow-small border-radius"
  }, [_c('div', {
    staticClass: "filter-result-header mt-15 clearfix"
  }, [_c('el-row', {
    staticStyle: {
      "flex-wrap": "wrap"
    },
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('el-col', {
    staticStyle: {
      "width": "auto"
    },
    attrs: {
      "id": "btnsone"
    }
  }, [_c('el-dropdown', [_c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("批量操作"), _c('i', {
    staticClass: "el-icon-caret-bottom el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.multiArrangement($event)
      }
    }
  }, [_vm._v("批量面试安排")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.multiChangePosition(_vm.idStr)
      }
    }
  }, [_vm._v("批量修改职位")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.syncToSupplier(_vm.idStr)
      }
    }
  }, [_vm._v("批量同步供应商")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.multiRemarkEdit(_vm.idStr)
      }
    }
  }, [_vm._v("批量修改备注")])], 1)], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-mianshianpai",
      "plain": true,
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.myArrangement.show()
      }
    }
  }, [_vm._v("我的面试安排\n                    ")]), _vm._v(" "), _c('el-dropdown', {
    staticClass: "ml-10 mr-10"
  }, [_c('el-button', {
    attrs: {
      "icon": "el-icon-my-daochu",
      "type": "info"
    }
  }, [_vm._v("导出简历"), _c('i', {
    staticClass: "el-icon-caret-bottom el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.exportFiles(_vm.idStr)
      }
    }
  }, [_vm._v("导出已选记录(excel)")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.exportFiles(_vm.idStr, undefined, undefined, 'type=HTML')
      }
    }
  }, [_vm._v("导出已选记录(html)")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        _vm.exportParamsFiles('/employ/exportAllResume.api?employPhase=' + Number(_vm.$route.params.id - 1))
      }
    }
  }, [_vm._v("\n                                导出所有查询结果(excel)\n                            ")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        _vm.exportParamsFiles('/employ/exportAllResume.api?employPhase=' + Number(_vm.$route.params.id - 1), 'HTML')
      }
    }
  }, [_vm._v("\n                                导出所有查询结果(html)\n                            ")])], 1)], 1), _vm._v(" "), (false) ? _c('el-button', {
    attrs: {
      "icon": "el-icon-my-daochu",
      "plain": true,
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.download()
      }
    }
  }, [_vm._v("导出面试评价")]) : _vm._e(), _vm._v(" "), _c('export-custom-dialog', {
    attrs: {
      "valid-call-back": _vm.customExportValid,
      "params-call-back": _vm.customExportParams
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "width": "auto"
    },
    attrs: {
      "id": "btnstwo"
    }
  }, [(_vm.lists.length) ? _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "end"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.resetInterview(_vm.idStr)
      }
    }
  }, [_vm._v("重置面试安排\n                        ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-queding color-success",
      "type": "success",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.idStr, 'pass')
      }
    }
  }, [_vm._v("通过\n                        ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-daiding color-warning",
      "type": "warning",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.idStr, 'undetermined')
      }
    }
  }, [_vm._v("待定\n                        ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-guanbi color-danger",
      "type": "danger",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.idStr, 'notPass')
      }
    }
  }, [_vm._v("淘汰\n                        ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-lahei color-purple",
      "type": "purple",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.idStr, 'lh')
      }
    }
  }, [_vm._v("拉黑\n                        ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-huitui color-info",
      "type": "info",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.idStr, 'back')
      }
    }
  }, [_vm._v("回退\n                        ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-guanbi color-danger",
      "type": "danger",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.idStr, 'fq')
      }
    }
  }, [_vm._v("放弃\n                        ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-queding color-success",
      "type": "success",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.idStr, 'entry')
      }
    }
  }, [_vm._v("进入入职\n                        ")]), _vm._v(" "), (_vm.$store.state.user.paymentFlag) ? _c('el-button', {
    attrs: {
      "icon": "el-icon-my-queding color-success",
      "type": "success",
      "plain": true
    },
    on: {
      "click": _vm.checkPaymentData
    }
  }, [_vm._v("进入定薪\n                        ")]) : _vm._e()], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.partialLoading),
      expression: "partialLoading"
    }]
  }, [_c('empty-tip', {
    attrs: {
      "show": !_vm.lists.length
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "table-list mt-20"
  }, [(_vm.lists.length) ? _c('el-table', {
    attrs: {
      "data": _vm.lists
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center",
      "fixed": "",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "姓名",
      "align": "center",
      "fixed": "",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "name-txt eclip-name-txt",
          attrs: {
            "title": scope.row.resumeForm.name
          },
          on: {
            "click": function($event) {
              return _vm.toResumeDetail(scope.row)
            }
          }
        }, [_vm._v("\n                                " + _vm._s(scope.row.resumeForm.name) + "\n                            ")]), _vm._v(" "), (scope.row.iaId > 0) ? _c('el-tag', {
          staticClass: "pull-right",
          attrs: {
            "type": "success",
            "title": "已安排面试"
          }
        }, [_vm._v("排\n                            ")]) : _vm._e()]
      }
    }], null, false, 1646321192)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resumeForm.gender",
      "label": "性别",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "70"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s({
          1: '男',
          2: '女'
        }[scope.row.resumeForm.gender] || '-'))]
      }
    }], null, false, 3168019877)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "岗位",
      "align": "center",
      "class-name": "no-wrap",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.oldPositionName || scope.row.newPositionName) ? _c('el-tooltip', {
          attrs: {
            "effect": "dark",
            "content": _vm.getPositionTipText(scope.row),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text",
            "icon": "el-icon-my-xinxi"
          }
        })], 1) : _vm._e(), _vm._v(" "), _c('span', {
          attrs: {
            "title": scope.row.positionForm.name
          }
        }, [_vm._v(_vm._s(scope.row.positionForm.name))])]
      }
    }], null, false, 455889647)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "招聘部门",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.positionForm.deptNames) + "\n                        ")]
      }
    }], null, false, 2934477005)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resumeForm.mobilePhone",
      "label": "手机号",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resumeForm.email",
      "show-overflow-tooltip": true,
      "label": "邮箱",
      "align": "center",
      "min-width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.resumeForm.email || '-') + "\n                        ")]
      }
    }], null, false, 2903445021)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resumeForm.resumeMaxEducation.major",
      "label": "最高学历",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.getSelectMapText('WB_EDU_DEGREE', scope.row.resumeForm.resumeMaxEducation.degree)) + "\n                        ")]
      }
    }], null, false, 433538694)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resumeForm.resumeMaxEducation.school",
      "label": "最高学历学校",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resumeForm.resumeMaxEducation.major",
      "label": "专业",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "source",
      "show-overflow-tooltip": true,
      "label": "简历来源",
      "align": "center",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.resumeForm && _vm.transToText('WB_RESUME_SOURCE',
          scope.row.resumeForm.resumeSource)) + "\n                        ")]
      }
    }], null, false, 2622597149)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "当前所在地",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.resumeForm.residence || '-') + "\n                        ")]
      }
    }], null, false, 3375146197)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "应聘城市",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.getSelectMapText('WB_POSITION_CITY', scope.row.resumeForm.expectCityId)) + "\n                        ")]
      }
    }], null, false, 2621839696)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "positionForm.sourceFrom",
      "label": "投递渠道",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.resumeForm && _vm.getSelectMapText('WB_ADD_SOURCE',
          scope.row.resumeForm.addSource)) + "\n                        ")]
      }
    }], null, false, 3698601694)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "投递人",
      "prop": "resumeForm.addName",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "推荐人",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.resumeForm.recommenderUser) ? _c('span', [_vm._v(_vm._s(scope.row.resumeForm.recommenderUser.name))]) : _vm._e()]
      }
    }], null, false, 2383682320)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "游戏经验",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.resumeForm.gameExperience) + "\n                        ")]
      }
    }], null, false, 3038609676)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "简历附件",
      "align": "center",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('attach-view-in-list', {
          attrs: {
            "attachList": scope.row.resumeForm.resumeAttachList
          }
        })]
      }
    }], null, false, 2021903071)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "投递时间",
      "show-overflow-tooltip": true,
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm.dateFormat(scope.row.commitTime)))]
      }
    }], null, false, 3274253775)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.operateReason) ? _c('el-tooltip', {
          attrs: {
            "effect": "dark",
            "content": scope.row.operateReason,
            "placement": "top-start"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text",
            "icon": "el-icon-my-xinxi"
          }
        }, [_vm._v(_vm._s(_vm.getStatusText(scope.row)) + "\n                                ")])], 1) : _c('span', [_vm._v(_vm._s(_vm.getStatusText(scope.row)))])]
      }
    }], null, false, 2141505024)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "同步供应商",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.getSelectMapText('WB_SYNC_STATUS', scope.row.resumeForm.isSync)))])]
      }
    }], null, false, 3131267630)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "class-name": "no-wrap",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-dropdown', {
          staticClass: "mr-5",
          attrs: {
            "hide-on-click": false
          },
          on: {
            "command": _vm.handleCommand
          }
        }, [_c('span', {
          staticClass: "el-dropdown-link"
        }, [_vm._v("面试评估")]), _vm._v(" "), _c('el-dropdown-menu', {
          attrs: {
            "slot": "dropdown"
          },
          slot: "dropdown"
        }, [_c('el-dropdown-item', {
          attrs: {
            "command": ((scope.row.id) + "/pass")
          }
        }, [_c('i', {
          staticClass: "el-icon-my-queding color-success mr-10"
        }), _vm._v("通过\n                                    ")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": ((scope.row.id) + "/undetermined")
          }
        }, [_c('i', {
          staticClass: "el-icon-my-daiding color-warning mr-10"
        }), _vm._v("待定\n                                    ")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": ((scope.row.id) + "/notPass")
          }
        }, [_c('i', {
          staticClass: "el-icon-my-guanbi color-danger mr-10"
        }), _vm._v("淘汰\n                                    ")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": ((scope.row.id) + "/lh")
          }
        }, [_c('i', {
          staticClass: "el-icon-my-lahei color-purple mr-10"
        }), _vm._v("拉黑\n                                    ")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": ((scope.row.id) + "/back")
          }
        }, [_c('i', {
          staticClass: "el-icon-my-huitui color-info mr-10"
        }), _vm._v("回退\n                                    ")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": ((scope.row.id) + "/fq")
          }
        }, [_c('i', {
          staticClass: "el-icon-my-guanbi color-danger mr-10"
        }), _vm._v("放弃\n                                    ")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": ((scope.row.id) + "/entry")
          }
        }, [_c('i', {
          staticClass: "el-icon-my-queding color-success mr-10"
        }), _vm._v("进入入职\n                                    ")]), _vm._v(" "), (_vm.$store.state.user.paymentFlag && scope.row.positionForm.paymentState == 1) ? _c('el-dropdown-item', {
          attrs: {
            "command": ((scope.row.id) + "/payment")
          }
        }, [_c('i', {
          staticClass: "el-icon-my-queding color-success mr-10"
        }), _vm._v("进入定薪\n                                    ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('router-link', {
          attrs: {
            "to": _vm.getArrangementUrl(scope.row.id)
          }
        }, [_vm._v("面试安排")])]
      }
    }], null, false, 111580810)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resumeForm.remark",
      "show-overflow-tooltip": true,
      "label": "备注",
      "align": "center",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('remark-edit', {
          attrs: {
            "id": scope.row.resumeForm.id
          },
          model: {
            value: (scope.row.resumeForm.remark),
            callback: function($$v) {
              _vm.$set(scope.row.resumeForm, "remark", $$v)
            },
            expression: "scope.row.resumeForm.remark"
          }
        })]
      }
    }], null, false, 1691095712)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resumeForm.remark",
      "label": "最近操作人",
      "align": "center",
      "min-width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticStyle: {
            "font-size": "12px"
          }
        }, [_c('p', [_vm._v(_vm._s(scope.row.lastOperateUserInfo ? scope.row.lastOperateUserInfo.name : ''))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(scope.row.lastOperateTime && scope.row.lastOperateTime.slice(5)))])])]
      }
    }], null, false, 4062077065)
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.lists.length) ? _c('el-pagination', {
    staticClass: "text-center mt-20 mb-20",
    attrs: {
      "current-page": _vm.pagination.pageIndex,
      "page-size": _vm.pagination.pageSize,
      "page-sizes": [20, 50, 100, 200],
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.pagination.recordCounts
    },
    on: {
      "size-change": _vm.pageSizeChange,
      "current-change": _vm.pageIndexChange
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('MyArrangementListDialog', {
    ref: "myArrangement"
  }), _vm._v(" "), _c('change-position-dialog', {
    ref: "changePositionDialog",
    on: {
      "reload": _vm.fetchData
    }
  }), _vm._v(" "), _c('multi-remark-edit-dialog', {
    ref: "multiRemarkEditDialog",
    on: {
      "reload": _vm.fetchData
    }
  })], 1) : _vm._e()
}
var interviewList_staticRenderFns = []
var interviewList_esExports = { render: interviewList_render, staticRenderFns: interviewList_staticRenderFns }
/* harmony default export */ var interview_interviewList_defaultExport = (interviewList_esExports);
// CONCATENATED MODULE: ./src/views/interview/interviewList.vue
function interviewList_injectStyle (ssrContext) {
  __webpack_require__(888)
}
var interviewList_normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var interviewList___vue_styles__ = interviewList_injectStyle
/* scopeId */
var interviewList___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var interviewList___vue_module_identifier__ = null
var interviewList_Component = interviewList_normalizeComponent(
  interviewList_defaultExport,
  interview_interviewList_defaultExport,
  interviewList___vue_styles__,
  interviewList___vue_scopeId__,
  interviewList___vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (interviewList_Component.exports);


/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(889);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("1447c136", content, true);

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(891);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("2a47379a", content, true);

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".el-pagination .el-pagination__total[data-v-17e4b046]{margin-top:-3px}", ""]);

// exports


/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/operation/arrangeSalaryDialog.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fetchPositionListMixin__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_userSelect_searchDownList__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mixins_selectMapMixin__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mixins_formCommonMixin__ = __webpack_require__(25);









var FormModel = {
    evaluatorId: null,
    ids: '',
    isEmail: 1,
    isPoPo: 1
};
/* harmony default export */ var arrangeSalaryDialog_defaultExport = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_2__fetchPositionListMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4_mixins_selectMapMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5_mixins_formCommonMixin__["a" /* default */]],
    data: function data() {
        return {
            showDialog: false,
            isSingle: true,
            confirmInfo: {
                name: '',
                gender: '',
                phone: '',
                email: '',
                position: '',
                school: '',
                evaluator: []
            },
            multiConfirmInfo: [],
            preventKey: 1,
            ruleForm: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, FormModel),
            rules: {
                evaluatorId: { required: true, pattern: /\d+/, message: '请输入评估人', trigger: 'blur,change' }
            }
        };
    },

    methods: {
        show: function show(data) {
            var single = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            var paymentMessageList = arguments[2];

            this.preventKey = +new Date();
            this.isSingle = single;
            this.ruleForm = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, FormModel);
            this.ruleForm.isEmail = (paymentMessageList.filter(function (item) {
                return item.type === 'email';
            })[0] || {}).value;
            this.ruleForm.isPoPo = (paymentMessageList.filter(function (item) {
                return item.type === 'popo';
            })[0] || {}).value;
            if (this.isSingle) {
                this.multiConfirmInfo = [data];
                console.log(data.paymentEvaluationForm.id);
                this.confirmInfo = {
                    name: data.resumeForm.name,
                    gender: data.resumeForm.gender,
                    phone: data.resumeForm.mobilePhone,
                    email: data.resumeForm.email,
                    position: data.positionForm.name,
                    school: data.resumeForm.resumeMaxEducation.school,
                    sLevel: data.resumeForm.resumeMaxEducation.sLevel
                };
                this.ruleForm.ids = data.id;
                this.showDialog = true;
            } else {
                this.multiConfirmInfo = data;
                this.ruleForm.ids = data.map(function (item) {
                    return item.id;
                }).join(',');
                this.ruleForm.evaluatorId = '';
                this.showDialog = true;
            }
        },
        getTitle: function getTitle() {
            return this.isSingle ? '定薪安排' : '定薪批量安排';
        },
        saveForm: function saveForm(boolean) {
            var _this = this;

            if (!this.isSingle && this.multiConfirmInfo.length === 0) {
                this.$message({
                    type: 'warning',
                    message: '请勾选数据'
                });
                return false;
            }
            var resumePositionIdArr = [],
                types = [],
                ignoreData = [],
                ignoreId = [];
            this.multiConfirmInfo.forEach(function (item) {
                resumePositionIdArr.push(item.id);
                if (item.paymentEvaluationForm.id && item.paymentEvaluationForm.status === 2) {
                    ignoreData.push(item.resumeForm.name);
                    ignoreId.push(item.id);
                }
            });
            if (ignoreData.length) {
                resumePositionIdArr = resumePositionIdArr.filter(function (v) {
                    return !ignoreId.includes(v);
                });
                if (!resumePositionIdArr.length) {
                    this.$message({
                        type: 'info',
                        message: '所选记录已被评估，请重新选择'
                    });
                    return;
                }
                this.$confirm(ignoreData.join('、') + '\u7684\u5B9A\u85AA\u8BC4\u4F30\u5DF2\u5B8C\u6210\uFF0C\u4E0D\u53EF\u518D\u6B21\u5B89\u6392\uFF0C\u5C06\u5FFD\u7565\u6B64\u6570\u636E', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    _this.submitData(resumePositionIdArr, types);
                }).catch(function (e) {});
            } else {
                this.submitData(resumePositionIdArr, types);
            }
        },
        submitData: function submitData(resumePositionIdArr, types) {
            var _this2 = this;

            console.log(this.ruleForm.isEmail, this.ruleForm.isPoPo);
            this.ruleForm.isEmail === 1 && types.push('email');
            this.ruleForm.isPoPo === 1 && types.push('popo');
            this.$axios.post('/payment/insert.api', {
                operators: this.ruleForm.evaluatorId instanceof Array ? this.ruleForm.evaluatorId[0] : this.ruleForm.evaluatorId,
                resumePositionIds: resumePositionIdArr.join(','),
                messageTypes: types.join(',')
            }, { 'X-showMessage': true }).then(function (res) {
                _this2.showDialog = false;
                _this2.$emit('reload');
                _this2.saveDefaultMessageType();
            }).catch(console.error);
        },
        saveDefaultMessageType: function saveDefaultMessageType() {
            var types = [];
            types.push({ type: 'email', value: Number(this.ruleForm.isEmail) });
            types.push({ type: 'popo', value: Number(this.ruleForm.isPoPo) });
            this.$axios.post('/payment/changeMessage.api', {
                dataList: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(types)
            }, { 'X-showMessage': false }).then(function (res) {}).catch(console.error);
        }
    },
    components: {
        UserSearch: __WEBPACK_IMPORTED_MODULE_3_components_userSelect_searchDownList__["a" /* default */]
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aee57440"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/operation/arrangeSalaryDialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "recommend-resume-dialog",
    attrs: {
      "title": _vm.getTitle(),
      "visible": _vm.showDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.showDialog = $event
      }
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#999",
      "margin": "-10px 20px 10px"
    }
  }, [_c('i', {
    staticClass: "el-icon-my-xinxi"
  }), _vm._v("已评估的数据不可重新安排，将被忽略")]), _vm._v(" "), _c('div', {
    key: _vm.preventKey + 'a',
    staticClass: "content-confirm border-radius"
  }, [_c('h1', {
    staticClass: "text-center"
  }, [_vm._v("候选人信息")]), _vm._v(" "), (_vm.isSingle) ? _c('el-row', [_c('el-col', [_c('p', [_c('span', [_vm._v("候选人：" + _vm._s(_vm.confirmInfo.name))]), _vm._v(" "), _c('span', {
    staticClass: "ml-20"
  }, [_vm._v("性别：" + _vm._s(_vm.getSelectMapText('WB_GENDER', _vm.confirmInfo.gender) || '-'))]), _vm._v(" "), _c('span', {
    staticClass: "ml-20"
  }, [_vm._v("手机号：" + _vm._s(_vm.confirmInfo.phone))]), _vm._v(" "), _c('span', {
    staticClass: "ml-20"
  }, [_vm._v("邮箱：" + _vm._s(_vm.confirmInfo.email))])]), _vm._v(" "), _c('p', {
    staticClass: "mt-10"
  }, [_vm._v("当前职位：" + _vm._s(_vm.confirmInfo.position)), _c('span', {
    staticClass: "ml-20"
  }, [_vm._v("最高学历学校：" + _vm._s(_vm.confirmInfo.school))]), (_vm.confirmInfo.sLevel) ? _c('span', [_vm._v("【" + _vm._s(_vm.confirmInfo.sLevel) + "】")]) : _vm._e()])])], 1) : _c('el-table', {
    attrs: {
      "data": _vm.multiConfirmInfo
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "候选人",
      "prop": "resumeForm.name",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "性别",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm.getSelectMapText('WB_GENDER', scope.row.resumeForm.gender) || '-'))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "手机号",
      "prop": "resumeForm.mobilePhone",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "邮箱",
      "prop": "resumeForm.email",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "prop": "name",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                    " + _vm._s(scope.row.paymentEvaluationForm.status === null ? '未安排' : {
          1: '未评估',
          2: '已评估'
        }[scope.row.paymentEvaluationForm.status]) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "prop": "positionForm.name",
      "align": "center",
      "min-width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticStyle: {
            "color": "#ff4949"
          },
          attrs: {
            "icon": "el-icon-my-guanbi",
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.multiConfirmInfo.splice(scope.$index, 1)
            }
          }
        })]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-form', {
    key: _vm.preventKey + 'b',
    ref: "ruleForm",
    staticClass: "form-beauty",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "评估人",
      "prop": "evaluatorId"
    }
  }, [_c('user-search', {
    ref: "evaluator",
    attrs: {
      "cacheOptions": _vm.confirmInfo.evaluator
    },
    model: {
      value: (_vm.ruleForm.evaluatorId),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "evaluatorId", $$v)
      },
      expression: "ruleForm.evaluatorId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "消息提醒"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "true-label": 1,
      "false-label": 0,
      "label": "邮件"
    },
    model: {
      value: (_vm.ruleForm.isEmail),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "isEmail", $$v)
      },
      expression: "ruleForm.isEmail"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "true-label": 1,
      "false-label": 0,
      "label": "泡泡"
    },
    model: {
      value: (_vm.ruleForm.isPoPo),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "isPoPo", $$v)
      },
      expression: "ruleForm.isPoPo"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showDialog = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("确认")])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var operation_arrangeSalaryDialog_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/views/operation/arrangeSalaryDialog.vue
function injectStyle (ssrContext) {
  __webpack_require__(895)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  arrangeSalaryDialog_defaultExport,
  operation_arrangeSalaryDialog_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var views_operation_arrangeSalaryDialog_defaultExport = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/operation/arrangeTooltips.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui__);





/* harmony default export */ var arrangeTooltips_defaultExport = ({
    data: function data() {
        return {
            baseData: [{
                text: '一面面试官',
                value: '张三、李四、王五'
            }]
        };
    },

    props: {
        stateName: '',
        showIcon: {
            type: Boolean,
            default: true
        },
        id: ''
    },
    methods: {
        show: function show() {
            var _this = this;

            this.loadingInstance = __WEBPACK_IMPORTED_MODULE_1_element_ui__["Loading"].service({
                target: document.querySelector('.arrangement-info-tooltip-wpr')
            });
            var CancelToken = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.CancelToken;
            this.source = CancelToken.source();
            this.ajax = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/employ/listEval.api?id=' + this.id, {
                cancelToken: this.source.token,
                'X-loadingOff': true
            }).then(function (res) {
                _this.baseData = res.result.list;
                _this.loadingInstance.close();
                _this.ajax = null;
            }).catch(function () {});
        },
        hide: function hide() {
            this.loadingInstance.close();
            if (this.ajax) {
                this.source.cancel('不要啦，我关闭不看了');
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0dfdbefe"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/operation/arrangeTooltips.vue
var arrangeTooltips_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-popover', {
    ref: "popover",
    attrs: {
      "placement": "top-end",
      "visible-arrow": false,
      "trigger": "hover"
    },
    on: {
      "show": _vm.show,
      "hide": _vm.hide
    }
  }, [_c('div', {
    staticClass: "arrangement-info-tooltip-wpr"
  }, [_c('table', {
    staticClass: "table text-center arrangement-info"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-hd"
  }, [_c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "80"
    }
  }, [_vm._v("阶段")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "200"
    }
  }, [_vm._v("结果")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.baseData), function(item, index) {
    return _c('tr', {
      staticClass: "border-row"
    }, [_c('td', {
      staticClass: "text-td"
    }, [_vm._v(_vm._s(item.text))]), _vm._v(" "), _c('td', {
      staticClass: "text-td"
    }, [_vm._v(_vm._s(item.value))])])
  }), 0)])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "popover",
      rawName: "v-popover:popover",
      arg: "popover"
    }],
    staticStyle: {
      "font-size": "12px"
    }
  }, [_c('span', {
    staticClass: "state-name"
  }, [_vm._v(_vm._s(_vm.stateName))]), _c('i', {
    staticClass: "el-icon-my-tishi color-warning"
  })])], 1)
}
var arrangeTooltips_staticRenderFns = []
var arrangeTooltips_esExports = { render: arrangeTooltips_render, staticRenderFns: arrangeTooltips_staticRenderFns }
/* harmony default export */ var operation_arrangeTooltips_defaultExport = (arrangeTooltips_esExports);
// CONCATENATED MODULE: ./src/views/operation/arrangeTooltips.vue
function arrangeTooltips_injectStyle (ssrContext) {
  __webpack_require__(899)
}
var arrangeTooltips_normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var arrangeTooltips___vue_styles__ = arrangeTooltips_injectStyle
/* scopeId */
var arrangeTooltips___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var arrangeTooltips___vue_module_identifier__ = null
var arrangeTooltips_Component = arrangeTooltips_normalizeComponent(
  arrangeTooltips_defaultExport,
  operation_arrangeTooltips_defaultExport,
  arrangeTooltips___vue_styles__,
  arrangeTooltips___vue_scopeId__,
  arrangeTooltips___vue_module_identifier__
)

/* harmony default export */ var views_operation_arrangeTooltips_defaultExport = (arrangeTooltips_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/operation/salaryEditDialog.vue


/* harmony default export */ var salaryEditDialog_defaultExport = ({
    data: function data() {
        return {
            salary: '',
            showDialog: false
        };
    },

    props: {
        id: '',
        value: ''
    },
    watch: {
        value: function value(val) {
            this.salary = val;
        }
    },
    methods: {
        showEditDialog: function showEditDialog() {
            this.salary = this.value;
            this.showDialog = true;
        },
        submitForm: function submitForm() {
            var _this = this;

            if (this.salary) {
                this.$axios.post('/desktop/task/updateExpectSalary.api', {
                    id: this.id,
                    expectSalary: this.salary
                }).then(function (res) {
                    _this.$emit('input', _this.salary);
                    _this.$message.success('更新成功');
                    _this.showDialog = false;
                });
            } else {
                this.$message.warning('请输入期望薪资');
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54fb896a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/operation/salaryEditDialog.vue
var salaryEditDialog_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', [_c('span', {
    staticClass: "salary-desc",
    attrs: {
      "title": _vm.value
    }
  }, [_vm._v(_vm._s(_vm.value))]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-my-bishi edit-salary-btn",
    on: {
      "click": _vm.showEditDialog
    }
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑期望薪资",
      "visible": _vm.showDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.showDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "form-beauty",
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "期望薪资",
      "prop": "salary"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 500,
      "type": "number",
      "min": 0,
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.salary),
      callback: function($$v) {
        _vm.salary = _vm._n($$v)
      },
      expression: "salary"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.showDialog = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)
}
var salaryEditDialog_staticRenderFns = []
var salaryEditDialog_esExports = { render: salaryEditDialog_render, staticRenderFns: salaryEditDialog_staticRenderFns }
/* harmony default export */ var operation_salaryEditDialog_defaultExport = (salaryEditDialog_esExports);
// CONCATENATED MODULE: ./src/views/operation/salaryEditDialog.vue
function salaryEditDialog_injectStyle (ssrContext) {
  __webpack_require__(901)
}
var salaryEditDialog_normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var salaryEditDialog___vue_styles__ = salaryEditDialog_injectStyle
/* scopeId */
var salaryEditDialog___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var salaryEditDialog___vue_module_identifier__ = null
var salaryEditDialog_Component = salaryEditDialog_normalizeComponent(
  salaryEditDialog_defaultExport,
  operation_salaryEditDialog_defaultExport,
  salaryEditDialog___vue_styles__,
  salaryEditDialog___vue_scopeId__,
  salaryEditDialog___vue_module_identifier__
)

/* harmony default export */ var views_operation_salaryEditDialog_defaultExport = (salaryEditDialog_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/operation/salaryEmailDialog.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_userSelect_searchDownList__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_userSelect_userSelect__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_fileUpload__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_tools__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_underscore__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_vueditor__ = __webpack_require__(232);












/* harmony default export */ var salaryEmailDialog_defaultExport = ({
    components: {
        Vueditor: __WEBPACK_IMPORTED_MODULE_8_components_vueditor__["a" /* default */], UserSearch: __WEBPACK_IMPORTED_MODULE_2_components_userSelect_searchDownList__["a" /* default */], FileUpload: __WEBPACK_IMPORTED_MODULE_4_components_fileUpload__["a" /* default */], UserGroup: __WEBPACK_IMPORTED_MODULE_3_components_userSelect_userSelect__["a" /* default */]
    },
    data: function data() {
        return {
            dialogFormVisible: false,
            renderKey: 1,
            params: null,
            isPreview: false,
            dataList: [{ provider: '南油外服', number: 5, users: [{ name: '张三', email: 'test1@163.com' }, { name: '李四', email: 'test2@163.com' }, { name: '王五', email: 'test3@163.com' }] }, { provider: '软通', number: 2, users: [{ name: '张三', email: 'test1@163.com' }, { name: '李四', email: 'test2@163.com' }, { name: '王五', email: 'test3@163.com' }] }, { provider: '中科', number: 3, users: [{ name: '张三', email: 'test1@163.com' }, { name: '李四', email: 'test2@163.com' }] }],
            form: {
                name: '',
                sendEmail: '',
                recipients: [],
                ccList: [],
                delivery: false,
                mailAttachInfos: [],
                hrAttachIds: [],
                content: '',
                contentCode: ''
            },
            fileList: [],
            placeHolders: [],
            baseData: null,
            formLabelWidth: '120px',
            uploadData: {
                code: '',
                fileType: 'upload'
            },
            emailTemplate: '',
            emailTemplateList: [],
            recipients: '',
            recipientsDisabled: false,
            rpIds: []
        };
    },

    methods: {
        togglerUserActive: function togglerUserActive(item) {
            var _this = this;

            this.$nextTick(function () {
                item.disabled = !item.disabled;
                if (_this.dataList.every(function (cv) {
                    return cv.contactList && cv.contactList.length && cv.contactList.every(function (item) {
                        return item.disabled;
                    }) || cv.contactList && !cv.contactList.length;
                })) {
                    _this.recipientsDisabled = false;
                } else {
                    _this.recipientsDisabled = true;
                }
            });
        },
        updateData: function updateData(data) {
            this.form.contentCode = data;
        },
        toEditView: function toEditView() {
            this.isPreview = false;
        },
        getEmailTemplate: function getEmailTemplate() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var res;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this2.$axios.get('/system/mailTemplate/listByPhase.api?phase=3');

                            case 2:
                                res = _context.sent;

                                _this2.emailTemplateList = res.status ? res.result.list : [];

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        show: function show(params) {
            var _this3 = this;

            this.getEmailTemplate();
            var rpIds = params.map(function (item) {
                return item.id;
            }).join(',');
            this.rpIds = params.map(function (item) {
                return item.id;
            });
            this.$axios.post('/payment/supplierNotifyPanelInfo.api?rpIds=' + rpIds).then(function (res) {
                _this3.dataList = res.result.supplierInfo;
                if (_this3.dataList) {
                    _this3.dataList.forEach(function (cv) {
                        if (cv.contactList && cv.contactList.length) {
                            cv.contactList.map(function (item) {
                                _this3.$set(item, 'disabled', true);
                            });
                        }
                    });
                }
                _this3.recipientsDisabled = false;
                _this3.placeHolders = res.result.placeHolders;
                _this3.fileList = [];
                _this3.params = params;
                _this3.isPreview = false;
                _this3.emailTemplate = '';
                _this3.form.name = '';

                _this3.$refs.ccList && _this3.$refs.ccList.$refs.select && _this3.$refs.ccList.$refs.select.reset();
                _this3.form.delivery = false;
                _this3.form.content = '';
                _this3.form.contentCode = '';
                _this3.renderKey++;
                _this3.$refs.editor && (_this3.$refs.editor.lastRange = null);
                _this3.dialogFormVisible = true;
            });
        },
        checkForm: function checkForm() {
            if (this.form.name === '') {
                this.$message({
                    message: '邮件标题不能为空',
                    type: 'warning'
                });
                return false;
            }
            if (this.form.contentCode === '') {
                this.$message({
                    message: '邮件内容不能为空',
                    type: 'warning'
                });
                return false;
            }
            return true;
        },
        previewEmailByRecipients: function previewEmailByRecipients() {
            var _this4 = this;

            if (this.checkForm() === false) {
                return false;
            }
            if (this.recipientsDisabled) {
                this.$message({
                    message: '仅支持供应商对接人为空时预览',
                    type: 'warning'
                });
                return false;
            }
            if (this.$refs.recipients.getSelected().length <= 0) {
                this.$message({
                    message: '收件人不能为空',
                    type: 'warning'
                });
                return false;
            }
            this.form.ccList = this.$refs.ccList.getSelected();
            this.interviewerUsers = this.$refs.recipients.getSelected();
            var params = {
                name: this.form.name,
                receivers: [{
                    rpIds: this.rpIds
                }],
                content: this.form.contentCode + this.getSign(),
                ccs: this.form.ccList.map(function (item) {
                    var id = void 0;
                    if (item.id < 0) {
                        id = item.id;
                    } else {
                        id = /^\d+$/.test(item.id) ? item.id : null;
                    }
                    return {
                        id: id,
                        name: item.name
                    };
                })
            };
            var url = '/payment/supplierNotifyPreview.api';
            __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(url, params, {
                'X-JSON': true
            }).then(function (res) {
                _this4.form.content = res.result.content;
                _this4.isPreview = true;
            }).catch(function () {});
        },
        previewEmail: function previewEmail(data) {
            var _this5 = this;

            if (this.checkForm() === false) {
                return false;
            }
            this.form.ccList = this.$refs.ccList.getSelected();

            this.interviewerUsers = data.contactList.filter(function (item) {
                return item.disabled !== true;
            }) || [];
            if (this.$refs.recipients.getSelected().length > 0) {
                this.interviewerUsers = this.interviewerUsers.concat(this.$refs.recipients.getSelected());
            }
            if (this.interviewerUsers.length === 0) {
                this.$message({
                    message: '供应商对接人不能为空',
                    type: 'warning'
                });
                return false;
            }
            var params = {
                name: this.form.name,
                receivers: [{
                    supplierCode: data.supplierCode,
                    rpIds: data.rpIdList,
                    emails: this.interviewerUsers.map(function (item) {
                        return item.email;
                    })
                }],
                content: this.form.contentCode + this.getSign(),
                ccs: this.form.ccList.map(function (item) {
                    var id = void 0;
                    if (item.id < 0) {
                        id = item.id;
                    } else {
                        id = /^\d+$/.test(item.id) ? item.id : null;
                    }
                    return {
                        id: id,
                        name: item.name
                    };
                })
            };
            var url = '/payment/supplierNotifyPreview.api';
            __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(url, params, {
                'X-JSON': true
            }).then(function (res) {
                _this5.form.content = res.result.content;
                _this5.isPreview = true;
            }).catch(function () {});
        },
        sendEmail: function sendEmail() {
            var _this6 = this;

            if (this.checkForm() === false) {
                return false;
            }
            var url = '/payment/supplierNotify.api';

            if (this.$refs.ccList) {
                this.form.ccList = this.$refs.ccList.getSelected();
            }
            var emailLength = 0;
            var params = {
                receivers: this.dataList.map(function (data) {
                    var emails = data.contactList.filter(function (item) {
                        return item.disabled !== true;
                    }).map(function (item) {
                        return item.email;
                    });
                    if (emails.length) {
                        emailLength += 1;
                    }
                    return {
                        supplierCode: data.supplierCode,
                        rpIds: data.rpIdList,
                        emails: emails
                    };
                }),
                recipients: this.$refs.recipients.getSelected().map(function (item) {
                    var id = void 0;
                    if (item.id < 0) {
                        id = item.id;
                    } else {
                        id = /^\d+$/.test(item.id) ? item.id : null;
                    }
                    return {
                        id: id,
                        name: item.name
                    };
                }),
                title: this.form.name,
                attaches: this.fileList,
                content: '<div style="font-family:微软雅黑;">' + this.form.contentCode + this.getSign() + '</div>',
                ccs: this.form.ccList.map(function (item) {
                    var id = void 0;
                    if (item.id < 0) {
                        id = item.id;
                    } else {
                        id = /^\d+$/.test(item.id) ? item.id : null;
                    }
                    return {
                        id: id,
                        name: item.name
                    };
                })
            };
            if (this.$refs.recipients.getSelected().length <= 0 && !emailLength) {
                this.$message({
                    message: '供应商对接人和收件人不能同时为空',
                    type: 'warning'
                });
                return false;
            }

            __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(url, params, {
                'X-showMessage': true,
                'X-JSON': true
            }).then(function (res) {
                _this6.dialogFormVisible = false;
                _this6.$emit('sendSuccess', _this6.params);
            });
        },
        getFileData: function getFileData() {
            var _this7 = this;

            var data = [];
            this.form.hrAttachIds.forEach(function (id) {
                var item = __WEBPACK_IMPORTED_MODULE_7_underscore___default.a.findWhere(_this7.baseData.hrAttachList, { id: id });
                item && data.push(['hr', item.md5, item.fileId, item.attachName].join(','));
            });
            return [];
        },
        getSign: function getSign() {
            var userInfo = this.$store.state.user;
            return '<div style="color: #999;margin-top: 50px;font-family: \u5FAE\u8F6F\u96C5\u9ED1;font-size: 14px;">\n                        <p style="margin: 5px 0;border-bottom: 1px solid #999;width: 300px;">' + Object(__WEBPACK_IMPORTED_MODULE_5_modules_tools__["a" /* dateFormat */])(new Date()) + '</p>\n                        <p style="margin:5px 0;">\u53D1\u4EF6\u4EBA\uFF1A' + (userInfo.name || '-') + '</p>\n                        <p style="margin:5px 0;">\u90E8\u95E8\uFF1A' + (userInfo.deptName || '-') + '</p>\n                        <p style="margin:5px 0;">POPO\uFF1A' + (userInfo.email || '-') + '</p>\n                    </div>';
        },
        renderEmailTemplate: function renderEmailTemplate(id) {
            var list = this.emailTemplateList.find(function (el) {
                return el.id === id;
            }) || [];
            this.form.name = list.title || '';
            this.$refs.editor.resetContent(list.content || '');
        }
    },
    computed: {
        getAttachItems: function getAttachItems() {
            var ids = this.form.hrAttachIds,
                res = [];
            this.baseData.hrAttachList.forEach(function (item) {
                if (ids.indexOf(item.id) > -1) {
                    res.push(item);
                }
            });
            return res;
        },
        senderTitle: function senderTitle() {
            return this.isPreview ? '邮件预览' : '邮件发送';
        },
        showPreviewBtn: function showPreviewBtn() {
            return !this.isPreview;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-051324bc"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/operation/salaryEmailDialog.vue
var salaryEmailDialog_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.params) ? _c('el-dialog', {
    staticClass: "scoped-interivew-email",
    attrs: {
      "title": _vm.senderTitle,
      "visible": _vm.dialogFormVisible,
      "close-on-click-modal": false,
      "close-on-press-escape": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isPreview),
      expression: "!isPreview"
    }],
    key: _vm.renderKey,
    staticClass: "editView"
  }, [_c('div', {
    staticStyle: {
      "width": "85%",
      "margin": "0px auto 20px"
    }
  }, [_c('p', [_vm._v("已勾选" + _vm._s(_vm.params.length) + "条数据")]), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.dataList
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "供应商",
      "width": "100",
      "prop": "supplierName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "定薪数量",
      "width": "80",
      "prop": "supplierName"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.rpIdList.length))]
      }
    }], null, false, 3940408418)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "对接人(点击名字标签可不发送给该对接人)",
      "prop": "users"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.contactList), function(item, index) {
          return _c('el-tag', {
            key: index,
            staticClass: "user-tag",
            class: {
              'disabled': item.disabled === true
            },
            nativeOn: {
              "click": function($event) {
                return _vm.togglerUserActive(item)
              }
            }
          }, [_vm._v(_vm._s(item.name) + "(" + _vm._s(item.email) + ")")])
        })
      }
    }], null, false, 311185674)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "100",
      "prop": "number"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          attrs: {
            "href": "javascript:;"
          },
          on: {
            "click": function($event) {
              return _vm.previewEmail(scope.row)
            }
          }
        }, [_vm._v("预览")])]
      }
    }], null, false, 643718374)
  })], 1)], 1), _vm._v(" "), _c('el-form', {
    staticClass: "form-beauty",
    attrs: {
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择模板",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择模板",
      "clearable": ""
    },
    on: {
      "change": _vm.renderEmailTemplate
    },
    model: {
      value: (_vm.emailTemplate),
      callback: function($$v) {
        _vm.emailTemplate = $$v
      },
      expression: "emailTemplate"
    }
  }, _vm._l((_vm.emailTemplateList), function(item, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "邮件标题",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "maxlength": 200,
      "placeholder": "请输入邮件标题"
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "收件人",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('user-group', {
    ref: "recipients",
    attrs: {
      "allowEmail": true
    },
    model: {
      value: (_vm.recipients),
      callback: function($$v) {
        _vm.recipients = $$v
      },
      expression: "recipients"
    }
  }), _vm._v(" "), _c('a', {
    staticStyle: {
      "position": "absolute",
      "right": "-40px",
      "top": "0px"
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.previewEmailByRecipients()
      }
    }
  }, [_vm._v("预览")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "抄送人",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('user-group', {
    ref: "ccList",
    attrs: {
      "allowEmail": true
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "附件",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('file-upload', {
    staticClass: "upload-desc",
    attrs: {
      "action": ((_vm.$axios.defaults.baseURL) + "/payment/template/fileInsert.api")
    },
    model: {
      value: (_vm.fileList),
      callback: function($$v) {
        _vm.fileList = $$v
      },
      expression: "fileList"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("点击上传")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "邮件内容",
      "label-width": _vm.formLabelWidth
    }
  }, [(_vm.placeHolders.length) ? _c('div', {
    staticClass: "quickTool"
  }, _vm._l((_vm.placeHolders), function(item, key) {
    return _c('el-tag', {
      key: key,
      attrs: {
        "icon": "el-icon-plus",
        "size": "small"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.$refs.editor.addAfterCursor(item.value)
        }
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1) : _vm._e(), _vm._v(" "), _c('vueditor', {
    ref: "editor",
    model: {
      value: (_vm.form.contentCode),
      callback: function($$v) {
        _vm.$set(_vm.form, "contentCode", $$v)
      },
      expression: "form.contentCode"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.isPreview) ? _c('div', {
    staticClass: "previewView"
  }, [_c('div', {
    staticStyle: {
      "border-bottom": "1px solid #ddd"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bold"
    }
  }, [_vm._v("邮件标题：" + _vm._s(_vm.form.name))]), _vm._v(" "), _c('p', [_vm._v("收件人："), _vm._l((_vm.interviewerUsers), function(item, index) {
    return (item.disabled !== true) ? _c('span', {
      key: item.id
    }, [_vm._v(_vm._s(item.name)), _c('span', [_vm._v(";")])]) : _vm._e()
  })], 2), _vm._v(" "), _c('p', [_vm._v("抄送人："), _vm._l((_vm.form.ccList), function(item, index) {
    return _c('span', {
      key: item.id
    }, [_vm._v(_vm._s(item.name)), _c('span', [_vm._v(";")])])
  })], 2), _vm._v(" "), (_vm.fileList.length) ? _c('p', [_vm._v("附件："), _vm._l((_vm.fileList), function(item) {
    return _c('span', {
      key: item.fileId
    }, [_vm._v(_vm._s(item.fileName || item.name) + ";")])
  })], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border-top": "1px solid #ddd",
      "padding-top": "10px"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.form.content)
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(!_vm.isPreview) ? _c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("取 消")]) : _vm._e(), _vm._v(" "), (_vm.isPreview) ? _c('el-button', {
    staticClass: "left",
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.toEditView
    }
  }, [_vm._v("返 回")]) : _vm._e(), _vm._v(" "), (!_vm.isPreview) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.sendEmail
    }
  }, [_vm._v("发 送")]) : _vm._e()], 1)]) : _vm._e()
}
var salaryEmailDialog_staticRenderFns = []
var salaryEmailDialog_esExports = { render: salaryEmailDialog_render, staticRenderFns: salaryEmailDialog_staticRenderFns }
/* harmony default export */ var operation_salaryEmailDialog_defaultExport = (salaryEmailDialog_esExports);
// CONCATENATED MODULE: ./src/views/operation/salaryEmailDialog.vue
function salaryEmailDialog_injectStyle (ssrContext) {
  __webpack_require__(902)
  __webpack_require__(903)
}
var salaryEmailDialog_normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var salaryEmailDialog___vue_styles__ = salaryEmailDialog_injectStyle
/* scopeId */
var salaryEmailDialog___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var salaryEmailDialog___vue_module_identifier__ = null
var salaryEmailDialog_Component = salaryEmailDialog_normalizeComponent(
  salaryEmailDialog_defaultExport,
  operation_salaryEmailDialog_defaultExport,
  salaryEmailDialog___vue_styles__,
  salaryEmailDialog___vue_scopeId__,
  salaryEmailDialog___vue_module_identifier__
)

/* harmony default export */ var views_operation_salaryEmailDialog_defaultExport = (salaryEmailDialog_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/operation/managerEditDialog.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fetchPositionListMixin__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mixins_selectMapMixin__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mixins_formCommonMixin__ = __webpack_require__(25);
/* harmony import */ var managerEditDialog___WEBPACK_IMPORTED_MODULE_3_components_userSelect_searchDownList__ = __webpack_require__(55);






/* harmony default export */ var managerEditDialog_defaultExport = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_0__fetchPositionListMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1_mixins_selectMapMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2_mixins_formCommonMixin__["a" /* default */]],
    components: { UserSearch: managerEditDialog___WEBPACK_IMPORTED_MODULE_3_components_userSelect_searchDownList__["a" /* default */] },
    data: function data() {
        return {
            showDialog: false,
            isSingle: true,
            confirmInfo: {
                name: '',
                gender: '',
                phone: '',
                email: '',
                position: '',
                school: ''
            },
            preventKey: 1,
            ruleForm: {
                managerId: '',
                resumePositionId: ''
            }
        };
    },

    methods: {
        getTitle: function getTitle() {
            return '设置主管';
        },
        show: function show(data) {
            var _this = this;

            console.log(data);
            this.preventKey = +new Date();
            this.confirmInfo = {
                name: data.resumeForm.name,
                gender: data.resumeForm.gender,
                phone: data.resumeForm.mobilePhone,
                email: data.resumeForm.email,
                position: data.positionForm.name,
                school: data.resumeForm.resumeMaxEducation.school,
                sLevel: data.resumeForm.resumeMaxEducation.sLevel
            };
            this.ruleForm.resumePositionId = data.id;
            if (data.managerInfo) {
                this.$nextTick(function () {
                    if (data.managerInfo.id && data.managerInfo.name) {
                        _this.$refs['managerSelect'].setDefaultValueLater(data.managerInfo.id.toString(), data.managerInfo.name.toString());
                    }
                });
                this.ruleForm.managerId = data.managerInfo.id;
            }

            this.showDialog = true;
        },
        saveForm: function saveForm() {
            var _this2 = this;

            var url = '/resumePosition/setManagerInfo.api';
            this.$axios.post(url, this.ruleForm, { 'X-showMessage': true }).then(function (res) {
                _this2.showDialog = false;
                _this2.$emit('reload');
            }).catch(console.error);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31b91de1"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/operation/managerEditDialog.vue
var managerEditDialog_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "recommend-resume-dialog",
    attrs: {
      "title": _vm.getTitle(),
      "visible": _vm.showDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.showDialog = $event
      }
    }
  }, [_c('div', {
    key: _vm.preventKey + 'a',
    staticClass: "content-confirm border-radius"
  }, [_c('h1', {
    staticClass: "text-center"
  }, [_vm._v("候选人信息")]), _vm._v(" "), _c('el-row', [_c('el-col', [_c('p', [_c('span', [_vm._v("候选人：" + _vm._s(_vm.confirmInfo.name))]), _vm._v(" "), _c('span', {
    staticClass: "ml-20"
  }, [_vm._v("性别：" + _vm._s(_vm.getSelectMapText('WB_GENDER', _vm.confirmInfo.gender) || '-'))]), _vm._v(" "), _c('span', {
    staticClass: "ml-20"
  }, [_vm._v("手机号：" + _vm._s(_vm.confirmInfo.phone))]), _vm._v(" "), _c('span', {
    staticClass: "ml-20"
  }, [_vm._v("邮箱：" + _vm._s(_vm.confirmInfo.email))])]), _vm._v(" "), _c('p', {
    staticClass: "mt-10"
  }, [_vm._v("\n          当前职位：" + _vm._s(_vm.confirmInfo.position)), _c('span', {
    staticClass: "ml-20"
  }, [_vm._v("最高学历学校：" + _vm._s(_vm.confirmInfo.school))])])])], 1)], 1), _vm._v(" "), _c("el-form", {
    key: _vm.preventKey + 'b',
    ref: "ruleForm",
    tag: "el-form",
    staticClass: "form-beauty",
    attrs: {
      "model": _vm.ruleForm,
      "label-width": "150px"
    }
  }, [_c('el-form-item', [_c('user-search', {
    ref: "managerSelect",
    attrs: {
      "holder": "主管",
      "multiple": false
    },
    model: {
      value: (_vm.ruleForm.managerId),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "managerId", $$v)
      },
      expression: "ruleForm.managerId"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showDialog = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("确认")])], 1)], 1)
}
var managerEditDialog_staticRenderFns = []
var managerEditDialog_esExports = { render: managerEditDialog_render, staticRenderFns: managerEditDialog_staticRenderFns }
/* harmony default export */ var operation_managerEditDialog_defaultExport = (managerEditDialog_esExports);
// CONCATENATED MODULE: ./src/views/operation/managerEditDialog.vue
function managerEditDialog_injectStyle (ssrContext) {
  __webpack_require__(905)
}
var managerEditDialog_normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var managerEditDialog___vue_styles__ = managerEditDialog_injectStyle
/* scopeId */
var managerEditDialog___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var managerEditDialog___vue_module_identifier__ = null
var managerEditDialog_Component = managerEditDialog_normalizeComponent(
  managerEditDialog_defaultExport,
  operation_managerEditDialog_defaultExport,
  managerEditDialog___vue_styles__,
  managerEditDialog___vue_scopeId__,
  managerEditDialog___vue_module_identifier__
)

/* harmony default export */ var views_operation_managerEditDialog_defaultExport = (managerEditDialog_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/salary/salaryList.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_queryListExtend__ = __webpack_require__(20);
/* harmony import */ var salaryList___WEBPACK_IMPORTED_MODULE_1_mixins_selectMapMixin__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__operation_operationMixin__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__operation_queryListMixin__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__operation_attachViewInList__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_views_operation_modifySalaryDialog__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_modules_tools__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__operation_remarkEditDialog__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__operation_multiRemarkEditDialog_vue__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_views_common_multiSearch__ = __webpack_require__(88);


















/* harmony default export */ var salaryList_defaultExport = ({
    'extends': __WEBPACK_IMPORTED_MODULE_0_components_queryListExtend__["a" /* default */],
    'mixins': [salaryList___WEBPACK_IMPORTED_MODULE_1_mixins_selectMapMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__operation_operationMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__operation_queryListMixin__["a" /* default */]],
    data: function data() {
        return {
            fetchUrl: '/payment/list.api',
            paymentMessageList: [],
            multiFields: [{
                filter: 'WB_RESUME_STATUS_6',
                label: '简历状态',
                data: [],
                mode: 'select',
                name: 'statusSearch'
            }, {
                filter: 'WB_PAYMENT_STATUS',
                label: '定薪安排',
                multiple: false,
                data: '',
                mode: 'select',
                name: 'paymentStatusSearch'
            }, {
                label: '定薪安排时间',
                mode: 'daterange',
                name: 'paymentDate'
            }, {
                filter: 'WB_SYNC_STATUS',
                label: '是否同步',
                multiple: false,
                data: '',
                mode: 'select',
                name: 'isSync'
            }, {
                filter: 'WB_SEND_STATUS',
                label: '邮件通知',
                multiple: false,
                data: '',
                mode: 'select',
                name: 'paymentEmailStatus'
            }],
            searchData: {
                searchWord: null,
                orderBy: null,
                ascOrDesc: null
            },
            defaultSort: undefined
        };
    },
    created: function created() {
        var _$route$query = this.$route.query,
            prop = _$route$query.orderBy,
            ascOrDesc = _$route$query.ascOrDesc;

        if (prop) {
            this.defaultSort = {
                prop: prop,
                order: ascOrDesc ? ascOrDesc === 'desc' ? 'descending' : 'ascending' : null
            };
        }
    },

    methods: {
        multiRemarkEdit: function multiRemarkEdit(ids) {
            if (this.checkDataValid(ids)) {
                var $target = this.$refs.multiRemarkEditDialog;
                var rids = this.lists.filter(function (cv) {
                    return ids.indexOf(cv.id) > -1;
                }).map(function (cv) {
                    return cv.resumeForm.id;
                }).join(',');
                $target && $target.show(rids);
            }
        },
        dateFormat: function dateFormat(date) {
            var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'yyyy/MM/dd';

            return Object(__WEBPACK_IMPORTED_MODULE_7_modules_tools__["a" /* dateFormat */])(date, format);
        },
        fetchCallback: function fetchCallback(res) {
            this.paymentMessageList = res.result.paymentMessageList;
        },
        needToShowArrangetInfo: function needToShowArrangetInfo(data) {
            return data.interviewArrangeForms && data.interviewArrangeForms.length && _.any(data.interviewArrangeForms, function (item) {
                return !item.evaluationed;
            });
        },
        sendEmail: function sendEmail() {
            if (this.checkDataValid(this.multipleSelection)) {
                this.$refs.salaryEmailDialog.show(this.multipleSelection);
            }
        },
        editManager: function editManager(item) {
            this.$refs.managerEditDialog.show(item);
        },
        arrangeSalary: function arrangeSalary(item) {
            console.log(item);
            if (Array.isArray(item)) {
                if (this.checkDataValid(item)) {
                    if (item.length > 1) {
                        this.$refs.arrangeSalaryDialog.show(item, false, this.paymentMessageList);
                    } else {
                        this.$refs.arrangeSalaryDialog.show(item[0], true, this.paymentMessageList);
                    }
                }
            } else {
                this.$refs.arrangeSalaryDialog.show(item, true, this.paymentMessageList);
            }
        },
        modifySalary: function modifySalary(item) {
            console.log(item);
            if (Array.isArray(item)) {
                if (this.checkDataValid(item)) {
                    if (this.checkPaymentId(item)) {
                        this.$message({
                            message: '所选人员存在不同的定薪规则，不能批量修改！',
                            type: 'warning'
                        });
                        return;
                    }
                    if (item.length > 1) {
                        this.$refs.modifySalaryDialog.show(item, false);
                    } else {
                        this.$refs.modifySalaryDialog.show(item[0], true);
                    }
                }
            } else {
                this.$refs.modifySalaryDialog.show(item, true);
            }
        },
        checkPaymentId: function checkPaymentId(itemList) {
            return itemList.some(function (item) {
                return item.positionForm.paymentId !== itemList[0].positionForm.paymentId;
            });
        },
        toResumeDetail: function toResumeDetail(row) {
            var path = this.getResumeDetailUrl(row.id, row.status);

            var routeData = this.$router.resolve({ path: path });
            window.open(routeData.href, '_blank');
        },
        handleChangeSort: function handleChangeSort(val) {
            var orderBy = val.prop,
                order = val.order;

            var ascOrDesc = order ? order === 'descending' ? 'desc' : 'asc' : null;
            this.searchData.orderBy = ascOrDesc ? orderBy : '';
            this.searchData.ascOrDesc = ascOrDesc;
            this.defaultSort = undefined;
        },
        handleClear: function handleClear() {
            this.handleChangeSort({});
            this.$refs.table && this.$refs.table.clearSort();
        }
    },
    components: { ArrangeSalaryDialog: views_operation_arrangeSalaryDialog_defaultExport, ModifySalaryDialog: __WEBPACK_IMPORTED_MODULE_6_views_operation_modifySalaryDialog__["a" /* default */], ArrangementTooltips: views_operation_arrangeTooltips_defaultExport, RemarkEdit: __WEBPACK_IMPORTED_MODULE_9__operation_remarkEditDialog__["a" /* default */], AttachViewInList: __WEBPACK_IMPORTED_MODULE_4__operation_attachViewInList__["a" /* default */], MultiSearch: __WEBPACK_IMPORTED_MODULE_12_views_common_multiSearch__["a" /* default */], SalaryEdit: views_operation_salaryEditDialog_defaultExport, SalaryEmailDialog: views_operation_salaryEmailDialog_defaultExport, managerEditDialog: views_operation_managerEditDialog_defaultExport, MultiRemarkEditDialog: __WEBPACK_IMPORTED_MODULE_10__operation_multiRemarkEditDialog_vue__["a" /* default */] }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-91d04912"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/salary/salaryList.vue
var salaryList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.firstRendered) ? _c('div', [_c('div', {
    staticClass: "filter-condition box-shadow-small border-radius"
  }, [_c('multi-search', {
    key: _vm.$route.params.id,
    ref: "MultiSearch",
    staticClass: "salary-search",
    attrs: {
      "fields": _vm.multiFields
    },
    on: {
      "clear": _vm.handleClear
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "filter-result background-white box-shadow-small border-radius"
  }, [_c('div', {
    staticClass: "filter-result-header mt-15 clearfix"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-dropdown', {
    staticClass: "mr-5"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("批量操作"), _c('i', {
    staticClass: "el-icon-caret-bottom el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.syncToSupplier(_vm.idStr)
      }
    }
  }, [_vm._v("批量同步供应商")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.sendEmail(_vm.idStr)
      }
    }
  }, [_vm._v("批量发送定薪通知")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.multiRemarkEdit(_vm.idStr)
      }
    }
  }, [_vm._v("批量修改备注")])], 1)], 1), _vm._v(" "), _c('el-dropdown', [_c('el-button', {
    attrs: {
      "icon": "el-icon-my-daochu",
      "type": "info"
    }
  }, [_vm._v("导出简历"), _c('i', {
    staticClass: "el-icon-caret-bottom el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.exportFiles(_vm.idStr)
      }
    }
  }, [_vm._v("导出已选记录(excel)")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.exportFiles(_vm.idStr, undefined, undefined, 'type=HTML')
      }
    }
  }, [_vm._v("导出已选记录(html)")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.exportParamsFiles('/payment/exportAllResume.api')
      }
    }
  }, [_vm._v("导出所有查询结果(excel)")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.exportParamsFiles('/payment/exportAllResume.api', 'HTML')
      }
    }
  }, [_vm._v("导出所有查询结果(html)")])], 1)], 1), _vm._v(" "), _c('export-custom-dialog', {
    staticClass: "ml-10",
    attrs: {
      "valid-call-back": _vm.customExportValid,
      "params-call-back": _vm.customExportParams
    }
  })], 1), _vm._v(" "), _c('el-col', [(_vm.lists.length) ? _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "end"
    }
  }, [_c('el-button', {
    attrs: {
      "icon": "",
      "type": "success",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.modifySalary(_vm.multipleSelection)
      }
    }
  }, [_vm._v("定薪批量修改")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "",
      "type": "success",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.arrangeSalary(_vm.multipleSelection)
      }
    }
  }, [_vm._v("定薪批量安排")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-queding color-success",
      "type": "success",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.idStr, 'pass', null, '接受Offer')
      }
    }
  }, [_vm._v("接受Offer")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-guanbi color-danger",
      "type": "danger",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.idStr, 'fq', null, '放弃Offer')
      }
    }
  }, [_vm._v("放弃Offer")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-huitui color-info",
      "type": "danger",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.idStr, 'back', null, '回退')
      }
    }
  }, [_vm._v("回退")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-lahei color-purple",
      "type": "danger",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.idStr, 'lh', null, '拉黑')
      }
    }
  }, [_vm._v("拉黑")])], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.partialLoading),
      expression: "partialLoading"
    }]
  }, [_c('empty-tip', {
    attrs: {
      "show": !_vm.lists.length
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "table-list mt-20"
  }, [(_vm.lists.length) ? _c('el-table', {
    ref: "table",
    attrs: {
      "data": _vm.lists,
      "default-sort": _vm.defaultSort
    },
    on: {
      "selection-change": _vm.handleSelectionChange,
      "sort-change": _vm.handleChangeSort
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "姓名",
      "fixed": "",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "name-txt",
          on: {
            "click": function($event) {
              return _vm.toResumeDetail(scope.row)
            }
          }
        }, [_vm._v("\n                                " + _vm._s(scope.row.resumeForm.name) + "\n                                "), _c('i', {
          class: {
            'el-icon-my-nan': scope.row.resumeForm.gender === 1,
              'el-icon-my-nv color-danger': scope.row.resumeForm.gender === 2
          },
          staticStyle: {
            "transform": "scale(.7)"
          }
        })])]
      }
    }], null, false, 2836613620)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resumeForm.gender",
      "label": "性别",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s({
          1: '男',
          2: '女'
        }[scope.row.resumeForm.gender] || '-'))]
      }
    }], null, false, 3168019877)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "岗位",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.positionForm.name) + "\n                        ")]
      }
    }], null, false, 2092161755)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "招聘部门",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.positionForm.deptNames) + "\n                        ")]
      }
    }], null, false, 2934477005)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resumeForm.mobilePhone",
      "label": "手机号",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resumeForm.email",
      "label": "邮箱",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "最高学历",
      "align": "center",
      "show-overflow-tooltip": true,
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.getSelectMapText('WB_EDU_DEGREE', scope.row.resumeForm.resumeMaxEducation.degree)) + "\n                        ")]
      }
    }], null, false, 433538694)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "最高学历学校",
      "align": "center",
      "show-overflow-tooltip": true,
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.resumeForm.schoolType === '1') ? _c('el-tag', {
          attrs: {
            "type": "primary"
          }
        }, [_vm._v("985")]) : (scope.row.resumeForm.schoolType === '2') ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("211")]) : _vm._e(), _vm._v("\n                            " + _vm._s(scope.row.resumeForm.resumeMaxEducation.school) + "\n                        ")]
      }
    }], null, false, 2122314332)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "学校档位",
      "align": "center",
      "show-overflow-tooltip": true,
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.resumeForm.resumeMaxEducation.sLevel) + "\n                        ")]
      }
    }], null, false, 4118298064)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resumeForm.resumeMaxEducation.major",
      "label": "专业",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resumeForm.origin",
      "label": "籍贯",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "简历来源",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.getSelectMapText('WB_RESUME_SOURCE', scope.row.resumeForm.resumeSource)) + "\n                        ")]
      }
    }], null, false, 3166876443)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "当前所在地",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.resumeForm.residence || '-') + "\n                        ")]
      }
    }], null, false, 3375146197)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "应聘城市",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.getSelectMapText('WB_POSITION_CITY', scope.row.resumeForm.expectCityId)) + "\n                        ")]
      }
    }], null, false, 2621839696)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "positionForm.sourceFrom",
      "label": "投递渠道",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.resumeForm && _vm.getSelectMapText('WB_ADD_SOURCE',
          scope.row.resumeForm.addSource)) + "\n                        ")]
      }
    }], null, false, 3698601694)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "投递人",
      "prop": "resumeForm.addName",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "推荐人",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.resumeForm.recommenderUser) ? _c('span', [_vm._v(_vm._s(scope.row.resumeForm.recommenderUser.name))]) : _vm._e()]
      }
    }], null, false, 2383682320)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "游戏经验",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.resumeForm.gameExperience) + "\n                        ")]
      }
    }], null, false, 3038609676)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "简历附件",
      "align": "center",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('attach-view-in-list', {
          attrs: {
            "attachList": scope.row.resumeForm.resumeAttachList
          }
        })]
      }
    }], null, false, 2021903071)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "投递时间",
      "show-overflow-tooltip": true,
      "min-width": "100",
      "prop": "commitTime",
      "sortable": "custom"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm.dateFormat(scope.row.commitTime)))]
      }
    }], null, false, 3274253775)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "面试评分",
      "show-overflow-tooltip": true,
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.evaluationForm) ? _c('span', [_vm._v(_vm._s(scope.row.evaluationForm.grade || scope.row.evaluationForm.score))]) : _vm._e()]
      }
    }], null, false, 3006534052)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "综合评价",
      "show-overflow-tooltip": true,
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.evaluationForm) ? _c('span', [_vm._v(_vm._s(scope.row.evaluationForm.content))]) : _vm._e()]
      }
    }], null, false, 3023920798)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "建议方向",
      "show-overflow-tooltip": true,
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.evaluationForm) ? _c('span', [_vm._v(_vm._s(scope.row.evaluationForm.hireAdvice))]) : _vm._e()]
      }
    }], null, false, 1707642557)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "期望描述",
      "show-overflow-tooltip": true,
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.evaluationForm) ? _c('span', [_vm._v(_vm._s(scope.row.evaluationForm.expectSalary))]) : _vm._e()]
      }
    }], null, false, 1719133724)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resumeForm.expectSalary",
      "align": "center",
      "label": "期望薪资",
      "show-overflow-tooltip": true,
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('salary-edit', {
          attrs: {
            "id": scope.row.resumeForm.id
          },
          model: {
            value: (scope.row.resumeForm.expectSalary),
            callback: function($$v) {
              _vm.$set(scope.row.resumeForm, "expectSalary", $$v)
            },
            expression: "scope.row.resumeForm.expectSalary"
          }
        })]
      }
    }], null, false, 1968755839)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "定级",
      "show-overflow-tooltip": true,
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.resumePayment.secLevel))]
      }
    }], null, false, 743918963)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "定薪",
      "show-overflow-tooltip": true,
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.resumePayment.paymentLevel))]
      }
    }], null, false, 986868444)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "定薪人",
      "show-overflow-tooltip": true,
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.paymentEvaluationForm.names))]
      }
    }], null, false, 1154388317)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "定薪安排时间",
      "show-overflow-tooltip": true,
      "min-width": "120",
      "prop": "createTime",
      "sortable": "custom"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm.dateFormat(scope.row.paymentEvaluationForm.createTime)))]
      }
    }], null, false, 1960885934)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "简历状态",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.operateReason) ? _c('el-tooltip', {
          attrs: {
            "effect": "dark",
            "content": scope.row.operateReason,
            "placement": "top-start"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text",
            "icon": "el-icon-my-xinxi"
          }
        })], 1) : _vm._e(), _vm._v("\n                            " + _vm._s(_vm.getSelectMapText('WB_FLOW_STATUS', scope.row.status)) + "\n                        ")]
      }
    }], null, false, 1493638063)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "评估状态",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.paymentEvaluationForm) ? _c('span', [_vm._v(_vm._s(_vm.getSelectMapText('WB_EVALUATION_STATUS', scope.row.paymentEvaluationForm.status)))]) : _vm._e()]
      }
    }], null, false, 2088665350)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "邮件通知",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.getSelectMapText('WB_SEND_STATUS', scope.row.paymentEmailStatus) || '未发送'))])]
      }
    }], null, false, 3093531601)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "主管",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "width": "70px",
            "display": "inline-block",
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap",
            "vertical-align": "bottom"
          }
        }, [_vm._v(_vm._s(scope.row.managerInfo ? scope.row.managerInfo.name : ''))]), _vm._v(" "), _c('i', {
          staticClass: "el-icon-my-bishi edit-salary-btn",
          on: {
            "click": function($event) {
              return _vm.editManager(scope.row)
            }
          }
        })]
      }
    }], null, false, 1835964258)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "同步供应商",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.getSelectMapText('WB_SYNC_STATUS', scope.row.resumeForm.isSync)))])]
      }
    }], null, false, 3131267630)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right",
      "align": "center",
      "class-name": "no-wrap",
      "min-width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [((scope.row.paymentEvaluationForm || {}).status !== 2) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.arrangeSalary(scope.row)
            }
          }
        }, [_vm._v("定薪安排")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.modifySalary(scope.row)
            }
          }
        }, [_vm._v("定薪修改")])]
      }
    }], null, false, 1933580331)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resumeForm.remark",
      "show-overflow-tooltip": true,
      "label": "备注",
      "align": "center",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('remark-edit', {
          attrs: {
            "id": scope.row.resumeForm.id
          },
          model: {
            value: (scope.row.resumeForm.remark),
            callback: function($$v) {
              _vm.$set(scope.row.resumeForm, "remark", $$v)
            },
            expression: "scope.row.resumeForm.remark"
          }
        })]
      }
    }], null, false, 1691095712)
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.lists.length) ? _c('el-pagination', {
    staticClass: "text-center mt-20 mb-20",
    attrs: {
      "current-page": _vm.pagination.pageIndex,
      "page-size": _vm.pagination.pageSize,
      "page-sizes": [20, 50, 100, 200],
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.pagination.recordCounts
    },
    on: {
      "size-change": _vm.pageSizeChange,
      "current-change": _vm.pageIndexChange
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('arrange-salary-dialog', {
    ref: "arrangeSalaryDialog",
    on: {
      "reload": _vm.fetchData
    }
  }), _vm._v(" "), _c('modify-salary-dialog', {
    ref: "modifySalaryDialog",
    on: {
      "reload": _vm.fetchData
    }
  }), _vm._v(" "), _c('manager-edit-dialog', {
    ref: "managerEditDialog",
    on: {
      "reload": _vm.fetchData
    }
  }), _vm._v(" "), _c('salary-email-dialog', {
    ref: "salaryEmailDialog",
    on: {
      "reload": _vm.fetchData
    }
  }), _vm._v(" "), _c('multi-remark-edit-dialog', {
    ref: "multiRemarkEditDialog",
    on: {
      "reload": _vm.fetchData
    }
  })], 1) : _vm._e()
}
var salaryList_staticRenderFns = []
var salaryList_esExports = { render: salaryList_render, staticRenderFns: salaryList_staticRenderFns }
/* harmony default export */ var salary_salaryList_defaultExport = (salaryList_esExports);
// CONCATENATED MODULE: ./src/views/salary/salaryList.vue
function salaryList_injectStyle (ssrContext) {
  __webpack_require__(893)
}
var salaryList_normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var salaryList___vue_styles__ = salaryList_injectStyle
/* scopeId */
var salaryList___vue_scopeId__ = "data-v-91d04912"
/* moduleIdentifier (server only) */
var salaryList___vue_module_identifier__ = null
var salaryList_Component = salaryList_normalizeComponent(
  salaryList_defaultExport,
  salary_salaryList_defaultExport,
  salaryList___vue_styles__,
  salaryList___vue_scopeId__,
  salaryList___vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (salaryList_Component.exports);


/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(894);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("5693f30c", content, true);

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".salary-search[data-v-91d04912] .el-form-item.label-paymentDate label{width:100px!important}", ""]);

// exports


/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(896);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("35ab88d2", content, true);

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".recommend-resume-dialog .content-confirm{background-color:#2481ff;color:#fff;margin:0 20px 20px}.recommend-resume-dialog .content-confirm>h1{font-size:18px;padding:15px}.recommend-resume-dialog .content-confirm>.el-row{background-color:#59a0ff;padding:15px;border-radius:0 0 5px 5px}", ""]);

// exports


/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(898);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("322dd480", content, true);

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".recommend-resume-dialog .content-confirm{background-color:#2481ff;color:#fff;margin:0 20px 20px}.recommend-resume-dialog .content-confirm>h1{font-size:18px;padding:15px}.recommend-resume-dialog .content-confirm>.el-row{background-color:#59a0ff;padding:15px;border-radius:0 0 5px 5px}.recommend-resume-dialog .content-confirm-multiple{margin:0 0 20px 100px}.recommend-resume-dialog .content-confirm-multiple span{font-weight:700}", ""]);

// exports


/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(900);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("65e9e63b", content, true);

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".arrangement-info-tooltip-wpr{min-height:50px}.arrangement-info-tooltip-wpr .text-hd{background:#11b95c;color:#fff}.arrangement-info-tooltip-wpr .text-hd th{padding:3px 5px}.arrangement-info-tooltip-wpr .border-row{border-top:1px solid #ddd;border-bottom:1px solid #ddd}.arrangement-info-tooltip-wpr .text-td{padding:3px 5px}", ""]);

// exports


/***/ }),
/* 901 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 902 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(904);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("08776e5c", content, true);

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".scoped-interivew-email .previewView{overflow:auto;height:520px}.scoped-interivew-email .quickTool .el-tag{cursor:pointer;margin-right:5px}.scoped-interivew-email .dialog-footer button{width:150px}", ""]);

// exports


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(906);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("1505b990", content, true);

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".recommend-resume-dialog .content-confirm{background-color:#2481ff;color:#fff;margin:0 20px 20px}.recommend-resume-dialog .content-confirm>h1{font-size:18px;padding:15px}.recommend-resume-dialog .content-confirm>.el-row{background-color:#59a0ff;padding:15px;border-radius:0 0 5px 5px}.recommend-resume-dialog .content-confirm-multiple{margin:0 0 20px 100px}.recommend-resume-dialog .content-confirm-multiple span{font-weight:700}", ""]);

// exports


/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/evaluation/salary.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_thumbnail__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mixins_selectMapMixin__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_views_operation_modifySalaryDialog__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_views_common_empty__ = __webpack_require__(121);







/* harmony default export */ var salary_defaultExport = ({
    components: {
        Thumbnail: __WEBPACK_IMPORTED_MODULE_0_components_thumbnail__["a" /* default */], EmptyTip: __WEBPACK_IMPORTED_MODULE_3_views_common_empty__["a" /* default */], ModifySalaryDialog: __WEBPACK_IMPORTED_MODULE_2_views_operation_modifySalaryDialog__["a" /* default */]
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_1_mixins_selectMapMixin__["a" /* default */]],
    data: function data() {
        return {
            baseInfo: null,
            evaInfo: null,
            formKey: 1,
            showEdit: false,
            interviews: [],
            turn: null,
            dialogVisible: false,
            interviewInfo: {
                interviewArrangeId: null,
                evaluator: ''
            },
            dialogInfo: {
                extInfo: ''
            },
            form: {
                status: '',
                content: ''
            }
        };
    },
    created: function created() {
        this.getPhaseInfo();
        this.getEvaList();
    },

    methods: {
        getPhaseInfo: function getPhaseInfo() {
            var _this = this;

            this.$axios.post('/resumePosition/interviewArrange/getListWithOutEva.api', { resumePositionId: this.$route.params.id }).then(function (res) {
                _this.baseInfo = res.result;
            });
        },
        getEvaList: function getEvaList() {
            var _this2 = this;

            this.$axios.get('/payment/getEvaList.api?resumePositionId=' + this.$route.params.id).then(function (res) {
                console.log(res.result instanceof Array);
                _this2.evaInfo = res.result.list ? res.result : { list: [] };
            });
        },
        refresh: function refresh() {
            this.getEvaList();
        },
        cancelEdit: function cancelEdit() {
            this.showEdit = false;
        },
        showEditPopup: function showEditPopup(item) {
            var _this3 = this;

            this.dialogInfo.extInfo = {};
            this.dialogVisible = true;

            this.$nextTick(function () {
                _this3.$refs.updateForm.$refs.form.$data.updateUrl = '/resume/updateEvaluation.api';
                _this3.$refs.updateForm.setForm(item);
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c053c87"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/evaluation/salary.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "evaluation-scoped evaluation-resume-scoped container"
  }, [(_vm.baseInfo) ? _c('div', {
    staticClass: "resume-doc-wpr box-shadow-small border-radius"
  }, [_c('div', {
    staticStyle: {
      "padding-top": "30px"
    }
  }, [_c('div', {
    staticClass: "mb-15"
  }, [_c('thumbnail', {
    attrs: {
      "text": _vm.baseInfo.resume.name,
      "gender": _vm.baseInfo.resume.gender == 1 ? 'man' : 'woman',
      "font-size": 16,
      "width": 110
    }
  }), _vm._v(" "), _c('el-row', {
    staticClass: "mt-10 text-center",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("应聘职位：" + _vm._s(_vm.baseInfo.position.name))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("应聘部门：" + _vm._s(_vm.baseInfo.position.deptNames))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("手机号：" + _vm._s(_vm.baseInfo.resume.mobilePhone))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "margin-top": "50px"
    }
  }), _vm._v(" "), (_vm.evaInfo && !_vm.evaInfo.list.length) ? _c('div', [_c('empty-tip')], 1) : _c('div', {
    staticClass: "resume-doc"
  }, [(_vm.evaInfo && _vm.evaInfo.list.length) ? _c('div', {
    staticClass: "history-form"
  }, _vm._l((_vm.evaInfo.list), function(item, index) {
    return _c('el-table', {
      key: index,
      staticClass: "evaluation-item",
      attrs: {
        "row-class-name": "evaluate-row",
        "show-header": false,
        "data": [{}]
      }
    }, [_c('el-table-column', {
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('div', {
            staticClass: "evaluate-row"
          }, [_c('div', {
            staticClass: "isView"
          }, [_c('el-row', {
            staticClass: "mt-15"
          }, [_c('el-col', {
            attrs: {
              "span": 8
            }
          }, [_c('span', {
            staticClass: "txt-label"
          }, [_vm._v("定薪者：")]), _vm._v(_vm._s(item.name) + "\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-col', {
            attrs: {
              "span": 8
            }
          }, [_c('span', {
            staticClass: "txt-label"
          }, [_vm._v("时间：")]), _vm._v(_vm._s(item.updateTime) + "\n\t\t\t\t\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('el-row', {
            staticClass: "mt-15"
          }, [_c('el-col', {
            attrs: {
              "span": 8
            }
          }, [_c('span', {
            staticClass: "txt-label"
          }, [_vm._v("定级：")]), _vm._v(_vm._s(item.secLevel) + "\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-col', {
            attrs: {
              "span": 8
            }
          }, [_c('span', {
            staticClass: "txt-label"
          }, [_vm._v("定薪：")]), _vm._v(_vm._s(item.paymentLevel) + "\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-col', {
            attrs: {
              "span": 8
            }
          }, [_c('span', {
            staticClass: "txt-label"
          }, [_vm._v("offer标准：")]), _vm._v(_vm._s(item.paymentMonth) + "/月\n\t\t\t\t\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('el-row', {
            staticClass: "mt-15 mb-15"
          }, [_c('el-col', [_c('span', {
            staticClass: "txt-label"
          }, [_vm._v("备注：")]), _vm._v(" "), _c('pre', {
            staticClass: "multi-row-content"
          }, [_vm._v(_vm._s(item.remark))])])], 1)], 1)])]
        }
      }], null, true)
    })], 1)
  }), 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('modify-salary-dialog', {
    ref: "modifySalaryDialog",
    on: {
      "reload": _vm.getEvaList
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var evaluation_salary_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/views/evaluation/salary.vue
function injectStyle (ssrContext) {
  __webpack_require__(908)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  salary_defaultExport,
  evaluation_salary_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(909);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("743d4dba", content, true);

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".scoped-evaluation-society{padding:0}.evaluation-scoped .top-nav{position:absolute;width:200px;top:0;z-index:200;background-color:transparent;left:46%}.evaluation-scoped .top-nav .title{position:absolute;left:10px;font-size:18px;color:#fff;border-bottom:0}.evaluation-scoped .top-nav .title:hover{border-bottom:0}.evaluation-scoped .resume-top-bar{background:#fff;height:80px;line-height:80px}.evaluation-scoped .resume-top-bar .resume-top{width:1200px;margin:0 auto}.evaluation-scoped .resume-top-bar .top-user-info{width:50%;float:left;text-align:left;position:relative}.evaluation-scoped .resume-top-bar .top-user-info .user-name{font-size:18px;font-weight:700;margin-top:10px}.evaluation-scoped .resume-top-bar .top-user-info .round-image{position:absolute;top:10px}.evaluation-scoped .resume-top-bar .top-user-info .thumbnail-text{display:inline-block;margin-left:80px}.evaluation-scoped .resume-top-bar .top-user-info .thumbnail-text p{height:30px;line-height:30px}.evaluation-scoped .button-footer{text-align:center;margin:20px}.evaluation-scoped .multi-row-content{display:inline-block;vertical-align:top;margin:0;word-break:break-all;width:795px;word-wrap:break-word;white-space:pre-wrap}.evaluation-scoped .history-form{margin-bottom:50px}.evaluation-scoped .history-form .evaluate-row{color:#333}.evaluation-scoped .history-form .evaluate-row:hover td{background:none}.evaluation-scoped .history-form .evaluate-row:hover .name-td{background:#f6f9fc}.evaluation-scoped .history-form .txt-label{font-weight:700}.evaluation-scoped .history-form .name-td{background:#f6f9fc;text-align:center;border-right:1px solid #dfe3ec;font-weight:700}.evaluation-scoped .history-form .evaluation-item{margin-top:-1px}.evaluation-resume-scoped .mask-tip{position:absolute;left:0;top:0;background:rgba(0,0,0,.1);text-align:center;width:100%;height:100%;z-index:20}.evaluation-resume-scoped .mask-tip p{position:absolute;width:100%;top:48%}.evaluation-resume-scoped .evaluate-row{position:relative;padding:10px 20px}", ""]);

// exports


/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/salary/salaryRuleList.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_queryListExtend__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mixins_selectMapMixin__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__operation_queryListMixin__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_tools__ = __webpack_require__(14);







/* harmony default export */ var salaryRuleList_defaultExport = ({
    'extends': __WEBPACK_IMPORTED_MODULE_0_components_queryListExtend__["a" /* default */],
    'mixins': [__WEBPACK_IMPORTED_MODULE_1_mixins_selectMapMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__operation_queryListMixin__["a" /* default */]],
    data: function data() {
        return {
            fetchUrl: '/payment/template/list.api'
        };
    },
    created: function created() {
        console.log('create');
    },

    methods: {
        dateFormat: function dateFormat(date) {
            var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'yyyy/MM/dd';

            return Object(__WEBPACK_IMPORTED_MODULE_3_modules_tools__["a" /* dateFormat */])(date, format);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a560dbda"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/salary/salaryRuleList.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-container"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.partialLoading),
      expression: "partialLoading"
    }],
    staticClass: "filter-result background-white box-shadow-small border-radius"
  }, [_c('div', {
    staticClass: "filter-result-header mb-20"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'paymentRuleDetail',
          params: {
            id: 'create'
          }
        })
      }
    }
  }, [_vm._v("新增规则")])], 1), _vm._v(" "), _c('empty-tip', {
    attrs: {
      "show": !_vm.lists.length
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "table-list"
  }, [(_vm.lists.length) ? _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.lists
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "规则名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "state",
      "label": "状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.state == 1 ? '启用' : '停用'))])]
      }
    }], null, false, 2095674422)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "updateTime",
      "label": "最后修改时间",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "modifyUserName",
      "label": "最后修改人",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "操作",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.$router.push({
                name: 'paymentRuleDetail',
                params: {
                  id: scope.row.id
                }
              })
            }
          }
        }, [_vm._v("编辑")])]
      }
    }], null, false, 4014934352)
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.lists.length) ? _c('el-pagination', {
    staticClass: "text-center mb-20 mt-20",
    attrs: {
      "current-page": _vm.pagination.pageIndex,
      "page-size": _vm.pagination.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.pagination.recordCounts
    },
    on: {
      "size-change": _vm.pageSizeChange,
      "current-change": _vm.pageIndexChange
    }
  }) : _vm._e()], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var salary_salaryRuleList_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/views/salary/salaryRuleList.vue
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  salaryRuleList_defaultExport,
  salary_salaryRuleList_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/salary/salayRuleDetail.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_fileUpload__ = __webpack_require__(89);





/* harmony default export */ var salayRuleDetail_defaultExport = ({
    components: {
        FileUpload: __WEBPACK_IMPORTED_MODULE_2_components_fileUpload__["a" /* default */]
    },
    data: function data() {
        return {
            action: this.$axios.defaults.baseURL + '/payment/template/fileInsert.api',
            fileList: [],
            ruleForm: {
                name: '',
                state: 1
            },
            rules: {
                name: { required: true, message: '请输入', trigger: 'blur' }
            },
            paymentConfigs: []
        };
    },
    created: function created() {
        var _this = this;

        if (!this.isCreate) {
            this.$axios.post('/payment/template/getDetailById.api', {
                id: this.id
            }).then(function (res) {
                _this.paymentConfigs = res.result.bean.configList;
                _this.ruleForm.name = res.result.bean.name;
                _this.ruleForm.state = res.result.bean.state;
                _this.fileList = res.result.bean.paymentAttachList;
            });
        } else {
            this.addLevelBlock();
        }
    },

    computed: {
        id: function id() {
            return this.$route.params.id;
        },
        isCreate: function isCreate() {
            return this.id === 'create';
        }
    },
    methods: {
        handleFileSuccess: function handleFileSuccess(res, file) {
            if (res.status) {
                this.fileList = [res.result];
            } else {
                this.$message.error(res.desc || '上传失败');
            }
        },
        handleFileRemove: function handleFileRemove(file, fileList) {
            this.fileList = fileList;
        },
        handlePreview: function handlePreview(file) {
            window.open(file.preUrl);
        },
        uploadRemove: function uploadRemove() {},
        defaultLevelData: function defaultLevelData() {
            return {
                secLevel: '',
                paymentList: [{
                    paymentLevel: '',
                    paymentMonth: ''
                }]
            };
        },
        addLevelBlock: function addLevelBlock() {
            this.paymentConfigs.push(this.defaultLevelData());
        },
        addInnerRow: function addInnerRow(data) {
            data.paymentList.push({
                paymentLevel: '',
                paymentMonth: ''
            });
        },
        checkLevelList: function checkLevelList() {
            var isSuccess = true;
            var tip = '';
            this.paymentConfigs.forEach(function (item) {
                if (item.secLevel === '') {
                    isSuccess = false;
                } else {
                    item.paymentList.forEach(function (one) {
                        if (one.paymentLevel === '' || one.paymentMonth === '') {
                            isSuccess = false;
                        } else if (!/^\d+$/.test(one.paymentMonth)) {
                            isSuccess = false;
                            tip = 'offer标准只能为数字';
                        }
                    });
                }
            });
            !isSuccess && this.$message.warning(tip || '定级详情表单不能为空');
            return isSuccess;
        },
        onSubmit: function onSubmit() {
            var _this2 = this;

            console.log(this.ruleForm, this.fileList);
            this.$refs.form.validate(function (valid) {
                if (valid && _this2.checkLevelList()) {
                    _this2.$axios.post('/payment/template/save.api', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _this2.ruleForm, {
                        id: _this2.isCreate ? undefined : _this2.id,
                        md5: _this2.fileList.length ? _this2.fileList[0].md5 : '',
                        fileId: _this2.fileList.length ? _this2.fileList[0].fileId : '',
                        paymentConfigs: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this2.paymentConfigs)
                    })).then(function (res) {
                        _this2.$message.success('保存成功');
                        _this2.$router.push({ name: 'paymentRules' });
                    });
                }
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d0a7878"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/salary/salayRuleDetail.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-container scoped-salary-rules"
  }, [_c('div', {
    staticClass: "background-white box-shadow-small border-radius"
  }, [_c('el-breadcrumb', {
    staticClass: "mt-10 mb-25",
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'paymentRules'
      }
    }
  }, [_vm._v("定薪规则管理")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("编辑规则")])], 1), _vm._v(" "), _c('el-form', {
    ref: "form",
    attrs: {
      "label-width": "90px",
      "model": _vm.ruleForm,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "规则名称:",
      "prop": "name"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "size": "medium",
      "maxlength": 20,
      "placeholder": "请输入规则名称"
    },
    model: {
      value: (_vm.ruleForm.name),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "is-required",
    attrs: {
      "label": "是否启用:"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.ruleForm.state),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "state", $$v)
      },
      expression: "ruleForm.state"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("停用")])], 1), _vm._v(" "), _c('span', {
    staticClass: "level-tip"
  }, [_vm._v("（停用后将不能使用该定薪规则，但不影响历史数据）")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "说明文档:"
    }
  }, [_c('el-upload', {
    staticClass: "upload-desc",
    attrs: {
      "multiple": false,
      "action": _vm.action,
      "on-preview": _vm.handlePreview,
      "accept": "application/pdf",
      "on-success": _vm.handleFileSuccess,
      "on-remove": _vm.handleFileRemove,
      "file-list": _vm.fileList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("点击上传")]), _vm._v(" "), _c('div', {
    staticClass: "file-upload-tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("（只限pdf格式）")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "is-required",
    attrs: {
      "label": "定级详情:"
    }
  }, [_vm._l((_vm.paymentConfigs), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "rule-row mb-15"
    }, [_c('div', {
      staticClass: "el-table el-table--fit el-table--border el-table--enable-row-transition",
      staticStyle: {
        "width": "602px"
      }
    }, [_c('table', {
      staticClass: "el-table__body"
    }, [_c('tr', {
      staticClass: "el-table__row"
    }, [_c('td', {
      staticClass: "is-center",
      attrs: {
        "width": "50"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v("定级")])]), _vm._v(" "), _c('td', {
      staticClass: "is-center",
      attrs: {
        "width": "400"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_c('el-input', {
      attrs: {
        "size": "medium",
        "placeholder": "请输入定级名称"
      },
      model: {
        value: (item.secLevel),
        callback: function($$v) {
          _vm.$set(item, "secLevel", (typeof $$v === 'string' ? $$v.trim() : $$v))
        },
        expression: "item.secLevel"
      }
    })], 1)]), _vm._v(" "), _c('td', {
      staticClass: "is-center",
      attrs: {
        "width": "150"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_c('el-button', {
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          return _vm.addInnerRow(item)
        }
      }
    }, [_vm._v("新增")]), _vm._v(" "), (_vm.paymentConfigs.length > 1) ? _c('el-button', {
      staticStyle: {
        "color": "#ff4949"
      },
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          return _vm.paymentConfigs.splice(index, 1)
        }
      }
    }, [_vm._v("删除")]) : _vm._e()], 1)])])])]), _vm._v(" "), _c('el-table', {
      staticClass: "rule-salary",
      staticStyle: {
        "width": "602px"
      },
      attrs: {
        "data": item.paymentList,
        "border": "",
        "align": "center"
      }
    }, [_c('el-table-column', {
      attrs: {
        "header-align": "center",
        "align": "center",
        "width": "50",
        "type": "index"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "header-align": "center",
        "align": "center",
        "width": "200",
        "label": "定薪",
        "prop": "paymentLevel"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-input', {
            attrs: {
              "size": "medium"
            },
            model: {
              value: (scope.row.paymentLevel),
              callback: function($$v) {
                _vm.$set(scope.row, "paymentLevel", (typeof $$v === 'string' ? $$v.trim() : $$v))
              },
              expression: "scope.row.paymentLevel"
            }
          })]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "header-align": "center",
        "align": "center",
        "width": "200",
        "label": "offer标准",
        "prop": "paymentMonth"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-input', {
            attrs: {
              "size": "medium",
              "maxlength": "10"
            },
            model: {
              value: (scope.row.paymentMonth),
              callback: function($$v) {
                _vm.$set(scope.row, "paymentMonth", (typeof $$v === 'string' ? $$v.trim() : $$v))
              },
              expression: "scope.row.paymentMonth"
            }
          })]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "header-align": "center",
        "align": "center",
        "width": "150",
        "label": "操作"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(item.paymentList.length > 1) ? _c('el-button', {
            staticStyle: {
              "color": "#ff4949"
            },
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return item.paymentList.splice(scope.$index, 1)
              }
            }
          }, [_vm._v("删除")]) : _vm._e()]
        }
      }], null, true)
    })], 1)], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-20"
  }, [_c('el-button', {
    attrs: {
      "type": "default",
      "icon": "el-icon-plus"
    },
    on: {
      "click": _vm.addLevelBlock
    }
  }, [_vm._v("添加定级")]), (_vm.paymentConfigs.length) ? _c('span', {
    staticClass: "level-tip"
  }, [_vm._v("（当前共" + _vm._s(_vm.paymentConfigs.length) + "个定级）")]) : _vm._e()], 1)], 2), _vm._v(" "), _c('el-form-item', {
    staticClass: "handler-btns"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.$back({
          name: 'paymentRules'
        })
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var salary_salayRuleDetail_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/views/salary/salayRuleDetail.vue
function injectStyle (ssrContext) {
  __webpack_require__(912)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  salayRuleDetail_defaultExport,
  salary_salayRuleDetail_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(913);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("369651f2", content, true);

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".scoped-salary-rules{min-height:500px}.scoped-salary-rules .file-upload-tip{padding-top:5px;position:absolute;left:240px;top:-7px;color:#aaa}.scoped-salary-rules .level-tip{color:#aaa;margin-left:30px}.scoped-salary-rules .handler-btns{background:#fbfbfb;padding:30px 80px;border:1px solid #ddd;border-radius:5px}.scoped-salary-rules .rule-salary th{height:30px}.scoped-salary-rules .rule-salary .is-leaf{font-weight:400}.scoped-salary-rules .rule-salary .is-leaf .cell{color:#999}.scoped-salary-rules .upload-desc{width:300px}", ""]);

// exports


/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/entry/entryList.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_queryListExtend__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mixins_selectMapMixin__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__operation_operationMixin__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__operation_remarkEditDialog_vue__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__operation_multiRemarkEditDialog_vue__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__operation_attachViewInList_vue__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__operation_queryListMixin__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_modules_tools__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_views_common_multiSearch__ = __webpack_require__(88);












/* harmony default export */ var entryList_defaultExport = ({
    'extends': __WEBPACK_IMPORTED_MODULE_0_components_queryListExtend__["a" /* default */],
    'mixins': [__WEBPACK_IMPORTED_MODULE_1_mixins_selectMapMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__operation_operationMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__operation_queryListMixin__["a" /* default */]],
    components: {
        AttachViewInList: __WEBPACK_IMPORTED_MODULE_5__operation_attachViewInList_vue__["a" /* default */], RemarkEdit: __WEBPACK_IMPORTED_MODULE_3__operation_remarkEditDialog_vue__["a" /* default */], MultiSearch: __WEBPACK_IMPORTED_MODULE_8_views_common_multiSearch__["a" /* default */], MultiRemarkEditDialog: __WEBPACK_IMPORTED_MODULE_4__operation_multiRemarkEditDialog_vue__["a" /* default */]
    },
    data: function data() {
        return {
            fetchUrl: '/entry/list.api',
            multiFields: [{
                filter: 'WB_RESUME_STATUS_7',
                label: '简历状态',
                mode: 'select',
                data: [],
                name: 'statusSearch'
            }],
            searchData: {
                searchWord: null
            }
        };
    },

    methods: {
        multiRemarkEdit: function multiRemarkEdit(ids) {
            if (this.checkDataValid(ids)) {
                var $target = this.$refs.multiRemarkEditDialog;
                var rids = this.lists.filter(function (cv) {
                    return ids.indexOf(cv.id) > -1;
                }).map(function (cv) {
                    return cv.resumeForm.id;
                }).join(',');
                $target && $target.show(rids);
            }
        },
        dateFormat: function dateFormat(date) {
            var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'yyyy/MM/dd';

            return Object(__WEBPACK_IMPORTED_MODULE_7_modules_tools__["a" /* dateFormat */])(date, format);
        },
        addResume: function addResume() {
            this.$refs.addResumeDialog.show();
        },
        fetchCallback: function fetchCallback(res) {},
        recommendResume: function recommendResume(item) {
            this.$refs.recommendResumeDialog.show(item);
        },
        toResumeDetail: function toResumeDetail(row) {
            var path = this.getResumeDetailUrl(row.id, row.status);

            var routeData = this.$router.resolve({ path: path });
            window.open(routeData.href, '_blank');
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-171d18dd"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/entry/entryList.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.firstRendered) ? _c('div', [_c('div', {
    staticClass: "filter-condition box-shadow-small border-radius"
  }, [_c('multi-search', {
    attrs: {
      "fields": _vm.multiFields
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "filter-result background-white box-shadow-small border-radius"
  }, [_c('div', {
    staticClass: "filter-result-header mt-15 clearfix"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    staticClass: "hide",
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("导出面试评分表")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.multiRemarkEdit(_vm.idStr)
      }
    }
  }, [_vm._v("批量编辑备注")]), _vm._v(" "), _c('el-dropdown', [_c('el-button', {
    attrs: {
      "icon": "el-icon-my-daochu",
      "type": "info"
    }
  }, [_vm._v("导出简历"), _c('i', {
    staticClass: "el-icon-caret-bottom el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.exportFiles(_vm.idStr)
      }
    }
  }, [_vm._v("导出已选记录(excel)")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.exportFiles(_vm.idStr, undefined, undefined, 'type=HTML')
      }
    }
  }, [_vm._v("导出已选记录(html)")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.exportParamsFiles('/entry/exportAllResume.api')
      }
    }
  }, [_vm._v("导出所有查询结果(excel)")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.exportParamsFiles('/entry/exportAllResume.api', 'HTML')
      }
    }
  }, [_vm._v("导出所有查询结果(html)")])], 1)], 1), _vm._v(" "), _c('export-custom-dialog', {
    attrs: {
      "valid-call-back": _vm.customExportValid,
      "params-call-back": _vm.customExportParams
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [(_vm.lists.length) ? _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "end"
    }
  }, [_c('el-button', {
    attrs: {
      "icon": "el-icon-my-queding color-success",
      "type": "success",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.idStr, 'pass', null, '入职')
      }
    }
  }, [_vm._v("入职")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-guanbi color-danger",
      "type": "danger",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.idStr, 'notPass', null, '毁约')
      }
    }
  }, [_vm._v("毁约")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-huitui color-info",
      "type": "info",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.idStr, 'back')
      }
    }
  }, [_vm._v("回退")])], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.partialLoading),
      expression: "partialLoading"
    }]
  }, [_c('empty-tip', {
    attrs: {
      "show": !_vm.lists.length
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "table-list mt-20"
  }, [(_vm.lists.length) ? _c('el-table', {
    attrs: {
      "data": _vm.lists
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center",
      "fixed": "",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "姓名",
      "show-overflow-tooltip": true,
      "align": "center",
      "fixed": "",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "name-txt",
          on: {
            "click": function($event) {
              return _vm.toResumeDetail(scope.row)
            }
          }
        }, [_vm._v("\n                                " + _vm._s(scope.row.resumeForm.name) + "\n                            ")])]
      }
    }], null, false, 1635889994)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resumeForm.gender",
      "label": "性别",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "70"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s({
          1: '男',
          2: '女'
        }[scope.row.resumeForm.gender] || '-'))]
      }
    }], null, false, 3168019877)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "岗位",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.positionForm.name) + "\n                        ")]
      }
    }], null, false, 2092161755)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "招聘部门",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.positionForm.deptNames) + "\n                        ")]
      }
    }], null, false, 2934477005)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resumeForm.mobilePhone",
      "label": "手机号",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resumeForm.email",
      "label": "邮箱",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "110"
    }
  }), _c('el-table-column', {
    attrs: {
      "label": "最高学历",
      "align": "center",
      "show-overflow-tooltip": true,
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(_vm.getSelectMapText('WB_EDU_DEGREE', scope.row.resumeForm.resumeMaxEducation.degree)) + "\n                    ")]
      }
    }], null, false, 2417504390)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "最高学历学校",
      "align": "center",
      "show-overflow-tooltip": true,
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.resumeForm.schoolType === '1') ? _c('el-tag', {
          attrs: {
            "type": "primary"
          }
        }, [_vm._v("985")]) : (scope.row.resumeForm.schoolType === '2') ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("211")]) : _vm._e(), _vm._v("\n                            " + _vm._s(scope.row.resumeForm.resumeMaxEducation.school) + "\n                        ")]
      }
    }], null, false, 2122314332)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resumeForm.resumeMaxEducation.major",
      "label": "专业",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resumeForm.origin",
      "label": "籍贯",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "简历来源",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.getSelectMapText('WB_RESUME_SOURCE', scope.row.resumeForm.resumeSource)) + "\n                        ")]
      }
    }], null, false, 3166876443)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "当前所在地",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.resumeForm.residence || '-') + "\n                        ")]
      }
    }], null, false, 3375146197)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "应聘城市",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.getSelectMapText('WB_POSITION_CITY', scope.row.resumeForm.expectCityId)) + "\n                        ")]
      }
    }], null, false, 2621839696)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "positionForm.sourceFrom",
      "label": "投递渠道",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.resumeForm && _vm.getSelectMapText('WB_ADD_SOURCE',
          scope.row.resumeForm.addSource)) + "\n                        ")]
      }
    }], null, false, 3698601694)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "投递人",
      "prop": "resumeForm.addName",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "推荐人",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.resumeForm.recommenderUser) ? _c('span', [_vm._v(_vm._s(scope.row.resumeForm.recommenderUser.name))]) : _vm._e()]
      }
    }], null, false, 2383682320)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "游戏经验",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.resumeForm.gameExperience) + "\n                        ")]
      }
    }], null, false, 3038609676)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "简历附件",
      "align": "center",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('attach-view-in-list', {
          attrs: {
            "attachList": scope.row.resumeForm.resumeAttachList
          }
        })]
      }
    }], null, false, 2021903071)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "投递时间",
      "show-overflow-tooltip": true,
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm.dateFormat(scope.row.commitTime)))]
      }
    }], null, false, 3274253775)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.getSelectMapText('WB_FLOW_STATUS', scope.row.status)) + "\n                        ")]
      }
    }], null, false, 1024731912)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "class-name": "no-wrap",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-dropdown', {
          attrs: {
            "hide-on-click": false
          },
          on: {
            "command": _vm.handleCommand
          }
        }, [_c('span', {
          staticClass: "el-dropdown-link"
        }, [_vm._v("入职评估")]), _vm._v(" "), _c('el-dropdown-menu', {
          attrs: {
            "slot": "dropdown"
          },
          slot: "dropdown"
        }, [_c('el-dropdown-item', {
          attrs: {
            "command": ((scope.row.id) + "/pass//入职")
          }
        }, [_c('i', {
          staticClass: "el-icon-my-queding color-success mr-10"
        }), _vm._v("入职\n                                    ")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": ((scope.row.id) + "/notPass//毁约")
          }
        }, [_c('i', {
          staticClass: "el-icon-my-guanbi color-danger mr-10"
        }), _vm._v("毁约\n                                    ")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": ((scope.row.id) + "/back")
          }
        }, [_c('i', {
          staticClass: "el-icon-my-huitui color-info mr-10"
        }), _vm._v("回退\n                                    ")])], 1)], 1)]
      }
    }], null, false, 3499144239)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "show-overflow-tooltip": true,
      "label": "备注",
      "align": "center",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('remark-edit', {
          attrs: {
            "id": scope.row.resumeForm.id
          },
          model: {
            value: (scope.row.resumeForm.remark),
            callback: function($$v) {
              _vm.$set(scope.row.resumeForm, "remark", $$v)
            },
            expression: "scope.row.resumeForm.remark"
          }
        })]
      }
    }], null, false, 1691095712)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resumeForm.remark",
      "show-overflow-tooltip": true,
      "label": "最近操作人",
      "align": "center",
      "min-width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticStyle: {
            "font-size": "12px"
          }
        }, [_c('p', [_vm._v(_vm._s(scope.row.lastOperateUserInfo ? scope.row.lastOperateUserInfo.name : ''))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(scope.row.lastOperateTime && scope.row.lastOperateTime.slice(5)))])])]
      }
    }], null, false, 4062077065)
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.lists.length) ? _c('el-pagination', {
    staticClass: "text-center mt-20 mb-20",
    attrs: {
      "current-page": _vm.pagination.pageIndex,
      "page-size": _vm.pagination.pageSize,
      "page-sizes": [20, 50, 100, 200],
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.pagination.recordCounts
    },
    on: {
      "size-change": _vm.pageSizeChange,
      "current-change": _vm.pageIndexChange
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('multi-remark-edit-dialog', {
    ref: "multiRemarkEditDialog",
    on: {
      "reload": _vm.fetchData
    }
  })], 1)]) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var entry_entryList_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/views/entry/entryList.vue
function injectStyle (ssrContext) {
  __webpack_require__(915)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  entryList_defaultExport,
  entry_entryList_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(916);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("6bde75da", content, true);

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/written/writtenList.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_queryListExtend__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mixins_selectMapMixin__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__operation_remarkEditDialog_vue__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__operation_multiRemarkEditDialog_vue__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__operation_operationMixin__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__operation_queryListMixin__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_statusIcon__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_modules_tools__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_views_common_multiSearch__ = __webpack_require__(88);












/* harmony default export */ var writtenList_defaultExport = ({
    components: {
        StatusIcon: __WEBPACK_IMPORTED_MODULE_6_components_statusIcon__["a" /* default */], RemarkEdit: __WEBPACK_IMPORTED_MODULE_2__operation_remarkEditDialog_vue__["a" /* default */], MultiSearch: __WEBPACK_IMPORTED_MODULE_8_views_common_multiSearch__["a" /* default */], MultiRemarkEditDialog: __WEBPACK_IMPORTED_MODULE_3__operation_multiRemarkEditDialog_vue__["a" /* default */]
    },
    'extends': __WEBPACK_IMPORTED_MODULE_0_components_queryListExtend__["a" /* default */],
    'mixins': [__WEBPACK_IMPORTED_MODULE_1_mixins_selectMapMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__operation_operationMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__operation_queryListMixin__["a" /* default */]],
    data: function data() {
        return {
            fetchUrl: '/arrangeExam/list.api',
            multiFields: [{
                filter: 'WB_RESUME_STATUS_1',
                label: '简历状态',
                data: [],
                mode: 'select',
                name: 'resumeStatus'
            }, {
                filter: 'WB_RESUME_EXAM_STATUS',
                label: '考试状态',
                data: [],
                mode: 'select',
                name: 'examStatus'
            }, {
                filter: '',
                label: '安排时间',
                data: [],
                mode: 'date',
                name: 'arrangeTime'
            }, {
                filter: '',
                label: '开始时间',
                data: [],
                mode: 'date',
                name: 'startTime'
            }],
            oneScoreList: []
        };
    },

    methods: {
        multiRemarkEdit: function multiRemarkEdit(ids) {
            if (this.checkDataValid(ids)) {
                var $target = this.$refs.multiRemarkEditDialog;
                var rids = this.lists.filter(function (cv) {
                    return ids.indexOf(cv.id) > -1;
                }).map(function (cv) {
                    return cv.resumeId;
                }).join(',');
                $target && $target.show(rids);
            }
        },
        dateFormat: function dateFormat(date) {
            var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'yyyy/MM/dd';

            return Object(__WEBPACK_IMPORTED_MODULE_7_modules_tools__["a" /* dateFormat */])(date, format);
        },
        multiProcess: function multiProcess(routeName) {
            if (!this.checkDataValid(this.idStr)) {
                return false;
            }
            this.$router.push({ name: routeName, params: { ids: this.idStr } });
        },
        hideTooltip: function hideTooltip(curItem) {
            if (this.ajax) {
                this.source.cancel('取消未返回的请求');
            } else {
                this.$set(curItem, 'isExamStatusShow', false);
                this.$nextTick(function () {
                    var doms = document.querySelectorAll('.tooltip-status-popover');
                    doms.forEach(function (item) {
                        item.remove();
                    });
                });
            }
        },
        changeArrangeTime: function changeArrangeTime(value) {
            this.searchData.arrangeTime = value;
        },
        changeStartTime: function changeStartTime(value) {
            this.searchData.startTime = value;
        },
        tableColumnFormatter: function tableColumnFormatter(row, column, value) {
            return value || '-';
        },
        searchScore: function searchScore(curItem) {
            var _this = this;

            var rpid = curItem.id;
            if (this.ajax) {
                this.source.cancel('取消未返回的请求');
            }
            var CancelToken = this.$axios.CancelToken;
            this.source = CancelToken.source();
            this.oneScoreList = [];
            this.ajax = this.$axios.get('/arrangeExam/getPaperScore.api?id=' + rpid, {
                cancelToken: this.source.token
            }).then(function (res) {
                _this.ajax = null;
                _this.oneScoreList = res.result.list;
                _this.showTips(curItem);
            });
        },
        showTips: function showTips(curItem) {
            var _this2 = this;

            this.lists.map(function (item) {
                item.isExamStatusShow === true && _this2.$set(item, 'isExamStatusShow', false);
            });
            this.$set(curItem, 'isExamStatusShow', true);
            this.$nextTick(function () {
                var doms = document.querySelectorAll('.tooltip-status-popover');
                doms.forEach(function (item, index) {
                    index !== doms.length - 1 && item.remove();
                });
            });
        },
        toResumeDetail: function toResumeDetail(row) {
            var path = '/resume/detail/' + row.id + '/' + row.resumeStatus.substr(0, 1);

            var routeData = this.$router.resolve({ path: path });
            window.open(routeData.href, '_blank');
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e506567"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/written/writtenList.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.firstRendered) ? _c('div', [_c('div', {
    staticClass: "filter-condition box-shadow-small border-radius"
  }, [_c('multi-search', {
    attrs: {
      "fields": _vm.multiFields
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "filter-result background-white box-shadow-small border-radius"
  }, [_c('div', {
    staticClass: "filter-result-header clearfix mt-10"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.multiProcess('writtenArrangement')
      }
    }
  }, [_vm._v("批量笔试安排")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.multiProcess('writtenRecommend')
      }
    }
  }, [_vm._v("批量笔试推荐")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'writtenExamList'
        })
      }
    }
  }, [_vm._v("查看笔试安排列表")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.multiRemarkEdit(_vm.idStr)
      }
    }
  }, [_vm._v("批量编辑备注")]), _vm._v(" "), _c('el-dropdown', {
    staticClass: "ml-10"
  }, [_c('el-button', {
    attrs: {
      "icon": "el-icon-my-daochu",
      "type": "primary"
    }
  }, [_vm._v("导出简历"), _c('i', {
    staticClass: "el-icon-caret-bottom el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.exportFiles(_vm.idStr, '/arrangeExam')
      }
    }
  }, [_vm._v("导出已选记录(excel)")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.exportFiles(_vm.idStr, '/arrangeExam', undefined, 'type=HTML')
      }
    }
  }, [_vm._v("导出已选记录(html)")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.exportParamsFiles('/arrangeExam/exportAllResume.api')
      }
    }
  }, [_vm._v("导出所有查询结果(excel)")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.exportParamsFiles('/arrangeExam/exportAllResume.api', 'HTML')
      }
    }
  }, [_vm._v("\n                                导出所有查询结果(html)\n                            ")])], 1)], 1), _vm._v(" "), _c('export-custom-dialog', {
    attrs: {
      "valid-call-back": _vm.customExportValid,
      "params-call-back": _vm.customExportParams
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [(_vm.lists.length) ? _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "end"
    }
  }, [_c('el-button', {
    attrs: {
      "icon": "el-icon-my-queding color-success",
      "type": "success",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.idStr, 'pass')
      }
    }
  }, [_vm._v("通过\n                        ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-daiding color-warning",
      "type": "warning",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.idStr, 'undetermined')
      }
    }
  }, [_vm._v("待定\n                        ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-guanbi color-danger",
      "type": "danger",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.idStr, 'notPass')
      }
    }
  }, [_vm._v("淘汰\n                        ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-lahei color-purple",
      "type": "purple",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.idStr, 'lh')
      }
    }
  }, [_vm._v("拉黑\n                        ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-huitui color-info",
      "type": "info",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.idStr, 'back')
      }
    }
  }, [_vm._v("回退\n                        ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-guanbi color-danger",
      "type": "danger",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.idStr, 'fq')
      }
    }
  }, [_vm._v("放弃\n                        ")])], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.partialLoading),
      expression: "partialLoading"
    }]
  }, [_c('empty-tip', {
    attrs: {
      "show": !_vm.lists.length
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "table-list mt-20"
  }, [(_vm.lists.length) ? _c('el-table', {
    attrs: {
      "data": _vm.lists
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center",
      "fixed": "",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "姓名",
      "fixed": "",
      "min-width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [(scope.row.operateReason) ? _c('el-tooltip', {
          attrs: {
            "effect": "dark",
            "content": scope.row.operateReason,
            "placement": "top-start"
          }
        }, [_c('span', [_c('status-icon', {
          attrs: {
            "icon": ['not-deal', 'undetermined', 'not-pass', 'lh', 'fq'][scope.row.resumeStatus.substr(2)]
          }
        }), _c('i', {
          staticClass: "el-icon-my-xinxi"
        })], 1)]) : _c('status-icon', {
          attrs: {
            "icon": ['not-deal', 'undetermined', 'not-pass', 'lh', 'fq'][scope.row.resumeStatus.substr(2)]
          }
        }), _vm._v(" "), _c('span', {
          staticClass: "name-txt eclip-name-txt",
          attrs: {
            "title": scope.row.name
          },
          on: {
            "click": function($event) {
              return _vm.toResumeDetail(scope.row)
            }
          }
        }, [_vm._v("\n                                    " + _vm._s(scope.row.name) + "\n                                ")])], 1)]
      }
    }], null, false, 3961304189)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "gender",
      "label": "性别",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "70"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s({
          1: '男',
          2: '女'
        }[scope.row.gender] || '-'))]
      }
    }], null, false, 3151373380)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "岗位",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.positionName) + "\n                        ")]
      }
    }], null, false, 2940168419)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "招聘部门",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.deptNames) + "\n                        ")]
      }
    }], null, false, 3474352204)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "手机号",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "email",
      "label": "邮箱",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "degree",
      "label": "最高学历",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.getSelectMapText('WB_EDU_DEGREE', scope.row.degree)) + "\n                        ")]
      }
    }], null, false, 4066434606)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "school",
      "label": "最高学历学校",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "major",
      "label": "专业",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "90"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "简历来源",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.getSelectMapText('WB_RESUME_SOURCE', scope.row.resumeSource) || '-') + "\n                        ")]
      }
    }], null, false, 3000401975)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "residence",
      "label": "当前所在地",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "90"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "应聘城市",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.getSelectMapText('WB_POSITION_CITY', scope.row.expectCityId)) + "\n                        ")]
      }
    }], null, false, 4273930065)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "positionForm.sourceFrom",
      "label": "投递渠道",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.getSelectMapText('WB_ADD_SOURCE',
          scope.row.addSource)) + "\n                        ")]
      }
    }], null, false, 1900089712)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "投递人",
      "prop": "addName",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "推荐人",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.recommender) ? _c('span', [_vm._v(_vm._s(scope.row.recommender.name))]) : _vm._e()]
      }
    }], null, false, 1484247024)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "投递时间",
      "show-overflow-tooltip": true,
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm.dateFormat(scope.row.commitTime)))]
      }
    }], null, false, 3274253775)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "考试场次",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scoped) {
        return [_c('router-link', {
          staticClass: "exam-name-span",
          attrs: {
            "title": scoped.row.examName,
            "target": "_blank",
            "to": ("/written/exam/detail/" + (scoped.row.examId))
          }
        }, [_vm._v(_vm._s(scoped.row.examName))]), _vm._v(" "), (scoped.row.examTimes.length) ? _c('el-popover', {
          attrs: {
            "placement": "top",
            "popper-class": "dark-theme popper-line",
            "trigger": "hover"
          }
        }, [_c('div', {
          staticStyle: {
            "width": "220px"
          }
        }, [_c('p', [_vm._v("考试时间")]), _vm._v(" "), _vm._l((scoped.row.examTimes), function(item, index) {
          return _c('p', {
            key: index
          }, [_vm._v(_vm._s(item.startTime) + "-" + _vm._s(item.endTime.slice(10)))])
        })], 2), _vm._v(" "), _c('span', {
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [_c('i', {
          staticClass: "el-icon-my-xinxi color-primary"
        })])]) : _vm._e()]
      }
    }], null, false, 1402188680)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "答卷",
      "prop": "paperName",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scoped) {
        return [(scoped.row.paperName) ? [_c('router-link', {
          attrs: {
            "target": "_blank",
            "to": ("/written/topic/" + (scoped.row.paperId) + "?resumePositionId=" + (scoped.row.resumePositionId) + "&examId=" + (scoped.row.examId))
          }
        }, [_vm._v(_vm._s(scoped.row.paperName))])] : _vm._e()]
      }
    }], null, false, 1601771769)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "答卷时间段",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scoped) {
        return [(scoped.row.startTime && scoped.row.endTime) ? [_vm._v(_vm._s(scoped.row.startTime) + "-" + _vm._s(scoped.row.endTime.slice(10)))] : _vm._e()]
      }
    }], null, false, 1879860894)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "考试状态",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.getSelectMapText('WB_RESUME_EXAM_STATUS', scope.row.examStatus)) + "\n                            "), (scope.row.examStatus) ? _c('el-popover', {
          attrs: {
            "placement": "top",
            "popper-class": "dark-theme popper-line text-center tooltip-status-popover",
            "value": scope.row.isExamStatusShow,
            "trigger": "manual"
          },
          nativeOn: {
            "mouseenter": function($event) {
              return _vm.searchScore(scope.row)
            },
            "mouseleave": function($event) {
              return _vm.hideTooltip(scope.row)
            }
          }
        }, [_c('div', {
          staticStyle: {
            "width": "300px"
          }
        }, [(_vm.oneScoreList.length) ? _c('span', [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 5
          }
        }, [_vm._v("评估人")]), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 5
          }
        }, [_vm._v("评分")]), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 5
          }
        }, [_vm._v("状态")]), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 9
          }
        }, [_vm._v("备注")])], 1), _vm._v(" "), _vm._l((_vm.oneScoreList), function(item, index) {
          return _c('el-row', {
            key: index
          }, [_c('el-col', {
            attrs: {
              "span": 5
            }
          }, [_vm._v(_vm._s(item.markName))]), _vm._v(" "), _c('el-col', {
            attrs: {
              "span": 5
            }
          }, [_vm._v(_vm._s(item.score || '-'))]), _vm._v(" "), _c('el-col', {
            attrs: {
              "span": 5
            }
          }, [_vm._v(_vm._s(item.result || '-'))]), _vm._v(" "), _c('el-col', {
            attrs: {
              "span": 9
            }
          }, [_vm._v(_vm._s(item.remark || '-'))])], 1)
        })], 2) : _c('el-row', [_vm._v("暂无数据")])], 1), _vm._v(" "), _c('span', {
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [_c('i', {
          staticClass: "el-icon-my-xinxi color-primary"
        })])]) : _c('span', [_vm._v("-")])]
      }
    }], null, false, 3769297722)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "评分",
      "prop": "score",
      "show-overflow-tooltip": true,
      "align": "center",
      "formatter": _vm.tableColumnFormatter,
      "min-width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "class-name": "no-wrap",
      "min-width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-dropdown', {
          staticClass: "mr-10",
          attrs: {
            "hide-on-click": false
          },
          on: {
            "command": _vm.handleCommand
          }
        }, [_c('span', {
          staticClass: "el-dropdown-link"
        }, [_vm._v("笔试评估")]), _vm._v(" "), _c('el-dropdown-menu', {
          attrs: {
            "slot": "dropdown"
          },
          slot: "dropdown"
        }, [_c('el-dropdown-item', {
          attrs: {
            "command": ((scope.row.id) + "/pass")
          }
        }, [_c('i', {
          staticClass: "el-icon-my-queding color-success mr-10"
        }), _vm._v("通过\n                                    ")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": ((scope.row.id) + "/undetermined")
          }
        }, [_c('i', {
          staticClass: "el-icon-my-daiding color-warning mr-10"
        }), _vm._v("待定\n                                    ")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": ((scope.row.id) + "/notPass")
          }
        }, [_c('i', {
          staticClass: "el-icon-my-guanbi color-danger mr-10"
        }), _vm._v("淘汰\n                                    ")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": ((scope.row.id) + "/lh")
          }
        }, [_c('i', {
          staticClass: "el-icon-my-lahei color-purple mr-10"
        }), _vm._v("拉黑\n                                    ")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": ((scope.row.id) + "/back")
          }
        }, [_c('i', {
          staticClass: "el-icon-my-huitui color-info mr-10"
        }), _vm._v("回退\n                                    ")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": ((scope.row.id) + "/fq")
          }
        }, [_c('i', {
          staticClass: "el-icon-my-guanbi color-danger mr-10"
        }), _vm._v("放弃\n                                    ")])], 1)], 1), _vm._v(" "), _c('router-link', {
          attrs: {
            "to": ("/written/recommend/" + (scope.row.id))
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          }
        }, [_vm._v("笔试推荐")])], 1)]
      }
    }], null, false, 3475871136)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "show-overflow-tooltip": true,
      "label": "备注",
      "align": "center",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('remark-edit', {
          attrs: {
            "id": scope.row.resumeId
          },
          model: {
            value: (scope.row.resumeRemark),
            callback: function($$v) {
              _vm.$set(scope.row, "resumeRemark", $$v)
            },
            expression: "scope.row.resumeRemark"
          }
        })]
      }
    }], null, false, 1923734144)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resumeForm.remark",
      "show-overflow-tooltip": true,
      "label": "最近操作人",
      "align": "center",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticStyle: {
            "font-size": "12px"
          }
        }, [_c('p', [_vm._v(_vm._s(scope.row.lastOperateUserName))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(scope.row.lastOperateTime && scope.row.lastOperateTime.slice(5)))])])]
      }
    }], null, false, 3685772737)
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.lists.length) ? _c('el-pagination', {
    staticClass: "text-center mt-20 mb-20",
    attrs: {
      "current-page": _vm.pagination.pageIndex,
      "page-size": _vm.pagination.pageSize,
      "page-sizes": [20, 50, 100, 200],
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.pagination.recordCounts
    },
    on: {
      "size-change": _vm.pageSizeChange,
      "current-change": _vm.pageIndexChange
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('multi-remark-edit-dialog', {
    ref: "multiRemarkEditDialog",
    on: {
      "reload": _vm.fetchData
    }
  })], 1)]) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var written_writtenList_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/views/written/writtenList.vue
function injectStyle (ssrContext) {
  __webpack_require__(918)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  writtenList_defaultExport,
  written_writtenList_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(919);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("1eca804e", content, true);

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".dark-theme{background:#1f2d3d;color:#fff;border-radius:5px}.dark-theme[x-placement^=top] .popper__arrow:after{border-top-color:#1f2d3d}.popper-line .el-row{word-break:break-all;padding:3px 0}.popper-line .el-row:not(:first-child){border-top:1px solid #415062;margin-top:1px}.exam-name-span{max-width:95px;display:inline-block;overflow:hidden;text-overflow:ellipsis;vertical-align:bottom}", ""]);

// exports


/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(921);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("a64fe480", content, true);

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".status-icon[data-v-05ace6cf]{width:48px;height:21px;display:inline-block;vertical-align:middle;background:url(" + __webpack_require__(922) + ") no-repeat 0 0}.status-icon.undetermined[data-v-05ace6cf]{background-position:0 -31px}.status-icon.lh[data-v-05ace6cf]{background-position:0 -62px}.status-icon.not-deal[data-v-05ace6cf]{background-position:0 -93px}.status-icon.fq[data-v-05ace6cf]{background-position:0 -125px}", ""]);

// exports


/***/ }),
/* 922 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/written/writtenPersonDetail.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_thumbnail__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_views_common_empty__ = __webpack_require__(121);








/* harmony default export */ var writtenPersonDetail_defaultExport = ({
    components: {
        Thumbnail: __WEBPACK_IMPORTED_MODULE_3_components_thumbnail__["a" /* default */],
        EmptyTip: __WEBPACK_IMPORTED_MODULE_4_views_common_empty__["a" /* default */]
    },
    data: function data() {
        return {
            urls: {
                fetch: '/arrangeExam/getExamInfo.api'
            },
            baseInfo: {},
            baseData: {} };
    },

    computed: {
        id: function id() {
            return this.$route.params.id;
        }
    },
    methods: {
        fetchData: function fetchData() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var res1, res2;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this.$axios.get(_this.urls.fetch, { params: { resumePositionId: _this.id } });

                            case 2:
                                res1 = _context.sent;
                                _context.next = 5;
                                return _this.$axios.post('/resumePosition/interviewArrange/getListWithOutEva.api', { resumePositionId: _this.id });

                            case 5:
                                res2 = _context.sent;


                                _this.baseInfo = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, res1.result.exam, {
                                    positionName: res2.result.position.name,
                                    deptNames: res2.result.position.deptNames,
                                    gender: res2.result.resume.gender
                                });

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        sendEmail: function sendEmail(data, type) {
            var ids = [];
            var users = {};
            data.forEach(function (item) {
                ids.push(item.id);
                var masterIds = item.masterInterviewer.split(','),
                    masterNames = item.masterInterviewerNames.split('，'),
                    interviewIds = item.interviewer.split(','),
                    interviewNames = item.interviewerNames.split('，');
                item.interviewerUsers = [];
                if (item.masterInterviewer !== '') {
                    masterIds.forEach(function (mid, mindex) {
                        users[mid] = masterNames[mindex];
                        item.interviewerUsers.push({
                            id: mid,
                            name: masterNames[mindex]
                        });
                    });
                }
                if (item.interviewer !== '') {
                    interviewIds.forEach(function (iid, iindex) {
                        users[iid] = interviewNames[iindex];
                        item.interviewerUsers.push({
                            id: iid,
                            name: interviewNames[iindex]
                        });
                    });
                }
            });
            this.$refs.sendEmail.show({
                ids: this.baseData.id,
                interviewIds: ids.join(','),
                selecteds: data,
                resumePositionList: [this.result],
                phase: 2,
                userAttributes: type
            });
        }
    },
    created: function created() {
        this.fetchData();
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-657e0bcf"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/written/writtenPersonDetail.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scope-arrangement-setting container"
  }, [_c('div', {
    staticClass: "box-shadow-small border-radius",
    staticStyle: {
      "padding-bottom": "40px"
    }
  }, [_c('div', {}, [_c('div', {
    staticStyle: {
      "padding-top": "30px"
    }
  }, [_c('thumbnail', {
    attrs: {
      "text": _vm.baseInfo.name,
      "gender": _vm.baseInfo.gender === 1 ? 'man' : 'woman',
      "font-size": 16,
      "width": 110
    }
  }), _vm._v(" "), _c('el-row', {
    staticClass: "mt-10 text-center",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("应聘职位：" + _vm._s(_vm.baseInfo.positionName))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("应聘部门：" + _vm._s(_vm.baseInfo.deptNames))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("手机号：" + _vm._s(_vm.baseInfo.phone))])], 1)], 1)]), _vm._v(" "), (_vm.baseInfo.paperName) ? [_c('div', {
    staticClass: "mt-25"
  }, [_c('div', {
    staticClass: "el-table el-table--fit el-table--border el-table--enable-row-transition"
  }, [_c('table', {
    staticClass: "el-table__body",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', {
    staticClass: "el-table__row"
  }, [_vm._m(0), _vm._v(" "), _c('td', {
    staticClass: "is-center"
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v(_vm._s(_vm.baseInfo.examName || '-'))])])]), _vm._v(" "), _c('tr', {
    staticClass: "el-table__row"
  }, [_vm._m(1), _vm._v(" "), _c('td', {
    staticClass: "is-center"
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v(_vm._s(_vm.baseInfo.examRules || '-'))])])]), _vm._v(" "), _c('tr', {
    staticClass: "el-table__row"
  }, [_vm._m(2), _vm._v(" "), _c('td', {
    staticClass: "is-center"
  }, [_c('div', {
    staticClass: "cell"
  }, _vm._l((_vm.baseInfo.paperList), function(item, index) {
    return _c('p', {
      key: index
    }, [_vm._v(_vm._s(item.name))])
  }), 0)])]), _vm._v(" "), _c('tr', {
    staticClass: "el-table__row"
  }, [_vm._m(3), _vm._v(" "), _c('td', {
    staticClass: "is-center"
  }, [_c('div', {
    staticClass: "cell"
  }, _vm._l((_vm.baseInfo.examTimes), function(item, index) {
    return _c('p', {
      key: index
    }, [_vm._v("\n                                        " + _vm._s(item.startTime) + " - " + _vm._s(item.endTime))])
  }), 0)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mt-25"
  }, [_c('div', {
    staticClass: "el-table el-table--fit el-table--border el-table--enable-row-transition"
  }, [_c('table', {
    staticClass: "el-table__body",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', {
    staticClass: "el-table__row"
  }, [_vm._m(4), _vm._v(" "), _c('td', {
    staticClass: "is-center",
    attrs: {
      "width": "180",
      "colspan": "2"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v(_vm._s(_vm.baseInfo.privateScoreTotal || '-'))])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('td', {
    staticClass: "is-center"
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v(_vm._s(_vm.baseInfo.paperName || '-'))])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('td', {
    staticClass: "is-center",
    attrs: {
      "width": "250"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v(_vm._s(_vm.baseInfo.startTime) + " -  " + _vm._s((_vm.baseInfo.endTime || '').substring(11)))])])]), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._l((_vm.baseInfo.markExamList), function(item, index) {
    return _c('tr', {
      key: index,
      staticClass: "el-table__row"
    }, [_c('td', {
      staticClass: "is-center"
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.markName || '-'))])]), _vm._v(" "), _c('td', {
      staticClass: "is-center"
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.privateScore || '-'))])]), _vm._v(" "), _c('td', {
      staticClass: "is-center"
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.score || '-'))])]), _vm._v(" "), _c('td', {
      staticClass: "is-center"
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.result))])]), _vm._v(" "), _c('td', {
      staticClass: "is-center",
      attrs: {
        "colspan": "3"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.remark))])])])
  })], 2)])])] : _c('empty-tip')], 2)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "is-center",
    attrs: {
      "width": "240"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("考试标题")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "is-center"
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("考试须知")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "is-center"
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("选择笔试题")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "is-center"
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("考试日期")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "is-center",
    attrs: {
      "width": "120"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("系统评分总分")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "is-center",
    attrs: {
      "width": "120"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("答卷")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "is-center",
    attrs: {
      "width": "150"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("答卷时间段")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "el-table__row"
  }, [_c('td', {
    staticClass: "is-center",
    staticStyle: {
      "background": "#eee"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("评估人")])]), _vm._v(" "), _c('td', {
    staticClass: "is-center",
    staticStyle: {
      "background": "#eee"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("系统评分")])]), _vm._v(" "), _c('td', {
    staticClass: "is-center",
    staticStyle: {
      "background": "#eee"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("面试官评分")])]), _vm._v(" "), _c('td', {
    staticClass: "is-center",
    staticStyle: {
      "background": "#eee"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("状态")])]), _vm._v(" "), _c('td', {
    staticClass: "is-center",
    staticStyle: {
      "background": "#eee"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("备注")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var written_writtenPersonDetail_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/views/written/writtenPersonDetail.vue
function injectStyle (ssrContext) {
  __webpack_require__(924)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  writtenPersonDetail_defaultExport,
  written_writtenPersonDetail_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(925);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("5cdc4628", content, true);

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".scope-arrangement-setting .grey-line{position:absolute;height:100%;width:1px;background:#f4f4f3;padding:60px 0;box-sizing:border-box;left:83px}.scope-arrangement-setting .arrangement-first .grey-line{margin-top:50px}.scope-arrangement-setting .arrangement-last .grey-line{margin-top:-100px}.scope-arrangement-setting .c-text-banner.page-banner{background:url(" + __webpack_require__(230) + ") no-repeat;height:105px;position:relative}.scope-arrangement-setting .c-text-banner.page-banner h3{color:#fff;width:500px;font-size:20px;margin:0 0 0 80px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.scope-arrangement-setting .c-text-banner.page-banner .photo-img{display:inline-block;width:80px;height:80px;border-radius:100%;position:absolute}.scope-arrangement-setting .c-text-banner.page-banner .text-area-right{width:650px;top:30px;position:static;margin-left:110px;margin-top:20px}.scope-arrangement-setting .c-text-banner.page-banner .text-area-left{position:static}.scope-arrangement-setting .c-text-banner.page-banner .text-area{top:12px}.scope-arrangement-setting .top-handler-wpr{padding-top:10px;padding-bottom:10px}.scope-arrangement-setting .arrangement-list{margin-bottom:50px}.scope-arrangement-setting .arrangement-list .parse-name{width:60px;height:60px;margin-top:45px;border:2px solid #2481ff;color:#2481ff;border-radius:100%;text-align:center;line-height:60px;font-size:16px;display:inline-block;z-index:2;background:#fff;position:relative}.scope-arrangement-setting .arrangement-list .handler-btns{text-align:center}.scope-arrangement-setting .arrangement-list .arrangement-item{position:relative}.scope-arrangement-setting .arrangement-list .arrangement-item .el-form-item{margin-bottom:0}.scope-arrangement-setting .arrangement-list .arrangement-item .el-form-item__label{color:#888}.scope-arrangement-setting .arrangement-list .arrangement-item .name{color:#888;margin-right:15px;display:inline-block;width:70px;text-align:right}.scope-arrangement-setting .arrangement-list .arrangement-item .date-item input,.scope-arrangement-setting .arrangement-list .arrangement-item .way-item input{width:190px}.scope-arrangement-setting .arrangement-list .arrange-phase{text-align:center}.scope-arrangement-setting .arrangement-list .interview-one{height:50px;line-height:50px}.scope-arrangement-setting .arrangement-list .arrange-info-wpr{border:1px solid #e2e7eb;width:800px;margin:20px 0;border-radius:5px}.scope-arrangement-setting .arrangement-list .arrange-info-wpr .arrange-info{padding:25px}.scope-arrangement-setting .edit-state .arrange-info-wpr .arrange-info{padding:16px 25px}.scope-arrangement-setting .edit-state .parse-name{color:#333;border-color:#bfcbd9}.scope-arrangement-setting .edit-state .handler-btns{line-height:80px}", ""]);

// exports


/***/ }),
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/written/examTopic.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);



/* harmony default export */ var examTopic_defaultExport = ({
    data: function data() {
        return {
            resData: null,
            allScore: '-',
            totalFillText: 0,
            totalSimpleAnswer: 0,
            fillTextScore: {},
            simpleAnserScore: {},
            singleChoiceMode: '简单',
            multiChoiceMode: '简单'
        };
    },

    computed: {
        singleSelectIndex: function singleSelectIndex() {
            return 0;
        },
        multiSelectIndex: function multiSelectIndex() {
            return !!this.resData.singleChoice.length + 0;
        },
        fillBlackIndex: function fillBlackIndex() {
            return !!this.resData.multipleChoice.length + !!this.resData.singleChoice.length + 0;
        },
        simpleAnswerIndex: function simpleAnswerIndex() {
            return !!this.resData.fillTheBlank.length + !!this.resData.multipleChoice.length + !!this.resData.singleChoice.length + 0;
        },
        singleChoiceData: function singleChoiceData() {
            var _this = this;

            var result = {
                user: [],
                system: []
            };
            if (this.resData && this.resData.singleChoice) {
                var correctAnswer = this.resData.correctAnswers,
                    userAnswer = this.resData.answers;
                this.resData.singleChoice.forEach(function (item) {
                    var user = userAnswer[item.id] || [],
                        correct = correctAnswer[item.id] || [],
                        userAnsId = user.map(function (u) {
                        return +u.content;
                    }),
                        correctAnsId = correct.map(function (c) {
                        return c.id;
                    }),
                        allOptionsId = item.options.map(function (i) {
                        return i.id;
                    }),
                        userAnsIndex = allOptionsId.indexOf(userAnsId[0]),
                        correntAnsIndex = allOptionsId.indexOf(correctAnsId[0]);
                    result.user.push(userAnsIndex < 0 ? '-' : _this.num2letter(userAnsIndex + 1));
                    result.system.push(correntAnsIndex < 0 ? '-' : _this.num2letter(correntAnsIndex + 1));
                });
            }
            return result;
        },
        multipleChoiceData: function multipleChoiceData() {
            var _this2 = this;

            var result = {
                user: [],
                system: []
            };
            if (this.resData && this.resData.multipleChoice) {
                var userAnswer = this.resData.answers,
                    correctAnswer = this.resData.correctAnswers;
                this.resData.multipleChoice.forEach(function (item) {
                    var user = userAnswer[item.id] || [],
                        correct = correctAnswer[item.id] || [],
                        userAnsId = user.map(function (u) {
                        return +u.content;
                    }),
                        correctAnsId = correct.map(function (c) {
                        return c.id;
                    }),
                        allOptionsId = item.options.map(function (i) {
                        return i.id;
                    }),
                        userAnsLetter = [],
                        correctAnsLetter = [];
                    userAnsId.forEach(function (oneUserAnsId) {
                        var userAnsIndex = allOptionsId.indexOf(oneUserAnsId);
                        userAnsLetter.push(userAnsIndex < 0 ? '-' : _this2.num2letter(userAnsIndex + 1));
                    });
                    result.user.push(userAnsLetter.sort().join(''));

                    correctAnsId.forEach(function (oneCorrectAnsId) {
                        var correctAnsIndex = allOptionsId.indexOf(oneCorrectAnsId);
                        correctAnsLetter.push(correctAnsIndex < 0 ? '-' : _this2.num2letter(correctAnsIndex + 1));
                    });
                    result.system.push(correctAnsLetter.sort().join(''));
                });
            }
            return result;
        }
    },
    methods: {
        num2letter: function num2letter(num) {
            var letter = num <= 26 ? String.fromCharCode(num + 64) : convert(~~((num - 1) / 26)) + convert(num % 26 || 26);
            return letter;
        },
        answerColor: function answerColor(choice, index) {
            if (choice.user[index] === choice.system[index]) {
                return 'color-primary';
            } else {
                return 'color-danger';
            }
        },
        getFillBlankAndAns: function getFillBlankAndAns(item) {
            var conunter = 0,
                userAns = this.resData.answers[item.id] || [],
                resultContent = item.content.replace(/\[!--fill_the_blank--\]/ig, function () {
                if (conunter < userAns.length) {
                    var userContent = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.escape(userAns[conunter++].content);
                    return '<span class="exam-topic-blank">' + userContent + '</span>';
                } else {
                    return '<span class="exam-topic-blank"></span>';
                }
            });
            return resultContent;
        },
        num2Chinese: function num2Chinese(index) {
            return ['一', '二', '三', '四', '五'][index];
        },
        subTitle: function subTitle(type) {
            return this.resData.titles[type].titleSub;
        }
    },
    created: function created() {
        var _this3 = this;

        var rpId = this.$route.query.resumePositionId;
        var url = '/arrangeExam/previewPaperAndAns.api';
        var params = rpId ? {
            paperId: this.$route.params.id,
            resumePositionId: rpId,
            examId: this.$route.query.examId
        } : {
            paperId: this.$route.params.id
        };
        this.$axios.post(url, params).then(function (res) {
            _this3.resData = res.result.paper;
            _this3.resData.fillTheBlank.forEach(function (item) {
                _this3.fillTextScore[item.id] = _this3.resData.answers[item.id] ? _this3.resData.answers[item.id][0].score : 0;
                _this3.totalFillText += _this3.fillTextScore[item.id];
            });
            __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.keys(_this3.resData.questionAnswer).length && _this3.resData.questionAnswer.forEach(function (item) {
                _this3.simpleAnserScore[item.id] = _this3.resData.answers[item.id] ? _this3.resData.answers[item.id][0].score : 0;
            });
            _this3.allScore = parseInt(0 + _this3.resData.allScore);
        });
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1034e462"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/written/examTopic.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scope-exam-topic main-container"
  }, [(_vm.resData) ? _c('div', {
    staticClass: "box-shadow-small border-radius container"
  }, [_c('div', {
    staticClass: "exam-topic-header"
  }, [_c('h1', [_vm._v(_vm._s(_vm.resData.paperName))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.resData.examDuration))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.resData.examSummary) + "。")])]), _vm._v(" "), _c('div', {
    staticClass: "exam-topic-body"
  }, [(_vm.resData.singleChoice.length) ? _c('div', {
    staticClass: "box-shadow-small background-white border-radius exam-topic-item"
  }, [_c('h3', [_vm._v(_vm._s(_vm.num2Chinese(_vm.singleSelectIndex)) + "、" + _vm._s(_vm.resData.titles[_vm.singleSelectIndex].title))]), _vm._v(" "), _c('p', [(_vm.subTitle(_vm.singleSelectIndex)) ? _c('span', [_vm._v("(" + _vm._s(_vm.subTitle(_vm.singleSelectIndex)) + " )")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, _vm._l((_vm.resData.singleChoice), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "mt-20"
    }, [_c('h4', [_vm._v(_vm._s(index + 1) + ". "), _c('span', {
      staticClass: "ques-txt",
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v("（"), _c('span', {
      key: index,
      class: _vm.answerColor(_vm.singleChoiceData, index)
    }, [_vm._v(_vm._s(_vm.singleChoiceData.user[index]))]), _vm._v("）")])]), _vm._v(" "), _c('ul', {
      staticClass: "exam-topic-options"
    }, _vm._l((item.options), function(option, opIndex) {
      return _c('li', {
        key: opIndex
      }, [_vm._v(_vm._s(_vm.num2letter(opIndex + 1)) + "." + _vm._s(option.content))])
    }), 0), _vm._v(" "), _c('p', {
      staticClass: "system-answer"
    }, [_vm._v("正确答案："), _c('span', [_vm._v(_vm._s(_vm.resData.correctAnswers[item.id] ? _vm.resData.correctAnswers[item.id][0].content : '-'))])]), _vm._v(" "), (item.analysis) ? _c('p', {
      staticClass: "system-answer"
    }, [_vm._v("答案分析："), _c('span', {
      domProps: {
        "innerHTML": _vm._s(item.analysis)
      }
    })]) : _vm._e()])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "score-line"
  })]) : _vm._e(), _vm._v(" "), (_vm.resData.multipleChoice.length) ? _c('div', {
    staticClass: "box-shadow-small background-white border-radius exam-topic-item"
  }, [_c('h3', [_vm._v(_vm._s(_vm.num2Chinese(_vm.multiSelectIndex)) + "、" + _vm._s(_vm.resData.titles[_vm.multiSelectIndex].title) + " ")]), _vm._v(" "), _c('p', [(_vm.subTitle(_vm.multiSelectIndex)) ? _c('span', [_vm._v("(" + _vm._s(_vm.subTitle(_vm.multiSelectIndex)) + " )")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, _vm._l((_vm.resData.multipleChoice), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "mt-20"
    }, [_c('h4', [_vm._v(_vm._s(index + 1) + "."), _c('span', {
      staticClass: "ques-txt",
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v("（"), _c('span', {
      key: index,
      class: _vm.answerColor(_vm.singleChoiceData, index)
    }, [_vm._v(_vm._s(_vm.multipleChoiceData.user[index]))]), _vm._v("）")])]), _vm._v(" "), _c('ul', {
      staticClass: "exam-topic-options"
    }, _vm._l((item.options), function(option, opIndex) {
      return _c('li', {
        key: opIndex
      }, [_vm._v(_vm._s(_vm.num2letter(opIndex + 1)) + "." + _vm._s(option.content))])
    }), 0), _vm._v(" "), _c('p', {
      staticClass: "system-answer"
    }, [_vm._v("正确答案："), _c('span', [_vm._v(_vm._s(_vm.resData.correctAnswers[item.id] ? _vm.resData.correctAnswers[item.id][0].content : '-'))])]), _vm._v(" "), (item.analysis) ? _c('p', {
      staticClass: "system-answer"
    }, [_vm._v("答案分析："), _c('span', {
      domProps: {
        "innerHTML": _vm._s(item.analysis)
      }
    })]) : _vm._e()])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "score-line"
  })]) : _vm._e(), _vm._v(" "), (_vm.resData.fillTheBlank.length) ? _c('div', {
    staticClass: "box-shadow-small background-white border-radius exam-topic-item"
  }, [_c('h3', [_vm._v(_vm._s(_vm.num2Chinese(_vm.fillBlackIndex)) + "、" + _vm._s(_vm.resData.titles[_vm.fillBlackIndex].title))]), _vm._v(" "), _c('p', [(_vm.subTitle(_vm.fillBlackIndex)) ? _c('span', [_vm._v("(" + _vm._s(_vm.subTitle(_vm.fillBlackIndex)) + " )")]) : _vm._e()]), _vm._v(" "), _c('div', _vm._l((_vm.resData.fillTheBlank), function(item, index) {
    return _c('el-row', {
      key: index
    }, [_c('el-col', {
      attrs: {
        "span": 22
      }
    }, [_c('h4', [_vm._v(_vm._s(index + 1) + ". "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.getFillBlankAndAns(item))
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "system-answer"
    }, [_vm._v("正确答案："), _vm._l((_vm.resData.correctAnswers[item.id]), function(ans, indexj) {
      return _c('span', {
        key: index + indexj
      }, [_c('span', [_vm._v(_vm._s(ans.content))]), _vm._v(" "), (indexj < _vm.resData.correctAnswers[item.id].length - 1) ? _c('span', {
        staticClass: "color-info ml-5 mr-5"
      }, [_vm._v("|")]) : _vm._e()])
    })], 2), _vm._v(" "), (item.analysis) ? _c('p', {
      staticClass: "system-answer"
    }, [_vm._v("答案分析："), _c('span', {
      domProps: {
        "innerHTML": _vm._s(item.analysis)
      }
    })]) : _vm._e()]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 2
      }
    })], 1)
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "score-line"
  })]) : _vm._e(), _vm._v(" "), (_vm.resData.questionAnswer.length) ? _c('div', {
    staticClass: "box-shadow-small background-white border-radius exam-topic-item"
  }, [_c('h3', [_vm._v(_vm._s(_vm.num2Chinese(_vm.simpleAnswerIndex)) + "、" + _vm._s(_vm.resData.titles[_vm.simpleAnswerIndex].title) + " ")]), _vm._v(" "), _c('p', [(_vm.subTitle(_vm.simpleAnswerIndex)) ? _c('span', [_vm._v("(" + _vm._s(_vm.subTitle(_vm.simpleAnswerIndex)) + " )")]) : _vm._e()]), _vm._v(" "), _c('div', _vm._l((_vm.resData.questionAnswer), function(item, index) {
    return _c('el-row', {
      key: index
    }, [_c('el-col', {
      attrs: {
        "span": 22
      }
    }, [_c('h4', [_vm._v(_vm._s(index + 1) + "."), _c('span', {
      staticClass: "ques-txt",
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })]), _vm._v(" "), _c('div', [_c('label', {
      staticClass: "exam-topic-blank-label"
    }, [_vm._v("答案：")]), _vm._v(" "), _c('div', {
      staticClass: "exam-topic-blank block answer-txt"
    }, [_vm._v(_vm._s(_vm.resData.answers[item.id] ? _vm.resData.answers[item.id][0].content : '-') + "\n                                ")])]), _vm._v(" "), _c('p', {
      staticClass: "system-answer"
    }, [_vm._v("答案分析："), _c('span', {
      domProps: {
        "innerHTML": _vm._s(item.analysis)
      }
    })])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 2
      }
    })], 1)
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "score-line"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "text-center mt-20 mb-20"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": _vm.$win.close
    }
  }, [_vm._v("关闭")])], 1)]) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var written_examTopic_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/views/written/examTopic.vue
function injectStyle (ssrContext) {
  __webpack_require__(927)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  examTopic_defaultExport,
  written_examTopic_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(928);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("a5843384", content, true);

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".scope-exam-topic .answer-txt,.scope-exam-topic .ques-txt{white-space:pre-line}.scope-exam-topic .answer-txt{padding:0 5px}.scope-exam-topic .container{padding:30px}.scope-exam-topic .exam-topic-header{text-align:center}.scope-exam-topic .exam-topic-header h1{font-size:24px}.scope-exam-topic .exam-topic-header p{margin:15px 0 20px;color:#999}.scope-exam-topic .exam-topic-header h2{font-size:18px;text-align:left}.scope-exam-topic .exam-topic-item{margin-top:30px;padding:0 30px;border-top:1px dashed #2481ff;position:relative}.scope-exam-topic .exam-topic-item>h3{position:absolute;top:-15px;left:50%;margin-left:-70px;width:140px;text-align:center;background:#fff;font-size:18px;color:#2481ff}.scope-exam-topic .exam-topic-item>p{margin:20px 0;color:#999;text-align:center}.scope-exam-topic .exam-topic-item>h4{font-weight:700;margin-bottom:10px}.scope-exam-topic .exam-topic-item .exam-topic-options>li{line-height:30px}.scope-exam-topic .exam-topic-item .exam-topic-options>li:before{content:\"\";display:inline-block;width:18px;height:18px;border-radius:50%;border:1px solid #c1cbd9;vertical-align:middle;margin-right:10px}.scope-exam-topic .exam-topic-item .exam-topic-options.multi>li:before{content:\"\";display:inline-block;width:18px;height:18px;border-radius:5px;border:1px solid #c1cbd9;vertical-align:middle;margin-right:10px}.scope-exam-topic .exam-topic-item .exam-topic-blank-label{float:left}.scope-exam-topic .exam-topic-item .exam-topic-blank-label+.exam-topic-blank{overflow:hidden}.scope-exam-topic .exam-topic-item .exam-topic-blank{display:inline-block;margin:0 5px;border-radius:5px;border:1px solid #c1cbd9;min-height:34px;line-height:34px;min-width:200px;vertical-align:middle}.scope-exam-topic .exam-topic-item .exam-topic-blank.block{display:block;min-height:100px;width:inherit}.scope-exam-topic .exam-topic-item .exam-topic-blank.block:before{margin-left:10px;margin-top:5px;display:inline-block;content:\"\";color:#999}.scope-exam-topic .exam-topic-item .exam-topic-blank.block.answer-txt:before{display:none}.scope-exam-topic .system-answer{color:#999;line-height:24px;padding:0 0 15px;white-space:pre-line;text-align:left!important}", ""]);

// exports


/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/written/writtenArrangement.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mixins_selectMapMixin__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mixins_formCommonMixin__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__multiMixin__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_tools__ = __webpack_require__(14);








var timeDot = {
    id: Date.now(),
    startTimeDot: '',
    endTimeDot: '',
    pickerOptions: {
        start: '09:00',
        step: '01:00',
        end: '22:00'
    }
};

/* harmony default export */ var writtenArrangement_defaultExport = ({
    'mixins': [__WEBPACK_IMPORTED_MODULE_1_mixins_selectMapMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2_mixins_formCommonMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__multiMixin__["a" /* default */]],
    data: function data() {
        return {
            ruleForm: {
                beginDate: new Date(),
                paperIds: [],
                title: '',
                examRules: '',
                timeDotArr: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, timeDot)]
            },
            rules: {
                paperIds: { required: true, type: 'array', message: '请选择', trigger: 'change' },
                examRules: { required: true, message: '请输入', trigger: 'blur' },
                title: { required: true, message: '请输入', trigger: 'blur' }
            },
            pickerOptions: {
                disabledDate: function disabledDate(time) {
                    return time.getTime() < Date.now() - 8.64e7;
                }
            },
            examLists: [],
            pickedTimeDotArr: [],
            durationTime: 90,
            durationArr: [1, 30],
            removeTimeBool: false
        };
    },

    methods: {
        getExamName: function getExamName(id) {
            return this.examLists.filter(function (item) {
                return item.id === id;
            })[0].name;
        },
        showPage: function showPage(id) {
            window.open(this.$router.options.base + 'written/topic/' + id + '?resumePositionId=&examId=');
        },
        addTimeDot: function addTimeDot() {
            if (this.ruleForm.timeDotArr.length === 4) {
                this.$message({
                    message: '时间段不能超过 4 个',
                    type: 'error'
                });
                return;
            }
            this.ruleForm.timeDotArr.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, timeDot));
        },
        removeTimeDot: function removeTimeDot(index) {
            this.pickedTimeDotArr.splice(index, 1);
            this.ruleForm.timeDotArr.splice(index, 1);
            this.removeTimeBool = true;
        },
        changeTimeDot: function changeTimeDot(item, index) {
            if (this.removeTimeBool === true) {
                this.removeTimeBool = false;
                return;
            }

            if (item.startTimeDot) {
                if (this.pickedTimeDotArr.indexOf(item.startTimeDot) !== -1) {
                    this.$message.error('不能选择同一个时间段');
                    item.startTimeDot = '';
                    return;
                }

                var timeArr = item.startTimeDot.split(':'),
                    hour = +timeArr[0];
                item.endTimeDot = hour + this.durationArr[0] + ':' + this.durationArr[1];
            } else {
                item.endTimeDot = '';
            }

            this.pickedTimeDotArr[index] = item.startTimeDot;
        },
        saveForm: function saveForm(boolean) {
            var _this = this;

            var date = Object(__WEBPACK_IMPORTED_MODULE_4_modules_tools__["a" /* dateFormat */])(this.ruleForm.beginDate);
            var postData = {
                ids: this.ids,
                title: this.ruleForm.title,
                examRules: this.ruleForm.examRules,
                paperIds: this.ruleForm.paperIds.join(','),
                startTimeStr: this.ruleForm.timeDotArr.map(function (item) {
                    return date + ' ' + item.startTimeDot + ':00';
                }).join(',')
            };
            this.$axios.post('/arrangeExam/saveNewArrange.api', postData, { 'X-showMessage': true }).then(function (res) {
                _this.$router.replace({ name: 'writtenList' });
            }).catch(console.error);
        },
        fetchCallback: function fetchCallback(res) {
            var duration = res.result.examDuration || 90,
                durationInt = typeof duration === 'string' ? parseInt(duration) : duration,
                min = durationInt % 60 === 0 ? '00' : durationInt % 60;
            this.durationTime = durationInt;
            this.durationArr = [parseInt(durationInt / 60), min];
        }
    },
    created: function created() {
        var _this2 = this;

        this.fetchList();
        this.$axios.get('/arrangeExam/getAllPaper.api').then(function (res) {
            _this2.examLists = res.result.list;
        }).catch(console.error);
        this.$axios.get('/arrangeExam/getExamTemplate.api').then(function (res) {
            var result = res.result.bean;
            if (result) {
                _this2.ruleForm.title = result.title;
                _this2.ruleForm.examRules = result.examRules;
            }
        }).catch(console.error);
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bb62d35e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/written/writtenArrangement.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scope-written box-shadow-small border-radius"
  }, [_c('p', {
    staticClass: "mt-10 mb-20"
  }, [_c('router-link', {
    attrs: {
      "to": "/written"
    }
  }, [_c('i', {
    staticClass: "el-icon-arrow-left"
  }), _vm._v("返回笔试列表")])], 1), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    staticClass: "mt-20",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "120px"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 100
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "考试标题",
      "prop": "title"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "medium"
    },
    model: {
      value: (_vm.ruleForm.title),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "title", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "考生须知",
      "prop": "examRules"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 4,
        maxRows: 6
      },
      "resize": "none",
      "maxlength": 1000
    },
    model: {
      value: (_vm.ruleForm.examRules),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "examRules", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.examRules"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "选择笔试题",
      "prop": "paperIds"
    }
  }, [_c('div', {
    staticClass: "pull-right"
  }, [(_vm.ruleForm.paperIds.length === 0) ? _c('el-button', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("预览试卷")]) : (_vm.ruleForm.paperIds.length === 1) ? _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.showPage(_vm.ruleForm.paperIds[0])
      }
    }
  }, [_vm._v("\n                            预览试卷\n                        ")]) : _c('el-dropdown', [_c('el-button', {
    attrs: {
      "disabled": _vm.ruleForm.paperIds.length === 0
    }
  }, [_vm._v("\n                                预览试卷"), _c('i', {
    staticClass: "el-icon-caret-bottom el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, _vm._l((_vm.ruleForm.paperIds), function(item, index) {
    return _c('el-dropdown-item', {
      key: index,
      nativeOn: {
        "click": function($event) {
          return _vm.showPage(item)
        }
      }
    }, [_vm._v(_vm._s(_vm.getExamName(+item)) + "\n                                ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "hidden",
      "padding-right": "20px"
    }
  }, [_c('el-select', {
    staticClass: "mb-20",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "size": "medium",
      "multiple": ""
    },
    model: {
      value: (_vm.ruleForm.paperIds),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "paperIds", $$v)
      },
      expression: "ruleForm.paperIds"
    }
  }, _vm._l((_vm.examLists), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.id,
        "label": item.name
      }
    })
  }), 1)], 1)])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "pick-exam-time",
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "考试日期",
      "required": ""
    }
  }, [_c('el-date-picker', {
    ref: "startDate",
    attrs: {
      "type": "date",
      "placeholder": "考试日期",
      "size": "medium",
      "editable": false,
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.ruleForm.beginDate),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "beginDate", $$v)
      },
      expression: "ruleForm.beginDate"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ml-10 color-gray"
  }, [_vm._v("考试时长 "), _c('strong', [_vm._v(_vm._s(_vm.durationTime))]), _vm._v(" 分钟，可安排多个时段，考生需提前选择一个时段")])], 1), _vm._v(" "), _vm._l((_vm.ruleForm.timeDotArr), function(item, index) {
    return [_c('el-form-item', {
      staticClass: "time-dot",
      attrs: {
        "prop": 'timeDotArr.' + index + '.startTimeDot',
        "rules": {
          required: true,
          message: '开始时间点不能为空',
          trigger: 'blur'
        },
        "label": ("时间段 " + (index + 1))
      }
    }, [_c('el-time-select', {
      attrs: {
        "size": "medium",
        "picker-options": item.pickerOptions,
        "editable": false,
        "clearable": false,
        "placeholder": "选择开始时间点"
      },
      on: {
        "change": function($event) {
          return _vm.changeTimeDot(item, index)
        }
      },
      model: {
        value: (item.startTimeDot),
        callback: function($$v) {
          _vm.$set(item, "startTimeDot", $$v)
        },
        expression: "item.startTimeDot"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "ml-10"
    }, [_c('span', {
      staticClass: "color-gray mr-5"
    }, [_vm._v("——")]), _vm._v(" 结束时间：\n                            "), _c('span', {
      staticClass: "end-time-holder"
    }, [_vm._v(_vm._s(item.endTimeDot))]), _vm._v(" "), (index === 0) ? _c('el-button', {
      attrs: {
        "icon": "el-icon-my-xinjian",
        "type": "text"
      },
      on: {
        "click": _vm.addTimeDot
      }
    }) : _c('el-button', {
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          return _vm.removeTimeDot(index)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-my-shanchu color-danger"
    })])], 1)], 1)]
  })], 2)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-list mt-20"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.lists
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "候选人",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                    " + _vm._s(scope.row.name) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "手机号",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                    " + _vm._s(scope.row.phone) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "职位",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                    " + _vm._s(scope.row.positionName) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "简历来源",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                    " + _vm._s(_vm.getSelectMapText('WB_RESUME_SOURCE', scope.row.resumeSource) || '-') + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.removeItem(scope.row.id)
            }
          }
        }, [_vm._v("移除")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center mt-20 mb-10"
  }, [_c('el-button', {
    on: {
      "click": _vm.cancelAndBack
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.idsLength === 0
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("确认安排")])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var written_writtenArrangement_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/views/written/writtenArrangement.vue
function injectStyle (ssrContext) {
  __webpack_require__(930)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  writtenArrangement_defaultExport,
  written_writtenArrangement_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(931);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("0e6d7d43", content, true);

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".scope-written{margin:30px;padding:10px 30px}.scope-written .pick-exam-time .color-gray,.scope-written .pick-exam-time .time-dot .el-form-item__label{color:#999}.scope-written .pick-exam-time .end-time-holder{display:inline-block;width:50px}", ""]);

// exports


/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/written/writtenArrangementDetail.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_tools__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mixins_selectMapMixin__ = __webpack_require__(4);





/* harmony default export */ var writtenArrangementDetail_defaultExport = ({
    'mixins': [__WEBPACK_IMPORTED_MODULE_1_mixins_selectMapMixin__["a" /* default */]],
    data: function data() {
        return {
            resData: null
        };
    },

    methods: {
        backToExanmList: function backToExanmList() {
            if (window.history.length <= 1) {
                this.$router.push({ path: '/wb/written/exam/list' });
                return false;
            } else {
                this.$router.back(-1);
            }
        }
    },
    created: function created() {
        var _this = this;

        this.$axios.get('/exam/getDetailById.api?id=' + this.$route.params.id).then(function (res) {
            _this.resData = res.result;
        }).catch(console.error);
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76de8b82"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/written/writtenArrangementDetail.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.resData) ? _c('div', {
    staticClass: "scope-written box-shadow-small border-radius"
  }, [_c('p', {
    staticClass: "mt-10 mb-20"
  }, [_c('router-link', {
    attrs: {
      "to": "/written"
    }
  }, [_vm._v("笔试")]), _vm._v("\n        >\n        "), _c('router-link', {
    attrs: {
      "to": "/written/exam/list"
    }
  }, [_vm._v("笔试安排列表")]), _vm._v("\n        >\n        "), _c('span', [_vm._v("笔试安排详情")])], 1), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    staticClass: "mt-20",
    attrs: {
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "考试标题",
      "prop": "title"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.resData.exam.title) + "\n        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "考生须知",
      "prop": "examRules"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.resData.exam.examRules) + "\n        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "选择笔试题",
      "prop": "paperIds"
    }
  }, _vm._l((_vm.resData.exam.paperList), function(item, index) {
    return _c('p', {
      key: index
    }, [_c('router-link', {
      attrs: {
        "target": "_blank",
        "to": ("/written/topic/" + (item.id) + "?resumePositionId=&examId=")
      }
    }, [_vm._v(_vm._s(item.name))])], 1)
  }), 0), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "考试日期"
    }
  }, _vm._l((_vm.resData.exam.examTimes), function(item, index) {
    return _c('p', {
      key: index
    }, [_vm._v(_vm._s(item.startTime) + "-" + _vm._s(item.endTime))])
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-list mt-20"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.resData.list
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "候选人",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                    " + _vm._s(scope.row.name) + "\n                ")]
      }
    }], null, false, 4089127706)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "手机号",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                    " + _vm._s(scope.row.phone) + "\n                ")]
      }
    }], null, false, 304553441)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "职位",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                    " + _vm._s(scope.row.positionName) + "\n                ")]
      }
    }], null, false, 3608179427)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "简历来源",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                    " + _vm._s(_vm.getSelectMapText('WB_RESUME_SOURCE', scope.row.resumeSource) || '-') + "\n                ")]
      }
    }], null, false, 2124748343)
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center mt-20 mb-20"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": _vm.backToExanmList
    }
  }, [_vm._v("关闭")])], 1)], 1) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var written_writtenArrangementDetail_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/views/written/writtenArrangementDetail.vue
function injectStyle (ssrContext) {
  __webpack_require__(933)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  writtenArrangementDetail_defaultExport,
  written_writtenArrangementDetail_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(934);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("2095d929", content, true);

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".scope-written{margin:30px;padding:10px 30px}.scope-written .pick-exam-time .color-gray,.scope-written .pick-exam-time .time-dot .el-form-item__label{color:#999}.scope-written .pick-exam-time .end-time-holder{display:inline-block;width:50px}", ""]);

// exports


/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/written/writtenArrangementList.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_queryListExtend__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mixins_selectMapMixin__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__operation_operationMixin__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__operation_queryListMixin__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_statusIcon__ = __webpack_require__(360);








/* harmony default export */ var writtenArrangementList_defaultExport = ({
    components: { StatusIcon: __WEBPACK_IMPORTED_MODULE_4_components_statusIcon__["a" /* default */] },
    'extends': __WEBPACK_IMPORTED_MODULE_0_components_queryListExtend__["a" /* default */],
    'mixins': [__WEBPACK_IMPORTED_MODULE_1_mixins_selectMapMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__operation_operationMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__operation_queryListMixin__["a" /* default */]],
    data: function data() {
        return {
            fetchUrl: '/exam/list.api',
            timeForm: {
                arrangeTime: this.$route.query.arrangeTime ? new Date(this.$route.query.arrangeTime) : '',
                startTime: this.$route.query.startTime ? new Date(this.$route.query.startTime) : ''
            },
            searchData: {
                searchWord: null,
                arrangeTime: '',
                startTime: ''
            }
        };
    },

    methods: {
        multiProcess: function multiProcess(routeName) {
            if (!this.checkDataValid(this.idStr)) {
                return false;
            }
            this.$router.push({ name: routeName, params: { ids: this.idStr } });
        },
        changeArrangeTime: function changeArrangeTime(value) {
            console.log(123, value);
            this.searchData.arrangeTime = value;
        },
        changeStartTime: function changeStartTime(value) {
            console.log(123, value);
            this.searchData.startTime = value;
        },
        tableColumnFormatter: function tableColumnFormatter(row, column, value) {
            return value || '-';
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e888b0e2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/written/writtenArrangementList.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.firstRendered) ? _c('div', [_c('div', {
    staticClass: "filter-condition box-shadow-small border-radius"
  }, [_c('p', {
    staticClass: "mt-10 mb-20"
  }, [_c('router-link', {
    attrs: {
      "to": "/written"
    }
  }, [_vm._v("笔试")]), _vm._v("\n            >\n            "), _c('span', [_vm._v("笔试安排列表")])], 1), _vm._v(" "), _c('div', {
    staticClass: "search-box"
  }, [_c('el-button', {
    staticClass: "search-hd",
    attrs: {
      "type": "primary",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        return _vm.searchKeyword(_vm.keyword)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "search-bd"
  }, [_c('search-bar', {
    attrs: {
      "ajaxSearch": false,
      "placeholder": "请输入考试标题进行搜索"
    },
    on: {
      "enter-key": _vm.searchKeyword,
      "select": _vm.searchKeyword
    },
    model: {
      value: (_vm.keyword),
      callback: function($$v) {
        _vm.keyword = $$v
      },
      expression: "keyword"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "filter-panel"
  }, [_c('dl', [_c('dt', [_vm._v("笔试安排时间：")]), _vm._v(" "), _c('dd', [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "请选择时间",
      "editable": false,
      "format": "yyyy-MM-dd"
    },
    on: {
      "change": _vm.changeArrangeTime
    },
    model: {
      value: (_vm.timeForm.arrangeTime),
      callback: function($$v) {
        _vm.$set(_vm.timeForm, "arrangeTime", $$v)
      },
      expression: "timeForm.arrangeTime"
    }
  })], 1)]), _vm._v(" "), _c('dl', [_c('dt', [_vm._v("笔试开始时间：")]), _vm._v(" "), _c('dd', [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "请选择时间",
      "editable": false,
      "format": "yyyy-MM-dd"
    },
    on: {
      "change": _vm.changeStartTime
    },
    model: {
      value: (_vm.timeForm.startTime),
      callback: function($$v) {
        _vm.$set(_vm.timeForm, "startTime", $$v)
      },
      expression: "timeForm.startTime"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "filter-result background-white box-shadow-small border-radius"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.partialLoading),
      expression: "partialLoading"
    }]
  }, [_c('empty-tip', {
    attrs: {
      "show": !_vm.lists.length
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "table-list mt-20"
  }, [(_vm.lists.length) ? _c('el-table', {
    attrs: {
      "data": _vm.lists
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "考试标题",
      "show-overflow-tooltip": true,
      "align": "center",
      "prop": "title",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "examRules",
      "label": "考生须知",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "考试时间",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.examTimes), function(item, index) {
          return _c('p', {
            key: index
          }, [_vm._v(_vm._s(item.startTime) + "-" + _vm._s(item.endTime.slice(10)))])
        })
      }
    }], null, false, 117963444)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "笔试题试卷",
      "show-overflow-tooltip": true,
      "align": "center",
      "formatter": _vm.tableColumnFormatter,
      "min-width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.paperList), function(item, index) {
          return _c('p', {
            key: index
          }, [_vm._v(_vm._s(item.name))])
        })
      }
    }], null, false, 3913104794)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "class-name": "no-wrap",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('router-link', {
          attrs: {
            "to": ("/written/exam/detail/" + (scope.row.id))
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          }
        }, [_vm._v("查看详情")])], 1), _vm._v(" "), (false) ? _c('router-link', {
          staticClass: "ml-10",
          attrs: {
            "to": ("/written/recommend/" + (scope.row.id))
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          }
        }, [_vm._v("修改")])], 1) : _vm._e()]
      }
    }], null, false, 3977193534)
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.lists.length) ? _c('el-pagination', {
    staticClass: "text-center mt-20 mb-20",
    attrs: {
      "current-page": _vm.pagination.pageIndex,
      "page-size": _vm.pagination.pageSize,
      "page-sizes": [20, 50, 100, 200],
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.pagination.recordCounts
    },
    on: {
      "size-change": _vm.pageSizeChange,
      "current-change": _vm.pageIndexChange
    }
  }) : _vm._e()], 1)])]) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var written_writtenArrangementList_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/views/written/writtenArrangementList.vue
function injectStyle (ssrContext) {
  __webpack_require__(936)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  writtenArrangementList_defaultExport,
  written_writtenArrangementList_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(937);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("05a17f52", content, true);

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".dark-theme{background:#1f2d3d;color:#fff;border-radius:5px}.dark-theme[x-placement^=top] .popper__arrow:after{border-top-color:#1f2d3d}.popper-line .el-row{word-break:break-all;padding:3px 0}.popper-line .el-row:not(:first-child){border-top:1px solid #415062;margin-top:1px}", ""]);

// exports


/***/ }),
/* 938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/written/writtenRecommend.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__multiMixin__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_userSelect_searchDownList__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mixins_formCommonMixin__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_underscore__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_underscore__);








/* harmony default export */ var writtenRecommend_defaultExport = ({
    components: { SearchDownList: __WEBPACK_IMPORTED_MODULE_2_components_userSelect_searchDownList__["a" /* default */] },
    'mixins': [__WEBPACK_IMPORTED_MODULE_1__multiMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3_mixins_formCommonMixin__["a" /* default */]],
    data: function data() {
        return {
            ccUsers: [],
            selectedRow: [],
            watchRoute: false,
            topObj: {
                masterInterviewer: ''
            }
        };
    },

    computed: {
        dynamicForm: function dynamicForm() {
            return {
                lists: this.lists
            };
        },
        postData: function postData() {
            var data = this.lists.map(function (item) {
                return __WEBPACK_IMPORTED_MODULE_4_underscore___default.a.pick(item, ['name', 'id', 'markIds']);
            });
            return data;
        }
    },
    methods: {
        selectionChange: function selectionChange(selections) {
            this.selectedRow = selections;
        },
        saveForm: function saveForm(boolean) {
            var _this = this;

            var data = [];
            var emptyCounter = 0;
            this.postData.forEach(function (item) {
                if (item.markIds) {
                    data.push(item);
                } else {
                    emptyCounter++;
                }
            });
            if (emptyCounter === this.lists.length) {
                this.$message({
                    type: 'warning',
                    message: '评估人不能为空'
                });
            } else if (emptyCounter > 0) {
                this.$confirm('\u6709' + emptyCounter + '\u6761\u6570\u636E\u7684\u8BC4\u4F30\u4EBA\u4E3A\u7A7A, \u662F\u5426\u7EE7\u7EED?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    _this.update(data);
                });
            } else {
                this.update(data);
            }
        },
        update: function update(data) {
            var _this2 = this;

            this.$axios.post('/arrangeExam/saveNewRecommend.api', { jsonArrStr: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data) }, { 'X-showMessage': true }).then(function (res) {
                _this2.$router.replace({ name: 'writtenList' });
            }).catch(console.error);
        },
        removeRow: function removeRow(id, index) {
            var _this3 = this;

            var caches = [];
            this.lists.forEach(function (item) {
                caches[item.id] = _this3.$refs['userSelects-' + item.id].getSelected();
            });
            var ids = this.lists.map(function (item) {
                return item.id;
            });
            var curIndex = ids.indexOf(id);
            this.lists.splice(curIndex, 1);
            ids = this.lists.map(function (item) {
                return item.id;
            });
            this.$nextTick(function () {
                _this3.lists.forEach(function (item) {
                    var list = caches[item.id],
                        idStr = list.map(function (item) {
                        return item.id;
                    });
                    _this3.$refs['userSelects-' + item.id].setDefaultValue(list, idStr);
                });
            });
            this.$router.replace({
                name: this.$route.name,
                params: { ids: ids.length ? ids.join(',') : -1 }
            });
        },
        setBetchCol: function setBetchCol(attr) {
            var _this4 = this;

            var val = this.topObj[attr],
                names = '';
            if (attr === 'masterInterviewer') {
                var list = this.$refs.topInterviewer.getSelected();
                val = list.map(function (item) {
                    return item.id;
                }).join(',');
                names = list.map(function (item) {
                    return item.name;
                }).join('，');
            }
            if (val === '') {
                this.$message({
                    message: '数据不能为空',
                    type: 'warning'
                });
            } else {
                if (this.selectedRow.length === 0) {
                    this.$message({
                        message: '请勾选候选人',
                        type: 'warning'
                    });
                } else {
                    var allIds = this.dynamicForm.lists.map(function (item) {
                        return item.id;
                    });
                    this.selectedRow.forEach(function (item) {
                        if (attr === 'masterInterviewer') {
                            _this4.$refs['userSelects-' + item.id].setDefaultValueLater(val, names);
                        }
                    });
                    console.log(this.$refs);
                }
            }
        }
    },
    created: function created() {
        this.fetchList('/arrangeExam/newRecommend.api');
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1df79ac3"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/written/writtenRecommend.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scope-written"
  }, [_c('div', {
    staticClass: "box-shadow-small border-radius"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('p', {
    staticClass: "mt-10"
  }, [_c('router-link', {
    attrs: {
      "to": "/written"
    }
  }, [_c('i', {
    staticClass: "el-icon-arrow-left"
  }), _vm._v("返回笔试列表")])], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    staticClass: "pull-right hide",
    attrs: {
      "type": "warning",
      "plain": true,
      "icon": "el-icon-my-youjian color-warning"
    }
  }, [_vm._v("\n                    通知面试官\n                ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-list mt-20"
  }, [_c('el-row', {
    staticClass: "text-center multi-setting"
  }, [_c('el-col', {
    attrs: {
      "span": 8,
      "offset": 15
    }
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v("评估人")]), _vm._v(" "), _c('div', [_c('search-down-list', {
    ref: "topInterviewer",
    staticStyle: {
      "width": "60%",
      "display": "inline-block"
    },
    attrs: {
      "holder": "评估人"
    },
    model: {
      value: (_vm.topObj.masterInterviewer),
      callback: function($$v) {
        _vm.$set(_vm.topObj, "masterInterviewer", $$v)
      },
      expression: "topObj.masterInterviewer"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "betch-btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.setBetchCol('masterInterviewer')
      }
    }
  })], 1)])], 1), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm mt-20",
    attrs: {
      "model": _vm.dynamicForm
    }
  }, [_c('el-table', {
    ref: "recommendTable",
    attrs: {
      "data": _vm.dynamicForm.lists
    },
    on: {
      "selection-change": _vm.selectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "type": "selection",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "候选人",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.name) + "\n                        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "手机号",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.phone) + "\n                        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "职位",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.positionName) + "\n                        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "笔试答卷",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.examName || '-') + "\n                        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "评估人",
      "align": "center",
      "min-width": "220"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-form-item', {
          staticStyle: {
            "margin-top": "5px"
          }
        }, [_c('search-down-list', {
          ref: ("userSelects-" + (scope.row.id)),
          attrs: {
            "cacheOptions": scope.row.markList
          },
          model: {
            value: (scope.row.markIds),
            callback: function($$v) {
              _vm.$set(scope.row, "markIds", $$v)
            },
            expression: "scope.row.markIds"
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.removeRow(scope.row.id, scope.$index)
            }
          }
        }, [_vm._v("移除")])]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center mt-20 mb-10"
  }, [_c('el-button', {
    on: {
      "click": _vm.cancelAndBack
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.idsLength === 0
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("保存")])], 1)], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var written_writtenRecommend_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/views/written/writtenRecommend.vue
function injectStyle (ssrContext) {
  __webpack_require__(939)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  writtenRecommend_defaultExport,
  written_writtenRecommend_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(940);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("500e2db0", content, true);

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".scope-written .multi-setting{border-top:1px solid #ddd;margin-top:15px}.scope-written .multi-setting .label{font-weight:700;margin:5px}.scope-written .multi-setting .betch-btn{background:url(" + __webpack_require__(358) + ") no-repeat 50%;width:40px;height:36px;display:inline-block;vertical-align:bottom}", ""]);

// exports


/***/ }),
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/position/positionList.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_queryListExtend__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__positionMixin__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_tools__ = __webpack_require__(14);






/* harmony default export */ var positionList_defaultExport = ({
    'extends': __WEBPACK_IMPORTED_MODULE_0_components_queryListExtend__["a" /* default */],
    'mixins': [__WEBPACK_IMPORTED_MODULE_1__positionMixin__["a" /* default */]],
    data: function data() {
        return {
            fetchUrl: '/position/list.api',
            removeUrl: '/position/delete.api',
            filterConf: [{
                name: 'cityIds',
                label: '工作地点',
                mode: 'single',
                filter: 'WB_POSITION_CITY',
                data: []
            }, {
                name: 'state',
                label: '职位状态',
                mode: 'single',
                filter: 'WB_POSITION_STATE',
                data: []
            }, {
                filter: 'WB_POSITION_SEQUENCE_JSON',
                label: '岗位序列',
                mode: 'single',
                name: 'sequenceMainSearch',
                data: []
            }, {
                name: 'sequenceSubSearch',
                label: '岗位子序列',
                visible: false,
                data: []
            }],
            searchData: {
                searchWord: null
            },
            switchValue: ''
        };
    },

    methods: {
        dateFormat: function dateFormat(date, format) {
            return Object(__WEBPACK_IMPORTED_MODULE_2_modules_tools__["a" /* dateFormat */])(date, format);
        },
        fetchCallback: function fetchCallback(res) {
            this.updateChildrenFilter(res);
        },
        updateChildrenFilter: function updateChildrenFilter(res) {
            var _this = this;

            if (this.searchData.sequenceMainSearch && this.searchData.sequenceMainSearch.length) {
                var children = [];
                res.result.WB_POSITION_SEQUENCE_JSON.every(function (item) {
                    if (item.value === _this.searchData.sequenceMainSearch) {
                        children = item.list;
                        return false;
                    }
                    return true;
                });
                if (children.length) {
                    this.filterConf[3].visible = true;
                    if (this.lastPositionType !== this.searchData.sequenceSubSearch) {
                        this.filterConf[3].value = '';
                    }
                    this.filterConf[3].value = this.searchData.sequenceSubSearch;
                    this.filterConf[3].data = children;
                } else {
                    this.filterConf[3].visible = false;
                }
            } else {
                this.filterConf[3].visible = false;
            }
        },
        toggleState: function toggleState(ids, state) {
            var _this2 = this;

            if (ids) {
                var target = event.target;
                if (target.nodeName === 'SPAN' || target.nodeName === 'I') {
                    target = event.target.parentNode;
                }
                target.blur();
                this.$confirm('您确定要更改状态?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    _this2.$axios.post('/position/updateState.api', {
                        ids: ids,
                        state: state
                    }, {
                        'X-showMessage': true
                    }).then(function (res) {
                        _this2.fetchData();
                    });
                }).catch(function () {});
            } else {
                this.$message({
                    message: '请先勾选数据',
                    type: 'warning'
                });
            }
        },
        switchChange: function switchChange(value) {
            this.$axios.post('/position/setUnionEvaluationSwitchStatus.api', {
                status: value
            }, {
                'X-showMessage': true
            }).then(function (res) {}).catch(console.log);
        },
        handleParmasChange: function handleParmasChange(name) {
            var _this3 = this;

            this.getParams(function (params) {
                if (name === 'sequenceMainSearch') {
                    params.sequenceSubSearch = '';
                    var comp = _this3.$refs.condition.$children.find(function (c) {
                        return c.name === 'sequenceSubSearch';
                    });
                    comp && comp.checkedAll();
                }
            });
        }
    },
    created: function created() {
        var _this4 = this;

        this.$axios.get('/position/getUnionEvaluationSwitchStatus.api').then(function (_ref) {
            var result = _ref.result;

            _this4.switchValue = result.status;
        });
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e1c2817"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/position/positionList.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.firstRendered) ? _c('div', [_c('div', {
    staticClass: "filter-condition box-shadow-small border-radius"
  }, [_c('div', {
    staticClass: "search-box"
  }, [_c('el-button', {
    staticClass: "search-hd",
    attrs: {
      "type": "primary",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        return _vm.searchKeyword(_vm.keyword)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "search-bd"
  }, [_c('search-bar', {
    attrs: {
      "ajaxSearch": false,
      "placeholder": "请输入职位名称、职位编号、招聘HR进行搜索"
    },
    on: {
      "enter-key": _vm.searchKeyword,
      "select": _vm.searchKeyword
    },
    model: {
      value: (_vm.keyword),
      callback: function($$v) {
        _vm.keyword = $$v
      },
      expression: "keyword"
    }
  })], 1)], 1), _vm._v(" "), _c('filter-panel', {
    ref: "condition",
    on: {
      "params-change": _vm.handleParmasChange
    }
  }, _vm._l((_vm.filterConf), function(item, index) {
    return _c('filter-panel-item', {
      key: index,
      ref: item.name,
      refInFor: true,
      attrs: {
        "label": item.label,
        "mode": item.mode,
        "visible": item.visible,
        "name": item.name,
        "data": item.data,
        "initValue": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "filter-result background-white box-shadow-small border-radius"
  }, [_c('div', {
    staticClass: "filter-result-header mt-15 clearfix"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-button', {
    attrs: {
      "icon": "el-icon-plus",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.addPositionDialog.show()
      }
    }
  }, [_vm._v("新建职位")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [(_vm.lists.length) ? _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "end"
    }
  }, [_c('p', {
    staticClass: "mr-25"
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": "",
      "on-value": 1,
      "off-value": 0
    },
    on: {
      "change": _vm.switchChange
    },
    model: {
      value: (_vm.switchValue),
      callback: function($$v) {
        _vm.switchValue = $$v
      },
      expression: "switchValue"
    }
  }), _vm._v("\n                            多人面试无须全部评价\n                            "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "开启后，多人面试中，若有其中一个面试官已提交评价，则其他面试官无须再评价",
      "placement": "top"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text",
      "icon": "el-icon-information"
    }
  })], 1)], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-daiding color-warning",
      "type": "warning",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.toggleState(_vm.idStr, '0')
      }
    }
  }, [_vm._v("草稿\n                        ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-queding color-success",
      "type": "success",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.toggleState(_vm.idStr, '2')
      }
    }
  }, [_vm._v("暂停\n                        ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-daiding color-warning",
      "type": "warning",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.toggleState(_vm.idStr, '3')
      }
    }
  }, [_vm._v("待审核\n                        ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-guanbi color-danger",
      "type": "danger",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.remove(_vm.idStr)
      }
    }
  }, [_vm._v("删除\n                        ")])], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.partialLoading),
      expression: "partialLoading"
    }]
  }, [_c('empty-tip', {
    attrs: {
      "show": !_vm.lists.length
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "table-list mt-20"
  }, [(_vm.lists.length) ? _c('el-table', {
    attrs: {
      "data": _vm.lists
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "职位编号",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.code) + "\n                        ")]
      }
    }], null, false, 4143751376)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "职位名称",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticStyle: {
            "color": "#20A0FF"
          },
          attrs: {
            "href": "javascript:;"
          },
          on: {
            "click": function($event) {
              return _vm.$refs.preview.show(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }], null, false, 722025121)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "工作地点",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.cityNames) + "\n                        ")]
      }
    }], null, false, 2814164654)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "招聘人数",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.recruitCount) + "\n                        ")]
      }
    }], null, false, 1649549808)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "招聘范围",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.getSelectMapText('WB_PROPERTY_TYPE', scope.row.property)) + "\n                        ")]
      }
    }], null, false, 3894185378)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "门户展示",
      "show-overflow-tooltip": true,
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.showInDesk == 1 ? '是' : '否') + "\n                        ")]
      }
    }], null, false, 3889521821)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "内推职位",
      "show-overflow-tooltip": true,
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.getSelectMapText('WB_YES_OR_NO', scope.row.recommendable)) + "\n                        ")]
      }
    }], null, false, 403392328)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "开始时间",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.dateFormat(scope.row.onlineDate)) + "\n                        ")]
      }
    }], null, false, 2541078416)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "暂停时间",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.dateFormat(scope.row.offlineDate)) + "\n                        ")]
      }
    }], null, false, 3818310398)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "招聘部门",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.deptNames) + "\n                        ")]
      }
    }], null, false, 3474352204)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "审核时间",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.dateFormat(scope.row.apploveTime) || '-') + "\n                        ")]
      }
    }], null, false, 4148793826)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "招聘HR",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.mark) + "\n                        ")]
      }
    }], null, false, 4193532616)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作人",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.followUpName) + "\n                        ")]
      }
    }], null, false, 4288148430)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.getSelectMapText('WB_POSITION_STATE', scope.row.state)) + "\n                        ")]
      }
    }], null, false, 2223185923)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "class-name": "no-wrap",
      "min-width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.$refs.addPositionDialog.show(scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.remove(scope.row.id)
            }
          }
        }, [_c('span', {
          staticClass: "color-danger"
        }, [_vm._v("删除")])]), _vm._v(" "), _c('el-dropdown', {
          staticClass: "ml-10",
          attrs: {
            "hide-on-click": false
          }
        }, [_c('span', {
          staticClass: "el-dropdown-link"
        }, [_vm._v("更多")]), _vm._v(" "), _c('el-dropdown-menu', {
          attrs: {
            "slot": "dropdown"
          },
          slot: "dropdown"
        }, [_c('el-dropdown-item', {
          nativeOn: {
            "click": function($event) {
              return _vm.toggleState(scope.row.id, 0)
            }
          }
        }, [_c('i', {
          staticClass: "mr-10 el-icon-my-caogao color-success"
        }), _vm._v("草稿\n                                    ")]), _vm._v(" "), _c('el-dropdown-item', {
          nativeOn: {
            "click": function($event) {
              return _vm.toggleState(scope.row.id, 2)
            }
          }
        }, [_c('i', {
          staticClass: "mr-10 el-icon-my-zanting color-warning"
        }), _vm._v("暂停\n                                    ")]), _vm._v(" "), _c('el-dropdown-item', {
          nativeOn: {
            "click": function($event) {
              return _vm.toggleState(scope.row.id, 3)
            }
          }
        }, [_c('i', {
          staticClass: "mr-10 el-icon-my-daiding color-warning"
        }), _vm._v("待审核\n                                    ")])], 1)], 1)]
      }
    }], null, false, 4239388332)
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.lists.length) ? _c('el-pagination', {
    staticClass: "text-center mt-20 mb-20",
    attrs: {
      "current-page": _vm.pagination.pageIndex,
      "page-size": _vm.pagination.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.pagination.recordCounts
    },
    on: {
      "size-change": _vm.pageSizeChange,
      "current-change": _vm.pageIndexChange
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('Add-Position-Dialog', {
    ref: "addPositionDialog",
    on: {
      "reload": _vm.fetchData
    }
  }), _vm._v(" "), _c('preview-position', {
    ref: "preview"
  })], 1) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var position_positionList_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/views/position/positionList.vue
function injectStyle (ssrContext) {
  __webpack_require__(942)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  positionList_defaultExport,
  position_positionList_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(943);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("d47f2c90", content, true);

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(945);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("90555548", content, true);

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".form-col .col-2>.el-form-item{width:49%;float:none;display:inline-block}", ""]);

// exports


/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(947);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("8ca2af0a", content, true);

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".supplier-checkbox{color:#8492a6;font-size:12px;padding-left:8px}.supplier-select-popover.el-select-dropdown.is-multiple .el-select-dropdown__item.is-disabled{color:#bfc7d9;background-color:#fff}", ""]);

// exports


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(949);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("4866c753", content, true);

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".preview-inlineForm .el-form-item__label{color:#9e9e9e}.preview-inlineForm .el-form-item{width:300px;margin:4px 0}.preview-inlineForm .el-form-item__content{width:180px!important}.preview-dialog pre{margin:0;white-space:pre-line}.preview-dialog .el-form-item__label{color:#9e9e9e}.preview-dialog .el-form-item{margin:4px 0}", ""]);

// exports


/***/ }),
/* 950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/position/reviewList.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_queryListExtend__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__positionMixin__ = __webpack_require__(234);





/* harmony default export */ var reviewList_defaultExport = ({
    'extends': __WEBPACK_IMPORTED_MODULE_0_components_queryListExtend__["a" /* default */],
    'mixins': [__WEBPACK_IMPORTED_MODULE_1__positionMixin__["a" /* default */]],
    data: function data() {
        return {
            fetchUrl: '/positionApproval/list.api',
            filterConf: [{
                filter: 'WB_POSITION_SEQUENCE_JSON',
                label: '岗位序列',
                mode: 'single',
                name: 'sequenceMainSearch',
                data: []
            }, {
                name: 'sequenceSubSearch',
                label: '岗位子序列',
                visible: false,
                data: []
            }, {
                name: 'cityIds',
                label: '工作地点',
                filter: 'WB_POSITION_CITY',
                data: []
            }],
            searchData: {
                searchWord: null
            }
        };
    },

    methods: {
        addResume: function addResume() {
            this.$refs.addResumeDialog.show();
        },
        fetchCallback: function fetchCallback(res) {
            this.updateChildrenFilter(res);
        },
        updateChildrenFilter: function updateChildrenFilter(res) {
            var _this = this;

            if (this.searchData.sequenceMainSearch && this.searchData.sequenceMainSearch.length) {
                var children = [];
                res.result.WB_POSITION_SEQUENCE_JSON.every(function (item) {
                    if (item.value === _this.searchData.sequenceMainSearch) {
                        children = item.list;
                        return false;
                    }
                    return true;
                });
                if (children.length) {
                    this.filterConf[1].visible = true;
                    if (this.lastPositionType !== this.searchData.sequenceSubSearch) {
                        this.filterConf[1].value = '';
                    }
                    this.filterConf[1].value = this.searchData.sequenceSubSearch;
                    this.filterConf[1].data = children;
                } else {
                    this.filterConf[1].visible = false;
                }
            } else {
                this.filterConf[1].visible = false;
            }
        },
        toggleState: function toggleState(ids, state) {
            var _this2 = this;

            if (ids) {
                var target = event.target;
                if (target.nodeName === 'SPAN' || target.nodeName === 'I') {
                    target = event.target.parentNode;
                }
                target.blur();
                this.$confirm('您确定要更改状态?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    _this2.$axios.post('/positionApproval/updateState.api', {
                        ids: ids,
                        state: state
                    }, {
                        'X-showMessage': true
                    }).then(function (res) {
                        _this2.fetchData();
                    });
                }).catch(function () {});
            } else {
                this.$message({
                    message: '请先勾选数据',
                    type: 'warning'
                });
            }
        },
        handleParmasChange: function handleParmasChange(name) {
            var _this3 = this;

            this.getParams(function (params) {
                if (name === 'sequenceMainSearch') {
                    params.sequenceSubSearch = '';
                    var comp = _this3.$refs.condition.$children.find(function (c) {
                        return c.name === 'sequenceSubSearch';
                    });
                    comp && comp.checkedAll();
                }
            });
        }
    },
    components: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1375ed46"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/position/reviewList.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.firstRendered) ? _c('div', [_c('div', {
    staticClass: "filter-condition box-shadow-small border-radius"
  }, [_c('div', {
    staticClass: "search-box"
  }, [_c('el-button', {
    staticClass: "search-hd",
    attrs: {
      "type": "primary",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        return _vm.searchKeyword(_vm.keyword)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "search-bd"
  }, [_c('search-bar', {
    attrs: {
      "ajaxSearch": false,
      "placeholder": "请输入职位名称、职位编号、招聘HR进行搜索"
    },
    on: {
      "enter-key": _vm.searchKeyword,
      "select": _vm.searchKeyword
    },
    model: {
      value: (_vm.keyword),
      callback: function($$v) {
        _vm.keyword = $$v
      },
      expression: "keyword"
    }
  })], 1)], 1), _vm._v(" "), _c('filter-panel', {
    ref: "condition",
    on: {
      "params-change": _vm.handleParmasChange
    }
  }, _vm._l((_vm.filterConf), function(item, index) {
    return _c('filter-panel-item', {
      key: index,
      ref: item.name,
      refInFor: true,
      attrs: {
        "label": item.label,
        "mode": item.mode,
        "visible": item.visible,
        "name": item.name,
        "data": item.data,
        "initValue": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "filter-result background-white box-shadow-small border-radius"
  }, [_c('div', {
    staticClass: "filter-result-header mt-15 clearfix"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [(_vm.lists.length) ? _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "end"
    }
  }, [_c('el-button', {
    attrs: {
      "icon": "el-icon-my-queding color-success",
      "type": "success",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.toggleState(_vm.idStr, '1')
      }
    }
  }, [_vm._v("发布\n                        ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-daiding color-warning",
      "type": "warning",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.toggleState(_vm.idStr, '2')
      }
    }
  }, [_vm._v("待定\n                        ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-guanbi color-danger",
      "type": "danger",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.toggleState(_vm.idStr, '4')
      }
    }
  }, [_vm._v("不通过\n                        ")])], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.partialLoading),
      expression: "partialLoading"
    }]
  }, [_c('empty-tip', {
    attrs: {
      "show": !_vm.lists.length
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "table-list mt-20"
  }, [(_vm.lists.length) ? _c('el-table', {
    attrs: {
      "data": _vm.lists
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "code",
      "label": "职位编号",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "职位名称",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticStyle: {
            "color": "#20A0FF"
          },
          attrs: {
            "href": "javascript:;"
          },
          on: {
            "click": function($event) {
              return _vm.$refs.preview.show(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }], null, false, 722025121)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cityNames",
      "label": "工作地点",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deptNames",
      "label": "招聘部门",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "招聘范围",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.getSelectMapText('WB_PROPERTY_TYPE', scope.row.property)) + "\n                        ")]
      }
    }], null, false, 3894185378)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "门户展示",
      "show-overflow-tooltip": true,
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.showInDesk == 1 ? '是' : '否') + "\n                        ")]
      }
    }], null, false, 3889521821)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "内推职位",
      "show-overflow-tooltip": true,
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.getSelectMapText('WB_YES_OR_NO', scope.row.recommendable)) + "\n                        ")]
      }
    }], null, false, 403392328)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "审批人",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.apploverName || '-') + "\n                        ")]
      }
    }], null, false, 3126854548)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "审核时间",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.apploveTime || '-') + "\n                        ")]
      }
    }], null, false, 4061322964)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "followUpName",
      "label": "跟进人",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(['草稿', '已发布', '暂停', '待审核', '不通过'][scope.row.state]) + "\n                        ")]
      }
    }], null, false, 2224556558)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "class-name": "no-wrap",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.toggleState(scope.row.id, 1)
            }
          }
        }, [_vm._v("发布")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.toggleState(scope.row.id, 2)
            }
          }
        }, [_vm._v("暂停")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.toggleState(scope.row.id, 4)
            }
          }
        }, [_vm._v("不通过")])]
      }
    }], null, false, 2617036016)
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.lists.length) ? _c('el-pagination', {
    staticClass: "text-center mt-20 mb-20",
    attrs: {
      "current-page": _vm.pagination.pageIndex,
      "page-size": _vm.pagination.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.pagination.recordCounts
    },
    on: {
      "size-change": _vm.pageSizeChange,
      "current-change": _vm.pageIndexChange
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('preview-position', {
    ref: "preview"
  })], 1) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var position_reviewList_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/views/position/reviewList.vue
function injectStyle (ssrContext) {
  __webpack_require__(951)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  reviewList_defaultExport,
  position_reviewList_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(952);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("6fbd00ba", content, true);

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(954);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("0fc86bf6", content, true);

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/more/entrance.vue


/* harmony default export */ var entrance_defaultExport = ({
    data: function data() {
        return {
            iconMap: {
                boleList: 'tag-bole'
            }
        };
    },

    computed: {
        subMenu: function subMenu() {
            var menu = this.$store.state.app.menu,
                sub = menu[menu.length - 1].list;

            return sub;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d763678c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/more/entrance.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scope-more-entrance"
  }, [_c('el-row', {
    staticClass: "text-center"
  }, _vm._l((_vm.subMenu), function(item, index) {
    return _c('el-col', {
      key: index,
      attrs: {
        "span": 6
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: item.value
        }
      }
    }, [_c('div', {
      staticClass: "item-entrance"
    }, [_c('i', {
      staticClass: "item-entrance-tag",
      class: _vm.iconMap[item.value]
    }), _vm._v(" "), _c('span', {
      staticClass: "item-entrance-title"
    }, [_vm._v(_vm._s(item.text))])])])], 1)
  }), 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var more_entrance_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/views/more/entrance.vue
function injectStyle (ssrContext) {
  __webpack_require__(956)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  entrance_defaultExport,
  more_entrance_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(957);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("4cf848c2", content, true);

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".scope-more-entrance .item-entrance{border:2px solid transparent;padding:15px;background:#fff;border-radius:5px;box-sizing:border-box;display:inline-block;width:360px;box-shadow:0 0 6px rgba(0,0,0,.1);transition:all .4s ease 0s}.scope-more-entrance .item-entrance:hover{cursor:pointer;border-color:#2481ff}.scope-more-entrance .item-entrance:hover .item-entrance-title{color:#000}.scope-more-entrance .item-entrance-tag{float:left;width:56px;height:56px;background:url(" + __webpack_require__(958) + ") no-repeat center 0}.scope-more-entrance .item-entrance-tag.tag-project{background-position-y:-76px}.scope-more-entrance .item-entrance-tag.tag-bole{background-position-y:-228px}.scope-more-entrance .item-entrance-title{padding-left:76px;display:block;line-height:56px;vertical-align:middle;font-size:16px;font-weight:700;color:#999;text-align:left}", ""]);

// exports


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/item-tag8369d2a8.png";

/***/ }),
/* 959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/supplier/supplierList.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__listItem__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__editSupplierDialog__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_queryListExtend__ = __webpack_require__(20);






/* harmony default export */ var supplierList_defaultExport = ({
    'extends': __WEBPACK_IMPORTED_MODULE_2_components_queryListExtend__["a" /* default */],
    data: function data() {
        return {
            fetchUrl: '/supplier/list.api',
            filterConf: [{
                label: '签约部门',
                name: 'dbTypeSearch',
                filter: 'SYS_TYPE',
                data: []
            }],
            searchData: {
                searchWord: null
            }
        };
    },

    methods: {
        showEditWin: function showEditWin(data) {
            this.$refs.editSupplier.show(true, data);
        },
        getSourceName: function getSourceName(code) {
            var data = this.companyList.filter(function (item) {
                return item.code === code;
            });
            return data.length ? data[0].name : '-';
        }
    },
    components: {
        ListItem: __WEBPACK_IMPORTED_MODULE_0__listItem__["a" /* default */],
        EditSupplierDialog: __WEBPACK_IMPORTED_MODULE_1__editSupplierDialog__["a" /* default */]
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f1dcf77"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/supplier/supplierList.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.firstRendered) ? _c('div', {
    staticClass: "scoped-headhunter"
  }, [_c('div', {}, [_c('div', {
    staticClass: "filter-condition box-shadow-small border-radius"
  }, [_c('div', {
    staticClass: "search-box"
  }, [_c('el-button', {
    staticClass: "search-hd",
    attrs: {
      "type": "primary",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        return _vm.searchKeyword(_vm.keyword)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "search-bd"
  }, [_c('search-bar', {
    attrs: {
      "placeholder": "请输入对接人姓名、手机号、邮箱、供应商等",
      "ajaxSearch": false
    },
    on: {
      "enter-key": _vm.searchKeyword,
      "select": _vm.searchKeyword
    },
    model: {
      value: (_vm.keyword),
      callback: function($$v) {
        _vm.keyword = $$v
      },
      expression: "keyword"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "filter-result background-white box-shadow-small border-radius"
  }, [_c('div', {
    staticClass: "filter-result-header clearfix mt-10"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-plus"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.editSupplier.show()
      }
    }
  }, [_vm._v("新建供应商")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.partialLoading),
      expression: "partialLoading"
    }]
  }, [_c('empty-tip', {
    attrs: {
      "show": !_vm.lists.length
    }
  }), _vm._v(" "), _vm._l((_vm.lists), function(item, index) {
    return _c('div', {
      key: item.id,
      staticClass: "list mt-20"
    }, [_c('ListItem', {
      attrs: {
        "item": item,
        "index": index
      },
      on: {
        "remove": _vm.removeRecordById,
        "edit": _vm.showEditWin
      }
    })], 1)
  }), _vm._v(" "), (_vm.lists.length) ? _c('el-pagination', {
    staticClass: "text-center mb-20",
    attrs: {
      "current-page": _vm.pagination.pageIndex,
      "page-size": _vm.pagination.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.pagination.recordCounts
    },
    on: {
      "size-change": _vm.pageSizeChange,
      "current-change": _vm.pageIndexChange
    }
  }) : _vm._e()], 2)])]), _vm._v(" "), _c('EditSupplierDialog', {
    ref: "editSupplier",
    on: {
      "reload": _vm.fetchData
    }
  })], 1) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var supplier_supplierList_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/views/supplier/supplierList.vue
function injectStyle (ssrContext) {
  __webpack_require__(960)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  supplierList_defaultExport,
  supplier_supplierList_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(961);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("665c4386", content, true);

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".scoped-headhunter .filter-result{margin:20px 0}.scoped-headhunter .filter-result .list-item-bottom{background:#fff}.scoped-headhunter .filter-result .list-item:not(:first-child){margin-top:20px}.scoped-headhunter .filter-result .list-item .line-text-1,.scoped-headhunter .filter-result .list-item .line-text-2{margin:5px 0}.scoped-headhunter .filter-result .list-item-body .operate-btn-area button{display:block;width:100%;margin-left:0}.scoped-headhunter .filter-result .list-item-body .operate-btn-area button:not(:first-child){margin-top:5px}.scoped-headhunter .filter-result .title{font-size:16px}.scoped-headhunter .filter-result .c-tips{color:#999}", ""]);

// exports


/***/ }),
/* 962 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(964);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("318c2a02", content, true);

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".list-item[data-v-614be14b]{border:1px solid #ededed;margin-bottom:20px}.list-item-body[data-v-614be14b],.list-item-bottom[data-v-614be14b],.list-item-top[data-v-614be14b]{padding:10px 20px;color:#333}", ""]);

// exports


/***/ }),
/* 965 */
/***/ (function(module, exports) {



/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(967);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("a44b60a4", content, true);

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".round-button[data-v-2ae3f04c]{border-radius:50%;background-color:transparent;color:inherit}.round-button.el-button--success[data-v-2ae3f04c]{color:#11b970;border-color:#11b970}.round-button.el-button--info[data-v-2ae3f04c]{color:#4493ff;border-color:#4493ff}.round-button.el-button--warning[data-v-2ae3f04c]{color:#ffb033;border-color:#ffb033}.round-button.el-button--primary[data-v-2ae3f04c]{color:#2481ff;border-color:#2481ff}.round-button.el-button--purple[data-v-2ae3f04c]{color:#b94cff;border-color:#b94cff}", ""]);

// exports


/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(969);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("74ed2514", content, true);

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/textBanner.vue


/* harmony default export */ var textBanner_defaultExport = ({
    name: 'textBanner',
    props: {
        iconType: String
    },
    computed: {
        user: function user() {
            return this.$store.state.user;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-800c7a06"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/textBanner.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "c-text-banner"
  }, [_c('div', {
    staticClass: "text-area"
  }, [_c('div', {
    staticClass: "text-area-left"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "text-area-right"
  }, [_vm._t("right", [_c('p', [_c('span', [_vm._v("申请人：" + _vm._s(_vm.user.name))]), _vm._v(" "), _c('span', {
    staticClass: "ml-20"
  }, [_vm._v("签约部门：" + _vm._s(_vm.user.sysTypeName))])])])], 2)])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_textBanner_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/components/textBanner.vue
function injectStyle (ssrContext) {
  __webpack_require__(973)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-800c7a06"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  textBanner_defaultExport,
  components_textBanner_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_textBanner_defaultExport = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/supplier/supplierUsers.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_pIcon__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_pattern__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mixins_selectMapMixin__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__companyList__ = __webpack_require__(235);










/* harmony default export */ var supplierUsers_defaultExport = ({
    data: function data() {
        return {
            companyId: this.$route.query.id,
            supplier: {},
            dynamicForm: {
                tableData: [{
                    hunterPhone: ''
                }]
            },
            pattern: __WEBPACK_IMPORTED_MODULE_5_modules_pattern__["a" /* default */]
        };
    },

    mixins: [__WEBPACK_IMPORTED_MODULE_6_mixins_selectMapMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__companyList__["a" /* default */]],
    computed: {},
    methods: {
        sizeChange: function sizeChange(val) {
            console.log(val);
        },
        currentChange: function currentChange(val) {
            console.log(val);
        },
        editRow: function editRow(index, row) {
            row.__resetCopy = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, row);
            this.$set(row, 'isEditStatus', true);
        },
        deleteRow: function deleteRow(index, row) {
            var _this = this;

            this.$confirm('是否删除该记录?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post('/supplierLinkman/delete.api', { id: row.id }, { 'X-showMessage': true }).then(function (res) {
                    _this.dynamicForm.tableData = _this.dynamicForm.tableData.filter(function (item) {
                        return item.id !== row.id;
                    });
                }).catch(function () {});
            });
        },
        addRow: function addRow(index, row) {
            this.dynamicForm.tableData.push({
                'isEditStatus': true,
                'name': '',
                'email': '',
                'phone': '',
                'citys': []
            });
        },
        saveRow: function saveRow(index, row) {
            var _this2 = this;

            this.$refs['ruleTableForm'].validate(function (valid) {
                if (valid) {
                    var postUrl = row.id ? '/supplierLinkman/update.api' : '/supplierLinkman/insert.api',
                        postData = {
                        id: row.id || '',
                        supplierId: _this2.companyId,
                        name: row.name,
                        email: row.email,
                        phone: row.phone,
                        citys: row.citys.join(',')
                    };
                    __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(postUrl, postData, { 'X-showMessage': true }).then(function (res) {
                        var bean = res.result && res.result.bean;
                        if (bean) {
                            for (var name in row) {
                                _this2.$set(row, name, bean[name]);
                            }
                            _this2.$set(row, 'lastOperateName', bean.lastOperateName);
                            _this2.$set(row, 'modifyTime', bean.modifyTime);
                            _this2.$set(row, 'id', bean.id);
                            _this2.$set(row, 'citys', bean.citys ? bean.citys.split(',') : []);
                        }
                        _this2.$set(row, 'isEditStatus', false);
                    }).catch(function (err) {});
                } else {
                    return false;
                }
            });
        },
        cancelRow: function cancelRow(index, row) {
            if (row.id) {
                __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(row, row.__resetCopy);
                delete row.__resetCopy;
                this.$set(row, 'isEditStatus', false);
            } else {
                this.dynamicForm.tableData.pop();
            }
        },
        getSelectMapText: function getSelectMapText(selectMapName, value) {
            var separator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ',';

            value = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value));
            var text = '',
                list = selectMapName instanceof Array ? selectMapName : this.selectMap[selectMapName],
                curValue = '',
                resultTxt = [];
            if (!(value instanceof Array)) {
                value = [value];
            }
            curValue = value.shift();
            while (typeof curValue !== 'undefined' && list) {
                for (var index = 0; index < list.length; index++) {
                    var item = list[index];
                    if (item.value === String(curValue)) {
                        resultTxt.push(item.text);
                        break;
                    }
                }
                curValue = value.shift();
            }
            return resultTxt.length === 1 ? resultTxt[0] : resultTxt.join(separator);
        }
    },
    components: {
        TextBanner: src_components_textBanner_defaultExport,
        PIcon: __WEBPACK_IMPORTED_MODULE_3_components_pIcon__["a" /* default */]
    },
    created: function created() {
        var _this3 = this;

        __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('/supplier/selectByKey.api', { params: { id: this.companyId } }).then(function (res) {
            _this3.supplier = res.result.bean;
        });
        __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('/supplierLinkman/list.api', { params: { supplierId: this.companyId } }).then(function (res) {
            var result = res.result;
            _this3.dynamicForm.tableData = result.list.map(function (el) {
                el.citys = el.citys ? el.citys.split(',') : [];
                return el;
            });
        });
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-157a797f"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/supplier/supplierUsers.vue
var supplierUsers_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scoped-headhunterDetail"
  }, [_c('div', {
    staticClass: "white-block"
  }, [_c('p', [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'supplier'
        })
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-my-zuo ml-5"
  }), _vm._v(" 返回供应商列表")])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "banner-text mt-10"
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('p', {
    staticClass: "line-text-1"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "22px"
    }
  }, [_vm._v(_vm._s(_vm.supplier.linkman))]), _vm._v("（" + _vm._s(_vm.getSourceName(_vm.supplier.companyAbbr)) + "）")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('p-icon', {
    staticClass: "line-text-1",
    attrs: {
      "icon-name": "phone"
    }
  }, [_vm._v(_vm._s(_vm.supplier.tel))]), _vm._v(" "), _c('p-icon', {
    staticClass: "line-text-2",
    attrs: {
      "icon-name": "email"
    }
  }, [_vm._v(_vm._s(_vm.supplier.email))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('p-icon', {
    staticClass: "line-text-1",
    attrs: {
      "icon-name": "list"
    }
  }, [_vm._v(_vm._s(_vm.supplier.companyFullName))]), _vm._v(" "), _c('p-icon', {
    staticClass: "line-text-2",
    attrs: {
      "icon-name": "clock"
    }
  }, [_vm._v(_vm._s(_vm.supplier.createTime))])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "supplier-bottom"
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('label', [_vm._v("跟进HR：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.supplier.applicant))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('label', [_vm._v("签约部门：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.supplier.projectName))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('label', [_vm._v("备注：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.supplier.remark))])])], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "filter-result-header clearfix mt-20 mt-20"
  }, [_c('span', {
    staticClass: "title",
    staticStyle: {
      "font-size": "18px",
      "color": "#333"
    }
  }, [_vm._v("子账号列表（" + _vm._s(_vm.dynamicForm.tableData.length) + "）")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "icon": "el-icon-plus"
    },
    on: {
      "click": _vm.addRow
    }
  }, [_vm._v("添加账号")])], 1), _vm._v(" "), _c('el-form', {
    ref: "ruleTableForm",
    staticClass: "demo-ruleForm mt-20",
    attrs: {
      "model": _vm.dynamicForm
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.dynamicForm.tableData,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "对接人",
      "align": "center",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.isEditStatus) ? _c('span', {
          domProps: {
            "textContent": _vm._s(scope.row.name)
          }
        }) : _vm._e(), _vm._v(" "), (scope.row.isEditStatus) ? _c('el-input', {
          attrs: {
            "placeholder": "请输入对接人",
            "maxlength": 50
          },
          model: {
            value: (scope.row.name),
            callback: function($$v) {
              _vm.$set(scope.row, "name", $$v)
            },
            expression: "scope.row.name"
          }
        }) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "对接人电话",
      "align": "center",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.isEditStatus) ? _c('span', {
          domProps: {
            "textContent": _vm._s(scope.row.phone)
          }
        }) : _vm._e(), _vm._v(" "), (scope.row.isEditStatus) ? _c('el-form-item', {
          staticStyle: {
            "margin-top": "22px"
          },
          attrs: {
            "prop": 'tableData.' + scope.$index + '.phone',
            "rules": [{
                required: true,
                message: '请输入对接人电话',
                trigger: 'blur'
              },
              {
                pattern: /^[0-9]+$/,
                message: '请输入数字',
                trigger: 'blur,change'
              }
            ]
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入对接人电话",
            "maxlength": 20
          },
          model: {
            value: (scope.row.phone),
            callback: function($$v) {
              _vm.$set(scope.row, "phone", $$v)
            },
            expression: "scope.row.phone"
          }
        })], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "对接人邮箱"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.isEditStatus) ? _c('span', {
          domProps: {
            "textContent": _vm._s(scope.row.email)
          }
        }) : _vm._e(), _vm._v(" "), (scope.row.isEditStatus) ? _c('el-form-item', {
          staticStyle: {
            "margin-top": "22px"
          },
          attrs: {
            "prop": 'tableData.' + scope.$index + '.email',
            "rules": [{
                required: true,
                message: '请输入对接人邮箱',
                trigger: 'blur'
              },
              {
                type: 'email',
                message: '请输入正确的邮箱地址',
                trigger: 'blur,change'
              }
            ]
          }
        }, [(scope.row.isEditStatus) ? _c('el-input', {
          attrs: {
            "placeholder": "请输入对接人邮箱",
            "maxlength": 50
          },
          model: {
            value: (scope.row.email),
            callback: function($$v) {
              _vm.$set(scope.row, "email", $$v)
            },
            expression: "scope.row.email"
          }
        }) : _vm._e()], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "所属地区"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.isEditStatus && scope.row.citys) ? _c('span', [_vm._v(_vm._s(_vm.getSelectMapText('WB_POSITION_CITY', scope.row.citys)))]) : _vm._e(), _vm._v(" "), (scope.row.isEditStatus) ? _c('el-form-item', {
          staticStyle: {
            "margin-top": "22px"
          },
          attrs: {
            "prop": 'tableData.' + scope.$index + '.citys',
            "rules": [{
              required: true,
              type: 'array',
              message: '请选择对接人所属地区',
              trigger: 'blur'
            }]
          }
        }, [_c('el-select', {
          attrs: {
            "multiple": ""
          },
          model: {
            value: (scope.row.citys),
            callback: function($$v) {
              _vm.$set(scope.row, "citys", $$v)
            },
            expression: "scope.row.citys"
          }
        }, _vm._l((_vm.selectMap.WB_POSITION_CITY), function(item, idx) {
          return _c('el-option', {
            key: idx,
            attrs: {
              "label": item.text,
              "value": item.value
            }
          })
        }), 1)], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "最近操作人/时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          domProps: {
            "textContent": _vm._s((scope.row.lastOperateName || '') + ' ' + (scope.row.modifyTime || ''))
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "align": "center",
      "label": "操作",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.isEditStatus) ? _c('el-button', {
          attrs: {
            "type": "text",
            "icon": "el-icon-my-bianji color-info"
          },
          on: {
            "click": function($event) {
              return _vm.editRow(scope.$index, scope.row)
            }
          }
        }) : _vm._e(), _vm._v(" "), (!scope.row.isEditStatus) ? _c('el-button', {
          attrs: {
            "type": "text",
            "icon": "el-icon-my-shanchu color-danger"
          },
          on: {
            "click": function($event) {
              return _vm.deleteRow(scope.$index, scope.row)
            }
          }
        }) : _vm._e(), _vm._v(" "), (scope.row.isEditStatus) ? _c('el-button', {
          attrs: {
            "type": "text",
            "icon": "el-icon-check color-success"
          },
          on: {
            "click": function($event) {
              return _vm.saveRow(scope.$index, scope.row)
            }
          }
        }) : _vm._e(), _vm._v(" "), (scope.row.isEditStatus) ? _c('el-button', {
          attrs: {
            "type": "text",
            "icon": "el-icon-my-guanbi color-danger"
          },
          on: {
            "click": function($event) {
              return _vm.cancelRow(scope.$index, scope.row)
            }
          }
        }) : _vm._e()]
      }
    }])
  })], 1)], 1)], 1)], 1)])
}
var supplierUsers_staticRenderFns = []
var supplierUsers_esExports = { render: supplierUsers_render, staticRenderFns: supplierUsers_staticRenderFns }
/* harmony default export */ var supplier_supplierUsers_defaultExport = (supplierUsers_esExports);
// CONCATENATED MODULE: ./src/views/supplier/supplierUsers.vue
function supplierUsers_injectStyle (ssrContext) {
  __webpack_require__(971)
}
var supplierUsers_normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var supplierUsers___vue_styles__ = supplierUsers_injectStyle
/* scopeId */
var supplierUsers___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var supplierUsers___vue_module_identifier__ = null
var supplierUsers_Component = supplierUsers_normalizeComponent(
  supplierUsers_defaultExport,
  supplier_supplierUsers_defaultExport,
  supplierUsers___vue_styles__,
  supplierUsers___vue_scopeId__,
  supplierUsers___vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (supplierUsers_Component.exports);


/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(972);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("23429ae6", content, true);

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".scoped-headhunterDetail .white-block{background:#fff;padding:20px;min-height:700px}.scoped-headhunterDetail .supplier-bottom{border:1px solid #2481ff;color:#999;padding:5px 20px;margin-top:-1px;border-radius:0 0 5px 5px}.scoped-headhunterDetail .banner-text{padding:15px 20px;border:1px solid #2481ff;background:#2481ff;color:#fff;border-radius:5px 5px 0 0}.scoped-headhunterDetail .subTitle{width:500px}", ""]);

// exports


/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(974);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("d2417cdc", content, true);

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".c-text-banner[data-v-800c7a06]{position:relative;height:195px;background:url(" + __webpack_require__(975) + ") no-repeat 50%}.c-text-banner .text-area[data-v-800c7a06]{color:#fff;position:absolute;bottom:10px;left:20px;right:20px}.c-text-banner .text-area .title[data-v-800c7a06]{font-size:24px}.c-text-banner .text-area-left[data-v-800c7a06]{position:absolute;bottom:0;left:0}.c-text-banner .text-area-right[data-v-800c7a06]{max-width:700px;position:absolute;bottom:0;right:0;word-break:break-all}", ""]);

// exports


/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/banner-1c171c6ab.jpg";

/***/ }),
/* 976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/supplier/statistic.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__listItem__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__editSupplierDialog__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_queryListExtend__ = __webpack_require__(20);






/* harmony default export */ var statistic_defaultExport = ({
    'extends': __WEBPACK_IMPORTED_MODULE_2_components_queryListExtend__["a" /* default */],
    data: function data() {
        return {
            fetchUrl: '/supplier/getResumeStatistics.api',
            filterConf: [{
                label: '签约部门',
                name: 'dbTypeSearch',
                filter: 'SYS_TYPE',
                data: []
            }],
            searchData: {
                searchWord: null
            }
        };
    },

    methods: {
        showEditWin: function showEditWin(data) {
            this.$refs.editSupplier.show(true, data);
        },
        getSourceName: function getSourceName(code) {
            var data = this.companyList.filter(function (item) {
                return item.code === code;
            });
            return data.length ? data[0].name : '-';
        },
        extendParamsBeforeFetch: function extendParamsBeforeFetch() {
            return {
                supplierName: this.searchData.searchWord
            };
        }
    },
    components: {
        ListItem: __WEBPACK_IMPORTED_MODULE_0__listItem__["a" /* default */],
        EditSupplierDialog: __WEBPACK_IMPORTED_MODULE_1__editSupplierDialog__["a" /* default */]
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8cf51a9a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/supplier/statistic.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.firstRendered) ? _c('div', {
    staticClass: "scoped-headhunter"
  }, [_c('div', {}, [_c('div', {
    staticClass: "filter-condition box-shadow-small border-radius"
  }, [_c('div', {
    staticClass: "search-box"
  }, [_c('el-button', {
    staticClass: "search-hd",
    attrs: {
      "type": "primary",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        return _vm.searchKeyword(_vm.keyword)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "search-bd"
  }, [_c('search-bar', {
    attrs: {
      "placeholder": "请输入供应商名称",
      "ajaxSearch": false
    },
    on: {
      "enter-key": _vm.searchKeyword,
      "select": _vm.searchKeyword
    },
    model: {
      value: (_vm.keyword),
      callback: function($$v) {
        _vm.keyword = $$v
      },
      expression: "keyword"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "filter-result background-white box-shadow-small border-radius"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.partialLoading),
      expression: "partialLoading"
    }]
  }, [_c('empty-tip', {
    attrs: {
      "show": !_vm.lists.length
    }
  }), _vm._v(" "), (_vm.lists.length) ? _c('el-table', {
    attrs: {
      "data": _vm.lists,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "left",
      "prop": "supplierName",
      "label": "供应商名称",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "resumeTotal",
      "label": "简历推荐数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "resumePass",
      "label": "简历通过"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "resumeNotPass",
      "label": "简历不通过"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "resumeUndetermined",
      "label": "简历待定"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "resumeBlack",
      "label": "简历拉黑"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "paperPass",
      "label": "笔试通过"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "paperNotPass",
      "label": "笔试不通过"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "paperUndetermined",
      "label": "笔试待定"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "paperBlack",
      "label": "笔试拉黑"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "interviewPass",
      "label": "面试通过"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "interviewNotPass",
      "label": "面试不通过"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "interviewUndetermined",
      "label": "面试待定"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "interviewBlack",
      "label": "面试拉黑"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "offer",
      "label": "offer"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "breakPromise",
      "label": "毁约"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "entry",
      "label": "入职"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.lists.length) ? _c('el-pagination', {
    staticClass: "text-center mb-20 mt-10",
    attrs: {
      "current-page": _vm.pagination.pageIndex,
      "page-size": _vm.pagination.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.pagination.recordCounts
    },
    on: {
      "size-change": _vm.pageSizeChange,
      "current-change": _vm.pageIndexChange
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('EditSupplierDialog', {
    ref: "editSupplier",
    on: {
      "reload": _vm.fetchData
    }
  })], 1) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var supplier_statistic_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/views/supplier/statistic.vue
function injectStyle (ssrContext) {
  __webpack_require__(977)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  statistic_defaultExport,
  supplier_statistic_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(978);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("eddf95b6", content, true);

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".scoped-headhunter .filter-result{margin:20px 0}.scoped-headhunter .filter-result .list-item-bottom{background:#fff}.scoped-headhunter .filter-result .list-item:not(:first-child){margin-top:20px}.scoped-headhunter .filter-result .list-item .line-text-1,.scoped-headhunter .filter-result .list-item .line-text-2{margin:5px 0}.scoped-headhunter .filter-result .list-item-body .operate-btn-area button{display:block;width:100%;margin-left:0}.scoped-headhunter .filter-result .list-item-body .operate-btn-area button:not(:first-child){margin-top:5px}.scoped-headhunter .filter-result .title{font-size:16px}.scoped-headhunter .filter-result .c-tips{color:#999}", ""]);

// exports


/***/ }),
/* 979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/more/bole/addBoleDialog.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mixins_selectMapMixin__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mixins_formCommonMixin__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_pattern__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_rules__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_tools__ = __webpack_require__(14);










var Model = {
    id: '',
    name: '',
    mobilephone: '',
    firDeptName: '',
    secDeptName: '',
    thrDeptName: '',
    jobNumber: '',
    email: '' };
/* harmony default export */ var addBoleDialog_defaultExport = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_2_mixins_selectMapMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3_mixins_formCommonMixin__["a" /* default */]],
    data: function data() {
        return {
            urls: {
                add: '/bole/save.api',
                update: '/bole/save.api',
                fetch: '/bole/getDetailById.api'
            },
            showDialog: false,
            isEdit: false,
            preventKey: 1,
            ruleForm: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, Model),
            rules: {
                name: { required: true, message: '请输入姓名', trigger: 'blur' },
                mobilephone: [{ required: true, message: '请输入手机号', trigger: 'blur' }, { pattern: __WEBPACK_IMPORTED_MODULE_4_modules_pattern__["a" /* default */].phone, message: '手机号格式不正确', trigger: 'blur' }],
                email: [{ required: true, message: '请输入', trigger: 'blur' }, { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }],
                firDeptName: { required: true, message: '请输入一级部门', trigger: 'blur' },
                secDeptName: { required: true, message: '请输入二级部门', trigger: 'blur' },
                thrDeptName: { required: true, message: '请输入三级部门', trigger: 'blur' },
                jobNumber: { required: true, message: '请输入外包工号', trigger: 'blur' }
            }
        };
    },

    methods: {
        show: function show(data) {
            this.preventKey++;
            if (data) {
                this.fetchData(data.id);
            } else {
                this.ruleForm.id = '';
            }
            this.isEdit = Boolean(data && data.id);
            this.$refs.ruleForm && this.$refs.ruleForm.resetFields();
            this.showDialog = true;
        },
        saveForm: function saveForm(boolean) {
            var _this = this;

            this.$axios.post(this.ruleForm.id ? this.urls.update : this.urls.add, this.ruleForm, { 'X-showMessage': true }).then(function (res) {
                _this.resetForm('ruleForm');
                if (boolean === true) {
                    _this.showDialog = false;
                } else {
                    _this.ruleForm.id = '';
                }
                _this.$emit('reload');
            }).catch(function () {});
        },
        fetchData: function fetchData(id) {
            var _this2 = this;

            this.$axios.get(this.urls.fetch, { params: { id: id } }).then(function (res) {
                var data = res.result.bean;

                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this2.ruleForm).forEach(function (key) {
                    _this2.ruleForm[key] = data[key];
                });
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f4c55aa"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/more/bole/addBoleDialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": ((_vm.isEdit ? '编辑':'添加') + "帐号"),
      "visible": _vm.showDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.showDialog = $event
      }
    }
  }, [_c("el-form", {
    key: _vm.preventKey,
    ref: "ruleForm",
    tag: "component",
    staticClass: "form-beauty form-col",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.ruleForm,
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 50,
      "disabled": _vm.ruleForm.state == 1,
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.ruleForm.name),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号",
      "prop": "mobilephone"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 50,
      "disabled": _vm.ruleForm.state == 1,
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.ruleForm.mobilephone),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "mobilephone", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.mobilephone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "一级部门",
      "prop": "firDeptName"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 50,
      "disabled": _vm.ruleForm.state == 1,
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.ruleForm.firDeptName),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "firDeptName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.firDeptName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "二级部门",
      "prop": "secDeptName"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 50,
      "disabled": _vm.ruleForm.state == 1,
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.ruleForm.secDeptName),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "secDeptName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.secDeptName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "三级部门",
      "prop": "thrDeptName"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 50,
      "disabled": _vm.ruleForm.state == 1,
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.ruleForm.thrDeptName),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "thrDeptName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.thrDeptName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "外包工号",
      "prop": "jobNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 50,
      "disabled": _vm.ruleForm.state == 1,
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.ruleForm.jobNumber),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "jobNumber", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.jobNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "外包公司邮箱",
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 50,
      "disabled": _vm.ruleForm.state == 1,
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.ruleForm.email),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "email", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.email"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mb-10",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm', true)
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), (!_vm.isEdit) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm', false)
      }
    }
  }, [_vm._v("保存并继续添加")]) : _vm._e()], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var bole_addBoleDialog_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/views/more/bole/addBoleDialog.vue
function injectStyle (ssrContext) {
  __webpack_require__(981)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  addBoleDialog_defaultExport,
  bole_addBoleDialog_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var more_bole_addBoleDialog_defaultExport = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/more/bole/boleList.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_queryListExtend__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_fileUpload__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_views_operation_operationMixin__ = __webpack_require__(37);







/* harmony default export */ var boleList_defaultExport = ({
    'extends': __WEBPACK_IMPORTED_MODULE_0_components_queryListExtend__["a" /* default */],
    components: { FileUpload: __WEBPACK_IMPORTED_MODULE_1_components_fileUpload__["a" /* default */], AddBoleDialog: more_bole_addBoleDialog_defaultExport },
    mixins: [__WEBPACK_IMPORTED_MODULE_2_views_operation_operationMixin__["a" /* default */]],
    data: function data() {
        return {
            fetchUrl: '/bole/list.api',
            urls: {
                remove: '/bole/deleteById.api'
            },
            searchData: {
                searchWord: null
            }
        };
    },

    computed: {
        downloadTemplateUrl: function downloadTemplateUrl() {
            return this.$axios.defaults.baseURL + '/bole/downloadTemplate.api?token=' + this.$store.state.app.token;
        }
    },
    methods: {
        addRecord: function addRecord(data) {
            this.$refs.addBoleDialog.show(data);
        },
        removeRecord: function removeRecord(data) {
            var _this = this;

            this.$confirm('\u662F\u5426\u5220\u9664\u3010' + data.name + '\u3011\u8FD9\u6761\u8BB0\u5F55\uFF1F', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                _this.$axios.post(_this.urls.remove, { id: data.id }, { 'X-showMessage': true }).then(function (res) {
                    _this.fetchData();
                });
            });
        },
        uploadSuccess: function uploadSuccess(res, file) {
            this.fetchData();
            var h = this.$createElement;
            var nodeContent = res.result.list.map(function (item) {
                return h('p', null, item);
            });
            this.$notify({
                title: '导入结果提示：',
                duration: 0,
                message: h('div', {
                    style: {
                        maxHeight: '500px',
                        overflow: 'auto'
                    }
                }, nodeContent),
                type: res.result.isAllSuccess ? 'success' : 'error'
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b57514e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/more/bole/boleList.vue
var boleList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.firstRendered) ? _c('div', [_c('div', {
    staticClass: "filter-condition box-shadow-small border-radius"
  }, [_c('div', {
    staticClass: "search-box"
  }, [_c('el-button', {
    staticClass: "search-hd",
    attrs: {
      "type": "primary",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        return _vm.searchKeyword(_vm.keyword)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "search-bd"
  }, [_c('search-bar', {
    attrs: {
      "ajaxSearch": false,
      "placeholder": "请输入姓名、手机号、邮箱进行搜索"
    },
    on: {
      "enter-key": _vm.searchKeyword,
      "select": _vm.searchKeyword
    },
    model: {
      value: (_vm.keyword),
      callback: function($$v) {
        _vm.keyword = $$v
      },
      expression: "keyword"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "filter-result background-white box-shadow-small border-radius"
  }, [_c('div', {
    staticClass: "filter-result-header mt-15 clearfix"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    attrs: {
      "icon": "el-icon-plus",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.addRecord()
      }
    }
  }, [_vm._v("添加帐号")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-daochu",
      "type": "info"
    },
    on: {
      "click": function($event) {
        return _vm.exportFiles(_vm.idStr, '/bole', '/exportBole.api')
      }
    }
  }, [_vm._v("导出帐号")]), _vm._v(" "), _c('file-upload', {
    staticClass: "ml-5 mr-5",
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "upload-mode": "silence",
      "action": ((_vm.$axios.defaults.baseURL) + "/bole/importBole.api"),
      "accept": ".xls",
      "on-success": _vm.uploadSuccess,
      "fileLimit": 0,
      "showLoading": true
    }
  }, [_c('el-button', {
    attrs: {
      "plain": true,
      "icon": "el-icon-upload2",
      "type": "primary"
    }
  }, [_vm._v("导入帐号")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  })], 1), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.downloadTemplateUrl
    }
  }, [_c('el-button', {
    attrs: {
      "icon": "el-icon-my-daochu",
      "plain": true,
      "type": "text"
    }
  }, [_vm._v("下载导入模版")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.partialLoading),
      expression: "partialLoading"
    }]
  }, [_c('empty-tip', {
    attrs: {
      "show": !_vm.lists.length
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "table-list mt-20"
  }, [(_vm.lists.length) ? _c('el-table', {
    attrs: {
      "data": _vm.lists
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "姓名",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.name) + "\n                        ")]
      }
    }], null, false, 2291008282)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "手机号",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.mobilephone) + "\n                        ")]
      }
    }], null, false, 3734318849)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "一级部门",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.firDeptName) + "\n                        ")]
      }
    }], null, false, 3171223362)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "二级部门",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.secDeptName) + "\n                        ")]
      }
    }], null, false, 1454145930)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "三级部门",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.thrDeptName) + "\n                        ")]
      }
    }], null, false, 2899492305)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "外包工号",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.jobNumber) + "\n                        ")]
      }
    }], null, false, 2094672377)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "外包公司邮箱",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.email) + "\n                        ")]
      }
    }], null, false, 874926193)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.addRecord(scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.removeRecord(scope.row)
            }
          }
        }, [_c('span', {
          staticClass: "color-danger"
        }, [_vm._v("删除")])])]
      }
    }], null, false, 2305422754)
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.lists.length) ? _c('el-pagination', {
    staticClass: "text-center mb-20 mt-10",
    attrs: {
      "current-page": _vm.pagination.pageIndex,
      "page-size": _vm.pagination.pageSize,
      "page-sizes": [20, 50, 100, 200],
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.pagination.recordCounts
    },
    on: {
      "size-change": _vm.pageSizeChange,
      "current-change": _vm.pageIndexChange
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('add-bole-dialog', {
    ref: "addBoleDialog",
    on: {
      "reload": _vm.fetchData
    }
  })], 1) : _vm._e()
}
var boleList_staticRenderFns = []
var boleList_esExports = { render: boleList_render, staticRenderFns: boleList_staticRenderFns }
/* harmony default export */ var bole_boleList_defaultExport = (boleList_esExports);
// CONCATENATED MODULE: ./src/views/more/bole/boleList.vue
function boleList_injectStyle (ssrContext) {
  __webpack_require__(980)
}
var boleList_normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var boleList___vue_styles__ = boleList_injectStyle
/* scopeId */
var boleList___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var boleList___vue_module_identifier__ = null
var boleList_Component = boleList_normalizeComponent(
  boleList_defaultExport,
  bole_boleList_defaultExport,
  boleList___vue_styles__,
  boleList___vue_scopeId__,
  boleList___vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (boleList_Component.exports);


/***/ }),
/* 980 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(982);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("1679f672", content, true);

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/more/schoolLevel/addRecordDialog.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mixins_selectMapMixin__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mixins_formCommonMixin__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_pattern__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_rules__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_tools__ = __webpack_require__(14);










var Model = {
    id: '',
    name: '',
    provinceId: '',
    cityId: '',
    type: '',
    sLevel: '' };
/* harmony default export */ var addRecordDialog_defaultExport = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_2_mixins_selectMapMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3_mixins_formCommonMixin__["a" /* default */]],
    data: function data() {
        return {
            urls: {
                add: '/system/school/level/save.api',
                update: '/system/school/level/save.api'
            },
            showDialog: false,
            isEdit: false,
            preventKey: 1,
            ruleForm: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, Model),
            cityArr: [],
            rules: {
                name: { required: true, message: '请输入', trigger: 'blur' },
                provinceId: { required: true, message: '请选择', trigger: 'blur' },
                cityId: { required: true, message: '请选择', trigger: 'blur' },
                type: { required: true, message: '请选择', trigger: 'blur' },
                sLevel: { required: true, message: '请选择', trigger: 'blur' }
            }
        };
    },

    methods: {
        show: function show(data) {
            var _this = this;

            this.preventKey++;
            if (data) {
                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.ruleForm).forEach(function (key) {
                    _this.ruleForm[key] = typeof data[key] === 'number' ? data[key] && String(data[key]) || '' : data[key];
                });
                this.provinceChange(this.ruleForm.provinceId);
            } else {
                this.ruleForm = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, Model);
            }
            this.isEdit = Boolean(data && data.id);
            this.showDialog = true;
        },
        saveForm: function saveForm(boolean) {
            var _this2 = this;

            this.$axios.post(this.ruleForm.id ? this.urls.update : this.urls.add, this.ruleForm, { 'X-showMessage': true }).then(function (res) {
                _this2.resetForm('ruleForm');
                if (boolean === true) {
                    _this2.showDialog = false;
                } else {
                    _this2.ruleForm.id = '';
                }
                _this2.$emit('reload');
            }).catch(function () {});
        },
        provinceChange: function provinceChange(value) {
            var _this3 = this;

            var target = [];
            this.selectMap.WB_PROVINCE_ALL_WITH_CITY.forEach(function (item, index) {
                if (item.value === value) {
                    target = item.list;
                }
            });
            var isExist = false;
            if (target.length && this.ruleForm.cityId) {
                isExist = target.filter(function (item) {
                    return item.value === String(_this3.ruleForm.cityId);
                }).length;
            }
            this.cityArr = target;
            !isExist && (this.ruleForm.cityId = '');
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69bac047"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/more/schoolLevel/addRecordDialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": ((_vm.isEdit ? '编辑':'添加') + "学校"),
      "visible": _vm.showDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.showDialog = $event
      }
    }
  }, [_c("el-form", {
    key: _vm.preventKey,
    ref: "ruleForm",
    tag: "component",
    staticClass: "form-beauty form-col",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.ruleForm,
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "学校名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 50,
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.ruleForm.name),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.name"
    }
  })], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "省份名称",
      "prop": "provinceId"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择",
      "clearable": true
    },
    on: {
      "change": _vm.provinceChange
    },
    model: {
      value: (_vm.ruleForm.provinceId),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "provinceId", $$v)
      },
      expression: "ruleForm.provinceId"
    }
  }, _vm._l((_vm.selectMap.WB_PROVINCE_ALL_WITH_CITY), function(item, index) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 2
    }
  }, [_c('i', {
    staticClass: "el-icon-my-gengduo1",
    staticStyle: {
      "font-size": "24px",
      "vertical-align": "middle",
      "color": "#ddd",
      "position": "relative",
      "top": "5px"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "城市名称",
      "prop": "cityId",
      "label-width": "90px"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": true,
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.ruleForm.cityId),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "cityId", $$v)
      },
      expression: "ruleForm.cityId"
    }
  }, _vm._l((_vm.cityArr), function(item, index) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "学校类型",
      "prop": "type"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "clearable": true
    },
    model: {
      value: (_vm.ruleForm.type),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "type", $$v)
      },
      expression: "ruleForm.type"
    }
  }, _vm._l((_vm.selectMap.WB_SCHOOL_TYPES), function(item, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "学校档位",
      "prop": "sLevel"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "clearable": true
    },
    model: {
      value: (_vm.ruleForm.sLevel),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "sLevel", $$v)
      },
      expression: "ruleForm.sLevel"
    }
  }, _vm._l((_vm.selectMap.WB_SCHOOL_LEVEL), function(item, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mb-10",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm', true)
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), (!_vm.isEdit) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm', false)
      }
    }
  }, [_vm._v("保存并继续添加")]) : _vm._e()], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var schoolLevel_addRecordDialog_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/views/more/schoolLevel/addRecordDialog.vue
function injectStyle (ssrContext) {
  __webpack_require__(984)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  addRecordDialog_defaultExport,
  schoolLevel_addRecordDialog_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var more_schoolLevel_addRecordDialog_defaultExport = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/more/schoolLevel/searchArea.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_inputCustom__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mixins_selectMapMixin__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_tools__ = __webpack_require__(14);









var BaseFieldArr = [{
    filter: '',
    label: '学校名称',
    mode: 'input',
    name: 'name'
}, {
    filter: 'WB_PROVINCE_ALL_WITH_CITY',
    label: '省份名称',
    mode: 'select',
    name: 'provinceId'
}, {
    arr: [],
    label: '城市名称',
    mode: 'select',
    name: 'cityId'
}, {
    filter: 'WB_SCHOOL_TYPES',
    label: '学校类型',
    mode: 'select',
    name: 'type'
}, {
    filter: 'WB_SCHOOL_LEVEL',
    label: '学校档位',
    mode: 'select',
    name: 'sLevel'
}];
var fieldArr = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(BaseFieldArr)),
    arrToObj = function arrToObj(arr) {
    var temp = {};
    arr.forEach(function (field) {
        temp[field.name] = '';
    });
    return temp;
};

/* harmony default export */ var searchArea_defaultExport = ({
    name: 'SearchArea',
    components: { InputCustom: __WEBPACK_IMPORTED_MODULE_3_components_inputCustom__["a" /* default */] },
    mixins: [__WEBPACK_IMPORTED_MODULE_4_mixins_selectMapMixin__["a" /* default */]],
    props: {
        mode: {
            type: String,
            default: 'append' },
        fields: {
            type: Array,
            default: function _default() {
                return [];
            }
        }
    },
    watch: {
        'ruleForm.provinceId': function ruleFormProvinceId(value) {
            this.provinceChange(value);
        },
        selectMap: function selectMap(value) {
            this.provinceChange(this.ruleForm.provinceId);
        }
    },
    data: function data() {
        this.getFieldArr();
        var ruleForm = arrToObj(fieldArr);
        return {
            fieldArr: fieldArr,
            ruleForm: ruleForm
        };
    },

    computed: {
        isExam: function isExam() {
            return ['interviewList', 'writtenList', 'entryList'].indexOf(this.$route.name) > -1;
        }
    },

    methods: {
        submitForm: function submitForm() {
            var _this = this;

            var query = {};
            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.ruleForm).forEach(function (key) {
                query[key] = _this.getValueByArr(_this.ruleForm[key]);
            });
            query = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$parent.searchData, query, {
                pageIndex: 1,
                time: Date.now()
            });
            this.$router.push({ query: query });
        },
        clearAll: function clearAll() {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.ruleForm).forEach(function (key) {
                _this2.ruleForm[key] = Array.isArray(_this2.ruleForm[key]) ? [] : '';
            });
        },
        getFieldArr: function getFieldArr() {
            fieldArr = fieldArr.concat(this.fields);
            if (this.mode === 'cover') {
                fieldArr = this.fields;
            }
            return fieldArr;
        },
        getValueByArr: function getValueByArr(value) {
            return Array.isArray(value) ? value.join(',') : Object.prototype.toString.call(value) === '[object Date]' ? Object(__WEBPACK_IMPORTED_MODULE_5_modules_tools__["a" /* dateFormat */])(value) : value.replace(/\s+/g, ',').replace(/,,/g, ',');
        },
        provinceChange: function provinceChange(value) {
            var _this3 = this;

            var target = [];
            if (this.selectMap.WB_PROVINCE_ALL_WITH_CITY) {
                this.selectMap.WB_PROVINCE_ALL_WITH_CITY.forEach(function (item, index) {
                    if (item.value === value) {
                        target = item.list;
                    }
                });
                var isExist = false;
                if (target.length && this.ruleForm.cityId) {
                    isExist = target.filter(function (item) {
                        return item.value === String(_this3.ruleForm.cityId);
                    }).length;
                }
                this.fieldArr[2].arr = target;
                !isExist && (this.ruleForm.cityId = '');
            }
        }
    },
    mounted: function mounted() {
        var _this4 = this;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.ruleForm).forEach(function (key) {
            if (_this4.$route.query[key]) {
                _this4.ruleForm[key] = Array.isArray(_this4.ruleForm[key]) ? _this4.$route.query[key].split(',') : _this4.$route.query[key];
            }
        });
    },
    created: function created() {
        fieldArr = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(BaseFieldArr));
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-696c4250"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/more/schoolLevel/searchArea.vue
var searchArea_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    staticClass: "mt-20 search-area",
    attrs: {
      "inline": true,
      "label-width": "75px"
    }
  }, [_c('div', [_vm._l((_vm.fieldArr), function(item, index) {
    return [_c('el-form-item', {
      attrs: {
        "label": item.label
      }
    }, [(item.mode === 'input') ? _c('input-custom', {
      attrs: {
        "placeholder": ("请输入" + (item.label))
      },
      model: {
        value: (_vm.ruleForm[item.name]),
        callback: function($$v) {
          _vm.$set(_vm.ruleForm, item.name, (typeof $$v === 'string' ? $$v.trim() : $$v))
        },
        expression: "ruleForm[item.name]"
      }
    }) : _vm._e(), _vm._v(" "), (item.mode === 'select') ? _c('el-select', {
      ref: ((item.name) + "Select"),
      refInFor: true,
      attrs: {
        "filterable": "",
        "clearable": "",
        "placeholder": ("请选择" + (item.label))
      },
      model: {
        value: (_vm.ruleForm[item.name]),
        callback: function($$v) {
          _vm.$set(_vm.ruleForm, item.name, $$v)
        },
        expression: "ruleForm[item.name]"
      }
    }, _vm._l((item.arr || _vm.selectMap[item.filter]), function(subItem, subIndex) {
      return _c('el-option', {
        key: subItem.value,
        attrs: {
          "label": subItem.text,
          "value": subItem.value
        }
      })
    }), 1) : _vm._e()], 1)]
  }), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), _c('el-form-item', [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v(" ")]), _vm._v(" "), _c('el-button', {
    staticClass: "search-btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('el-button', {
    staticClass: "search-btn",
    on: {
      "click": function($event) {
        return _vm.clearAll()
      }
    }
  }, [_vm._v("清空")]), _vm._v(" "), _vm._t("operation")], 2)], 1)
}
var searchArea_staticRenderFns = []
var searchArea_esExports = { render: searchArea_render, staticRenderFns: searchArea_staticRenderFns }
/* harmony default export */ var schoolLevel_searchArea_defaultExport = (searchArea_esExports);
// CONCATENATED MODULE: ./src/views/more/schoolLevel/searchArea.vue
function searchArea_injectStyle (ssrContext) {
  __webpack_require__(986)
}
var searchArea_normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var searchArea___vue_styles__ = searchArea_injectStyle
/* scopeId */
var searchArea___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var searchArea___vue_module_identifier__ = null
var searchArea_Component = searchArea_normalizeComponent(
  searchArea_defaultExport,
  schoolLevel_searchArea_defaultExport,
  searchArea___vue_styles__,
  searchArea___vue_scopeId__,
  searchArea___vue_module_identifier__
)

/* harmony default export */ var more_schoolLevel_searchArea_defaultExport = (searchArea_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/more/schoolLevel/index.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_queryListExtend__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_fileUpload__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_views_operation_operationMixin__ = __webpack_require__(37);
/* harmony import */ var schoolLevel___WEBPACK_IMPORTED_MODULE_4_mixins_selectMapMixin__ = __webpack_require__(4);









/* harmony default export */ var schoolLevel_defaultExport = ({
    'extends': __WEBPACK_IMPORTED_MODULE_0_components_queryListExtend__["a" /* default */],
    components: { FileUpload: __WEBPACK_IMPORTED_MODULE_1_components_fileUpload__["a" /* default */], AddBoleDialog: more_schoolLevel_addRecordDialog_defaultExport, SearchArea: more_schoolLevel_searchArea_defaultExport },
    mixins: [__WEBPACK_IMPORTED_MODULE_2_views_operation_operationMixin__["a" /* default */], schoolLevel___WEBPACK_IMPORTED_MODULE_4_mixins_selectMapMixin__["a" /* default */]],
    data: function data() {
        return {
            fetchUrl: '/system/school/level/list.api',
            removeUrl: '/system/school/level/delete.api',
            searchData: {
                searchWord: null
            }
        };
    },

    computed: {
        downloadTemplateUrl: function downloadTemplateUrl() {
            return this.$axios.defaults.baseURL + '/system/school/level/downloadTemplate.api?token=' + this.$store.state.app.token;
        }
    },
    methods: {
        addRecord: function addRecord(data) {
            this.$refs.addBoleDialog.show(data);
        },
        removeRecord: function removeRecord(data) {
            var _this = this;

            this.$confirm('\u662F\u5426\u5220\u9664\u3010' + data.name + '\u3011\u8FD9\u6761\u8BB0\u5F55\uFF1F', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                _this.$axios.post(_this.removeUrl, { ids: data.id }, { 'X-showMessage': true }).then(function (res) {
                    _this.fetchData();
                });
            });
        },
        uploadSuccess: function uploadSuccess(res, file) {
            this.fetchData();
            var h = this.$createElement;
            var nodeContent = res.result.list.map(function (item) {
                return h('p', null, item);
            });
            this.$notify({
                title: '导入结果提示：',
                duration: 0,
                message: h('div', {
                    style: {
                        maxHeight: '500px',
                        overflow: 'auto'
                    }
                }, nodeContent),
                type: res.result.isAllSuccess ? 'success' : 'error'
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f3b6f9c2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/more/schoolLevel/index.vue
var schoolLevel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.firstRendered) ? _c('div', [_c('div', {
    staticClass: "filter-condition box-shadow-small border-radius"
  }, [_c('search-area', {
    ref: "SearchArea"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "filter-result background-white box-shadow-small border-radius"
  }, [_c('div', {
    staticClass: "filter-result-header mt-15 clearfix"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    attrs: {
      "icon": "el-icon-my-daochu",
      "type": "info"
    },
    on: {
      "click": function($event) {
        return _vm.exportFiles(_vm.idStr, '/system/school/level', '/export.api')
      }
    }
  }, [_vm._v("导出学校\n                    ")]), _vm._v(" "), _c('file-upload', {
    staticClass: "ml-5 mr-5",
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "upload-mode": "silence",
      "action": ((_vm.$axios.defaults.baseURL) + "/system/school/level/import.api"),
      "accept": ".xls",
      "on-success": _vm.uploadSuccess,
      "fileLimit": 0,
      "showLoading": true
    }
  }, [_c('el-button', {
    attrs: {
      "plain": true,
      "icon": "el-icon-upload2",
      "type": "primary"
    }
  }, [_vm._v("导入学校")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  })], 1), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.downloadTemplateUrl
    }
  }, [_c('el-button', {
    attrs: {
      "icon": "el-icon-my-daochu",
      "plain": true,
      "type": "text"
    }
  }, [_vm._v("下载导入模版")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "icon": "el-icon-plus",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.addRecord()
      }
    }
  }, [_vm._v("新建")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-shanchu",
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.remove(_vm.idStr)
      }
    }
  }, [_vm._v("删除")])], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.partialLoading),
      expression: "partialLoading"
    }]
  }, [_c('empty-tip', {
    attrs: {
      "show": !_vm.lists.length
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "table-list mt-20"
  }, [(_vm.lists.length) ? _c('el-table', {
    attrs: {
      "data": _vm.lists
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "学校名称",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.name) + "\n                        ")]
      }
    }], null, false, 2291008282)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "省份名称",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                           " + _vm._s(_vm.getSelectMapText('WB_PROVINCE_ALL', scope.row.provinceId) || '-') + "\n                        ")]
      }
    }], null, false, 2374841467)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "城市名称",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.getSelectMapText('WB_CITY_ALL', scope.row.cityId) || '-') + "\n                        ")]
      }
    }], null, false, 3420650619)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "学校类型",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.getSelectMapText('WB_SCHOOL_TYPES', scope.row.type) || '-') + "\n                        ")]
      }
    }], null, false, 3808797904)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "学校档位",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.sLevel && (scope.row.sLevel + '档') || '-') + "\n                        ")]
      }
    }], null, false, 828956889)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.addRecord(scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.removeRecord(scope.row)
            }
          }
        }, [_c('span', {
          staticClass: "color-danger"
        }, [_vm._v("删除")])])]
      }
    }], null, false, 2305422754)
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.lists.length) ? _c('el-pagination', {
    staticClass: "text-center mb-20 mt-10",
    attrs: {
      "current-page": _vm.pagination.pageIndex,
      "page-size": _vm.pagination.pageSize,
      "page-sizes": [20, 50, 100, 200],
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.pagination.recordCounts
    },
    on: {
      "size-change": _vm.pageSizeChange,
      "current-change": _vm.pageIndexChange
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('add-bole-dialog', {
    ref: "addBoleDialog",
    on: {
      "reload": _vm.fetchData
    }
  })], 1) : _vm._e()
}
var schoolLevel_staticRenderFns = []
var schoolLevel_esExports = { render: schoolLevel_render, staticRenderFns: schoolLevel_staticRenderFns }
/* harmony default export */ var more_schoolLevel_defaultExport = (schoolLevel_esExports);
// CONCATENATED MODULE: ./src/views/more/schoolLevel/index.vue
var schoolLevel_normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var schoolLevel___vue_styles__ = null
/* scopeId */
var schoolLevel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var schoolLevel___vue_module_identifier__ = null
var schoolLevel_Component = schoolLevel_normalizeComponent(
  schoolLevel_defaultExport,
  more_schoolLevel_defaultExport,
  schoolLevel___vue_styles__,
  schoolLevel___vue_scopeId__,
  schoolLevel___vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (schoolLevel_Component.exports);


/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(985);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("3c30913b", content, true);

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(987);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("0be5e393", content, true);

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".search-area .el-form--inline .el-form-item{margin-right:25px}.search-area .el-form--inline .el-date-editor.el-input,.search-area .el-form--inline .el-form-item__content,.search-area .el-form--inline .el-select{width:300px}.search-area .el-form--inline .el-select>.el-select__tags>span{line-height:30px;display:block;white-space:nowrap;overflow:auto}.search-area .el-form--inline .search-btn{padding:10px 40px}.search-area .el-form--inline .search-btn+.search-btn{margin-left:30px}", ""]);

// exports


/***/ }),
/* 988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/permission/projectList.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_queryListExtend__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_views_common_empty__ = __webpack_require__(121);





/* harmony default export */ var projectList_defaultExport = ({
    name: 'projectPermission',
    components: { EmptyTip: __WEBPACK_IMPORTED_MODULE_1_views_common_empty__["a" /* default */] },
    data: function data() {
        return {
            fetchUrl: 'http://frontend163.com:7300/mock/5badca8a1d71b43fc281d79d/wb/permission/project/list.api',
            lists: [],
            showDialog: false,
            isOpen: false,
            item: null
        };
    },
    methods: {
        permissionChange: function permissionChange() {
            var _this = this;

            this.$axios.post('http://frontend163.com:7300/mock/5badca8a1d71b43fc281d79d/wb/permission/project/update.api', {
                isOpen: this.isOpen,
                id: this.item.id
            }, { 'X-showMessage': true }).then(function (_ref) {
                var result = _ref.result;

                _this.showDialog = false;
            }).catch(console.error);
        },
        toggleOpen: function toggleOpen(isOpen, item) {
            this.isOpen = isOpen;
            this.showDialog = true;
            this.item = item;
        },
        fetchData: function fetchData() {
            var _this2 = this;

            this.$axios.get(this.fetchUrl).then(function (_ref2) {
                var result = _ref2.result;

                console.log(444, result);
                _this2.lists = result.list;
            }).catch(console.error);
        }
    },
    created: function created() {
        this.fetchData();
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60e15cfd"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/permission/projectList.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "filter-result background-white box-shadow-small border-radius"
  }, [_c('div', [_c('empty-tip', {
    attrs: {
      "show": !_vm.lists.length
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "table-list mt-20 mb-20"
  }, [(_vm.lists.length) ? _c('el-table', {
    attrs: {
      "data": _vm.lists
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "projectName",
      "label": "项目名称",
      "show-overflow-tooltip": true,
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "label": "创建时间",
      "show-overflow-tooltip": true,
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resumeCount",
      "label": "接收简历",
      "show-overflow-tooltip": true,
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "面试官查看",
      "show-overflow-tooltip": true,
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.interviewerCanUse) ? _c('i', {
          staticClass: "el-icon-circle-check color-success"
        }) : _c('i', {
          staticClass: "el-icon-circle-close color-danger"
        })]
      }
    }], null, false, 2176487141)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "show-overflow-tooltip": true,
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.interviewerCanUse) ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.toggleOpen(false, scope.row)
            }
          }
        }, [_vm._v("关闭\n                            ")]) : _c('el-button', {
          attrs: {
            "size": "small",
            "type": "success"
          },
          on: {
            "click": function($event) {
              return _vm.toggleOpen(true, scope.row)
            }
          }
        }, [_vm._v("开放\n                            ")])]
      }
    }], null, false, 3997240062)
  })], 1) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "size": "small",
      "title": "权限配置",
      "visible": _vm.showDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.showDialog = $event
      }
    }
  }, [_c('div', [(!_vm.isOpen) ? _c('p', [_vm._v("确定要向面试官开放该项目的权限吗？权限开放后面试官将会看到该项目相关的面试记录")]) : _c('p', [_vm._v("确定要向面试官关闭该项目的权限吗？权限开放后面试官将会看不到该项目相关的面试记录")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.permissionChange()
      }
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.showDialog = false
      }
    }
  }, [_vm._v("取消")])], 1)])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var permission_projectList_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/views/permission/projectList.vue
function injectStyle (ssrContext) {
  __webpack_require__(989)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-60e15cfd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  projectList_defaultExport,
  permission_projectList_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 989 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/message/editEmailTpl.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mixins_selectMapMixin__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_vueditor__ = __webpack_require__(232);






var Model = {
    id: null,
    userAttributes: '',
    phase: '',
    title: '',
    visible: '1',
    isPrivate: '0',
    name: '',
    content: ''
};

/* harmony default export */ var editEmailTpl_defaultExport = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_1_mixins_selectMapMixin__["a" /* default */]],
    data: function data() {
        return {
            showDialog: false,
            ruleForm: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, Model),
            attachList: [],
            mailHolders: [],
            preventKey: 1,
            rules: {
                name: [{ required: true, message: '请输入', trigger: 'blur' }],
                title: [{ required: true, message: '请输入', trigger: 'blur' }],
                content: [{ required: true, message: '请输入', trigger: 'blur' }],
                userAttributes: [{ required: true, message: '请选择', trigger: 'blur,change' }],
                phase: [{ required: true, message: '请选择', trigger: 'blur,change' }],
                visible: [{ required: true, message: '请选择', trigger: 'blur,change' }],
                isPrivate: [{ required: true, message: '请选择', trigger: 'blur,change' }]
            },
            labelWidth: '120px',
            editUrl: '/system/mailTemplate/update.api',
            addUrl: '/system/mailTemplate/insert.api'
        };
    },

    computed: {
        isEdit: function isEdit() {
            return !!this.ruleForm.id;
        }
    },
    methods: {
        show: function show(data) {
            this.preventKey = +new Date();
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.ruleForm, Model);
            if (data) {
                for (var attr in Model) {
                    this.ruleForm[attr] = typeof data[attr] === 'number' ? data[attr] + '' : data[attr];
                }
                this.getMailHolder(false);
            } else {
                this.mailHolders = [];
            }
            this.showDialog = true;
        },
        saveDate: function saveDate(formName) {
            var _this = this;

            this.$refs[formName].validate(function (valid) {
                if (valid) {
                    _this.$axios.post(_this.isEdit ? _this.editUrl : _this.addUrl, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this.ruleForm), { 'X-showMessage': true }).then(function (res) {
                        _this.showDialog = false;
                        _this.$emit('reloadList');
                    }).catch(function () {});
                } else {
                    return false;
                }
            });
        },
        getMailHolder: function getMailHolder(needResetContent) {
            var _this2 = this;

            var _ruleForm = this.ruleForm,
                phase = _ruleForm.phase,
                userAttributes = _ruleForm.userAttributes;

            if (phase && userAttributes) {
                this.$axios.get('/system/mailTemplate/getMailHolder.api', {
                    params: {
                        phase: phase,
                        userAttributes: userAttributes
                    }
                }).then(function (res) {
                    if (needResetContent && _this2.$refs.editor) {
                        _this2.$refs.editor.resetContent('');
                    }

                    _this2.mailHolders = res.result.list || [];
                });
            }
        }
    },
    components: {
        Vueditor: __WEBPACK_IMPORTED_MODULE_2_components_vueditor__["a" /* default */]
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c7dbf4c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/message/editEmailTpl.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.isEdit ? '编辑邮件模板' : '创建邮件模板',
      "visible": _vm.showDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.showDialog = $event
      }
    }
  }, [_c('el-form', {
    key: _vm.preventKey,
    ref: "ruleForm",
    staticClass: "form-beauty",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": _vm.labelWidth
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "模板名称:",
      "prop": "name",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 50,
      "placeholder": "请输入模板名称"
    },
    model: {
      value: (_vm.ruleForm.name),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "邮件标题:",
      "prop": "title",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 100,
      "placeholder": "请输入邮件标题"
    },
    model: {
      value: (_vm.ruleForm.title),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "title", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "招聘阶段:",
      "prop": "phase",
      "required": ""
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        return _vm.getMailHolder(true)
      }
    },
    model: {
      value: (_vm.ruleForm.phase),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "phase", $$v)
      },
      expression: "ruleForm.phase"
    }
  }, _vm._l((_vm.selectMap.WB_PHASE), function(item, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": item.text,
        "value": String(item.value)
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "用户类型:",
      "prop": "userAttributes",
      "required": ""
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        return _vm.getMailHolder(true)
      }
    },
    model: {
      value: (_vm.ruleForm.userAttributes),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "userAttributes", $$v)
      },
      expression: "ruleForm.userAttributes"
    }
  }, _vm._l((_vm.selectMap.WB_USER_ATTRIBUTES), function(item, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否可用:",
      "prop": "visible",
      "required": ""
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.ruleForm.visible),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "visible", $$v)
      },
      expression: "ruleForm.visible"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "0"
    }
  }, [_vm._v("不可用")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("可用")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否私有:",
      "prop": "isPrivate",
      "required": ""
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.ruleForm.isPrivate),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "isPrivate", $$v)
      },
      expression: "ruleForm.isPrivate"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "0"
    }
  }, [_vm._v("否")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("是")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "邮件内容:",
      "prop": "content"
    }
  }, [(_vm.mailHolders.length) ? _c('div', {
    staticClass: "el-tag-operation"
  }, _vm._l((_vm.mailHolders), function(item, index) {
    return _c('el-tag', {
      key: index,
      staticClass: "mr-5",
      nativeOn: {
        "click": function($event) {
          return _vm.$refs.editor.addAfterCursor(item.value)
        }
      }
    }, [_vm._v(_vm._s(item.text) + "\n                ")])
  }), 1) : _vm._e(), _vm._v(" "), _c('vueditor', {
    ref: "editor",
    model: {
      value: (_vm.ruleForm.content),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "content", $$v)
      },
      expression: "ruleForm.content"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showDialog = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.saveDate('ruleForm')
      }
    }
  }, [_vm._v("确定")])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var message_editEmailTpl_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/views/message/editEmailTpl.vue
function injectStyle (ssrContext) {
  __webpack_require__(993)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  editEmailTpl_defaultExport,
  message_editEmailTpl_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var views_message_editEmailTpl_defaultExport = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/message/viewEmailTpl.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var viewEmailTpl___WEBPACK_IMPORTED_MODULE_1_mixins_selectMapMixin__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui__);






/* harmony default export */ var viewEmailTpl_defaultExport = ({
    mixins: [viewEmailTpl___WEBPACK_IMPORTED_MODULE_1_mixins_selectMapMixin__["a" /* default */]],
    data: function data() {
        return {
            configMap: this.$store.state.baseData.selectMap,
            formLabelWidth: '110px',
            baseData: null,
            dialogVisible: false
        };
    },

    methods: {
        getData: function getData(id) {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/system/mailTemplate/selectByKey.api?id=' + id).then(function (res) {
                _this.baseData = res.result.bean;
                _this.dialogVisible = true;
            });
        },
        show: function show(id) {
            this.getData(id);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c887b67"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/message/viewEmailTpl.vue
var viewEmailTpl_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "preview-dialog",
    attrs: {
      "title": "预览",
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [(_vm.baseData) ? _c('el-form', {
    staticClass: "preview-inlineForm",
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "模板名称",
      "label-width": _vm.formLabelWidth
    }
  }, [_vm._v("\n            " + _vm._s(_vm.baseData.name) + "\n        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "邮件标题",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('pre', [_vm._v(_vm._s(_vm.baseData.title))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "招聘阶段",
      "label-width": _vm.formLabelWidth
    }
  }, [_vm._v("\n            " + _vm._s(_vm.getSelectMapText('WB_PHASE', _vm.baseData.phase)) + "\n        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "用户类型",
      "label-width": _vm.formLabelWidth
    }
  }, [_vm._v("\n            " + _vm._s(_vm.getSelectMapText('WB_USER_ATTRIBUTES', _vm.baseData.userAttributes)) + "\n        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否可用",
      "label-width": _vm.formLabelWidth
    }
  }, [_vm._v("\n            " + _vm._s(_vm.baseData.visible ? '可用' : '不可用') + "\n        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否私有",
      "label-width": _vm.formLabelWidth
    }
  }, [_vm._v("\n            " + _vm._s(_vm.baseData.isPrivate ? '是' : '否') + "\n        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.baseData) ? _c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "邮件内容",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.baseData.content)
    }
  })])], 1) : _vm._e()], 1)
}
var viewEmailTpl_staticRenderFns = []
var viewEmailTpl_esExports = { render: viewEmailTpl_render, staticRenderFns: viewEmailTpl_staticRenderFns }
/* harmony default export */ var message_viewEmailTpl_defaultExport = (viewEmailTpl_esExports);
// CONCATENATED MODULE: ./src/views/message/viewEmailTpl.vue
function viewEmailTpl_injectStyle (ssrContext) {
  __webpack_require__(995)
}
var viewEmailTpl_normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var viewEmailTpl___vue_styles__ = viewEmailTpl_injectStyle
/* scopeId */
var viewEmailTpl___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var viewEmailTpl___vue_module_identifier__ = null
var viewEmailTpl_Component = viewEmailTpl_normalizeComponent(
  viewEmailTpl_defaultExport,
  message_viewEmailTpl_defaultExport,
  viewEmailTpl___vue_styles__,
  viewEmailTpl___vue_scopeId__,
  viewEmailTpl___vue_module_identifier__
)

/* harmony default export */ var views_message_viewEmailTpl_defaultExport = (viewEmailTpl_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/message/emailTplList.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_queryListExtend__ = __webpack_require__(20);
/* harmony import */ var emailTplList___WEBPACK_IMPORTED_MODULE_1_mixins_selectMapMixin__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__operation_operationMixin__ = __webpack_require__(37);








/* harmony default export */ var emailTplList_defaultExport = ({
    'extends': __WEBPACK_IMPORTED_MODULE_0_components_queryListExtend__["a" /* default */],
    'mixins': [emailTplList___WEBPACK_IMPORTED_MODULE_1_mixins_selectMapMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__operation_operationMixin__["a" /* default */]],
    data: function data() {
        return {
            fetchUrl: '/system/mailTemplate/list.api',
            removeUrl: '/system/mailTemplate/delete.api',
            filterConf: [{
                name: 'phase',
                filter: 'WB_PHASE',
                label: '招聘阶段',
                visible: false,
                mode: 'single',
                data: []
            }, {
                name: 'userAttributes',
                filter: 'WB_USER_ATTRIBUTES',
                label: '用户类型',
                mode: 'single',
                visible: false,
                data: []
            }, {
                name: 'isPrivate',
                filter: 'WB_PRIVATE',
                label: '是否私有',
                mode: 'single',
                visible: false,
                data: []
            }, {
                name: 'visible',
                filter: 'WB_VISIBLE',
                label: '是否可用',
                mode: 'single',
                visible: false,
                data: []
            }],
            searchData: {
                searchWord: null
            }
        };
    },

    methods: {},
    components: {
        EditEmailTpl: views_message_editEmailTpl_defaultExport,
        ViewEmailTpl: views_message_viewEmailTpl_defaultExport
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15c717e0"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/message/emailTplList.vue
var emailTplList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.firstRendered) ? _c('div', [_c('div', {
    staticClass: "filter-condition box-shadow-small border-radius"
  }, [_c('div', {
    staticClass: "search-box"
  }, [_c('el-button', {
    staticClass: "search-hd",
    attrs: {
      "type": "primary",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        return _vm.searchKeyword(_vm.keyword)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "search-bd"
  }, [_c('search-bar', {
    attrs: {
      "ajaxSearch": false,
      "placeholder": "请输入模版名称"
    },
    on: {
      "enter-key": _vm.searchKeyword,
      "select": _vm.searchKeyword
    },
    model: {
      value: (_vm.keyword),
      callback: function($$v) {
        _vm.keyword = $$v
      },
      expression: "keyword"
    }
  })], 1)], 1), _vm._v(" "), _c('filter-panel', {
    ref: "condition",
    on: {
      "params-change": _vm.getParams
    }
  }, _vm._l((_vm.filterConf), function(item, index) {
    return _c('filter-panel-item', {
      key: index,
      attrs: {
        "label": item.label,
        "mode": item.mode,
        "name": item.name,
        "data": item.data,
        "initValue": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "filter-result background-white box-shadow-small border-radius"
  }, [_c('div', {
    staticClass: "filter-result-header mt-15 clearfix"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    attrs: {
      "icon": "el-icon-plus",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.editView.show()
      }
    }
  }, [_vm._v("新建邮件模版")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [(_vm.lists.length) ? _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "end"
    }
  }, [_c('el-button', {
    attrs: {
      "icon": "el-icon-my-guanbi color-danger",
      "type": "danger",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.remove(_vm.idStr, true)
      }
    }
  }, [_vm._v("删除\n                        ")])], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.partialLoading),
      expression: "partialLoading"
    }]
  }, [_c('empty-tip', {
    attrs: {
      "show": !_vm.lists.length
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "table-list mt-20"
  }, [(_vm.lists.length) ? _c('el-table', {
    attrs: {
      "data": _vm.lists
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "模版名称",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          attrs: {
            "href": "javascript://"
          },
          on: {
            "click": function($event) {
              return _vm.$refs.preview.show(scope.row.id)
            }
          }
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }], null, false, 3078569489)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "招聘阶段",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.getSelectMapText('WB_PHASE', scope.row.phase)) + "\n                        ")]
      }
    }], null, false, 1973864965)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "邮件标题",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.title) + "\n                        ")]
      }
    }], null, false, 2919489117)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "用户类型",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.getSelectMapText('WB_USER_ATTRIBUTES', scope.row.userAttributes)) + "\n                        ")]
      }
    }], null, false, 1716239674)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否可用",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(['不可用', '可用'][scope.row.visible]) + "\n                        ")]
      }
    }], null, false, 2365713234)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否私有",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(['否', '是'][scope.row.isPrivate]) + "\n                        ")]
      }
    }], null, false, 3623008847)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "class-name": "no-wrap",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.$refs.editView.show(scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.remove(scope.row.id)
            }
          }
        }, [_c('span', {
          staticClass: "color-danger"
        }, [_vm._v("删除")])])]
      }
    }], null, false, 786712276)
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.lists.length) ? _c('el-pagination', {
    staticClass: "text-center mt-20 mb-20",
    attrs: {
      "current-page": _vm.pagination.pageIndex,
      "page-size": _vm.pagination.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.pagination.recordCounts
    },
    on: {
      "size-change": _vm.pageSizeChange,
      "current-change": _vm.pageIndexChange
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('view-email-tpl', {
    ref: "preview"
  }), _vm._v(" "), _c('edit-email-tpl', {
    ref: "editView",
    on: {
      "reloadList": _vm.fetchData
    }
  })], 1) : _vm._e()
}
var emailTplList_staticRenderFns = []
var emailTplList_esExports = { render: emailTplList_render, staticRenderFns: emailTplList_staticRenderFns }
/* harmony default export */ var message_emailTplList_defaultExport = (emailTplList_esExports);
// CONCATENATED MODULE: ./src/views/message/emailTplList.vue
function emailTplList_injectStyle (ssrContext) {
  __webpack_require__(991)
}
var emailTplList_normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var emailTplList___vue_styles__ = emailTplList_injectStyle
/* scopeId */
var emailTplList___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var emailTplList___vue_module_identifier__ = null
var emailTplList_Component = emailTplList_normalizeComponent(
  emailTplList_defaultExport,
  message_emailTplList_defaultExport,
  emailTplList___vue_styles__,
  emailTplList___vue_scopeId__,
  emailTplList___vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (emailTplList_Component.exports);


/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(992);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("3f5c4a56", content, true);

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(994);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("b60bf4bc", content, true);

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(996);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("13c64bdb", content, true);

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".preview-inlineForm .el-form-item__label{color:#9e9e9e}.preview-inlineForm .el-form-item{width:300px;margin:4px 0}.preview-inlineForm .el-form-item__content{width:180px}.preview-dialog pre{margin:0;white-space:pre-line}.preview-dialog .el-form-item__label{color:#9e9e9e}.preview-dialog .el-form-item{margin:4px 0}", ""]);

// exports


/***/ }),
/* 997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/message/viewEmailHistoryItem.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mixins_selectMapMixin__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui__);





/* harmony default export */ var viewEmailHistoryItem_defaultExport = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_0_mixins_selectMapMixin__["a" /* default */]],
    data: function data() {
        return {
            styleStr: '\n                <style>\n                    html{overflow: auto}\n                    /*\u5B9A\u4E49\u6EDA\u52A8\u6761\u5BBD\u9AD8\u53CA\u80CC\u666F\uFF0C\u5BBD\u9AD8\u5206\u522B\u5BF9\u5E94\u6A2A\u7AD6\u6EDA\u52A8\u6761\u7684\u5C3A\u5BF8*/\n                    ::-webkit-scrollbar{\n                        width: 10px;\n                        height: 10px;\n                        background-color: #eee;\n                    }\n                    /*\u5B9A\u4E49\u6EDA\u52A8\u6761\u7684\u8F68\u9053\uFF0C\u5185\u9634\u5F71\u53CA\u5706\u89D2*/\n                    ::-webkit-scrollbar-track{\n                        background-color: #eee;\n                    }\n                    /*\u5B9A\u4E49\u6ED1\u5757\uFF0C\u5185\u9634\u5F71\u53CA\u5706\u89D2*/\n                    ::-webkit-scrollbar-thumb{\n                        /*width: 10px;*/\n                        height: 10px;\n                        background-color: #ddd;\n                    }</style>\n                ',
            configMap: this.$store.state.baseData.selectMap,
            formLabelWidth: '110px',
            baseData: null,
            dialogVisible: false
        };
    },

    methods: {
        show: function show(data) {
            this.baseData = data;
            this.dialogVisible = true;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b2d5d84"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/message/viewEmailHistoryItem.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "preview-dialog",
    attrs: {
      "title": "预览",
      "visible": _vm.dialogVisible,
      "size": "large"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [(_vm.baseData) ? _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('div', {
    staticStyle: {
      "border-bottom": "1px solid #ddd"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bold"
    }
  }, [_vm._v("邮件标题：" + _vm._s(_vm.baseData.name))]), _vm._v(" "), _c('p', [_vm._v("发送时间：" + _vm._s(_vm.baseData.sendTime))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border-top": "1px solid #ddd"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.baseData.content)
    }
  })])]) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var message_viewEmailHistoryItem_defaultExport = (esExports);
// CONCATENATED MODULE: ./src/views/message/viewEmailHistoryItem.vue
function injectStyle (ssrContext) {
  __webpack_require__(1000)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  viewEmailHistoryItem_defaultExport,
  message_viewEmailHistoryItem_defaultExport,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var views_message_viewEmailHistoryItem_defaultExport = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/message/emailHistoryList.vue
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_queryListExtend__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mixins_selectMapMixin__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__operation_operationMixin__ = __webpack_require__(37);







/* harmony default export */ var emailHistoryList_defaultExport = ({
    'extends': __WEBPACK_IMPORTED_MODULE_0_components_queryListExtend__["a" /* default */],
    'mixins': [__WEBPACK_IMPORTED_MODULE_1_mixins_selectMapMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__operation_operationMixin__["a" /* default */]],
    data: function data() {
        return {
            fetchUrl: '/system/mailHistory/list.api',
            filterConf: [{
                name: 'status',
                filter: 'WB_SMS_SEND',
                label: '发送状态',
                visible: false,
                mode: 'single',
                data: []
            }, {
                name: 'userAttributes',
                filter: 'WB_USER_ATTRIBUTES',
                label: '用户类型',
                mode: 'single',
                visible: false,
                data: []
            }],
            searchData: {
                searchWord: null
            }
        };
    },

    methods: {
        reSendEmail: function reSendEmail(ids) {
            var _this = this;

            if (!this.checkDataValid(ids)) {
                return false;
            }
            this.$axios.post('/system/mailHistory/repeat.api', {
                ids: ids
            }, { 'X-showMessage': true }).then(function (res) {
                _this.fetchData && _this.fetchData();
            }).catch(function () {});
        }
    },
    components: {
        ViewEmailHistory: views_message_viewEmailHistoryItem_defaultExport
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69513a04"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/message/emailHistoryList.vue
var emailHistoryList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.firstRendered) ? _c('div', [_c('div', {
    staticClass: "filter-condition box-shadow-small border-radius"
  }, [_c('div', {
    staticClass: "search-box"
  }, [_c('el-button', {
    staticClass: "search-hd",
    attrs: {
      "type": "primary",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        return _vm.searchKeyword(_vm.keyword)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "search-bd"
  }, [_c('search-bar', {
    attrs: {
      "ajaxSearch": false,
      "placeholder": "请输入邮件名称"
    },
    on: {
      "enter-key": _vm.searchKeyword,
      "select": _vm.searchKeyword
    },
    model: {
      value: (_vm.keyword),
      callback: function($$v) {
        _vm.keyword = $$v
      },
      expression: "keyword"
    }
  })], 1)], 1), _vm._v(" "), _c('filter-panel', {
    ref: "condition",
    on: {
      "params-change": _vm.getParams
    }
  }, _vm._l((_vm.filterConf), function(item, index) {
    return _c('filter-panel-item', {
      key: index,
      attrs: {
        "label": item.label,
        "mode": item.mode,
        "name": item.name,
        "data": item.data,
        "initValue": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "filter-result background-white box-shadow-small border-radius"
  }, [_c('div', {
    staticClass: "filter-result-header mt-15 clearfix"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [(_vm.lists.length) ? _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "end"
    }
  }, [_c('el-button', {
    attrs: {
      "icon": "el-icon-my-youjian color-primary",
      "type": "primary",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.reSendEmail(_vm.idStr)
      }
    }
  }, [_vm._v("重新发送\n                        ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.fetchData()
      }
    }
  }, [_vm._v("刷新列表\n                        ")])], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.partialLoading),
      expression: "partialLoading"
    }]
  }, [_c('empty-tip', {
    attrs: {
      "show": !_vm.lists.length
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "table-list mt-20"
  }, [(_vm.lists.length) ? _c('el-table', {
    attrs: {
      "data": _vm.lists
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "邮件名称",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          attrs: {
            "href": "javascript://"
          },
          on: {
            "click": function($event) {
              return _vm.$refs.preview.show(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }], null, false, 51994002)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "接收邮箱",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.sendEmail || '-') + "\n                        ")]
      }
    }], null, false, 3471763072)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "用户类型",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.getSelectMapText('WB_USER_ATTRIBUTES', scope.row.userAttributes)) + "\n                        ")]
      }
    }], null, false, 1716239674)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作人",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.operatorUser && scope.row.operatorUser.name || '-') + "\n                        ")]
      }
    }], null, false, 1695507737)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "发送状态",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.getSelectMapText('WB_SMS_SEND', scope.row.status) || '-') + "\n                        ")]
      }
    }], null, false, 1890910386)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "class-name": "no-wrap",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.reSendEmail(scope.row.id)
            }
          }
        }, [_vm._v("重新发送")])]
      }
    }], null, false, 583615288)
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.lists.length) ? _c('el-pagination', {
    staticClass: "text-center mt-20 mb-20",
    attrs: {
      "current-page": _vm.pagination.pageIndex,
      "page-size": _vm.pagination.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.pagination.recordCounts
    },
    on: {
      "size-change": _vm.pageSizeChange,
      "current-change": _vm.pageIndexChange
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('view-email-history', {
    ref: "preview"
  })], 1) : _vm._e()
}
var emailHistoryList_staticRenderFns = []
var emailHistoryList_esExports = { render: emailHistoryList_render, staticRenderFns: emailHistoryList_staticRenderFns }
/* harmony default export */ var message_emailHistoryList_defaultExport = (emailHistoryList_esExports);
// CONCATENATED MODULE: ./src/views/message/emailHistoryList.vue
function emailHistoryList_injectStyle (ssrContext) {
  __webpack_require__(998)
}
var emailHistoryList_normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var emailHistoryList___vue_styles__ = emailHistoryList_injectStyle
/* scopeId */
var emailHistoryList___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var emailHistoryList___vue_module_identifier__ = null
var emailHistoryList_Component = emailHistoryList_normalizeComponent(
  emailHistoryList_defaultExport,
  message_emailHistoryList_defaultExport,
  emailHistoryList___vue_styles__,
  emailHistoryList___vue_scopeId__,
  emailHistoryList___vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (emailHistoryList_Component.exports);


/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(999);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("51681c2c", content, true);

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1001);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("3597d736", content, true);

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".preview-inlineForm .el-form-item__label{color:#9e9e9e}.preview-inlineForm .el-form-item{width:300px;margin:4px 0}.preview-inlineForm .el-form-item__content{width:180px}.preview-dialog pre{margin:0;white-space:pre-line}.preview-dialog .el-form-item__label{color:#9e9e9e}.preview-dialog .el-form-item{margin:4px 0}", ""]);

// exports


/***/ }),
/* 1002 */,
/* 1003 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1004 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1005 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
],[365]);


// WEBPACK FOOTER //
// assets/js/indexbbd7a8af.js